(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $031feada4a3b44c2$export$2c579a9f1ddaf08d() {
    const dataToolTips = document.querySelectorAll('[data-tooltip-top], [data-tooltip-right], [data-tooltip-bottom], [data-tooltip-left]');
    const toolTipsClick = document.querySelectorAll('[data-tooltip-copy]');
    function getTooltipText(element) {
        return element.dataset.tooltipTop || element.dataset.tooltipRight || element.dataset.tooltipBottom || element.dataset.tooltipLeft;
    }
    dataToolTips.forEach((dataTooltip)=>{
        if (!dataTooltip.querySelector('.tooltip')) {
            const tooltipText = `<span class="tooltip">${getTooltipText(dataTooltip)}</span>`;
            dataTooltip.insertAdjacentHTML('afterbegin', tooltipText);
        }
    });
    toolTipsClick.forEach((toolTipClick)=>{
        toolTipClick.addEventListener('click', function() {
            const tooltip = toolTipClick.querySelector('.tooltip');
            const originalText = getTooltipText(toolTipClick);
            tooltip.textContent = toolTipClick.dataset.tooltipCopy;
            setTimeout(()=>{
                tooltip.textContent = originalText;
            }, 1000);
        });
    });
}
document.addEventListener('DOMContentLoaded', $031feada4a3b44c2$export$2c579a9f1ddaf08d);


document.addEventListener('click', (e)=>{
    // Add class ac-body and hidden to dropdowns
    const accordionBodies = document.querySelectorAll('.ac-body');
    accordionBodies.forEach(function(accordionBody) {
        const accordionHeader = accordionBody.previousElementSibling;
        if (e.target !== accordionBody && e.target !== accordionHeader && !accordionBody.contains(e.target)) {
            accordionHeader.classList.toggle('active');
            accordionBody.classList.toggle('block!');
        }
    });
    // Add class ac-header to the button that opens the dropdown
    if (e.target.classList.contains('ac-header')) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle('active');
        accordionBody.classList.toggle('block!');
    }
    if (e.target.classList.contains('ac-footer')) {
        const accordionBody = e.target.previousElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle('active');
        accordionBody.classList.toggle('block!');
    }
    if (e.target.classList.contains('ac-open-top')) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle('active');
        if (!accordionBody.classList.contains('flex!')) accordionBody.classList.add('flex!', 'gap-3', 'bottom-full', 'p-1', 'bg-white', 'rounded-sm');
        else accordionBody.classList.remove('flex!', 'gap-3', 'bottom-full', 'p-1', 'bg-white', 'rounded-sm');
    }
    if (e.target.classList.contains('ac-open-bottom')) {
        const accordionBody = e.target.nextElementSibling;
        const accordionHeader = e.target;
        accordionHeader.classList.toggle('active');
        if (!accordionBody.classList.contains('flex!')) accordionBody.classList.add('flex!', 'gap-3', 'top-full', 'p-1', 'bg-white', 'rounded-sm');
        else accordionBody.classList.remove('flex!', 'gap-3', 'top-full', 'p-1', 'bg-white', 'rounded-sm');
    }
    if (e.target.classList.contains('overlay')) {
        const overlay = e.target;
        overlay.classList.remove('visible');
    }
});


document.addEventListener('click', (e)=>{
    if (e.target.classList.contains('tab')) {
        const tab = e.target;
        // Makes sure the tab only affects the tabs inside the same tab-list
        const parent = tab.parentNode.parentNode;
        const tabs = parent.querySelectorAll('.tab');
        const tabContents = parent.querySelectorAll('.tab-content');
        tabs.forEach((tab)=>{
            tab.classList.remove('active');
        });
        tab.classList.add('active');
        tabContents.forEach((tabContent)=>{
            tabContent.classList.remove('active');
            if (tabContent.dataset.tab === tab.dataset.tab) tabContent.classList.add('active');
        });
    }
});


document.addEventListener('click', (e)=>{
    if (e.target.closest('a')) {
        const link = e.target.closest('a');
        let href = link.getAttribute('href');
        if (!href.startsWith('#') || href.startsWith('#') && href.length < 2 || link.classList.contains('open-gallery')) return;
        e.preventDefault();
        let target = document.querySelector(href);
        if (!target) return;
        let headerOffset = 130;
        let elementPosition = target.offsetTop;
        let offsetPosition = elementPosition - headerOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
});


/**
 * Load More — search (Relevanssi) + regular post/archive listings
 *
 * Features (all opt-in via data-attributes on the `.load-more` button):
 *   - data-search-query      → routes the request through `wp_ajax_search_load_more`
 *                              which runs the query through Relevanssi
 *   - data-infinite-scroll   → "true" enables IntersectionObserver-driven auto-load
 *   - data-preserve-state    → "true" saves rendered HTML + scroll position to
 *                              sessionStorage so back-navigation restores the list
 *   - data-instance-id       → identifies the component for multi-instance pages
 *                              (state keys + container scoping)
 *
 * Without any opt-in attributes the button behaves like a plain click-to-load-more.
 */ // ----------------------------------------------------------------------------
// Optional WooCommerce hook — no-op in lwlightning (kept as an extension point)
// ----------------------------------------------------------------------------
const $9aa4113698f7fa9e$var$addVariationsToProducts = ()=>{
// Lightning theme has no WooCommerce variations helper.
// Leave as no-op so the rest of the module stays portable.
};
// Track loading state per instance to prevent multiple simultaneous requests
const $9aa4113698f7fa9e$var$loadingStates = new Map();
// Storage key prefix for sessionStorage entries
const $9aa4113698f7fa9e$var$STORAGE_KEY_PREFIX = 'list_state_';
// ============================================================================
// Instance & container helpers
// ============================================================================
const $9aa4113698f7fa9e$var$getInstanceId = (button)=>{
    var _button_dataset;
    return (button === null || button === void 0 ? void 0 : (_button_dataset = button.dataset) === null || _button_dataset === void 0 ? void 0 : _button_dataset.instanceId) || null;
};
const $9aa4113698f7fa9e$var$isStatePreservationEnabled = (button)=>{
    var _button_dataset;
    return (button === null || button === void 0 ? void 0 : (_button_dataset = button.dataset) === null || _button_dataset === void 0 ? void 0 : _button_dataset.preserveState) === 'true';
};
const $9aa4113698f7fa9e$var$getStateKey = (button)=>{
    var _button_dataset, _button_dataset1, _button_dataset2;
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button);
    if (button === null || button === void 0 ? void 0 : (_button_dataset = button.dataset) === null || _button_dataset === void 0 ? void 0 : _button_dataset.searchQuery) return `search:${button.dataset.searchQuery}`;
    // Instance-scoped components (e.g. pc-post-listing) own their filter
    // state internally, so the key must stay stable across filter changes.
    // The active cat-id is persisted inside the state payload instead.
    if (instanceId) return `instance:${instanceId}:${window.location.pathname}`;
    if (button === null || button === void 0 ? void 0 : (_button_dataset1 = button.dataset) === null || _button_dataset1 === void 0 ? void 0 : _button_dataset1.catId) {
        const postType = button.dataset.postType || 'post';
        return `archive:${postType}:${button.dataset.catId}`;
    }
    const postType = (button === null || button === void 0 ? void 0 : (_button_dataset2 = button.dataset) === null || _button_dataset2 === void 0 ? void 0 : _button_dataset2.postType) || 'post';
    return `listing:${postType}:${window.location.pathname}`;
};
const $9aa4113698f7fa9e$var$getStorageKey = (stateKey)=>$9aa4113698f7fa9e$var$STORAGE_KEY_PREFIX + stateKey;
const $9aa4113698f7fa9e$var$getPostContainer = (button)=>{
    var _button_closest;
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button);
    if (instanceId) {
        // Look for a wrapper element with the same instance-id — but skip
        // the button itself, otherwise we'd inject loaded posts INSIDE the
        // button. Falls through to the .container-based lookup below when
        // no wrapper has been tagged.
        const wrappers = document.querySelectorAll(`[data-instance-id="${instanceId}"]`);
        for (const wrapper of wrappers){
            if (wrapper === button) continue;
            const postListing = wrapper.querySelector('.post-listing');
            if (postListing) return postListing;
            return wrapper;
        }
    }
    return button === null || button === void 0 ? void 0 : (_button_closest = button.closest('.container')) === null || _button_closest === void 0 ? void 0 : _button_closest.querySelector('.post-listing');
};
const $9aa4113698f7fa9e$var$isInstanceLoading = (button)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button) || 'global';
    return $9aa4113698f7fa9e$var$loadingStates.get(instanceId) || false;
};
const $9aa4113698f7fa9e$var$setInstanceLoading = (button, loading)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button) || 'global';
    $9aa4113698f7fa9e$var$loadingStates.set(instanceId, loading);
};
// ============================================================================
// State preservation (sessionStorage)
// ============================================================================
const $9aa4113698f7fa9e$var$getInstanceWrapper = (button)=>{
    const instanceId = $9aa4113698f7fa9e$var$getInstanceId(button);
    if (!instanceId) return null;
    return document.querySelector(`[data-instance-id="${instanceId}"]`);
};
const $9aa4113698f7fa9e$var$applyActiveCatFilter = (button, catId)=>{
    const wrapper = $9aa4113698f7fa9e$var$getInstanceWrapper(button);
    if (!wrapper) return;
    const catFilters = wrapper.querySelectorAll('.cat-filter');
    if (!catFilters.length) return;
    catFilters.forEach((filter)=>{
        filter.classList.toggle('active', filter.dataset.value === catId);
    });
};
const $9aa4113698f7fa9e$var$saveState = (button, container)=>{
    if (!$9aa4113698f7fa9e$var$isStatePreservationEnabled(button)) return;
    const stateKey = $9aa4113698f7fa9e$var$getStateKey(button);
    if (!stateKey || !container) return;
    const state = {
        html: container.innerHTML,
        paged: (button === null || button === void 0 ? void 0 : button.dataset.paged) || '1',
        maxPages: (button === null || button === void 0 ? void 0 : button.dataset.maxPages) || '',
        catId: (button === null || button === void 0 ? void 0 : button.dataset.catId) || '',
        scrollY: window.scrollY,
        timestamp: Date.now()
    };
    try {
        sessionStorage.setItem($9aa4113698f7fa9e$var$getStorageKey(stateKey), JSON.stringify(state));
    } catch (e) {
        console.warn('Could not save list state:', e);
    }
};
const $9aa4113698f7fa9e$var$restoreState = (button, container)=>{
    if (!$9aa4113698f7fa9e$var$isStatePreservationEnabled(button)) return false;
    const stateKey = $9aa4113698f7fa9e$var$getStateKey(button);
    if (!stateKey || !container) return false;
    try {
        const stored = sessionStorage.getItem($9aa4113698f7fa9e$var$getStorageKey(stateKey));
        if (!stored) return false;
        const state = JSON.parse(stored);
        // Drop states older than 30 minutes
        if (Date.now() - state.timestamp > 1800000) {
            sessionStorage.removeItem($9aa4113698f7fa9e$var$getStorageKey(stateKey));
            return false;
        }
        container.innerHTML = state.html;
        if (button) {
            button.dataset.paged = state.paged;
            if (state.maxPages) button.dataset.maxPages = state.maxPages;
            if (typeof state.catId === 'string') {
                button.dataset.catId = state.catId;
                $9aa4113698f7fa9e$var$applyActiveCatFilter(button, state.catId);
            }
        }
        requestAnimationFrame(()=>{
            window.scrollTo(0, state.scrollY);
        });
        $9aa4113698f7fa9e$var$addVariationsToProducts();
        return true;
    } catch (e) {
        console.warn('Could not restore list state:', e);
        return false;
    }
};
const $9aa4113698f7fa9e$var$clearOldStates = ()=>{
    try {
        const keysToRemove = [];
        for(let i = 0; i < sessionStorage.length; i++){
            const key = sessionStorage.key(i);
            if (key === null || key === void 0 ? void 0 : key.startsWith($9aa4113698f7fa9e$var$STORAGE_KEY_PREFIX)) {
                const stored = sessionStorage.getItem(key);
                if (stored) {
                    const state = JSON.parse(stored);
                    if (Date.now() - state.timestamp > 1800000) keysToRemove.push(key);
                }
            }
        }
        keysToRemove.forEach((key)=>sessionStorage.removeItem(key));
    } catch (e) {
    // Fail silently
    }
};
const $9aa4113698f7fa9e$var$setupStatePreservation = ()=>{
    const loadMoreButtons = document.querySelectorAll('.load-more[data-preserve-state="true"]');
    loadMoreButtons.forEach((button)=>{
        const container = $9aa4113698f7fa9e$var$getPostContainer(button);
        if (!container) return;
        // Save state when the user clicks a result link inside the container
        container.addEventListener('click', (e)=>{
            const link = e.target.closest('a');
            if (link && !link.closest('.load-more')) $9aa4113698f7fa9e$var$saveState(button, container);
        });
    });
    window.addEventListener('pagehide', ()=>{
        loadMoreButtons.forEach((button)=>{
            const container = $9aa4113698f7fa9e$var$getPostContainer(button);
            if (container) $9aa4113698f7fa9e$var$saveState(button, container);
        });
    });
};
const $9aa4113698f7fa9e$var$tryRestoreStates = ()=>{
    const loadMoreButtons = document.querySelectorAll('.load-more[data-preserve-state="true"]');
    loadMoreButtons.forEach((button)=>{
        const container = $9aa4113698f7fa9e$var$getPostContainer(button);
        if (!container) return;
        const restored = $9aa4113698f7fa9e$var$restoreState(button, container);
        if (restored) {
            const maxPages = parseInt(button.dataset.maxPages || '999', 10);
            const currentPage = parseInt(button.dataset.paged || '1', 10);
            if (currentPage >= maxPages) button.style.display = 'none';
        }
    });
};
// ============================================================================
// Core helpers
// ============================================================================
const $9aa4113698f7fa9e$var$getLoadMoreButton = (target)=>target === null || target === void 0 ? void 0 : target.closest('.load-more');
const $9aa4113698f7fa9e$var$setButtonState = (button, { loading: loading, disabled: disabled, text: text, hide: hide })=>{
    if (typeof loading !== 'undefined') {
        button.classList.toggle('loading', loading);
        $9aa4113698f7fa9e$var$setInstanceLoading(button, loading);
    }
    if (typeof disabled !== 'undefined') {
        if (disabled) button.setAttribute('disabled', 'disabled');
        else button.removeAttribute('disabled');
    }
    if (typeof text !== 'undefined') {
        const label = button.querySelector('.load-more-text');
        if (label) label.textContent = text;
    }
    if (typeof hide !== 'undefined') button.style.display = hide ? 'none' : '';
};
const $9aa4113698f7fa9e$var$appendPosts = (container, posts = [])=>{
    posts.forEach((post)=>{
        container.insertAdjacentHTML('beforeend', post);
    });
};
const $9aa4113698f7fa9e$var$isSearchLoadMore = (button)=>Boolean(button.dataset.searchQuery && button.dataset.searchQuery.length > 0);
// ============================================================================
// Search load more (Relevanssi)
// ============================================================================
const $9aa4113698f7fa9e$var$buildSearchRequestData = (button)=>{
    const data = new FormData();
    const { dataset: dataset } = button;
    const currentPage = parseInt(dataset.paged || '1', 10);
    const nextPage = currentPage + 1;
    data.append('action', 'search_load_more');
    data.append('security', liGlobal.loadMore);
    data.append('search_query', dataset.searchQuery);
    data.append('paged', nextPage);
    if (dataset.postsPerPage) data.append('posts_per_page', dataset.postsPerPage);
    if (dataset.postType) data.append('post_type', dataset.postType);
    return {
        data: data,
        nextPage: nextPage
    };
};
const $9aa4113698f7fa9e$var$requestSearchLoadMore = async (formData)=>{
    var _payload_data;
    const response = await fetch(liGlobal.ajaxUrl, {
        method: 'POST',
        body: formData
    });
    if (!response.ok) throw new Error("N\xe4tverksfel vid s\xf6kning");
    const payload = await response.json();
    if (!payload.success) throw new Error(((_payload_data = payload.data) === null || _payload_data === void 0 ? void 0 : _payload_data.message) || 'Servern returnerade ett fel');
    return payload.data;
};
const $9aa4113698f7fa9e$var$handleSearchLoadMoreSuccess = (button, container, data, nextPage)=>{
    var _data_max_num_pages;
    $9aa4113698f7fa9e$var$appendPosts(container, data.posts);
    button.dataset.paged = nextPage.toString();
    button.dataset.maxPages = ((_data_max_num_pages = data.max_num_pages) === null || _data_max_num_pages === void 0 ? void 0 : _data_max_num_pages.toString()) || '';
    if (data.no_more_posts) $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: true,
        text: data.load_more_btn_text,
        hide: true
    });
    else $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: false,
        text: data.load_more_btn_text
    });
    if (data.posts && data.posts.length > 0) $9aa4113698f7fa9e$var$addVariationsToProducts();
    $9aa4113698f7fa9e$var$saveState(button, container);
};
const $9aa4113698f7fa9e$var$triggerSearchLoadMore = async (button)=>{
    if ($9aa4113698f7fa9e$var$isInstanceLoading(button) || button.disabled) return;
    const postContainer = $9aa4113698f7fa9e$var$getPostContainer(button);
    if (!postContainer) return;
    $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: true
    });
    const { data: formData, nextPage: nextPage } = $9aa4113698f7fa9e$var$buildSearchRequestData(button);
    try {
        var _data_posts;
        const data = await $9aa4113698f7fa9e$var$requestSearchLoadMore(formData);
        if (data.no_more_posts && !((_data_posts = data.posts) === null || _data_posts === void 0 ? void 0 : _data_posts.length)) {
            $9aa4113698f7fa9e$var$setButtonState(button, {
                loading: false,
                disabled: true,
                text: data.load_more_btn_text,
                hide: true
            });
            return;
        }
        $9aa4113698f7fa9e$var$handleSearchLoadMoreSuccess(button, postContainer, data, nextPage);
    } catch (error) {
        console.error("Kunde inte ladda fler s\xf6kresultat", error);
        $9aa4113698f7fa9e$var$setButtonState(button, {
            loading: false,
            disabled: false
        });
    }
};
const $9aa4113698f7fa9e$var$loadSearchPosts = async (event)=>{
    event.preventDefault();
    const loadMoreBtn = $9aa4113698f7fa9e$var$getLoadMoreButton(event.target);
    if (!loadMoreBtn) return;
    await $9aa4113698f7fa9e$var$triggerSearchLoadMore(loadMoreBtn);
};
// ============================================================================
// Regular load more (non-search)
// ============================================================================
const $9aa4113698f7fa9e$var$collectExcludedPostIds = (container)=>{
    if (!container) return [
        ...document.querySelectorAll('[data-post-id]')
    ].map((post)=>post.dataset.postId).filter(Boolean);
    return [
        ...container.querySelectorAll('[data-post-id]')
    ].map((post)=>post.dataset.postId).filter(Boolean);
};
const $9aa4113698f7fa9e$var$buildRequestData = (button, container)=>{
    const data = new FormData();
    const { dataset: dataset } = button;
    const currentPage = parseInt(dataset.paged || '1', 10);
    const nextPage = currentPage + 1;
    if (dataset.catId) data.append('cat_id', dataset.catId);
    if (dataset.categoryIds) data.append('category_ids', dataset.categoryIds);
    if (dataset.categoryTaxonomy) data.append('category_taxonomy', dataset.categoryTaxonomy);
    if (dataset.productCategory) data.append('product_id', dataset.productCategory);
    if (dataset.productBrand) data.append('product_brand', dataset.productBrand);
    const excludedIds = $9aa4113698f7fa9e$var$collectExcludedPostIds(container);
    if (excludedIds.length) data.append('exclude', excludedIds.join(','));
    if (dataset.postType) data.append('post_type', dataset.postType);
    if (dataset.postsPerPage) data.append('posts_per_page', dataset.postsPerPage);
    if (dataset.orderby) data.append('orderby', dataset.orderby);
    if (dataset.order) data.append('order', dataset.order);
    data.append('action', 'load_more');
    data.append('security', liGlobal.loadMore);
    data.append('paged', nextPage);
    return {
        data: data,
        nextPage: nextPage
    };
};
const $9aa4113698f7fa9e$var$requestLoadMorePosts = async (formData)=>{
    var _payload_data;
    const response = await fetch(liGlobal.ajaxUrl, {
        method: 'POST',
        body: formData
    });
    if (!response.ok) throw new Error("N\xe4tverksfel vid Ladda fler-f\xf6rfr\xe5gan");
    const payload = await response.json();
    if (!payload.success) throw new Error(((_payload_data = payload.data) === null || _payload_data === void 0 ? void 0 : _payload_data.message) || 'Servern returnerade ett fel');
    return payload.data;
};
const $9aa4113698f7fa9e$var$handleLoadMoreSuccess = (button, container, data, nextPage)=>{
    var _data_max_num_pages;
    $9aa4113698f7fa9e$var$appendPosts(container, data.posts);
    button.dataset.paged = nextPage.toString();
    button.dataset.maxPages = ((_data_max_num_pages = data.max_num_pages) === null || _data_max_num_pages === void 0 ? void 0 : _data_max_num_pages.toString()) || '';
    if (data.no_more_posts) $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: true,
        text: data.load_more_btn_text,
        hide: true
    });
    else $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: false,
        text: data.load_more_btn_text
    });
    if (data.post_type === 'product') $9aa4113698f7fa9e$var$addVariationsToProducts();
    $9aa4113698f7fa9e$var$saveState(button, container);
};
const $9aa4113698f7fa9e$var$handleLoadMoreError = (button, error)=>{
    console.error("Kunde inte ladda fler inl\xe4gg", error);
    $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: false,
        disabled: false
    });
};
const $9aa4113698f7fa9e$var$triggerLoadMore = async (button)=>{
    if ($9aa4113698f7fa9e$var$isInstanceLoading(button) || button.disabled) return;
    const postContainer = $9aa4113698f7fa9e$var$getPostContainer(button);
    if (!postContainer) return;
    $9aa4113698f7fa9e$var$setButtonState(button, {
        loading: true
    });
    const { data: formData, nextPage: nextPage } = $9aa4113698f7fa9e$var$buildRequestData(button, postContainer);
    try {
        var _data_posts;
        const data = await $9aa4113698f7fa9e$var$requestLoadMorePosts(formData);
        if (data.no_more_posts && !((_data_posts = data.posts) === null || _data_posts === void 0 ? void 0 : _data_posts.length)) {
            $9aa4113698f7fa9e$var$setButtonState(button, {
                loading: false,
                disabled: true,
                text: data.load_more_btn_text,
                hide: true
            });
            return;
        }
        $9aa4113698f7fa9e$var$handleLoadMoreSuccess(button, postContainer, data, nextPage);
    } catch (error) {
        $9aa4113698f7fa9e$var$handleLoadMoreError(button, error);
    }
};
const $9aa4113698f7fa9e$export$b10b9b608ed3fa77 = async (event)=>{
    event.preventDefault();
    const loadMoreBtn = $9aa4113698f7fa9e$var$getLoadMoreButton(event.target);
    if (!loadMoreBtn) return;
    await $9aa4113698f7fa9e$var$triggerLoadMore(loadMoreBtn);
};
// ============================================================================
// Infinite scroll (opt-in via data-infinite-scroll="true")
// ============================================================================
const $9aa4113698f7fa9e$var$initInfiniteScroll = ()=>{
    const loadMoreButtons = document.querySelectorAll('.load-more[data-infinite-scroll="true"]');
    if (!loadMoreButtons.length) return;
    const observerOptions = {
        root: null,
        rootMargin: '400px',
        threshold: 0
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const button = entry.target;
                if (button.disabled || $9aa4113698f7fa9e$var$isInstanceLoading(button)) {
                    if (button.disabled) observer.unobserve(button);
                    return;
                }
                if ($9aa4113698f7fa9e$var$isSearchLoadMore(button)) $9aa4113698f7fa9e$var$triggerSearchLoadMore(button);
                else $9aa4113698f7fa9e$var$triggerLoadMore(button);
            }
        });
    }, observerOptions);
    loadMoreButtons.forEach((button)=>{
        observer.observe(button);
    });
};
// ============================================================================
// Event listeners & initialization
// ============================================================================
document.addEventListener('click', (event)=>{
    const loadMoreBtn = event.target.closest('.load-more');
    if (loadMoreBtn) {
        if ($9aa4113698f7fa9e$var$isSearchLoadMore(loadMoreBtn)) $9aa4113698f7fa9e$var$loadSearchPosts(event);
        else $9aa4113698f7fa9e$export$b10b9b608ed3fa77(event);
    }
});
const $9aa4113698f7fa9e$var$init = ()=>{
    $9aa4113698f7fa9e$var$clearOldStates();
    $9aa4113698f7fa9e$var$tryRestoreStates();
    $9aa4113698f7fa9e$var$setupStatePreservation();
    $9aa4113698f7fa9e$var$initInfiniteScroll();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $9aa4113698f7fa9e$var$init);
else $9aa4113698f7fa9e$var$init();
// Restore on bfcache page show (back/forward navigation)
window.addEventListener('pageshow', (event)=>{
    if (event.persisted) $9aa4113698f7fa9e$var$tryRestoreStates();
});


/**
 *  Add data-toggle_modal="my-modal-id" to a button
 *  Add data-modal_id="my-modal-id" to an element
 *  An inner div is required in the modal element, see example below
 **/ let $c34fafc86f04ace2$var$modal, $c34fafc86f04ace2$var$overlay, $c34fafc86f04ace2$var$modalId, $c34fafc86f04ace2$var$closeBtn;
function $c34fafc86f04ace2$var$handleModal(e) {
    if (e.target.dataset.toggle_modal) {
        if ($c34fafc86f04ace2$var$modal && $c34fafc86f04ace2$var$modal.classList.contains('active')) {
            $c34fafc86f04ace2$var$modal.classList.remove('active');
            $c34fafc86f04ace2$var$modal.querySelector('.overlay').remove();
            $c34fafc86f04ace2$var$modal.querySelector('.close-btn').remove();
        } else {
            $c34fafc86f04ace2$var$modalId = e.target.dataset.toggle_modal;
            $c34fafc86f04ace2$var$modal = document.querySelector([
                `[data-modal_id="${$c34fafc86f04ace2$var$modalId}"]`
            ]);
            const modalBody = $c34fafc86f04ace2$var$modal.querySelector('div:last-child');
            $c34fafc86f04ace2$var$overlay = /*html*/ `<div class="overlay fixed inset-0 bg-dark/25" data-toggle_modal="${$c34fafc86f04ace2$var$modalId}"></div>`;
            $c34fafc86f04ace2$var$closeBtn = /*html*/ `<button class="close-btn absolute flex items-center justify-center w-10 h-10 duration-150 rounded-full right-3 hover:bg-dark/5 active:bg-dark/10 top-3" data-toggle_modal="${$c34fafc86f04ace2$var$modalId}">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                </svg>
            </button>`;
            modalBody.insertAdjacentHTML('afterbegin', $c34fafc86f04ace2$var$closeBtn);
            $c34fafc86f04ace2$var$modal.insertAdjacentHTML('afterbegin', $c34fafc86f04ace2$var$overlay);
            $c34fafc86f04ace2$var$modal.classList.toggle('active');
        }
    }
}
document.addEventListener('click', (e)=>{
    $c34fafc86f04ace2$var$handleModal(e);
});
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Enter') $c34fafc86f04ace2$var$handleModal(e);
    if (e.key === 'Escape') {
        const activeModal = document.querySelector('[data-modal_id].active');
        if (activeModal) activeModal.classList.remove('active');
    }
}) /**
 * 
 * Example:
 * 
<button data-toggle_modal="login">Logga in</button>

<div class="flex items-center justify-center" data-modal_id="login">
    <div class="relative z-10 w-full max-w-lg p-4 bg-white rounded-lg md:p-6 lg:p-8">

    </div>
</div>
*/ ;


// Funktion för att sätta en cookie
const $7be597f098f5dfd6$var$setCookie = (name, value, days)=>{
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${value};expires=${expires};path=/`;
};
// Funktion för att hämta en cookie
const $7be597f098f5dfd6$var$getCookie = (name)=>{
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
};
// Sätter en cookie om användaren redan sett popupen och stängt den
const $7be597f098f5dfd6$var$setPopupCookie = ()=>{
    $7be597f098f5dfd6$var$setCookie('li_popup', 'closed', document.querySelector('.li-popup').getAttribute('data-popup_setcookie'));
};
// Kollar om användaren redan sett och stängt popupen
const $7be597f098f5dfd6$var$checkPopupCookie = ()=>{
    return $7be597f098f5dfd6$var$getCookie('li_popup') !== 'closed';
};
// Stänger popupen
const $7be597f098f5dfd6$var$closePopup = ()=>{
    const popup = document.querySelector('.li-popup');
    popup.classList.remove('active');
    $7be597f098f5dfd6$var$setPopupCookie();
};
// Öppnar popupen om användaren inte redan sett den efter 5 sekunder
const $7be597f098f5dfd6$var$openPopup = ()=>{
    const popup = document.querySelector('.li-popup');
    if (!popup) return;
    const delay = popup.dataset.popup_delay * 1000;
    setTimeout(()=>{
        if ($7be597f098f5dfd6$var$checkPopupCookie()) popup.classList.add('active');
    }, delay);
};
// Stänger popupen på stängknappen
const $7be597f098f5dfd6$var$closePopupBtn = ()=>{
    const closeBtn = document.querySelector('.close-li-popup');
    if (!closeBtn) return;
    closeBtn.addEventListener('click', $7be597f098f5dfd6$var$closePopup);
};
// Stänger popupen om användaren klickar utanför
const $7be597f098f5dfd6$var$closePopupOutside = ()=>{
    const popup = document.querySelector('.li-popup');
    if (!popup) return;
    popup.addEventListener('click', (e)=>{
        if (e.target.classList.contains('li-popup')) $7be597f098f5dfd6$var$closePopup();
    });
};
// Initialize the popup
const $7be597f098f5dfd6$var$initPopup = ()=>{
    $7be597f098f5dfd6$var$openPopup();
    $7be597f098f5dfd6$var$closePopupBtn();
    $7be597f098f5dfd6$var$closePopupOutside();
};
document.addEventListener('DOMContentLoaded', $7be597f098f5dfd6$var$initPopup);


function $ae7d283db5dd77fd$var$handleYouTube() {
    // Ladda YouTube IFrame API
    var youtubePlayers = document.querySelectorAll('.video-player-wrapper[data-video-type="youtube"]');
    if (youtubePlayers.length === 0) return;
    if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    // Initieras när YouTube API är klart
    window.onYouTubeIframeAPIReady = function() {
        var youtubePlayers = document.querySelectorAll('.video-player-wrapper[data-video-type="youtube"]');
        youtubePlayers.forEach(function(playerWrapper) {
            var videoId = playerWrapper.getAttribute('data-video-id');
            var autoplay = parseInt(playerWrapper.getAttribute('data-video-autoplay'), 10);
            var controls = parseInt(playerWrapper.getAttribute('data-video-controls'), 10);
            // Skapa en div för YouTube-spelaren
            var playerDiv = document.createElement('div');
            playerWrapper.querySelector('.video-player').appendChild(playerDiv);
            // Initiera YouTube-spelaren
            var ytPlayer = new YT.Player(playerDiv, {
                height: '360',
                width: '640',
                videoId: videoId,
                playerVars: {
                    autoplay: 0,
                    controls: controls,
                    mute: autoplay,
                    loop: autoplay,
                    playlist: videoId,
                    modestbranding: 1,
                    playsinline: 1,
                    fs: 0,
                    cc_load_policy: 0,
                    iv_load_policy: 3,
                    autohide: autoplay
                },
                events: {
                    onReady: function(event) {
                        // Använd IntersectionObserver för att starta videon när den är i viewport
                        if (autoplay) {
                            var observer = new IntersectionObserver(function(entries, obs) {
                                entries.forEach(function(entry) {
                                    if (entry.isIntersecting) {
                                        event.target.playVideo() // Spela video
                                        ;
                                        obs.unobserve(entry.target) // Koppla bort observern
                                        ;
                                    }
                                });
                            }, {
                                threshold: 0.5
                            } // Justera tröskelvärdet efter behov
                            );
                            observer.observe(playerWrapper);
                            const playPause = playerWrapper.querySelector('.play-pause');
                            if (playPause) playPause.addEventListener('click', function() {
                                if (playPause.classList.contains('remove-play-pause')) {
                                    playPause.remove();
                                    event.target.seekTo(0);
                                    event.target.unMute();
                                    event.target.playVideo();
                                    return;
                                }
                                if (playPause.classList.contains('paused')) {
                                    playPause.classList.remove('paused');
                                    event.target.playVideo();
                                } else {
                                    playPause.classList.add('paused');
                                    event.target.pauseVideo();
                                }
                            });
                        }
                    }
                }
            });
        });
    };
}
function $ae7d283db5dd77fd$var$handleHTML5() {
    // Ladda HTML5-videospelaren
    var html5Players = document.querySelectorAll('.video-player-wrapper[data-video-type="html5"]');
    if (html5Players.length === 0) return;
    html5Players.forEach(function(playerWrapper) {
        const video = playerWrapper.querySelector('video');
        const playPause = playerWrapper.querySelector('.play-pause');
        if (playPause) playPause.addEventListener('click', function(event) {
            if (playPause.classList.contains('remove-play-pause')) {
                playPause.remove();
                video.currentTime = 0;
                video.muted = false;
                video.play();
                return;
            }
            if (playPause.classList.contains('paused')) {
                playPause.classList.remove('paused');
                video.play();
            } else {
                playPause.classList.add('paused');
                video.pause();
            }
        });
    });
}
function $ae7d283db5dd77fd$var$handleVimeo() {
    var vimeoPlayerWrappers = document.querySelectorAll('.video-player-wrapper[data-video-type="vimeo"]');
    if (vimeoPlayerWrappers.length === 0) return;
    var tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    tag.onload = function() {
        vimeoPlayerWrappers.forEach(function(playerWrapper) {
            var videoId = playerWrapper.getAttribute('data-video-id');
            var autoplay = parseInt(playerWrapper.getAttribute('data-video-autoplay'), 10);
            var controls = parseInt(playerWrapper.getAttribute('data-video-controls'), 10);
            const playerDiv = playerWrapper.querySelector('.video-player');
            const vimeoPlayer = new Vimeo.Player(playerDiv, {
                id: videoId,
                autoplay: 0,
                controls: controls,
                muted: autoplay,
                loop: autoplay
            });
            if (autoplay) {
                var observer = new IntersectionObserver(function(entries, obs) {
                    entries.forEach(function(entry) {
                        if (entry.isIntersecting) {
                            vimeoPlayer.play();
                            obs.unobserve(entry.target);
                        }
                    });
                }, {
                    threshold: 0.5
                });
                observer.observe(playerWrapper);
            }
            vimeoPlayer.on('play', function() {
                playerWrapper.classList.add('video-activated');
            });
            vimeoPlayer.on('pause', function() {
                playerWrapper.classList.remove('video-activated');
            });
            const playPause = playerWrapper.querySelector('.play-pause');
            if (playPause) playPause.addEventListener('click', function() {
                vimeoPlayer.getPaused().then(function(paused) {
                    if (playPause.classList.contains('remove-play-pause')) {
                        playPause.remove();
                        vimeoPlayer.setCurrentTime(0);
                        vimeoPlayer.setVolume(1);
                        vimeoPlayer.play();
                        return;
                    }
                    if (paused) {
                        playPause.classList.remove('paused');
                        vimeoPlayer.play();
                    } else {
                        playPause.classList.add('paused');
                        vimeoPlayer.pause();
                    }
                });
            });
        });
    };
}
document.addEventListener('DOMContentLoaded', function() {
    $ae7d283db5dd77fd$var$handleYouTube();
    $ae7d283db5dd77fd$var$handleHTML5();
    $ae7d283db5dd77fd$var$handleVimeo();
});


document.addEventListener('DOMContentLoaded', ()=>{
    const previewText = /*html*/ `
    <span class="absolute -top-1.5 left-0 right-0 inline-flex items-center justify-center px-3 py-2 mx-auto text-sm text-center text-dark rounded-sm max-w-96 bg-[#FBF13C]/90 hover:opacity-20 transition-opacity z-10">
        <span class="inline-flex items-center justify-center p-1 mr-2 text-sm bg-white rounded-full sm:mr-3 size-5">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM12 9C10.34 9 9 10.34 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 10.34 13.66 9 12 9Z" fill="#000000" />
            </svg>
        </span>
        <strong class="mr-1">F\xf6rhandsgranskning</strong> - visas endast f\xf6r admin &darr;
    </span>`;
    const previewComponents = document.querySelectorAll('[data-preview]');
    if (previewComponents.length > 0) previewComponents.forEach((component)=>{
        component.insertAdjacentHTML('beforeend', previewText);
    });
});


/**
 * Swiper 12.1.4
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: April 29, 2026
 */ function $36e600d4bd8d4d58$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $cdba156f56d9c0b3$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $36e600d4bd8d4d58$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $90a40128ed2aa990$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $90a40128ed2aa990$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $90a40128ed2aa990$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


/**
 * SSR Window 5.0.1
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: June 27, 2025
 */ /* eslint-disable no-param-reassign */ function $14775fcb293f8fb4$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $14775fcb293f8fb4$var$extend(target = {}, src = {}) {
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($14775fcb293f8fb4$var$isObject(src[key]) && $14775fcb293f8fb4$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $14775fcb293f8fb4$var$extend(target[key], src[key]);
    });
}
const $14775fcb293f8fb4$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $14775fcb293f8fb4$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $14775fcb293f8fb4$var$extend(doc, $14775fcb293f8fb4$var$ssrDocument);
    return doc;
}
const $14775fcb293f8fb4$var$ssrWindow = {
    document: $14775fcb293f8fb4$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $14775fcb293f8fb4$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $14775fcb293f8fb4$var$extend(win, $14775fcb293f8fb4$var$ssrWindow);
    return win;
}



function $f63486b4947bc051$export$342063e11d6c3cad(classes = '') {
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $f63486b4947bc051$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $f63486b4947bc051$export$7ccc53e8f1e7dfc5(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $f63486b4947bc051$export$dda1d9f60106f0e9() {
    return Date.now();
}
function $f63486b4947bc051$var$getComputedStyle(el) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $f63486b4947bc051$export$882b5998b3b9117c(el, axis = 'x') {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $f63486b4947bc051$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $f63486b4947bc051$export$ffb5f4729a158638(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $f63486b4947bc051$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $f63486b4947bc051$export$d141bba7fdc215a3(...args) {
    const to = Object(args[0]);
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$f63486b4947bc051$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($f63486b4947bc051$export$ffb5f4729a158638(to[nextKey]) && $f63486b4947bc051$export$ffb5f4729a158638(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f63486b4947bc051$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$f63486b4947bc051$export$ffb5f4729a158638(to[nextKey]) && $f63486b4947bc051$export$ffb5f4729a158638(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $f63486b4947bc051$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $f63486b4947bc051$export$8b22cf2602fb60ce(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $f63486b4947bc051$export$3b14a55fb2447963({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $f63486b4947bc051$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $f63486b4947bc051$export$f1e1789686576879(element, selector = '') {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $f63486b4947bc051$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $f63486b4947bc051$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $f63486b4947bc051$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $f63486b4947bc051$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $f63486b4947bc051$export$db3b6bfb95261072(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $f63486b4947bc051$export$342063e11d6c3cad(classes));
    return el;
}
function $f63486b4947bc051$export$2d1720544b23b823(el) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $f63486b4947bc051$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $f63486b4947bc051$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $f63486b4947bc051$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $f63486b4947bc051$export$35e795649ee09318(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $f63486b4947bc051$export$4368d992c4eafac0(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $f63486b4947bc051$export$ae1af26003f05816(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $f63486b4947bc051$export$23f2a1d2818174ef(el, size, includeMargins) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $f63486b4947bc051$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $f63486b4947bc051$export$407448d2b89b1813(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $f63486b4947bc051$export$2408f22a0fab9ae5(el, html = '') {
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $19697d6420df31ba$var$support;
function $19697d6420df31ba$var$calcSupport() {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $19697d6420df31ba$var$getSupport() {
    if (!$19697d6420df31ba$var$support) $19697d6420df31ba$var$support = $19697d6420df31ba$var$calcSupport();
    return $19697d6420df31ba$var$support;
}
let $19697d6420df31ba$var$deviceCached;
function $19697d6420df31ba$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = $19697d6420df31ba$var$getSupport();
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $19697d6420df31ba$var$getDevice(overrides = {}) {
    if (!$19697d6420df31ba$var$deviceCached) $19697d6420df31ba$var$deviceCached = $19697d6420df31ba$var$calcDevice(overrides);
    return $19697d6420df31ba$var$deviceCached;
}
let $19697d6420df31ba$var$browser;
function $19697d6420df31ba$var$calcBrowser() {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const device = $19697d6420df31ba$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $19697d6420df31ba$var$getBrowser() {
    if (!$19697d6420df31ba$var$browser) $19697d6420df31ba$var$browser = $19697d6420df31ba$var$calcBrowser();
    return $19697d6420df31ba$var$browser;
}
function $19697d6420df31ba$var$Resize({ swiper: swiper, on: on, emit: emit }) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $19697d6420df31ba$var$Observer({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $f63486b4947bc051$export$4368d992c4eafac0)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $19697d6420df31ba$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $19697d6420df31ba$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $f63486b4947bc051$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $f63486b4947bc051$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $f63486b4947bc051$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $f63486b4947bc051$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $19697d6420df31ba$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
            if ((0, $f63486b4947bc051$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual.slidesPerViewAutoSlideSize) slideSize = params.virtual.slidesPerViewAutoSlideSize;
            if (slideSize && slide) {
                if (params.roundLengths) slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
            }
        } else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slide.style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $f63486b4947bc051$export$23f2a1d2818174ef)(slide, 'width', true) : (0, $f63486b4947bc051$export$23f2a1d2818174ef)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slide) slide.style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slide) slide.swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge && !params.loop && (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for(let i = slidesSizesGrid.length - 1; i >= 0; i -= 1){
                    accumulatedSize += slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) minVisibleSlides = slidesSizesGrid.length - i;
                    else break;
                }
            } else minVisibleSlides = Math.floor(params.slidesPerView);
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
            {
                if (i <= lastAllowedSnapIndex) newSlidesGrid.push(slidesGridItem);
            } else if (snapGrid[i] <= swiper.virtualSize - swiperSize) // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
            newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) // Only add edge-aligned snap if snapToSlideEdge is not enabled
        {
            if (!shouldSnapToSlideEdge) snapGrid.push(swiper.virtualSize - swiperSize);
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $19697d6420df31ba$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $19697d6420df31ba$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $19697d6420df31ba$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $19697d6420df31ba$var$updateSlidesProgress(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $19697d6420df31ba$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $19697d6420df31ba$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $19697d6420df31ba$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $19697d6420df31ba$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $19697d6420df31ba$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $f63486b4947bc051$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $f63486b4947bc051$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $19697d6420df31ba$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $19697d6420df31ba$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $19697d6420df31ba$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $19697d6420df31ba$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
                }
            });
        }
        // Skip removal if managed by React/Vue component
        if (lazyEl && !lazyEl.lazyPreloaderManaged) lazyEl.remove();
    }
};
const $19697d6420df31ba$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $19697d6420df31ba$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $19697d6420df31ba$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $19697d6420df31ba$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $19697d6420df31ba$var$unlazy(swiper, i);
    }
};
function $19697d6420df31ba$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $19697d6420df31ba$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $19697d6420df31ba$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled) {
        if (params.loop) realIndex = getVirtualRealIndex(activeIndex);
        else realIndex = activeIndex;
    } else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $19697d6420df31ba$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $19697d6420df31ba$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $19697d6420df31ba$var$update = {
    updateSize: $19697d6420df31ba$var$updateSize,
    updateSlides: $19697d6420df31ba$var$updateSlides,
    updateAutoHeight: $19697d6420df31ba$var$updateAutoHeight,
    updateSlidesOffset: $19697d6420df31ba$var$updateSlidesOffset,
    updateSlidesProgress: $19697d6420df31ba$var$updateSlidesProgress,
    updateProgress: $19697d6420df31ba$var$updateProgress,
    updateSlidesClasses: $19697d6420df31ba$var$updateSlidesClasses,
    updateActiveIndex: $19697d6420df31ba$var$updateActiveIndex,
    updateClickedSlide: $19697d6420df31ba$var$updateClickedSlide
};
function $19697d6420df31ba$var$getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $f63486b4947bc051$export$882b5998b3b9117c)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $19697d6420df31ba$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $19697d6420df31ba$var$minTranslate() {
    return -this.snapGrid[0];
}
function $19697d6420df31ba$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $19697d6420df31ba$var$translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $f63486b4947bc051$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $19697d6420df31ba$var$translate = {
    getTranslate: $19697d6420df31ba$var$getSwiperTranslate,
    setTranslate: $19697d6420df31ba$var$setTranslate,
    minTranslate: $19697d6420df31ba$var$minTranslate,
    maxTranslate: $19697d6420df31ba$var$maxTranslate,
    translateTo: $19697d6420df31ba$var$translateTo
};
function $19697d6420df31ba$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $19697d6420df31ba$var$transitionEmit({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $19697d6420df31ba$var$transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $19697d6420df31ba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $19697d6420df31ba$var$transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $19697d6420df31ba$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $19697d6420df31ba$var$transition = {
    setTransition: $19697d6420df31ba$var$setTransition,
    transitionStart: $19697d6420df31ba$var$transitionStart,
    transitionEnd: $19697d6420df31ba$var$transitionEnd
};
function $19697d6420df31ba$var$slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $f63486b4947bc051$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $19697d6420df31ba$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $19697d6420df31ba$var$slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = bothDirections ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $19697d6420df31ba$var$slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $19697d6420df31ba$var$slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $19697d6420df31ba$var$slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $19697d6420df31ba$var$slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $19697d6420df31ba$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(swiper.clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) swiper.slideToLoop(realIndex);
        else if (slideToIndex > (isGrid ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1) : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $f63486b4947bc051$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $19697d6420df31ba$var$slide = {
    slideTo: $19697d6420df31ba$var$slideTo,
    slideToLoop: $19697d6420df31ba$var$slideToLoop,
    slideNext: $19697d6420df31ba$var$slideNext,
    slidePrev: $19697d6420df31ba$var$slidePrev,
    slideReset: $19697d6420df31ba$var$slideReset,
    slideToClosest: $19697d6420df31ba$var$slideToClosest,
    slideToClickedSlide: $19697d6420df31ba$var$slideToClickedSlide
};
function $19697d6420df31ba$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const clearBlankSlides = ()=>{
        const slides = (0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el)=>{
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) clearBlankSlides();
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $f63486b4947bc051$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f63486b4947bc051$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $f63486b4947bc051$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial: initial
    });
}
function $19697d6420df31ba$var$loopFix({ slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = {}) {
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, slidesOffsetBefore: slidesOffsetBefore, slidesOffsetAfter: slidesOffsetAfter, initialSlide: initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!bothDirections && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (bothDirections && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = bothDirections ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2)) : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $f63486b4947bc051$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $f63486b4947bc051$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix((0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, loopParams), {
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            }));
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix((0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, loopParams), {
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        }));
    }
    swiper.emit('loopFix');
}
function $19697d6420df31ba$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $19697d6420df31ba$var$loop = {
    loopCreate: $19697d6420df31ba$var$loopCreate,
    loopFix: $19697d6420df31ba$var$loopFix,
    loopDestroy: $19697d6420df31ba$var$loopDestroy
};
function $19697d6420df31ba$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $19697d6420df31ba$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $19697d6420df31ba$var$grabCursor = {
    setGrabCursor: $19697d6420df31ba$var$setGrabCursor,
    unsetGrabCursor: $19697d6420df31ba$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $19697d6420df31ba$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $14775fcb293f8fb4$export$39b482c5e57630a8)() || el === (0, $14775fcb293f8fb4$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $19697d6420df31ba$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $19697d6420df31ba$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $19697d6420df31ba$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $f63486b4947bc051$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $19697d6420df31ba$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$19697d6420df31ba$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $f63486b4947bc051$export$dda1d9f60106f0e9)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $19697d6420df31ba$var$onTouchMove(event) {
    const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $f63486b4947bc051$export$dda1d9f60106f0e9)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $19697d6420df31ba$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $f63486b4947bc051$export$dda1d9f60106f0e9)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $f63486b4947bc051$export$dda1d9f60106f0e9)();
    (0, $f63486b4947bc051$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $19697d6420df31ba$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
        const slides = isVirtual ? swiper.virtual.slides : swiper.slides;
        swiper.slideTo(slides.length - 1, 0, false, true);
    } else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $19697d6420df31ba$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $19697d6420df31ba$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $19697d6420df31ba$var$onLoad(e) {
    const swiper = this;
    $19697d6420df31ba$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $19697d6420df31ba$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $19697d6420df31ba$var$events = (swiper, method)=>{
    const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $19697d6420df31ba$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $19697d6420df31ba$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $19697d6420df31ba$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $19697d6420df31ba$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $19697d6420df31ba$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $19697d6420df31ba$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $19697d6420df31ba$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $19697d6420df31ba$var$onScroll.bind(swiper);
    swiper.onClick = $19697d6420df31ba$var$onClick.bind(swiper);
    swiper.onLoad = $19697d6420df31ba$var$onLoad.bind(swiper);
    $19697d6420df31ba$var$events(swiper, 'on');
}
function $19697d6420df31ba$var$detachEvents() {
    const swiper = this;
    $19697d6420df31ba$var$events(swiper, 'off');
}
var $19697d6420df31ba$var$events$1 = {
    attachEvents: $19697d6420df31ba$var$attachEvents,
    detachEvents: $19697d6420df31ba$var$detachEvents
};
const $19697d6420df31ba$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $19697d6420df31ba$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $19697d6420df31ba$var$isGridEnabled(swiper, params);
    const isMultiRow = $19697d6420df31ba$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $f63486b4947bc051$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $19697d6420df31ba$var$getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $19697d6420df31ba$var$breakpoints = {
    setBreakpoint: $19697d6420df31ba$var$setBreakpoint,
    getBreakpoint: $19697d6420df31ba$var$getBreakpoint
};
function $19697d6420df31ba$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $19697d6420df31ba$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $19697d6420df31ba$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $19697d6420df31ba$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $19697d6420df31ba$var$classes = {
    addClasses: $19697d6420df31ba$var$addClasses,
    removeClasses: $19697d6420df31ba$var$removeClasses
};
function $19697d6420df31ba$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $19697d6420df31ba$var$checkOverflow$1 = {
    checkOverflow: $19697d6420df31ba$var$checkOverflow
};
var $19697d6420df31ba$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $19697d6420df31ba$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $f63486b4947bc051$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $f63486b4947bc051$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $f63486b4947bc051$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $19697d6420df31ba$var$prototypes = {
    eventsEmitter: $19697d6420df31ba$var$eventsEmitter,
    update: $19697d6420df31ba$var$update,
    translate: $19697d6420df31ba$var$translate,
    transition: $19697d6420df31ba$var$transition,
    slide: $19697d6420df31ba$var$slide,
    loop: $19697d6420df31ba$var$loop,
    grabCursor: $19697d6420df31ba$var$grabCursor,
    events: $19697d6420df31ba$var$events$1,
    breakpoints: $19697d6420df31ba$var$breakpoints,
    checkOverflow: $19697d6420df31ba$var$checkOverflow$1,
    classes: $19697d6420df31ba$var$classes
};
const $19697d6420df31ba$var$extendedDefaults = {};
class $19697d6420df31ba$export$25ce5a424b770e84 {
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $f63486b4947bc051$export$35e795649ee09318)(slides[0]);
        return (0, $f63486b4947bc051$export$35e795649ee09318)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') index = Math.floor(index / this.params.grid.rows);
            else if (this.params.grid.fill === 'row') index = index % Math.ceil(this.slides.length / this.params.grid.rows);
        }
        return index;
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $f63486b4947bc051$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $19697d6420df31ba$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $f63486b4947bc051$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $f63486b4947bc051$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $f63486b4947bc051$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $f63486b4947bc051$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $f63486b4947bc051$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $19697d6420df31ba$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $19697d6420df31ba$var$processLazyPreloader(swiper, e.target);
            });
        });
        $19697d6420df31ba$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $19697d6420df31ba$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $f63486b4947bc051$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $f63486b4947bc051$export$d141bba7fdc215a3)($19697d6420df31ba$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $19697d6420df31ba$var$extendedDefaults;
    }
    static get defaults() {
        return $19697d6420df31ba$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$19697d6420df31ba$export$25ce5a424b770e84.prototype.__modules__) $19697d6420df31ba$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $19697d6420df31ba$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$19697d6420df31ba$export$25ce5a424b770e84.installModule(m));
            return $19697d6420df31ba$export$25ce5a424b770e84;
        }
        $19697d6420df31ba$export$25ce5a424b770e84.installModule(module);
        return $19697d6420df31ba$export$25ce5a424b770e84;
    }
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $f63486b4947bc051$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $f63486b4947bc051$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $19697d6420df31ba$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $19697d6420df31ba$var$getSupport();
        swiper.device = $19697d6420df31ba$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $19697d6420df31ba$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) params.modules.forEach((mod)=>{
            if (typeof mod === 'function' && swiper.modules.indexOf(mod) < 0) swiper.modules.push(mod);
        });
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $19697d6420df31ba$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $f63486b4947bc051$export$d141bba7fdc215a3)({}, $19697d6420df31ba$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $f63486b4947bc051$export$d141bba7fdc215a3)({}, swiperParams, $19697d6420df31ba$var$extendedDefaults, params);
        swiper.originalParams = (0, $f63486b4947bc051$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $f63486b4947bc051$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
}
Object.keys($19697d6420df31ba$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($19697d6420df31ba$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $19697d6420df31ba$export$25ce5a424b770e84.prototype[protoMethod] = $19697d6420df31ba$var$prototypes[prototypeGroup][protoMethod];
    });
});
$19697d6420df31ba$export$25ce5a424b770e84.use([
    $19697d6420df31ba$var$Resize,
    $19697d6420df31ba$var$Observer
]);






function $c8aac4b46c52203d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, slidesPerView: slidesPerView, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter, slidesPerViewAutoSlideSize: slidesPerViewAutoSlideSize } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) swiperSize = swiper.isHorizontal() ? swiper.el.getBoundingClientRect().width : swiper.el.getBoundingClientRect().height;
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            } else slidesPerViewNumeric = 1;
        } else slidesPerViewNumeric = slidesPerView;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerViewNumeric + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $f63486b4947bc051$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $f63486b4947bc051$export$8b22cf2602fb60ce)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $6d5e995707fa8808$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && (document.activeElement.isContentEditable || document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea'))) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $f63486b4947bc051$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $f63486b4947bc051$export$4368d992c4eafac0)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $f63486b4947bc051$export$2d1720544b23b823)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        const speed = swiper.params.keyboard.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext(speed);
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev(speed);
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext(speed);
            if (isPageUp || isArrowUp) swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $47601edebfe9f0d9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $f63486b4947bc051$export$dda1d9f60106f0e9)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $f63486b4947bc051$export$dda1d9f60106f0e9)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $f63486b4947bc051$export$dda1d9f60106f0e9)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $f63486b4947bc051$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $f63486b4947bc051$export$dda1d9f60106f0e9)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $f63486b4947bc051$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $f63486b4947bc051$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $eabd97a759edb8dd$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $f63486b4947bc051$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



const $c72bcdce5794cbe8$var$arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
function $c72bcdce5794cbe8$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $c72bcdce5794cbe8$var$arrowSvg
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $eabd97a759edb8dd$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) {
                if (params.addIcons && el.matches('.swiper-button-next,.swiper-button-prev') && !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(tempEl, $c72bcdce5794cbe8$var$arrowSvg);
                    el.appendChild(tempEl.querySelector('svg'));
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $43163227b064f588$export$db3b6bfb95261072(classes = '') {
    // Escape all CSS selector special characters
    return `.${classes.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $e498979ab5c29284$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $43163227b064f588$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $f63486b4947bc051$export$35e795649ee09318)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $f63486b4947bc051$export$23f2a1d2818174ef)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $f63486b4947bc051$export$35e795649ee09318)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $43163227b064f588$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $43163227b064f588$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $43163227b064f588$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $43163227b064f588$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $eabd97a759edb8dd$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $f63486b4947bc051$export$4368d992c4eafac0)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $f63486b4947bc051$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $0fdb1d18cf59742b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $f63486b4947bc051$export$2d1720544b23b823)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $f63486b4947bc051$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $eabd97a759edb8dd$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $43163227b064f588$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $f63486b4947bc051$export$342063e11d6c3cad)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $e273f055571028fb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $f63486b4947bc051$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $f63486b4947bc051$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $4fdd7221683e4a3e$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f63486b4947bc051$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $f63486b4947bc051$export$882b5998b3b9117c)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $f63486b4947bc051$export$882b5998b3b9117c)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f63486b4947bc051$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f63486b4947bc051$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $f63486b4947bc051$export$2d1720544b23b823)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $f63486b4947bc051$export$2d1720544b23b823)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $f63486b4947bc051$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $f63486b4947bc051$export$4368d992c4eafac0)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $1b0919b664bd52d7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $f63486b4947bc051$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $f63486b4947bc051$export$ae1af26003f05816)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $18bc782111a64b6d$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $f63486b4947bc051$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $43163227b064f588$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $f63486b4947bc051$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $f63486b4947bc051$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $43163227b064f588$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $f63486b4947bc051$export$35e795649ee09318)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $43163227b064f588$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const isActive = (isVirtual ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'))), 0);
            else if (isVirtual) swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10)), 0);
            else swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $f63486b4947bc051$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $f63486b4947bc051$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $5d68ce09a23fbbda$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $29b2db4f9a62e5cd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
    const window = (0, $14775fcb293f8fb4$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $f63486b4947bc051$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $dc4db6294c5b4e51$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params }) {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const getTotalDelay = ()=>{
        let totalDelay = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0) totalDelay = currentSlideDelay;
        return totalDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $a3ba6f802f7e66cf$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return false;
        return thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $f63486b4947bc051$export$ffb5f4729a158638)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) swiper.thumbs.swiper.on('virtualUpdate', ()=>{
            update(false, {
                autoScroll: false
            });
        });
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) for(let i = 0; i < thumbsToActivate; i += 1)(0, $f63486b4947bc051$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        var _p_autoScroll;
        if ((_p_autoScroll = p === null || p === void 0 ? void 0 : p.autoScroll) !== null && _p_autoScroll !== void 0 ? _p_autoScroll : true) autoScroll(initial ? 0 : undefined);
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $14775fcb293f8fb4$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $aa747788341205cc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $f63486b4947bc051$export$dda1d9f60106f0e9)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $f63486b4947bc051$export$dda1d9f60106f0e9)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $f63486b4947bc051$export$dda1d9f60106f0e9)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $f63486b4947bc051$export$ae1af26003f05816)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $f63486b4947bc051$export$ae1af26003f05816)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $f63486b4947bc051$export$ae1af26003f05816)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $550853a253892f85$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView) * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $80bbcf5d8d02e995$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $80bbcf5d8d02e995$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $f63486b4947bc051$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $80bbcf5d8d02e995$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $80bbcf5d8d02e995$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $80bbcf5d8d02e995$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $80bbcf5d8d02e995$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: $80bbcf5d8d02e995$var$appendSlide.bind(swiper),
        prependSlide: $80bbcf5d8d02e995$var$prependSlide.bind(swiper),
        addSlide: $80bbcf5d8d02e995$var$addSlide.bind(swiper),
        removeSlide: $80bbcf5d8d02e995$var$removeSlide.bind(swiper),
        removeAllSlides: $80bbcf5d8d02e995$var$removeAllSlides.bind(swiper)
    });
}


function $1f8b0c179ac9fa94$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $40e95dd21002e7c3$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $fb00b11adfa7a9e0$export$f1e1789686576879({ swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides }) {
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $f63486b4947bc051$export$ae1af26003f05816)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $0bcd97b980d53787$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $40e95dd21002e7c3$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $fb00b11adfa7a9e0$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $1f8b0c179ac9fa94$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $ebfcd60279f19b8a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $f63486b4947bc051$export$407448d2b89b1813)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $1f8b0c179ac9fa94$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $3ee1a1280d2716ba$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $f63486b4947bc051$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $241d443decbe76a9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $3ee1a1280d2716ba$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $3ee1a1280d2716ba$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $f63486b4947bc051$export$407448d2b89b1813)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $40e95dd21002e7c3$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $fb00b11adfa7a9e0$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $1f8b0c179ac9fa94$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $d2fcb220b437b571$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $f63486b4947bc051$export$407448d2b89b1813)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $40e95dd21002e7c3$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $3ee1a1280d2716ba$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $3ee1a1280d2716ba$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $1f8b0c179ac9fa94$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $306bc3ef9fbf904b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $f63486b4947bc051$export$407448d2b89b1813)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $3ee1a1280d2716ba$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $40e95dd21002e7c3$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $fb00b11adfa7a9e0$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $1f8b0c179ac9fa94$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $b4d23b0c6e2a1cbd$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $3ee1a1280d2716ba$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $40e95dd21002e7c3$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $f63486b4947bc051$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $fb00b11adfa7a9e0$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $1f8b0c179ac9fa94$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




/**
 * Master-fil för alla .swiper-carousel i temat.
 *
 * Konfigureras helt via data-attribut (alla är JSON):
 *
 *   data-slider_breakpoints   Swiper breakpoints.
 *   data-slider_autoplay      Närvaron aktiverar kontinuerlig autoplay (loop
 *                             utan stopp). Värde (valfritt):
 *                               { "speed": 6000 }   // ms per steg, lägre = snabbare
 *   data-slider_thumbs        Närvaron aktiverar koppling till en .swiper-thumbs
 *                             i samma parent. Värde (alla valfria):
 *                               { "target": ".swiper-thumbs",
 *                                 "effect": "fade" | "slide",
 *                                 "touch":  true | false }
 *
 * Tomt värde (t.ex. data-slider_thumbs='{}') = default-config.
 */ /**
 * Läser ett data-attribut och tolkar det som JSON.
 *   - attribut saknas helt   → null
 *   - attributet är tomt     → {}     (= aktivera med defaults)
 *   - giltig JSON            → parsat värde
 *   - ogiltig JSON           → null (loggar varning)
 */ function $382dd2a1c0fca85d$var$readJSON(el, key) {
    const raw = el.dataset[key];
    if (raw == null) return null;
    try {
        return raw.trim() ? JSON.parse(raw) : {};
    } catch (err) {
        console.warn(`[sliders] Ogiltig JSON i data-${key}:`, raw, err);
        return null;
    }
}
/**
 * Skapar en Swiper-instans på elementet, men bara om en inte redan finns.
 * Swiper sätter automatiskt el.swiper, så den används som idempotens-check
 * (skyddar mot dubbla init, t.ex. vid HMR).
 */ function $382dd2a1c0fca85d$var$makeSwiper(el, options) {
    if (el.swiper) return el.swiper;
    el.swiper = new (0, $19697d6420df31ba$export$25ce5a424b770e84)(el, options);
    return el.swiper;
}
/**
 * Initierar en thumbs-slider (det lilla navigationsbandet).
 * Anropas av initCarousel när en master pekar ut den.
 */ function $382dd2a1c0fca85d$var$initThumbs(el) {
    return $382dd2a1c0fca85d$var$makeSwiper(el, {
        modules: [
            (0, $c72bcdce5794cbe8$export$2e2bcd8739ae039)
        ],
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: $382dd2a1c0fca85d$var$readJSON(el, 'slider_breakpoints') || undefined
    });
}
/**
 * Initierar en master-slider (.swiper-carousel).
 * Bygger ihop Swiper-options baserat på data-attribut:
 * navigation/scrollbar hittas i parent, breakpoints/autoplay/thumbs läses
 * från data-attribut. Om data-slider_thumbs finns kopplas en thumbs-slider in.
 */ function $382dd2a1c0fca85d$var$initCarousel(el) {
    const parent = el.parentElement;
    const options = {
        modules: [
            (0, $c72bcdce5794cbe8$export$2e2bcd8739ae039),
            (0, $0fdb1d18cf59742b$export$2e2bcd8739ae039),
            (0, $dc4db6294c5b4e51$export$2e2bcd8739ae039)
        ],
        speed: 500,
        navigation: {
            nextEl: parent.querySelector('.swiper-button-next'),
            prevEl: parent.querySelector('.swiper-button-prev')
        },
        scrollbar: {
            el: parent.querySelector('.swiper-scrollbar'),
            draggable: true
        }
    };
    const breakpoints = $382dd2a1c0fca85d$var$readJSON(el, 'slider_breakpoints');
    if (breakpoints) options.breakpoints = breakpoints;
    const autoplay = $382dd2a1c0fca85d$var$readJSON(el, 'slider_autoplay');
    if (autoplay) {
        const wrapperEl = el.querySelector('.swiper-wrapper');
        const originalSlides = wrapperEl ? Array.from(wrapperEl.children) : [];
        const minRealSlides = 16;
        if (originalSlides.length > 0 && originalSlides.length < minRealSlides) {
            const extraRounds = Math.ceil(minRealSlides / originalSlides.length) - 1;
            for(let i = 0; i < extraRounds; i++)originalSlides.forEach((slide)=>wrapperEl.appendChild(slide.cloneNode(true)));
        }
        options.loop = true;
        // Förklonar fler slides utanför synfältet så att de kan "glida" in
        options.loopAdditionalSlides = 10;
        options.speed = autoplay.speed || 6000;
        options.autoplay = {
            delay: 0
        };
    }
    const thumbs = $382dd2a1c0fca85d$var$readJSON(el, 'slider_thumbs');
    if (thumbs) {
        const thumbsEl = parent.querySelector(thumbs.target || '.swiper-thumbs');
        if (thumbsEl) {
            options.modules.push((0, $a3ba6f802f7e66cf$export$2e2bcd8739ae039), (0, $0bcd97b980d53787$export$2e2bcd8739ae039));
            options.thumbs = {
                swiper: $382dd2a1c0fca85d$var$initThumbs(thumbsEl)
            };
            if (thumbs.effect !== 'slide') {
                options.effect = 'fade';
                options.fadeEffect = {
                    crossFade: true
                };
            }
            if (thumbs.touch !== true) options.allowTouchMove = false;
        }
    }
    const swiperInstance = $382dd2a1c0fca85d$var$makeSwiper(el, options);
    if (autoplay) $382dd2a1c0fca85d$var$initAutoplayToggle(parent, swiperInstance);
}
/**
 * Pausknapp för autoplay.
 */ function $382dd2a1c0fca85d$var$initAutoplayToggle(parent, swiperInstance) {
    const toggleBtn = parent.querySelector('.swiper-autoplay-toggle');
    if (!toggleBtn || toggleBtn.dataset.bound) return;
    toggleBtn.dataset.bound = '1';
    const pauseIcon = toggleBtn.querySelector('.swiper-autoplay-icon-pause');
    const playIcon = toggleBtn.querySelector('.swiper-autoplay-icon-play');
    toggleBtn.addEventListener('click', ()=>{
        const isPaused = toggleBtn.classList.toggle('is-paused');
        if (isPaused) {
            // autoplay.stop() hindrar bara NÄSTA steg från att schemaläggas —
            // den pågående CSS-övergången skulle annars glida klart till sin
            // slutposition. Läs av wrapperns exakta interpolerade position
            // just nu och frys den där utan övergång.
            swiperInstance.autoplay.stop();
            try {
                const matrix = new DOMMatrixReadOnly(getComputedStyle(swiperInstance.wrapperEl).transform);
                swiperInstance.setTransition(0);
                swiperInstance.setTranslate(matrix.m41);
                // Utan detta tror Swiper internt att den fortfarande animerar
                // (transitionend hann aldrig triggas eftersom vi avbröt
                // övergången manuellt) och vägrar då starta nästa steg när
                // autoplay återupptas.
                swiperInstance.transitionEnd();
            } catch (err) {
            // Om transformen inte gick att tolka: redan stoppad ovan,
            // den hinner bara glida klart det sista steget.
            }
        } else swiperInstance.autoplay.start();
        pauseIcon === null || pauseIcon === void 0 ? void 0 : pauseIcon.classList.toggle('hidden', isPaused);
        playIcon === null || playIcon === void 0 ? void 0 : playIcon.classList.toggle('hidden', !isPaused);
        toggleBtn.setAttribute('aria-label', isPaused ? toggleBtn.dataset.pausedLabel || 'Spela upp' : toggleBtn.dataset.playingLabel || 'Pausa');
    });
}
document.querySelectorAll('.swiper-carousel').forEach($382dd2a1c0fca85d$var$initCarousel);


const $d9bbb5e2b12cf194$var$mainMenu = document.querySelector('#main-menu');
const $d9bbb5e2b12cf194$var$menuToggleBtn = document.querySelector('.main-menu-toggle-btn');
const $d9bbb5e2b12cf194$var$searchWrapper = document.querySelector('.site-search-wrapper');
const $d9bbb5e2b12cf194$var$searchInput = $d9bbb5e2b12cf194$var$searchWrapper.querySelector('.main-search-input');
function $d9bbb5e2b12cf194$var$toggleMenu() {
    $d9bbb5e2b12cf194$var$closeSearch();
    $d9bbb5e2b12cf194$var$mainMenu.classList.toggle('flex!');
    $d9bbb5e2b12cf194$var$menuToggleBtn.classList.contains('menu-toggled') ? $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove('menu-toggled') : $d9bbb5e2b12cf194$var$menuToggleBtn.classList.add('menu-toggled');
}
let $d9bbb5e2b12cf194$var$dropdownBtn, $d9bbb5e2b12cf194$var$dropdown;
document.addEventListener('click', function(e) {
    if (e.target.closest('.main-menu-toggle-btn')) $d9bbb5e2b12cf194$var$toggleMenu();
    // if clicking outside of dropdown menu and dropdown menu is open then close it
    if ($d9bbb5e2b12cf194$var$dropdown && e.target !== $d9bbb5e2b12cf194$var$dropdown && !$d9bbb5e2b12cf194$var$dropdown.contains(e.target)) {
        $d9bbb5e2b12cf194$var$dropdownBtn.classList.remove('pointer-events-none');
        $d9bbb5e2b12cf194$var$dropdown.classList.remove('block!');
    }
    if (e.target.classList.contains('dropdown-btn')) {
        $d9bbb5e2b12cf194$var$dropdownBtn = e.target;
        $d9bbb5e2b12cf194$var$mainMenu.classList.remove('flex!');
        $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove('menu-toggled');
        $d9bbb5e2b12cf194$var$dropdown = e.target.closest('.dropdown-btn').nextElementSibling;
        if ($d9bbb5e2b12cf194$var$dropdown.classList.contains('block!')) $d9bbb5e2b12cf194$var$dropdown.classList.remove('block!');
        else {
            $d9bbb5e2b12cf194$var$dropdownBtn.classList.add('pointer-events-none');
            $d9bbb5e2b12cf194$var$dropdown.classList.add('block!');
        }
    }
    if (e.target.classList.contains('sub-menu-toggle-button')) {
        const parent = e.target.closest('.menu-item-has-children');
        const submenu = parent.querySelector('.sub-menu');
        if (submenu.classList.contains('active')) {
            submenu.classList.remove('active');
            parent.classList.remove('active');
        } else {
            submenu.classList.add('active');
            parent.classList.add('active');
        }
    }
    // Search toggle
    if (e.target.classList.contains('search-toggle')) {
        $d9bbb5e2b12cf194$var$searchWrapper.classList.toggle('block!');
        $d9bbb5e2b12cf194$var$mainMenu.classList.remove('flex!');
        $d9bbb5e2b12cf194$var$menuToggleBtn.classList.remove('menu-toggled');
        $d9bbb5e2b12cf194$var$searchInput.focus();
    }
    if (e.target.classList.contains('search-overlay') || e.target.classList.contains('close-search')) $d9bbb5e2b12cf194$var$closeSearch();
});
// remove submenu_classes from submenu when window is resized, only once
const $d9bbb5e2b12cf194$var$submenus = document.querySelectorAll('.sub-menu');
let $d9bbb5e2b12cf194$var$resized = false;
window.addEventListener('resize', function() {
    if (window.innerWidth > 1024) {
        if ($d9bbb5e2b12cf194$var$resized) return;
        $d9bbb5e2b12cf194$var$submenus.forEach((submenu)=>submenu.classList.remove('active'));
        $d9bbb5e2b12cf194$var$resized = true;
    } else {
        if (!$d9bbb5e2b12cf194$var$resized) return;
        $d9bbb5e2b12cf194$var$submenus.forEach((submenu)=>submenu.classList.remove('active'));
        $d9bbb5e2b12cf194$var$resized = false;
    }
});
function $d9bbb5e2b12cf194$var$closeSearch() {
    $d9bbb5e2b12cf194$var$searchInput.value = '';
    $d9bbb5e2b12cf194$var$searchWrapper.classList.remove('block!');
    return;
}
document.addEventListener('keyup', function(e) {
    if (e.target.classList.contains('main-search-input')) {
        if (e.key === 'Escape') $d9bbb5e2b12cf194$var$closeSearch();
    }
});


const $c001ddf96774b03f$export$becb836e43488847 = ()=>{
    // Target all input containers from all Gravity Forms
    const inputContainers = document.getElementsByClassName('ginput_container');
    if (inputContainers.length) // Setup focus and blur events for each field
    for (const inputContainer of inputContainers){
        // Target input element in container, whether it's an input or a textarea
        const inputElement = inputContainer.querySelectorAll(":scope > *")[0];
        // Label element is always the previous sibling of the input container
        const labelElement = inputContainer.previousElementSibling;
        // Activate label if input has value - this moves the label above the input
        inputElement.addEventListener('focus', (event)=>{
            labelElement.classList.add('active');
        });
        // Deactivate label if input is empty on blur - this moves the label back to its original position
        inputElement.addEventListener('blur-sm', (event)=>{
            if (inputElement.value === '') labelElement.classList.remove('active');
        });
        // If the input has a value on page load (when user submit fails) then activate the label
        // Also prevent animation to avoid flicker
        if (inputElement.value !== '') {
            labelElement.classList.add('no-animation');
            labelElement.classList.add('active');
            setTimeout(()=>{
                labelElement.classList.remove('no-animation');
            }, 200);
        }
    }
};
document.addEventListener('DOMContentLoaded', function() {
    // Have to use jQuery here because the gform_post_render event is triggered by Gravity Forms
    // This fires on page load and on submit.
    jQuery(document).on('gform_post_render', function(event, form_id, current_page) {
        // Move validation error message to bottom of form
        jQuery(`#gform_wrapper_${form_id} div.gform_validation_errors`).appendTo(`#gform_${form_id} div.gform_body`);
        $c001ddf96774b03f$export$becb836e43488847();
    });
}, false);


function $5e82a80886c905d1$var$checkCardBodies() {
    const cardBodies = document.querySelectorAll('.testimonial .card-body');
    cardBodies.forEach((cardBody)=>{
        if (cardBody.classList.contains('!line-clamp-none')) return;
        if (cardBody.scrollHeight > cardBody.clientHeight) cardBody.classList.add('cursor-pointer');
        else cardBody.classList.remove('cursor-pointer');
    });
}
document.addEventListener('DOMContentLoaded', $5e82a80886c905d1$var$checkCardBodies);
window.addEventListener('resize', $5e82a80886c905d1$var$checkCardBodies);
document.addEventListener('click', (e)=>{
    if (e.target.classList.contains('card-body')) {
        const cardBody = e.target;
        cardBody.classList.toggle('!line-clamp-none');
    }
});


document.addEventListener('DOMContentLoaded', function() {
    const stickyMenu = document.querySelector('.pc-sticky-menu');
    const masthead = document.querySelector('#masthead');
    if (!stickyMenu || !masthead) return;
    const updateStickyMenu = ()=>{
        const mastheadHeight = masthead.offsetHeight;
        if (stickyMenu.style.top !== `${mastheadHeight}px`) stickyMenu.style.top = `${mastheadHeight}px`;
    };
    updateStickyMenu();
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateStickyMenu, 100);
    });
});


document.addEventListener('click', (e)=>{
    if (!e.target.closest('.cat-filter')) return;
    const catFilter = e.target.closest('.cat-filter');
    const filterValue = catFilter.dataset.value;
    const isSubFilter = catFilter.classList.contains('cat-filter-sub');
    const childrenId = catFilter.dataset.childrenId // set on parent pills that have children
    ;
    const parentId = catFilter.dataset.parentId // set on sub-pills
    ;
    const postListing = catFilter.closest('.pc-post-listing');
    if (!postListing) return;
    const postContainer = postListing.querySelector('.post-listing');
    const loadMoreBtn = postListing.querySelector('.load-more');
    const loadMoreBtnText = (loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.querySelector('.load-more-text')) || null;
    const filterContainer = postListing.querySelector('[data-filter-post-type]');
    const postType = (filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.dataset.filterPostType) || 'post';
    const filterTaxonomy = (filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.dataset.filterTaxonomy) || '';
    const categoryIds = (filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.dataset.categoryIds) || (loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.dataset.categoryIds) || '';
    const orderby = (filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.dataset.orderby) || (loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.dataset.orderby) || '';
    const order = (filterContainer === null || filterContainer === void 0 ? void 0 : filterContainer.dataset.order) || (loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.dataset.order) || '';
    // --- Sub-filter group visibility ---
    const allSubGroups = postListing.querySelectorAll('.sub-filter-group');
    const allParents = postListing.querySelectorAll('.cat-filter[data-children-id]');
    const collapseAll = ()=>{
        allSubGroups.forEach((g)=>g.classList.add('hidden'));
        allParents.forEach((btn)=>btn.setAttribute('aria-expanded', 'false'));
    };
    const expandGroup = (parentBtn, subGroup)=>{
        collapseAll();
        subGroup === null || subGroup === void 0 ? void 0 : subGroup.classList.remove('hidden');
        parentBtn === null || parentBtn === void 0 ? void 0 : parentBtn.setAttribute('aria-expanded', 'true');
    };
    if (!filterValue) collapseAll();
    else if (childrenId) expandGroup(catFilter, postListing.querySelector(`.sub-filter-group[data-parent-id="${catFilter.dataset.value}"]`));
    else if (isSubFilter && parentId) {
        const parentBtn = postListing.querySelector(`.cat-filter[data-children-id="sub-${parentId}"]`);
        expandGroup(parentBtn, postListing.querySelector(`.sub-filter-group[data-parent-id="${parentId}"]`));
    } else collapseAll();
    // Deactivate all pills before the fetch (active state is set after a successful response)
    postListing.querySelectorAll('.cat-filter').forEach((btn)=>btn.classList.remove('active'));
    // Update load-more button state
    if (loadMoreBtn) {
        loadMoreBtn.dataset.catId = filterValue;
        if (filterTaxonomy) loadMoreBtn.dataset.categoryTaxonomy = filterTaxonomy;
    }
    const data = new FormData();
    data.append('action', 'load_more');
    data.append('security', liGlobal.loadMore);
    data.append('cat_id', filterValue);
    data.append('post_type', postType);
    if (filterTaxonomy) data.append('category_taxonomy', filterTaxonomy);
    if (categoryIds) data.append('category_ids', categoryIds);
    if (loadMoreBtn === null || loadMoreBtn === void 0 ? void 0 : loadMoreBtn.dataset.postsPerPage) data.append('posts_per_page', loadMoreBtn.dataset.postsPerPage);
    if (orderby) data.append('orderby', orderby);
    if (order) data.append('order', order);
    fetch(liGlobal.ajaxUrl, {
        method: 'POST',
        body: data
    }).then((response)=>response.json()).then((response)=>{
        if (!response.success) return;
        catFilter.classList.add('active');
        const posts = response.data.posts || [];
        const maxNumPages = parseInt(response.data.max_num_pages || '0', 10);
        const hasMorePages = maxNumPages > 1;
        if (!postContainer) return;
        postContainer.innerHTML = '';
        posts.forEach((post)=>{
            postContainer.insertAdjacentHTML('beforeend', post);
        });
        if (!loadMoreBtn) return;
        loadMoreBtn.classList.remove('loading');
        loadMoreBtn.dataset.paged = '1';
        loadMoreBtn.dataset.maxPages = maxNumPages.toString();
        if (hasMorePages) {
            loadMoreBtn.removeAttribute('disabled');
            loadMoreBtn.style.display = '';
            if (loadMoreBtnText) loadMoreBtnText.textContent = 'Ladda fler';
        } else {
            loadMoreBtn.setAttribute('disabled', 'disabled');
            loadMoreBtn.style.display = 'none';
        }
    });
});


const $5ca30802796f7eff$var$searchInput = document.getElementById('document-list-search');
const $5ca30802796f7eff$var$categorySelect = document.getElementById('document-list-category');
const $5ca30802796f7eff$var$folders = document.querySelectorAll('.document-list-folder');
const $5ca30802796f7eff$var$emptyMsg = document.querySelector('.document-list-empty');
function $5ca30802796f7eff$var$normalize(str) {
    return (str || '').toUpperCase();
}
function $5ca30802796f7eff$var$applyFilters() {
    const query = $5ca30802796f7eff$var$normalize($5ca30802796f7eff$var$searchInput.value);
    const category = $5ca30802796f7eff$var$categorySelect ? $5ca30802796f7eff$var$categorySelect.value : '';
    let anyVisible = false;
    $5ca30802796f7eff$var$folders.forEach((folder)=>{
        const matchesCategory = !category || folder.dataset.category === category;
        const items = folder.querySelectorAll('.document-list-item');
        let visibleCount = 0;
        items.forEach((item)=>{
            const matchesText = !query || $5ca30802796f7eff$var$normalize(item.textContent).indexOf(query) !== -1;
            const show = matchesCategory && matchesText;
            item.classList.toggle('hidden', !show);
            if (show) visibleCount++;
        });
        const folderVisible = visibleCount > 0;
        folder.classList.toggle('hidden', !folderVisible);
        if (folderVisible) anyVisible = true;
    });
    if ($5ca30802796f7eff$var$emptyMsg) $5ca30802796f7eff$var$emptyMsg.classList.toggle('hidden', anyVisible);
}
if ($5ca30802796f7eff$var$searchInput && $5ca30802796f7eff$var$folders.length) {
    $5ca30802796f7eff$var$searchInput.addEventListener('input', $5ca30802796f7eff$var$applyFilters);
    if ($5ca30802796f7eff$var$categorySelect) $5ca30802796f7eff$var$categorySelect.addEventListener('change', $5ca30802796f7eff$var$applyFilters);
}


document.addEventListener('DOMContentLoaded', function() {
    const counters = document.querySelectorAll('.count');
    if (counters.length === 0) return;
    const observerOptions = {
        root: null,
        threshold: 0.9
    };
    const startCounting = (entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                const counter = entry.target;
                const target = +counter.getAttribute('data-target');
                const speed = +counter.getAttribute('data-milliseconds');
                const updateCount = ()=>{
                    const count = +counter.innerText;
                    const increment = target / speed;
                    if (count < target) {
                        counter.innerText = Math.ceil(count + increment);
                        requestAnimationFrame(updateCount);
                    } else counter.innerText = target;
                };
                updateCount();
                observer.unobserve(counter) // Sluta observera efter att animeringen är klar
                ;
            }
        });
    };
    const observer = new IntersectionObserver(startCounting, observerOptions);
    counters.forEach((counter)=>{
        observer.observe(counter);
    });
});


document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.cert-finder').forEach($2fead50aa43ca477$var$initCertFinder);
});
function $2fead50aa43ca477$var$initCertFinder(el) {
    const tree = JSON.parse(el.dataset.tree);
    const total = parseInt(el.dataset.total, 10) || 3;
    const { texts: texts } = tree;
    const $ = (sel)=>el.querySelector(sel);
    const question = $('.cert-finder__question');
    const optionsEl = $('.cert-finder__options');
    const qWrap = $('.cert-finder__question-wrap');
    const resultEl = $('.cert-finder__result');
    const centersWrap = $('.cert-finder__centers');
    const centersList = $('.cert-finder__centers-list');
    const centersMore = $('.cert-finder__centers-more');
    const backBtn = $('.cert-finder__back');
    const resultIcon = $('.cert-finder__result-icon');
    const stepDots = el.querySelectorAll('.cert-finder__step');
    $('.cert-finder__back-text').textContent = texts.backLabel;
    $('.cert-finder__restart-text').textContent = texts.restartLabel;
    $('.cert-finder__cta-primary-text').textContent = texts.ctaPrimary;
    let history = [];
    const areasFor = (catId)=>tree.areas.filter((a)=>a.categories.includes(catId));
    const getCategoryId = ()=>{
        for(let i = history.length - 1; i >= 0; i--){
            if (history[i].categoryId != null) return history[i].categoryId;
        }
        return null;
    };
    const cloneIcon = (key, target)=>{
        const source = $(`[data-icon-for="${key}"]`);
        if (!(source === null || source === void 0 ? void 0 : source.firstElementChild)) return false;
        target.appendChild(source.firstElementChild.cloneNode(true));
        return true;
    };
    const setResultIcon = (area)=>{
        resultIcon.textContent = '';
        const catId = getCategoryId();
        if (catId != null && cloneIcon(`result-cat-${catId}`, resultIcon)) return;
        cloneIcon(`result-area-${area.id}`, resultIcon);
    };
    backBtn.addEventListener('click', ()=>{
        if (!history.length) return;
        const prev = history.pop();
        if (prev.step === 'categories') renderCategories();
        else if (prev.step === 'areas') renderAreas(prev.categoryId);
    });
    $('.cert-finder__restart').addEventListener('click', ()=>{
        history = [];
        renderCategories();
    });
    renderCategories();
    function renderCategories() {
        updateProgress(1);
        setBack(false);
        transition(qWrap, resultEl, ()=>{
            question.textContent = texts.q1;
            optionsEl.textContent = '';
            tree.categories.forEach((cat)=>{
                const areas = areasFor(cat.id);
                if (!areas.length) return;
                const meta = `${areas.length} ${areas.length === 1 ? 'certifiering' : 'certifieringar'}`;
                const row = makeOptionRow(cat.name, `cat-${cat.id}`, meta);
                row.addEventListener('click', ()=>{
                    selectRow(row, ()=>{
                        history.push({
                            step: 'categories'
                        });
                        if (areas.length === 1) {
                            history.push({
                                step: 'areas',
                                categoryId: cat.id
                            });
                            showResult(areas[0]);
                        } else renderAreas(cat.id);
                    });
                });
                optionsEl.appendChild(row);
            });
        });
    }
    function renderAreas(catId) {
        updateProgress(2);
        setBack(true);
        transition(qWrap, resultEl, ()=>{
            question.textContent = texts.q2;
            optionsEl.textContent = '';
            areasFor(catId).forEach((area)=>{
                const row = makeOptionRow(area.title, `area-${area.id}`);
                row.addEventListener('click', ()=>{
                    selectRow(row, ()=>{
                        history.push({
                            step: 'areas',
                            categoryId: catId
                        });
                        showResult(area);
                    });
                });
                optionsEl.appendChild(row);
            });
        });
    }
    function showResult(area) {
        updateProgress(total);
        setBack(true);
        transition(resultEl, qWrap, ()=>{
            $('.cert-finder__result-label').textContent = texts.resultLabel;
            $('.cert-finder__result-title').textContent = area.title;
            $('.cert-finder__result-desc').textContent = area.description;
            $('.cert-finder__result-link').href = area.url;
            setResultIcon(area);
            renderCenters(area);
        });
    }
    function renderCenters(area) {
        var _area_centers;
        centersList.textContent = '';
        if (!((_area_centers = area.centers) === null || _area_centers === void 0 ? void 0 : _area_centers.length)) {
            centersWrap.classList.add('hidden');
            return;
        }
        centersWrap.classList.remove('hidden');
        const tpl = $('.tpl-center-row').firstElementChild;
        area.centers.forEach((center)=>{
            const row = tpl.cloneNode(true);
            row.querySelector('.cert-finder__center-name').textContent = center.name;
            if (center.address) {
                const addr = row.querySelector('.cert-finder__center-address');
                addr.textContent = center.address;
                addr.classList.remove('hidden');
            }
            if (center.content) {
                const content = row.querySelector('.cert-finder__center-content');
                content.innerHTML = center.content;
                content.classList.remove('hidden');
            }
            if (center.phone) {
                const phone = row.querySelector('.cert-finder__center-phone');
                phone.href = `tel:${center.phone}`;
                phone.querySelector('.cert-finder__center-phone-text').textContent = center.phone;
                phone.classList.remove('hidden');
            }
            if (center.website) {
                const web = row.querySelector('.cert-finder__center-website');
                web.href = center.website;
                web.querySelector('.cert-finder__center-website-text').textContent = center.website.replace(/^https?:\/\//, '').replace(/\/$/, '');
                web.classList.remove('hidden');
            }
            centersList.appendChild(row);
        });
        if (centersMore) {
            centersMore.classList.remove('hidden');
            centersMore.classList.add('flex');
        }
    }
    function makeOptionRow(label, iconKey, meta = null) {
        const row = $('.tpl-option-row').firstElementChild.cloneNode(true);
        const iconCircle = row.querySelector('.cert-finder__option-icon');
        cloneIcon(iconKey, iconCircle);
        row.querySelector('.cert-finder__option-label').textContent = label;
        const metaEl = row.querySelector('.cert-finder__option-meta');
        if (meta) {
            metaEl.textContent = meta;
            metaEl.classList.remove('hidden');
        } else metaEl.remove();
        return row;
    }
    function updateProgress(current) {
        $('.cert-finder__step-label').textContent = texts.stepLabel.replace('{current}', current).replace('{total}', total);
        stepDots.forEach((dot)=>{
            const n = parseInt(dot.dataset.step, 10);
            const circle = dot.querySelector('.cert-finder__step-dot');
            const numEl = dot.querySelector('.cert-finder__step-num-inner');
            const checkEl = dot.querySelector('.cert-finder__step-check');
            const lineEl = dot.querySelector('.cert-finder__step-line-fill');
            circle.classList.remove('bg-accent-primary', 'border-accent-primary', 'text-white', 'bg-secondary-50', 'text-accent-primary');
            if (n < current) {
                circle.classList.add('bg-accent-primary', 'border-accent-primary', 'text-white');
                numEl.classList.add('hidden');
                checkEl.classList.remove('hidden');
            } else if (n === current) {
                circle.classList.add('bg-secondary-50', 'border-accent-primary', 'text-accent-primary');
                numEl.classList.remove('hidden');
                checkEl.classList.add('hidden');
            } else {
                numEl.classList.remove('hidden');
                checkEl.classList.add('hidden');
            }
            if (lineEl) {
                lineEl.classList.toggle('w-full', n < current);
                lineEl.classList.toggle('w-0', n >= current);
            }
        });
    }
    function setBack(visible) {
        backBtn.classList.toggle('hidden', !visible);
        backBtn.classList.toggle('flex', visible);
        backBtn.nextElementSibling.classList.toggle('invisible', visible);
    }
    function transition(showEl, hideEl, updateFn) {
        hideEl.classList.add('hidden');
        showEl.classList.remove('hidden');
        showEl.style.opacity = '0';
        showEl.style.transform = 'translateY(8px)';
        updateFn();
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                showEl.style.transition = 'opacity 0.25s, transform 0.25s';
                showEl.style.opacity = '1';
                showEl.style.transform = 'translateY(0)';
            });
        });
    }
    function selectRow(btn, cb) {
        btn.classList.add('bg-current/10');
        setTimeout(cb, 120);
    }
}


var $cc75f711ea0318a4$exports = {};
// Redirects any `import ... from 'vue'` (used internally by npm packages such as
// @vuepic/vue-datepicker) to the single global Vue instance loaded via vendor/vue.global.prod.js
// (enqueued separately in theme-setup/scripts.php). This keeps exactly one Vue runtime on the
// page — a component library bundled against its own separate copy of Vue would get incompatible
// internal symbols (Fragment, Teleport, etc.) from the app's own Vue instance.
$cc75f711ea0318a4$exports = window.Vue;


'use strict';
function $af63e388eb3e7024$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $0a51f960109e0fa4$var$toString } = Object.prototype;
const { getPrototypeOf: $0a51f960109e0fa4$var$getPrototypeOf } = Object;
const { iterator: $0a51f960109e0fa4$var$iterator, toStringTag: $0a51f960109e0fa4$var$toStringTag } = Symbol;
/* Creating a function that will check if an object has a property. */ const $0a51f960109e0fa4$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Walk the prototype chain (excluding the shared Object.prototype) looking for
 * an own `prop`. This distinguishes genuine own/inherited members — including
 * class accessors and template prototypes — from members injected via
 * Object.prototype pollution (e.g. `Object.prototype.username = '...'`), which
 * live on Object.prototype itself and are therefore never matched.
 *
 * @param {*} thing The value whose chain to inspect
 * @param {string|symbol} prop The property key to look for
 *
 * @returns {boolean} True when `prop` is owned below Object.prototype
 */ const $0a51f960109e0fa4$var$hasOwnInPrototypeChain = (thing, prop)=>{
    let obj = thing;
    const seen = [];
    while(obj != null && obj !== Object.prototype){
        if (seen.indexOf(obj) !== -1) return false;
        seen.push(obj);
        if ($0a51f960109e0fa4$var$hasOwnProperty(obj, prop)) return true;
        obj = $0a51f960109e0fa4$var$getPrototypeOf(obj);
    }
    return false;
};
/**
 * Read `obj[prop]` only when it is safe from Object.prototype pollution. Own
 * properties and members inherited from a non-Object.prototype source (a class
 * instance or template object) are honored; a value reachable only through a
 * polluted Object.prototype is ignored and `undefined` is returned.
 *
 * @param {*} obj The source object
 * @param {string|symbol} prop The property key to read
 *
 * @returns {*} The resolved value, or undefined when unsafe/absent
 */ const $0a51f960109e0fa4$var$getSafeProp = (obj, prop)=>obj != null && $0a51f960109e0fa4$var$hasOwnInPrototypeChain(obj, prop) ? obj[prop] : undefined;
const $0a51f960109e0fa4$var$kindOf = ((cache)=>(thing)=>{
        const str = $0a51f960109e0fa4$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0a51f960109e0fa4$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0a51f960109e0fa4$var$kindOf(thing) === type;
};
const $0a51f960109e0fa4$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is a non-null object
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0a51f960109e0fa4$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0a51f960109e0fa4$var$isUndefined = $0a51f960109e0fa4$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0a51f960109e0fa4$var$isBuffer(val) {
    return val !== null && !$0a51f960109e0fa4$var$isUndefined(val) && val.constructor !== null && !$0a51f960109e0fa4$var$isUndefined(val.constructor) && $0a51f960109e0fa4$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0a51f960109e0fa4$var$isArrayBuffer = $0a51f960109e0fa4$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0a51f960109e0fa4$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0a51f960109e0fa4$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0a51f960109e0fa4$var$isString = $0a51f960109e0fa4$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0a51f960109e0fa4$var$isFunction = $0a51f960109e0fa4$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0a51f960109e0fa4$var$isNumber = $0a51f960109e0fa4$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0a51f960109e0fa4$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0a51f960109e0fa4$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0a51f960109e0fa4$var$isPlainObject = (val)=>{
    if (!$0a51f960109e0fa4$var$isObject(val)) return false;
    const prototype = $0a51f960109e0fa4$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || $0a51f960109e0fa4$var$getPrototypeOf(prototype) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
    // Symbol.iterator as evidence the value is a tagged/iterable type rather
    // than a plain object, while ignoring keys injected onto Object.prototype.
    !$0a51f960109e0fa4$var$hasOwnInPrototypeChain(val, $0a51f960109e0fa4$var$toStringTag) && !$0a51f960109e0fa4$var$hasOwnInPrototypeChain(val, $0a51f960109e0fa4$var$iterator);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const $0a51f960109e0fa4$var$isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!$0a51f960109e0fa4$var$isObject(val) || $0a51f960109e0fa4$var$isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0a51f960109e0fa4$var$isDate = $0a51f960109e0fa4$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0a51f960109e0fa4$var$isFile = $0a51f960109e0fa4$var$kindOfTest('File');
/**
 * Determine if a value is a React Native Blob
 * React Native "blob": an object with a `uri` attribute. Optionally, it can
 * also have a `name` and `type` attribute to specify filename and content type
 *
 * @see https://github.com/facebook/react-native/blob/26684cf3adf4094eb6c405d345a75bf8c7c0bf88/Libraries/Network/FormData.js#L68-L71
 *
 * @param {*} value The value to test
 *
 * @returns {boolean} True if value is a React Native Blob, otherwise false
 */ const $0a51f960109e0fa4$var$isReactNativeBlob = (value)=>{
    return !!(value && typeof value.uri !== 'undefined');
};
/**
 * Determine if environment is React Native
 * ReactNative `FormData` has a non-standard `getParts()` method
 *
 * @param {*} formData The formData to test
 *
 * @returns {boolean} True if environment is React Native, otherwise false
 */ const $0a51f960109e0fa4$var$isReactNative = (formData)=>formData && typeof formData.getParts !== 'undefined';
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0a51f960109e0fa4$var$isBlob = $0a51f960109e0fa4$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a FileList, otherwise false
 */ const $0a51f960109e0fa4$var$isFileList = $0a51f960109e0fa4$var$kindOfTest('FileList');
const $0a51f960109e0fa4$var$isSet = $0a51f960109e0fa4$var$kindOfTest('Set');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0a51f960109e0fa4$var$isStream = (val)=>$0a51f960109e0fa4$var$isObject(val) && $0a51f960109e0fa4$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $0a51f960109e0fa4$var$getGlobal() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
}
const $0a51f960109e0fa4$var$G = $0a51f960109e0fa4$var$getGlobal();
const $0a51f960109e0fa4$var$FormDataCtor = typeof $0a51f960109e0fa4$var$G.FormData !== 'undefined' ? $0a51f960109e0fa4$var$G.FormData : undefined;
const $0a51f960109e0fa4$var$isFormData = (thing)=>{
    if (!thing) return false;
    if ($0a51f960109e0fa4$var$FormDataCtor && thing instanceof $0a51f960109e0fa4$var$FormDataCtor) return true;
    // Reject plain objects inheriting directly from Object.prototype so prototype-pollution gadgets can't spoof FormData.
    const proto = $0a51f960109e0fa4$var$getPrototypeOf(thing);
    if (!proto || proto === Object.prototype) return false;
    if (!$0a51f960109e0fa4$var$isFunction(thing.append)) return false;
    const kind = $0a51f960109e0fa4$var$kindOf(thing);
    return kind === 'formdata' || // detect form-data instance
    kind === 'object' && $0a51f960109e0fa4$var$isFunction(thing.toString) && thing.toString() === '[object FormData]';
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0a51f960109e0fa4$var$isURLSearchParams = $0a51f960109e0fa4$var$kindOfTest('URLSearchParams');
const [$0a51f960109e0fa4$var$isReadableStream, $0a51f960109e0fa4$var$isRequest, $0a51f960109e0fa4$var$isResponse, $0a51f960109e0fa4$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($0a51f960109e0fa4$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0a51f960109e0fa4$var$trim = (str)=>{
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array<unknown>} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys = false]
 * @returns {any}
 */ function $0a51f960109e0fa4$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0a51f960109e0fa4$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if ($0a51f960109e0fa4$var$isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
/**
 * Finds a key in an object, case-insensitive, returning the actual key name.
 * Returns null if the object is a Buffer or if no match is found.
 *
 * @param {Object} obj - The object to search.
 * @param {string} key - The key to find (case-insensitive).
 * @returns {?string} The actual key name if found, otherwise null.
 */ function $0a51f960109e0fa4$var$findKey(obj, key) {
    if ($0a51f960109e0fa4$var$isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0a51f960109e0fa4$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== 'undefined') return globalThis;
    return typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $0a51f960109e0fa4$var$isContextDefined = (context)=>!$0a51f960109e0fa4$var$isUndefined(context) && context !== $0a51f960109e0fa4$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * const result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0a51f960109e0fa4$var$merge(...objs) {
    const { caseless: caseless, skipUndefined: skipUndefined } = $0a51f960109e0fa4$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        // Skip dangerous property names to prevent prototype pollution
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        // findKey lowercases the key, so caseless lookup only applies to strings —
        // symbol keys are identity-matched.
        const targetKey = caseless && typeof key === 'string' && $0a51f960109e0fa4$var$findKey(result, key) || key;
        // Read via own-prop only — a bare `result[targetKey]` walks the prototype
        // chain, so a polluted Object.prototype value could surface here and get
        // copied into the merged result.
        const existing = $0a51f960109e0fa4$var$hasOwnProperty(result, targetKey) ? result[targetKey] : undefined;
        if ($0a51f960109e0fa4$var$isPlainObject(existing) && $0a51f960109e0fa4$var$isPlainObject(val)) result[targetKey] = $0a51f960109e0fa4$var$merge(existing, val);
        else if ($0a51f960109e0fa4$var$isPlainObject(val)) result[targetKey] = $0a51f960109e0fa4$var$merge({}, val);
        else if ($0a51f960109e0fa4$var$isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !$0a51f960109e0fa4$var$isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = objs.length; i < l; i++){
        const source = objs[i];
        if (!source || $0a51f960109e0fa4$var$isBuffer(source)) continue;
        $0a51f960109e0fa4$var$forEach(source, assignValue);
        if (typeof source !== 'object' || $0a51f960109e0fa4$var$isArray(source)) continue;
        const symbols = Object.getOwnPropertySymbols(source);
        for(let j = 0; j < symbols.length; j++){
            const symbol = symbols[j];
            if ($0a51f960109e0fa4$var$propertyIsEnumerable.call(source, symbol)) assignValue(source[symbol], symbol);
        }
    }
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Object} [options]
 * @param {Boolean} [options.allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0a51f960109e0fa4$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0a51f960109e0fa4$var$forEach(b, (val, key)=>{
        if (thisArg && $0a51f960109e0fa4$var$isFunction(val)) Object.defineProperty(a, key, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot
            // hijack defineProperty's accessor-vs-data resolution.
            __proto__: null,
            value: (0, $af63e388eb3e7024$export$2e2bcd8739ae039)(val, thisArg),
            writable: true,
            enumerable: true,
            configurable: true
        });
        else Object.defineProperty(a, key, {
            __proto__: null,
            value: val,
            writable: true,
            enumerable: true,
            configurable: true
        });
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0a51f960109e0fa4$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xfeff) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0a51f960109e0fa4$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    Object.defineProperty(constructor.prototype, 'constructor', {
        __proto__: null,
        value: constructor,
        writable: true,
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(constructor, 'super', {
        __proto__: null,
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0a51f960109e0fa4$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0a51f960109e0fa4$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0a51f960109e0fa4$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0a51f960109e0fa4$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0a51f960109e0fa4$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0a51f960109e0fa4$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0a51f960109e0fa4$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $0a51f960109e0fa4$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0a51f960109e0fa4$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[$0a51f960109e0fa4$var$iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0a51f960109e0fa4$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0a51f960109e0fa4$var$isHTMLForm = $0a51f960109e0fa4$var$kindOfTest('HTMLFormElement');
const $0a51f960109e0fa4$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
const { propertyIsEnumerable: $0a51f960109e0fa4$var$propertyIsEnumerable } = Object.prototype;
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0a51f960109e0fa4$var$isRegExp = $0a51f960109e0fa4$var$kindOfTest('RegExp');
const $0a51f960109e0fa4$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0a51f960109e0fa4$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0a51f960109e0fa4$var$freezeMethods = (obj)=>{
    $0a51f960109e0fa4$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0a51f960109e0fa4$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].includes(name)) return false;
        const value = obj[name];
        if (!$0a51f960109e0fa4$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
/**
 * Converts an array or a delimited string into an object set with values as keys and true as values.
 * Useful for fast membership checks.
 *
 * @param {Array|string} arrayOrString - The array or string to convert.
 * @param {string} delimiter - The delimiter to use if input is a string.
 * @returns {Object} An object with keys from the array or string, values set to true.
 */ const $0a51f960109e0fa4$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0a51f960109e0fa4$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0a51f960109e0fa4$var$noop = ()=>{};
const $0a51f960109e0fa4$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0a51f960109e0fa4$var$isSpecCompliantForm(thing) {
    return !!(thing && $0a51f960109e0fa4$var$isFunction(thing.append) && thing[$0a51f960109e0fa4$var$toStringTag] === 'FormData' && thing[$0a51f960109e0fa4$var$iterator]);
}
/**
 * Recursively converts an object to a JSON-compatible object, handling circular references and Buffers.
 *
 * @param {Object} obj - The object to convert.
 * @returns {Object} The JSON-compatible object.
 */ const $0a51f960109e0fa4$var$toJSONObject = (obj)=>{
    const visited = new WeakSet();
    const visit = (source)=>{
        if ($0a51f960109e0fa4$var$isObject(source)) {
            if (visited.has(source)) return;
            //Buffer check
            if ($0a51f960109e0fa4$var$isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                // add-on descent / delete-on-ascent: preserves path semantics, so DAG nodes serialise at every occurrence (see #7230).
                visited.add(source);
                let target;
                if ($0a51f960109e0fa4$var$isSet(source)) {
                    target = [];
                    for (const value of source){
                        const reducedValue = visit(value);
                        !$0a51f960109e0fa4$var$isUndefined(reducedValue) && target.push(reducedValue);
                    }
                } else {
                    target = $0a51f960109e0fa4$var$isArray(source) ? [] : {};
                    $0a51f960109e0fa4$var$forEach(source, (value, key)=>{
                        const reducedValue = visit(value);
                        !$0a51f960109e0fa4$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                    });
                }
                visited.delete(source);
                return target;
            }
        }
        return source;
    };
    return visit(obj);
};
/**
 * Determines if a value is an async function.
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is an async function, otherwise false.
 */ const $0a51f960109e0fa4$var$isAsyncFn = $0a51f960109e0fa4$var$kindOfTest('AsyncFunction');
/**
 * Determines if a value is thenable (has then and catch methods).
 *
 * @param {*} thing - The value to test.
 * @returns {boolean} True if value is thenable, otherwise false.
 */ const $0a51f960109e0fa4$var$isThenable = (thing)=>thing && ($0a51f960109e0fa4$var$isObject(thing) || $0a51f960109e0fa4$var$isFunction(thing)) && $0a51f960109e0fa4$var$isFunction(thing.then) && $0a51f960109e0fa4$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
/**
 * Provides a cross-platform setImmediate implementation.
 * Uses native setImmediate if available, otherwise falls back to postMessage or setTimeout.
 *
 * @param {boolean} setImmediateSupported - Whether setImmediate is supported.
 * @param {boolean} postMessageSupported - Whether postMessage is supported.
 * @returns {Function} A function to schedule a callback asynchronously.
 */ const $0a51f960109e0fa4$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $0a51f960109e0fa4$var$_global.addEventListener('message', ({ source: source, data: data })=>{
            if (source === $0a51f960109e0fa4$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $0a51f960109e0fa4$var$_global.postMessage(token, '*');
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $0a51f960109e0fa4$var$isFunction($0a51f960109e0fa4$var$_global.postMessage));
/**
 * Schedules a microtask or asynchronous callback as soon as possible.
 * Uses queueMicrotask if available, otherwise falls back to process.nextTick or _setImmediate.
 *
 * @type {Function}
 */ const $0a51f960109e0fa4$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($0a51f960109e0fa4$var$_global) : $0a51f960109e0fa4$var$_setImmediate;
// *********************
const $0a51f960109e0fa4$var$isIterable = (thing)=>thing != null && $0a51f960109e0fa4$var$isFunction(thing[$0a51f960109e0fa4$var$iterator]);
/**
 * Determine if a value is iterable via an iterator that is NOT sourced solely
 * from a polluted Object.prototype. Use this instead of `isIterable` whenever
 * the iterable comes from untrusted input (e.g. user-supplied header sources),
 * so `Object.prototype[Symbol.iterator] = ...` cannot turn an ordinary object
 * into an attacker-controlled entries iterator.
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value has a non-polluted iterator
 */ const $0a51f960109e0fa4$var$isSafeIterable = (thing)=>thing != null && $0a51f960109e0fa4$var$hasOwnInPrototypeChain(thing, $0a51f960109e0fa4$var$iterator) && $0a51f960109e0fa4$var$isIterable(thing);
var $0a51f960109e0fa4$export$2e2bcd8739ae039 = {
    isArray: $0a51f960109e0fa4$var$isArray,
    isArrayBuffer: $0a51f960109e0fa4$var$isArrayBuffer,
    isBuffer: $0a51f960109e0fa4$var$isBuffer,
    isFormData: $0a51f960109e0fa4$var$isFormData,
    isArrayBufferView: $0a51f960109e0fa4$var$isArrayBufferView,
    isString: $0a51f960109e0fa4$var$isString,
    isNumber: $0a51f960109e0fa4$var$isNumber,
    isBoolean: $0a51f960109e0fa4$var$isBoolean,
    isObject: $0a51f960109e0fa4$var$isObject,
    isPlainObject: $0a51f960109e0fa4$var$isPlainObject,
    isEmptyObject: $0a51f960109e0fa4$var$isEmptyObject,
    isReadableStream: $0a51f960109e0fa4$var$isReadableStream,
    isRequest: $0a51f960109e0fa4$var$isRequest,
    isResponse: $0a51f960109e0fa4$var$isResponse,
    isHeaders: $0a51f960109e0fa4$var$isHeaders,
    isUndefined: $0a51f960109e0fa4$var$isUndefined,
    isDate: $0a51f960109e0fa4$var$isDate,
    isFile: $0a51f960109e0fa4$var$isFile,
    isReactNativeBlob: $0a51f960109e0fa4$var$isReactNativeBlob,
    isReactNative: $0a51f960109e0fa4$var$isReactNative,
    isBlob: $0a51f960109e0fa4$var$isBlob,
    isRegExp: $0a51f960109e0fa4$var$isRegExp,
    isFunction: $0a51f960109e0fa4$var$isFunction,
    isStream: $0a51f960109e0fa4$var$isStream,
    isURLSearchParams: $0a51f960109e0fa4$var$isURLSearchParams,
    isTypedArray: $0a51f960109e0fa4$var$isTypedArray,
    isFileList: $0a51f960109e0fa4$var$isFileList,
    forEach: $0a51f960109e0fa4$var$forEach,
    merge: $0a51f960109e0fa4$var$merge,
    extend: $0a51f960109e0fa4$var$extend,
    trim: $0a51f960109e0fa4$var$trim,
    stripBOM: $0a51f960109e0fa4$var$stripBOM,
    inherits: $0a51f960109e0fa4$var$inherits,
    toFlatObject: $0a51f960109e0fa4$var$toFlatObject,
    kindOf: $0a51f960109e0fa4$var$kindOf,
    kindOfTest: $0a51f960109e0fa4$var$kindOfTest,
    endsWith: $0a51f960109e0fa4$var$endsWith,
    toArray: $0a51f960109e0fa4$var$toArray,
    forEachEntry: $0a51f960109e0fa4$var$forEachEntry,
    matchAll: $0a51f960109e0fa4$var$matchAll,
    isHTMLForm: $0a51f960109e0fa4$var$isHTMLForm,
    hasOwnProperty: $0a51f960109e0fa4$var$hasOwnProperty,
    hasOwnProp: $0a51f960109e0fa4$var$hasOwnProperty,
    hasOwnInPrototypeChain: $0a51f960109e0fa4$var$hasOwnInPrototypeChain,
    getSafeProp: $0a51f960109e0fa4$var$getSafeProp,
    reduceDescriptors: $0a51f960109e0fa4$var$reduceDescriptors,
    freezeMethods: $0a51f960109e0fa4$var$freezeMethods,
    toObjectSet: $0a51f960109e0fa4$var$toObjectSet,
    toCamelCase: $0a51f960109e0fa4$var$toCamelCase,
    noop: $0a51f960109e0fa4$var$noop,
    toFiniteNumber: $0a51f960109e0fa4$var$toFiniteNumber,
    findKey: $0a51f960109e0fa4$var$findKey,
    global: $0a51f960109e0fa4$var$_global,
    isContextDefined: $0a51f960109e0fa4$var$isContextDefined,
    isSpecCompliantForm: $0a51f960109e0fa4$var$isSpecCompliantForm,
    toJSONObject: $0a51f960109e0fa4$var$toJSONObject,
    isAsyncFn: $0a51f960109e0fa4$var$isAsyncFn,
    isThenable: $0a51f960109e0fa4$var$isThenable,
    setImmediate: $0a51f960109e0fa4$var$_setImmediate,
    asap: $0a51f960109e0fa4$var$asap,
    isIterable: $0a51f960109e0fa4$var$isIterable,
    isSafeIterable: $0a51f960109e0fa4$var$isSafeIterable
};









'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $39939d8f2c4d666a$var$ignoreDuplicateOf = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $39939d8f2c4d666a$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        const hasKey = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(parsed, key);
        if (!key || hasKey && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp($39939d8f2c4d666a$var$ignoreDuplicateOf, key)) return;
        if (key === 'set-cookie') {
            if (hasKey) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = hasKey ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};



'use strict';
function $4cbde29721a2bb46$var$trimSPorHTAB(str) {
    let start = 0;
    let end = str.length;
    while(start < end){
        const code = str.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === str.length ? str : str.slice(start, end);
}
// The control-code ranges are intentional: header sanitization strips C0/DEL bytes.
// eslint-disable-next-line no-control-regex
const $4cbde29721a2bb46$var$INVALID_UNICODE_HEADER_VALUE_CHARS = new RegExp('[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+', 'g');
// eslint-disable-next-line no-control-regex
const $4cbde29721a2bb46$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS = new RegExp('[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+', 'g');
function $4cbde29721a2bb46$var$sanitizeValue(value, invalidChars) {
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value)) return value.map((item)=>$4cbde29721a2bb46$var$sanitizeValue(item, invalidChars));
    return $4cbde29721a2bb46$var$trimSPorHTAB(String(value).replace(invalidChars, ''));
}
const $4cbde29721a2bb46$export$9e344cffce061a22 = (value)=>$4cbde29721a2bb46$var$sanitizeValue(value, $4cbde29721a2bb46$var$INVALID_UNICODE_HEADER_VALUE_CHARS);
const $4cbde29721a2bb46$export$59dd66c2a12d8f62 = (value)=>$4cbde29721a2bb46$var$sanitizeValue(value, $4cbde29721a2bb46$var$INVALID_BYTE_STRING_HEADER_VALUE_CHARS);
function $4cbde29721a2bb46$export$c30c72bb7e677d54(headers) {
    const byteStringHeaders = Object.create(null);
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(headers.toJSON(), (value, header)=>{
        byteStringHeaders[header] = $4cbde29721a2bb46$export$59dd66c2a12d8f62(value);
    });
    return byteStringHeaders;
}


'use strict';
const $332fc3eba15a6bb9$var$$internals = Symbol('internals');
function $332fc3eba15a6bb9$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $332fc3eba15a6bb9$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) ? value.map($332fc3eba15a6bb9$var$normalizeValue) : (0, $4cbde29721a2bb46$export$9e344cffce061a22)(String(value));
}
function $332fc3eba15a6bb9$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $332fc3eba15a6bb9$var$parameterNameRE = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function $332fc3eba15a6bb9$var$trimOWS(value) {
    let start = 0;
    let end = value.length;
    while(start < end){
        const code = value.charCodeAt(start);
        if (code !== 0x09 && code !== 0x20) break;
        start += 1;
    }
    while(end > start){
        const code = value.charCodeAt(end - 1);
        if (code !== 0x09 && code !== 0x20) break;
        end -= 1;
    }
    return start === 0 && end === value.length ? value : value.slice(start, end);
}
function $332fc3eba15a6bb9$var$decodeQuotedString(value) {
    const last = value.length - 1;
    if (last < 1 || value.charCodeAt(0) !== 0x22 || value.charCodeAt(last) !== 0x22) return value;
    let decoded = '';
    for(let i = 1; i < last; i++){
        const code = value.charCodeAt(i);
        if (code === 0x22) return value;
        if (code === 0x5c) {
            i += 1;
            if (i >= last) return value;
        }
        decoded += value[i];
    }
    return decoded;
}
function $332fc3eba15a6bb9$var$parseParameters(value) {
    const parameters = Object.create(null);
    const str = String(value);
    let start = 0;
    let quoted = false;
    let escaped = false;
    function parseParameter(end) {
        const part = $332fc3eba15a6bb9$var$trimOWS(str.slice(start, end));
        const equals = part.indexOf('=');
        if (equals < 1) return;
        const name = $332fc3eba15a6bb9$var$trimOWS(part.slice(0, equals));
        if (!$332fc3eba15a6bb9$var$parameterNameRE.test(name)) return;
        const normalizedName = name.toLowerCase();
        if (normalizedName === '__proto__' || normalizedName === 'constructor' || normalizedName === 'prototype') return;
        const parameterValue = $332fc3eba15a6bb9$var$trimOWS(part.slice(equals + 1));
        parameters[normalizedName] = $332fc3eba15a6bb9$var$decodeQuotedString(parameterValue);
    }
    for(let i = 0; i < str.length; i++){
        const code = str.charCodeAt(i);
        if (quoted) {
            if (escaped) escaped = false;
            else if (code === 0x5c) escaped = true;
            else if (code === 0x22) quoted = false;
        } else if (code === 0x22) quoted = true;
        else if (code === 0x2c || code === 0x3b) {
            parseParameter(i);
            start = i + 1;
        }
    }
    parseParameter(str.length);
    return parameters;
}
const $332fc3eba15a6bb9$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $332fc3eba15a6bb9$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $332fc3eba15a6bb9$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $332fc3eba15a6bb9$var$buildAccessors(obj, header) {
    const accessorName = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $332fc3eba15a6bb9$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $332fc3eba15a6bb9$var$normalizeHeader(_header);
            if (!lHeader) return;
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $332fc3eba15a6bb9$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$332fc3eba15a6bb9$var$isValidHeaderName(header)) setHeaders((0, $39939d8f2c4d666a$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(header) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isSafeIterable(header)) {
            let obj = Object.create(null), dest, key;
            for (const entry of header){
                if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(entry)) throw new TypeError('Object iterator must return a key-value pair');
                key = entry[0];
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(obj, key)) {
                    dest = obj[key];
                    obj[key] = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(dest) ? [
                        ...dest,
                        entry[1]
                    ] : [
                        dest,
                        entry[1]
                    ];
                } else obj[key] = entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $332fc3eba15a6bb9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $332fc3eba15a6bb9$var$parseTokens(value);
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $332fc3eba15a6bb9$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $332fc3eba15a6bb9$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $332fc3eba15a6bb9$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $332fc3eba15a6bb9$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $332fc3eba15a6bb9$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $332fc3eba15a6bb9$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $332fc3eba15a6bb9$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $332fc3eba15a6bb9$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        const value = this.get('set-cookie');
        return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) ? value : value == null || value === false ? [] : [
            value
        ];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static parseParameters(value) {
        return $332fc3eba15a6bb9$var$parseParameters(value);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$332fc3eba15a6bb9$var$$internals] = this[$332fc3eba15a6bb9$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $332fc3eba15a6bb9$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $332fc3eba15a6bb9$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$332fc3eba15a6bb9$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).reduceDescriptors($332fc3eba15a6bb9$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).freezeMethods($332fc3eba15a6bb9$var$AxiosHeaders);
var $332fc3eba15a6bb9$export$2e2bcd8739ae039 = $332fc3eba15a6bb9$var$AxiosHeaders;


'use strict';
const $f2fd8632892200c7$export$6acd2efa8ac62a1b = '[REDACTED ****]';
function $f2fd8632892200c7$var$hasOwnOrPrototypeToJSON(source) {
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(source, 'toJSON')) return true;
    let prototype = Object.getPrototypeOf(source);
    while(prototype && prototype !== Object.prototype){
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(prototype, 'toJSON')) return true;
        prototype = Object.getPrototypeOf(prototype);
    }
    return false;
}
// Build a plain-object snapshot of `config` and replace the value of any key
// (case-insensitive) listed in `redactKeys` with REDACTED. Walks through arrays
// and AxiosHeaders, and short-circuits on circular references.
function $f2fd8632892200c7$var$redactConfig(config, redactKeys) {
    const lowerKeys = new Set(redactKeys.map((k)=>String(k).toLowerCase()));
    const seen = [];
    const visit = (source)=>{
        if (source === null || typeof source !== 'object') return source;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBuffer(source)) return source;
        if (seen.indexOf(source) !== -1) return undefined;
        if (source instanceof (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039)) source = source.toJSON();
        seen.push(source);
        let result;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(source)) {
            result = [];
            source.forEach((v, i)=>{
                const reducedValue = visit(v);
                if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[i] = reducedValue;
            });
        } else {
            if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(source) && $f2fd8632892200c7$var$hasOwnOrPrototypeToJSON(source)) {
                seen.pop();
                return source;
            }
            result = Object.create(null);
            for (const [key, value] of Object.entries(source)){
                const reducedValue = lowerKeys.has(key.toLowerCase()) ? $f2fd8632892200c7$export$6acd2efa8ac62a1b : visit(value);
                if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(reducedValue)) result[key] = reducedValue;
            }
        }
        seen.pop();
        return result;
    };
    return visit(config);
}
function $f2fd8632892200c7$var$stringifySafely(value) {
    try {
        return String(value);
    } catch (err) {
        return '';
    }
}
function $f2fd8632892200c7$var$aggregateErrorMessage(error) {
    const message = error.errors.map((entry)=>{
        try {
            return entry && entry.message ? $f2fd8632892200c7$var$stringifySafely(entry.message) : $f2fd8632892200c7$var$stringifySafely(entry);
        } catch (err) {
            return '';
        }
    }).filter(Boolean).join('; ');
    return message || error.name || 'AggregateError';
}
class $f2fd8632892200c7$var$AxiosError extends Error {
    static from(error, code, config, request, response, customProps) {
        // `AggregateError` (thrown by Node on dual-stack/Happy-Eyeballs connection
        // failures) has an empty `message`; its detail lives in `errors[]`. Without
        // this, the wrapped error surfaces with a blank message (see #6721).
        let message = error.message;
        if (!message && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(error.errors) && error.errors.length) message = $f2fd8632892200c7$var$aggregateErrorMessage(error);
        const axiosError = new $f2fd8632892200c7$var$AxiosError(message, code || error.code, config, request, response);
        // Match native `Error` `cause` semantics: non-enumerable. The wrapped
        // error often carries circular internals (sockets, requests, agents), so
        // an enumerable `cause` makes structured loggers (pino/winston) and any
        // own-property walk throw "Converting circular structure to JSON".
        // Regression from #6982; see #7205. `__proto__: null` mirrors the
        // `message` descriptor below (prototype-pollution-safe descriptor).
        Object.defineProperty(axiosError, 'cause', {
            __proto__: null,
            value: error,
            writable: true,
            enumerable: false,
            configurable: true
        });
        axiosError.name = error.name;
        // Preserve status from the original error if not already set from response
        if (error.status != null && axiosError.status == null) axiosError.status = error.status;
        customProps && Object.assign(axiosError, customProps);
        return axiosError;
    }
    toJSON() {
        // Opt-in redaction: when the request config carries a `redact` array, the
        // value of any matching key (case-insensitive, at any depth) is replaced
        // with REDACTED in the serialized snapshot. Undefined or empty leaves the
        // existing serialization behavior unchanged.
        const config = this.config;
        const redactKeys = config && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config, 'redact') ? config.redact : undefined;
        const serializedConfig = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(redactKeys) && redactKeys.length > 0 ? $f2fd8632892200c7$var$redactConfig(config, redactKeys) : (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toJSONObject(config);
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: serializedConfig,
            code: this.code,
            status: this.status
        };
    }
    /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */ constructor(message, code, config, request, response){
        super(message);
        // Make message enumerable to maintain backward compatibility
        // The native Error constructor sets message as non-enumerable,
        // but axios < v1.13.3 had it as enumerable
        Object.defineProperty(this, 'message', {
            // Null-proto descriptor so a polluted Object.prototype.get cannot turn
            // this data descriptor into an accessor descriptor on the way in.
            __proto__: null,
            value: message,
            enumerable: true,
            writable: true,
            configurable: true
        });
        this.name = 'AxiosError';
        this.isAxiosError = true;
        code && (this.code = code);
        config && (this.config = config);
        request && (this.request = request);
        if (response) {
            this.response = response;
            this.status = response.status;
        }
    }
}
// This can be changed to static properties as soon as the parser options in .eslint.cjs are updated.
$f2fd8632892200c7$var$AxiosError.ERR_BAD_OPTION_VALUE = 'ERR_BAD_OPTION_VALUE';
$f2fd8632892200c7$var$AxiosError.ERR_BAD_OPTION = 'ERR_BAD_OPTION';
$f2fd8632892200c7$var$AxiosError.ECONNABORTED = 'ECONNABORTED';
$f2fd8632892200c7$var$AxiosError.ETIMEDOUT = 'ETIMEDOUT';
$f2fd8632892200c7$var$AxiosError.ECONNREFUSED = 'ECONNREFUSED';
$f2fd8632892200c7$var$AxiosError.ERR_NETWORK = 'ERR_NETWORK';
$f2fd8632892200c7$var$AxiosError.ERR_FR_TOO_MANY_REDIRECTS = 'ERR_FR_TOO_MANY_REDIRECTS';
$f2fd8632892200c7$var$AxiosError.ERR_DEPRECATED = 'ERR_DEPRECATED';
$f2fd8632892200c7$var$AxiosError.ERR_BAD_RESPONSE = 'ERR_BAD_RESPONSE';
$f2fd8632892200c7$var$AxiosError.ERR_BAD_REQUEST = 'ERR_BAD_REQUEST';
$f2fd8632892200c7$var$AxiosError.ERR_CANCELED = 'ERR_CANCELED';
$f2fd8632892200c7$var$AxiosError.ERR_NOT_SUPPORT = 'ERR_NOT_SUPPORT';
$f2fd8632892200c7$var$AxiosError.ERR_INVALID_URL = 'ERR_INVALID_URL';
$f2fd8632892200c7$var$AxiosError.ERR_FORM_DATA_DEPTH_EXCEEDED = 'ERR_FORM_DATA_DEPTH_EXCEEDED';
var $f2fd8632892200c7$export$2e2bcd8739ae039 = $f2fd8632892200c7$var$AxiosError;


// eslint-disable-next-line strict
var $92fbca5b49d9b1b0$export$2e2bcd8739ae039 = null;



'use strict';
const $1a17727e3ca99c94$export$659081b45d03227d = 100;
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $1a17727e3ca99c94$var$isVisitable(thing) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $1a17727e3ca99c94$var$removeBrackets(key) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $1a17727e3ca99c94$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $1a17727e3ca99c94$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $1a17727e3ca99c94$var$isFlatArray(arr) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(arr) && !arr.some($1a17727e3ca99c94$var$isVisitable);
}
const $1a17727e3ca99c94$var$predicates = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFlatObject((0, $0a51f960109e0fa4$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $1a17727e3ca99c94$var$toFormData(obj, formData, options) {
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const maxDepth = options.maxDepth === undefined ? $1a17727e3ca99c94$export$659081b45d03227d : options.maxDepth;
    const useBlob = _Blob && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    const stack = [];
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBoolean(value)) return value.toString();
        if (!useBlob && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isTypedArray(value)) {
            if (useBlob && typeof _Blob === 'function') return new _Blob([
                value
            ]);
            if ((0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039) && (0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039).isBufferAvailable()) return (0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039).from(value);
            throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
        }
        return value;
    }
    function throwIfMaxDepthExceeded(depth) {
        if (depth > maxDepth) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Object is too deeply nested (' + depth + ' levels). Max depth: ' + maxDepth, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
    }
    function stringifyWithDepthLimit(value, depth) {
        if (maxDepth === Infinity) return JSON.stringify(value);
        const ancestors = [];
        return JSON.stringify(value, function limitDepth(_key, currentValue) {
            if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(currentValue)) return currentValue;
            while(ancestors.length && ancestors[ancestors.length - 1] !== this)ancestors.pop();
            ancestors.push(currentValue);
            throwIfMaxDepthExceeded(depth + ancestors.length - 1);
            return currentValue;
        });
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReactNative(formData) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReactNativeBlob(value)) {
            formData.append($1a17727e3ca99c94$var$renderKey(path, key, dots), convertValue(value));
            return false;
        }
        if (value && !path && typeof value === 'object') {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = stringifyWithDepthLimit(value, 1);
            } else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(value) && $1a17727e3ca99c94$var$isFlatArray(value) || ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFileList(value) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $1a17727e3ca99c94$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $1a17727e3ca99c94$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($1a17727e3ca99c94$var$isVisitable(value)) return true;
        formData.append($1a17727e3ca99c94$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const exposedHelpers = Object.assign($1a17727e3ca99c94$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $1a17727e3ca99c94$var$isVisitable
    });
    function build(value, path, depth = 0) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(value)) return;
        throwIfMaxDepthExceeded(depth);
        if (stack.indexOf(value) !== -1) throw new Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ], depth + 1);
        });
        stack.pop();
    }
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $1a17727e3ca99c94$export$2e2bcd8739ae039 = $1a17727e3ca99c94$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $0b6d5fbd9064a844$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $0b6d5fbd9064a844$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $1a17727e3ca99c94$export$2e2bcd8739ae039)(params, this, options);
}
const $0b6d5fbd9064a844$var$prototype = $0b6d5fbd9064a844$var$AxiosURLSearchParams.prototype;
$0b6d5fbd9064a844$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$0b6d5fbd9064a844$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? (value)=>encoder.call(this, value, $0b6d5fbd9064a844$var$encode) : $0b6d5fbd9064a844$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $0b6d5fbd9064a844$export$2e2bcd8739ae039 = $0b6d5fbd9064a844$var$AxiosURLSearchParams;


'use strict';
function $05a98f245b338187$export$c564cdbbe6da493(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function $05a98f245b338187$export$2e2bcd8739ae039(url, params, options) {
    if (!params) return url;
    url = url || '';
    const _options = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(options) ? {
        serialize: options
    } : options;
    // Read serializer options pollution-safely: own properties and methods on a
    // class/template prototype are honored, but values injected onto a polluted
    // Object.prototype are ignored.
    const _encode = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).getSafeProp(_options, 'encode') || $05a98f245b338187$export$c564cdbbe6da493;
    const serializeFn = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).getSafeProp(_options, 'serialize');
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, _options);
    else serializedParams = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $0b6d5fbd9064a844$export$2e2bcd8739ae039)(params, _options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $15156ebcfb4812c5$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $15156ebcfb4812c5$export$2e2bcd8739ae039 = $15156ebcfb4812c5$var$InterceptorManager;





'use strict';
var $00f36b71c2a7ac3f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false,
    legacyInterceptorReqResOrdering: true,
    advertiseZstdAcceptEncoding: false,
    validateStatusUndefinedResolves: true
};








'use strict';
var $75c47b9a7df70563$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $0b6d5fbd9064a844$export$2e2bcd8739ae039);


'use strict';
var $9ab76d0fd47552f9$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $950afdd45c11eefd$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $f1a7bd4b4996e189$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $75c47b9a7df70563$export$2e2bcd8739ae039,
        FormData: $9ab76d0fd47552f9$export$2e2bcd8739ae039,
        Blob: $950afdd45c11eefd$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $aff4ce6cdd77574c$exports = {};

$parcel$export($aff4ce6cdd77574c$exports, "hasBrowserEnv", function () { return $aff4ce6cdd77574c$export$c4996c4b7b93b0bf; });
$parcel$export($aff4ce6cdd77574c$exports, "navigator", function () { return $aff4ce6cdd77574c$export$ec7c8efa7f5790ae; });
$parcel$export($aff4ce6cdd77574c$exports, "hasStandardBrowserEnv", function () { return $aff4ce6cdd77574c$export$c0bcc9250309d66; });
$parcel$export($aff4ce6cdd77574c$exports, "hasStandardBrowserWebWorkerEnv", function () { return $aff4ce6cdd77574c$export$c81692cf5af97dac; });
$parcel$export($aff4ce6cdd77574c$exports, "origin", function () { return $aff4ce6cdd77574c$export$f710a83a91838a36; });
const $aff4ce6cdd77574c$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $aff4ce6cdd77574c$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $aff4ce6cdd77574c$export$c0bcc9250309d66 = $aff4ce6cdd77574c$export$c4996c4b7b93b0bf && (!$aff4ce6cdd77574c$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($aff4ce6cdd77574c$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $aff4ce6cdd77574c$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $aff4ce6cdd77574c$export$f710a83a91838a36 = $aff4ce6cdd77574c$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $4938695c38e1350b$export$2e2bcd8739ae039 = (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $aff4ce6cdd77574c$exports, (0, $f1a7bd4b4996e189$export$2e2bcd8739ae039));


'use strict';
function $3b2bbf5127635efb$export$2e2bcd8739ae039(data, options) {
    return (0, $1a17727e3ca99c94$export$2e2bcd8739ae039)(data, new (0, $4938695c38e1350b$export$2e2bcd8739ae039).classes.URLSearchParams(), (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        visitor: function(value, key, path, helpers) {
            if ((0, $4938695c38e1350b$export$2e2bcd8739ae039).isNode && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}






'use strict';
const $c8fdac2f0594b0a9$var$MAX_DEPTH = (0, $1a17727e3ca99c94$export$659081b45d03227d);
function $c8fdac2f0594b0a9$var$throwIfDepthExceeded(index) {
    if (index > $c8fdac2f0594b0a9$var$MAX_DEPTH) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('FormData field is too deeply nested (' + index + ' levels). Max depth: ' + $c8fdac2f0594b0a9$var$MAX_DEPTH, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_FORM_DATA_DEPTH_EXCEEDED);
}
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $c8fdac2f0594b0a9$var$parsePropPath(name) {
    // foo[x][y][z] -> ['foo', 'x', 'y', 'z']
    // foo.x.y.z    -> ['foo', 'x', 'y', 'z']
    // A path is split on `.` and on `[...]` groups. A segment — whether written
    // in dot notation or captured inside brackets — may contain any character
    // except `.`, `[` and `]`, so a key like `user-name` or `user name` is kept
    // literal instead of being split (#5402). `.`, `[` and `]` keep their existing
    // meaning, e.g. `foo[bar.baz]` -> ['foo', 'bar', 'baz'] and `[]` is an array push.
    // Excluding `[` from the bracket group also makes the match fail fast at the
    // next `[`, so a malformed name cannot rescan to the end of the string from
    // every unmatched `[` — parsing stays linear in the length of the name.
    const path = [];
    const pattern = /[^.[\]]+|\[([^.[\]]*)]/g;
    let match;
    while((match = pattern.exec(name)) !== null){
        $c8fdac2f0594b0a9$var$throwIfDepthExceeded(path.length);
        path.push(match[0] === '[]' ? '' : match[1] || match[0]);
    }
    return path;
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $c8fdac2f0594b0a9$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $c8fdac2f0594b0a9$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        $c8fdac2f0594b0a9$var$throwIfDepthExceeded(index);
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(target[name]) ? target[name].concat(value) : [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(target, name) || !(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $c8fdac2f0594b0a9$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(formData) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($c8fdac2f0594b0a9$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $c8fdac2f0594b0a9$export$2e2bcd8739ae039 = $c8fdac2f0594b0a9$var$formDataToJSON;


'use strict';
const $4392fb744c26f5ee$var$own = (obj, key)=>obj != null && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(obj, key) ? obj[key] : undefined;
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $4392fb744c26f5ee$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $4392fb744c26f5ee$var$defaults = {
    transitional: (0, $00f36b71c2a7ac3f$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $c8fdac2f0594b0a9$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBuffer(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isStream(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFile(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBlob(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                const formSerializer = $4392fb744c26f5ee$var$own(this, 'formSerializer');
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $3b2bbf5127635efb$export$2e2bcd8739ae039)(data, formSerializer).toString();
                if ((isFileList = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const env = $4392fb744c26f5ee$var$own(this, 'env');
                    const _FormData = env && env.FormData;
                    return (0, $1a17727e3ca99c94$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $4392fb744c26f5ee$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = $4392fb744c26f5ee$var$own(this, 'transitional') || $4392fb744c26f5ee$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const responseType = $4392fb744c26f5ee$var$own(this, 'responseType');
            const JSONRequested = responseType === 'json';
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isResponse(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, $4392fb744c26f5ee$var$own(this, 'parseReviver'));
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $f2fd8632892200c7$export$2e2bcd8739ae039).from(e, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, $4392fb744c26f5ee$var$own(this, 'response'));
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4938695c38e1350b$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $4938695c38e1350b$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch',
    'query'
], (method)=>{
    $4392fb744c26f5ee$var$defaults.headers[method] = {};
});
var $4392fb744c26f5ee$export$2e2bcd8739ae039 = $4392fb744c26f5ee$var$defaults;



'use strict';
function $1b3211cf98b1fc9d$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $4392fb744c26f5ee$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $5f05ed7c320a541d$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}




'use strict';
class $8375e36a423af45d$var$CanceledError extends (0, $f2fd8632892200c7$export$2e2bcd8739ae039) {
    /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */ constructor(message, config, request){
        super(message == null ? 'canceled' : message, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
        this.name = 'CanceledError';
        this.__CANCEL__ = true;
    }
}
var $8375e36a423af45d$export$2e2bcd8739ae039 = $8375e36a423af45d$var$CanceledError;







'use strict';
function $dbff109b7f5e22f3$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, response.status >= 400 && response.status < 500 ? (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_REQUEST : (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, response.config, response.request, response));
}





'use strict';
function $79a7b620bb64a66c$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25}):(?:\/\/)?/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4f5412cd0dae3aed$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4f5412cd0dae3aed$export$2e2bcd8739ae039 = $4f5412cd0dae3aed$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $dd6d4425e05b077a$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $dd6d4425e05b077a$export$2e2bcd8739ae039 = $dd6d4425e05b077a$var$throttle;



const $93173d492fe9d75a$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4f5412cd0dae3aed$export$2e2bcd8739ae039)(50, 250);
    return (0, $dd6d4425e05b077a$export$2e2bcd8739ae039)((e)=>{
        if (!e || typeof e.loaded !== 'number') return;
        const rawLoaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const loaded = Math.max(0, total != null ? Math.min(rawLoaded, total) : rawLoaded);
        const progressBytes = Math.max(0, loaded - bytesNotified);
        const rate = _speedometer(progressBytes);
        bytesNotified = Math.max(bytesNotified, loaded);
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $93173d492fe9d75a$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $93173d492fe9d75a$export$5d35863c355a22a9 = (fn, scheduler = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).asap)=>(...args)=>scheduler(()=>fn(...args));






var $aabaaa3820e32699$export$2e2bcd8739ae039 = (0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $4938695c38e1350b$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $4938695c38e1350b$export$2e2bcd8739ae039).origin), (0, $4938695c38e1350b$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $4938695c38e1350b$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $51b4a528f7fee75c$export$2e2bcd8739ae039 = (0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv ? {
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(path)) cookie.push(`path=${path}`);
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        // Match name=value by splitting on the semicolon separator instead of building a
        // RegExp from `name` — interpolating an unescaped string into a RegExp would let
        // metacharacters (e.g. `.+?` in an attacker-influenced cookie name) cause ReDoS or
        // match the wrong cookie. Browsers may serialize cookie pairs as either ";" or
        // "; ", so ignore optional whitespace before each cookie name.
        const cookies = document.cookie.split(';');
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i].replace(/^\s+/, '');
            const eq = cookie.indexOf('=');
            if (eq !== -1 && cookie.slice(0, eq) === name) try {
                return decodeURIComponent(cookie.slice(eq + 1));
            } catch (e) {
                return cookie.slice(eq + 1);
            }
        }
        return null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : {
    write () {},
    read () {
        return null;
    },
    remove () {}
};



'use strict';
function $05561197e8d5bfda$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    if (typeof url !== 'string') return false;
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $672dd09c2eb18b41$export$2e2bcd8739ae039(baseURL, relativeURL) {
    if (!relativeURL) return baseURL;
    let end = baseURL.length;
    while(end > 0 && baseURL.charCodeAt(end - 1) === 47)end--;
    return baseURL.slice(0, end) + '/' + relativeURL.replace(/^\/+/, '');
}


'use strict';
const $3ab4466f8c03b360$var$malformedHttpProtocol = /^https?:(?!\/\/)/i;
const $3ab4466f8c03b360$var$httpProtocolControlCharacters = /[\t\n\r]/g;
function $3ab4466f8c03b360$var$stripLeadingC0ControlOrSpace(url) {
    let i = 0;
    while(i < url.length && url.charCodeAt(i) <= 0x20)i++;
    return url.slice(i);
}
function $3ab4466f8c03b360$var$normalizeURLForProtocolCheck(url) {
    return $3ab4466f8c03b360$var$stripLeadingC0ControlOrSpace(url).replace($3ab4466f8c03b360$var$httpProtocolControlCharacters, '');
}
// Redact the parts of a URL that can carry secrets before it is embedded in an
// error message. AxiosError.toJSON() serializes `message` verbatim and errors
// are commonly logged, while the opt-in `config.redact` model only cleans
// config keys — it cannot reach the message. Redact only the genuinely
// sensitive substrings — userinfo (credentials), query parameter values and
// fragment contents — with the same REDACTED marker the config redaction uses,
// while keeping the scheme, host, path and parameter names so the offending
// request stays accurately identifiable.
function $3ab4466f8c03b360$var$redactFragment(fragment) {
    if (!fragment) return fragment;
    return fragment.replace(/(^|&)([^=&]*=)?[^&]+/g, (match, separator, parameterName = '')=>{
        return `${separator}${parameterName}${0, $f2fd8632892200c7$export$6acd2efa8ac62a1b}`;
    });
}
function $3ab4466f8c03b360$var$redactSensitiveURLParts(url) {
    const redactedURL = url.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${(0, $f2fd8632892200c7$export$6acd2efa8ac62a1b)}@`);
    const fragmentIndex = redactedURL.indexOf('#');
    const urlWithoutFragment = fragmentIndex === -1 ? redactedURL : redactedURL.slice(0, fragmentIndex);
    const redactedURLWithoutFragment = urlWithoutFragment.replace(/([?&][^=&#]*=)[^&#]*/g, `$1${(0, $f2fd8632892200c7$export$6acd2efa8ac62a1b)}`);
    if (fragmentIndex === -1) return redactedURLWithoutFragment;
    return `${redactedURLWithoutFragment}#${$3ab4466f8c03b360$var$redactFragment(redactedURL.slice(fragmentIndex + 1))}`;
}
function $3ab4466f8c03b360$var$assertValidHttpProtocolURL(url, config) {
    if (typeof url === 'string') {
        const normalizedURL = $3ab4466f8c03b360$var$normalizeURLForProtocolCheck(url);
        if ($3ab4466f8c03b360$var$malformedHttpProtocol.test(normalizedURL)) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`Invalid URL ${JSON.stringify($3ab4466f8c03b360$var$redactSensitiveURLParts(normalizedURL))}: missing "//" after protocol`, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_INVALID_URL, config);
    }
}
function $3ab4466f8c03b360$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls, config) {
    $3ab4466f8c03b360$var$assertValidHttpProtocolURL(requestedURL, config);
    let isRelativeUrl = !(0, $05561197e8d5bfda$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls === false)) {
        $3ab4466f8c03b360$var$assertValidHttpProtocolURL(baseURL, config);
        return (0, $672dd09c2eb18b41$export$2e2bcd8739ae039)(baseURL, requestedURL);
    }
    return requestedURL;
}





'use strict';
const $30c22c167a0df6c3$var$headersToObject = (thing)=>thing instanceof (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039) ? (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, thing) : thing;
const $30c22c167a0df6c3$var$ownEnumerableKeys = (thing)=>{
    if (Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor) return Object.keys(thing).concat(Object.getOwnPropertySymbols(thing).filter((symbol)=>Object.getOwnPropertyDescriptor(thing, symbol).enumerable));
    return Object.keys(thing);
};
function $30c22c167a0df6c3$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config1 = config1 || {};
    config2 = config2 || {};
    // Use a null-prototype object so that downstream reads such as `config.auth`
    // or `config.baseURL` cannot inherit polluted values from Object.prototype.
    // `hasOwnProperty` is restored as a non-enumerable own slot to preserve
    // ergonomics for user code that relies on it.
    const config = Object.create(null);
    Object.defineProperty(config, 'hasOwnProperty', {
        // Null-proto descriptor so a polluted Object.prototype.get cannot turn
        // this data descriptor into an accessor descriptor on the way in.
        __proto__: null,
        value: Object.prototype.hasOwnProperty,
        enumerable: false,
        writable: true,
        configurable: true
    });
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    function getMergedTransitionalOption(prop) {
        const transitional2 = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config2, 'transitional') ? config2.transitional : undefined;
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(transitional2)) {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(transitional2)) {
                if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(transitional2, prop)) return transitional2[prop];
            } else return undefined;
        }
        const transitional1 = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config1, 'transitional') ? config1.transitional : undefined;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isPlainObject(transitional1) && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(transitional1, prop)) return transitional1[prop];
        return undefined;
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config2, prop)) return getMergedValue(a, b);
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config1, prop)) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        allowedSocketPaths: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($30c22c167a0df6c3$var$headersToObject(a), $30c22c167a0df6c3$var$headersToObject(b), prop, true)
    };
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach($30c22c167a0df6c3$var$ownEnumerableKeys((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, config1, config2)), function computeConfigValue(prop) {
        if (prop === '__proto__' || prop === 'constructor' || prop === 'prototype') return;
        const merge = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(mergeMap, prop) ? mergeMap[prop] : mergeDeepProperties;
        const a = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config1, prop) ? config1[prop] : undefined;
        const b = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config2, prop) ? config2[prop] : undefined;
        const configValue = merge(a, b, prop);
        (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config2, 'validateStatus') && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(config2.validateStatus) && getMergedTransitionalOption('validateStatusUndefinedResolves') === false) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config1, 'validateStatus')) config.validateStatus = getMergedValue(undefined, config1.validateStatus);
        else delete config.validateStatus;
    }
    return config;
}



'use strict';
const $87ca77766d1ccae4$var$FORM_DATA_CONTENT_HEADERS = [
    'content-type',
    'content-length'
];
function $87ca77766d1ccae4$export$2e2bcd8739ae039(headers, formHeaders, policy) {
    if (policy !== 'content-only') {
        headers.set(formHeaders);
        return;
    }
    Object.entries(formHeaders || {}).forEach(([key, val])=>{
        if ($87ca77766d1ccae4$var$FORM_DATA_CONTENT_HEADERS.includes(key.toLowerCase())) headers.set(key, val);
    });
}



/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $90e3b762d743f050$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
function $90e3b762d743f050$var$resolveConfig(config) {
    const newConfig = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039)({}, config);
    // Read only own properties to prevent prototype pollution gadgets
    // (e.g. Object.prototype.baseURL = 'https://evil.com').
    const own = (key)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(newConfig, key) ? newConfig[key] : undefined;
    const data = own('data');
    let withXSRFToken = own('withXSRFToken');
    const xsrfHeaderName = own('xsrfHeaderName');
    const xsrfCookieName = own('xsrfCookieName');
    let headers = own('headers');
    const auth = own('auth');
    const baseURL = own('baseURL');
    const allowAbsoluteUrls = own('allowAbsoluteUrls');
    const url = own('url');
    newConfig.headers = headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $05a98f245b338187$export$2e2bcd8739ae039)((0, $3ab4466f8c03b360$export$2e2bcd8739ae039)(baseURL, url, allowAbsoluteUrls, newConfig), own('params'), own('paramsSerializer'));
    // HTTP basic authentication
    if (auth) {
        const username = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).getSafeProp(auth, 'username') || '';
        const password = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).getSafeProp(auth, 'password') || '';
        try {
            headers.set('Authorization', 'Basic ' + btoa(username + ':' + (password ? $90e3b762d743f050$var$encodeUTF8(password) : '')));
        } catch (e) {
            throw (0, $f2fd8632892200c7$export$2e2bcd8739ae039).from(e, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE, config);
        }
    }
    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReactNative(data)) headers.setContentType(undefined); // browser/web worker/RN handles it
        else if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(data.getHeaders)) // Node.js FormData (like form-data package)
        (0, $87ca77766d1ccae4$export$2e2bcd8739ae039)(headers, data.getHeaders(), own('formDataHeaderPolicy'));
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4938695c38e1350b$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(withXSRFToken)) withXSRFToken = withXSRFToken(newConfig);
        // Strict boolean check — prevents proto-pollution gadgets (e.g. Object.prototype.withXSRFToken = 1)
        // and misconfigurations (e.g. "false") from short-circuiting the same-origin check and leaking
        // the XSRF token cross-origin.
        const shouldSendXSRF = withXSRFToken === true || withXSRFToken == null && (0, $aabaaa3820e32699$export$2e2bcd8739ae039)(newConfig.url);
        if (shouldSendXSRF) {
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $51b4a528f7fee75c$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
}
var $90e3b762d743f050$export$2e2bcd8739ae039 = $90e3b762d743f050$var$resolveConfig;



const $72d3f9749acaef4a$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $72d3f9749acaef4a$export$2e2bcd8739ae039 = $72d3f9749acaef4a$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $90e3b762d743f050$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $dbff109b7f5e22f3$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.startsWith('file:'))) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Request aborted', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(msg, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            done();
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $00f36b71c2a7ac3f$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ETIMEDOUT : (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            done();
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach((0, $4cbde29721a2bb46$export$c30c72bb7e677d54)(requestHeaders), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $93173d492fe9d75a$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $93173d492fe9d75a$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                done();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $79a7b620bb64a66c$export$2e2bcd8739ae039)(_config.url);
        if (protocol && !(0, $4938695c38e1350b$export$2e2bcd8739ae039).protocols.includes(protocol)) {
            reject(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            done();
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};










const $ebd9aa0e6d5102ea$var$composeSignals = (signals, timeout)=>{
    signals = signals ? signals.filter(Boolean) : [];
    if (!timeout && !signals.length) return;
    const controller = new AbortController();
    let aborted = false;
    const onabort = function(reason) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = reason instanceof Error ? reason : this.reason;
            controller.abort(err instanceof (0, $f2fd8632892200c7$export$2e2bcd8739ae039) ? err : new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        timer = null;
        onabort(new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`timeout of ${timeout}ms exceeded`, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (!signals) return;
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal)=>{
            signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
    };
    signals.forEach((signal)=>{
        if (aborted) return;
        if (signal.aborted) {
            onabort.call(signal);
            return;
        }
        signal.addEventListener('abort', onabort, {
            once: true
        });
    });
    const { signal: signal } = controller;
    signal.unsubscribe = ()=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).asap(unsubscribe);
    return signal;
};
var $ebd9aa0e6d5102ea$export$2e2bcd8739ae039 = $ebd9aa0e6d5102ea$var$composeSignals;


const $045595b6d88fc556$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $045595b6d88fc556$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $045595b6d88fc556$var$readStream(iterable))yield* $045595b6d88fc556$export$71b051935044bd5d(chunk, chunkSize);
};
const $045595b6d88fc556$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $045595b6d88fc556$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $045595b6d88fc556$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






/**
 * Estimate data: URL byte lengths *without* allocating large buffers.
 * - Fetch percent-decodes a base64 body before decoding it.
 * - Node's Buffer.from(body, 'base64') sizes its backing allocation from the
 *   raw body, including ignored characters and content after padding.
 * - Non-base64 data is percent-decoded and then encoded as UTF-8.
 */ const $ad9ff8df3e6845ce$var$isHexDigit = (charCode)=>charCode >= 48 && charCode <= 57 || charCode >= 65 && charCode <= 70 || charCode >= 97 && charCode <= 102;
const $ad9ff8df3e6845ce$var$isPercentEncodedByte = (str, i, len)=>i + 2 < len && $ad9ff8df3e6845ce$var$isHexDigit(str.charCodeAt(i + 1)) && $ad9ff8df3e6845ce$var$isHexDigit(str.charCodeAt(i + 2));
const $ad9ff8df3e6845ce$var$hexValue = (charCode)=>charCode <= 57 ? charCode - 48 : (charCode & 0xdf) - 55;
const $ad9ff8df3e6845ce$var$isBase64Char = (charCode)=>charCode >= 65 && charCode <= 90 || // A-Z
    charCode >= 97 && charCode <= 122 || // a-z
    charCode >= 48 && charCode <= 57 || // 0-9
    charCode === 43 || // +
    charCode === 47 || // /
    charCode === 45 || // - (base64url)
    charCode === 95; // _ (base64url)
const $ad9ff8df3e6845ce$var$isBase64Whitespace = (charCode)=>charCode === 9 || charCode === 10 || charCode === 12 || charCode === 13 || charCode === 32;
const $ad9ff8df3e6845ce$var$base64Bytes = (significant)=>{
    const groups = Math.floor(significant / 4);
    const remainder = significant % 4;
    return groups * 3 + (remainder === 2 ? 1 : remainder === 3 ? 2 : 0);
};
// Buffer.byteLength(body, 'base64') uses the raw string length as an allocation
// upper bound even when Buffer.from later ignores characters or stops at '='.
const $ad9ff8df3e6845ce$var$estimateBase64BufferAllocation = (body)=>{
    const len = body.length;
    let padding = 0;
    if (len > 0 && body.charCodeAt(len - 1) === 61 /* '=' */ ) {
        padding++;
        if (len > 1 && body.charCodeAt(len - 2) === 61 /* '=' */ ) padding++;
    }
    return Math.floor((len - padding) * 3 / 4);
};
const $ad9ff8df3e6845ce$var$estimatePercentDecodedBase64Bytes = (body)=>{
    const len = body.length;
    let significant = 0;
    let padding = 0;
    let invalid = false;
    for(let i = 0; i < len; i++){
        let code = body.charCodeAt(i);
        if (code === 37 /* '%' */  && $ad9ff8df3e6845ce$var$isPercentEncodedByte(body, i, len)) {
            code = $ad9ff8df3e6845ce$var$hexValue(body.charCodeAt(i + 1)) * 16 + $ad9ff8df3e6845ce$var$hexValue(body.charCodeAt(i + 2));
            i += 2;
        }
        if ($ad9ff8df3e6845ce$var$isBase64Whitespace(code)) continue;
        if (code === 61 /* '=' */ ) {
            padding++;
            continue;
        }
        if (!$ad9ff8df3e6845ce$var$isBase64Char(code) || padding > 0) {
            invalid = true;
            continue;
        }
        significant++;
    }
    // Fetch rejects malformed forgiving-base64 input. Returning the raw-size
    // allocation bound keeps that invalid input from becoming a pre-check bypass.
    if (invalid || padding > 2 || padding > 0 && (significant + padding) % 4 !== 0 || significant % 4 === 1) return $ad9ff8df3e6845ce$var$estimateBase64BufferAllocation(body);
    return $ad9ff8df3e6845ce$var$base64Bytes(significant);
};
const $ad9ff8df3e6845ce$var$estimateDataURLBytes = (url, estimateBase64)=>{
    if (!url || typeof url !== 'string') return 0;
    if (!url.startsWith('data:')) return 0;
    const comma = url.indexOf(',');
    if (comma < 0) return 0;
    const meta = url.slice(5, comma);
    const body = url.slice(comma + 1);
    const isBase64 = /;base64/i.test(meta);
    if (isBase64) return estimateBase64(body);
    // Compute UTF-8 byte length directly from UTF-16 code units without allocating
    // a byte buffer (TextEncoder.encode would defeat the DoS guard on large bodies).
    // Valid %XX triplets count as one decoded byte; this matches the bytes that
    // decodeURIComponent(body) would produce before Buffer re-encodes the string.
    let bytes = 0;
    for(let i = 0, len = body.length; i < len; i++){
        const c = body.charCodeAt(i);
        if (c === 37 /* '%' */  && $ad9ff8df3e6845ce$var$isPercentEncodedByte(body, i, len)) {
            bytes += 1;
            i += 2;
        } else if (c < 0x80) bytes += 1;
        else if (c < 0x800) bytes += 2;
        else if (c >= 0xd800 && c <= 0xdbff && i + 1 < len) {
            const next = body.charCodeAt(i + 1);
            if (next >= 0xdc00 && next <= 0xdfff) {
                bytes += 4;
                i++;
            } else bytes += 3;
        } else bytes += 3;
    }
    return bytes;
};
function $ad9ff8df3e6845ce$export$2e2bcd8739ae039(url) {
    // Fetch removes URL fragments before processing a data: URL.
    const fragmentIndex = typeof url === 'string' ? url.indexOf('#') : -1;
    return $ad9ff8df3e6845ce$var$estimateDataURLBytes(fragmentIndex === -1 ? url : url.slice(0, fragmentIndex), $ad9ff8df3e6845ce$var$estimatePercentDecodedBase64Bytes);
}
function $ad9ff8df3e6845ce$export$1f39e64b554a246f(url) {
    return $ad9ff8df3e6845ce$var$estimateDataURLBytes(url, $ad9ff8df3e6845ce$var$estimateBase64BufferAllocation);
}


const $3d37115bbc67f13c$export$a4ad2735b021c132 = "1.19.0";



const $990cf3f47f0b19e3$var$DEFAULT_CHUNK_SIZE = 65536;
const { isFunction: $990cf3f47f0b19e3$var$isFunction } = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039);
/**
 * Encode a UTF-8 string to a Latin-1 byte string for use with btoa().
 * This is a modern replacement for the deprecated unescape(encodeURIComponent(str)) pattern.
 *
 * @param {string} str The string to encode
 *
 * @returns {string} UTF-8 bytes as a Latin-1 string
 */ const $990cf3f47f0b19e3$var$encodeUTF8 = (str)=>encodeURIComponent(str).replace(/%([0-9A-F]{2})/gi, (_, hex)=>String.fromCharCode(parseInt(hex, 16)));
// Node's WHATWG URL parser returns `username` and `password` percent-encoded.
// Decode before composing the `auth` option so credentials such as
// `my%40email.com:pass` are sent as `my@email.com:pass`. Falls back to the
// original value for malformed input so a bad encoding never throws.
const $990cf3f47f0b19e3$var$decodeURIComponentSafe = (value)=>{
    if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(value)) return value;
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
};
const $990cf3f47f0b19e3$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $990cf3f47f0b19e3$var$maybeWithAuthCredentials = (url)=>{
    const protocolIndex = url.indexOf('://');
    let urlToCheck = url;
    if (protocolIndex !== -1) urlToCheck = urlToCheck.slice(protocolIndex + 3);
    return urlToCheck.includes('@') || urlToCheck.includes(':');
};
const $990cf3f47f0b19e3$var$factory = (env)=>{
    const globalObject = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).global !== undefined && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).global !== null ? (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).global : globalThis;
    const { ReadableStream: ReadableStream, TextEncoder: TextEncoder } = globalObject;
    env = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge.call({
        skipUndefined: true
    }, {
        Request: globalObject.Request,
        Response: globalObject.Response
    }, env);
    const { fetch: envFetch, Request: Request, Response: Response } = env;
    const isFetchSupported = envFetch ? $990cf3f47f0b19e3$var$isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = $990cf3f47f0b19e3$var$isFunction(Request);
    const isResponseSupported = $990cf3f47f0b19e3$var$isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && $990cf3f47f0b19e3$var$isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && $990cf3f47f0b19e3$var$test(()=>{
        let duplexAccessed = false;
        const request = new Request((0, $4938695c38e1350b$export$2e2bcd8739ae039).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        });
        const hasContentType = request.headers.has('Content-Type');
        if (request.body != null) request.body.cancel();
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && $990cf3f47f0b19e3$var$test(()=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isBlob(body)) return body.size;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
            const _request = new Request((0, $4938695c38e1350b$export$2e2bcd8739ae039).origin, {
                method: 'POST',
                body: body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
        if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions, maxContentLength: maxContentLength, maxBodyLength: maxBodyLength } = (0, $90e3b762d743f050$export$2e2bcd8739ae039)(config);
        const hasMaxContentLength = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isNumber(maxContentLength) && maxContentLength > -1;
        const hasMaxBodyLength = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isNumber(maxBodyLength) && maxBodyLength > -1;
        const own = (key)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config, key) ? config[key] : undefined;
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, $ebd9aa0e6d5102ea$export$2e2bcd8739ae039)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        // AxiosError we raise while the request body is being streamed. Captured
        // by identity so the catch block can surface it directly, regardless of
        // how the runtime wraps the resulting fetch rejection (undici exposes it
        // as `err.cause`; some browsers drop the original error entirely).
        let pendingBodyError = null;
        const maxBodyLengthError = ()=>new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Request body larger than maxBodyLength limit', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config, request);
        try {
            // HTTP basic authentication
            let auth = undefined;
            const configAuth = own('auth');
            if (configAuth) {
                const username = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).getSafeProp(configAuth, 'username') || '';
                const password = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).getSafeProp(configAuth, 'password') || '';
                auth = {
                    username: username,
                    password: password
                };
            }
            if ($990cf3f47f0b19e3$var$maybeWithAuthCredentials(url)) {
                const parsedURL = new URL(url, (0, $4938695c38e1350b$export$2e2bcd8739ae039).origin);
                if (!auth && (parsedURL.username || parsedURL.password)) {
                    const urlUsername = $990cf3f47f0b19e3$var$decodeURIComponentSafe(parsedURL.username);
                    const urlPassword = $990cf3f47f0b19e3$var$decodeURIComponentSafe(parsedURL.password);
                    auth = {
                        username: urlUsername,
                        password: urlPassword
                    };
                }
                if (parsedURL.username || parsedURL.password) {
                    parsedURL.username = '';
                    parsedURL.password = '';
                    url = parsedURL.href;
                }
            }
            if (auth) {
                headers.delete('authorization');
                headers.set('Authorization', 'Basic ' + btoa($990cf3f47f0b19e3$var$encodeUTF8((auth.username || '') + ':' + (auth.password || ''))));
            }
            // Enforce maxContentLength for data: URLs up-front so we never materialize
            // an oversized payload. The HTTP adapter applies the same check (see http.js
            // "if (protocol === 'data:')" branch).
            if (hasMaxContentLength && typeof url === 'string' && url.startsWith('data:')) {
                const estimated = (0, $ad9ff8df3e6845ce$export$2e2bcd8739ae039)(url);
                if (estimated > maxContentLength) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            // Enforce maxBodyLength against known-size bodies before dispatch using
            // the body's *actual* size — never a caller-declared Content-Length,
            // which could under-report to slip an oversized body past the check.
            // Unknown-size streams return undefined here and are counted per-chunk
            // below as fetch consumes them.
            if (hasMaxBodyLength && method !== 'get' && method !== 'head') {
                const outboundLength = await getBodyLength(data);
                if (typeof outboundLength === 'number' && isFinite(outboundLength)) {
                    requestContentLength = outboundLength;
                    if (outboundLength > maxBodyLength) throw maxBodyLengthError();
                }
            }
            // A streamed body under maxBodyLength must be counted as fetch consumes
            // it; its size is never trusted from a caller-declared Content-Length.
            const mustEnforceStreamBody = hasMaxBodyLength && ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isReadableStream(data) || (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isStream(data));
            const trackRequestStream = (stream, onProgress, flush)=>(0, $045595b6d88fc556$export$b0119225647bd83)(stream, $990cf3f47f0b19e3$var$DEFAULT_CHUNK_SIZE, (loadedBytes)=>{
                    if (hasMaxBodyLength && loadedBytes > maxBodyLength) throw pendingBodyError = maxBodyLengthError();
                    onProgress && onProgress(loadedBytes);
                }, flush);
            if (supportsRequestStream && method !== 'get' && method !== 'head' && (onUploadProgress || mustEnforceStreamBody)) {
                requestContentLength = requestContentLength == null ? await resolveBodyLength(headers, data) : requestContentLength;
                // A declared length of 0 is only trusted to skip the wrap when we are
                // not enforcing a stream limit (which must not rely on that header).
                if (requestContentLength !== 0 || mustEnforceStreamBody) {
                    let _request = new Request(url, {
                        method: 'POST',
                        body: data,
                        duplex: 'half'
                    });
                    let contentTypeHeader;
                    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                    if (_request.body) {
                        const [onProgress, flush] = onUploadProgress && (0, $93173d492fe9d75a$export$d9fadd12586c18d6)(requestContentLength, (0, $93173d492fe9d75a$export$c1b28109d46c3592)((0, $93173d492fe9d75a$export$5d35863c355a22a9)(onUploadProgress))) || [];
                        data = trackRequestStream(_request.body, onProgress, flush);
                    }
                }
            } else if (mustEnforceStreamBody && !isRequestSupported && isReadableStreamSupported && method !== 'get' && method !== 'head') data = trackRequestStream(data);
            else if (mustEnforceStreamBody && isRequestSupported && !supportsRequestStream && method !== 'get' && method !== 'head') throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Stream request bodies are not supported by the current fetch implementation', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config, request);
            if (!(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && 'credentials' in Request.prototype;
            // If data is FormData and Content-Type is multipart/form-data without boundary,
            // delete it so fetch can set it correctly with the boundary
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFormData(data)) {
                const contentType = headers.getContentType();
                if (contentType && /^multipart\/form-data/i.test(contentType) && !/boundary=/i.test(contentType)) headers.delete('content-type');
            }
            // Set User-Agent header if not already set (fetch defaults to 'node' in Node.js)
            headers.set('User-Agent', 'axios/' + (0, $3d37115bbc67f13c$export$a4ad2735b021c132), false);
            const resolvedOptions = (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, fetchOptions), {
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: (0, $4cbde29721a2bb46$export$c30c72bb7e677d54)(headers.normalize()),
                body: data,
                duplex: 'half',
                credentials: isCredentialsSupported ? withCredentials : undefined
            });
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const responseHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(response.headers);
            // Cheap pre-check: if the server honestly declares a content-length that
            // already exceeds the cap, reject before we start streaming.
            if (hasMaxContentLength) {
                const declaredLength = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                if (declaredLength != null && declaredLength > maxContentLength) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && response.body && (onDownloadProgress || hasMaxContentLength || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).toFiniteNumber(responseHeaders.getContentLength());
                const [onProgress, flush] = onDownloadProgress && (0, $93173d492fe9d75a$export$d9fadd12586c18d6)(responseContentLength, (0, $93173d492fe9d75a$export$c1b28109d46c3592)((0, $93173d492fe9d75a$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
                let bytesRead = 0;
                const onChunkProgress = (loadedBytes)=>{
                    if (hasMaxContentLength) {
                        bytesRead = loadedBytes;
                        if (bytesRead > maxContentLength) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
                    }
                    onProgress && onProgress(loadedBytes);
                };
                response = new Response((0, $045595b6d88fc556$export$b0119225647bd83)(response.body, $990cf3f47f0b19e3$var$DEFAULT_CHUNK_SIZE, onChunkProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).findKey(resolvers, responseType) || 'text'](response, config);
            // Fallback enforcement for environments without ReadableStream support
            // (legacy runtimes). Detect materialized size from typed output; skip
            // streams/Response passthrough since the user will read those themselves.
            if (hasMaxContentLength && !supportsResponseStream && !isStreamResponse) {
                let materializedSize;
                if (responseData != null) {
                    if (typeof responseData.byteLength === 'number') materializedSize = responseData.byteLength;
                    else if (typeof responseData.size === 'number') materializedSize = responseData.size;
                    else if (typeof responseData === 'string') materializedSize = typeof TextEncoder === 'function' ? new TextEncoder().encode(responseData).byteLength : responseData.length;
                }
                if (typeof materializedSize === 'number' && materializedSize > maxContentLength) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('maxContentLength size of ' + maxContentLength + ' exceeded', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, config, request);
            }
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, $dbff109b7f5e22f3$export$2e2bcd8739ae039)(resolve, reject, {
                    data: responseData,
                    headers: (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config: config,
                    request: request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            // Safari can surface fetch aborts as a DOMException-like object whose
            // branded getters throw. Prefer our composed signal reason before reading
            // the caught error, preserving timeout vs cancellation semantics.
            if (composedSignal && composedSignal.aborted && composedSignal.reason instanceof (0, $f2fd8632892200c7$export$2e2bcd8739ae039)) {
                const canceledError = composedSignal.reason;
                canceledError.config = config;
                request && (canceledError.request = request);
                if (err !== canceledError) // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(canceledError, 'cause', {
                    __proto__: null,
                    value: err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw canceledError;
            }
            // Surface a maxBodyLength violation we raised while the request body was
            // being streamed. Matching by identity (rather than reading
            // `err.cause.isAxiosError`) keeps the error deterministic across runtimes
            // and avoids both prototype-pollution reads and mis-attributing a foreign
            // AxiosError that merely happened to land in `err.cause`.
            if (pendingBodyError) {
                request && !pendingBodyError.request && (pendingBodyError.request = request);
                throw pendingBodyError;
            }
            // Re-throw AxiosErrors we raised synchronously (data: URL / content-length
            // pre-checks, response size enforcement) without re-wrapping them.
            if (err instanceof (0, $f2fd8632892200c7$export$2e2bcd8739ae039)) {
                request && !err.request && (err.request = request);
                throw err;
            }
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) {
                const networkError = new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Network Error', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NETWORK, config, request, err && err.response);
                // Non-enumerable to match native Error `cause` semantics so loggers
                // don't recurse into circular fetch internals (see #7205).
                Object.defineProperty(networkError, 'cause', {
                    __proto__: null,
                    value: err.cause || err,
                    writable: true,
                    enumerable: false,
                    configurable: true
                });
                throw networkError;
            }
            throw (0, $f2fd8632892200c7$export$2e2bcd8739ae039).from(err, err && err.code, config, request, err && err.response);
        }
    };
};
const $990cf3f47f0b19e3$var$seedCache = new Map();
const $990cf3f47f0b19e3$export$3105c6651375d4fa = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request: Request, Response: Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = $990cf3f47f0b19e3$var$seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : $990cf3f47f0b19e3$var$factory(env));
        map = target;
    }
    return target;
};
const $990cf3f47f0b19e3$var$adapter = $990cf3f47f0b19e3$export$3105c6651375d4fa();
var $990cf3f47f0b19e3$export$2e2bcd8739ae039 = $990cf3f47f0b19e3$var$adapter;



/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 *
 * @type {Object<string, Function|Object>}
 */ const $aeaf0cdf32c87a26$var$knownAdapters = {
    http: (0, $92fbca5b49d9b1b0$export$2e2bcd8739ae039),
    xhr: (0, $72d3f9749acaef4a$export$2e2bcd8739ae039),
    fetch: {
        get: $990cf3f47f0b19e3$export$3105c6651375d4fa
    }
};
// Assign adapter names for easier debugging and identification
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach($aeaf0cdf32c87a26$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            // Null-proto descriptors so a polluted Object.prototype.get cannot turn
            // these data descriptors into accessor descriptors on the way in.
            Object.defineProperty(fn, 'name', {
                __proto__: null,
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            __proto__: null,
            value: value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 *
 * @param {string} reason
 * @returns {string}
 */ const $aeaf0cdf32c87a26$var$renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 *
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const $aeaf0cdf32c87a26$var$isResolvedHandle = (adapter)=>(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 *
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function $aeaf0cdf32c87a26$var$getAdapter(adapters, config) {
    adapters = (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length: length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!$aeaf0cdf32c87a26$var$isResolvedHandle(nameOrAdapter)) {
            adapter = $aeaf0cdf32c87a26$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($aeaf0cdf32c87a26$var$renderReason).join('\n') : ' ' + $aeaf0cdf32c87a26$var$renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_NOT_SUPPORT);
    }
    return adapter;
}
var /**
 * Exports Axios adapters and utility to resolve an adapter
 */ $aeaf0cdf32c87a26$export$2e2bcd8739ae039 = {
    getAdapter: /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ $aeaf0cdf32c87a26$var$getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: $aeaf0cdf32c87a26$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $dd383be87f2615f6$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(null, config);
}
function $dd383be87f2615f6$export$2e2bcd8739ae039(config) {
    $dd383be87f2615f6$var$throwIfCancellationRequested(config);
    config.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $1b3211cf98b1fc9d$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $aeaf0cdf32c87a26$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $4392fb744c26f5ee$export$2e2bcd8739ae039).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        $dd383be87f2615f6$var$throwIfCancellationRequested(config);
        // Expose the current response on config so that transformResponse can
        // attach it to any AxiosError it throws (e.g. on JSON parse failure).
        // We clean it up afterwards to avoid polluting the config object.
        config.response = response;
        try {
            response.data = (0, $1b3211cf98b1fc9d$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        } finally{
            delete config.response;
        }
        response.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5f05ed7c320a541d$export$2e2bcd8739ae039)(reason)) {
            $dd383be87f2615f6$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                config.response = reason.response;
                try {
                    reason.response.data = (0, $1b3211cf98b1fc9d$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                } finally{
                    delete config.response;
                }
                reason.response.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}






'use strict';
const $197627880ab628f6$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $197627880ab628f6$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $197627880ab628f6$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $197627880ab628f6$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $3d37115bbc67f13c$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$197627880ab628f6$var$deprecatedWarnings[opt]) {
            $197627880ab628f6$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$197627880ab628f6$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $197627880ab628f6$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object' || options === null) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('options must be an object', (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        // Use hasOwnProperty so a polluted Object.prototype.<opt> cannot supply
        // a non-function validator and cause a TypeError.
        const validator = Object.prototype.hasOwnProperty.call(schema, opt) ? schema[opt] : undefined;
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $f2fd8632892200c7$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $f2fd8632892200c7$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $197627880ab628f6$export$2e2bcd8739ae039 = {
    assertOptions: $197627880ab628f6$var$assertOptions,
    validators: $197627880ab628f6$var$validators
};




'use strict';
const $3c793b01c43703e1$var$validators = (0, $197627880ab628f6$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $3c793b01c43703e1$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = (()=>{
                    if (!dummy.stack) return '';
                    const firstNewlineIndex = dummy.stack.indexOf('\n');
                    return firstNewlineIndex === -1 ? '' : dummy.stack.slice(firstNewlineIndex + 1);
                })();
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack) {
                        const firstNewlineIndex = stack.indexOf('\n');
                        const secondNewlineIndex = firstNewlineIndex === -1 ? -1 : stack.indexOf('\n', firstNewlineIndex + 1);
                        const stackWithoutTwoTopLines = secondNewlineIndex === -1 ? '' : stack.slice(secondNewlineIndex + 1);
                        if (!String(err.stack).endsWith(stackWithoutTwoTopLines)) err.stack += '\n' + stack;
                    }
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $197627880ab628f6$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            forcedJSONParsing: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            clarifyTimeoutError: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            legacyInterceptorReqResOrdering: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            advertiseZstdAcceptEncoding: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean),
            validateStatusUndefinedResolves: $3c793b01c43703e1$var$validators.transitional($3c793b01c43703e1$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $197627880ab628f6$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $3c793b01c43703e1$var$validators.function,
                serialize: $3c793b01c43703e1$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $197627880ab628f6$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $3c793b01c43703e1$var$validators.spelling('baseURL'),
            withXsrfToken: $3c793b01c43703e1$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'query',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            const transitional = config.transitional || (0, $00f36b71c2a7ac3f$export$2e2bcd8739ae039);
            const legacyInterceptorReqResOrdering = transitional && transitional.legacyInterceptorReqResOrdering;
            if (legacyInterceptorReqResOrdering) requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
            else requestInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $dd383be87f2615f6$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled ? onFulfilled(newConfig) : newConfig;
            } catch (error) {
                if (!onRejected) {
                    promise = Promise.reject(error);
                    break;
                }
                try {
                    const rejectedResult = onRejected.call(this, error);
                    if ((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isThenable(rejectedResult)) promise = Promise.resolve(rejectedResult).then(()=>(0, $dd383be87f2615f6$export$2e2bcd8739ae039).call(this, newConfig));
                } catch (rejectedError) {
                    promise = Promise.reject(rejectedError);
                }
                break;
            }
        }
        if (!promise) try {
            promise = (0, $dd383be87f2615f6$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            promise = Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $3ab4466f8c03b360$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls, config);
        return (0, $05a98f245b338187$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, $15156ebcfb4812c5$export$2e2bcd8739ae039)(),
            response: new (0, $15156ebcfb4812c5$export$2e2bcd8739ae039)()
        };
    }
}
// Provide aliases for supported request methods
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $3c793b01c43703e1$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: config && (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).hasOwnProp(config, 'data') ? config.data : undefined
        }));
    };
});
(0, $0a51f960109e0fa4$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch',
    'query'
], function forEachMethodWithData(method) {
    function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $3c793b01c43703e1$var$Axios.prototype[method] = generateHTTPMethod();
    // QUERY is a safe/idempotent read method; multipart form bodies don't fit
    // its semantics, so no queryForm shorthand is generated.
    if (method !== 'query') $3c793b01c43703e1$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $3c793b01c43703e1$export$2e2bcd8739ae039 = $3c793b01c43703e1$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $41c6d49ff23d7cbb$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $41c6d49ff23d7cbb$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $8375e36a423af45d$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $41c6d49ff23d7cbb$export$2e2bcd8739ae039 = $41c6d49ff23d7cbb$var$CancelToken;






'use strict';
function $392194938cc89728$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $7fd4247c35dc1f27$export$2e2bcd8739ae039(payload) {
    return (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $d4f7ae775bec0665$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerReturnsAnUnknownError: 520,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries($d4f7ae775bec0665$var$HttpStatusCode).forEach(([key, value])=>{
    $d4f7ae775bec0665$var$HttpStatusCode[value] = key;
});
var $d4f7ae775bec0665$export$2e2bcd8739ae039 = $d4f7ae775bec0665$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5774572e96b4aaf1$var$createInstance(defaultConfig) {
    const context = new (0, $3c793b01c43703e1$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $af63e388eb3e7024$export$2e2bcd8739ae039)((0, $3c793b01c43703e1$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).extend(instance, (0, $3c793b01c43703e1$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0a51f960109e0fa4$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5774572e96b4aaf1$var$createInstance((0, $30c22c167a0df6c3$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5774572e96b4aaf1$var$axios = $5774572e96b4aaf1$var$createInstance((0, $4392fb744c26f5ee$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5774572e96b4aaf1$var$axios.Axios = (0, $3c793b01c43703e1$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5774572e96b4aaf1$var$axios.CanceledError = (0, $8375e36a423af45d$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.CancelToken = (0, $41c6d49ff23d7cbb$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.isCancel = (0, $5f05ed7c320a541d$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.VERSION = (0, $3d37115bbc67f13c$export$a4ad2735b021c132);
$5774572e96b4aaf1$var$axios.toFormData = (0, $1a17727e3ca99c94$export$2e2bcd8739ae039);
// Expose AxiosError class
$5774572e96b4aaf1$var$axios.AxiosError = (0, $f2fd8632892200c7$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5774572e96b4aaf1$var$axios.Cancel = $5774572e96b4aaf1$var$axios.CanceledError;
// Expose all/spread
$5774572e96b4aaf1$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5774572e96b4aaf1$var$axios.spread = (0, $392194938cc89728$export$2e2bcd8739ae039);
// Expose isAxiosError
$5774572e96b4aaf1$var$axios.isAxiosError = (0, $7fd4247c35dc1f27$export$2e2bcd8739ae039);
// Expose mergeConfig
$5774572e96b4aaf1$var$axios.mergeConfig = (0, $30c22c167a0df6c3$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.AxiosHeaders = (0, $332fc3eba15a6bb9$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.formToJSON = (thing)=>(0, $c8fdac2f0594b0a9$export$2e2bcd8739ae039)((0, $0a51f960109e0fa4$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5774572e96b4aaf1$var$axios.getAdapter = (0, $aeaf0cdf32c87a26$export$2e2bcd8739ae039).getAdapter;
$5774572e96b4aaf1$var$axios.HttpStatusCode = (0, $d4f7ae775bec0665$export$2e2bcd8739ae039);
$5774572e96b4aaf1$var$axios.default = $5774572e96b4aaf1$var$axios;
var // this module should only have a default export
$5774572e96b4aaf1$export$2e2bcd8739ae039 = $5774572e96b4aaf1$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $3be821c10766c4b6$export$1c00760e9e5a4e95, AxiosError: $3be821c10766c4b6$export$c1fbed17c2f6a328, CanceledError: $3be821c10766c4b6$export$1ab0c6b20d94fa14, isCancel: $3be821c10766c4b6$export$3b22524397b493c6, CancelToken: $3be821c10766c4b6$export$fd08e3cb425f0d61, VERSION: $3be821c10766c4b6$export$a4ad2735b021c132, all: $3be821c10766c4b6$export$84bf76cd7afc7469, Cancel: $3be821c10766c4b6$export$848c9b7ead0df967, isAxiosError: $3be821c10766c4b6$export$fbafdbe06a5b5a9a, spread: $3be821c10766c4b6$export$3ae0fd4797ed47c8, toFormData: $3be821c10766c4b6$export$10ae0d317ea97f8b, AxiosHeaders: $3be821c10766c4b6$export$4e7d6ff0f3e6520, HttpStatusCode: $3be821c10766c4b6$export$a972f69c851492b3, formToJSON: $3be821c10766c4b6$export$86d7c59254d6a2c9, getAdapter: $3be821c10766c4b6$export$17ddc20a97d669e2, mergeConfig: $3be821c10766c4b6$export$7ec1ebcfa9d8bd6a, create: $3be821c10766c4b6$export$185802fd694ee1f5 } = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);


var $e457b70bcd427770$exports = {};
'use strict';
Object.defineProperty($e457b70bcd427770$exports, '__esModule', {
    value: true
});
function $e457b70bcd427770$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e457b70bcd427770$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e457b70bcd427770$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e457b70bcd427770$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e457b70bcd427770$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e457b70bcd427770$var$_extends() {
    $e457b70bcd427770$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e457b70bcd427770$var$_extends.apply(this, arguments);
}
function $e457b70bcd427770$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $e457b70bcd427770$var$_setPrototypeOf(subClass, superClass);
}
function $e457b70bcd427770$var$_getPrototypeOf(o) {
    $e457b70bcd427770$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e457b70bcd427770$var$_getPrototypeOf(o);
}
function $e457b70bcd427770$var$_setPrototypeOf(o, p) {
    $e457b70bcd427770$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e457b70bcd427770$var$_setPrototypeOf(o, p);
}
function $e457b70bcd427770$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e457b70bcd427770$var$_construct(Parent, args, Class) {
    if ($e457b70bcd427770$var$_isNativeReflectConstruct()) $e457b70bcd427770$var$_construct = Reflect.construct.bind();
    else $e457b70bcd427770$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $e457b70bcd427770$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $e457b70bcd427770$var$_construct.apply(null, arguments);
}
function $e457b70bcd427770$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $e457b70bcd427770$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $e457b70bcd427770$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$e457b70bcd427770$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $e457b70bcd427770$var$_construct(Class, arguments, $e457b70bcd427770$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $e457b70bcd427770$var$_setPrototypeOf(Wrapper, Class);
    };
    return $e457b70bcd427770$var$_wrapNativeSuper(Class);
}
function $e457b70bcd427770$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e457b70bcd427770$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e457b70bcd427770$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e457b70bcd427770$var$_arrayLikeToArray(o, minLen);
}
function $e457b70bcd427770$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e457b70bcd427770$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $e457b70bcd427770$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e457b70bcd427770$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e457b70bcd427770$var$_toPropertyKey(arg) {
    var key = $e457b70bcd427770$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $e457b70bcd427770$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $e457b70bcd427770$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $e457b70bcd427770$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $e457b70bcd427770$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $e457b70bcd427770$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $e457b70bcd427770$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $e457b70bcd427770$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $e457b70bcd427770$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $e457b70bcd427770$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $e457b70bcd427770$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $e457b70bcd427770$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($e457b70bcd427770$var$LuxonError);
/**
 * @private
 */ var $e457b70bcd427770$var$n = "numeric", $e457b70bcd427770$var$s = "short", $e457b70bcd427770$var$l = "long";
var $e457b70bcd427770$var$DATE_SHORT = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$n,
    day: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATE_MED = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$s,
    day: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATE_MED_WITH_WEEKDAY = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$s,
    day: $e457b70bcd427770$var$n,
    weekday: $e457b70bcd427770$var$s
};
var $e457b70bcd427770$var$DATE_FULL = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$l,
    day: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATE_HUGE = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$l,
    day: $e457b70bcd427770$var$n,
    weekday: $e457b70bcd427770$var$l
};
var $e457b70bcd427770$var$TIME_SIMPLE = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$TIME_WITH_SECONDS = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$TIME_WITH_SHORT_OFFSET = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    timeZoneName: $e457b70bcd427770$var$s
};
var $e457b70bcd427770$var$TIME_WITH_LONG_OFFSET = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    timeZoneName: $e457b70bcd427770$var$l
};
var $e457b70bcd427770$var$TIME_24_SIMPLE = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    hourCycle: "h23"
};
var $e457b70bcd427770$var$TIME_24_WITH_SECONDS = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    hourCycle: "h23"
};
var $e457b70bcd427770$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    hourCycle: "h23",
    timeZoneName: $e457b70bcd427770$var$s
};
var $e457b70bcd427770$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    hourCycle: "h23",
    timeZoneName: $e457b70bcd427770$var$l
};
var $e457b70bcd427770$var$DATETIME_SHORT = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$n,
    day: $e457b70bcd427770$var$n,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$n,
    day: $e457b70bcd427770$var$n,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATETIME_MED = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$s,
    day: $e457b70bcd427770$var$n,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATETIME_MED_WITH_SECONDS = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$s,
    day: $e457b70bcd427770$var$n,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$s,
    day: $e457b70bcd427770$var$n,
    weekday: $e457b70bcd427770$var$s,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n
};
var $e457b70bcd427770$var$DATETIME_FULL = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$l,
    day: $e457b70bcd427770$var$n,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    timeZoneName: $e457b70bcd427770$var$s
};
var $e457b70bcd427770$var$DATETIME_FULL_WITH_SECONDS = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$l,
    day: $e457b70bcd427770$var$n,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    timeZoneName: $e457b70bcd427770$var$s
};
var $e457b70bcd427770$var$DATETIME_HUGE = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$l,
    day: $e457b70bcd427770$var$n,
    weekday: $e457b70bcd427770$var$l,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    timeZoneName: $e457b70bcd427770$var$l
};
var $e457b70bcd427770$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $e457b70bcd427770$var$n,
    month: $e457b70bcd427770$var$l,
    day: $e457b70bcd427770$var$n,
    weekday: $e457b70bcd427770$var$l,
    hour: $e457b70bcd427770$var$n,
    minute: $e457b70bcd427770$var$n,
    second: $e457b70bcd427770$var$n,
    timeZoneName: $e457b70bcd427770$var$l
};
/**
 * @interface
 */ var $e457b70bcd427770$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $e457b70bcd427770$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $e457b70bcd427770$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $e457b70bcd427770$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $e457b70bcd427770$var$ZoneIsAbstractError();
    };
    $e457b70bcd427770$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $e457b70bcd427770$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $e457b70bcd427770$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $e457b70bcd427770$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $e457b70bcd427770$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $e457b70bcd427770$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $e457b70bcd427770$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $e457b70bcd427770$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $e457b70bcd427770$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $e457b70bcd427770$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $e457b70bcd427770$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($e457b70bcd427770$var$singleton$1 === null) $e457b70bcd427770$var$singleton$1 = new SystemZone();
                return $e457b70bcd427770$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($e457b70bcd427770$var$Zone);
var $e457b70bcd427770$var$dtfCache = new Map();
function $e457b70bcd427770$var$makeDTF(zoneName) {
    var dtf = $e457b70bcd427770$var$dtfCache.get(zoneName);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat("en-US", {
            hour12: false,
            timeZone: zoneName,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            era: "short"
        });
        $e457b70bcd427770$var$dtfCache.set(zoneName, dtf);
    }
    return dtf;
}
var $e457b70bcd427770$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $e457b70bcd427770$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $e457b70bcd427770$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $e457b70bcd427770$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$e457b70bcd427770$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $e457b70bcd427770$var$ianaZoneCache = new Map();
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $e457b70bcd427770$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $e457b70bcd427770$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        var zone = $e457b70bcd427770$var$ianaZoneCache.get(name);
        if (zone === undefined) $e457b70bcd427770$var$ianaZoneCache.set(name, zone = new IANAZone(name));
        return zone;
    };
    IANAZone.resetCache = function resetCache() {
        $e457b70bcd427770$var$ianaZoneCache.clear();
        $e457b70bcd427770$var$dtfCache.clear();
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */ var _proto = IANAZone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $e457b70bcd427770$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $e457b70bcd427770$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        if (!this.valid) return NaN;
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $e457b70bcd427770$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $e457b70bcd427770$var$partsOffset(dtf, date) : $e457b70bcd427770$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $e457b70bcd427770$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $e457b70bcd427770$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($e457b70bcd427770$var$Zone);
var $e457b70bcd427770$var$_excluded = [
    "base"
], $e457b70bcd427770$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $e457b70bcd427770$var$intlLFCache = {};
function $e457b70bcd427770$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $e457b70bcd427770$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $e457b70bcd427770$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $e457b70bcd427770$var$intlDTCache = new Map();
function $e457b70bcd427770$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $e457b70bcd427770$var$intlDTCache.get(key);
    if (dtf === undefined) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $e457b70bcd427770$var$intlDTCache.set(key, dtf);
    }
    return dtf;
}
var $e457b70bcd427770$var$intlNumCache = new Map();
function $e457b70bcd427770$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $e457b70bcd427770$var$intlNumCache.get(key);
    if (inf === undefined) {
        inf = new Intl.NumberFormat(locString, opts);
        $e457b70bcd427770$var$intlNumCache.set(key, inf);
    }
    return inf;
}
var $e457b70bcd427770$var$intlRelCache = new Map();
function $e457b70bcd427770$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $e457b70bcd427770$var$_objectWithoutPropertiesLoose(_opts, $e457b70bcd427770$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $e457b70bcd427770$var$intlRelCache.get(key);
    if (inf === undefined) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $e457b70bcd427770$var$intlRelCache.set(key, inf);
    }
    return inf;
}
var $e457b70bcd427770$var$sysLocaleCache = null;
function $e457b70bcd427770$var$systemLocale() {
    if ($e457b70bcd427770$var$sysLocaleCache) return $e457b70bcd427770$var$sysLocaleCache;
    else {
        $e457b70bcd427770$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $e457b70bcd427770$var$sysLocaleCache;
    }
}
var $e457b70bcd427770$var$intlResolvedOptionsCache = new Map();
function $e457b70bcd427770$var$getCachedIntResolvedOptions(locString) {
    var opts = $e457b70bcd427770$var$intlResolvedOptionsCache.get(locString);
    if (opts === undefined) {
        opts = new Intl.DateTimeFormat(locString).resolvedOptions();
        $e457b70bcd427770$var$intlResolvedOptionsCache.set(locString, opts);
    }
    return opts;
}
var $e457b70bcd427770$var$weekInfoCache = new Map();
function $e457b70bcd427770$var$getCachedWeekInfo(locString) {
    var data = $e457b70bcd427770$var$weekInfoCache.get(locString);
    if (!data) {
        var locale = new Intl.Locale(locString);
        // browsers currently implement this as a property, but spec says it should be a getter function
        data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
        // minimalDays was removed from WeekInfo: https://github.com/tc39/proposal-intl-locale-info/issues/86
        if (!("minimalDays" in data)) data = $e457b70bcd427770$var$_extends({}, $e457b70bcd427770$var$fallbackWeekSettings, data);
        $e457b70bcd427770$var$weekInfoCache.set(locString, data);
    }
    return data;
}
function $e457b70bcd427770$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $e457b70bcd427770$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $e457b70bcd427770$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $e457b70bcd427770$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $e457b70bcd427770$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $e457b70bcd427770$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $e457b70bcd427770$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $e457b70bcd427770$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $e457b70bcd427770$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $e457b70bcd427770$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $e457b70bcd427770$var$getCachedIntResolvedOptions(loc.locale).numberingSystem === "latn";
}
/**
 * @private
 */ var $e457b70bcd427770$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $e457b70bcd427770$var$_objectWithoutPropertiesLoose(opts, $e457b70bcd427770$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $e457b70bcd427770$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $e457b70bcd427770$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $e457b70bcd427770$var$roundTo(i, 3);
            return $e457b70bcd427770$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $e457b70bcd427770$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $e457b70bcd427770$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $e457b70bcd427770$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $e457b70bcd427770$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $e457b70bcd427770$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $e457b70bcd427770$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $e457b70bcd427770$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $e457b70bcd427770$var$hasRelative()) this.rtf = $e457b70bcd427770$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $e457b70bcd427770$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
var $e457b70bcd427770$var$fallbackWeekSettings = {
    firstDay: 1,
    minimalDays: 4,
    weekend: [
        6,
        7
    ]
};
/**
 * @private
 */ var $e457b70bcd427770$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $e457b70bcd427770$var$Settings.defaultLocale;
        // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $e457b70bcd427770$var$systemLocale());
        var numberingSystemR = numberingSystem || $e457b70bcd427770$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $e457b70bcd427770$var$Settings.defaultOutputCalendar;
        var weekSettingsR = $e457b70bcd427770$var$validateWeekSettings(weekSettings) || $e457b70bcd427770$var$Settings.defaultWeekSettings;
        return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $e457b70bcd427770$var$sysLocaleCache = null;
        $e457b70bcd427770$var$intlDTCache.clear();
        $e457b70bcd427770$var$intlNumCache.clear();
        $e457b70bcd427770$var$intlRelCache.clear();
        $e457b70bcd427770$var$intlResolvedOptionsCache.clear();
        $e457b70bcd427770$var$weekInfoCache.clear();
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar, weekSettings = _ref2.weekSettings;
        return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
    };
    function Locale(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
        var _parseLocaleString = $e457b70bcd427770$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.weekSettings = weekSettings;
        this.intl = $e457b70bcd427770$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, $e457b70bcd427770$var$validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($e457b70bcd427770$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($e457b70bcd427770$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $e457b70bcd427770$var$listStuff(this, length, $e457b70bcd427770$var$months, function() {
            // Workaround for "ja" locale: formatToParts does not label all parts of the month
            // as "month" and for this locale there is no difference between "format" and "non-format".
            // As such, just use format() instead of formatToParts() and take the whole string
            var monthSpecialCase = _this2.intl === "ja" || _this2.intl.startsWith("ja-");
            format &= !monthSpecialCase;
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) {
                var mapper = !monthSpecialCase ? function(dt) {
                    return _this2.extract(dt, intl, "month");
                } : function(dt) {
                    return _this2.dtFormatter(dt, intl).format();
                };
                _this2.monthsCache[formatStr][length] = $e457b70bcd427770$var$mapMonths(mapper);
            }
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $e457b70bcd427770$var$listStuff(this, length, $e457b70bcd427770$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $e457b70bcd427770$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $e457b70bcd427770$var$listStuff(this, undefined, function() {
            return $e457b70bcd427770$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $e457b70bcd427770$var$DateTime.utc(2016, 11, 13, 9),
                    $e457b70bcd427770$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $e457b70bcd427770$var$listStuff(this, length, $e457b70bcd427770$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $e457b70bcd427770$var$DateTime.utc(-40, 1, 1),
                $e457b70bcd427770$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $e457b70bcd427770$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $e457b70bcd427770$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $e457b70bcd427770$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $e457b70bcd427770$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $e457b70bcd427770$var$getCachedIntResolvedOptions(this.intl).locale.startsWith("en-us");
    };
    _proto4.getWeekSettings = function getWeekSettings() {
        if (this.weekSettings) return this.weekSettings;
        else if (!$e457b70bcd427770$var$hasLocaleWeekInfo()) return $e457b70bcd427770$var$fallbackWeekSettings;
        else return $e457b70bcd427770$var$getCachedWeekInfo(this.locale);
    };
    _proto4.getStartOfWeek = function getStartOfWeek() {
        return this.getWeekSettings().firstDay;
    };
    _proto4.getMinDaysInFirstWeek = function getMinDaysInFirstWeek() {
        return this.getWeekSettings().minimalDays;
    };
    _proto4.getWeekendDays = function getWeekendDays() {
        return this.getWeekSettings().weekend;
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    _proto4.toString = function toString() {
        return "Locale(" + this.locale + ", " + this.numberingSystem + ", " + this.outputCalendar + ")";
    };
    $e457b70bcd427770$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $e457b70bcd427770$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $e457b70bcd427770$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $e457b70bcd427770$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $e457b70bcd427770$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($e457b70bcd427770$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */ var _proto = FixedOffsetZone.prototype;
    /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $e457b70bcd427770$var$formatOffset(this.fixed, format);
    };
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $e457b70bcd427770$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $e457b70bcd427770$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $e457b70bcd427770$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($e457b70bcd427770$var$singleton === null) $e457b70bcd427770$var$singleton = new FixedOffsetZone(0);
                return $e457b70bcd427770$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($e457b70bcd427770$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $e457b70bcd427770$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $e457b70bcd427770$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $e457b70bcd427770$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($e457b70bcd427770$var$Zone);
/**
 * @private
 */ function $e457b70bcd427770$var$normalizeZone(input, defaultZone) {
    if ($e457b70bcd427770$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $e457b70bcd427770$var$Zone) return input;
    else if ($e457b70bcd427770$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $e457b70bcd427770$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $e457b70bcd427770$var$FixedOffsetZone.utcInstance;
        else return $e457b70bcd427770$var$FixedOffsetZone.parseSpecifier(lowered) || $e457b70bcd427770$var$IANAZone.create(input);
    } else if ($e457b70bcd427770$var$isNumber(input)) return $e457b70bcd427770$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $e457b70bcd427770$var$InvalidZone(input);
}
var $e457b70bcd427770$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $e457b70bcd427770$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $e457b70bcd427770$var$hanidecChars = $e457b70bcd427770$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $e457b70bcd427770$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($e457b70bcd427770$var$numberingSystems.hanidec) !== -1) value += $e457b70bcd427770$var$hanidecChars.indexOf(str[i]);
            else for(var key in $e457b70bcd427770$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $e457b70bcd427770$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
// cache of {numberingSystem: {append: regex}}
var $e457b70bcd427770$var$digitRegexCache = new Map();
function $e457b70bcd427770$var$resetDigitRegexCache() {
    $e457b70bcd427770$var$digitRegexCache.clear();
}
function $e457b70bcd427770$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    var ns = numberingSystem || "latn";
    var appendCache = $e457b70bcd427770$var$digitRegexCache.get(ns);
    if (appendCache === undefined) {
        appendCache = new Map();
        $e457b70bcd427770$var$digitRegexCache.set(ns, appendCache);
    }
    var regex = appendCache.get(append);
    if (regex === undefined) {
        regex = new RegExp("" + $e457b70bcd427770$var$numberingSystems[ns] + append);
        appendCache.set(append, regex);
    }
    return regex;
}
var $e457b70bcd427770$var$now = function now() {
    return Date.now();
}, $e457b70bcd427770$var$defaultZone = "system", $e457b70bcd427770$var$defaultLocale = null, $e457b70bcd427770$var$defaultNumberingSystem = null, $e457b70bcd427770$var$defaultOutputCalendar = null, $e457b70bcd427770$var$twoDigitCutoffYear = 60, $e457b70bcd427770$var$throwOnInvalid, $e457b70bcd427770$var$defaultWeekSettings = null;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $e457b70bcd427770$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $e457b70bcd427770$var$Locale.resetCache();
        $e457b70bcd427770$var$IANAZone.resetCache();
        $e457b70bcd427770$var$DateTime.resetCache();
        $e457b70bcd427770$var$resetDigitRegexCache();
    };
    $e457b70bcd427770$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $e457b70bcd427770$var$now;
            },
            set: function set(n) {
                $e457b70bcd427770$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $e457b70bcd427770$var$normalizeZone($e457b70bcd427770$var$defaultZone, $e457b70bcd427770$var$SystemZone.instance);
            },
            set: function set(zone) {
                $e457b70bcd427770$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $e457b70bcd427770$var$defaultLocale;
            },
            set: function set(locale) {
                $e457b70bcd427770$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $e457b70bcd427770$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $e457b70bcd427770$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $e457b70bcd427770$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $e457b70bcd427770$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "defaultWeekSettings",
            get: function get() {
                return $e457b70bcd427770$var$defaultWeekSettings;
            },
            set: function set(weekSettings) {
                $e457b70bcd427770$var$defaultWeekSettings = $e457b70bcd427770$var$validateWeekSettings(weekSettings);
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $e457b70bcd427770$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $e457b70bcd427770$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $e457b70bcd427770$var$throwOnInvalid;
            },
            set: function set(t) {
                $e457b70bcd427770$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $e457b70bcd427770$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
var $e457b70bcd427770$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $e457b70bcd427770$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $e457b70bcd427770$var$unitOutOfRange(unit, value) {
    return new $e457b70bcd427770$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $e457b70bcd427770$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $e457b70bcd427770$var$computeOrdinal(year, month, day) {
    return day + ($e457b70bcd427770$var$isLeapYear(year) ? $e457b70bcd427770$var$leapLadder : $e457b70bcd427770$var$nonLeapLadder)[month - 1];
}
function $e457b70bcd427770$var$uncomputeOrdinal(year, ordinal) {
    var table = $e457b70bcd427770$var$isLeapYear(year) ? $e457b70bcd427770$var$leapLadder : $e457b70bcd427770$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $e457b70bcd427770$var$isoWeekdayToLocal(isoWeekday, startOfWeek) {
    return (isoWeekday - startOfWeek + 7) % 7 + 1;
}
/**
 * @private
 */ function $e457b70bcd427770$var$gregorianToWeek(gregObj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $e457b70bcd427770$var$computeOrdinal(year, month, day), weekday = $e457b70bcd427770$var$isoWeekdayToLocal($e457b70bcd427770$var$dayOfWeek(year, month, day), startOfWeek);
    var weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $e457b70bcd427770$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
    } else if (weekNumber > $e457b70bcd427770$var$weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $e457b70bcd427770$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $e457b70bcd427770$var$timeObject(gregObj));
}
function $e457b70bcd427770$var$weekToGregorian(weekData, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $e457b70bcd427770$var$isoWeekdayToLocal($e457b70bcd427770$var$dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek), yearInDays = $e457b70bcd427770$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $e457b70bcd427770$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $e457b70bcd427770$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $e457b70bcd427770$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $e457b70bcd427770$var$_extends({
        year: year,
        month: month,
        day: day
    }, $e457b70bcd427770$var$timeObject(weekData));
}
function $e457b70bcd427770$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $e457b70bcd427770$var$computeOrdinal(year, month, day);
    return $e457b70bcd427770$var$_extends({
        year: year,
        ordinal: ordinal
    }, $e457b70bcd427770$var$timeObject(gregData));
}
function $e457b70bcd427770$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $e457b70bcd427770$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $e457b70bcd427770$var$_extends({
        year: year,
        month: month,
        day: day
    }, $e457b70bcd427770$var$timeObject(ordinalData));
}
/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */ function $e457b70bcd427770$var$usesLocalWeekValues(obj, loc) {
    var hasLocaleWeekData = !$e457b70bcd427770$var$isUndefined(obj.localWeekday) || !$e457b70bcd427770$var$isUndefined(obj.localWeekNumber) || !$e457b70bcd427770$var$isUndefined(obj.localWeekYear);
    if (hasLocaleWeekData) {
        var hasIsoWeekData = !$e457b70bcd427770$var$isUndefined(obj.weekday) || !$e457b70bcd427770$var$isUndefined(obj.weekNumber) || !$e457b70bcd427770$var$isUndefined(obj.weekYear);
        if (hasIsoWeekData) throw new $e457b70bcd427770$var$ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
        if (!$e457b70bcd427770$var$isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
        if (!$e457b70bcd427770$var$isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
        if (!$e457b70bcd427770$var$isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
        delete obj.localWeekday;
        delete obj.localWeekNumber;
        delete obj.localWeekYear;
        return {
            minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
            startOfWeek: loc.getStartOfWeek()
        };
    } else return {
        minDaysInFirstWeek: 4,
        startOfWeek: 1
    };
}
function $e457b70bcd427770$var$hasInvalidWeekData(obj, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var validYear = $e457b70bcd427770$var$isInteger(obj.weekYear), validWeek = $e457b70bcd427770$var$integerBetween(obj.weekNumber, 1, $e457b70bcd427770$var$weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)), validWeekday = $e457b70bcd427770$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $e457b70bcd427770$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $e457b70bcd427770$var$unitOutOfRange("week", obj.weekNumber);
    else if (!validWeekday) return $e457b70bcd427770$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $e457b70bcd427770$var$hasInvalidOrdinalData(obj) {
    var validYear = $e457b70bcd427770$var$isInteger(obj.year), validOrdinal = $e457b70bcd427770$var$integerBetween(obj.ordinal, 1, $e457b70bcd427770$var$daysInYear(obj.year));
    if (!validYear) return $e457b70bcd427770$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $e457b70bcd427770$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $e457b70bcd427770$var$hasInvalidGregorianData(obj) {
    var validYear = $e457b70bcd427770$var$isInteger(obj.year), validMonth = $e457b70bcd427770$var$integerBetween(obj.month, 1, 12), validDay = $e457b70bcd427770$var$integerBetween(obj.day, 1, $e457b70bcd427770$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $e457b70bcd427770$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $e457b70bcd427770$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $e457b70bcd427770$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $e457b70bcd427770$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $e457b70bcd427770$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $e457b70bcd427770$var$integerBetween(minute, 0, 59), validSecond = $e457b70bcd427770$var$integerBetween(second, 0, 59), validMillisecond = $e457b70bcd427770$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $e457b70bcd427770$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $e457b70bcd427770$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $e457b70bcd427770$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $e457b70bcd427770$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
/**
 * @private
 */ // TYPES
function $e457b70bcd427770$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $e457b70bcd427770$var$isNumber(o) {
    return typeof o === "number";
}
function $e457b70bcd427770$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $e457b70bcd427770$var$isString(o) {
    return typeof o === "string";
}
function $e457b70bcd427770$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $e457b70bcd427770$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $e457b70bcd427770$var$hasLocaleWeekInfo() {
    try {
        return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $e457b70bcd427770$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $e457b70bcd427770$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $e457b70bcd427770$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $e457b70bcd427770$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $e457b70bcd427770$var$validateWeekSettings(settings) {
    if (settings == null) return null;
    else if (typeof settings !== "object") throw new $e457b70bcd427770$var$InvalidArgumentError("Week settings must be an object");
    else {
        if (!$e457b70bcd427770$var$integerBetween(settings.firstDay, 1, 7) || !$e457b70bcd427770$var$integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(function(v) {
            return !$e457b70bcd427770$var$integerBetween(v, 1, 7);
        })) throw new $e457b70bcd427770$var$InvalidArgumentError("Invalid week settings");
        return {
            firstDay: settings.firstDay,
            minimalDays: settings.minimalDays,
            weekend: Array.from(settings.weekend)
        };
    }
}
// NUMBERS AND STRINGS
function $e457b70bcd427770$var$integerBetween(thing, bottom, top) {
    return $e457b70bcd427770$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $e457b70bcd427770$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $e457b70bcd427770$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $e457b70bcd427770$var$parseInteger(string) {
    if ($e457b70bcd427770$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $e457b70bcd427770$var$parseFloating(string) {
    if ($e457b70bcd427770$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $e457b70bcd427770$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($e457b70bcd427770$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $e457b70bcd427770$var$roundTo(number, digits, rounding) {
    if (rounding === void 0) rounding = "round";
    var factor = Math.pow(10, digits);
    switch(rounding){
        case "expand":
            return number > 0 ? Math.ceil(number * factor) / factor : Math.floor(number * factor) / factor;
        case "trunc":
            return Math.trunc(number * factor) / factor;
        case "round":
            return Math.round(number * factor) / factor;
        case "floor":
            return Math.floor(number * factor) / factor;
        case "ceil":
            return Math.ceil(number * factor) / factor;
        default:
            throw new RangeError("Value rounding " + rounding + " is out of range");
    }
}
// DATE BASICS
function $e457b70bcd427770$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $e457b70bcd427770$var$daysInYear(year) {
    return $e457b70bcd427770$var$isLeapYear(year) ? 366 : 365;
}
function $e457b70bcd427770$var$daysInMonth(year, month) {
    var modMonth = $e457b70bcd427770$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $e457b70bcd427770$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $e457b70bcd427770$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function $e457b70bcd427770$var$firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
    var fwdlw = $e457b70bcd427770$var$isoWeekdayToLocal($e457b70bcd427770$var$dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
    return -fwdlw + minDaysInFirstWeek - 1;
}
function $e457b70bcd427770$var$weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek) {
    if (minDaysInFirstWeek === void 0) minDaysInFirstWeek = 4;
    if (startOfWeek === void 0) startOfWeek = 1;
    var weekOffset = $e457b70bcd427770$var$firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
    var weekOffsetNext = $e457b70bcd427770$var$firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
    return ($e457b70bcd427770$var$daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function $e457b70bcd427770$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $e457b70bcd427770$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $e457b70bcd427770$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $e457b70bcd427770$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $e457b70bcd427770$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $e457b70bcd427770$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || !Number.isFinite(numericValue)) throw new $e457b70bcd427770$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $e457b70bcd427770$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($e457b70bcd427770$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $e457b70bcd427770$var$asNumber(v);
    }
    return normalized;
}
/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */ function $e457b70bcd427770$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $e457b70bcd427770$var$padStart(hours, 2) + ":" + $e457b70bcd427770$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $e457b70bcd427770$var$padStart(hours, 2) + $e457b70bcd427770$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $e457b70bcd427770$var$timeObject(obj) {
    return $e457b70bcd427770$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $e457b70bcd427770$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $e457b70bcd427770$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $e457b70bcd427770$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $e457b70bcd427770$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($e457b70bcd427770$var$monthsNarrow);
        case "short":
            return [].concat($e457b70bcd427770$var$monthsShort);
        case "long":
            return [].concat($e457b70bcd427770$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $e457b70bcd427770$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $e457b70bcd427770$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $e457b70bcd427770$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $e457b70bcd427770$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($e457b70bcd427770$var$weekdaysNarrow);
        case "short":
            return [].concat($e457b70bcd427770$var$weekdaysShort);
        case "long":
            return [].concat($e457b70bcd427770$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $e457b70bcd427770$var$meridiems = [
    "AM",
    "PM"
];
var $e457b70bcd427770$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $e457b70bcd427770$var$erasShort = [
    "BC",
    "AD"
];
var $e457b70bcd427770$var$erasNarrow = [
    "B",
    "A"
];
function $e457b70bcd427770$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($e457b70bcd427770$var$erasNarrow);
        case "short":
            return [].concat($e457b70bcd427770$var$erasShort);
        case "long":
            return [].concat($e457b70bcd427770$var$erasLong);
        default:
            return null;
    }
}
function $e457b70bcd427770$var$meridiemForDateTime(dt) {
    return $e457b70bcd427770$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $e457b70bcd427770$var$weekdayForDateTime(dt, length) {
    return $e457b70bcd427770$var$weekdays(length)[dt.weekday - 1];
}
function $e457b70bcd427770$var$monthForDateTime(dt, length) {
    return $e457b70bcd427770$var$months(length)[dt.month - 1];
}
function $e457b70bcd427770$var$eraForDateTime(dt, length) {
    return $e457b70bcd427770$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $e457b70bcd427770$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $e457b70bcd427770$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $e457b70bcd427770$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $e457b70bcd427770$var$_macroTokenToFormatOpts = {
    D: $e457b70bcd427770$var$DATE_SHORT,
    DD: $e457b70bcd427770$var$DATE_MED,
    DDD: $e457b70bcd427770$var$DATE_FULL,
    DDDD: $e457b70bcd427770$var$DATE_HUGE,
    t: $e457b70bcd427770$var$TIME_SIMPLE,
    tt: $e457b70bcd427770$var$TIME_WITH_SECONDS,
    ttt: $e457b70bcd427770$var$TIME_WITH_SHORT_OFFSET,
    tttt: $e457b70bcd427770$var$TIME_WITH_LONG_OFFSET,
    T: $e457b70bcd427770$var$TIME_24_SIMPLE,
    TT: $e457b70bcd427770$var$TIME_24_WITH_SECONDS,
    TTT: $e457b70bcd427770$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $e457b70bcd427770$var$TIME_24_WITH_LONG_OFFSET,
    f: $e457b70bcd427770$var$DATETIME_SHORT,
    ff: $e457b70bcd427770$var$DATETIME_MED,
    fff: $e457b70bcd427770$var$DATETIME_FULL,
    ffff: $e457b70bcd427770$var$DATETIME_HUGE,
    F: $e457b70bcd427770$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $e457b70bcd427770$var$DATETIME_MED_WITH_SECONDS,
    FFF: $e457b70bcd427770$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $e457b70bcd427770$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $e457b70bcd427770$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                // turn '' into a literal signal quote instead of just skipping the empty literal
                if (currentFull.length > 0 || bracketed) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull === "" ? "'" : currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $e457b70bcd427770$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $e457b70bcd427770$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $e457b70bcd427770$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p, signDisplay) {
        if (p === void 0) p = 0;
        if (signDisplay === void 0) signDisplay = undefined;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $e457b70bcd427770$var$padStart(n, p);
        var opts = $e457b70bcd427770$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        if (signDisplay) opts.signDisplay = signDisplay;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $e457b70bcd427770$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $e457b70bcd427770$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $e457b70bcd427770$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $e457b70bcd427770$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "n":
                    return _this.num(dt.localWeekNumber);
                case "nn":
                    return _this.num(dt.localWeekNumber, 2);
                case "ii":
                    return _this.num(dt.localWeekYear.toString().slice(-2), 2);
                case "iiii":
                    return _this.num(dt.localWeekYear, 4);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $e457b70bcd427770$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var invertLargest = this.opts.signMode === "negativeLargestOnly" ? -1 : 1;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "milliseconds";
                case "s":
                    return "seconds";
                case "m":
                    return "minutes";
                case "h":
                    return "hours";
                case "d":
                    return "days";
                case "w":
                    return "weeks";
                case "M":
                    return "months";
                case "y":
                    return "years";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur, info) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) {
                    var inversionFactor = info.isNegativeDuration && mapped !== info.largestUnit ? invertLargest : 1;
                    var signDisplay;
                    if (_this2.opts.signMode === "negativeLargestOnly" && mapped !== info.largestUnit) signDisplay = "never";
                    else if (_this2.opts.signMode === "all") signDisplay = "always";
                    else // "auto" and "negative" are the same, but "auto" has better support
                    signDisplay = "auto";
                    return _this2.num(lildur.get(mapped) * inversionFactor, token.length, signDisplay);
                } else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        })), durationInfo = {
            isNegativeDuration: collapsed < 0,
            // this relies on "collapsed" being based on "shiftTo", which builds up the object
            // in order
            largestUnit: Object.keys(collapsed.values)[0]
        };
        return $e457b70bcd427770$var$stringifyTokens(tokens, tokenToString(collapsed, durationInfo));
    };
    return Formatter;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $e457b70bcd427770$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $e457b70bcd427770$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $e457b70bcd427770$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $e457b70bcd427770$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $e457b70bcd427770$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $e457b70bcd427770$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $e457b70bcd427770$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $e457b70bcd427770$var$offsetRegex = /(?:([Zz])|([+-]\d\d)(?::?(\d\d))?)/;
var $e457b70bcd427770$var$isoExtendedZone = "(?:" + $e457b70bcd427770$var$offsetRegex.source + "?(?:\\[(" + $e457b70bcd427770$var$ianaRegex.source + ")\\])?)?";
var $e457b70bcd427770$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $e457b70bcd427770$var$isoTimeRegex = RegExp("" + $e457b70bcd427770$var$isoTimeBaseRegex.source + $e457b70bcd427770$var$isoExtendedZone);
var $e457b70bcd427770$var$isoTimeExtensionRegex = RegExp("(?:[Tt]" + $e457b70bcd427770$var$isoTimeRegex.source + ")?");
var $e457b70bcd427770$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $e457b70bcd427770$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $e457b70bcd427770$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $e457b70bcd427770$var$extractISOWeekData = $e457b70bcd427770$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $e457b70bcd427770$var$extractISOOrdinalData = $e457b70bcd427770$var$simpleParse("year", "ordinal");
var $e457b70bcd427770$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $e457b70bcd427770$var$sqlTimeRegex = RegExp($e457b70bcd427770$var$isoTimeBaseRegex.source + " ?(?:" + $e457b70bcd427770$var$offsetRegex.source + "|(" + $e457b70bcd427770$var$ianaRegex.source + "))?");
var $e457b70bcd427770$var$sqlTimeExtensionRegex = RegExp("(?: " + $e457b70bcd427770$var$sqlTimeRegex.source + ")?");
function $e457b70bcd427770$var$int(match, pos, fallback) {
    var m = match[pos];
    return $e457b70bcd427770$var$isUndefined(m) ? fallback : $e457b70bcd427770$var$parseInteger(m);
}
function $e457b70bcd427770$var$extractISOYmd(match, cursor) {
    var item = {
        year: $e457b70bcd427770$var$int(match, cursor),
        month: $e457b70bcd427770$var$int(match, cursor + 1, 1),
        day: $e457b70bcd427770$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $e457b70bcd427770$var$extractISOTime(match, cursor) {
    var item = {
        hours: $e457b70bcd427770$var$int(match, cursor, 0),
        minutes: $e457b70bcd427770$var$int(match, cursor + 1, 0),
        seconds: $e457b70bcd427770$var$int(match, cursor + 2, 0),
        milliseconds: $e457b70bcd427770$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $e457b70bcd427770$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $e457b70bcd427770$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $e457b70bcd427770$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $e457b70bcd427770$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $e457b70bcd427770$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $e457b70bcd427770$var$isoTimeOnly = RegExp("^T?" + $e457b70bcd427770$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $e457b70bcd427770$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $e457b70bcd427770$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($e457b70bcd427770$var$parseFloating(yearStr)),
            months: maybeNegate($e457b70bcd427770$var$parseFloating(monthStr)),
            weeks: maybeNegate($e457b70bcd427770$var$parseFloating(weekStr)),
            days: maybeNegate($e457b70bcd427770$var$parseFloating(dayStr)),
            hours: maybeNegate($e457b70bcd427770$var$parseFloating(hourStr)),
            minutes: maybeNegate($e457b70bcd427770$var$parseFloating(minuteStr)),
            seconds: maybeNegate($e457b70bcd427770$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($e457b70bcd427770$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $e457b70bcd427770$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $e457b70bcd427770$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $e457b70bcd427770$var$untruncateYear($e457b70bcd427770$var$parseInteger(yearStr)) : $e457b70bcd427770$var$parseInteger(yearStr),
        month: $e457b70bcd427770$var$monthsShort.indexOf(monthStr) + 1,
        day: $e457b70bcd427770$var$parseInteger(dayStr),
        hour: $e457b70bcd427770$var$parseInteger(hourStr),
        minute: $e457b70bcd427770$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $e457b70bcd427770$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $e457b70bcd427770$var$weekdaysLong.indexOf(weekdayStr) + 1 : $e457b70bcd427770$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $e457b70bcd427770$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $e457b70bcd427770$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $e457b70bcd427770$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $e457b70bcd427770$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $e457b70bcd427770$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $e457b70bcd427770$var$FixedOffsetZone(offset)
    ];
}
function $e457b70bcd427770$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $e457b70bcd427770$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $e457b70bcd427770$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $e457b70bcd427770$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $e457b70bcd427770$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $e457b70bcd427770$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $e457b70bcd427770$var$FixedOffsetZone.utcInstance
    ];
}
function $e457b70bcd427770$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $e457b70bcd427770$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $e457b70bcd427770$var$FixedOffsetZone.utcInstance
    ];
}
var $e457b70bcd427770$var$isoYmdWithTimeExtensionRegex = $e457b70bcd427770$var$combineRegexes($e457b70bcd427770$var$isoYmdRegex, $e457b70bcd427770$var$isoTimeExtensionRegex);
var $e457b70bcd427770$var$isoWeekWithTimeExtensionRegex = $e457b70bcd427770$var$combineRegexes($e457b70bcd427770$var$isoWeekRegex, $e457b70bcd427770$var$isoTimeExtensionRegex);
var $e457b70bcd427770$var$isoOrdinalWithTimeExtensionRegex = $e457b70bcd427770$var$combineRegexes($e457b70bcd427770$var$isoOrdinalRegex, $e457b70bcd427770$var$isoTimeExtensionRegex);
var $e457b70bcd427770$var$isoTimeCombinedRegex = $e457b70bcd427770$var$combineRegexes($e457b70bcd427770$var$isoTimeRegex);
var $e457b70bcd427770$var$extractISOYmdTimeAndOffset = $e457b70bcd427770$var$combineExtractors($e457b70bcd427770$var$extractISOYmd, $e457b70bcd427770$var$extractISOTime, $e457b70bcd427770$var$extractISOOffset, $e457b70bcd427770$var$extractIANAZone);
var $e457b70bcd427770$var$extractISOWeekTimeAndOffset = $e457b70bcd427770$var$combineExtractors($e457b70bcd427770$var$extractISOWeekData, $e457b70bcd427770$var$extractISOTime, $e457b70bcd427770$var$extractISOOffset, $e457b70bcd427770$var$extractIANAZone);
var $e457b70bcd427770$var$extractISOOrdinalDateAndTime = $e457b70bcd427770$var$combineExtractors($e457b70bcd427770$var$extractISOOrdinalData, $e457b70bcd427770$var$extractISOTime, $e457b70bcd427770$var$extractISOOffset, $e457b70bcd427770$var$extractIANAZone);
var $e457b70bcd427770$var$extractISOTimeAndOffset = $e457b70bcd427770$var$combineExtractors($e457b70bcd427770$var$extractISOTime, $e457b70bcd427770$var$extractISOOffset, $e457b70bcd427770$var$extractIANAZone);
/*
 * @private
 */ function $e457b70bcd427770$var$parseISODate(s) {
    return $e457b70bcd427770$var$parse(s, [
        $e457b70bcd427770$var$isoYmdWithTimeExtensionRegex,
        $e457b70bcd427770$var$extractISOYmdTimeAndOffset
    ], [
        $e457b70bcd427770$var$isoWeekWithTimeExtensionRegex,
        $e457b70bcd427770$var$extractISOWeekTimeAndOffset
    ], [
        $e457b70bcd427770$var$isoOrdinalWithTimeExtensionRegex,
        $e457b70bcd427770$var$extractISOOrdinalDateAndTime
    ], [
        $e457b70bcd427770$var$isoTimeCombinedRegex,
        $e457b70bcd427770$var$extractISOTimeAndOffset
    ]);
}
function $e457b70bcd427770$var$parseRFC2822Date(s) {
    return $e457b70bcd427770$var$parse($e457b70bcd427770$var$preprocessRFC2822(s), [
        $e457b70bcd427770$var$rfc2822,
        $e457b70bcd427770$var$extractRFC2822
    ]);
}
function $e457b70bcd427770$var$parseHTTPDate(s) {
    return $e457b70bcd427770$var$parse(s, [
        $e457b70bcd427770$var$rfc1123,
        $e457b70bcd427770$var$extractRFC1123Or850
    ], [
        $e457b70bcd427770$var$rfc850,
        $e457b70bcd427770$var$extractRFC1123Or850
    ], [
        $e457b70bcd427770$var$ascii,
        $e457b70bcd427770$var$extractASCII
    ]);
}
function $e457b70bcd427770$var$parseISODuration(s) {
    return $e457b70bcd427770$var$parse(s, [
        $e457b70bcd427770$var$isoDuration,
        $e457b70bcd427770$var$extractISODuration
    ]);
}
var $e457b70bcd427770$var$extractISOTimeOnly = $e457b70bcd427770$var$combineExtractors($e457b70bcd427770$var$extractISOTime);
function $e457b70bcd427770$var$parseISOTimeOnly(s) {
    return $e457b70bcd427770$var$parse(s, [
        $e457b70bcd427770$var$isoTimeOnly,
        $e457b70bcd427770$var$extractISOTimeOnly
    ]);
}
var $e457b70bcd427770$var$sqlYmdWithTimeExtensionRegex = $e457b70bcd427770$var$combineRegexes($e457b70bcd427770$var$sqlYmdRegex, $e457b70bcd427770$var$sqlTimeExtensionRegex);
var $e457b70bcd427770$var$sqlTimeCombinedRegex = $e457b70bcd427770$var$combineRegexes($e457b70bcd427770$var$sqlTimeRegex);
var $e457b70bcd427770$var$extractISOTimeOffsetAndIANAZone = $e457b70bcd427770$var$combineExtractors($e457b70bcd427770$var$extractISOTime, $e457b70bcd427770$var$extractISOOffset, $e457b70bcd427770$var$extractIANAZone);
function $e457b70bcd427770$var$parseSQL(s) {
    return $e457b70bcd427770$var$parse(s, [
        $e457b70bcd427770$var$sqlYmdWithTimeExtensionRegex,
        $e457b70bcd427770$var$extractISOYmdTimeAndOffset
    ], [
        $e457b70bcd427770$var$sqlTimeCombinedRegex,
        $e457b70bcd427770$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $e457b70bcd427770$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $e457b70bcd427770$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $e457b70bcd427770$var$casualMatrix = $e457b70bcd427770$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $e457b70bcd427770$var$lowOrderMatrix), $e457b70bcd427770$var$daysInYearAccurate = 365.2425, $e457b70bcd427770$var$daysInMonthAccurate = 30.436875, $e457b70bcd427770$var$accurateMatrix = $e457b70bcd427770$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $e457b70bcd427770$var$daysInYearAccurate / 7,
        days: $e457b70bcd427770$var$daysInYearAccurate,
        hours: $e457b70bcd427770$var$daysInYearAccurate * 24,
        minutes: $e457b70bcd427770$var$daysInYearAccurate * 1440,
        seconds: $e457b70bcd427770$var$daysInYearAccurate * 86400,
        milliseconds: $e457b70bcd427770$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $e457b70bcd427770$var$daysInYearAccurate / 28,
        days: $e457b70bcd427770$var$daysInYearAccurate / 4,
        hours: $e457b70bcd427770$var$daysInYearAccurate * 24 / 4,
        minutes: $e457b70bcd427770$var$daysInYearAccurate * 1440 / 4,
        seconds: $e457b70bcd427770$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $e457b70bcd427770$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $e457b70bcd427770$var$daysInMonthAccurate / 7,
        days: $e457b70bcd427770$var$daysInMonthAccurate,
        hours: $e457b70bcd427770$var$daysInMonthAccurate * 24,
        minutes: $e457b70bcd427770$var$daysInMonthAccurate * 1440,
        seconds: $e457b70bcd427770$var$daysInMonthAccurate * 86400,
        milliseconds: $e457b70bcd427770$var$daysInMonthAccurate * 86400000
    }
}, $e457b70bcd427770$var$lowOrderMatrix);
// units ordered by size
var $e457b70bcd427770$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $e457b70bcd427770$var$reverseUnits = $e457b70bcd427770$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $e457b70bcd427770$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $e457b70bcd427770$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $e457b70bcd427770$var$Duration(conf);
}
function $e457b70bcd427770$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $e457b70bcd427770$var$_createForOfIteratorHelperLoose($e457b70bcd427770$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $e457b70bcd427770$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $e457b70bcd427770$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $e457b70bcd427770$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$e457b70bcd427770$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $e457b70bcd427770$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$e457b70bcd427770$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $e457b70bcd427770$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $e457b70bcd427770$var$Duration = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $e457b70bcd427770$var$accurateMatrix : $e457b70bcd427770$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $e457b70bcd427770$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $e457b70bcd427770$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $e457b70bcd427770$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $e457b70bcd427770$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($e457b70bcd427770$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $e457b70bcd427770$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $e457b70bcd427770$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $e457b70bcd427770$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $e457b70bcd427770$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $e457b70bcd427770$var$Invalid ? reason : new $e457b70bcd427770$var$Invalid(reason, explanation);
        if ($e457b70bcd427770$var$Settings.throwOnInvalid) throw new $e457b70bcd427770$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $e457b70bcd427770$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @param {'negative'|'all'|'negativeLargestOnly'} [opts.signMode=negative] - How to handle signs
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @example Duration.fromObject({ days: 6, seconds: 2 }).toFormat("d s", { signMode: "all" }) //=> "+6 +2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "all" }) //=> "-6 -2"
   * @example Duration.fromObject({ days: -6, seconds: -2 }).toFormat("d s", { signMode: "negativeLargestOnly" }) //=> "-6 2"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $e457b70bcd427770$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $e457b70bcd427770$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $e457b70bcd427770$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $e457b70bcd427770$var$INVALID$2;
        var showZeros = opts.showZeros !== false;
        var l = $e457b70bcd427770$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($e457b70bcd427770$var$isUndefined(val) || val === 0 && !showZeros) return null;
            return _this.loc.numberFormatter($e457b70bcd427770$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($e457b70bcd427770$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $e457b70bcd427770$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $e457b70bcd427770$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $e457b70bcd427770$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $e457b70bcd427770$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Duration { values: " + JSON.stringify(this.values) + " }";
        else return "Duration { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $e457b70bcd427770$var$durationToMillis(this.matrix, this.values);
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $e457b70bcd427770$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($e457b70bcd427770$var$hasOwnProperty(dur.values, k) || $e457b70bcd427770$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $e457b70bcd427770$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $e457b70bcd427770$var$asNumber(fn(this.values[k], k));
        }
        return $e457b70bcd427770$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $e457b70bcd427770$var$_extends({}, this.values, $e457b70bcd427770$var$normalizeObject(values, Duration.normalizeUnit));
        return $e457b70bcd427770$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $e457b70bcd427770$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $e457b70bcd427770$var$normalizeValues(this.matrix, vals);
        return $e457b70bcd427770$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $e457b70bcd427770$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $e457b70bcd427770$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $e457b70bcd427770$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($e457b70bcd427770$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($e457b70bcd427770$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $e457b70bcd427770$var$normalizeValues(this.matrix, built);
        return $e457b70bcd427770$var$clone$1(this, {
            values: built
        }, true);
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $e457b70bcd427770$var$clone$1(this, {
            values: negated
        }, true);
    };
    _proto.removeZeros = function removeZeros() {
        if (!this.isValid) return this;
        var vals = $e457b70bcd427770$var$removeZeroes(this.values);
        return $e457b70bcd427770$var$clone$1(this, {
            values: vals
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $e457b70bcd427770$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $e457b70bcd427770$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}(Symbol.for("nodejs.util.inspect.custom"));
var $e457b70bcd427770$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $e457b70bcd427770$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $e457b70bcd427770$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $e457b70bcd427770$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $e457b70bcd427770$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $e457b70bcd427770$var$Interval = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $e457b70bcd427770$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $e457b70bcd427770$var$Invalid ? reason : new $e457b70bcd427770$var$Invalid(reason, explanation);
        if ($e457b70bcd427770$var$Settings.throwOnInvalid) throw new $e457b70bcd427770$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $e457b70bcd427770$var$friendlyDateTime(start), builtEnd = $e457b70bcd427770$var$friendlyDateTime(end);
        var validateError = $e457b70bcd427770$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $e457b70bcd427770$var$Duration.fromDurationLike(duration), dt = $e457b70bcd427770$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $e457b70bcd427770$var$Duration.fromDurationLike(duration), dt = $e457b70bcd427770$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $e457b70bcd427770$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $e457b70bcd427770$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $e457b70bcd427770$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $e457b70bcd427770$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit, opts);
        var end;
        if (opts != null && opts.useLocaleWeeks) end = this.end.reconfigure({
            locale: start.locale
        });
        else end = this.end;
        end = end.startOf(unit, opts);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($e457b70bcd427770$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(function(a, b) {
            return a.toMillis() - b.toMillis();
        }), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $e457b70bcd427770$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $e457b70bcd427770$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $e457b70bcd427770$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "Interval { start: " + this.s.toISO() + ", end: " + this.e.toISO() + " }";
        else return "Interval { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $e457b70bcd427770$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $e457b70bcd427770$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $e457b70bcd427770$var$INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $e457b70bcd427770$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $e457b70bcd427770$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $e457b70bcd427770$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $e457b70bcd427770$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $e457b70bcd427770$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $e457b70bcd427770$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "lastDateTime",
            get: function get() {
                return this.isValid ? this.e ? this.e.minus(1) : null : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}(Symbol.for("nodejs.util.inspect.custom"));
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $e457b70bcd427770$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $e457b70bcd427770$var$Settings.defaultZone;
        var proto = $e457b70bcd427770$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $e457b70bcd427770$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $e457b70bcd427770$var$normalizeZone(input, $e457b70bcd427770$var$Settings.defaultZone);
    };
    Info.getStartOfWeek = function getStartOfWeek(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj;
        return (locObj || $e457b70bcd427770$var$Locale.create(locale)).getStartOfWeek();
    };
    Info.getMinimumDaysInFirstWeek = function getMinimumDaysInFirstWeek(_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj;
        return (locObj || $e457b70bcd427770$var$Locale.create(locale)).getMinDaysInFirstWeek();
    };
    Info.getWeekendWeekdays = function getWeekendWeekdays(_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        // copy the array, because we cache it internally
        return (locObj || $e457b70bcd427770$var$Locale.create(locale)).getWeekendDays().slice();
    };
    Info.months = function months(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj, _ref4$outputCalendar = _ref4.outputCalendar, outputCalendar = _ref4$outputCalendar === void 0 ? "gregory" : _ref4$outputCalendar;
        return (locObj || $e457b70bcd427770$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp5) {
        if (length === void 0) length = "long";
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale, _ref5$numberingSystem = _ref5.numberingSystem, numberingSystem = _ref5$numberingSystem === void 0 ? null : _ref5$numberingSystem, _ref5$locObj = _ref5.locObj, locObj = _ref5$locObj === void 0 ? null : _ref5$locObj, _ref5$outputCalendar = _ref5.outputCalendar, outputCalendar = _ref5$outputCalendar === void 0 ? "gregory" : _ref5$outputCalendar;
        return (locObj || $e457b70bcd427770$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp6) {
        if (length === void 0) length = "long";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale, _ref6$numberingSystem = _ref6.numberingSystem, numberingSystem = _ref6$numberingSystem === void 0 ? null : _ref6$numberingSystem, _ref6$locObj = _ref6.locObj, locObj = _ref6$locObj === void 0 ? null : _ref6$locObj;
        return (locObj || $e457b70bcd427770$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp7) {
        if (length === void 0) length = "long";
        var _ref7 = _temp7 === void 0 ? {} : _temp7, _ref7$locale = _ref7.locale, locale = _ref7$locale === void 0 ? null : _ref7$locale, _ref7$numberingSystem = _ref7.numberingSystem, numberingSystem = _ref7$numberingSystem === void 0 ? null : _ref7$numberingSystem, _ref7$locObj = _ref7.locObj, locObj = _ref7$locObj === void 0 ? null : _ref7$locObj;
        return (locObj || $e457b70bcd427770$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp8) {
        var _ref8 = _temp8 === void 0 ? {} : _temp8, _ref8$locale = _ref8.locale, locale = _ref8$locale === void 0 ? null : _ref8$locale;
        return $e457b70bcd427770$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp9) {
        if (length === void 0) length = "short";
        var _ref9 = _temp9 === void 0 ? {} : _temp9, _ref9$locale = _ref9.locale, locale = _ref9$locale === void 0 ? null : _ref9$locale;
        return $e457b70bcd427770$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $e457b70bcd427770$var$hasRelative(),
            localeWeek: $e457b70bcd427770$var$hasLocaleWeekInfo()
        };
    };
    return Info;
}();
function $e457b70bcd427770$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($e457b70bcd427770$var$Duration.fromMillis(ms).as("days"));
}
function $e457b70bcd427770$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $e457b70bcd427770$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $e457b70bcd427770$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $e457b70bcd427770$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $e457b70bcd427770$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $e457b70bcd427770$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $e457b70bcd427770$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $e457b70bcd427770$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $e457b70bcd427770$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($e457b70bcd427770$var$parseDigits(s));
        }
    };
}
var $e457b70bcd427770$var$NBSP = String.fromCharCode(160);
var $e457b70bcd427770$var$spaceOrNBSP = "[ " + $e457b70bcd427770$var$NBSP + "]";
var $e457b70bcd427770$var$spaceOrNBSPRegExp = new RegExp($e457b70bcd427770$var$spaceOrNBSP, "g");
function $e457b70bcd427770$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($e457b70bcd427770$var$spaceOrNBSPRegExp, $e457b70bcd427770$var$spaceOrNBSP);
}
function $e457b70bcd427770$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($e457b70bcd427770$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $e457b70bcd427770$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($e457b70bcd427770$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $e457b70bcd427770$var$stripInsensitivities(s) === $e457b70bcd427770$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $e457b70bcd427770$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $e457b70bcd427770$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $e457b70bcd427770$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $e457b70bcd427770$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $e457b70bcd427770$var$unitForToken(token, loc) {
    var one = $e457b70bcd427770$var$digitRegex(loc), two = $e457b70bcd427770$var$digitRegex(loc, "{2}"), three = $e457b70bcd427770$var$digitRegex(loc, "{3}"), four = $e457b70bcd427770$var$digitRegex(loc, "{4}"), six = $e457b70bcd427770$var$digitRegex(loc, "{6}"), oneOrTwo = $e457b70bcd427770$var$digitRegex(loc, "{1,2}"), oneToThree = $e457b70bcd427770$var$digitRegex(loc, "{1,3}"), oneToSix = $e457b70bcd427770$var$digitRegex(loc, "{1,6}"), oneToNine = $e457b70bcd427770$var$digitRegex(loc, "{1,9}"), twoToFour = $e457b70bcd427770$var$digitRegex(loc, "{2,4}"), fourToSix = $e457b70bcd427770$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($e457b70bcd427770$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $e457b70bcd427770$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $e457b70bcd427770$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $e457b70bcd427770$var$intUnit(oneToSix);
            case "yy":
                return $e457b70bcd427770$var$intUnit(twoToFour, $e457b70bcd427770$var$untruncateYear);
            case "yyyy":
                return $e457b70bcd427770$var$intUnit(four);
            case "yyyyy":
                return $e457b70bcd427770$var$intUnit(fourToSix);
            case "yyyyyy":
                return $e457b70bcd427770$var$intUnit(six);
            // months
            case "M":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "MM":
                return $e457b70bcd427770$var$intUnit(two);
            case "MMM":
                return $e457b70bcd427770$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $e457b70bcd427770$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "LL":
                return $e457b70bcd427770$var$intUnit(two);
            case "LLL":
                return $e457b70bcd427770$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $e457b70bcd427770$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "dd":
                return $e457b70bcd427770$var$intUnit(two);
            // ordinals
            case "o":
                return $e457b70bcd427770$var$intUnit(oneToThree);
            case "ooo":
                return $e457b70bcd427770$var$intUnit(three);
            // time
            case "HH":
                return $e457b70bcd427770$var$intUnit(two);
            case "H":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "hh":
                return $e457b70bcd427770$var$intUnit(two);
            case "h":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "mm":
                return $e457b70bcd427770$var$intUnit(two);
            case "m":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "q":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "qq":
                return $e457b70bcd427770$var$intUnit(two);
            case "s":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "ss":
                return $e457b70bcd427770$var$intUnit(two);
            case "S":
                return $e457b70bcd427770$var$intUnit(oneToThree);
            case "SSS":
                return $e457b70bcd427770$var$intUnit(three);
            case "u":
                return $e457b70bcd427770$var$simple(oneToNine);
            case "uu":
                return $e457b70bcd427770$var$simple(oneOrTwo);
            case "uuu":
                return $e457b70bcd427770$var$intUnit(one);
            // meridiem
            case "a":
                return $e457b70bcd427770$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $e457b70bcd427770$var$intUnit(four);
            case "kk":
                return $e457b70bcd427770$var$intUnit(twoToFour, $e457b70bcd427770$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $e457b70bcd427770$var$intUnit(oneOrTwo);
            case "WW":
                return $e457b70bcd427770$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $e457b70bcd427770$var$intUnit(one);
            case "EEE":
                return $e457b70bcd427770$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $e457b70bcd427770$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $e457b70bcd427770$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $e457b70bcd427770$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $e457b70bcd427770$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $e457b70bcd427770$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $e457b70bcd427770$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $e457b70bcd427770$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $e457b70bcd427770$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $e457b70bcd427770$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $e457b70bcd427770$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $e457b70bcd427770$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $e457b70bcd427770$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $e457b70bcd427770$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($e457b70bcd427770$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $e457b70bcd427770$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$e457b70bcd427770$var$isUndefined(matches.z)) zone = $e457b70bcd427770$var$IANAZone.create(matches.z);
    if (!$e457b70bcd427770$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $e457b70bcd427770$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$e457b70bcd427770$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$e457b70bcd427770$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$e457b70bcd427770$var$isUndefined(matches.u)) matches.S = $e457b70bcd427770$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $e457b70bcd427770$var$dummyDateTimeCache = null;
function $e457b70bcd427770$var$getDummyDateTime() {
    if (!$e457b70bcd427770$var$dummyDateTimeCache) $e457b70bcd427770$var$dummyDateTimeCache = $e457b70bcd427770$var$DateTime.fromMillis(1555555555555);
    return $e457b70bcd427770$var$dummyDateTimeCache;
}
function $e457b70bcd427770$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $e457b70bcd427770$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $e457b70bcd427770$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $e457b70bcd427770$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $e457b70bcd427770$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ var $e457b70bcd427770$var$TokenParser = /*#__PURE__*/ function() {
    function TokenParser(locale, format) {
        this.locale = locale;
        this.format = format;
        this.tokens = $e457b70bcd427770$var$expandMacroTokens($e457b70bcd427770$var$Formatter.parseFormat(format), locale);
        this.units = this.tokens.map(function(t) {
            return $e457b70bcd427770$var$unitForToken(t, locale);
        });
        this.disqualifyingUnit = this.units.find(function(t) {
            return t.invalidReason;
        });
        if (!this.disqualifyingUnit) {
            var _buildRegex = $e457b70bcd427770$var$buildRegex(this.units), regexString = _buildRegex[0], handlers = _buildRegex[1];
            this.regex = RegExp(regexString, "i");
            this.handlers = handlers;
        }
    }
    var _proto = TokenParser.prototype;
    _proto.explainFromTokens = function explainFromTokens(input) {
        if (!this.isValid) return {
            input: input,
            tokens: this.tokens,
            invalidReason: this.invalidReason
        };
        else {
            var _match = $e457b70bcd427770$var$match(input, this.regex, this.handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $e457b70bcd427770$var$dateTimeFromMatches(matches) : [
                null,
                null,
                undefined
            ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
            if ($e457b70bcd427770$var$hasOwnProperty(matches, "a") && $e457b70bcd427770$var$hasOwnProperty(matches, "H")) throw new $e457b70bcd427770$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
            return {
                input: input,
                tokens: this.tokens,
                regex: this.regex,
                rawMatches: rawMatches,
                matches: matches,
                result: result,
                zone: zone,
                specificOffset: specificOffset
            };
        }
    };
    $e457b70bcd427770$var$_createClass(TokenParser, [
        {
            key: "isValid",
            get: function get() {
                return !this.disqualifyingUnit;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
            }
        }
    ]);
    return TokenParser;
}();
function $e457b70bcd427770$var$explainFromTokens(locale, input, format) {
    var parser = new $e457b70bcd427770$var$TokenParser(locale, format);
    return parser.explainFromTokens(input);
}
function $e457b70bcd427770$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $e457b70bcd427770$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $e457b70bcd427770$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $e457b70bcd427770$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($e457b70bcd427770$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $e457b70bcd427770$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $e457b70bcd427770$var$INVALID = "Invalid DateTime";
var $e457b70bcd427770$var$MAX_DATE = 8.64e15;
function $e457b70bcd427770$var$unsupportedZone(zone) {
    return new $e457b70bcd427770$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */ function $e457b70bcd427770$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $e457b70bcd427770$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
/**
 * @param {DateTime} dt
 */ function $e457b70bcd427770$var$possiblyCachedLocalWeekData(dt) {
    if (dt.localWeekData === null) dt.localWeekData = $e457b70bcd427770$var$gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
    return dt.localWeekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $e457b70bcd427770$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $e457b70bcd427770$var$DateTime($e457b70bcd427770$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $e457b70bcd427770$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $e457b70bcd427770$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $e457b70bcd427770$var$objToTS(obj, offset, zone) {
    return $e457b70bcd427770$var$fixOffset($e457b70bcd427770$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $e457b70bcd427770$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $e457b70bcd427770$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $e457b70bcd427770$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $e457b70bcd427770$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $e457b70bcd427770$var$objToLocalTS(c);
    var _fixOffset = $e457b70bcd427770$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $e457b70bcd427770$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $e457b70bcd427770$var$DateTime.fromObject(parsed, $e457b70bcd427770$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $e457b70bcd427770$var$DateTime.invalid(new $e457b70bcd427770$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $e457b70bcd427770$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $e457b70bcd427770$var$Formatter.create($e457b70bcd427770$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $e457b70bcd427770$var$_toISODate(o, extended, precision) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $e457b70bcd427770$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (precision === "year") return c;
    if (extended) {
        c += "-";
        c += $e457b70bcd427770$var$padStart(o.c.month);
        if (precision === "month") return c;
        c += "-";
    } else {
        c += $e457b70bcd427770$var$padStart(o.c.month);
        if (precision === "month") return c;
    }
    c += $e457b70bcd427770$var$padStart(o.c.day);
    return c;
}
function $e457b70bcd427770$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision) {
    var showSeconds = !suppressSeconds || o.c.millisecond !== 0 || o.c.second !== 0, c = "";
    switch(precision){
        case "day":
        case "month":
        case "year":
            break;
        default:
            c += $e457b70bcd427770$var$padStart(o.c.hour);
            if (precision === "hour") break;
            if (extended) {
                c += ":";
                c += $e457b70bcd427770$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) {
                    c += ":";
                    c += $e457b70bcd427770$var$padStart(o.c.second);
                }
            } else {
                c += $e457b70bcd427770$var$padStart(o.c.minute);
                if (precision === "minute") break;
                if (showSeconds) c += $e457b70bcd427770$var$padStart(o.c.second);
            }
            if (precision === "second") break;
            if (showSeconds && (!suppressMilliseconds || o.c.millisecond !== 0)) {
                c += ".";
                c += $e457b70bcd427770$var$padStart(o.c.millisecond, 3);
            }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $e457b70bcd427770$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $e457b70bcd427770$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $e457b70bcd427770$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $e457b70bcd427770$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $e457b70bcd427770$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $e457b70bcd427770$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $e457b70bcd427770$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $e457b70bcd427770$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $e457b70bcd427770$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $e457b70bcd427770$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $e457b70bcd427770$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $e457b70bcd427770$var$InvalidUnitError(unit);
    return normalized;
}
function $e457b70bcd427770$var$normalizeUnitWithLocalWeeks(unit) {
    switch(unit.toLowerCase()){
        case "localweekday":
        case "localweekdays":
            return "localWeekday";
        case "localweeknumber":
        case "localweeknumbers":
            return "localWeekNumber";
        case "localweekyear":
        case "localweekyears":
            return "localWeekYear";
        default:
            return $e457b70bcd427770$var$normalizeUnit(unit);
    }
}
// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
/**
 * @param {Zone} zone
 * @return {number}
 */ function $e457b70bcd427770$var$guessOffsetForZone(zone) {
    if ($e457b70bcd427770$var$zoneOffsetTs === undefined) $e457b70bcd427770$var$zoneOffsetTs = $e457b70bcd427770$var$Settings.now();
    // Do not cache anything but IANA zones, because it is not safe to do so.
    // Guessing an offset which is not present in the zone can cause wrong results from fixOffset
    if (zone.type !== "iana") return zone.offset($e457b70bcd427770$var$zoneOffsetTs);
    var zoneName = zone.name;
    var offsetGuess = $e457b70bcd427770$var$zoneOffsetGuessCache.get(zoneName);
    if (offsetGuess === undefined) {
        offsetGuess = zone.offset($e457b70bcd427770$var$zoneOffsetTs);
        $e457b70bcd427770$var$zoneOffsetGuessCache.set(zoneName, offsetGuess);
    }
    return offsetGuess;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $e457b70bcd427770$var$quickDT(obj, opts) {
    var zone = $e457b70bcd427770$var$normalizeZone(opts.zone, $e457b70bcd427770$var$Settings.defaultZone);
    if (!zone.isValid) return $e457b70bcd427770$var$DateTime.invalid($e457b70bcd427770$var$unsupportedZone(zone));
    var loc = $e457b70bcd427770$var$Locale.fromObject(opts);
    var ts, o;
    // assume we have the higher-order units
    if (!$e457b70bcd427770$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $e457b70bcd427770$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($e457b70bcd427770$var$isUndefined(obj[u])) obj[u] = $e457b70bcd427770$var$defaultUnitValues[u];
        }
        var invalid = $e457b70bcd427770$var$hasInvalidGregorianData(obj) || $e457b70bcd427770$var$hasInvalidTimeData(obj);
        if (invalid) return $e457b70bcd427770$var$DateTime.invalid(invalid);
        var offsetProvis = $e457b70bcd427770$var$guessOffsetForZone(zone);
        var _objToTS = $e457b70bcd427770$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = $e457b70bcd427770$var$Settings.now();
    return new $e457b70bcd427770$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $e457b70bcd427770$var$diffRelative(start, end, opts) {
    var round = $e457b70bcd427770$var$isUndefined(opts.round) ? true : opts.round, rounding = $e457b70bcd427770$var$isUndefined(opts.rounding) ? "trunc" : opts.rounding, format = function format(c, unit) {
        c = $e457b70bcd427770$var$roundTo(c, round || opts.calendary ? 0 : 2, opts.calendary ? "round" : rounding);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $e457b70bcd427770$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $e457b70bcd427770$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */ var $e457b70bcd427770$var$zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */ var $e457b70bcd427770$var$zoneOffsetGuessCache = new Map();
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $e457b70bcd427770$var$DateTime = /*#__PURE__*/ function(_Symbol$for) {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $e457b70bcd427770$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $e457b70bcd427770$var$Invalid("invalid input") : null) || (!zone.isValid ? $e457b70bcd427770$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $e457b70bcd427770$var$isUndefined(config.ts) ? $e457b70bcd427770$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                // If an offset has been passed and we have not been called from
                // clone(), we can trust it and avoid the offset calculation.
                var ot = $e457b70bcd427770$var$isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
                c = $e457b70bcd427770$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $e457b70bcd427770$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $e457b70bcd427770$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.localWeekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $e457b70bcd427770$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $e457b70bcd427770$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $e457b70bcd427770$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $e457b70bcd427770$var$FixedOffsetZone.utcInstance;
        return $e457b70bcd427770$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $e457b70bcd427770$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $e457b70bcd427770$var$normalizeZone(options.zone, $e457b70bcd427770$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($e457b70bcd427770$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $e457b70bcd427770$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$e457b70bcd427770$var$isNumber(milliseconds)) throw new $e457b70bcd427770$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$e457b70bcd427770$var$MAX_DATE || milliseconds > $e457b70bcd427770$var$MAX_DATE) // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $e457b70bcd427770$var$normalizeZone(options.zone, $e457b70bcd427770$var$Settings.defaultZone),
            loc: $e457b70bcd427770$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$e457b70bcd427770$var$isNumber(seconds)) throw new $e457b70bcd427770$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $e457b70bcd427770$var$normalizeZone(options.zone, $e457b70bcd427770$var$Settings.defaultZone),
            loc: $e457b70bcd427770$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $e457b70bcd427770$var$normalizeZone(opts.zone, $e457b70bcd427770$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($e457b70bcd427770$var$unsupportedZone(zoneToUse));
        var loc = $e457b70bcd427770$var$Locale.fromObject(opts);
        var normalized = $e457b70bcd427770$var$normalizeObject(obj, $e457b70bcd427770$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues = $e457b70bcd427770$var$usesLocalWeekValues(normalized, loc), minDaysInFirstWeek = _usesLocalWeekValues.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues.startOfWeek;
        var tsNow = $e457b70bcd427770$var$Settings.now(), offsetProvis = !$e457b70bcd427770$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), containsOrdinal = !$e457b70bcd427770$var$isUndefined(normalized.ordinal), containsGregorYear = !$e457b70bcd427770$var$isUndefined(normalized.year), containsGregorMD = !$e457b70bcd427770$var$isUndefined(normalized.month) || !$e457b70bcd427770$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $e457b70bcd427770$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $e457b70bcd427770$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $e457b70bcd427770$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $e457b70bcd427770$var$orderedWeekUnits;
            defaultValues = $e457b70bcd427770$var$defaultWeekUnitValues;
            objNow = $e457b70bcd427770$var$gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
        } else if (containsOrdinal) {
            units = $e457b70bcd427770$var$orderedOrdinalUnits;
            defaultValues = $e457b70bcd427770$var$defaultOrdinalUnitValues;
            objNow = $e457b70bcd427770$var$gregorianToOrdinal(objNow);
        } else {
            units = $e457b70bcd427770$var$orderedUnits;
            defaultValues = $e457b70bcd427770$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $e457b70bcd427770$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$e457b70bcd427770$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $e457b70bcd427770$var$hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $e457b70bcd427770$var$hasInvalidOrdinalData(normalized) : $e457b70bcd427770$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $e457b70bcd427770$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $e457b70bcd427770$var$weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? $e457b70bcd427770$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $e457b70bcd427770$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        if (!inst.isValid) return DateTime.invalid(inst.invalid);
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $e457b70bcd427770$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $e457b70bcd427770$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $e457b70bcd427770$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $e457b70bcd427770$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $e457b70bcd427770$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $e457b70bcd427770$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($e457b70bcd427770$var$isUndefined(text) || $e457b70bcd427770$var$isUndefined(fmt)) throw new $e457b70bcd427770$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $e457b70bcd427770$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $e457b70bcd427770$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $e457b70bcd427770$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $e457b70bcd427770$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $e457b70bcd427770$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $e457b70bcd427770$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $e457b70bcd427770$var$Invalid ? reason : new $e457b70bcd427770$var$Invalid(reason, explanation);
        if ($e457b70bcd427770$var$Settings.throwOnInvalid) throw new $e457b70bcd427770$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $e457b70bcd427770$var$formatOptsToTokens(formatOpts, $e457b70bcd427770$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $e457b70bcd427770$var$expandMacroTokens($e457b70bcd427770$var$Formatter.parseFormat(fmt), $e457b70bcd427770$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    DateTime.resetCache = function resetCache() {
        $e457b70bcd427770$var$zoneOffsetTs = undefined;
        $e457b70bcd427770$var$zoneOffsetGuessCache.clear();
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $e457b70bcd427770$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $e457b70bcd427770$var$tsToObj(ts1, o1);
        var c2 = $e457b70bcd427770$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $e457b70bcd427770$var$clone(this, {
                ts: ts1
            }),
            $e457b70bcd427770$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $e457b70bcd427770$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($e457b70bcd427770$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($e457b70bcd427770$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $e457b70bcd427770$var$normalizeZone(zone, $e457b70bcd427770$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($e457b70bcd427770$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $e457b70bcd427770$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $e457b70bcd427770$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $e457b70bcd427770$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $e457b70bcd427770$var$normalizeObject(values, $e457b70bcd427770$var$normalizeUnitWithLocalWeeks);
        var _usesLocalWeekValues2 = $e457b70bcd427770$var$usesLocalWeekValues(normalized, this.loc), minDaysInFirstWeek = _usesLocalWeekValues2.minDaysInFirstWeek, startOfWeek = _usesLocalWeekValues2.startOfWeek;
        var settingWeekStuff = !$e457b70bcd427770$var$isUndefined(normalized.weekYear) || !$e457b70bcd427770$var$isUndefined(normalized.weekNumber) || !$e457b70bcd427770$var$isUndefined(normalized.weekday), containsOrdinal = !$e457b70bcd427770$var$isUndefined(normalized.ordinal), containsGregorYear = !$e457b70bcd427770$var$isUndefined(normalized.year), containsGregorMD = !$e457b70bcd427770$var$isUndefined(normalized.month) || !$e457b70bcd427770$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $e457b70bcd427770$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $e457b70bcd427770$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $e457b70bcd427770$var$weekToGregorian($e457b70bcd427770$var$_extends({}, $e457b70bcd427770$var$gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek), normalized), minDaysInFirstWeek, startOfWeek);
        else if (!$e457b70bcd427770$var$isUndefined(normalized.ordinal)) mixed = $e457b70bcd427770$var$ordinalToGregorian($e457b70bcd427770$var$_extends({}, $e457b70bcd427770$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $e457b70bcd427770$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($e457b70bcd427770$var$isUndefined(normalized.day)) mixed.day = Math.min($e457b70bcd427770$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $e457b70bcd427770$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $e457b70bcd427770$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $e457b70bcd427770$var$Duration.fromDurationLike(duration);
        return $e457b70bcd427770$var$clone(this, $e457b70bcd427770$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $e457b70bcd427770$var$Duration.fromDurationLike(duration).negate();
        return $e457b70bcd427770$var$clone(this, $e457b70bcd427770$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit, _temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$useLocaleWeeks = _ref4.useLocaleWeeks, useLocaleWeeks = _ref4$useLocaleWeeks === void 0 ? false : _ref4$useLocaleWeeks;
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $e457b70bcd427770$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") {
            if (useLocaleWeeks) {
                var startOfWeek = this.loc.getStartOfWeek();
                var weekday = this.weekday;
                if (weekday < startOfWeek) o.weekNumber = this.weekNumber - 1;
                o.weekday = startOfWeek;
            } else o.weekday = 1;
        }
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit, opts) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit, opts).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $e457b70bcd427770$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $e457b70bcd427770$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $e457b70bcd427770$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $e457b70bcd427770$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $e457b70bcd427770$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $e457b70bcd427770$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format, _ref5$suppressSeconds = _ref5.suppressSeconds, suppressSeconds = _ref5$suppressSeconds === void 0 ? false : _ref5$suppressSeconds, _ref5$suppressMillise = _ref5.suppressMilliseconds, suppressMilliseconds = _ref5$suppressMillise === void 0 ? false : _ref5$suppressMillise, _ref5$includeOffset = _ref5.includeOffset, includeOffset = _ref5$includeOffset === void 0 ? true : _ref5$includeOffset, _ref5$extendedZone = _ref5.extendedZone, extendedZone = _ref5$extendedZone === void 0 ? false : _ref5$extendedZone, _ref5$precision = _ref5.precision, precision = _ref5$precision === void 0 ? "milliseconds" : _ref5$precision;
        if (!this.isValid) return null;
        precision = $e457b70bcd427770$var$normalizeUnit(precision);
        var ext = format === "extended";
        var c = $e457b70bcd427770$var$_toISODate(this, ext, precision);
        if ($e457b70bcd427770$var$orderedUnits.indexOf(precision) >= 3) c += "T";
        c += $e457b70bcd427770$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
        return c;
    };
    _proto.toISODate = function toISODate(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format, _ref6$precision = _ref6.precision, precision = _ref6$precision === void 0 ? "day" : _ref6$precision;
        if (!this.isValid) return null;
        return $e457b70bcd427770$var$_toISODate(this, format === "extended", $e457b70bcd427770$var$normalizeUnit(precision));
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $e457b70bcd427770$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressMillise = _ref7.suppressMilliseconds, suppressMilliseconds = _ref7$suppressMillise === void 0 ? false : _ref7$suppressMillise, _ref7$suppressSeconds = _ref7.suppressSeconds, suppressSeconds = _ref7$suppressSeconds === void 0 ? false : _ref7$suppressSeconds, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includePrefix = _ref7.includePrefix, includePrefix = _ref7$includePrefix === void 0 ? false : _ref7$includePrefix, _ref7$extendedZone = _ref7.extendedZone, extendedZone = _ref7$extendedZone === void 0 ? false : _ref7$extendedZone, _ref7$format = _ref7.format, format = _ref7$format === void 0 ? "extended" : _ref7$format, _ref7$precision = _ref7.precision, precision = _ref7$precision === void 0 ? "milliseconds" : _ref7$precision;
        if (!this.isValid) return null;
        precision = $e457b70bcd427770$var$normalizeUnit(precision);
        var c = includePrefix && $e457b70bcd427770$var$orderedUnits.indexOf(precision) >= 3 ? "T" : "";
        return c + $e457b70bcd427770$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone, precision);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $e457b70bcd427770$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $e457b70bcd427770$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $e457b70bcd427770$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp7) {
        var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$includeOffset = _ref8.includeOffset, includeOffset = _ref8$includeOffset === void 0 ? true : _ref8$includeOffset, _ref8$includeZone = _ref8.includeZone, includeZone = _ref8$includeZone === void 0 ? false : _ref8$includeZone, _ref8$includeOffsetSp = _ref8.includeOffsetSpace, includeOffsetSpace = _ref8$includeOffsetSp === void 0 ? true : _ref8$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $e457b70bcd427770$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $e457b70bcd427770$var$INVALID;
    };
    _proto[_Symbol$for] = function() {
        if (this.isValid) return "DateTime { ts: " + this.toISO() + ", zone: " + this.zone.name + ", locale: " + this.locale + " }";
        else return "DateTime { Invalid, reason: " + this.invalidReason + " }";
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $e457b70bcd427770$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $e457b70bcd427770$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $e457b70bcd427770$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $e457b70bcd427770$var$maybeArray(unit).map($e457b70bcd427770$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $e457b70bcd427770$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $e457b70bcd427770$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit, opts) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $e457b70bcd427770$var$diffRelative(base, this.plus(padding), $e457b70bcd427770$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $e457b70bcd427770$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $e457b70bcd427770$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $e457b70bcd427770$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $e457b70bcd427770$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $e457b70bcd427770$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $e457b70bcd427770$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $e457b70bcd427770$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $e457b70bcd427770$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    DateTime.buildFormatParser = function buildFormatParser(fmt, options) {
        if (options === void 0) options = {};
        var _options2 = options, _options2$locale = _options2.locale, locale = _options2$locale === void 0 ? null : _options2$locale, _options2$numberingSy = _options2.numberingSystem, numberingSystem = _options2$numberingSy === void 0 ? null : _options2$numberingSy, localeToUse = $e457b70bcd427770$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return new $e457b70bcd427770$var$TokenParser(localeToUse, fmt);
    };
    DateTime.fromFormatParser = function fromFormatParser(text, formatParser, opts) {
        if (opts === void 0) opts = {};
        if ($e457b70bcd427770$var$isUndefined(text) || $e457b70bcd427770$var$isUndefined(formatParser)) throw new $e457b70bcd427770$var$InvalidArgumentError("fromFormatParser requires an input string and a format parser");
        var _opts2 = opts, _opts2$locale = _opts2.locale, locale = _opts2$locale === void 0 ? null : _opts2$locale, _opts2$numberingSyste = _opts2.numberingSystem, numberingSystem = _opts2$numberingSyste === void 0 ? null : _opts2$numberingSyste, localeToUse = $e457b70bcd427770$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        if (!localeToUse.equals(formatParser.locale)) throw new $e457b70bcd427770$var$InvalidArgumentError("fromFormatParser called with a locale of " + localeToUse + ", " + ("but the format parser was created for " + formatParser.locale));
        var _formatParser$explain = formatParser.explainFromTokens(text), result = _formatParser$explain.result, zone = _formatParser$explain.zone, specificOffset = _formatParser$explain.specificOffset, invalidReason = _formatParser$explain.invalidReason;
        if (invalidReason) return DateTime.invalid(invalidReason);
        else return $e457b70bcd427770$var$parseDataToDateTime(result, zone, opts, "format " + formatParser.format, text, specificOffset);
    };
    $e457b70bcd427770$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "isWeekend",
            get: function get() {
                return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
            }
        },
        {
            key: "localWeekday",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$possiblyCachedLocalWeekData(this).weekday : NaN;
            }
        },
        {
            key: "localWeekNumber",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$possiblyCachedLocalWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "localWeekYear",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$possiblyCachedLocalWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $e457b70bcd427770$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $e457b70bcd427770$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        },
        {
            key: "weeksInLocalWeekYear",
            get: function get() {
                return this.isValid ? $e457b70bcd427770$var$weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $e457b70bcd427770$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $e457b70bcd427770$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $e457b70bcd427770$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $e457b70bcd427770$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $e457b70bcd427770$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $e457b70bcd427770$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $e457b70bcd427770$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $e457b70bcd427770$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $e457b70bcd427770$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $e457b70bcd427770$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $e457b70bcd427770$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $e457b70bcd427770$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $e457b70bcd427770$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $e457b70bcd427770$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}(Symbol.for("nodejs.util.inspect.custom"));
function $e457b70bcd427770$var$friendlyDateTime(dateTimeish) {
    if ($e457b70bcd427770$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $e457b70bcd427770$var$isNumber(dateTimeish.valueOf())) return $e457b70bcd427770$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $e457b70bcd427770$var$DateTime.fromObject(dateTimeish);
    else throw new $e457b70bcd427770$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $e457b70bcd427770$var$VERSION = "3.7.2";
$e457b70bcd427770$exports.DateTime = $e457b70bcd427770$var$DateTime;
$e457b70bcd427770$exports.Duration = $e457b70bcd427770$var$Duration;
$e457b70bcd427770$exports.FixedOffsetZone = $e457b70bcd427770$var$FixedOffsetZone;
$e457b70bcd427770$exports.IANAZone = $e457b70bcd427770$var$IANAZone;
$e457b70bcd427770$exports.Info = $e457b70bcd427770$var$Info;
$e457b70bcd427770$exports.Interval = $e457b70bcd427770$var$Interval;
$e457b70bcd427770$exports.InvalidZone = $e457b70bcd427770$var$InvalidZone;
$e457b70bcd427770$exports.Settings = $e457b70bcd427770$var$Settings;
$e457b70bcd427770$exports.SystemZone = $e457b70bcd427770$var$SystemZone;
$e457b70bcd427770$exports.VERSION = $e457b70bcd427770$var$VERSION;
$e457b70bcd427770$exports.Zone = $e457b70bcd427770$var$Zone;


var $bd9b13a4b7314f5d$exports = {};
"use strict";
Object.defineProperty($bd9b13a4b7314f5d$exports, "__esModule", {
    value: true
});
$bd9b13a4b7314f5d$exports.libraryName = $bd9b13a4b7314f5d$exports.getWorksheetColumnWidths = $bd9b13a4b7314f5d$exports.getJsonSheetRow = $bd9b13a4b7314f5d$exports.utils = void 0;
$bd9b13a4b7314f5d$exports.getContentProperty = $bd9b13a4b7314f5d$var$getContentProperty;
$bd9b13a4b7314f5d$exports.xlsx = $bd9b13a4b7314f5d$var$xlsx;
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ var $4cbd986da0289bb5$exports = {};
"use strict";


var $77f9f80a0cede680$require$Buffer = $4cbd986da0289bb5$exports.Buffer;
var $77f9f80a0cede680$var$XLSX = {};
$77f9f80a0cede680$var$XLSX.version = '0.20.3';
var $77f9f80a0cede680$var$current_codepage = 1200, $77f9f80a0cede680$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $77f9f80a0cede680$var$$cptable;
var $77f9f80a0cede680$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $77f9f80a0cede680$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $77f9f80a0cede680$var$set_ansi = function(cp /*:number*/ ) {
    if ($77f9f80a0cede680$var$VALID_ANSI.indexOf(cp) == -1) return;
    $77f9f80a0cede680$var$current_ansi = $77f9f80a0cede680$var$CS2CP[0] = cp;
};
function $77f9f80a0cede680$var$reset_ansi() {
    $77f9f80a0cede680$var$set_ansi(1252);
}
var $77f9f80a0cede680$var$set_cp = function(cp /*:number*/ ) {
    $77f9f80a0cede680$var$current_codepage = cp;
    $77f9f80a0cede680$var$set_ansi(cp);
};
function $77f9f80a0cede680$var$reset_cp() {
    $77f9f80a0cede680$var$set_cp(1200);
    $77f9f80a0cede680$var$reset_ansi();
}
function $77f9f80a0cede680$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $77f9f80a0cede680$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $77f9f80a0cede680$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $77f9f80a0cede680$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $77f9f80a0cede680$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $77f9f80a0cede680$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $77f9f80a0cede680$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $77f9f80a0cede680$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $77f9f80a0cede680$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $77f9f80a0cede680$export$58f247d16f363b86(cptable) {
    $77f9f80a0cede680$var$$cptable = cptable;
    $77f9f80a0cede680$var$set_cp = function(cp /*:number*/ ) {
        $77f9f80a0cede680$var$current_codepage = cp;
        $77f9f80a0cede680$var$set_ansi(cp);
    };
    $77f9f80a0cede680$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $77f9f80a0cede680$var$$cptable.utils.decode(1200, $77f9f80a0cede680$var$char_codes(data.slice(2)));
        return data;
    };
    $77f9f80a0cede680$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($77f9f80a0cede680$var$current_codepage === 1200) return String.fromCharCode(x);
        return $77f9f80a0cede680$var$$cptable.utils.decode($77f9f80a0cede680$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $77f9f80a0cede680$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $77f9f80a0cede680$var$$cptable.utils.decode($77f9f80a0cede680$var$current_ansi, [
            x
        ])[0];
    };
    $77f9f80a0cede680$var$cpdoit();
}
var $77f9f80a0cede680$var$DENSE = null;
var $77f9f80a0cede680$var$DIF_XL = true;
var $77f9f80a0cede680$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $77f9f80a0cede680$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $77f9f80a0cede680$var$Base64_map.charAt(e1) + $77f9f80a0cede680$var$Base64_map.charAt(e2) + $77f9f80a0cede680$var$Base64_map.charAt(e3) + $77f9f80a0cede680$var$Base64_map.charAt(e4);
    }
    return o;
}
function $77f9f80a0cede680$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $77f9f80a0cede680$var$Base64_map.charAt(e1) + $77f9f80a0cede680$var$Base64_map.charAt(e2) + $77f9f80a0cede680$var$Base64_map.charAt(e3) + $77f9f80a0cede680$var$Base64_map.charAt(e4);
    }
    return o;
}
function $77f9f80a0cede680$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $77f9f80a0cede680$var$Base64_map.charAt(e1) + $77f9f80a0cede680$var$Base64_map.charAt(e2) + $77f9f80a0cede680$var$Base64_map.charAt(e3) + $77f9f80a0cede680$var$Base64_map.charAt(e4);
    }
    return o;
}
function $77f9f80a0cede680$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $77f9f80a0cede680$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $77f9f80a0cede680$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $77f9f80a0cede680$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $77f9f80a0cede680$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $77f9f80a0cede680$var$has_buf = /*#__PURE__*/ function() {
    return typeof $77f9f80a0cede680$require$Buffer !== 'undefined' && false;
}();
var $77f9f80a0cede680$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $77f9f80a0cede680$require$Buffer !== 'undefined') {
        var nbfs = !$77f9f80a0cede680$require$Buffer.from;
        if (!nbfs) try {
            $77f9f80a0cede680$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $77f9f80a0cede680$require$Buffer(buf, enc) : new $77f9f80a0cede680$require$Buffer(buf);
        } : $77f9f80a0cede680$require$Buffer.from.bind($77f9f80a0cede680$require$Buffer);
    }
    return function() {};
}();
var $77f9f80a0cede680$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $77f9f80a0cede680$require$Buffer === 'undefined') return false;
    var x = $77f9f80a0cede680$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $77f9f80a0cede680$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$require$Buffer.alloc ? $77f9f80a0cede680$require$Buffer.alloc(len) : new $77f9f80a0cede680$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $77f9f80a0cede680$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$require$Buffer.allocUnsafe ? $77f9f80a0cede680$require$Buffer.allocUnsafe(len) : new $77f9f80a0cede680$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $77f9f80a0cede680$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $77f9f80a0cede680$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $77f9f80a0cede680$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $77f9f80a0cede680$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $77f9f80a0cede680$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $77f9f80a0cede680$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $77f9f80a0cede680$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $77f9f80a0cede680$var$bconcat = $77f9f80a0cede680$var$has_buf ? function(bufs) {
    return $77f9f80a0cede680$require$Buffer.concat(bufs.map(function(buf) {
        return $77f9f80a0cede680$require$Buffer.isBuffer(buf) ? buf : $77f9f80a0cede680$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($77f9f80a0cede680$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $77f9f80a0cede680$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $77f9f80a0cede680$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $77f9f80a0cede680$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $77f9f80a0cede680$var$bconcat(out);
}
var $77f9f80a0cede680$var$chr0 = /\u0000/g, $77f9f80a0cede680$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $77f9f80a0cede680$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $77f9f80a0cede680$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $77f9f80a0cede680$var$fill('0', d - t.length) + t;
}
function $77f9f80a0cede680$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $77f9f80a0cede680$var$fill(' ', d - t.length) + t;
}
function $77f9f80a0cede680$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $77f9f80a0cede680$var$fill(' ', d - t.length);
}
function $77f9f80a0cede680$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $77f9f80a0cede680$var$fill('0', d - t.length) + t;
}
function $77f9f80a0cede680$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $77f9f80a0cede680$var$fill('0', d - t.length) + t;
}
var $77f9f80a0cede680$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $77f9f80a0cede680$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $77f9f80a0cede680$var$p2_32 || v < -$77f9f80a0cede680$var$p2_32) return $77f9f80a0cede680$var$pad0r1(v, d);
    var i = Math.round(v);
    return $77f9f80a0cede680$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $77f9f80a0cede680$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $77f9f80a0cede680$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $77f9f80a0cede680$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $77f9f80a0cede680$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $77f9f80a0cede680$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $77f9f80a0cede680$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $77f9f80a0cede680$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $77f9f80a0cede680$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $77f9f80a0cede680$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $77f9f80a0cede680$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $77f9f80a0cede680$var$fill("0", s.length - 15);
    return Number(n);
}
function $77f9f80a0cede680$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $77f9f80a0cede680$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $77f9f80a0cede680$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $77f9f80a0cede680$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $77f9f80a0cede680$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $77f9f80a0cede680$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $77f9f80a0cede680$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $77f9f80a0cede680$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $77f9f80a0cede680$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $77f9f80a0cede680$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    if (!isFinite(v)) return isNaN(v) ? "#NUM!" : "#DIV/0!";
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $77f9f80a0cede680$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $77f9f80a0cede680$var$SSF_large_exp(v);
    return $77f9f80a0cede680$var$SSF_strip_decimal($77f9f80a0cede680$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $77f9f80a0cede680$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $77f9f80a0cede680$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $77f9f80a0cede680$var$SSF_format(14, $77f9f80a0cede680$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $77f9f80a0cede680$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $77f9f80a0cede680$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val1, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val1.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val1.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $77f9f80a0cede680$var$months[val1.m - 1][1];
                case 5:
                    return $77f9f80a0cede680$var$months[val1.m - 1][0];
                default:
                    return $77f9f80a0cede680$var$months[val1.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $77f9f80a0cede680$var$days[val1.q][0];
                default:
                    return $77f9f80a0cede680$var$days[val1.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val1.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val1.u === 0 && (fmt == "s" || fmt == "ss")) return $77f9f80a0cede680$var$pad0(val1.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val1.S + val1.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $77f9f80a0cede680$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val1.D * 24 + val1.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val1.D * 24 + val1.H) * 60 + val1.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val1.D * 24 + val1.H) * 60 + val1.M) * 60 + (ss0 == 0 ? Math.round(val1.S + val1.u) : val1.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $77f9f80a0cede680$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $77f9f80a0cede680$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $77f9f80a0cede680$var$pct1 = /%/g;
function $77f9f80a0cede680$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($77f9f80a0cede680$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $77f9f80a0cede680$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $77f9f80a0cede680$var$fill("%", mul);
}
function $77f9f80a0cede680$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $77f9f80a0cede680$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $77f9f80a0cede680$var$write_num_exp(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $77f9f80a0cede680$var$write_num_exp(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $77f9f80a0cede680$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $77f9f80a0cede680$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $77f9f80a0cede680$var$fill(" ", r[1].length + 1 + r[4].length) : $77f9f80a0cede680$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $77f9f80a0cede680$var$pad0(myd, r[4].length));
}
function $77f9f80a0cede680$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $77f9f80a0cede680$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $77f9f80a0cede680$var$dec1 = /^#*0*\.([0#]+)/;
var $77f9f80a0cede680$var$closeparen = /\)[^)]*[0#]/;
var $77f9f80a0cede680$var$phone = /\(###\) ###\\?-####/;
function $77f9f80a0cede680$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $77f9f80a0cede680$var$rnd(val1 /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val1 * dd) / dd;
}
function $77f9f80a0cede680$var$dec(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val1 - Math.floor(val1), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $77f9f80a0cede680$var$carry(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val1 - Math.floor(val1)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $77f9f80a0cede680$var$flr(val1 /*:number*/ ) /*:string*/ {
    if (val1 < 2147483647 && val1 > -2147483648) return "" + (val1 >= 0 ? val1 | 0 : val1 - 1 | 0);
    return "" + Math.floor(val1);
}
function $77f9f80a0cede680$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($77f9f80a0cede680$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $77f9f80a0cede680$var$write_num_flt('n', ffmt, val1);
        return '(' + $77f9f80a0cede680$var$write_num_flt('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $77f9f80a0cede680$var$write_num_cm(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $77f9f80a0cede680$var$write_num_pct(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $77f9f80a0cede680$var$write_num_exp(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $77f9f80a0cede680$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $77f9f80a0cede680$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $77f9f80a0cede680$var$pad0r(val1, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $77f9f80a0cede680$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($77f9f80a0cede680$var$frac1)) return $77f9f80a0cede680$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $77f9f80a0cede680$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($77f9f80a0cede680$var$dec1)) {
        o = $77f9f80a0cede680$var$rnd(val1, r[1].length).replace(/^([^\.]+)$/, "$1." + $77f9f80a0cede680$var$hashq(r[1])).replace(/\.$/, "." + $77f9f80a0cede680$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $77f9f80a0cede680$var$fill("0", $77f9f80a0cede680$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $77f9f80a0cede680$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $77f9f80a0cede680$var$commaify($77f9f80a0cede680$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $77f9f80a0cede680$var$write_num_flt(type, fmt, -val1) : $77f9f80a0cede680$var$commaify("" + (Math.floor(val1) + $77f9f80a0cede680$var$carry(val1, r[1].length))) + "." + $77f9f80a0cede680$var$pad0($77f9f80a0cede680$var$dec(val1, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $77f9f80a0cede680$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $77f9f80a0cede680$var$_strrev($77f9f80a0cede680$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $77f9f80a0cede680$var$_strrev($77f9f80a0cede680$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($77f9f80a0cede680$var$phone)) {
        o = $77f9f80a0cede680$var$write_num_flt(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $77f9f80a0cede680$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $77f9f80a0cede680$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $77f9f80a0cede680$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $77f9f80a0cede680$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $77f9f80a0cede680$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $77f9f80a0cede680$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $77f9f80a0cede680$var$rpad_(ff[2], ri) : $77f9f80a0cede680$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $77f9f80a0cede680$var$pad0r(val1, 0);
        if (fmt.length <= o.length) return o;
        return $77f9f80a0cede680$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $77f9f80a0cede680$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $77f9f80a0cede680$var$dec(val1, r[1].length);
        return val1 < 0 ? "-" + $77f9f80a0cede680$var$write_num_flt(type, fmt, -val1) : $77f9f80a0cede680$var$commaify($77f9f80a0cede680$var$flr(val1)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $77f9f80a0cede680$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $77f9f80a0cede680$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $77f9f80a0cede680$var$write_num_flt(type, "#,##0.00", val1);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $77f9f80a0cede680$var$commaify($77f9f80a0cede680$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $77f9f80a0cede680$var$write_num_flt(type, "###,##0.00", val1).replace(/^0\./, ".");
        case "#,###.00":
            return $77f9f80a0cede680$var$write_num_flt(type, "#,##0.00", val1).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $77f9f80a0cede680$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $77f9f80a0cede680$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $77f9f80a0cede680$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($77f9f80a0cede680$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $77f9f80a0cede680$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $77f9f80a0cede680$var$fill("%", mul);
}
function $77f9f80a0cede680$var$write_num_exp2(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $77f9f80a0cede680$var$write_num_exp2(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $77f9f80a0cede680$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($77f9f80a0cede680$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $77f9f80a0cede680$var$write_num_int('n', ffmt, val1);
        return '(' + $77f9f80a0cede680$var$write_num_int('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $77f9f80a0cede680$var$write_num_cm2(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $77f9f80a0cede680$var$write_num_pct2(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $77f9f80a0cede680$var$write_num_exp2(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $77f9f80a0cede680$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $77f9f80a0cede680$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val1;
        if (val1 === 0) o = "";
        return o.length > fmt.length ? o : $77f9f80a0cede680$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($77f9f80a0cede680$var$frac1)) return $77f9f80a0cede680$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $77f9f80a0cede680$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($77f9f80a0cede680$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val1).replace(/^([^\.]+)$/, "$1." + $77f9f80a0cede680$var$hashq(r[1])).replace(/\.$/, "." + $77f9f80a0cede680$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $77f9f80a0cede680$var$fill("0", $77f9f80a0cede680$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $77f9f80a0cede680$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $77f9f80a0cede680$var$write_num_int(type, fmt, -val1) : $77f9f80a0cede680$var$commaify("" + val1) + "." + $77f9f80a0cede680$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $77f9f80a0cede680$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $77f9f80a0cede680$var$_strrev($77f9f80a0cede680$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $77f9f80a0cede680$var$_strrev($77f9f80a0cede680$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($77f9f80a0cede680$var$phone)) {
        o = $77f9f80a0cede680$var$write_num_int(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $77f9f80a0cede680$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $77f9f80a0cede680$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $77f9f80a0cede680$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $77f9f80a0cede680$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $77f9f80a0cede680$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $77f9f80a0cede680$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $77f9f80a0cede680$var$rpad_(ff[2], ri) : $77f9f80a0cede680$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val1;
        if (fmt.length <= o.length) return o;
        return $77f9f80a0cede680$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $77f9f80a0cede680$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val1 < 0 ? "-" + $77f9f80a0cede680$var$write_num_int(type, fmt, -val1) : $77f9f80a0cede680$var$commaify("" + val1).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $77f9f80a0cede680$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $77f9f80a0cede680$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $77f9f80a0cede680$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $77f9f80a0cede680$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val1) + $77f9f80a0cede680$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $77f9f80a0cede680$var$write_num(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    return (val1 | 0) === val1 ? $77f9f80a0cede680$var$write_num_int(type, fmt, val1) : $77f9f80a0cede680$var$write_num_flt(type, fmt, val1);
}
function $77f9f80a0cede680$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $77f9f80a0cede680$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $77f9f80a0cede680$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($77f9f80a0cede680$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($77f9f80a0cede680$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $77f9f80a0cede680$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$77f9f80a0cede680$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $77f9f80a0cede680$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $77f9f80a0cede680$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $77f9f80a0cede680$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($77f9f80a0cede680$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $77f9f80a0cede680$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$77f9f80a0cede680$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $77f9f80a0cede680$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $77f9f80a0cede680$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $77f9f80a0cede680$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $77f9f80a0cede680$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $77f9f80a0cede680$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $77f9f80a0cede680$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $77f9f80a0cede680$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $77f9f80a0cede680$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $77f9f80a0cede680$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $77f9f80a0cede680$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $77f9f80a0cede680$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    /* NOTE: most spreadsheet software do not support NaN or infinities */ if (typeof v === "number" && !isFinite(v)) v = 0;
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($77f9f80a0cede680$var$cfregex2);
        var m2 = fmt[1].match($77f9f80a0cede680$var$cfregex2);
        return $77f9f80a0cede680$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $77f9f80a0cede680$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $77f9f80a0cede680$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $77f9f80a0cede680$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$77f9f80a0cede680$var$SSF_default_map[fmt]] || $77f9f80a0cede680$var$table_fmt[$77f9f80a0cede680$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $77f9f80a0cede680$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($77f9f80a0cede680$var$SSF_isgeneral(sfmt, 0)) return $77f9f80a0cede680$var$SSF_general(v, o);
    if (v instanceof Date) v = $77f9f80a0cede680$var$datenum(v, o.date1904);
    var f = $77f9f80a0cede680$var$choose_fmt(sfmt, v);
    if ($77f9f80a0cede680$var$SSF_isgeneral(f[1])) return $77f9f80a0cede680$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    else if (isNaN(v) && f[1].indexOf("0") > -1) return "#NUM!";
    else if (!isFinite(v) && f[1].indexOf("0") > -1) return "#DIV/0!";
    return $77f9f80a0cede680$var$eval_fmt(f[1], v, o, f[0]);
}
function $77f9f80a0cede680$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($77f9f80a0cede680$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($77f9f80a0cede680$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $77f9f80a0cede680$var$table_fmt[idx] = fmt;
    return idx;
}
function $77f9f80a0cede680$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $77f9f80a0cede680$var$SSF_load(tbl[i], i);
}
function $77f9f80a0cede680$var$make_ssf() {
    $77f9f80a0cede680$var$table_fmt = $77f9f80a0cede680$var$SSF_init_table();
}
var $77f9f80a0cede680$export$40d8edd678456c2b = {
    format: $77f9f80a0cede680$var$SSF_format,
    load: $77f9f80a0cede680$var$SSF_load,
    _table: $77f9f80a0cede680$var$table_fmt,
    load_table: $77f9f80a0cede680$var$SSF_load_table,
    parse_date_code: $77f9f80a0cede680$var$SSF_parse_date_code,
    is_date: $77f9f80a0cede680$var$fmt_is_date,
    get_table: function get_table() {
        return $77f9f80a0cede680$export$40d8edd678456c2b._table = $77f9f80a0cede680$var$table_fmt;
    }
};
var $77f9f80a0cede680$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $77f9f80a0cede680$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $77f9f80a0cede680$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $77f9f80a0cede680$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($77f9f80a0cede680$var$dateNFregex, "(\\d+)");
    $77f9f80a0cede680$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $77f9f80a0cede680$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($77f9f80a0cede680$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $77f9f80a0cede680$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $77f9f80a0cede680$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $77f9f80a0cede680$var$SSF__load(fmt, idx) {
    return $77f9f80a0cede680$var$SSF_load($77f9f80a0cede680$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $77f9f80a0cede680$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /*::
type CRC32TableType = Array<number> | Int32Array;
*/ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:?number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $77f9f80a0cede680$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val1 = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val1.setMilliseconds(0);
        val1.setFullYear(ymd + 1980);
        val1.setMonth(m - 1);
        val1.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val1.setHours(hms);
        val1.setMinutes(M);
        val1.setSeconds(S << 1);
        return val1;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $77f9f80a0cede680$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $77f9f80a0cede680$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $77f9f80a0cede680$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $77f9f80a0cede680$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $77f9f80a0cede680$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $77f9f80a0cede680$var$new_buf(0);
        return $77f9f80a0cede680$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $77f9f80a0cede680$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($77f9f80a0cede680$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $77f9f80a0cede680$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $77f9f80a0cede680$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $77f9f80a0cede680$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $77f9f80a0cede680$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $77f9f80a0cede680$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $77f9f80a0cede680$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $77f9f80a0cede680$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($77f9f80a0cede680$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $77f9f80a0cede680$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($77f9f80a0cede680$var$s2a($77f9f80a0cede680$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($77f9f80a0cede680$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $77f9f80a0cede680$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $77f9f80a0cede680$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($77f9f80a0cede680$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($77f9f80a0cede680$var$chr1);
        UCPath = UCPath.replace($77f9f80a0cede680$var$chr0, '');
        if (m) UCPath = UCPath.replace($77f9f80a0cede680$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($77f9f80a0cede680$var$chr1, '!') : UCFullPaths[w]).replace($77f9f80a0cede680$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($77f9f80a0cede680$var$chr1, '!') : UCPaths[w]).replace($77f9f80a0cede680$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $77f9f80a0cede680$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$require$Buffer.isBuffer(o) ? o : $77f9f80a0cede680$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $77f9f80a0cede680$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($77f9f80a0cede680$var$has_buf) {
            var o = $77f9f80a0cede680$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $77f9f80a0cede680$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $77f9f80a0cede680$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $77f9f80a0cede680$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $77f9f80a0cede680$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = EF[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                blob.l += _csz;
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $77f9f80a0cede680$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || Array.isArray(fi.content) && fi.content.length == 0 || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $77f9f80a0cede680$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $77f9f80a0cede680$var$CRC32.bstr(fi.content, 0) : $77f9f80a0cede680$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $77f9f80a0cede680$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $77f9f80a0cede680$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $77f9f80a0cede680$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $77f9f80a0cede680$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $77f9f80a0cede680$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $77f9f80a0cede680$var$bconcat([
            $77f9f80a0cede680$var$bconcat(out /*:any*/ ),
            $77f9f80a0cede680$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $77f9f80a0cede680$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $77f9f80a0cede680$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $77f9f80a0cede680$var$s2a($77f9f80a0cede680$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $77f9f80a0cede680$var$ReadShift,
        CheckField: $77f9f80a0cede680$var$CheckField,
        prep_blob: $77f9f80a0cede680$var$prep_blob,
        bconcat: $77f9f80a0cede680$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $77f9f80a0cede680$var$_fs;
function $77f9f80a0cede680$export$a48eb669e1768bcf(fs) {
    $77f9f80a0cede680$var$_fs = fs;
}
/* normalize data for blob ctor */ function $77f9f80a0cede680$var$blobify(data) {
    if (typeof data === "string") return $77f9f80a0cede680$var$s2ab(data);
    if (Array.isArray(data)) return $77f9f80a0cede680$var$a2u(data);
    return data;
}
/* write or download file */ function $77f9f80a0cede680$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $77f9f80a0cede680$var$_fs !== 'undefined' && $77f9f80a0cede680$var$_fs.writeFileSync) return enc ? $77f9f80a0cede680$var$_fs.writeFileSync(fname, payload, enc) : $77f9f80a0cede680$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $77f9f80a0cede680$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $77f9f80a0cede680$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $77f9f80a0cede680$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $77f9f80a0cede680$var$Base64_encode_arr(new Uint8Array($77f9f80a0cede680$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $77f9f80a0cede680$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $77f9f80a0cede680$var$read_binary(path /*:string*/ ) {
    if (typeof $77f9f80a0cede680$var$_fs !== 'undefined') return $77f9f80a0cede680$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $77f9f80a0cede680$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $77f9f80a0cede680$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $77f9f80a0cede680$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $77f9f80a0cede680$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $77f9f80a0cede680$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $77f9f80a0cede680$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $77f9f80a0cede680$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $77f9f80a0cede680$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $77f9f80a0cede680$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $77f9f80a0cede680$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $77f9f80a0cede680$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $77f9f80a0cede680$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $77f9f80a0cede680$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $77f9f80a0cede680$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $77f9f80a0cede680$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $77f9f80a0cede680$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $77f9f80a0cede680$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $77f9f80a0cede680$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $77f9f80a0cede680$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $77f9f80a0cede680$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $77f9f80a0cede680$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($77f9f80a0cede680$var$pdre1);
    if (m) return new Date((date1904 ? $77f9f80a0cede680$var$dnthresh2 : $77f9f80a0cede680$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($77f9f80a0cede680$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($77f9f80a0cede680$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $77f9f80a0cede680$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(arr)) {
        if (debomit && $77f9f80a0cede680$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $77f9f80a0cede680$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $77f9f80a0cede680$var$utf8write($77f9f80a0cede680$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $77f9f80a0cede680$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $77f9f80a0cede680$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $77f9f80a0cede680$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $77f9f80a0cede680$var$dup(o[k]);
    return out;
}
function $77f9f80a0cede680$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $77f9f80a0cede680$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $77f9f80a0cede680$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $77f9f80a0cede680$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $77f9f80a0cede680$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $77f9f80a0cede680$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $77f9f80a0cede680$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $77f9f80a0cede680$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $77f9f80a0cede680$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $77f9f80a0cede680$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($77f9f80a0cede680$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $77f9f80a0cede680$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($77f9f80a0cede680$var$FDRE1);
    if (M) return $77f9f80a0cede680$var$fuzzytime1(M);
    M = lnos.match($77f9f80a0cede680$var$FDRE2);
    if (M) return $77f9f80a0cede680$var$fuzzytime2(M);
    M = lnos.match($77f9f80a0cede680$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($77f9f80a0cede680$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $77f9f80a0cede680$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $77f9f80a0cede680$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $77f9f80a0cede680$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $77f9f80a0cede680$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $77f9f80a0cede680$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $77f9f80a0cede680$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $77f9f80a0cede680$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $77f9f80a0cede680$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $77f9f80a0cede680$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$77f9f80a0cede680$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $77f9f80a0cede680$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $77f9f80a0cede680$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $77f9f80a0cede680$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $77f9f80a0cede680$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $77f9f80a0cede680$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $77f9f80a0cede680$var$cc2str(data.content, true);
    if (data.data) return $77f9f80a0cede680$var$debom(data.data);
    if (data.asNodeBuffer && $77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $77f9f80a0cede680$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $77f9f80a0cede680$var$debom($77f9f80a0cede680$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $77f9f80a0cede680$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $77f9f80a0cede680$var$char_codes(data.data);
    if (data.asNodeBuffer && $77f9f80a0cede680$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $77f9f80a0cede680$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $77f9f80a0cede680$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $77f9f80a0cede680$var$getdatabin(data) : $77f9f80a0cede680$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $77f9f80a0cede680$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $77f9f80a0cede680$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $77f9f80a0cede680$var$getzipfile(zip, file /*:string*/ ) {
    var o = $77f9f80a0cede680$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $77f9f80a0cede680$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $77f9f80a0cede680$var$getdata($77f9f80a0cede680$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $77f9f80a0cede680$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $77f9f80a0cede680$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $77f9f80a0cede680$var$getdatastr($77f9f80a0cede680$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $77f9f80a0cede680$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $77f9f80a0cede680$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $77f9f80a0cede680$var$getdatabin($77f9f80a0cede680$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $77f9f80a0cede680$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $77f9f80a0cede680$var$zipentries(zip) {
    var k = zip.FullPaths || $77f9f80a0cede680$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $77f9f80a0cede680$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (Array.isArray(content) && typeof content[0] == "string") content = content.join("");
        if (typeof content == "string") {
            var res;
            if ($77f9f80a0cede680$var$has_buf) res = $77f9f80a0cede680$var$Buffer_from(content);
            else res = $77f9f80a0cede680$var$utf8decode(content);
            return $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $77f9f80a0cede680$var$zip_new() {
    return $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_new();
}
function $77f9f80a0cede680$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $77f9f80a0cede680$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $77f9f80a0cede680$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $77f9f80a0cede680$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $77f9f80a0cede680$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $77f9f80a0cede680$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $77f9f80a0cede680$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $77f9f80a0cede680$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $77f9f80a0cede680$var$tagregex2 = /<[^<>]*>/g;
var $77f9f80a0cede680$var$tagregex = /*#__PURE__*/ $77f9f80a0cede680$var$XML_HEADER.match($77f9f80a0cede680$var$tagregex1) ? $77f9f80a0cede680$var$tagregex1 : $77f9f80a0cede680$var$tagregex2;
var $77f9f80a0cede680$var$nsregex = /<\w*:/, $77f9f80a0cede680$var$nsregex2 = /<(\/?)\w+:/;
function $77f9f80a0cede680$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($77f9f80a0cede680$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $77f9f80a0cede680$var$parsexmltagraw(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($77f9f80a0cede680$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
        z[q] = v;
        if (!skip_LC) z[q.toLowerCase()] = v;
    }
    return z;
}
function $77f9f80a0cede680$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($77f9f80a0cede680$var$nsregex2, "<$1");
}
var $77f9f80a0cede680$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $77f9f80a0cede680$var$rencoding = /*#__PURE__*/ $77f9f80a0cede680$var$evert($77f9f80a0cede680$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $77f9f80a0cede680$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $77f9f80a0cede680$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $77f9f80a0cede680$var$decregex = /[&<>'"]/g, $77f9f80a0cede680$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $77f9f80a0cede680$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($77f9f80a0cede680$var$decregex, function(y) {
        return $77f9f80a0cede680$var$rencoding[y];
    }).replace($77f9f80a0cede680$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $77f9f80a0cede680$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $77f9f80a0cede680$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $77f9f80a0cede680$var$htmlcharegex = /[\u0000-\u001f]/g;
function $77f9f80a0cede680$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($77f9f80a0cede680$var$decregex, function(y) {
        return $77f9f80a0cede680$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($77f9f80a0cede680$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $77f9f80a0cede680$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($77f9f80a0cede680$var$decregex, function(y) {
        return $77f9f80a0cede680$var$rencoding[y];
    }).replace($77f9f80a0cede680$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $77f9f80a0cede680$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $77f9f80a0cede680$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $77f9f80a0cede680$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $77f9f80a0cede680$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $77f9f80a0cede680$var$utf8readb(data) {
    var out = $77f9f80a0cede680$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $77f9f80a0cede680$var$utf8readc(data) {
    return $77f9f80a0cede680$var$Buffer_from(data, 'binary').toString('utf8');
}
var $77f9f80a0cede680$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $77f9f80a0cede680$var$utf8read = $77f9f80a0cede680$var$has_buf && /*#__PURE__*/ ($77f9f80a0cede680$var$utf8readc($77f9f80a0cede680$var$utf8corpus) == /*#__PURE__*/ $77f9f80a0cede680$var$utf8reada($77f9f80a0cede680$var$utf8corpus) && $77f9f80a0cede680$var$utf8readc || /*#__PURE__*/ $77f9f80a0cede680$var$utf8readb($77f9f80a0cede680$var$utf8corpus) == /*#__PURE__*/ $77f9f80a0cede680$var$utf8reada($77f9f80a0cede680$var$utf8corpus) && $77f9f80a0cede680$var$utf8readb) || $77f9f80a0cede680$var$utf8reada;
var $77f9f80a0cede680$var$utf8write /*:StringConv*/  = $77f9f80a0cede680$var$has_buf ? function(data) {
    return $77f9f80a0cede680$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $77f9f80a0cede680$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $77f9f80a0cede680$var$vtvregex = /<\/?(?:vt:)?variant>/g, $77f9f80a0cede680$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $77f9f80a0cede680$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $77f9f80a0cede680$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $77f9f80a0cede680$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($77f9f80a0cede680$var$vtvregex, "").match($77f9f80a0cede680$var$vtmregex);
        if (v) res.push({
            v: $77f9f80a0cede680$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $77f9f80a0cede680$var$wtregex = /(^\s|\s$|\n)/;
function $77f9f80a0cede680$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($77f9f80a0cede680$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $77f9f80a0cede680$var$wxt_helper(h) /*:string*/ {
    return $77f9f80a0cede680$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $77f9f80a0cede680$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $77f9f80a0cede680$var$wxt_helper(h) : "") + (g != null ? (g.match($77f9f80a0cede680$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $77f9f80a0cede680$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $77f9f80a0cede680$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $77f9f80a0cede680$var$writextag('vt:lpwstr', $77f9f80a0cede680$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $77f9f80a0cede680$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $77f9f80a0cede680$var$escapexml(String(s)));
        case 'boolean':
            return $77f9f80a0cede680$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $77f9f80a0cede680$var$writextag('vt:filetime', $77f9f80a0cede680$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $77f9f80a0cede680$var$xlml_normalize(d) /*:string*/ {
    if ($77f9f80a0cede680$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $77f9f80a0cede680$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $77f9f80a0cede680$var$utf8read($77f9f80a0cede680$var$a2s($77f9f80a0cede680$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $77f9f80a0cede680$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $77f9f80a0cede680$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $77f9f80a0cede680$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $77f9f80a0cede680$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $77f9f80a0cede680$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $77f9f80a0cede680$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $77f9f80a0cede680$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $77f9f80a0cede680$var$__toBuffer = $77f9f80a0cede680$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $77f9f80a0cede680$require$Buffer.isBuffer(bufs[0][0]) ? $77f9f80a0cede680$require$Buffer.concat(bufs[0].map(function(x) {
        return $77f9f80a0cede680$require$Buffer.isBuffer(x) ? x : $77f9f80a0cede680$var$Buffer_from(x);
    })) : $77f9f80a0cede680$var$___toBuffer(bufs);
} : $77f9f80a0cede680$var$___toBuffer;
var $77f9f80a0cede680$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($77f9f80a0cede680$var$__readUInt16LE(b, i)));
    return ss.join("").replace($77f9f80a0cede680$var$chr0, '');
};
var $77f9f80a0cede680$var$__utf16le = $77f9f80a0cede680$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$77f9f80a0cede680$require$Buffer.isBuffer(b) || !$77f9f80a0cede680$var$buf_utf16le) return $77f9f80a0cede680$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($77f9f80a0cede680$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $77f9f80a0cede680$var$___utf16le;
var $77f9f80a0cede680$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $77f9f80a0cede680$var$__hexlify = $77f9f80a0cede680$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $77f9f80a0cede680$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $77f9f80a0cede680$var$___hexlify(b, s, l);
} : $77f9f80a0cede680$var$___hexlify;
var $77f9f80a0cede680$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($77f9f80a0cede680$var$__readUInt8(b, i)));
    return ss.join("");
};
var $77f9f80a0cede680$var$__utf8 = $77f9f80a0cede680$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $77f9f80a0cede680$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $77f9f80a0cede680$var$___utf8(b, s, e);
} : $77f9f80a0cede680$var$___utf8;
var $77f9f80a0cede680$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
    return len > 0 ? $77f9f80a0cede680$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $77f9f80a0cede680$var$__lpstr = $77f9f80a0cede680$var$___lpstr;
var $77f9f80a0cede680$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
    return len > 0 ? $77f9f80a0cede680$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $77f9f80a0cede680$var$__cpstr = $77f9f80a0cede680$var$___cpstr;
var $77f9f80a0cede680$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $77f9f80a0cede680$var$__readUInt32LE(b, i);
    return len > 0 ? $77f9f80a0cede680$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $77f9f80a0cede680$var$__lpwstr = $77f9f80a0cede680$var$___lpwstr;
var $77f9f80a0cede680$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
    return len > 0 ? $77f9f80a0cede680$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $77f9f80a0cede680$var$__lpp4 = $77f9f80a0cede680$var$___lpp4;
var $77f9f80a0cede680$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
    return len > 0 ? $77f9f80a0cede680$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $77f9f80a0cede680$var$__8lpp4 = $77f9f80a0cede680$var$___8lpp4;
var $77f9f80a0cede680$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $77f9f80a0cede680$var$read_double_le(b, idx);
};
var $77f9f80a0cede680$var$__double = $77f9f80a0cede680$var$___double;
var $77f9f80a0cede680$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($77f9f80a0cede680$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $77f9f80a0cede680$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$77f9f80a0cede680$require$Buffer.isBuffer(b)) return $77f9f80a0cede680$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $77f9f80a0cede680$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$77f9f80a0cede680$require$Buffer.isBuffer(b)) return $77f9f80a0cede680$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $77f9f80a0cede680$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$77f9f80a0cede680$require$Buffer.isBuffer(b) || !$77f9f80a0cede680$var$buf_utf16le) return $77f9f80a0cede680$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $77f9f80a0cede680$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$77f9f80a0cede680$require$Buffer.isBuffer(b) || !$77f9f80a0cede680$var$buf_utf16le) return $77f9f80a0cede680$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $77f9f80a0cede680$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$77f9f80a0cede680$require$Buffer.isBuffer(b)) return $77f9f80a0cede680$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $77f9f80a0cede680$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($77f9f80a0cede680$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $77f9f80a0cede680$var$___double(b, i);
    };
    $77f9f80a0cede680$var$is_buf = function is_buf_b(a) {
        return $77f9f80a0cede680$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $77f9f80a0cede680$var$cpdoit() {
    $77f9f80a0cede680$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $77f9f80a0cede680$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($77f9f80a0cede680$var$chr0, '');
    };
    $77f9f80a0cede680$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $77f9f80a0cede680$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $77f9f80a0cede680$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
        return len > 0 ? $77f9f80a0cede680$var$$cptable.utils.decode($77f9f80a0cede680$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $77f9f80a0cede680$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
        return len > 0 ? $77f9f80a0cede680$var$$cptable.utils.decode($77f9f80a0cede680$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $77f9f80a0cede680$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $77f9f80a0cede680$var$__readUInt32LE(b, i);
        return len > 0 ? $77f9f80a0cede680$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $77f9f80a0cede680$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
        return len > 0 ? $77f9f80a0cede680$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $77f9f80a0cede680$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $77f9f80a0cede680$var$__readUInt32LE(b, i);
        return len > 0 ? $77f9f80a0cede680$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined') $77f9f80a0cede680$var$cpdoit();
var $77f9f80a0cede680$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $77f9f80a0cede680$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $77f9f80a0cede680$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $77f9f80a0cede680$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $77f9f80a0cede680$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $77f9f80a0cede680$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $77f9f80a0cede680$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(this) && $77f9f80a0cede680$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($77f9f80a0cede680$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $77f9f80a0cede680$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $77f9f80a0cede680$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined') o = $77f9f80a0cede680$var$$cptable.utils.decode($77f9f80a0cede680$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $77f9f80a0cede680$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $77f9f80a0cede680$var$__lpstr(this, this.l);
            size = 4 + $77f9f80a0cede680$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $77f9f80a0cede680$var$__cpstr(this, this.l);
            size = 4 + $77f9f80a0cede680$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $77f9f80a0cede680$var$__lpwstr(this, this.l);
            size = 4 + 2 * $77f9f80a0cede680$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $77f9f80a0cede680$var$__readUInt32LE(this, this.l);
            o = $77f9f80a0cede680$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $77f9f80a0cede680$var$__readUInt32LE(this, this.l);
            o = $77f9f80a0cede680$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $77f9f80a0cede680$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($77f9f80a0cede680$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $77f9f80a0cede680$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($77f9f80a0cede680$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $77f9f80a0cede680$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $77f9f80a0cede680$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($77f9f80a0cede680$var$_getchar($77f9f80a0cede680$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined') {
                o = $77f9f80a0cede680$var$$cptable.utils.decode($77f9f80a0cede680$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $77f9f80a0cede680$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $77f9f80a0cede680$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($77f9f80a0cede680$var$_getchar($77f9f80a0cede680$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $77f9f80a0cede680$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $77f9f80a0cede680$var$__readInt16LE : $77f9f80a0cede680$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $77f9f80a0cede680$var$__readInt32LE : $77f9f80a0cede680$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $77f9f80a0cede680$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $77f9f80a0cede680$var$__double(this, this.l);
                        else oR = $77f9f80a0cede680$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $77f9f80a0cede680$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $77f9f80a0cede680$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
    b[idx + 2] = val1 >>> 16 & 0xFF;
    b[idx + 3] = val1 >>> 24 & 0xFF;
};
var $77f9f80a0cede680$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >> 8 & 0xFF;
    b[idx + 2] = val1 >> 16 & 0xFF;
    b[idx + 3] = val1 >> 24 & 0xFF;
};
var $77f9f80a0cede680$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
};
function $77f9f80a0cede680$var$WriteShift(t /*:number*/ , val1 /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)$77f9f80a0cede680$var$__writeUInt16LE(this, val1.charCodeAt(i), this.l + 2 * i);
        size = 2 * val1.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined' && $77f9f80a0cede680$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i){
                var cpp = $77f9f80a0cede680$var$$cptable.utils.encode($77f9f80a0cede680$var$current_ansi, val1.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val1.length;
        } else if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $77f9f80a0cede680$var$$cptable.utils.encode($77f9f80a0cede680$var$current_codepage, val1);
            /* replace null bytes with _ when relevant */ if (cpp.length == val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[i] == 0 && val1.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val1.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val1 = val1.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)this[this.l + i] = val1.charCodeAt(i) & 0xFF;
            size = val1.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val1.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val1.length, t); ++i){
            var cc = val1.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val1 & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 2] = val1 & 0xFF;
            break;
        case 4:
            size = 4;
            $77f9f80a0cede680$var$__writeUInt32LE(this, val1, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $77f9f80a0cede680$var$write_double_le(this, val1, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $77f9f80a0cede680$var$__writeInt32LE(this, val1, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $77f9f80a0cede680$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $77f9f80a0cede680$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $77f9f80a0cede680$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $77f9f80a0cede680$var$ReadShift /*:: :any)*/ ;
    blob.chk = $77f9f80a0cede680$var$CheckField;
    blob.write_shift = $77f9f80a0cede680$var$WriteShift;
}
function $77f9f80a0cede680$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $77f9f80a0cede680$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $77f9f80a0cede680$var$new_raw_buf(sz);
    $77f9f80a0cede680$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $77f9f80a0cede680$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $77f9f80a0cede680$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $77f9f80a0cede680$var$XLSBRecordEnum[RT] || $77f9f80a0cede680$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $77f9f80a0cede680$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $77f9f80a0cede680$var$has_buf ? 16384 : 2048;
    var has_buf_copy = $77f9f80a0cede680$var$has_buf && typeof $77f9f80a0cede680$var$new_buf(blksz).copy == "function";
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $77f9f80a0cede680$var$new_buf(sz);
        $77f9f80a0cede680$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $77f9f80a0cede680$var$bconcat(bufs);
    };
    var end2 = function() {
        endbuf();
        return bufs;
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs,
        end2: end2
    } /*:any*/ ;
}
function $77f9f80a0cede680$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $77f9f80a0cede680$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $77f9f80a0cede680$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $77f9f80a0cede680$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $77f9f80a0cede680$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $77f9f80a0cede680$var$shift_range_xls(cell, range, opts) {
    var out = $77f9f80a0cede680$var$dup(cell);
    out.s = $77f9f80a0cede680$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $77f9f80a0cede680$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $77f9f80a0cede680$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $77f9f80a0cede680$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $77f9f80a0cede680$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $77f9f80a0cede680$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $77f9f80a0cede680$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $77f9f80a0cede680$var$fix_row(s);
    return s;
}
function $77f9f80a0cede680$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $77f9f80a0cede680$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $77f9f80a0cede680$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $77f9f80a0cede680$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $77f9f80a0cede680$var$encode_row(r.e.r);
    }
    return $77f9f80a0cede680$var$encode_cell_xls(r.s, opts.biff) + ":" + $77f9f80a0cede680$var$encode_cell_xls(r.e, opts.biff);
}
function $77f9f80a0cede680$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($77f9f80a0cede680$var$unfix_row(rowstr), 10) - 1;
}
function $77f9f80a0cede680$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $77f9f80a0cede680$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $77f9f80a0cede680$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $77f9f80a0cede680$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $77f9f80a0cede680$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $77f9f80a0cede680$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $77f9f80a0cede680$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $77f9f80a0cede680$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $77f9f80a0cede680$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $77f9f80a0cede680$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $77f9f80a0cede680$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $77f9f80a0cede680$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $77f9f80a0cede680$var$decode_cell(range),
        e: $77f9f80a0cede680$var$decode_cell(range)
    };
    return {
        s: $77f9f80a0cede680$var$decode_cell(range.slice(0, idx)),
        e: $77f9f80a0cede680$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $77f9f80a0cede680$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $77f9f80a0cede680$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $77f9f80a0cede680$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $77f9f80a0cede680$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $77f9f80a0cede680$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $77f9f80a0cede680$var$decode_range(a1);
    return "$" + $77f9f80a0cede680$var$encode_col(s.s.c) + "$" + $77f9f80a0cede680$var$encode_row(s.s.r) + ":$" + $77f9f80a0cede680$var$encode_col(s.e.c) + "$" + $77f9f80a0cede680$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $77f9f80a0cede680$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $77f9f80a0cede680$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $77f9f80a0cede680$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $77f9f80a0cede680$var$SSF_format(cell.z, q ? $77f9f80a0cede680$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $77f9f80a0cede680$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $77f9f80a0cede680$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $77f9f80a0cede680$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $77f9f80a0cede680$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $77f9f80a0cede680$var$safe_format_cell(cell, cell.v);
    return $77f9f80a0cede680$var$safe_format_cell(cell, v);
}
function $77f9f80a0cede680$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $77f9f80a0cede680$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $77f9f80a0cede680$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($77f9f80a0cede680$var$DENSE != null && dense == null) dense = $77f9f80a0cede680$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? {
        "!data": []
    } : {} /*:any*/ );
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $77f9f80a0cede680$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R;
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        var data_R = data[R];
        for(var C = 0; C != data_R.length; ++C){
            if (typeof data_R[C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data_R[C],
                t: ""
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data_R[C] && typeof data_R[C] === 'object' && !Array.isArray(data_R[C]) && !(data_R[C] instanceof Date)) cell = data_R[C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data_R[C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') {
                    if (isFinite(cell.v)) cell.t = 'n';
                    else if (isNaN(cell.v)) {
                        cell.t = 'e';
                        cell.v = 0x0F; /* #VALUE! */ 
                    } else {
                        cell.t = 'e';
                        cell.v = 0x07; /*# DIV/0 */ 
                    }
                } else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $77f9f80a0cede680$var$table_fmt[14];
                    if (!o.UTC) cell.v = $77f9f80a0cede680$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $77f9f80a0cede680$var$SSF_format(cell.z, $77f9f80a0cede680$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $77f9f80a0cede680$var$datenum(cell.v, o.date1904);
                        cell.w = $77f9f80a0cede680$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $77f9f80a0cede680$var$encode_col(__C) + (__R + 1 /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
    return ws;
}
function $77f9f80a0cede680$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $77f9f80a0cede680$var$sheet_add_aoa(null, data, opts);
}
function $77f9f80a0cede680$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $77f9f80a0cede680$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $77f9f80a0cede680$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $77f9f80a0cede680$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $77f9f80a0cede680$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $77f9f80a0cede680$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $77f9f80a0cede680$var$write_StrRun(run, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $77f9f80a0cede680$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $77f9f80a0cede680$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($77f9f80a0cede680$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $77f9f80a0cede680$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $77f9f80a0cede680$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $77f9f80a0cede680$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $77f9f80a0cede680$var$parse_BrtCommentText = $77f9f80a0cede680$var$parse_RichStr;
function $77f9f80a0cede680$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $77f9f80a0cede680$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $77f9f80a0cede680$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $77f9f80a0cede680$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $77f9f80a0cede680$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $77f9f80a0cede680$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $77f9f80a0cede680$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $77f9f80a0cede680$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $77f9f80a0cede680$var$parse_XLSBCodeName = $77f9f80a0cede680$var$parse_XLWideString;
var $77f9f80a0cede680$var$write_XLSBCodeName = $77f9f80a0cede680$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $77f9f80a0cede680$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $77f9f80a0cede680$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $77f9f80a0cede680$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $77f9f80a0cede680$var$parse_XLNameWideString = $77f9f80a0cede680$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $77f9f80a0cede680$var$parse_RelID = $77f9f80a0cede680$var$parse_XLNullableWideString;
var $77f9f80a0cede680$var$write_RelID = $77f9f80a0cede680$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $77f9f80a0cede680$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $77f9f80a0cede680$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $77f9f80a0cede680$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $77f9f80a0cede680$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $77f9f80a0cede680$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $77f9f80a0cede680$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $77f9f80a0cede680$var$parse_UncheckedRfX = $77f9f80a0cede680$var$parse_RfX;
var $77f9f80a0cede680$var$write_UncheckedRfX = $77f9f80a0cede680$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $77f9f80a0cede680$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $77f9f80a0cede680$var$write_Xnum(data, o) {
    return (o || $77f9f80a0cede680$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $77f9f80a0cede680$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $77f9f80a0cede680$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $77f9f80a0cede680$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $77f9f80a0cede680$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $77f9f80a0cede680$var$write_BrtColor(color, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $77f9f80a0cede680$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $77f9f80a0cede680$var$write_FontFlags(font, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $77f9f80a0cede680$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $77f9f80a0cede680$var$parse_ClipboardFormatOrAnsiString(o) {
    return $77f9f80a0cede680$var$parse_ClipboardFormatOrString(o, 1);
}
function $77f9f80a0cede680$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $77f9f80a0cede680$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $77f9f80a0cede680$var$VT_I2 = 0x0002;
var $77f9f80a0cede680$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $77f9f80a0cede680$var$VT_BOOL = 0x000B;
var $77f9f80a0cede680$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $77f9f80a0cede680$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $77f9f80a0cede680$var$VT_FILETIME = 0x0040;
var $77f9f80a0cede680$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $77f9f80a0cede680$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $77f9f80a0cede680$var$VT_VECTOR_VARIANT = 0x100C;
var $77f9f80a0cede680$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $77f9f80a0cede680$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $77f9f80a0cede680$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $77f9f80a0cede680$var$VT_CUSTOM = [
    $77f9f80a0cede680$var$VT_STRING,
    $77f9f80a0cede680$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $77f9f80a0cede680$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $77f9f80a0cede680$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $77f9f80a0cede680$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $77f9f80a0cede680$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $77f9f80a0cede680$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $77f9f80a0cede680$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $77f9f80a0cede680$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $77f9f80a0cede680$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $77f9f80a0cede680$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $77f9f80a0cede680$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $77f9f80a0cede680$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $77f9f80a0cede680$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $77f9f80a0cede680$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $77f9f80a0cede680$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $77f9f80a0cede680$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $77f9f80a0cede680$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $77f9f80a0cede680$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $77f9f80a0cede680$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $77f9f80a0cede680$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $77f9f80a0cede680$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $77f9f80a0cede680$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $77f9f80a0cede680$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $77f9f80a0cede680$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $77f9f80a0cede680$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $77f9f80a0cede680$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $77f9f80a0cede680$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $77f9f80a0cede680$var$_XLSIcv = /*#__PURE__*/ $77f9f80a0cede680$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $77f9f80a0cede680$var$XLSIcv = /*#__PURE__*/ $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $77f9f80a0cede680$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $77f9f80a0cede680$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $77f9f80a0cede680$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $77f9f80a0cede680$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $77f9f80a0cede680$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $77f9f80a0cede680$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $77f9f80a0cede680$var$parse_ct(data /*:?string*/ ) {
    var ct = $77f9f80a0cede680$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch(y[0].replace($77f9f80a0cede680$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$77f9f80a0cede680$var$ct2type[y.ContentType]] !== undefined) ct[$77f9f80a0cede680$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $77f9f80a0cede680$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $77f9f80a0cede680$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $77f9f80a0cede680$var$evert_arr($77f9f80a0cede680$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $77f9f80a0cede680$var$XML_HEADER;
        o[o.length] = $77f9f80a0cede680$var$writextag('Types', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS.CT,
            'xmlns:xsd': $77f9f80a0cede680$var$XMLNS.xsd,
            'xmlns:xsi': $77f9f80a0cede680$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $77f9f80a0cede680$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $77f9f80a0cede680$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $77f9f80a0cede680$var$CT_LIST[w][opts.bookType] || $77f9f80a0cede680$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $77f9f80a0cede680$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $77f9f80a0cede680$var$CT_LIST[w][opts.bookType] || $77f9f80a0cede680$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $77f9f80a0cede680$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $77f9f80a0cede680$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $77f9f80a0cede680$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $77f9f80a0cede680$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $77f9f80a0cede680$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $77f9f80a0cede680$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $77f9f80a0cede680$var$write_rels(rels) /*:string*/ {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $77f9f80a0cede680$var$XMLNS.RELS
        })
    ];
    $77f9f80a0cede680$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $77f9f80a0cede680$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $77f9f80a0cede680$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $77f9f80a0cede680$var$RELS.HLINK,
        $77f9f80a0cede680$var$RELS.XPATH,
        $77f9f80a0cede680$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $77f9f80a0cede680$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $77f9f80a0cede680$var$parse_manifest(d, opts) {
    var str = $77f9f80a0cede680$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $77f9f80a0cede680$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $77f9f80a0cede680$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $77f9f80a0cede680$var$write_manifest(manifest) {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $77f9f80a0cede680$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $77f9f80a0cede680$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $77f9f80a0cede680$var$write_rdf(rdf) {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($77f9f80a0cede680$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($77f9f80a0cede680$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($77f9f80a0cede680$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $77f9f80a0cede680$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $77f9f80a0cede680$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $77f9f80a0cede680$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $77f9f80a0cede680$var$parse_core_props(data) {
    var p = {};
    data = $77f9f80a0cede680$var$utf8read(data);
    for(var i = 0; i < $77f9f80a0cede680$var$CORE_PROPS.length; ++i){
        var f = $77f9f80a0cede680$var$CORE_PROPS[i], cur = $77f9f80a0cede680$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $77f9f80a0cede680$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $77f9f80a0cede680$var$parseDate(p[f[1]]);
    }
    return p;
}
function $77f9f80a0cede680$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $77f9f80a0cede680$var$escapexml(g);
    o[o.length] = h ? $77f9f80a0cede680$var$writextag(f, g, h) : $77f9f80a0cede680$var$writetag(f, g);
}
function $77f9f80a0cede680$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $77f9f80a0cede680$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $77f9f80a0cede680$var$XMLNS.dc,
            'xmlns:dcterms': $77f9f80a0cede680$var$XMLNS.dcterms,
            'xmlns:dcmitype': $77f9f80a0cede680$var$XMLNS.dcmitype,
            'xmlns:xsi': $77f9f80a0cede680$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $77f9f80a0cede680$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $77f9f80a0cede680$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $77f9f80a0cede680$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $77f9f80a0cede680$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $77f9f80a0cede680$var$CORE_PROPS.length; ++i){
        var f = $77f9f80a0cede680$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $77f9f80a0cede680$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $77f9f80a0cede680$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $77f9f80a0cede680$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $77f9f80a0cede680$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $77f9f80a0cede680$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $77f9f80a0cede680$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $77f9f80a0cede680$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $77f9f80a0cede680$var$utf8read(data);
    $77f9f80a0cede680$var$EXT_PROPS.forEach(function(f) {
        var xml = ($77f9f80a0cede680$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $77f9f80a0cede680$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $77f9f80a0cede680$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $77f9f80a0cede680$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $77f9f80a0cede680$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $77f9f80a0cede680$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $77f9f80a0cede680$var$XML_HEADER;
    o[o.length] = $77f9f80a0cede680$var$writextag('Properties', null, {
        'xmlns': $77f9f80a0cede680$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $77f9f80a0cede680$var$XMLNS.vt
    });
    $77f9f80a0cede680$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $77f9f80a0cede680$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $77f9f80a0cede680$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $77f9f80a0cede680$var$custregex = /<[^<>]+>[^<]*/g;
function $77f9f80a0cede680$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($77f9f80a0cede680$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $77f9f80a0cede680$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $77f9f80a0cede680$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $77f9f80a0cede680$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $77f9f80a0cede680$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $77f9f80a0cede680$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $77f9f80a0cede680$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('Properties', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $77f9f80a0cede680$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $77f9f80a0cede680$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $77f9f80a0cede680$var$writextag('property', $77f9f80a0cede680$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $77f9f80a0cede680$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $77f9f80a0cede680$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $77f9f80a0cede680$var$evert_XLMLDPM;
function $77f9f80a0cede680$var$xlml_set_prop(Props, tag /*:string*/ , val1) {
    if (!$77f9f80a0cede680$var$evert_XLMLDPM) $77f9f80a0cede680$var$evert_XLMLDPM = $77f9f80a0cede680$var$evert($77f9f80a0cede680$var$XLMLDocPropsMap);
    tag = $77f9f80a0cede680$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val1;
}
function $77f9f80a0cede680$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $77f9f80a0cede680$var$keys($77f9f80a0cede680$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $77f9f80a0cede680$var$CORE_PROPS.length; ++i)if ($77f9f80a0cede680$var$CORE_PROPS[i][1] == m) return $77f9f80a0cede680$var$CORE_PROPS[i];
        for(i = 0; i < $77f9f80a0cede680$var$EXT_PROPS.length; ++i)if ($77f9f80a0cede680$var$EXT_PROPS[i][1] == m) return $77f9f80a0cede680$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($77f9f80a0cede680$var$writetag($77f9f80a0cede680$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $77f9f80a0cede680$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $77f9f80a0cede680$var$XLMLNS.o
    });
}
function $77f9f80a0cede680$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $77f9f80a0cede680$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $77f9f80a0cede680$var$CORE_PROPS.length; ++i)if (k == $77f9f80a0cede680$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $77f9f80a0cede680$var$EXT_PROPS.length; ++i)if (k == $77f9f80a0cede680$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($77f9f80a0cede680$var$writextag($77f9f80a0cede680$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $77f9f80a0cede680$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($77f9f80a0cede680$var$writextag($77f9f80a0cede680$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $77f9f80a0cede680$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $77f9f80a0cede680$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $77f9f80a0cede680$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $77f9f80a0cede680$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $77f9f80a0cede680$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $77f9f80a0cede680$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $77f9f80a0cede680$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $77f9f80a0cede680$var$parse_lpwstr(blob);
    return $77f9f80a0cede680$var$parse_lpstr(blob, stringType, pad);
}
function $77f9f80a0cede680$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $77f9f80a0cede680$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $77f9f80a0cede680$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $77f9f80a0cede680$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $77f9f80a0cede680$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($77f9f80a0cede680$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $77f9f80a0cede680$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($77f9f80a0cede680$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $77f9f80a0cede680$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $77f9f80a0cede680$var$parse_TypedPropertyValue(blob, $77f9f80a0cede680$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $77f9f80a0cede680$var$parse_TypedPropertyValue(blob, $77f9f80a0cede680$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $77f9f80a0cede680$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($77f9f80a0cede680$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $77f9f80a0cede680$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($77f9f80a0cede680$var$chr0, '').replace($77f9f80a0cede680$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $77f9f80a0cede680$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $77f9f80a0cede680$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $77f9f80a0cede680$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $77f9f80a0cede680$var$VT_VARIANT) {
        if (t !== type && $77f9f80a0cede680$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $77f9f80a0cede680$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            blob.l += 4;
            val = $77f9f80a0cede680$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x1F /*VT_LPWSTR*/ :
            blob.l += 4;
            val = $77f9f80a0cede680$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x40 /*VT_FILETIME*/ :
            return $77f9f80a0cede680$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $77f9f80a0cede680$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $77f9f80a0cede680$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $77f9f80a0cede680$var$parse_VtString(blob, t, !opts.raw).replace($77f9f80a0cede680$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $77f9f80a0cede680$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($77f9f80a0cede680$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $77f9f80a0cede680$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $77f9f80a0cede680$var$parse_VtVecLpwstrValue(blob) : $77f9f80a0cede680$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $77f9f80a0cede680$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $77f9f80a0cede680$var$new_buf(4), p = $77f9f80a0cede680$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $77f9f80a0cede680$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $77f9f80a0cede680$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $77f9f80a0cede680$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $77f9f80a0cede680$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $77f9f80a0cede680$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $77f9f80a0cede680$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $77f9f80a0cede680$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $77f9f80a0cede680$var$parse_TypedPropertyValue(blob, $77f9f80a0cede680$var$VT_I2);
                $77f9f80a0cede680$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $77f9f80a0cede680$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $77f9f80a0cede680$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val1;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val1 = $77f9f80a0cede680$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val1 = $77f9f80a0cede680$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val1 = $77f9f80a0cede680$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val1 = $77f9f80a0cede680$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val1 = $77f9f80a0cede680$var$parseDate($77f9f80a0cede680$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val1;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $77f9f80a0cede680$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $77f9f80a0cede680$var$guess_property_type(val1 /*:any*/ ) /*:number*/ {
    switch(typeof val1){
        case "boolean":
            return 0x0B;
        case "number":
            return (val1 | 0) == val1 ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val1 instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $77f9f80a0cede680$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $77f9f80a0cede680$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $77f9f80a0cede680$var$new_buf(8), pio = $77f9f80a0cede680$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $77f9f80a0cede680$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $77f9f80a0cede680$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $77f9f80a0cede680$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $77f9f80a0cede680$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($77f9f80a0cede680$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $77f9f80a0cede680$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val1 = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val1 == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val1.split(".");
                val1 = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $77f9f80a0cede680$var$write_TypedPropertyValue(pinfo.t, val1);
        } else {
            var T = $77f9f80a0cede680$var$guess_property_type(val1);
            if (T == -1) {
                T = 0x1F;
                val1 = String(val1);
            }
            pr = $77f9f80a0cede680$var$write_TypedPropertyValue(T, val1);
        }
        prop.push(pr);
        pio = $77f9f80a0cede680$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $77f9f80a0cede680$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $77f9f80a0cede680$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $77f9f80a0cede680$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $77f9f80a0cede680$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $77f9f80a0cede680$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $77f9f80a0cede680$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $77f9f80a0cede680$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $77f9f80a0cede680$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $77f9f80a0cede680$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $77f9f80a0cede680$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $77f9f80a0cede680$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $77f9f80a0cede680$var$bconcat(bufs);
}
function $77f9f80a0cede680$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $77f9f80a0cede680$var$writezeroes(n, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $77f9f80a0cede680$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $77f9f80a0cede680$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $77f9f80a0cede680$var$writebool(v /*:any*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $77f9f80a0cede680$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $77f9f80a0cede680$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $77f9f80a0cede680$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $77f9f80a0cede680$var$parslurp(blob, length, $77f9f80a0cede680$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $77f9f80a0cede680$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $77f9f80a0cede680$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $77f9f80a0cede680$var$current_codepage;
    if (opts && opts.biff >= 8) $77f9f80a0cede680$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $77f9f80a0cede680$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $77f9f80a0cede680$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $77f9f80a0cede680$var$current_codepage;
    $77f9f80a0cede680$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $77f9f80a0cede680$var$current_codepage = cp;
    return z;
}
function $77f9f80a0cede680$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $77f9f80a0cede680$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $77f9f80a0cede680$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $77f9f80a0cede680$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $77f9f80a0cede680$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $77f9f80a0cede680$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $77f9f80a0cede680$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $77f9f80a0cede680$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $77f9f80a0cede680$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($77f9f80a0cede680$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $77f9f80a0cede680$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($77f9f80a0cede680$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $77f9f80a0cede680$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $77f9f80a0cede680$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $77f9f80a0cede680$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $77f9f80a0cede680$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($77f9f80a0cede680$var$chr0, "") : "";
    return o;
}
function $77f9f80a0cede680$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $77f9f80a0cede680$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $77f9f80a0cede680$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $77f9f80a0cede680$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $77f9f80a0cede680$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $77f9f80a0cede680$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $77f9f80a0cede680$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $77f9f80a0cede680$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $77f9f80a0cede680$var$write_Hyperlink(hl) {
    var out = $77f9f80a0cede680$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $77f9f80a0cede680$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $77f9f80a0cede680$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $77f9f80a0cede680$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $77f9f80a0cede680$var$parse_LongRGB(blob, length) {
    var x = $77f9f80a0cede680$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $77f9f80a0cede680$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $77f9f80a0cede680$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $77f9f80a0cede680$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $77f9f80a0cede680$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $77f9f80a0cede680$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $77f9f80a0cede680$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $77f9f80a0cede680$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $77f9f80a0cede680$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $77f9f80a0cede680$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $77f9f80a0cede680$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $77f9f80a0cede680$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $77f9f80a0cede680$var$parse_Ref = $77f9f80a0cede680$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $77f9f80a0cede680$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $77f9f80a0cede680$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $77f9f80a0cede680$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $77f9f80a0cede680$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $77f9f80a0cede680$var$FtTab = {
    0x00: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtEnd */ 0x04: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtMacro */ 0x05: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtButton */ 0x06: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtGmo */ 0x07: $77f9f80a0cede680$var$parse_FtCf,
    /* FtCf */ 0x08: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $77f9f80a0cede680$var$parse_FtNts,
    /* FtNts */ 0x0E: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtGboData */ 0x10: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtRboData */ 0x12: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $77f9f80a0cede680$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $77f9f80a0cede680$var$parse_FtCmo
};
function $77f9f80a0cede680$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $77f9f80a0cede680$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $77f9f80a0cede680$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $77f9f80a0cede680$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $77f9f80a0cede680$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $77f9f80a0cede680$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $77f9f80a0cede680$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $77f9f80a0cede680$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $77f9f80a0cede680$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $77f9f80a0cede680$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $77f9f80a0cede680$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $77f9f80a0cede680$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $77f9f80a0cede680$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $77f9f80a0cede680$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($77f9f80a0cede680$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $77f9f80a0cede680$var$write_SST(sst, opts) {
    var header = $77f9f80a0cede680$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $77f9f80a0cede680$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $77f9f80a0cede680$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $77f9f80a0cede680$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $77f9f80a0cede680$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $77f9f80a0cede680$var$parse_ForceFullCalculation(blob) {
    var header = $77f9f80a0cede680$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $77f9f80a0cede680$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $77f9f80a0cede680$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $77f9f80a0cede680$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $77f9f80a0cede680$var$write_Window1() {
    var o = $77f9f80a0cede680$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $77f9f80a0cede680$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $77f9f80a0cede680$var$write_Window2(view) {
    var o = $77f9f80a0cede680$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $77f9f80a0cede680$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $77f9f80a0cede680$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $77f9f80a0cede680$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $77f9f80a0cede680$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $77f9f80a0cede680$var$parse_LabelSst(blob, length, opts) {
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $77f9f80a0cede680$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(10);
    $77f9f80a0cede680$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $77f9f80a0cede680$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, length, opts);
    var str = $77f9f80a0cede680$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $77f9f80a0cede680$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $77f9f80a0cede680$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $77f9f80a0cede680$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $77f9f80a0cede680$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $77f9f80a0cede680$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $77f9f80a0cede680$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $77f9f80a0cede680$var$parse_BIFF2Format = $77f9f80a0cede680$var$parse_XLUnicodeString2;
function $77f9f80a0cede680$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $77f9f80a0cede680$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $77f9f80a0cede680$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $77f9f80a0cede680$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $77f9f80a0cede680$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $77f9f80a0cede680$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $77f9f80a0cede680$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $77f9f80a0cede680$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($77f9f80a0cede680$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $77f9f80a0cede680$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $77f9f80a0cede680$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $77f9f80a0cede680$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $77f9f80a0cede680$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $77f9f80a0cede680$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $77f9f80a0cede680$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $77f9f80a0cede680$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $77f9f80a0cede680$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $77f9f80a0cede680$var$write_BIFF2XF(xf) {
    var o = $77f9f80a0cede680$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $77f9f80a0cede680$var$write_BIFF3XF(xf) {
    var o = $77f9f80a0cede680$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $77f9f80a0cede680$var$write_BIFF4XF = $77f9f80a0cede680$var$write_BIFF3XF;
function $77f9f80a0cede680$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $77f9f80a0cede680$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $77f9f80a0cede680$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $77f9f80a0cede680$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $77f9f80a0cede680$var$parse_BoolErr(blob, length, opts) {
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 6, opts);
    var val1 = $77f9f80a0cede680$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
function $77f9f80a0cede680$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(8);
    $77f9f80a0cede680$var$write_XLSCell(R, C, os, o);
    $77f9f80a0cede680$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $77f9f80a0cede680$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 6, opts);
    var xnum = $77f9f80a0cede680$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $77f9f80a0cede680$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(14);
    $77f9f80a0cede680$var$write_XLSCell(R, C, os, o);
    $77f9f80a0cede680$var$write_Xnum(v, o);
    return o;
}
var $77f9f80a0cede680$var$parse_XLHeaderFooter = $77f9f80a0cede680$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $77f9f80a0cede680$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($77f9f80a0cede680$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $77f9f80a0cede680$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $77f9f80a0cede680$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $77f9f80a0cede680$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $77f9f80a0cede680$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $77f9f80a0cede680$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $77f9f80a0cede680$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $77f9f80a0cede680$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $77f9f80a0cede680$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($77f9f80a0cede680$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $77f9f80a0cede680$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $77f9f80a0cede680$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $77f9f80a0cede680$var$parse_ShrFmla(blob, length, opts) {
    var ref = $77f9f80a0cede680$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $77f9f80a0cede680$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $77f9f80a0cede680$var$parse_Array(blob, length, opts) {
    var ref = $77f9f80a0cede680$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $77f9f80a0cede680$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $77f9f80a0cede680$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $77f9f80a0cede680$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $77f9f80a0cede680$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $77f9f80a0cede680$var$parse_NoteSh(blob, length, opts);
}
function $77f9f80a0cede680$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $77f9f80a0cede680$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($77f9f80a0cede680$var$parse_Ref8U(blob, length));
    return merges;
}
function $77f9f80a0cede680$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $77f9f80a0cede680$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$77f9f80a0cede680$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $77f9f80a0cede680$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $77f9f80a0cede680$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $77f9f80a0cede680$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $77f9f80a0cede680$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $77f9f80a0cede680$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $77f9f80a0cede680$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($77f9f80a0cede680$var$parse_BIFF5OT[ot] || $77f9f80a0cede680$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $77f9f80a0cede680$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $77f9f80a0cede680$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $77f9f80a0cede680$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $77f9f80a0cede680$var$parse_HLink(blob, length) {
    var ref = $77f9f80a0cede680$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $77f9f80a0cede680$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $77f9f80a0cede680$var$write_HLink(hl) {
    var O = $77f9f80a0cede680$var$new_buf(24);
    var ref = $77f9f80a0cede680$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $77f9f80a0cede680$var$bconcat([
        O,
        $77f9f80a0cede680$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $77f9f80a0cede680$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $77f9f80a0cede680$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($77f9f80a0cede680$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $77f9f80a0cede680$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $77f9f80a0cede680$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $77f9f80a0cede680$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $77f9f80a0cede680$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $77f9f80a0cede680$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $77f9f80a0cede680$var$CountryEnum[d] || d;
    return o;
}
function $77f9f80a0cede680$var$write_Country(o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $77f9f80a0cede680$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($77f9f80a0cede680$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $77f9f80a0cede680$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($77f9f80a0cede680$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $77f9f80a0cede680$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $77f9f80a0cede680$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $77f9f80a0cede680$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $77f9f80a0cede680$var$write_ColInfo(col, idx) {
    var o = $77f9f80a0cede680$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $77f9f80a0cede680$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $77f9f80a0cede680$var$parse_Xnum(blob, 8);
    o.footer = $77f9f80a0cede680$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $77f9f80a0cede680$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $77f9f80a0cede680$var$write_RRTabId(n /*:number*/ ) {
    var out = $77f9f80a0cede680$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $77f9f80a0cede680$var$parse_Blank = $77f9f80a0cede680$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $77f9f80a0cede680$var$parse_Scl = $77f9f80a0cede680$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $77f9f80a0cede680$var$parse_String = $77f9f80a0cede680$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $77f9f80a0cede680$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $77f9f80a0cede680$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $77f9f80a0cede680$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $77f9f80a0cede680$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 7, opts);
    var str = $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $77f9f80a0cede680$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 7, opts);
    var num = $77f9f80a0cede680$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $77f9f80a0cede680$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe, ifmt) {
    var out = $77f9f80a0cede680$var$new_buf(15);
    $77f9f80a0cede680$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val1, 'f');
    return out;
}
function $77f9f80a0cede680$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $77f9f80a0cede680$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $77f9f80a0cede680$var$new_buf(9);
    $77f9f80a0cede680$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val1);
    return out;
}
function $77f9f80a0cede680$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $77f9f80a0cede680$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val1 = $77f9f80a0cede680$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $77f9f80a0cede680$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $77f9f80a0cede680$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $77f9f80a0cede680$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $77f9f80a0cede680$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $77f9f80a0cede680$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $77f9f80a0cede680$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $77f9f80a0cede680$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $77f9f80a0cede680$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $77f9f80a0cede680$var$s2a($77f9f80a0cede680$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $77f9f80a0cede680$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $77f9f80a0cede680$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $77f9f80a0cede680$var$$cptable !== "undefined" ? $77f9f80a0cede680$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $77f9f80a0cede680$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $77f9f80a0cede680$var$prep_blob(dd, 0);
                var s = typeof $77f9f80a0cede680$var$$cptable !== "undefined" ? $77f9f80a0cede680$var$$cptable.utils.decode(current_cp, dd) : $77f9f80a0cede680$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $77f9f80a0cede680$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $77f9f80a0cede680$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $77f9f80a0cede680$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $77f9f80a0cede680$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $77f9f80a0cede680$var$current_codepage;
        if (+o.codepage >= 0) $77f9f80a0cede680$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $77f9f80a0cede680$var$buf_array();
        var aoa /*:AOA*/  = $77f9f80a0cede680$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $77f9f80a0cede680$var$$cptable !== "undefined" && typeof col[j] == "string" ? $77f9f80a0cede680$var$$cptable.utils.encode($77f9f80a0cede680$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $77f9f80a0cede680$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $77f9f80a0cede680$var$current_codepage + ", using 1252");
            $77f9f80a0cede680$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $77f9f80a0cede680$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $77f9f80a0cede680$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $77f9f80a0cede680$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $77f9f80a0cede680$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $77f9f80a0cede680$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $77f9f80a0cede680$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($77f9f80a0cede680$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(d) ? d.toString('binary') : $77f9f80a0cede680$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($77f9f80a0cede680$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $77f9f80a0cede680$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val1;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $77f9f80a0cede680$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val1 = record[rj].slice(1);
                            if (val1.charAt(0) === '"') {
                                val1 = val1.slice(1, val1.length - 1);
                                cell_t = "s";
                            } else if (val1 === 'TRUE' || val1 === 'FALSE') {
                                val1 = val1 === 'TRUE';
                                cell_t = "b";
                            } else if (val1.charAt(0) == "#" && $77f9f80a0cede680$var$RBErr[val1] != null) {
                                cell_t = "e";
                                val1 = $77f9f80a0cede680$var$RBErr[val1];
                            } else if (!isNaN($77f9f80a0cede680$var$fuzzynum(val1))) {
                                val1 = $77f9f80a0cede680$var$fuzzynum(val1);
                                cell_t = "n";
                                if (next_cell_format !== null && $77f9f80a0cede680$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val1 = $77f9f80a0cede680$var$numdate(wb.Workbook.WBProps.date1904 ? val1 + 1462 : val1);
                                    cell_t = typeof val1 == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined' && typeof val1 == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val1 = $77f9f80a0cede680$var$$cptable.utils.decode(opts.codepage, val1);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $77f9f80a0cede680$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val1
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val1;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $77f9f80a0cede680$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $77f9f80a0cede680$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $77f9f80a0cede680$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $77f9f80a0cede680$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $77f9f80a0cede680$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $77f9f80a0cede680$var$aoa_to_sheet(aoa, _opts);
        $77f9f80a0cede680$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $77f9f80a0cede680$var$sheet_to_workbook(o, opts);
        $77f9f80a0cede680$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += isFinite(cell.v) ? cell.v || 0 : $77f9f80a0cede680$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                if (cell.f && !cell.F) o += ";E" + $77f9f80a0cede680$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $77f9f80a0cede680$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $77f9f80a0cede680$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $77f9f80a0cede680$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $77f9f80a0cede680$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $77f9f80a0cede680$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $77f9f80a0cede680$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $77f9f80a0cede680$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($77f9f80a0cede680$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(d) ? d.toString('binary') : $77f9f80a0cede680$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($77f9f80a0cede680$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($77f9f80a0cede680$var$fuzzynum(value))) arr[R][C] = $77f9f80a0cede680$var$fuzzynum(value);
                    else if (!isNaN($77f9f80a0cede680$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $77f9f80a0cede680$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $77f9f80a0cede680$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($77f9f80a0cede680$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $77f9f80a0cede680$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $77f9f80a0cede680$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $77f9f80a0cede680$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$77f9f80a0cede680$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $77f9f80a0cede680$var$SSF_format(cell.z || $77f9f80a0cede680$var$table_fmt[14], $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $77f9f80a0cede680$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $77f9f80a0cede680$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = record[record.length - 1].charAt(0) == "#" ? {
                                t: "e",
                                v: $77f9f80a0cede680$var$RBErr[record[record.length - 1]]
                            } : +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $77f9f80a0cede680$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $77f9f80a0cede680$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $77f9f80a0cede680$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $77f9f80a0cede680$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                    oo.push(encode(cell.v));
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $77f9f80a0cede680$var$SSF_format(cell.z || $77f9f80a0cede680$var$table_fmt[14], t);
                    break;
                case 'n':
                    if (isFinite(cell.v)) {
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                    } else {
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = "e" + $77f9f80a0cede680$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                        oo[4] = "0";
                        oo[5] = cell.f || oo[3].slice(1);
                        oo[6] = "e";
                        oo[7] = oo[3].slice(1);
                    }
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $77f9f80a0cede680$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($77f9f80a0cede680$var$fuzzynum(data))) arr[R][C] = $77f9f80a0cede680$var$fuzzynum(data);
        else if (!isNaN($77f9f80a0cede680$var$fuzzydate(data).getDate())) arr[R][C] = $77f9f80a0cede680$var$parseDate(data);
        else if (data.charCodeAt(0) == 35 /* # */  && $77f9f80a0cede680$var$RBErr[data] != null) arr[R][C] = {
            t: 'e',
            v: $77f9f80a0cede680$var$RBErr[data],
            w: data
        };
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($77f9f80a0cede680$var$DENSE != null && o.dense == null) o.dense = $77f9f80a0cede680$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $77f9f80a0cede680$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($77f9f80a0cede680$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $77f9f80a0cede680$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $77f9f80a0cede680$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $77f9f80a0cede680$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $77f9f80a0cede680$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $77f9f80a0cede680$var$parseDate(news);
                    if (o && o.UTC === false) v = $77f9f80a0cede680$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $77f9f80a0cede680$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $77f9f80a0cede680$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $77f9f80a0cede680$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else if (s.charCodeAt(0) == 35 /* # */  && $77f9f80a0cede680$var$RBErr[s] != null) {
                cell.t = 'e';
                cell.w = s;
                cell.v = $77f9f80a0cede680$var$RBErr[s];
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$77f9f80a0cede680$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $77f9f80a0cede680$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $77f9f80a0cede680$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $77f9f80a0cede680$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $77f9f80a0cede680$var$$cptable !== 'undefined') str = $77f9f80a0cede680$var$$cptable.utils.decode(opts.codepage, d);
                else str = $77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(d) ? d.toString('binary') : $77f9f80a0cede680$var$a2s(d);
                break;
            case 'array':
                str = $77f9f80a0cede680$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $77f9f80a0cede680$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $77f9f80a0cede680$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $77f9f80a0cede680$var$$cptable !== 'undefined' && opts.codepage) str = $77f9f80a0cede680$var$$cptable.utils.decode(opts.codepage, $77f9f80a0cede680$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $77f9f80a0cede680$var$ETH.to_sheet(opts.type == 'string' ? str : $77f9f80a0cede680$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $77f9f80a0cede680$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $77f9f80a0cede680$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($77f9f80a0cede680$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $77f9f80a0cede680$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $77f9f80a0cede680$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $77f9f80a0cede680$var$PRN.to_workbook(d, opts);
    }
}
var $77f9f80a0cede680$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $77f9f80a0cede680$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($77f9f80a0cede680$var$s2a($77f9f80a0cede680$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($77f9f80a0cede680$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($77f9f80a0cede680$var$DENSE != null && o.dense == null) o.dense = $77f9f80a0cede680$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val1;
                        if (val1 >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val1;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val1;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val1) next_n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val1;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        if (o.works || o.works2) val1[1].v = val1[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val1[2] & 0x70) == 0x70 && (val1[2] & 0x0F) > 1 && (val1[2] & 0x0F) < 15) {
                            val1[1].z = o.dateNF || LOTUS_DATE_FMTS[(val1[2] & 0x0F) - 1] || $77f9f80a0cede680$var$table_fmt[14];
                            if (o.cellDates) {
                                val1[1].v = $77f9f80a0cede680$var$numdate(val1[1].v);
                                val1[1].t = typeof val1[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val1[3] > sidx) {
                                s["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val1[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val1[0].r] || [])[val1[0].c] : s[$77f9f80a0cede680$var$encode_cell(val1[0])];
                        if (tmpcell) {
                            tmpcell.t = val1[1].t;
                            tmpcell.v = val1[1].v;
                            if (val1[1].z != null) tmpcell.z = val1[1].z;
                            if (val1[1].f != null) tmpcell.f = val1[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$77f9f80a0cede680$var$encode_cell(val1[0])] = val1[1];
                        lastcell = val1[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val1 == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $77f9f80a0cede680$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val1[1].v = val1[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val1[3] > sidx) {
                            s["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val1[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val1[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$77f9f80a0cede680$var$encode_cell(val1[0])] = val1[1];
                        if (refguess.e.c < val1[0].c) refguess.e.c = val1[0].c;
                        if (refguess.e.r < val1[0].r) refguess.e.r = val1[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val1[0x36b0]) realnames[val1[0x36b0][0]] = val1[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val1[0]] = val1[1];
                        if (val1[0] == sidx) n = val1[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $77f9f80a0cede680$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $77f9f80a0cede680$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $77f9f80a0cede680$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $77f9f80a0cede680$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $77f9f80a0cede680$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $77f9f80a0cede680$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $77f9f80a0cede680$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $77f9f80a0cede680$var$table_fmt[14]
                        }));
                        else $77f9f80a0cede680$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $77f9f80a0cede680$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $77f9f80a0cede680$var$format_cell(cell);
                        $77f9f80a0cede680$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $77f9f80a0cede680$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $77f9f80a0cede680$var$buf_array();
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $77f9f80a0cede680$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $77f9f80a0cede680$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $77f9f80a0cede680$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $77f9f80a0cede680$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $77f9f80a0cede680$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $77f9f80a0cede680$var$format_cell(cell);
                        /* TODO: max len? */ $77f9f80a0cede680$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $77f9f80a0cede680$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $77f9f80a0cede680$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $77f9f80a0cede680$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $77f9f80a0cede680$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $77f9f80a0cede680$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $77f9f80a0cede680$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $77f9f80a0cede680$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $77f9f80a0cede680$var$encode_col(V) : $77f9f80a0cede680$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $77f9f80a0cede680$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $77f9f80a0cede680$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $77f9f80a0cede680$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $77f9f80a0cede680$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $77f9f80a0cede680$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $77f9f80a0cede680$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $77f9f80a0cede680$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $77f9f80a0cede680$var$prep_blob(d, 0);
        var o = opts || {};
        if ($77f9f80a0cede680$var$DENSE != null && o.dense == null) o.dense = $77f9f80a0cede680$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $77f9f80a0cede680$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $77f9f80a0cede680$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $77f9f80a0cede680$var$encode_range(range);
                    $77f9f80a0cede680$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $77f9f80a0cede680$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $77f9f80a0cede680$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $77f9f80a0cede680$var$dup(cell);
                            if (cell.t == "n" && cell.z && $77f9f80a0cede680$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $77f9f80a0cede680$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $77f9f80a0cede680$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $77f9f80a0cede680$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $77f9f80a0cede680$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($77f9f80a0cede680$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $77f9f80a0cede680$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $77f9f80a0cede680$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $77f9f80a0cede680$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $77f9f80a0cede680$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $77f9f80a0cede680$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $77f9f80a0cede680$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $77f9f80a0cede680$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $77f9f80a0cede680$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $77f9f80a0cede680$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $77f9f80a0cede680$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $77f9f80a0cede680$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $77f9f80a0cede680$var$utf8read(x);
        if (html) z.h = $77f9f80a0cede680$var$escapehtml(z.t);
    } else if (/*y = */ x.match($77f9f80a0cede680$var$sirregex)) {
        z.r = $77f9f80a0cede680$var$utf8read(x);
        z.t = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(($77f9f80a0cede680$var$str_remove_xml_ns_g(x, "rPh").match($77f9f80a0cede680$var$sitregex) || []).join("").replace($77f9f80a0cede680$var$tagregex, "")), true);
        if (html) z.h = $77f9f80a0cede680$var$rs_to_html($77f9f80a0cede680$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $77f9f80a0cede680$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $77f9f80a0cede680$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $77f9f80a0cede680$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $77f9f80a0cede680$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($77f9f80a0cede680$var$sstr1, "").split($77f9f80a0cede680$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $77f9f80a0cede680$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $77f9f80a0cede680$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $77f9f80a0cede680$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $77f9f80a0cede680$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $77f9f80a0cede680$var$XML_HEADER
    ];
    o[o.length] = $77f9f80a0cede680$var$writextag('sst', null, {
        xmlns: $77f9f80a0cede680$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($77f9f80a0cede680$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $77f9f80a0cede680$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $77f9f80a0cede680$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $77f9f80a0cede680$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $77f9f80a0cede680$var$recordhopper(data, function hopper_sst(val1, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val1[0];
                s.Unique = val1[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val1);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $77f9f80a0cede680$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $77f9f80a0cede680$var$write_BrtSSTItem = $77f9f80a0cede680$var$write_RichStr;
function $77f9f80a0cede680$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $77f9f80a0cede680$var$buf_array();
    $77f9f80a0cede680$var$write_record(ba, 0x009F /* BrtBeginSst */ , $77f9f80a0cede680$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$77f9f80a0cede680$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $77f9f80a0cede680$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $77f9f80a0cede680$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $77f9f80a0cede680$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined') return $77f9f80a0cede680$var$$cptable.utils.encode($77f9f80a0cede680$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $77f9f80a0cede680$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    o.U = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    o.W = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $77f9f80a0cede680$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $77f9f80a0cede680$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($77f9f80a0cede680$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $77f9f80a0cede680$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $77f9f80a0cede680$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    o.U = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    o.W = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $77f9f80a0cede680$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $77f9f80a0cede680$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $77f9f80a0cede680$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $77f9f80a0cede680$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $77f9f80a0cede680$var$parse_EncryptionInfo(blob) {
    var vers = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $77f9f80a0cede680$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $77f9f80a0cede680$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $77f9f80a0cede680$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $77f9f80a0cede680$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $77f9f80a0cede680$var$parse_EncryptionHeader(blob, sz);
    var verifier = $77f9f80a0cede680$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $77f9f80a0cede680$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $77f9f80a0cede680$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($77f9f80a0cede680$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $77f9f80a0cede680$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $77f9f80a0cede680$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $77f9f80a0cede680$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $77f9f80a0cede680$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $77f9f80a0cede680$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $77f9f80a0cede680$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $77f9f80a0cede680$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $77f9f80a0cede680$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $77f9f80a0cede680$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $77f9f80a0cede680$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $77f9f80a0cede680$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $77f9f80a0cede680$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $77f9f80a0cede680$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $77f9f80a0cede680$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $77f9f80a0cede680$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $77f9f80a0cede680$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $77f9f80a0cede680$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $77f9f80a0cede680$var$parseuint16(blob),
        verificationBytes: $77f9f80a0cede680$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $77f9f80a0cede680$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $77f9f80a0cede680$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $77f9f80a0cede680$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $77f9f80a0cede680$var$parse_RC4Header(blob, length);
    else o.Data = $77f9f80a0cede680$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $77f9f80a0cede680$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $77f9f80a0cede680$var$parse_FilePassHeader(blob, length - 2, o);
    else $77f9f80a0cede680$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $77f9f80a0cede680$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $77f9f80a0cede680$var$rtf_to_sheet_str($77f9f80a0cede680$var$Base64_decode(d), opts);
        case "binary":
            return $77f9f80a0cede680$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $77f9f80a0cede680$var$rtf_to_sheet_str($77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(d) ? d.toString("binary") : $77f9f80a0cede680$var$a2s(d), opts);
        case "array":
            return $77f9f80a0cede680$var$rtf_to_sheet_str($77f9f80a0cede680$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $77f9f80a0cede680$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $77f9f80a0cede680$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($77f9f80a0cede680$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $77f9f80a0cede680$var$fuzzynum(cell.v);
                        } else if ($77f9f80a0cede680$var$RBErr[cell.v] != null) {
                            cell.t = "e";
                            cell.w = cell.v;
                            cell.v = $77f9f80a0cede680$var$RBErr[cell.v];
                        }
                        if (dense) row[C] = cell;
                        else ws[$77f9f80a0cede680$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $77f9f80a0cede680$var$encode_range(range);
    return ws;
}
function $77f9f80a0cede680$var$rtf_to_workbook(d, opts) {
    var wb = $77f9f80a0cede680$var$sheet_to_workbook($77f9f80a0cede680$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $77f9f80a0cede680$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $77f9f80a0cede680$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $77f9f80a0cede680$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($77f9f80a0cede680$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $77f9f80a0cede680$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $77f9f80a0cede680$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $77f9f80a0cede680$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $77f9f80a0cede680$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $77f9f80a0cede680$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $77f9f80a0cede680$var$rgb2HSL($77f9f80a0cede680$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $77f9f80a0cede680$var$rgb2Hex($77f9f80a0cede680$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $77f9f80a0cede680$var$DEF_MDW = 6, $77f9f80a0cede680$var$MAX_MDW = 15, $77f9f80a0cede680$var$MIN_MDW = 1, $77f9f80a0cede680$var$MDW = $77f9f80a0cede680$var$DEF_MDW;
function $77f9f80a0cede680$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $77f9f80a0cede680$var$MDW) / 256) * $77f9f80a0cede680$var$MDW);
}
function $77f9f80a0cede680$var$px2char(px) {
    return Math.floor((px - 5) / $77f9f80a0cede680$var$MDW * 100 + 0.5) / 100;
}
function $77f9f80a0cede680$var$char2width(chr) {
    return Math.round((chr * $77f9f80a0cede680$var$MDW + 5) / $77f9f80a0cede680$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $77f9f80a0cede680$var$cycle_width(collw) {
    return $77f9f80a0cede680$var$char2width($77f9f80a0cede680$var$px2char($77f9f80a0cede680$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $77f9f80a0cede680$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $77f9f80a0cede680$var$cycle_width(collw)), _MDW = $77f9f80a0cede680$var$MDW;
    if (delta > 0.005) {
        for($77f9f80a0cede680$var$MDW = $77f9f80a0cede680$var$MIN_MDW; $77f9f80a0cede680$var$MDW < $77f9f80a0cede680$var$MAX_MDW; ++$77f9f80a0cede680$var$MDW)if (Math.abs(collw - $77f9f80a0cede680$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $77f9f80a0cede680$var$cycle_width(collw));
            _MDW = $77f9f80a0cede680$var$MDW;
        }
    }
    $77f9f80a0cede680$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $77f9f80a0cede680$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $77f9f80a0cede680$var$width2px(coll.width);
        coll.wch = $77f9f80a0cede680$var$px2char(coll.wpx);
        coll.MDW = $77f9f80a0cede680$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $77f9f80a0cede680$var$px2char(coll.wpx);
        coll.width = $77f9f80a0cede680$var$char2width(coll.wch);
        coll.MDW = $77f9f80a0cede680$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $77f9f80a0cede680$var$char2width(coll.wch);
        coll.wpx = $77f9f80a0cede680$var$width2px(coll.width);
        coll.MDW = $77f9f80a0cede680$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $77f9f80a0cede680$var$DEF_PPI = 96, $77f9f80a0cede680$var$PPI = $77f9f80a0cede680$var$DEF_PPI;
function $77f9f80a0cede680$var$px2pt(px) {
    return px * 96 / $77f9f80a0cede680$var$PPI;
}
function $77f9f80a0cede680$var$pt2px(pt) {
    return pt * $77f9f80a0cede680$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $77f9f80a0cede680$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $77f9f80a0cede680$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $77f9f80a0cede680$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $77f9f80a0cede680$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $77f9f80a0cede680$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $77f9f80a0cede680$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $77f9f80a0cede680$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            case '</b>':
            case '</b':
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            case '</i>':
            case '</i':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            case '</u>':
            case '</u':
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
            case '</strike':
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
            case '</outline':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
            case '</shadow':
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            case '</condense>':
            case '</condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $77f9f80a0cede680$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            case '</extend>':
            case '</extend':
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
            case '</sz':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
            case '</vertAlign':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
            case '</family':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
            case '</scheme':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $77f9f80a0cede680$var$CS2CP[parseInt(y.val, 10)];
                break;
            case '<charset/>':
            case '</charset>':
            case '</charset':
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $77f9f80a0cede680$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $77f9f80a0cede680$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $77f9f80a0cede680$var$XLSIcv[1];
                    if (!icv) icv = $77f9f80a0cede680$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $77f9f80a0cede680$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
            case '</color':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
            case '</AlternateContent':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $77f9f80a0cede680$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $77f9f80a0cede680$var$keys($77f9f80a0cede680$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $77f9f80a0cede680$var$table_fmt[k[i]];
    var m = t.match($77f9f80a0cede680$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $77f9f80a0cede680$var$parsexmltag(m[i]);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $77f9f80a0cede680$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $77f9f80a0cede680$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $77f9f80a0cede680$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $77f9f80a0cede680$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $77f9f80a0cede680$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $77f9f80a0cede680$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $77f9f80a0cede680$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $77f9f80a0cede680$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x), i = 0;
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $77f9f80a0cede680$var$cellXF_uint.length; ++i)if (xf[$77f9f80a0cede680$var$cellXF_uint[i]]) xf[$77f9f80a0cede680$var$cellXF_uint[i]] = parseInt(xf[$77f9f80a0cede680$var$cellXF_uint[i]], 10);
                for(i = 0; i < $77f9f80a0cede680$var$cellXF_bool.length; ++i)if (xf[$77f9f80a0cede680$var$cellXF_bool[i]]) xf[$77f9f80a0cede680$var$cellXF_bool[i]] = $77f9f80a0cede680$var$parsexmlbool(xf[$77f9f80a0cede680$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $77f9f80a0cede680$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $77f9f80a0cede680$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $77f9f80a0cede680$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $77f9f80a0cede680$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $77f9f80a0cede680$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $77f9f80a0cede680$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $77f9f80a0cede680$var$remove_doctype($77f9f80a0cede680$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $77f9f80a0cede680$var$str_match_xml_ns(data, "numFmts")) $77f9f80a0cede680$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $77f9f80a0cede680$var$str_match_xml_ns(data, "fonts")) $77f9f80a0cede680$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $77f9f80a0cede680$var$str_match_xml_ns(data, "fills")) $77f9f80a0cede680$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $77f9f80a0cede680$var$str_match_xml_ns(data, "borders")) $77f9f80a0cede680$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $77f9f80a0cede680$var$str_match_xml_ns(data, "cellXfs")) $77f9f80a0cede680$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $77f9f80a0cede680$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('styleSheet', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS_main[0],
            'xmlns:vt': $77f9f80a0cede680$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $77f9f80a0cede680$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $77f9f80a0cede680$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $77f9f80a0cede680$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $77f9f80a0cede680$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $77f9f80a0cede680$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $77f9f80a0cede680$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $77f9f80a0cede680$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $77f9f80a0cede680$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $77f9f80a0cede680$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $77f9f80a0cede680$var$parse_XLWideString(data, length - 21);
    return out;
}
function $77f9f80a0cede680$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $77f9f80a0cede680$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $77f9f80a0cede680$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $77f9f80a0cede680$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $77f9f80a0cede680$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $77f9f80a0cede680$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $77f9f80a0cede680$var$parse_BrtFill = $77f9f80a0cede680$var$parsenoop;
function $77f9f80a0cede680$var$write_BrtFill(fill, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(84);
    if (!$77f9f80a0cede680$var$rev_XLSBFillPTNames) $77f9f80a0cede680$var$rev_XLSBFillPTNames = $77f9f80a0cede680$var$evert($77f9f80a0cede680$var$XLSBFillPTNames);
    var fls /*:number*/  = $77f9f80a0cede680$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $77f9f80a0cede680$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $77f9f80a0cede680$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $77f9f80a0cede680$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $77f9f80a0cede680$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $77f9f80a0cede680$var$write_Blxf(data, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $77f9f80a0cede680$var$parse_BrtBorder = $77f9f80a0cede680$var$parsenoop;
function $77f9f80a0cede680$var$write_BrtBorder(border, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $77f9f80a0cede680$var$write_Blxf(null, o); /* top */ 
    $77f9f80a0cede680$var$write_Blxf(null, o); /* bottom */ 
    $77f9f80a0cede680$var$write_Blxf(null, o); /* left */ 
    $77f9f80a0cede680$var$write_Blxf(null, o); /* right */ 
    $77f9f80a0cede680$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $77f9f80a0cede680$var$write_BrtStyle(style, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $77f9f80a0cede680$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $77f9f80a0cede680$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $77f9f80a0cede680$var$new_buf(2052);
    o.write_shift(4, cnt);
    $77f9f80a0cede680$var$write_XLNullableWideString(defTableStyle, o);
    $77f9f80a0cede680$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $77f9f80a0cede680$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $77f9f80a0cede680$var$table_fmt)styles.NumberFmt[y] = $77f9f80a0cede680$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $77f9f80a0cede680$var$recordhopper(data, function hopper_sty(val1, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val1[0]] = val1[1];
                $77f9f80a0cede680$var$SSF__load(val1[1], val1[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val1);
                if (val1.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val1.color.rgb = $77f9f80a0cede680$var$rgb_tint(themes.themeElements.clrScheme[val1.color.theme].rgb, val1.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val1);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $77f9f80a0cede680$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $77f9f80a0cede680$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $77f9f80a0cede680$var$write_record(ba, 0x002C /* BrtFmt */ , $77f9f80a0cede680$var$write_BrtFmt(i, NF[i]));
    });
    $77f9f80a0cede680$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $77f9f80a0cede680$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $77f9f80a0cede680$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    $77f9f80a0cede680$var$write_record(ba, 0x002B /* BrtFont */ , $77f9f80a0cede680$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $77f9f80a0cede680$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $77f9f80a0cede680$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $77f9f80a0cede680$var$write_record(ba, 0x025B /* BrtBeginFills */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    $77f9f80a0cede680$var$write_record(ba, 0x002D /* BrtFill */ , $77f9f80a0cede680$var$write_BrtFill({
        patternType: "none"
    }));
    $77f9f80a0cede680$var$write_record(ba, 0x002D /* BrtFill */ , $77f9f80a0cede680$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $77f9f80a0cede680$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $77f9f80a0cede680$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $77f9f80a0cede680$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    $77f9f80a0cede680$var$write_record(ba, 0x002E /* BrtBorder */ , $77f9f80a0cede680$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $77f9f80a0cede680$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $77f9f80a0cede680$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $77f9f80a0cede680$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    $77f9f80a0cede680$var$write_record(ba, 0x002F /* BrtXF */ , $77f9f80a0cede680$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $77f9f80a0cede680$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $77f9f80a0cede680$var$write_CELLXFS_bin(ba, data) {
    $77f9f80a0cede680$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $77f9f80a0cede680$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $77f9f80a0cede680$var$write_record(ba, 0x002F /* BrtXF */ , $77f9f80a0cede680$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $77f9f80a0cede680$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $77f9f80a0cede680$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $77f9f80a0cede680$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    $77f9f80a0cede680$var$write_record(ba, 0x0030 /* BrtStyle */ , $77f9f80a0cede680$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $77f9f80a0cede680$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $77f9f80a0cede680$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $77f9f80a0cede680$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $77f9f80a0cede680$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $77f9f80a0cede680$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $77f9f80a0cede680$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $77f9f80a0cede680$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $77f9f80a0cede680$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $77f9f80a0cede680$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $77f9f80a0cede680$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $77f9f80a0cede680$var$write_sty_bin(wb, opts) {
    var ba = $77f9f80a0cede680$var$buf_array();
    $77f9f80a0cede680$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $77f9f80a0cede680$var$write_FMTS_bin(ba, wb.SSF);
    $77f9f80a0cede680$var$write_FONTS_bin(ba, wb);
    $77f9f80a0cede680$var$write_FILLS_bin(ba, wb);
    $77f9f80a0cede680$var$write_BORDERS_bin(ba, wb);
    $77f9f80a0cede680$var$write_CELLSTYLEXFS_bin(ba, wb);
    $77f9f80a0cede680$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $77f9f80a0cede680$var$write_STYLES_bin(ba, wb);
    $77f9f80a0cede680$var$write_DXFS_bin(ba, wb);
    $77f9f80a0cede680$var$write_TABLESTYLES_bin(ba, wb);
    $77f9f80a0cede680$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $77f9f80a0cede680$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $77f9f80a0cede680$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $77f9f80a0cede680$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$77f9f80a0cede680$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $77f9f80a0cede680$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $77f9f80a0cede680$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $77f9f80a0cede680$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $77f9f80a0cede680$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $77f9f80a0cede680$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $77f9f80a0cede680$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $77f9f80a0cede680$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $77f9f80a0cede680$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $77f9f80a0cede680$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $77f9f80a0cede680$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $77f9f80a0cede680$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $77f9f80a0cede680$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $77f9f80a0cede680$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $77f9f80a0cede680$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $77f9f80a0cede680$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $77f9f80a0cede680$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $77f9f80a0cede680$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $77f9f80a0cede680$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $77f9f80a0cede680$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $77f9f80a0cede680$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $77f9f80a0cede680$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $77f9f80a0cede680$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $77f9f80a0cede680$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $77f9f80a0cede680$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $77f9f80a0cede680$var$parse_IcvXF(blob, length) {
    return $77f9f80a0cede680$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $77f9f80a0cede680$var$parse_XFExtGradient(blob, length) {
    return $77f9f80a0cede680$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $77f9f80a0cede680$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $77f9f80a0cede680$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $77f9f80a0cede680$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $77f9f80a0cede680$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($77f9f80a0cede680$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $77f9f80a0cede680$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $77f9f80a0cede680$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $77f9f80a0cede680$var$parse_XLWideString(data, length - 8)
    };
}
function $77f9f80a0cede680$var$write_BrtMdtinfo(data) {
    var o = $77f9f80a0cede680$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $77f9f80a0cede680$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $77f9f80a0cede680$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $77f9f80a0cede680$var$write_BrtMdb(mdb) {
    var o = $77f9f80a0cede680$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $77f9f80a0cede680$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $77f9f80a0cede680$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $77f9f80a0cede680$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $77f9f80a0cede680$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $77f9f80a0cede680$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $77f9f80a0cede680$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $77f9f80a0cede680$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $77f9f80a0cede680$var$recordhopper(data, function(val1, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val1.name
                });
                break;
            case 51:
                val1.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val1 ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $77f9f80a0cede680$var$write_xlmeta_bin() {
    var ba = $77f9f80a0cede680$var$buf_array();
    $77f9f80a0cede680$var$write_record(ba, 332);
    $77f9f80a0cede680$var$write_record(ba, 334, $77f9f80a0cede680$var$write_UInt32LE(1));
    $77f9f80a0cede680$var$write_record(ba, 335, $77f9f80a0cede680$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $77f9f80a0cede680$var$write_record(ba, 336);
    $77f9f80a0cede680$var$write_record(ba, 339, $77f9f80a0cede680$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $77f9f80a0cede680$var$write_record(ba, 52);
    $77f9f80a0cede680$var$write_record(ba, 35, $77f9f80a0cede680$var$write_UInt32LE(514));
    $77f9f80a0cede680$var$write_record(ba, 4096, $77f9f80a0cede680$var$write_UInt32LE(0));
    $77f9f80a0cede680$var$write_record(ba, 4097, $77f9f80a0cede680$var$writeuint16(1));
    $77f9f80a0cede680$var$write_record(ba, 36);
    $77f9f80a0cede680$var$write_record(ba, 53);
    $77f9f80a0cede680$var$write_record(ba, 340);
    $77f9f80a0cede680$var$write_record(ba, 337, $77f9f80a0cede680$var$write_BrtBeginEsmdb(1, true));
    $77f9f80a0cede680$var$write_record(ba, 51, $77f9f80a0cede680$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $77f9f80a0cede680$var$write_record(ba, 338);
    $77f9f80a0cede680$var$write_record(ba, 333);
    return ba.end();
}
function $77f9f80a0cede680$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($77f9f80a0cede680$var$tagregex, function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $77f9f80a0cede680$var$write_xlmeta_xml() {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $77f9f80a0cede680$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($77f9f80a0cede680$var$tagregex) || []).forEach(function(x) {
        var y = $77f9f80a0cede680$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $77f9f80a0cede680$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $77f9f80a0cede680$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $77f9f80a0cede680$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $77f9f80a0cede680$var$recordhopper(data, function hopper_cc(val1, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val1);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $77f9f80a0cede680$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $77f9f80a0cede680$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $77f9f80a0cede680$var$recordhopper(data, function xlink_parse(val1, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $77f9f80a0cede680$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $77f9f80a0cede680$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($77f9f80a0cede680$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($77f9f80a0cede680$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $77f9f80a0cede680$var$parsexmltag(x);
            switch($77f9f80a0cede680$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $77f9f80a0cede680$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $77f9f80a0cede680$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $77f9f80a0cede680$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $77f9f80a0cede680$var$writextag("xml", null, {
            'xmlns:v': $77f9f80a0cede680$var$XLMLNS.v,
            'xmlns:o': $77f9f80a0cede680$var$XLMLNS.o,
            'xmlns:x': $77f9f80a0cede680$var$XLMLNS.x,
            'xmlns:mv': $77f9f80a0cede680$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $77f9f80a0cede680$var$writextag("o:shapelayout", $77f9f80a0cede680$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($77f9f80a0cede680$var$writextag("v:shapetype", [
        $77f9f80a0cede680$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $77f9f80a0cede680$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($77f9f80a0cede680$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $77f9f80a0cede680$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $77f9f80a0cede680$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $77f9f80a0cede680$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $77f9f80a0cede680$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $77f9f80a0cede680$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $77f9f80a0cede680$var$writextag("v:shadow", null, shadata),
        $77f9f80a0cede680$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $77f9f80a0cede680$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $77f9f80a0cede680$var$writetag('x:AutoFill', "False"),
        $77f9f80a0cede680$var$writetag('x:Row', String(c.r)),
        $77f9f80a0cede680$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $77f9f80a0cede680$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $77f9f80a0cede680$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $77f9f80a0cede680$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $77f9f80a0cede680$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $77f9f80a0cede680$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $77f9f80a0cede680$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $77f9f80a0cede680$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $77f9f80a0cede680$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $77f9f80a0cede680$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $77f9f80a0cede680$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $77f9f80a0cede680$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $77f9f80a0cede680$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('comments', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $77f9f80a0cede680$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($77f9f80a0cede680$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $77f9f80a0cede680$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($77f9f80a0cede680$var$escapexml(c.a)) + '"><text>');
            o.push($77f9f80a0cede680$var$writetag("t", c.t == null ? "" : $77f9f80a0cede680$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($77f9f80a0cede680$var$writetag("t", $77f9f80a0cede680$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $77f9f80a0cede680$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($77f9f80a0cede680$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $77f9f80a0cede680$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('ThreadedComments', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($77f9f80a0cede680$var$writextag('threadedComment', $77f9f80a0cede680$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $77f9f80a0cede680$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($77f9f80a0cede680$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $77f9f80a0cede680$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('personList', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS.TCMNT,
            'xmlns:x': $77f9f80a0cede680$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($77f9f80a0cede680$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $77f9f80a0cede680$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $77f9f80a0cede680$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $77f9f80a0cede680$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $77f9f80a0cede680$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $77f9f80a0cede680$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $77f9f80a0cede680$var$parse_BrtCommentAuthor = $77f9f80a0cede680$var$parse_XLWideString;
function $77f9f80a0cede680$var$write_BrtCommentAuthor(data) {
    return $77f9f80a0cede680$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $77f9f80a0cede680$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $77f9f80a0cede680$var$recordhopper(data, function hopper_cmnt(val1, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val1);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val1;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val1.t;
                c.h = val1.h;
                c.r = val1.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $77f9f80a0cede680$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $77f9f80a0cede680$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $77f9f80a0cede680$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $77f9f80a0cede680$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $77f9f80a0cede680$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $77f9f80a0cede680$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $77f9f80a0cede680$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $77f9f80a0cede680$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $77f9f80a0cede680$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $77f9f80a0cede680$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $77f9f80a0cede680$var$decode_cell(comment[0]),
                e: $77f9f80a0cede680$var$decode_cell(comment[0])
            };
            $77f9f80a0cede680$var$write_record(ba, 0x027B /* BrtBeginComment */ , $77f9f80a0cede680$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $77f9f80a0cede680$var$write_record(ba, 0x027D /* BrtCommentText */ , $77f9f80a0cede680$var$write_BrtCommentText(c));
            $77f9f80a0cede680$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $77f9f80a0cede680$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $77f9f80a0cede680$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $77f9f80a0cede680$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $77f9f80a0cede680$var$make_vba_xls(cfb) {
    var newcfb = $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $77f9f80a0cede680$export$9f0e51cd97c572a.write(newcfb);
}
function $77f9f80a0cede680$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $77f9f80a0cede680$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $77f9f80a0cede680$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $77f9f80a0cede680$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $77f9f80a0cede680$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $77f9f80a0cede680$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $77f9f80a0cede680$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $77f9f80a0cede680$var$encode_col(C) + (rRel ? "" : "$") + $77f9f80a0cede680$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $77f9f80a0cede680$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $77f9f80a0cede680$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $77f9f80a0cede680$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($77f9f80a0cede680$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $77f9f80a0cede680$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $77f9f80a0cede680$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $77f9f80a0cede680$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($77f9f80a0cede680$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $77f9f80a0cede680$var$encode_col($77f9f80a0cede680$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $77f9f80a0cede680$var$encode_row($77f9f80a0cede680$var$decode_row($5) + delta.r));
    });
}
function $77f9f80a0cede680$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $77f9f80a0cede680$var$decode_range(range), s = r.s, c = $77f9f80a0cede680$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $77f9f80a0cede680$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $77f9f80a0cede680$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $77f9f80a0cede680$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $77f9f80a0cede680$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $77f9f80a0cede680$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $77f9f80a0cede680$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $77f9f80a0cede680$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    var C = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $77f9f80a0cede680$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $77f9f80a0cede680$var$parse_ColRelU(blob, 2), R = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $77f9f80a0cede680$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $77f9f80a0cede680$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    var C = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $77f9f80a0cede680$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $77f9f80a0cede680$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $77f9f80a0cede680$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $77f9f80a0cede680$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $77f9f80a0cede680$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $77f9f80a0cede680$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $77f9f80a0cede680$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $77f9f80a0cede680$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $77f9f80a0cede680$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $77f9f80a0cede680$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $77f9f80a0cede680$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $77f9f80a0cede680$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $77f9f80a0cede680$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $77f9f80a0cede680$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $77f9f80a0cede680$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $77f9f80a0cede680$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $77f9f80a0cede680$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $77f9f80a0cede680$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $77f9f80a0cede680$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $77f9f80a0cede680$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $77f9f80a0cede680$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $77f9f80a0cede680$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $77f9f80a0cede680$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $77f9f80a0cede680$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $77f9f80a0cede680$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $77f9f80a0cede680$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $77f9f80a0cede680$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $77f9f80a0cede680$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $77f9f80a0cede680$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $77f9f80a0cede680$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $77f9f80a0cede680$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $77f9f80a0cede680$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $77f9f80a0cede680$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $77f9f80a0cede680$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $77f9f80a0cede680$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $77f9f80a0cede680$var$FtabArgc[iftab],
        $77f9f80a0cede680$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $77f9f80a0cede680$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $77f9f80a0cede680$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $77f9f80a0cede680$var$Ftab : $77f9f80a0cede680$var$Cetab)[tab[1]]
    ];
}
function $77f9f80a0cede680$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $77f9f80a0cede680$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $77f9f80a0cede680$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $77f9f80a0cede680$var$parse_PtgErr(blob) {
    blob.l++;
    return $77f9f80a0cede680$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $77f9f80a0cede680$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $77f9f80a0cede680$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $77f9f80a0cede680$var$parse_PtgNum(blob) {
    blob.l++;
    return $77f9f80a0cede680$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $77f9f80a0cede680$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $77f9f80a0cede680$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $77f9f80a0cede680$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val1 = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val1[0]){
        case 0x02:
            val1[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val1[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val1[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val1[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val1[0]){
        case 0x04:
            /* SerBool -- boolean */ val1[1] = $77f9f80a0cede680$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val1[1] = $77f9f80a0cede680$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val1[1] = $77f9f80a0cede680$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val1[1] = $77f9f80a0cede680$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val1[0]); /* Unreachable */ 
    }
    return val1;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $77f9f80a0cede680$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $77f9f80a0cede680$var$parse_UncheckedRfX : $77f9f80a0cede680$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $77f9f80a0cede680$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $77f9f80a0cede680$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $77f9f80a0cede680$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $77f9f80a0cede680$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $77f9f80a0cede680$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $77f9f80a0cede680$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $77f9f80a0cede680$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $77f9f80a0cede680$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $77f9f80a0cede680$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $77f9f80a0cede680$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $77f9f80a0cede680$var$parse_PtgMemErr = $77f9f80a0cede680$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $77f9f80a0cede680$var$parse_PtgMemNoMem = $77f9f80a0cede680$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $77f9f80a0cede680$var$parse_PtgTbl = $77f9f80a0cede680$var$parsenoop;
function $77f9f80a0cede680$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $77f9f80a0cede680$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $77f9f80a0cede680$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $77f9f80a0cede680$var$parse_PtgElfCol = $77f9f80a0cede680$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $77f9f80a0cede680$var$parse_PtgElfColS = $77f9f80a0cede680$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $77f9f80a0cede680$var$parse_PtgElfColSV = $77f9f80a0cede680$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $77f9f80a0cede680$var$parse_PtgElfColV = $77f9f80a0cede680$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $77f9f80a0cede680$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $77f9f80a0cede680$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $77f9f80a0cede680$var$parse_PtgElfRadical = $77f9f80a0cede680$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $77f9f80a0cede680$var$parse_PtgElfRadicalLel = $77f9f80a0cede680$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $77f9f80a0cede680$var$parse_PtgElfRadicalS = $77f9f80a0cede680$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $77f9f80a0cede680$var$parse_PtgElfRw = $77f9f80a0cede680$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $77f9f80a0cede680$var$parse_PtgElfRwV = $77f9f80a0cede680$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $77f9f80a0cede680$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $77f9f80a0cede680$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $77f9f80a0cede680$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $77f9f80a0cede680$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $77f9f80a0cede680$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $77f9f80a0cede680$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $77f9f80a0cede680$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $77f9f80a0cede680$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $77f9f80a0cede680$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $77f9f80a0cede680$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $77f9f80a0cede680$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $77f9f80a0cede680$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $77f9f80a0cede680$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $77f9f80a0cede680$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $77f9f80a0cede680$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $77f9f80a0cede680$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $77f9f80a0cede680$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $77f9f80a0cede680$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $77f9f80a0cede680$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $77f9f80a0cede680$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $77f9f80a0cede680$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $77f9f80a0cede680$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $77f9f80a0cede680$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $77f9f80a0cede680$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $77f9f80a0cede680$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $77f9f80a0cede680$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $77f9f80a0cede680$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $77f9f80a0cede680$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $77f9f80a0cede680$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $77f9f80a0cede680$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $77f9f80a0cede680$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $77f9f80a0cede680$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $77f9f80a0cede680$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $77f9f80a0cede680$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $77f9f80a0cede680$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $77f9f80a0cede680$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $77f9f80a0cede680$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $77f9f80a0cede680$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $77f9f80a0cede680$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $77f9f80a0cede680$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $77f9f80a0cede680$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $77f9f80a0cede680$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $77f9f80a0cede680$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $77f9f80a0cede680$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $77f9f80a0cede680$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $77f9f80a0cede680$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $77f9f80a0cede680$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $77f9f80a0cede680$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $77f9f80a0cede680$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $77f9f80a0cede680$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $77f9f80a0cede680$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $77f9f80a0cede680$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $77f9f80a0cede680$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $77f9f80a0cede680$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $77f9f80a0cede680$var$parse_PtgSxName
    },
    0xFF: {}
};
var $77f9f80a0cede680$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $77f9f80a0cede680$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $77f9f80a0cede680$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $77f9f80a0cede680$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $77f9f80a0cede680$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $77f9f80a0cede680$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $77f9f80a0cede680$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $77f9f80a0cede680$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $77f9f80a0cede680$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $77f9f80a0cede680$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $77f9f80a0cede680$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $77f9f80a0cede680$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $77f9f80a0cede680$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $77f9f80a0cede680$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $77f9f80a0cede680$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $77f9f80a0cede680$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($77f9f80a0cede680$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $77f9f80a0cede680$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $77f9f80a0cede680$var$PtgTypes[id] || $77f9f80a0cede680$var$PtgTypes[$77f9f80a0cede680$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $77f9f80a0cede680$var$Ptg18 : $77f9f80a0cede680$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $77f9f80a0cede680$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $77f9f80a0cede680$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $77f9f80a0cede680$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $77f9f80a0cede680$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $77f9f80a0cede680$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $77f9f80a0cede680$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $77f9f80a0cede680$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $77f9f80a0cede680$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $77f9f80a0cede680$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $77f9f80a0cede680$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $77f9f80a0cede680$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $77f9f80a0cede680$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($77f9f80a0cede680$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $77f9f80a0cede680$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($77f9f80a0cede680$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $77f9f80a0cede680$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($77f9f80a0cede680$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $77f9f80a0cede680$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $77f9f80a0cede680$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $77f9f80a0cede680$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $77f9f80a0cede680$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($77f9f80a0cede680$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $77f9f80a0cede680$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($77f9f80a0cede680$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $77f9f80a0cede680$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $77f9f80a0cede680$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($77f9f80a0cede680$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $77f9f80a0cede680$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $77f9f80a0cede680$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $77f9f80a0cede680$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $77f9f80a0cede680$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$77f9f80a0cede680$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$77f9f80a0cede680$var$encode_cell(c)];
                    stack.push($77f9f80a0cede680$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($77f9f80a0cede680$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $77f9f80a0cede680$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $77f9f80a0cede680$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $77f9f80a0cede680$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $77f9f80a0cede680$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $77f9f80a0cede680$var$parsenoop(blob, length - 2)
    ];
    var rgce = $77f9f80a0cede680$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $77f9f80a0cede680$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $77f9f80a0cede680$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $77f9f80a0cede680$var$parsenoop(blob, length - 2)
    ];
    var rgce = $77f9f80a0cede680$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $77f9f80a0cede680$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $77f9f80a0cede680$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $77f9f80a0cede680$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $77f9f80a0cede680$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $77f9f80a0cede680$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $77f9f80a0cede680$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $77f9f80a0cede680$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $77f9f80a0cede680$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $77f9f80a0cede680$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($77f9f80a0cede680$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $77f9f80a0cede680$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $77f9f80a0cede680$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $77f9f80a0cede680$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $77f9f80a0cede680$var$write_Xnum(value);
    return $77f9f80a0cede680$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $77f9f80a0cede680$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSCell(blob, 6, opts);
    var val1 = $77f9f80a0cede680$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $77f9f80a0cede680$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val1[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val1[1]
    };
}
function $77f9f80a0cede680$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $77f9f80a0cede680$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $77f9f80a0cede680$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $77f9f80a0cede680$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $77f9f80a0cede680$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $77f9f80a0cede680$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $77f9f80a0cede680$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $77f9f80a0cede680$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $77f9f80a0cede680$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $77f9f80a0cede680$var$parse_XLSBArrayParsedFormula = $77f9f80a0cede680$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $77f9f80a0cede680$var$parse_XLSBCellParsedFormula = $77f9f80a0cede680$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $77f9f80a0cede680$var$parse_XLSBNameParsedFormula = $77f9f80a0cede680$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $77f9f80a0cede680$var$parse_XLSBSharedParsedFormula = $77f9f80a0cede680$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $77f9f80a0cede680$var$write_XLSBFormulaNum(val1 /*:number*/ ) {
    if ((val1 | 0) == val1 && val1 < Math.pow(2, 16) && val1 >= 0) {
        var oint = $77f9f80a0cede680$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val1);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $77f9f80a0cede680$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val1);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $77f9f80a0cede680$var$write_XLSBFormulaErr(val1 /*:number*/ ) {
    var oint = $77f9f80a0cede680$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val1);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $77f9f80a0cede680$var$write_XLSBFormulaBool(val1 /*:boolean*/ ) {
    var oint = $77f9f80a0cede680$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val1 ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $77f9f80a0cede680$var$write_XLSBFormulaStr(val1 /*:string*/ ) {
    var preamble = $77f9f80a0cede680$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val1.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val1.length);
    var body = $77f9f80a0cede680$var$new_buf(2 * val1.length);
    body.write_shift(2 * val1.length, val1, "utf16le");
    var postamble = $77f9f80a0cede680$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $77f9f80a0cede680$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $77f9f80a0cede680$var$write_XLSBFormulaRef(str) {
    var cell = $77f9f80a0cede680$var$decode_cell(str);
    var out = $77f9f80a0cede680$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $77f9f80a0cede680$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $77f9f80a0cede680$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $77f9f80a0cede680$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $77f9f80a0cede680$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $77f9f80a0cede680$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $77f9f80a0cede680$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $77f9f80a0cede680$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $77f9f80a0cede680$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $77f9f80a0cede680$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $77f9f80a0cede680$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $77f9f80a0cede680$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $77f9f80a0cede680$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $77f9f80a0cede680$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $77f9f80a0cede680$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $77f9f80a0cede680$var$decode_range(_str);
    var out = $77f9f80a0cede680$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $77f9f80a0cede680$var$write_XLSBFormula(val1 /*:string|number*/ , wb) {
    if (typeof val1 == "number") return $77f9f80a0cede680$var$write_XLSBFormulaNum(val1);
    if (typeof val1 == "boolean") return $77f9f80a0cede680$var$write_XLSBFormulaBool(val1);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val1)) return $77f9f80a0cede680$var$write_XLSBFormulaErr(+$77f9f80a0cede680$var$RBErr[val1]);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $77f9f80a0cede680$var$write_XLSBFormulaRef(val1);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $77f9f80a0cede680$var$write_XLSBFormulaRange(val1);
    if (val1.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $77f9f80a0cede680$var$write_XLSBFormulaArea3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $77f9f80a0cede680$var$write_XLSBFormulaRef3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $77f9f80a0cede680$var$write_XLSBFormulaRangeWS(val1, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val1)) return $77f9f80a0cede680$var$write_XLSBFormulaRefErr3D(val1, wb);
    if (/^".*"$/.test(val1)) return $77f9f80a0cede680$var$write_XLSBFormulaStr(val1);
    if (/^[+-]\d+$/.test(val1)) return $77f9f80a0cede680$var$write_XLSBFormulaNum(parseInt(val1, 10));
    throw "Formula |" + val1 + "| not supported for XLSB";
}
var $77f9f80a0cede680$var$write_XLSBNameParsedFormula = $77f9f80a0cede680$var$write_XLSBFormula;
var $77f9f80a0cede680$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $77f9f80a0cede680$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $77f9f80a0cede680$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $77f9f80a0cede680$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $77f9f80a0cede680$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($77f9f80a0cede680$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $77f9f80a0cede680$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $77f9f80a0cede680$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $77f9f80a0cede680$var$strs = {}; // shared strings
var $77f9f80a0cede680$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $77f9f80a0cede680$var$browser_has_Map = typeof Map !== 'undefined';
function $77f9f80a0cede680$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($77f9f80a0cede680$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $77f9f80a0cede680$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($77f9f80a0cede680$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $77f9f80a0cede680$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $77f9f80a0cede680$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $77f9f80a0cede680$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $77f9f80a0cede680$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $77f9f80a0cede680$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $77f9f80a0cede680$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $77f9f80a0cede680$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $77f9f80a0cede680$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $77f9f80a0cede680$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $77f9f80a0cede680$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($77f9f80a0cede680$var$table_fmt[fmtid] == null) $77f9f80a0cede680$var$SSF__load($77f9f80a0cede680$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $77f9f80a0cede680$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $77f9f80a0cede680$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $77f9f80a0cede680$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $77f9f80a0cede680$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $77f9f80a0cede680$var$SSF_general(p.v, $77f9f80a0cede680$var$_ssfopts);
        } else if (p.t === 'd') p.w = $77f9f80a0cede680$var$SSF_format(fmtid, $77f9f80a0cede680$var$datenum(p.v, !!date1904), $77f9f80a0cede680$var$_ssfopts);
        else p.w = $77f9f80a0cede680$var$SSF_format(fmtid, p.v, $77f9f80a0cede680$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $77f9f80a0cede680$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $77f9f80a0cede680$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $77f9f80a0cede680$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $77f9f80a0cede680$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $77f9f80a0cede680$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $77f9f80a0cede680$var$encode_range(d);
}
var $77f9f80a0cede680$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $77f9f80a0cede680$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $77f9f80a0cede680$var$dimregex = /"(\w*:\w*)"/;
var $77f9f80a0cede680$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $77f9f80a0cede680$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $77f9f80a0cede680$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $77f9f80a0cede680$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $77f9f80a0cede680$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($77f9f80a0cede680$var$DENSE != null && opts.dense == null) opts.dense = $77f9f80a0cede680$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $77f9f80a0cede680$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($77f9f80a0cede680$var$sheetprregex);
    if (sheetPr) $77f9f80a0cede680$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $77f9f80a0cede680$var$str_match_xml_ns(data1, "sheetPr")) $77f9f80a0cede680$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($77f9f80a0cede680$var$dimregex);
        if (ref && !(opts && opts.nodim)) $77f9f80a0cede680$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $77f9f80a0cede680$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $77f9f80a0cede680$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($77f9f80a0cede680$var$colregex);
        if (cols) $77f9f80a0cede680$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $77f9f80a0cede680$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($77f9f80a0cede680$var$afregex);
    if (afilter) s['!autofilter'] = $77f9f80a0cede680$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($77f9f80a0cede680$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $77f9f80a0cede680$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("=") + 2));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($77f9f80a0cede680$var$hlinkregex);
    if (hlink) $77f9f80a0cede680$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($77f9f80a0cede680$var$marginregex);
    if (margins) s['!margins'] = $77f9f80a0cede680$var$parse_ws_xml_margins($77f9f80a0cede680$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $77f9f80a0cede680$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $77f9f80a0cede680$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $77f9f80a0cede680$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $77f9f80a0cede680$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $77f9f80a0cede680$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $77f9f80a0cede680$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(data.codeName));
}
function $77f9f80a0cede680$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $77f9f80a0cede680$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $77f9f80a0cede680$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $77f9f80a0cede680$var$utf8write($77f9f80a0cede680$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $77f9f80a0cede680$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $77f9f80a0cede680$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $77f9f80a0cede680$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $77f9f80a0cede680$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $77f9f80a0cede680$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $77f9f80a0cede680$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $77f9f80a0cede680$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $77f9f80a0cede680$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $77f9f80a0cede680$var$writextag('sheetProtection', null, o);
}
function $77f9f80a0cede680$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val1 = $77f9f80a0cede680$var$parsexmltag($77f9f80a0cede680$var$utf8read(data[i]), true);
        if (!val1.ref) return;
        var rel = ((rels || {})['!id'] || [])[val1.id];
        if (rel) {
            val1.Target = rel.Target;
            if (val1.location) val1.Target += "#" + $77f9f80a0cede680$var$unescapexml(val1.location);
        } else {
            val1.Target = "#" + $77f9f80a0cede680$var$unescapexml(val1.location);
            rel = {
                Target: val1.Target,
                TargetMode: 'Internal'
            };
        }
        val1.Rel = rel;
        if (val1.tooltip) {
            val1.Tooltip = val1.tooltip;
            delete val1.tooltip;
        }
        var rng = $77f9f80a0cede680$var$safe_decode_range(val1.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val1;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val1;
            }
        }
    }
}
function $77f9f80a0cede680$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $77f9f80a0cede680$var$write_ws_xml_margins(margin) /*:string*/ {
    $77f9f80a0cede680$var$default_margins(margin);
    return $77f9f80a0cede680$var$writextag('pageMargins', null, margin);
}
function $77f9f80a0cede680$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $77f9f80a0cede680$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $77f9f80a0cede680$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $77f9f80a0cede680$var$find_mdw_colw(coll.width);
        }
        $77f9f80a0cede680$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $77f9f80a0cede680$var$dup(coll);
    }
}
function $77f9f80a0cede680$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $77f9f80a0cede680$var$writextag('col', null, $77f9f80a0cede680$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $77f9f80a0cede680$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $77f9f80a0cede680$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $77f9f80a0cede680$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $77f9f80a0cede680$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $77f9f80a0cede680$var$decode_range(ws["!ref"]).e.r;
        ref = $77f9f80a0cede680$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $77f9f80a0cede680$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $77f9f80a0cede680$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $77f9f80a0cede680$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $77f9f80a0cede680$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $77f9f80a0cede680$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($77f9f80a0cede680$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $77f9f80a0cede680$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $77f9f80a0cede680$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $77f9f80a0cede680$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $77f9f80a0cede680$var$writextag("sheetViews", $77f9f80a0cede680$var$writextag("sheetView", null, sview), {});
}
function $77f9f80a0cede680$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $77f9f80a0cede680$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $77f9f80a0cede680$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $77f9f80a0cede680$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $77f9f80a0cede680$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $77f9f80a0cede680$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $77f9f80a0cede680$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $77f9f80a0cede680$var$writetag('v', $77f9f80a0cede680$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $77f9f80a0cede680$var$writetag('v', '' + $77f9f80a0cede680$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $77f9f80a0cede680$var$writextag('f', $77f9f80a0cede680$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $77f9f80a0cede680$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $77f9f80a0cede680$var$writextag('c', v, o);
}
var $77f9f80a0cede680$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $77f9f80a0cede680$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $77f9f80a0cede680$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $77f9f80a0cede680$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $77f9f80a0cede680$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $77f9f80a0cede680$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $77f9f80a0cede680$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $77f9f80a0cede680$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $77f9f80a0cede680$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $77f9f80a0cede680$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $77f9f80a0cede680$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $77f9f80a0cede680$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $77f9f80a0cede680$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $77f9f80a0cede680$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $77f9f80a0cede680$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $77f9f80a0cede680$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $77f9f80a0cede680$var$parsexmltag(cref[0]);
                                var ___f = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $77f9f80a0cede680$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $77f9f80a0cede680$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $77f9f80a0cede680$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $77f9f80a0cede680$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $77f9f80a0cede680$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $77f9f80a0cede680$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $77f9f80a0cede680$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $77f9f80a0cede680$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $77f9f80a0cede680$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $77f9f80a0cede680$var$parseDate(p.v, date1904);
                        else {
                            p.v = $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $77f9f80a0cede680$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $77f9f80a0cede680$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $77f9f80a0cede680$var$fmt_is_date($77f9f80a0cede680$var$table_fmt[fmtid])) {
                    p.v = $77f9f80a0cede680$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $77f9f80a0cede680$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $77f9f80a0cede680$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $77f9f80a0cede680$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null, data = dense ? ws["!data"] : [];
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $77f9f80a0cede680$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $77f9f80a0cede680$var$encode_row(R);
        var data_R = dense ? data[R] : [];
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? data_R[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $77f9f80a0cede680$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $77f9f80a0cede680$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $77f9f80a0cede680$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $77f9f80a0cede680$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $77f9f80a0cede680$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $77f9f80a0cede680$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER,
        $77f9f80a0cede680$var$writextag('worksheet', null, {
            'xmlns': $77f9f80a0cede680$var$XMLNS_main[0],
            'xmlns:r': $77f9f80a0cede680$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $77f9f80a0cede680$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $77f9f80a0cede680$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $77f9f80a0cede680$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $77f9f80a0cede680$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $77f9f80a0cede680$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $77f9f80a0cede680$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $77f9f80a0cede680$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $77f9f80a0cede680$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $77f9f80a0cede680$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $77f9f80a0cede680$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $77f9f80a0cede680$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $77f9f80a0cede680$var$add_rels(rels, -1, $77f9f80a0cede680$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $77f9f80a0cede680$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $77f9f80a0cede680$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $77f9f80a0cede680$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $77f9f80a0cede680$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $77f9f80a0cede680$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $77f9f80a0cede680$var$writetag("ignoredErrors", $77f9f80a0cede680$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $77f9f80a0cede680$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $77f9f80a0cede680$var$RELS.DRAW);
        o[o.length] = $77f9f80a0cede680$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $77f9f80a0cede680$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $77f9f80a0cede680$var$RELS.VML);
        o[o.length] = $77f9f80a0cede680$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $77f9f80a0cede680$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $77f9f80a0cede680$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $77f9f80a0cede680$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $77f9f80a0cede680$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$77f9f80a0cede680$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $77f9f80a0cede680$var$write_row_header(ba, ws, range, R) {
    var o = $77f9f80a0cede680$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $77f9f80a0cede680$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $77f9f80a0cede680$var$parse_BrtWsDim = $77f9f80a0cede680$var$parse_UncheckedRfX;
var $77f9f80a0cede680$var$write_BrtWsDim = $77f9f80a0cede680$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $77f9f80a0cede680$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $77f9f80a0cede680$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $77f9f80a0cede680$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $77f9f80a0cede680$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $77f9f80a0cede680$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $77f9f80a0cede680$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $77f9f80a0cede680$var$parse_BrtCellBlank(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $77f9f80a0cede680$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(8);
    return $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
}
function $77f9f80a0cede680$var$parse_BrtShortBlank(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $77f9f80a0cede680$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(4);
    return $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $77f9f80a0cede680$var$parse_BrtCellBool(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $77f9f80a0cede680$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(9);
    $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $77f9f80a0cede680$var$parse_BrtShortBool(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $77f9f80a0cede680$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(5);
    $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $77f9f80a0cede680$var$parse_BrtCellError(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $77f9f80a0cede680$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(9);
    $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $77f9f80a0cede680$var$parse_BrtShortError(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $77f9f80a0cede680$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(8);
    $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $77f9f80a0cede680$var$parse_BrtCellIsst(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $77f9f80a0cede680$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(12);
    $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $77f9f80a0cede680$var$parse_BrtShortIsst(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $77f9f80a0cede680$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(8);
    $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $77f9f80a0cede680$var$parse_BrtCellReal(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var value = $77f9f80a0cede680$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $77f9f80a0cede680$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(16);
    $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
    $77f9f80a0cede680$var$write_Xnum(cell.v, o);
    return o;
}
function $77f9f80a0cede680$var$parse_BrtShortReal(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    var value = $77f9f80a0cede680$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $77f9f80a0cede680$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(12);
    $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
    $77f9f80a0cede680$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $77f9f80a0cede680$var$parse_BrtCellRk(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var value = $77f9f80a0cede680$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $77f9f80a0cede680$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(12);
    $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
    $77f9f80a0cede680$var$write_RkNumber(cell.v, o);
    return o;
}
function $77f9f80a0cede680$var$parse_BrtShortRk(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    var value = $77f9f80a0cede680$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $77f9f80a0cede680$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(8);
    $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
    $77f9f80a0cede680$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $77f9f80a0cede680$var$parse_BrtCellRString(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var value = $77f9f80a0cede680$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $77f9f80a0cede680$var$parse_BrtCellSt(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    var value = $77f9f80a0cede680$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $77f9f80a0cede680$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $77f9f80a0cede680$var$new_buf(12 + 4 * cell.v.length);
    $77f9f80a0cede680$var$write_XLSBCell(ncell, o);
    $77f9f80a0cede680$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $77f9f80a0cede680$var$parse_BrtShortSt(data) {
    var cell = $77f9f80a0cede680$var$parse_XLSBShortCell(data);
    var value = $77f9f80a0cede680$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $77f9f80a0cede680$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $77f9f80a0cede680$var$new_buf(8 + 4 * data.length);
    $77f9f80a0cede680$var$write_XLSBShortCell(ncell, o);
    $77f9f80a0cede680$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $77f9f80a0cede680$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $77f9f80a0cede680$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $77f9f80a0cede680$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $77f9f80a0cede680$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $77f9f80a0cede680$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $77f9f80a0cede680$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $77f9f80a0cede680$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $77f9f80a0cede680$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $77f9f80a0cede680$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $77f9f80a0cede680$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $77f9f80a0cede680$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $77f9f80a0cede680$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $77f9f80a0cede680$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $77f9f80a0cede680$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $77f9f80a0cede680$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $77f9f80a0cede680$var$parse_BrtMergeCell = $77f9f80a0cede680$var$parse_UncheckedRfX;
var $77f9f80a0cede680$var$write_BrtMergeCell = $77f9f80a0cede680$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $77f9f80a0cede680$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $77f9f80a0cede680$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $77f9f80a0cede680$var$parse_UncheckedRfX(data, 16);
    var relId = $77f9f80a0cede680$var$parse_XLNullableWideString(data);
    var loc = $77f9f80a0cede680$var$parse_XLWideString(data);
    var tooltip = $77f9f80a0cede680$var$parse_XLWideString(data);
    var display = $77f9f80a0cede680$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $77f9f80a0cede680$var$write_BrtHLink(l, rId) {
    var o = $77f9f80a0cede680$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $77f9f80a0cede680$var$write_UncheckedRfX({
        s: $77f9f80a0cede680$var$decode_cell(l[0]),
        e: $77f9f80a0cede680$var$decode_cell(l[0])
    }, o);
    $77f9f80a0cede680$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $77f9f80a0cede680$var$write_XLWideString(loc || "", o);
    $77f9f80a0cede680$var$write_XLWideString(l[1].Tooltip || "", o);
    $77f9f80a0cede680$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $77f9f80a0cede680$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $77f9f80a0cede680$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $77f9f80a0cede680$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $77f9f80a0cede680$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $77f9f80a0cede680$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $77f9f80a0cede680$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $77f9f80a0cede680$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $77f9f80a0cede680$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(18);
    var p = $77f9f80a0cede680$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $77f9f80a0cede680$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $77f9f80a0cede680$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $77f9f80a0cede680$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $77f9f80a0cede680$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $77f9f80a0cede680$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(48);
    $77f9f80a0cede680$var$default_margins(margins);
    $77f9f80a0cede680$var$BrtMarginKeys.forEach(function(k) {
        $77f9f80a0cede680$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $77f9f80a0cede680$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $77f9f80a0cede680$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $77f9f80a0cede680$var$write_BrtCellIgnoreEC(ref) {
    var o = $77f9f80a0cede680$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $77f9f80a0cede680$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $77f9f80a0cede680$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $77f9f80a0cede680$var$new_buf(66);
    o.write_shift(2, sp.password ? $77f9f80a0cede680$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $77f9f80a0cede680$var$parse_BrtDVal() {}
function $77f9f80a0cede680$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $77f9f80a0cede680$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($77f9f80a0cede680$var$DENSE != null && opts.dense == null) opts.dense = $77f9f80a0cede680$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $77f9f80a0cede680$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $77f9f80a0cede680$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $77f9f80a0cede680$var$recordhopper(data, function ws_parse(val1, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val1;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val1;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $77f9f80a0cede680$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val1.hidden || val1.hpt || val1.level != null) {
                    if (val1.hpt) val1.hpx = $77f9f80a0cede680$var$pt2px(val1.hpt);
                    rowinfo[val1.r] = val1;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val1[2]
                } /*:any*/ ;
                switch(val1[2]){
                    case 'n':
                        p.v = val1[1];
                        break;
                    case 's':
                        sstr = $77f9f80a0cede680$var$strs[val1[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val1[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val1[1];
                        if (opts.cellText !== false) p.w = $77f9f80a0cede680$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val1[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val1[1].t;
                        break;
                }
                if (cf = styles.CellXf[val1[0].iStyleRef]) $77f9f80a0cede680$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$77f9f80a0cede680$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $77f9f80a0cede680$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val1.length > 3) p.f = val1[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $77f9f80a0cede680$var$fmt_is_date($77f9f80a0cede680$var$table_fmt[cf.numFmtId])) {
                    var _d = $77f9f80a0cede680$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$77f9f80a0cede680$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val1);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val1 - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val1.relId];
                if (rel) {
                    val1.Target = rel.Target;
                    if (val1.loc) val1.Target += "#" + val1.loc;
                    val1.Rel = rel;
                } else if (val1.relId == '') val1.Target = "#" + val1.loc;
                for(R = val1.rfx.s.r; R <= val1.rfx.e.r; ++R)for(C = val1.rfx.s.c; C <= val1.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val1;
                } else {
                    addr = $77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val1;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val1);
                cell = opts.dense ? s["!data"][R][C] : s[$77f9f80a0cede680$var$encode_col(C) + rr];
                cell.f = $77f9f80a0cede680$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $77f9f80a0cede680$var$encode_range(val1[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$77f9f80a0cede680$var$encode_cell(val1[0].s)] = val1[1];
                cell = opts.dense ? s["!data"][R][C] : s[$77f9f80a0cede680$var$encode_col(C) + rr];
                cell.f = $77f9f80a0cede680$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val1.e >= val1.s){
                    colinfo[val1.e--] = {
                        width: val1.w / 256,
                        hidden: !!(val1.flags & 0x01),
                        level: val1.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $77f9f80a0cede680$var$find_mdw_colw(val1.w / 256);
                    }
                    $77f9f80a0cede680$var$process_col(colinfo[val1.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val1) s["!legrel"] = val1;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $77f9f80a0cede680$var$encode_range(val1)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val1;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                if (val1.above || val1.left) s['!outline'] = {
                    above: val1.above,
                    left: val1.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val1.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $77f9f80a0cede680$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $77f9f80a0cede680$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $77f9f80a0cede680$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $77f9f80a0cede680$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $77f9f80a0cede680$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $77f9f80a0cede680$var$dup(cell);
            cell.z = cell.z || $77f9f80a0cede680$var$table_fmt[14];
            cell.v = $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $77f9f80a0cede680$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $77f9f80a0cede680$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $77f9f80a0cede680$var$write_BrtShortIsst(cell, o));
                else $77f9f80a0cede680$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $77f9f80a0cede680$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x0011 /* BrtShortSt */ , $77f9f80a0cede680$var$write_BrtShortSt(cell, o));
                else $77f9f80a0cede680$var$write_record(ba, 0x0006 /* BrtCellSt */ , $77f9f80a0cede680$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x000D /* BrtShortRk */ , $77f9f80a0cede680$var$write_BrtShortRk(cell, o));
                else $77f9f80a0cede680$var$write_record(ba, 0x0002 /* BrtCellRk */ , $77f9f80a0cede680$var$write_BrtCellRk(cell, o));
            } else if (!isFinite(cell.v)) {
                o.t = "e";
                if (isNaN(cell.v)) {
                    if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x000E /* BrtShortError */ , $77f9f80a0cede680$var$write_BrtShortError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                    else $77f9f80a0cede680$var$write_record(ba, 0x0003 /* BrtCellError */ , $77f9f80a0cede680$var$write_BrtCellError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                } else if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x000E /* BrtShortError */ , $77f9f80a0cede680$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $77f9f80a0cede680$var$write_record(ba, 0x0003 /* BrtCellError */ , $77f9f80a0cede680$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x0010 /* BrtShortReal */ , $77f9f80a0cede680$var$write_BrtShortReal(cell, o));
            else $77f9f80a0cede680$var$write_record(ba, 0x0005 /* BrtCellReal */ , $77f9f80a0cede680$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x000F /* BrtShortBool */ , $77f9f80a0cede680$var$write_BrtShortBool(cell, o));
            else $77f9f80a0cede680$var$write_record(ba, 0x0004 /* BrtCellBool */ , $77f9f80a0cede680$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x000E /* BrtShortError */ , $77f9f80a0cede680$var$write_BrtShortError(cell, o));
            else $77f9f80a0cede680$var$write_record(ba, 0x0003 /* BrtCellError */ , $77f9f80a0cede680$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $77f9f80a0cede680$var$write_record(ba, 0x000C /* BrtShortBlank */ , $77f9f80a0cede680$var$write_BrtShortBlank(cell, o));
    else $77f9f80a0cede680$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $77f9f80a0cede680$var$write_BrtCellBlank(cell, o));
    return true;
}
function $77f9f80a0cede680$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $77f9f80a0cede680$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null, row = dense ? ws["!data"][range.s.r] : [];
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $77f9f80a0cede680$var$encode_row(R);
        if (dense) row = ws["!data"][R];
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $77f9f80a0cede680$var$write_row_header(ba, ws, range, R);
        if (dense && !row) continue;
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $77f9f80a0cede680$var$encode_col(C);
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $77f9f80a0cede680$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $77f9f80a0cede680$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $77f9f80a0cede680$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $77f9f80a0cede680$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $77f9f80a0cede680$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $77f9f80a0cede680$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $77f9f80a0cede680$var$write_BrtMergeCell(m));
    });
    $77f9f80a0cede680$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $77f9f80a0cede680$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $77f9f80a0cede680$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $77f9f80a0cede680$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $77f9f80a0cede680$var$write_BrtColInfo(i, m));
    });
    $77f9f80a0cede680$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $77f9f80a0cede680$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $77f9f80a0cede680$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $77f9f80a0cede680$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $77f9f80a0cede680$var$write_BrtCellIgnoreEC($77f9f80a0cede680$var$safe_decode_range(ws['!ref'])));
    $77f9f80a0cede680$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $77f9f80a0cede680$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $77f9f80a0cede680$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $77f9f80a0cede680$var$RELS.HLINK);
        $77f9f80a0cede680$var$write_record(ba, 0x01EE /* BrtHLink */ , $77f9f80a0cede680$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $77f9f80a0cede680$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $77f9f80a0cede680$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $77f9f80a0cede680$var$RELS.VML);
        $77f9f80a0cede680$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $77f9f80a0cede680$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $77f9f80a0cede680$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $77f9f80a0cede680$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $77f9f80a0cede680$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $77f9f80a0cede680$var$decode_range(ws["!ref"]).e.r;
        ref = $77f9f80a0cede680$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $77f9f80a0cede680$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $77f9f80a0cede680$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $77f9f80a0cede680$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $77f9f80a0cede680$var$fix_range(ref)
    });
    $77f9f80a0cede680$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $77f9f80a0cede680$var$write_UncheckedRfX($77f9f80a0cede680$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $77f9f80a0cede680$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $77f9f80a0cede680$var$write_WSVIEWS2(ba, ws, Workbook) {
    $77f9f80a0cede680$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $77f9f80a0cede680$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $77f9f80a0cede680$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $77f9f80a0cede680$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $77f9f80a0cede680$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $77f9f80a0cede680$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $77f9f80a0cede680$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $77f9f80a0cede680$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $77f9f80a0cede680$var$write_BrtSheetProtection(ws['!protect']));
}
function $77f9f80a0cede680$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $77f9f80a0cede680$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $77f9f80a0cede680$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $77f9f80a0cede680$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $77f9f80a0cede680$var$write_record(ba, 0x0093 /* BrtWsProp */ , $77f9f80a0cede680$var$write_BrtWsProp(c, ws['!outline']));
    $77f9f80a0cede680$var$write_record(ba, 0x0094 /* BrtWsDim */ , $77f9f80a0cede680$var$write_BrtWsDim(r));
    $77f9f80a0cede680$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $77f9f80a0cede680$var$write_WSFMTINFO(ba, ws);
    $77f9f80a0cede680$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $77f9f80a0cede680$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $77f9f80a0cede680$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $77f9f80a0cede680$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $77f9f80a0cede680$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $77f9f80a0cede680$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $77f9f80a0cede680$var$write_record(ba, 0x01DC /* BrtMargins */ , $77f9f80a0cede680$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $77f9f80a0cede680$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $77f9f80a0cede680$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $77f9f80a0cede680$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $77f9f80a0cede680$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $77f9f80a0cede680$var$unescapexml(($77f9f80a0cede680$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($77f9f80a0cede680$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $77f9f80a0cede680$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($77f9f80a0cede680$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $77f9f80a0cede680$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $77f9f80a0cede680$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $77f9f80a0cede680$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $77f9f80a0cede680$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($77f9f80a0cede680$var$sheetprregex);
    if (sheetPr) $77f9f80a0cede680$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $77f9f80a0cede680$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $77f9f80a0cede680$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $77f9f80a0cede680$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $77f9f80a0cede680$var$recordhopper(data, function cs_parse(val1, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val1;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $77f9f80a0cede680$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $77f9f80a0cede680$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $77f9f80a0cede680$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $77f9f80a0cede680$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $77f9f80a0cede680$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $77f9f80a0cede680$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $77f9f80a0cede680$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $77f9f80a0cede680$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $77f9f80a0cede680$var$parse_wb_defaults(wb) {
    $77f9f80a0cede680$var$push_defaults(wb.WBProps, $77f9f80a0cede680$var$WBPropsDef);
    $77f9f80a0cede680$var$push_defaults(wb.CalcPr, $77f9f80a0cede680$var$CalcPrDef);
    $77f9f80a0cede680$var$push_defaults_array(wb.WBView, $77f9f80a0cede680$var$WBViewDef);
    $77f9f80a0cede680$var$push_defaults_array(wb.Sheets, $77f9f80a0cede680$var$SheetDef);
    $77f9f80a0cede680$var$_ssfopts.date1904 = $77f9f80a0cede680$var$parsexmlbool(wb.WBProps.date1904);
}
function $77f9f80a0cede680$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $77f9f80a0cede680$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $77f9f80a0cede680$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $77f9f80a0cede680$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $77f9f80a0cede680$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $77f9f80a0cede680$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $77f9f80a0cede680$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $77f9f80a0cede680$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $77f9f80a0cede680$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$77f9f80a0cede680$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $77f9f80a0cede680$var$formula_quote_sheet_name(n) + "!" + $77f9f80a0cede680$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $77f9f80a0cede680$var$wbnsregex = /<\w+:workbook/;
function $77f9f80a0cede680$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($77f9f80a0cede680$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $77f9f80a0cede680$var$parsexmltag(x);
        switch($77f9f80a0cede680$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($77f9f80a0cede680$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $77f9f80a0cede680$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $77f9f80a0cede680$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $77f9f80a0cede680$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $77f9f80a0cede680$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($77f9f80a0cede680$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($77f9f80a0cede680$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $77f9f80a0cede680$var$parse_wb_defaults(wb);
    return wb;
}
function $77f9f80a0cede680$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $77f9f80a0cede680$var$XML_HEADER
    ];
    o[o.length] = $77f9f80a0cede680$var$writextag('workbook', null, {
        'xmlns': $77f9f80a0cede680$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $77f9f80a0cede680$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $77f9f80a0cede680$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $77f9f80a0cede680$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $77f9f80a0cede680$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $77f9f80a0cede680$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $77f9f80a0cede680$var$writextag('definedName', $77f9f80a0cede680$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $77f9f80a0cede680$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $77f9f80a0cede680$var$parse_RelID(data, length - 8);
    z.name = $77f9f80a0cede680$var$parse_XLWideString(data);
    return z;
}
function $77f9f80a0cede680$var$write_BrtBundleSh(data, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $77f9f80a0cede680$var$write_RelID(data.strRelID, o);
    $77f9f80a0cede680$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $77f9f80a0cede680$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $77f9f80a0cede680$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $77f9f80a0cede680$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $77f9f80a0cede680$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $77f9f80a0cede680$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $77f9f80a0cede680$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $77f9f80a0cede680$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $77f9f80a0cede680$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $77f9f80a0cede680$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $77f9f80a0cede680$var$write_BrtName(name, wb) {
    var o = $77f9f80a0cede680$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($77f9f80a0cede680$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $77f9f80a0cede680$var$write_XLWideString(dname),
        $77f9f80a0cede680$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($77f9f80a0cede680$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $77f9f80a0cede680$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $77f9f80a0cede680$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $77f9f80a0cede680$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $77f9f80a0cede680$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $77f9f80a0cede680$var$parse_BrtFRTArchID$
    };
    $77f9f80a0cede680$var$recordhopper(data, function hopper_wb(val1, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val1.name);
                wb.Sheets.push(val1);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val1;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val1.Sheet != null) opts.SID = val1.Sheet;
                val1.Ref = val1.Ptg ? $77f9f80a0cede680$var$stringify_formula(val1.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val1.Ptg;
                Names.push(val1);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val1
                ];
                else supbooks.push([
                    RT,
                    val1
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                supbooks.XTI = supbooks.XTI.concat(val1);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $77f9f80a0cede680$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $77f9f80a0cede680$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $77f9f80a0cede680$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $77f9f80a0cede680$var$write_record(ba, 0x009C /* BrtBundleSh */ , $77f9f80a0cede680$var$write_BrtBundleSh(d));
    }
    $77f9f80a0cede680$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $77f9f80a0cede680$var$write_BrtFileVersion(data, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $77f9f80a0cede680$var$write_XLWideString("SheetJS", o);
    $77f9f80a0cede680$var$write_XLWideString($77f9f80a0cede680$var$XLSX.version, o);
    $77f9f80a0cede680$var$write_XLWideString($77f9f80a0cede680$var$XLSX.version, o);
    $77f9f80a0cede680$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $77f9f80a0cede680$var$write_BrtBookView(idx, o) {
    if (!o) o = $77f9f80a0cede680$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $77f9f80a0cede680$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $77f9f80a0cede680$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $77f9f80a0cede680$var$write_record(ba, 0x009E /* BrtBookView */ , $77f9f80a0cede680$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $77f9f80a0cede680$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $77f9f80a0cede680$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $77f9f80a0cede680$var$write_record(ba, 0x0027 /* BrtName */ , $77f9f80a0cede680$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $77f9f80a0cede680$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $77f9f80a0cede680$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $77f9f80a0cede680$var$write_EXTERNALS_xlsb(ba, wb) {
    $77f9f80a0cede680$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $77f9f80a0cede680$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $77f9f80a0cede680$var$write_record(ba, 0x016A /* BrtExternSheet */ , $77f9f80a0cede680$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $77f9f80a0cede680$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $77f9f80a0cede680$var$write_wb_bin(wb, opts) {
    var ba = $77f9f80a0cede680$var$buf_array();
    $77f9f80a0cede680$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $77f9f80a0cede680$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $77f9f80a0cede680$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $77f9f80a0cede680$var$write_record(ba, 0x0099 /* BrtWbProp */ , $77f9f80a0cede680$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $77f9f80a0cede680$var$write_BOOKVIEWS(ba, wb, opts);
    $77f9f80a0cede680$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $77f9f80a0cede680$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $77f9f80a0cede680$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $77f9f80a0cede680$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $77f9f80a0cede680$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_wb_bin(data /*:any*/ , opts);
    return $77f9f80a0cede680$var$parse_wb_xml(data /*:any*/ , opts);
}
function $77f9f80a0cede680$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $77f9f80a0cede680$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $77f9f80a0cede680$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $77f9f80a0cede680$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $77f9f80a0cede680$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $77f9f80a0cede680$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $77f9f80a0cede680$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $77f9f80a0cede680$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $77f9f80a0cede680$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $77f9f80a0cede680$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $77f9f80a0cede680$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_sst_bin(data /*:any*/ , opts);
    return $77f9f80a0cede680$var$parse_sst_xml(data /*:any*/ , opts);
}
function $77f9f80a0cede680$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_comments_bin(data /*:any*/ , opts);
    return $77f9f80a0cede680$var$parse_comments_xml(data /*:any*/ , opts);
}
function $77f9f80a0cede680$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $77f9f80a0cede680$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $77f9f80a0cede680$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $77f9f80a0cede680$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $77f9f80a0cede680$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $77f9f80a0cede680$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $77f9f80a0cede680$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $77f9f80a0cede680$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $77f9f80a0cede680$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $77f9f80a0cede680$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($77f9f80a0cede680$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($77f9f80a0cede680$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $77f9f80a0cede680$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($77f9f80a0cede680$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($77f9f80a0cede680$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $77f9f80a0cede680$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $77f9f80a0cede680$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $77f9f80a0cede680$var$XLMLFormatMap[format] || $77f9f80a0cede680$var$unescapexml(format);
    if (fmt === "General") return $77f9f80a0cede680$var$SSF_general(value);
    return $77f9f80a0cede680$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $77f9f80a0cede680$var$xlml_set_custprop(Custprops, key, cp, val1 /*:string*/ ) {
    var oval /*:any*/  = val1;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $77f9f80a0cede680$var$parsexmlbool(val1);
            break;
        case "i2":
        case "int":
            oval = parseInt(val1, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val1);
            break;
        case "date":
        case "dateTime.tz":
            oval = $77f9f80a0cede680$var$parseDate(val1);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$77f9f80a0cede680$var$unescapexml(key)] = oval;
}
function $77f9f80a0cede680$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $77f9f80a0cede680$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $77f9f80a0cede680$var$SSF_general_num(cell.v);
            } else cell.w = $77f9f80a0cede680$var$SSF_general(cell.v);
        } else cell.w = $77f9f80a0cede680$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $77f9f80a0cede680$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $77f9f80a0cede680$var$fmt_is_date(z)) {
            var _d = $77f9f80a0cede680$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $77f9f80a0cede680$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $77f9f80a0cede680$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $77f9f80a0cede680$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $77f9f80a0cede680$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $77f9f80a0cede680$var$xlml_fixstr($77f9f80a0cede680$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $77f9f80a0cede680$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $77f9f80a0cede680$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $77f9f80a0cede680$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $77f9f80a0cede680$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $77f9f80a0cede680$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $77f9f80a0cede680$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $77f9f80a0cede680$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $77f9f80a0cede680$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $77f9f80a0cede680$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $77f9f80a0cede680$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $77f9f80a0cede680$var$xlml_prefix_dname(dname) {
    return $77f9f80a0cede680$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $77f9f80a0cede680$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $77f9f80a0cede680$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $77f9f80a0cede680$var$make_ssf();
    var str = $77f9f80a0cede680$var$debom($77f9f80a0cede680$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $77f9f80a0cede680$var$$cptable !== 'undefined') str = $77f9f80a0cede680$var$$cptable.utils.decode(65001, $77f9f80a0cede680$var$char_codes(str));
        else str = $77f9f80a0cede680$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $77f9f80a0cede680$var$dup(opts);
        _o.type = "string";
        return $77f9f80a0cede680$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $77f9f80a0cede680$var$html_to_workbook(str, opts);
    $77f9f80a0cede680$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $77f9f80a0cede680$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $77f9f80a0cede680$var$table_fmt[15],
        "Short Date": $77f9f80a0cede680$var$table_fmt[14],
        "Long Time": $77f9f80a0cede680$var$table_fmt[19],
        "Medium Time": $77f9f80a0cede680$var$table_fmt[18],
        "Short Time": $77f9f80a0cede680$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $77f9f80a0cede680$var$table_fmt[2],
        "Standard": $77f9f80a0cede680$var$table_fmt[4],
        "Percent": $77f9f80a0cede680$var$table_fmt[10],
        "Scientific": $77f9f80a0cede680$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($77f9f80a0cede680$var$DENSE != null && opts.dense == null) opts.dense = $77f9f80a0cede680$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $77f9f80a0cede680$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $77f9f80a0cede680$var$xlmlregex.lastIndex = 0;
    str = $77f9f80a0cede680$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $77f9f80a0cede680$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $77f9f80a0cede680$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$77f9f80a0cede680$var$encode_col(c) + $77f9f80a0cede680$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $77f9f80a0cede680$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$77f9f80a0cede680$var$encode_col(cma) + $77f9f80a0cede680$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $77f9f80a0cede680$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $77f9f80a0cede680$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $77f9f80a0cede680$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
                sheetname = $77f9f80a0cede680$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $77f9f80a0cede680$var$process_style_xlml(styles, stag, opts);
            else stag = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $77f9f80a0cede680$var$unescapexml($77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($77f9f80a0cede680$var$XLMLFormatMap[stag.nf]) stag.nf = $77f9f80a0cede680$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($77f9f80a0cede680$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($77f9f80a0cede680$var$table_fmt[ssfidx] == null) {
                    $77f9f80a0cede680$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $77f9f80a0cede680$var$MDW = $77f9f80a0cede680$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $77f9f80a0cede680$var$process_col(cstys[_col]);
            }
            if (seencol) $77f9f80a0cede680$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $77f9f80a0cede680$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $77f9f80a0cede680$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $77f9f80a0cede680$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $77f9f80a0cede680$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $77f9f80a0cede680$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $77f9f80a0cede680$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
                if (!$77f9f80a0cede680$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $77f9f80a0cede680$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $77f9f80a0cede680$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $77f9f80a0cede680$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $77f9f80a0cede680$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $77f9f80a0cede680$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$77f9f80a0cede680$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$77f9f80a0cede680$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $77f9f80a0cede680$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$77f9f80a0cede680$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$77f9f80a0cede680$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $77f9f80a0cede680$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $77f9f80a0cede680$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $77f9f80a0cede680$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $77f9f80a0cede680$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $77f9f80a0cede680$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $77f9f80a0cede680$var$parse_xlml_xml($77f9f80a0cede680$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $77f9f80a0cede680$var$parse_xlml_xml(data, opts);
        case "array":
            return $77f9f80a0cede680$var$parse_xlml_xml($77f9f80a0cede680$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $77f9f80a0cede680$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($77f9f80a0cede680$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($77f9f80a0cede680$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $77f9f80a0cede680$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $77f9f80a0cede680$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($77f9f80a0cede680$var$writextag('NumberFormat', null, {
            "ss:Format": $77f9f80a0cede680$var$escapexml($77f9f80a0cede680$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($77f9f80a0cede680$var$writextag('Style', payload.join(""), o));
    });
    return $77f9f80a0cede680$var$writextag("Styles", styles.join(""));
}
function $77f9f80a0cede680$var$write_name_xlml(n) {
    return $77f9f80a0cede680$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $77f9f80a0cede680$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $77f9f80a0cede680$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($77f9f80a0cede680$var$write_name_xlml(n));
    }
    return $77f9f80a0cede680$var$writextag("Names", out.join(""));
}
function $77f9f80a0cede680$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($77f9f80a0cede680$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $77f9f80a0cede680$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($77f9f80a0cede680$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($77f9f80a0cede680$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($77f9f80a0cede680$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($77f9f80a0cede680$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($77f9f80a0cede680$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($77f9f80a0cede680$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($77f9f80a0cede680$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($77f9f80a0cede680$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($77f9f80a0cede680$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $77f9f80a0cede680$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $77f9f80a0cede680$var$XLMLNS.x
    });
}
function $77f9f80a0cede680$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $77f9f80a0cede680$var$xlml_unfixstr(c.t || "");
        var d = $77f9f80a0cede680$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $77f9f80a0cede680$var$writextag("Comment", d, p);
    }).join("");
}
function $77f9f80a0cede680$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $77f9f80a0cede680$var$escapexml($77f9f80a0cede680$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $77f9f80a0cede680$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $77f9f80a0cede680$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $77f9f80a0cede680$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            if (!isFinite(cell.v)) {
                t = 'Error';
                p = $77f9f80a0cede680$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
            } else {
                t = 'Number';
                p = String(cell.v);
            }
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $77f9f80a0cede680$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $77f9f80a0cede680$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $77f9f80a0cede680$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $77f9f80a0cede680$var$write_ws_xlml_comment(cell.c);
    return $77f9f80a0cede680$var$writextag("Cell", m, attr);
}
function $77f9f80a0cede680$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $77f9f80a0cede680$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $77f9f80a0cede680$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $77f9f80a0cede680$var$process_col(n);
        var w = !!n.width;
        var p = $77f9f80a0cede680$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $77f9f80a0cede680$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($77f9f80a0cede680$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    var addr = {
        r: 0,
        c: 0
    };
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $77f9f80a0cede680$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        addr.r = R;
        for(var C = range.s.c; C <= range.e.c; ++C){
            addr.c = C;
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var ref = $77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($77f9f80a0cede680$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $77f9f80a0cede680$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $77f9f80a0cede680$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $77f9f80a0cede680$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($77f9f80a0cede680$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws && ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $77f9f80a0cede680$var$a1_to_rc($77f9f80a0cede680$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $77f9f80a0cede680$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    if (wb.SSF) {
        $77f9f80a0cede680$var$make_ssf();
        $77f9f80a0cede680$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $77f9f80a0cede680$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($77f9f80a0cede680$var$write_props_xlml(wb, opts));
    d.push($77f9f80a0cede680$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push($77f9f80a0cede680$var$write_names_xlml(wb, opts));
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($77f9f80a0cede680$var$writextag("Worksheet", $77f9f80a0cede680$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $77f9f80a0cede680$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $77f9f80a0cede680$var$write_sty_xlml(wb, opts);
    return $77f9f80a0cede680$var$XML_HEADER + $77f9f80a0cede680$var$writextag("Workbook", d.join(""), {
        'xmlns': $77f9f80a0cede680$var$XLMLNS.ss,
        'xmlns:o': $77f9f80a0cede680$var$XLMLNS.o,
        'xmlns:x': $77f9f80a0cede680$var$XLMLNS.x,
        'xmlns:ss': $77f9f80a0cede680$var$XLMLNS.ss,
        'xmlns:dt': $77f9f80a0cede680$var$XLMLNS.dt,
        'xmlns:html': $77f9f80a0cede680$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $77f9f80a0cede680$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $77f9f80a0cede680$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $77f9f80a0cede680$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $77f9f80a0cede680$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $77f9f80a0cede680$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $77f9f80a0cede680$var$__readUInt16LE(blob, blob.l), next = $77f9f80a0cede680$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $77f9f80a0cede680$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $77f9f80a0cede680$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $77f9f80a0cede680$var$XLSRecordEnum[nextrt = $77f9f80a0cede680$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $77f9f80a0cede680$var$bconcat(bufs);
    $77f9f80a0cede680$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $77f9f80a0cede680$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $77f9f80a0cede680$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $77f9f80a0cede680$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $77f9f80a0cede680$var$SSF_general_num(p.v);
            } else p.w = $77f9f80a0cede680$var$SSF_general(p.v);
        } else p.w = $77f9f80a0cede680$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $77f9f80a0cede680$var$fmt_is_date($77f9f80a0cede680$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $77f9f80a0cede680$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $77f9f80a0cede680$var$make_cell(val1, ixfe, t) /*:Cell*/ {
    return {
        v: val1,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $77f9f80a0cede680$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($77f9f80a0cede680$var$DENSE != null && options.dense == null) options.dense = $77f9f80a0cede680$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $77f9f80a0cede680$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $77f9f80a0cede680$var$XLSIcv[icv];
        return $77f9f80a0cede680$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $77f9f80a0cede680$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $77f9f80a0cede680$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $77f9f80a0cede680$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $77f9f80a0cede680$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $77f9f80a0cede680$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $77f9f80a0cede680$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $77f9f80a0cede680$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val1 /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val1 = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val1 = /*::(*/ $77f9f80a0cede680$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val1;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val1;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val1.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val1.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val1;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val1);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $77f9f80a0cede680$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val1;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val1;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val1;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val1;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val1;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val1;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val1;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val1;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val1;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val1;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val1;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val1.fDialog) out["!type"] = "dialog";
                    if (!val1.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val1.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val1);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val1
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val1);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val1.Name,
                        Ref: $77f9f80a0cede680$var$stringify_formula(val1.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val1.itab > 0) last_lbl.Sheet = val1.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val1);
                    if (val1.Name == "_xlnm._FilterDatabase" && val1.itab > 0) {
                        if (val1.rgce && val1.rgce[0] && val1.rgce[0][0] && val1.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val1.itab - 1] = {
                            ref: $77f9f80a0cede680$var$encode_range(val1.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val1;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                    supbooks.XTI = supbooks.XTI.concat(val1);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val1[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val1;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val1 !== 0 && opts.WTF) console.error("Password verifier: " + val1);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val1.pos] = val1;
                    opts.snames.push(val1.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $77f9f80a0cede680$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $77f9f80a0cede680$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val1.BIFFVer] || 8;
                    opts.biffguess = val1.BIFFVer == 0;
                    if (val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $77f9f80a0cede680$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val1.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val1.BIFFVer == 0 && val1.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $77f9f80a0cede680$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val1.dt == 0x20) out["!type"] = "chart";
                    if (val1.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val1.r] || [])[val1.c] : out[$77f9f80a0cede680$var$encode_col(val1.c) + $77f9f80a0cede680$var$encode_row(val1.r)]) ++val1.c;
                    }
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe] || {},
                        v: val1.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.val,
                        t: val1.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val1.c; j <= val1.C; ++j){
                        var ixfe = val1.rkrec[j - val1.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val1.rkrec[j - val1.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val1.val == 'String') {
                        last_formula = val1;
                        break;
                    }
                    temp_val = $77f9f80a0cede680$var$make_cell(val1.val, val1.cell.ixfe, val1.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val1.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $77f9f80a0cede680$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $77f9f80a0cede680$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $77f9f80a0cede680$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val1.cell, temp_val, options);
                    last_formula = val1;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val1;
                        temp_val = $77f9f80a0cede680$var$make_cell(val1, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $77f9f80a0cede680$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val1);
                    var _arraystart = $77f9f80a0cede680$var$encode_cell(val1[0].s);
                    cc = options.dense ? (out["!data"][val1[0].s.r] || [])[val1[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $77f9f80a0cede680$var$stringify_formula(val1[1], range, val1[0], supbooks, opts);
                        cc.F = $77f9f80a0cede680$var$encode_range(val1[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$77f9f80a0cede680$var$encode_cell(last_formula.cell)] = val1[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$77f9f80a0cede680$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $77f9f80a0cede680$var$stringify_formula(val1[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $77f9f80a0cede680$var$make_cell(sst[val1.isst].t, val1.ixfe, 's');
                    if (sst[val1.isst].h) temp_val.h = sst[val1.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val1.ixfe,
                            XF: XFs[val1.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val1.c,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val1.c; _j <= val1.C; ++_j){
                        var _ixfe = val1.ixfe[_j - val1.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $77f9f80a0cede680$var$make_cell(val1.val, val1.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $77f9f80a0cede680$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val1; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val1;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val1[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($77f9f80a0cede680$var$table_fmt[b4idx] == val1[1]) break;
                        if (b4idx >= 163) $77f9f80a0cede680$var$SSF__load(val1[1], BIFF2Fmt + 163);
                    } else $77f9f80a0cede680$var$SSF__load(val1[1], val1[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val1;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($77f9f80a0cede680$var$table_fmt[b2idx] == val1) break;
                    if (b2idx >= 163) $77f9f80a0cede680$var$SSF__load(val1, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val1);
                    break;
                case 0x005d /* Obj */ :
                    objects[val1.cmo[0]] = opts.lastobj = val1;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val1;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val1;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$77f9f80a0cede680$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val1[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$77f9f80a0cede680$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val1[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val1[0].r] || [])[val1[0].c] : out[$77f9f80a0cede680$var$encode_cell(val1[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val1[0].r]) out["!data"][val1[0].r] = [];
                            cc = out["!data"][val1[0].r][val1[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$77f9f80a0cede680$var$encode_cell(val1[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val1[0].r);
                        range.s.r = Math.min(range.s.r, val1[0].r);
                        range.e.c = Math.max(range.e.c, val1[0].c);
                        range.s.c = Math.min(range.s.c, val1[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val1[1]
                    };
                    else {
                        var noteobj = objects[val1[2]];
                        cmnt = {
                            a: val1[1],
                            t: noteobj.TxO.t
                        };
                        if (val1[3] != null && !(val1[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $77f9f80a0cede680$var$update_xfext(XFs[val1.ixfe], val1.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val1.e >= val1.s){
                        colinfo[val1.e--] = {
                            width: val1.w / 256,
                            level: val1.level || 0,
                            hidden: !!(val1.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $77f9f80a0cede680$var$find_mdw_colw(val1.w / 256);
                        }
                        $77f9f80a0cede680$var$process_col(colinfo[val1.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val1.level != null) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.level = val1.level;
                    }
                    if (val1.hidden) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val1.hpt) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hpt = val1.hpt;
                        rowobj.hpx = $77f9f80a0cede680$var$pt2px(val1.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $77f9f80a0cede680$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val1;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $77f9f80a0cede680$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val1.header;
                    out['!margins'].footer = val1.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val1.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val1;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val1;
                    break;
                case 0x008c /* Country */ :
                    country = val1;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val1 || "ThisWorkbook";
                    else wsprops.CodeName = val1 || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $77f9f80a0cede680$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $77f9f80a0cede680$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $77f9f80a0cede680$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $77f9f80a0cede680$var$parse_PropertySetStream(DSI, $77f9f80a0cede680$var$DocSummaryPIDDSI, $77f9f80a0cede680$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $77f9f80a0cede680$var$parse_PropertySetStream(SI, $77f9f80a0cede680$var$SummaryPIDSI, $77f9f80a0cede680$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $77f9f80a0cede680$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $77f9f80a0cede680$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $77f9f80a0cede680$var$evert_key($77f9f80a0cede680$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $77f9f80a0cede680$var$evert_key($77f9f80a0cede680$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $77f9f80a0cede680$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $77f9f80a0cede680$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($77f9f80a0cede680$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $77f9f80a0cede680$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $77f9f80a0cede680$var$write_PropertySetStream(SEntries, $77f9f80a0cede680$var$PSCLSID.SI, SummaryRE, $77f9f80a0cede680$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $77f9f80a0cede680$var$write_PropertySetStream(DSEntries, $77f9f80a0cede680$var$PSCLSID.DSI, DocSummaryRE, $77f9f80a0cede680$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $77f9f80a0cede680$var$PSCLSID.UDI));
}
function $77f9f80a0cede680$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $77f9f80a0cede680$var$fix_read_opts(options);
    $77f9f80a0cede680$var$reset_cp();
    if (options.codepage) $77f9f80a0cede680$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $77f9f80a0cede680$var$s2a($77f9f80a0cede680$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $77f9f80a0cede680$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $77f9f80a0cede680$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $77f9f80a0cede680$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $77f9f80a0cede680$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $77f9f80a0cede680$var$parse_workbook(WB.content, options);
        else if ((_data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $77f9f80a0cede680$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $77f9f80a0cede680$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $77f9f80a0cede680$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $77f9f80a0cede680$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $77f9f80a0cede680$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $77f9f80a0cede680$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $77f9f80a0cede680$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $77f9f80a0cede680$var$fill_vba_xls(cfb, $77f9f80a0cede680$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $77f9f80a0cede680$var$XLSBRecordEnum = {
    0x0000: {
        f: $77f9f80a0cede680$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $77f9f80a0cede680$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $77f9f80a0cede680$var$parse_BrtCellRk
    },
    0x0003: {
        f: $77f9f80a0cede680$var$parse_BrtCellError
    },
    0x0004: {
        f: $77f9f80a0cede680$var$parse_BrtCellBool
    },
    0x0005: {
        f: $77f9f80a0cede680$var$parse_BrtCellReal
    },
    0x0006: {
        f: $77f9f80a0cede680$var$parse_BrtCellSt
    },
    0x0007: {
        f: $77f9f80a0cede680$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $77f9f80a0cede680$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $77f9f80a0cede680$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $77f9f80a0cede680$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $77f9f80a0cede680$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $77f9f80a0cede680$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $77f9f80a0cede680$var$parse_BrtShortRk
    },
    0x000E: {
        f: $77f9f80a0cede680$var$parse_BrtShortError
    },
    0x000F: {
        f: $77f9f80a0cede680$var$parse_BrtShortBool
    },
    0x0010: {
        f: $77f9f80a0cede680$var$parse_BrtShortReal
    },
    0x0011: {
        f: $77f9f80a0cede680$var$parse_BrtShortSt
    },
    0x0012: {
        f: $77f9f80a0cede680$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $77f9f80a0cede680$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $77f9f80a0cede680$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $77f9f80a0cede680$var$parse_BrtFont
    },
    0x002C: {
        f: $77f9f80a0cede680$var$parse_BrtFmt
    },
    0x002D: {
        f: $77f9f80a0cede680$var$parse_BrtFill
    },
    0x002E: {
        f: $77f9f80a0cede680$var$parse_BrtBorder
    },
    0x002F: {
        f: $77f9f80a0cede680$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $77f9f80a0cede680$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $77f9f80a0cede680$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $77f9f80a0cede680$var$parse_ColInfo
    },
    0x003E: {
        f: $77f9f80a0cede680$var$parse_BrtCellRString
    },
    0x003F: {
        f: $77f9f80a0cede680$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $77f9f80a0cede680$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $77f9f80a0cede680$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $77f9f80a0cede680$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $77f9f80a0cede680$var$parse_BrtWsProp
    },
    0x0094: {
        f: $77f9f80a0cede680$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $77f9f80a0cede680$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $77f9f80a0cede680$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $77f9f80a0cede680$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $77f9f80a0cede680$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $77f9f80a0cede680$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $77f9f80a0cede680$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $77f9f80a0cede680$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $77f9f80a0cede680$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $77f9f80a0cede680$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $77f9f80a0cede680$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $77f9f80a0cede680$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $77f9f80a0cede680$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $77f9f80a0cede680$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $77f9f80a0cede680$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $77f9f80a0cede680$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $77f9f80a0cede680$var$parse_RelID
    },
    0x0227: {
        f: $77f9f80a0cede680$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $77f9f80a0cede680$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $77f9f80a0cede680$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $77f9f80a0cede680$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $77f9f80a0cede680$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $77f9f80a0cede680$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $77f9f80a0cede680$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $77f9f80a0cede680$var$parse_Formula
    },
    0x000a: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x000c: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x000d: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x000e: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x000f: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0010: {
        f: $77f9f80a0cede680$var$parse_Xnum
    },
    0x0011: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0012: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0013: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x0014: {
        f: $77f9f80a0cede680$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $77f9f80a0cede680$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $77f9f80a0cede680$var$parse_ExternSheet
    },
    0x0018: {
        f: $77f9f80a0cede680$var$parse_Lbl
    },
    0x0019: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $77f9f80a0cede680$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0023: {
        f: $77f9f80a0cede680$var$parse_ExternName
    },
    0x0026: {
        f: $77f9f80a0cede680$var$parse_Xnum
    },
    0x0027: {
        f: $77f9f80a0cede680$var$parse_Xnum
    },
    0x0028: {
        f: $77f9f80a0cede680$var$parse_Xnum
    },
    0x0029: {
        f: $77f9f80a0cede680$var$parse_Xnum
    },
    0x002a: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x002b: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x002f: {
        f: $77f9f80a0cede680$var$parse_FilePass
    },
    0x0031: {
        f: $77f9f80a0cede680$var$parse_Font
    },
    0x0033: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $77f9f80a0cede680$var$parse_Window1
    },
    0x0040: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0041: {
        f: $77f9f80a0cede680$var$parse_Pane
    },
    0x0042: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $77f9f80a0cede680$var$parse_WriteAccess
    },
    0x005d: {
        f: $77f9f80a0cede680$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x007d: {
        f: $77f9f80a0cede680$var$parse_ColInfo
    },
    0x0080: {
        f: $77f9f80a0cede680$var$parse_Guts
    },
    0x0081: {
        f: $77f9f80a0cede680$var$parse_WsBool
    },
    0x0082: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x0083: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0084: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0085: {
        f: $77f9f80a0cede680$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $77f9f80a0cede680$var$parse_Country
    },
    0x008d: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $77f9f80a0cede680$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $77f9f80a0cede680$var$parse_Scl
    },
    0x00a1: {
        f: $77f9f80a0cede680$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $77f9f80a0cede680$var$parse_MulRk
    },
    0x00be: {
        f: $77f9f80a0cede680$var$parse_MulBlank
    },
    0x00c1: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $77f9f80a0cede680$var$parse_XF
    },
    0x00e1: {
        f: $77f9f80a0cede680$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $77f9f80a0cede680$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $77f9f80a0cede680$var$parse_SST
    },
    0x00fd: {
        f: $77f9f80a0cede680$var$parse_LabelSst
    },
    0x00ff: {
        f: $77f9f80a0cede680$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $77f9f80a0cede680$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x0161: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $77f9f80a0cede680$var$parse_SupBook
    },
    0x01af: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $77f9f80a0cede680$var$parse_TxO
    },
    0x01b7: {
        f: $77f9f80a0cede680$var$parsebool
    },
    0x01b8: {
        f: $77f9f80a0cede680$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $77f9f80a0cede680$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x01c1: {
        f: $77f9f80a0cede680$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x0200: {
        f: $77f9f80a0cede680$var$parse_Dimensions
    },
    0x0201: {
        f: $77f9f80a0cede680$var$parse_Blank
    },
    0x0203: {
        f: $77f9f80a0cede680$var$parse_Number
    },
    0x0204: {
        f: $77f9f80a0cede680$var$parse_Label
    },
    0x0205: {
        f: $77f9f80a0cede680$var$parse_BoolErr
    },
    0x0207: {
        f: $77f9f80a0cede680$var$parse_String
    },
    0x0208: {
        f: $77f9f80a0cede680$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $77f9f80a0cede680$var$parse_Array
    },
    0x0225: {
        f: $77f9f80a0cede680$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $77f9f80a0cede680$var$parse_Window2
    },
    0x027e: {
        f: $77f9f80a0cede680$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $77f9f80a0cede680$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $77f9f80a0cede680$var$parse_ShrFmla
    },
    0x0800: {
        f: $77f9f80a0cede680$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $77f9f80a0cede680$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $77f9f80a0cede680$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $77f9f80a0cede680$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $77f9f80a0cede680$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $77f9f80a0cede680$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $77f9f80a0cede680$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $77f9f80a0cede680$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $77f9f80a0cede680$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $77f9f80a0cede680$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $77f9f80a0cede680$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $77f9f80a0cede680$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $77f9f80a0cede680$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $77f9f80a0cede680$var$parse_BIFF2INT
    },
    0x0003: {
        f: $77f9f80a0cede680$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $77f9f80a0cede680$var$parse_BIFF2STR
    },
    0x0005: {
        f: $77f9f80a0cede680$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $77f9f80a0cede680$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $77f9f80a0cede680$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x001e: {
        f: $77f9f80a0cede680$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $77f9f80a0cede680$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $77f9f80a0cede680$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $77f9f80a0cede680$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $77f9f80a0cede680$var$parse_BIFF2XF
    },
    0x0044: {
        f: $77f9f80a0cede680$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $77f9f80a0cede680$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $77f9f80a0cede680$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $77f9f80a0cede680$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $77f9f80a0cede680$var$parse_Formula
    },
    0x0209: {
        f: $77f9f80a0cede680$var$parse_BOF
    },
    0x0218: {
        f: $77f9f80a0cede680$var$parse_Lbl
    },
    0x0223: {
        f: $77f9f80a0cede680$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $77f9f80a0cede680$var$parse_BIFF3XF
    },
    0x0406: {
        f: $77f9f80a0cede680$var$parse_Formula
    },
    0x0409: {
        f: $77f9f80a0cede680$var$parse_BOF
    },
    0x0443: {
        f: $77f9f80a0cede680$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $77f9f80a0cede680$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $77f9f80a0cede680$var$is_buf(payload)) ba.push(payload);
}
function $77f9f80a0cede680$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $77f9f80a0cede680$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $77f9f80a0cede680$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val1, t /*:?string*/ ) {
    var out = $77f9f80a0cede680$var$new_buf(9);
    $77f9f80a0cede680$var$write_BIFF2Cell(out, r, c);
    $77f9f80a0cede680$var$write_Bes(val1, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $77f9f80a0cede680$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val1) {
    var out = $77f9f80a0cede680$var$new_buf(8 + 2 * val1.length);
    $77f9f80a0cede680$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val1.length);
    out.write_shift(val1.length, val1, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $77f9f80a0cede680$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $77f9f80a0cede680$var$write_biff_rec(ba, 0x001C, $77f9f80a0cede680$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x001C, $77f9f80a0cede680$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$77f9f80a0cede680$var$write_biff_rec(ba, 0x001C, $77f9f80a0cede680$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $77f9f80a0cede680$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0002, $77f9f80a0cede680$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0005, $77f9f80a0cede680$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0005, $77f9f80a0cede680$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0003, $77f9f80a0cede680$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0005, $77f9f80a0cede680$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0004, $77f9f80a0cede680$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0001, $77f9f80a0cede680$var$write_BIFF2Cell(null, R, C));
}
function $77f9f80a0cede680$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $77f9f80a0cede680$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $77f9f80a0cede680$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $77f9f80a0cede680$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $77f9f80a0cede680$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $77f9f80a0cede680$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $77f9f80a0cede680$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $77f9f80a0cede680$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $77f9f80a0cede680$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0022, $77f9f80a0cede680$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $77f9f80a0cede680$var$buf_array();
    $77f9f80a0cede680$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $77f9f80a0cede680$var$write_biff_rec(ba, 0x001E, $77f9f80a0cede680$var$write_BIFF2Format(f));
        else $77f9f80a0cede680$var$write_biff_rec(ba, 0x041E, $77f9f80a0cede680$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $77f9f80a0cede680$var$write_biff_rec(ba, 0x0043, $77f9f80a0cede680$var$write_BIFF2XF(xf));
                break;
            case 3:
                $77f9f80a0cede680$var$write_biff_rec(ba, 0x0243, $77f9f80a0cede680$var$write_BIFF3XF(xf));
                break;
            case 4:
                $77f9f80a0cede680$var$write_biff_rec(ba, 0x0443, $77f9f80a0cede680$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $77f9f80a0cede680$var$b8oid = 1, $77f9f80a0cede680$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $77f9f80a0cede680$var$write_MsoDrawingGroup() {
    var buf = $77f9f80a0cede680$var$new_buf(82 + 8 * $77f9f80a0cede680$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $77f9f80a0cede680$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $77f9f80a0cede680$var$b8ocnts.length);
    buf.write_shift(4, $77f9f80a0cede680$var$b8oid);
    buf.write_shift(4, $77f9f80a0cede680$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $77f9f80a0cede680$var$b8ocnts.length; ++i)acc += $77f9f80a0cede680$var$b8ocnts[i] && $77f9f80a0cede680$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $77f9f80a0cede680$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $77f9f80a0cede680$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $77f9f80a0cede680$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $77f9f80a0cede680$var$buf_array(), baseid = $77f9f80a0cede680$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$77f9f80a0cede680$var$b8oid;
        var oasc = $77f9f80a0cede680$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $77f9f80a0cede680$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $77f9f80a0cede680$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $77f9f80a0cede680$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $77f9f80a0cede680$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $77f9f80a0cede680$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $77f9f80a0cede680$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $77f9f80a0cede680$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $77f9f80a0cede680$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $77f9f80a0cede680$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $77f9f80a0cede680$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $77f9f80a0cede680$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $77f9f80a0cede680$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $77f9f80a0cede680$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $77f9f80a0cede680$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $77f9f80a0cede680$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $77f9f80a0cede680$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $77f9f80a0cede680$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $77f9f80a0cede680$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $77f9f80a0cede680$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x001C, n);
    });
    $77f9f80a0cede680$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $77f9f80a0cede680$var$b8oid
    ]);
    ++$77f9f80a0cede680$var$b8oid;
}
function $77f9f80a0cede680$var$write_FONTS_biff8(ba, data, opts) {
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0031 /* Font */ , $77f9f80a0cede680$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $77f9f80a0cede680$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $77f9f80a0cede680$var$write_biff_rec(ba, 0x041E /* Format */ , $77f9f80a0cede680$var$write_Format(i, NF[i], opts));
    });
}
function $77f9f80a0cede680$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $77f9f80a0cede680$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $77f9f80a0cede680$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $77f9f80a0cede680$var$write_Ref8U($77f9f80a0cede680$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $77f9f80a0cede680$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$77f9f80a0cede680$var$write_biff_rec(ba, 0x00e0 /* XF */ , $77f9f80a0cede680$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x00e0 /* XF */ , $77f9f80a0cede680$var$write_XF(c, 0, opts));
    });
}
function $77f9f80a0cede680$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $77f9f80a0cede680$var$write_HLink(HL));
        if (HL[1].Tooltip) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $77f9f80a0cede680$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $77f9f80a0cede680$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $77f9f80a0cede680$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $77f9f80a0cede680$var$write_ColInfo($77f9f80a0cede680$var$col_obj_w(idx, col), idx));
    });
}
function $77f9f80a0cede680$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $77f9f80a0cede680$var$write_biff_rec(ba, 0x0201 /* Blank */ , $77f9f80a0cede680$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0006 /* Formula */ , $77f9f80a0cede680$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $77f9f80a0cede680$var$datenum($77f9f80a0cede680$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $77f9f80a0cede680$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $77f9f80a0cede680$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $77f9f80a0cede680$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $77f9f80a0cede680$var$write_biff_rec(ba, 0x0203 /* Number */ , $77f9f80a0cede680$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $77f9f80a0cede680$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $77f9f80a0cede680$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $77f9f80a0cede680$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $77f9f80a0cede680$var$write_LabelSst(R, C, isst, os, opts));
            } else $77f9f80a0cede680$var$write_biff_rec(ba, 0x0204 /* Label */ , $77f9f80a0cede680$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $77f9f80a0cede680$var$write_biff_rec(ba, 0x0201 /* Blank */ , $77f9f80a0cede680$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $77f9f80a0cede680$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $77f9f80a0cede680$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV" + MAX_ROWS);
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, MAX_ROWS - 1);
    }
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0809, $77f9f80a0cede680$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $77f9f80a0cede680$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $77f9f80a0cede680$var$writeuint16(1));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $77f9f80a0cede680$var$writeuint16(100));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $77f9f80a0cede680$var$writebool(true));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $77f9f80a0cede680$var$write_Xnum(0.001));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $77f9f80a0cede680$var$writebool(true));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $77f9f80a0cede680$var$writeuint16(1));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0080 /* Guts */ , $77f9f80a0cede680$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $77f9f80a0cede680$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $77f9f80a0cede680$var$writebool(false));
    /* ... */ if (b8) $77f9f80a0cede680$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $77f9f80a0cede680$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $77f9f80a0cede680$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $77f9f80a0cede680$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $77f9f80a0cede680$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $77f9f80a0cede680$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                cols[C] + rr,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $77f9f80a0cede680$var$write_comments_biff8(ba, comments);
    else $77f9f80a0cede680$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $77f9f80a0cede680$var$write_biff_rec(ba, 0x023e /* Window2 */ , $77f9f80a0cede680$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $77f9f80a0cede680$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $77f9f80a0cede680$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $77f9f80a0cede680$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $77f9f80a0cede680$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $77f9f80a0cede680$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $77f9f80a0cede680$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $77f9f80a0cede680$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $77f9f80a0cede680$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $77f9f80a0cede680$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $77f9f80a0cede680$var$write_biff_rec(A, 0x0809, $77f9f80a0cede680$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $77f9f80a0cede680$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $77f9f80a0cede680$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $77f9f80a0cede680$var$writeuint16(0x04b0) : null);
    $77f9f80a0cede680$var$write_biff_rec(A, 0x00c1 /* Mms */ , $77f9f80a0cede680$var$writezeroes(2));
    if (b5) $77f9f80a0cede680$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $77f9f80a0cede680$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $77f9f80a0cede680$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $77f9f80a0cede680$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $77f9f80a0cede680$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $77f9f80a0cede680$var$write_biff_rec(A, 0x0042 /* CodePage */ , $77f9f80a0cede680$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $77f9f80a0cede680$var$write_biff_rec(A, 0x0161 /* DSF */ , $77f9f80a0cede680$var$writeuint16(0));
    if (b8) $77f9f80a0cede680$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $77f9f80a0cede680$var$write_biff_rec(A, 0x013d /* RRTabId */ , $77f9f80a0cede680$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $77f9f80a0cede680$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $77f9f80a0cede680$var$write_biff_rec(A, 0x01ba /* CodeName */ , $77f9f80a0cede680$var$write_XLUnicodeString(cname, opts));
    }
    $77f9f80a0cede680$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $77f9f80a0cede680$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $77f9f80a0cede680$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x0012 /* Protect */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x0013 /* Password */ , $77f9f80a0cede680$var$writeuint16(0));
    if (b8) $77f9f80a0cede680$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $77f9f80a0cede680$var$writebool(false));
    if (b8) $77f9f80a0cede680$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $77f9f80a0cede680$var$writeuint16(0));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x003d /* Window1 */ , $77f9f80a0cede680$var$write_Window1(opts));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x0040 /* Backup */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x008d /* HideObj */ , $77f9f80a0cede680$var$writeuint16(0));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $77f9f80a0cede680$var$writebool($77f9f80a0cede680$var$safe1904(wb) == "true"));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $77f9f80a0cede680$var$writebool(true));
    if (b8) $77f9f80a0cede680$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $77f9f80a0cede680$var$writebool(false));
    $77f9f80a0cede680$var$write_biff_rec(A, 0x00DA /* BookBool */ , $77f9f80a0cede680$var$writeuint16(0));
    /* ... */ $77f9f80a0cede680$var$write_FONTS_biff8(A, wb, opts);
    $77f9f80a0cede680$var$write_FMTS_biff8(A, wb.SSF, opts);
    $77f9f80a0cede680$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $77f9f80a0cede680$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $77f9f80a0cede680$var$writebool(false));
    var a = A.end();
    var C = $77f9f80a0cede680$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $77f9f80a0cede680$var$write_biff_rec(C, 0x008C /* Country */ , $77f9f80a0cede680$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $77f9f80a0cede680$var$b8ocnts.length) $77f9f80a0cede680$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $77f9f80a0cede680$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $77f9f80a0cede680$var$write_biff_continue(C, 0x00FC /* SST */ , $77f9f80a0cede680$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $77f9f80a0cede680$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $77f9f80a0cede680$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $77f9f80a0cede680$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $77f9f80a0cede680$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $77f9f80a0cede680$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $77f9f80a0cede680$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    if (wb && wb.SSF) {
        $77f9f80a0cede680$var$make_ssf();
        $77f9f80a0cede680$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $77f9f80a0cede680$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $77f9f80a0cede680$var$b8oid = 1;
    $77f9f80a0cede680$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $77f9f80a0cede680$var$fix_write_opts(o);
    o.cellXfs = [];
    $77f9f80a0cede680$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $77f9f80a0cede680$var$write_ws_biff8(i, o, wb);
    bufs.unshift($77f9f80a0cede680$var$write_biff8_global(wb, bufs, o));
    return $77f9f80a0cede680$var$bconcat(bufs);
}
function $77f9f80a0cede680$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
        if (range.e.r > 65535) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond row 65536.  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $77f9f80a0cede680$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $77f9f80a0cede680$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $77f9f80a0cede680$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $77f9f80a0cede680$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $77f9f80a0cede680$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $77f9f80a0cede680$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $77f9f80a0cede680$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $77f9f80a0cede680$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($77f9f80a0cede680$var$fuzzynum(m))) o = {
                t: 'n',
                v: $77f9f80a0cede680$var$fuzzynum(m)
            };
            else if (!isNaN($77f9f80a0cede680$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $77f9f80a0cede680$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $77f9f80a0cede680$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $77f9f80a0cede680$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $77f9f80a0cede680$var$table_fmt[14];
            } else if (m.charCodeAt(0) == 35 /* # */  && $77f9f80a0cede680$var$RBErr[m] != null) {
                o.t = 'e';
                o.w = m;
                o.v = $77f9f80a0cede680$var$RBErr[m];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$77f9f80a0cede680$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $77f9f80a0cede680$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        if (cell && cell.t == 'n' && cell.v != null && !isFinite(cell.v)) {
            if (isNaN(cell.v)) cell = {
                t: 'e',
                v: 0x24,
                w: $77f9f80a0cede680$var$BErr[0x24]
            };
            else cell = {
                t: 'e',
                v: 0x07,
                w: $77f9f80a0cede680$var$BErr[0x07]
            };
        }
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $77f9f80a0cede680$var$escapehtml(cell.w || ($77f9f80a0cede680$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $77f9f80a0cede680$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $77f9f80a0cede680$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($77f9f80a0cede680$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $77f9f80a0cede680$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $77f9f80a0cede680$var$HTML_END = '</body></html>';
function $77f9f80a0cede680$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $77f9f80a0cede680$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $77f9f80a0cede680$var$sheet_to_workbook($77f9f80a0cede680$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $77f9f80a0cede680$var$book_new();
    mtch.forEach(function(s, idx) {
        $77f9f80a0cede680$var$book_append_sheet(wb, $77f9f80a0cede680$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $77f9f80a0cede680$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $77f9f80a0cede680$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $77f9f80a0cede680$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $77f9f80a0cede680$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $77f9f80a0cede680$var$decode_range(ws['!ref'] || "A1");
    out.push($77f9f80a0cede680$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($77f9f80a0cede680$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $77f9f80a0cede680$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $77f9f80a0cede680$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($77f9f80a0cede680$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $77f9f80a0cede680$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $77f9f80a0cede680$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (_t == "e" && $77f9f80a0cede680$var$BErr[+v]) o = {
                    t: 'e',
                    v: +v,
                    w: $77f9f80a0cede680$var$BErr[+v]
                };
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($77f9f80a0cede680$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $77f9f80a0cede680$var$fuzzynum(v)
                };
                else if (!isNaN($77f9f80a0cede680$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $77f9f80a0cede680$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $77f9f80a0cede680$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $77f9f80a0cede680$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $77f9f80a0cede680$var$table_fmt[14];
                } else if (v.charCodeAt(0) == 35 /* # */  && $77f9f80a0cede680$var$RBErr[v] != null) o = {
                    t: 'e',
                    v: $77f9f80a0cede680$var$RBErr[v],
                    w: v
                };
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$77f9f80a0cede680$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $77f9f80a0cede680$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $77f9f80a0cede680$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $77f9f80a0cede680$var$sheet_add_dom(ws, table, _opts);
}
function $77f9f80a0cede680$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $77f9f80a0cede680$var$sheet_to_workbook($77f9f80a0cede680$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $77f9f80a0cede680$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $77f9f80a0cede680$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $77f9f80a0cede680$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $77f9f80a0cede680$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $77f9f80a0cede680$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $77f9f80a0cede680$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $77f9f80a0cede680$var$xlml_normalize(d);
    $77f9f80a0cede680$var$xlmlregex.lastIndex = 0;
    str = $77f9f80a0cede680$var$remove_doctype($77f9f80a0cede680$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $77f9f80a0cede680$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $77f9f80a0cede680$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $77f9f80a0cede680$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $77f9f80a0cede680$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $77f9f80a0cede680$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $77f9f80a0cede680$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            NF += "0." + $77f9f80a0cede680$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $77f9f80a0cede680$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($77f9f80a0cede680$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $77f9f80a0cede680$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $77f9f80a0cede680$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $77f9f80a0cede680$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $77f9f80a0cede680$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $77f9f80a0cede680$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $77f9f80a0cede680$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            if ($77f9f80a0cede680$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $77f9f80a0cede680$var$fill("0", +y["min-integer-digits"] || 1);
            if ($77f9f80a0cede680$var$parsexmlbool(y["grouping"])) tNF = $77f9f80a0cede680$var$commaify($77f9f80a0cede680$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $77f9f80a0cede680$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $77f9f80a0cede680$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $77f9f80a0cede680$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $77f9f80a0cede680$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $77f9f80a0cede680$var$xlmlregex.lastIndex;
                etpos = -+$77f9f80a0cede680$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $77f9f80a0cede680$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($77f9f80a0cede680$var$DENSE != null && opts.dense == null) opts.dense = $77f9f80a0cede680$var$DENSE;
    var str = $77f9f80a0cede680$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ , ctag2 = {} /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $77f9f80a0cede680$var$xlmlregex.lastIndex = 0;
    str = $77f9f80a0cede680$var$remove_doctype($77f9f80a0cede680$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $77f9f80a0cede680$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') {
                ++C;
                ctag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                if (opts.sheetStubs) {
                    while(colpeat-- > 0){
                        if (opts.dense) {
                            if (!ws["!data"][R]) ws["!data"][R] = [];
                            ws["!data"][R][C] = {
                                t: 'z'
                            };
                        } else ws[$77f9f80a0cede680$var$encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                        ++C;
                    }
                    --C;
                } else C += colpeat - 1;
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $77f9f80a0cede680$var$ods_to_csf_formula($77f9f80a0cede680$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $77f9f80a0cede680$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
                ctag2 = $77f9f80a0cede680$var$parsexmltagraw(Rn[0], true);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $77f9f80a0cede680$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $77f9f80a0cede680$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $77f9f80a0cede680$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'] || "1", 10) || 1;
                    mC = parseInt(ctag['number-columns-spanned'] || "1", 10) || 1;
                    if (mR * mC > 1) {
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        merges.push(mrange);
                    }
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $77f9f80a0cede680$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $77f9f80a0cede680$var$fmt_is_date(q.z)) {
                            q.v = $77f9f80a0cede680$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $77f9f80a0cede680$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $77f9f80a0cede680$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $77f9f80a0cede680$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $77f9f80a0cede680$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $77f9f80a0cede680$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (ctag2['calcext:value-type'] == "error" && $77f9f80a0cede680$var$RBErr[textp] != null) {
                    q.t = 'e';
                    q.w = textp;
                    q.v = $77f9f80a0cede680$var$RBErr[textp];
                }
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $77f9f80a0cede680$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $77f9f80a0cede680$var$dup(q);
                        } else {
                            ws[$77f9f80a0cede680$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$77f9f80a0cede680$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $77f9f80a0cede680$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $77f9f80a0cede680$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $77f9f80a0cede680$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $77f9f80a0cede680$var$xlmlregex.lastIndex;
                $77f9f80a0cede680$var$parse_ods_styles(str.slice(nfidx, $77f9f80a0cede680$var$xlmlregex.lastIndex), _opts, number_format_map);
                $77f9f80a0cede680$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $77f9f80a0cede680$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            _Ref = $77f9f80a0cede680$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $77f9f80a0cede680$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $77f9f80a0cede680$var$ods_to_csf_3D($77f9f80a0cede680$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $77f9f80a0cede680$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $77f9f80a0cede680$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $77f9f80a0cede680$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $77f9f80a0cede680$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($77f9f80a0cede680$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $77f9f80a0cede680$var$parse_manifest($77f9f80a0cede680$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $77f9f80a0cede680$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $77f9f80a0cede680$var$parse_ods_styles($77f9f80a0cede680$var$utf8read(styles), opts);
    var content = $77f9f80a0cede680$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $77f9f80a0cede680$var$parse_content_xml($77f9f80a0cede680$var$utf8read(content), opts, Styles);
    if ($77f9f80a0cede680$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $77f9f80a0cede680$var$parse_core_props($77f9f80a0cede680$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $77f9f80a0cede680$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $77f9f80a0cede680$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $77f9f80a0cede680$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $77f9f80a0cede680$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $77f9f80a0cede680$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $77f9f80a0cede680$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $77f9f80a0cede680$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $77f9f80a0cede680$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $77f9f80a0cede680$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $77f9f80a0cede680$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $77f9f80a0cede680$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $77f9f80a0cede680$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $77f9f80a0cede680$var$writextag("number:" + type + "-style", payload, nopts);
}
function $77f9f80a0cede680$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $77f9f80a0cede680$var$csf_to_ods_3D(name.Ref);
        return "        " + $77f9f80a0cede680$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $77f9f80a0cede680$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $77f9f80a0cede680$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $77f9f80a0cede680$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $77f9f80a0cede680$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $77f9f80a0cede680$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $77f9f80a0cede680$var$escapexml($77f9f80a0cede680$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $77f9f80a0cede680$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        if (!isFinite(cell.v)) {
                            if (isNaN(cell.v)) {
                                textp = "#NUM!";
                                ct['table:formula'] = "of:=#NUM!";
                            } else {
                                textp = "#DIV/0!";
                                ct['table:formula'] = "of:=" + (cell.v < 0 ? "-" : "") + "1/0";
                            }
                            ct['office:string-value'] = "";
                            ct['office:value-type'] = "string";
                            ct['calcext:value-type'] = "error";
                        } else {
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                        }
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $77f9f80a0cede680$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $77f9f80a0cede680$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $77f9f80a0cede680$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $77f9f80a0cede680$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $77f9f80a0cede680$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $77f9f80a0cede680$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $77f9f80a0cede680$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($77f9f80a0cede680$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $77f9f80a0cede680$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$77f9f80a0cede680$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $77f9f80a0cede680$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $77f9f80a0cede680$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $77f9f80a0cede680$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $77f9f80a0cede680$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $77f9f80a0cede680$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($77f9f80a0cede680$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($77f9f80a0cede680$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $77f9f80a0cede680$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $77f9f80a0cede680$var$write_content_ods(wb, opts);
    var zip = $77f9f80a0cede680$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $77f9f80a0cede680$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$XML_HEADER + $77f9f80a0cede680$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $77f9f80a0cede680$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $77f9f80a0cede680$require$Buffer !== "undefined") {
            if (typeof $77f9f80a0cede680$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $77f9f80a0cede680$require$Buffer.from == "function" ? $77f9f80a0cede680$require$Buffer.from([
                72,
                62
            ]) : new $77f9f80a0cede680$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $77f9f80a0cede680$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $77f9f80a0cede680$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $77f9f80a0cede680$var$utf8read($77f9f80a0cede680$var$a2s(u8));
}
function $77f9f80a0cede680$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $77f9f80a0cede680$var$s2a($77f9f80a0cede680$var$utf8write(str));
}
function $77f9f80a0cede680$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $77f9f80a0cede680$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $77f9f80a0cede680$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $77f9f80a0cede680$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $77f9f80a0cede680$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $77f9f80a0cede680$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$77f9f80a0cede680$var$subarray](0, L);
}
function $77f9f80a0cede680$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($77f9f80a0cede680$var$parse_varint49(buf, ptr));
    return out;
}
function $77f9f80a0cede680$var$write_packed_varints(nums) {
    return $77f9f80a0cede680$var$u8concat(nums.map(function(x) {
        return $77f9f80a0cede680$var$write_varint49(x);
    }));
}
function $77f9f80a0cede680$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $77f9f80a0cede680$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $77f9f80a0cede680$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $77f9f80a0cede680$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$77f9f80a0cede680$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$77f9f80a0cede680$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $77f9f80a0cede680$var$parse_varint49(buf, ptr);
                data = buf[$77f9f80a0cede680$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$77f9f80a0cede680$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $77f9f80a0cede680$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($77f9f80a0cede680$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($77f9f80a0cede680$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $77f9f80a0cede680$var$u8concat(out);
}
function $77f9f80a0cede680$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $77f9f80a0cede680$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $77f9f80a0cede680$var$parse_varint49(buf, ptr);
        var ai = $77f9f80a0cede680$var$parse_shallow(buf[$77f9f80a0cede680$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $77f9f80a0cede680$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $77f9f80a0cede680$var$parse_shallow(b.data);
            var fl = $77f9f80a0cede680$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$77f9f80a0cede680$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $77f9f80a0cede680$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $77f9f80a0cede680$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $77f9f80a0cede680$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $77f9f80a0cede680$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $77f9f80a0cede680$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $77f9f80a0cede680$var$write_shallow(ai);
        bufs.push($77f9f80a0cede680$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $77f9f80a0cede680$var$u8concat(bufs);
}
function $77f9f80a0cede680$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $77f9f80a0cede680$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$77f9f80a0cede680$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$77f9f80a0cede680$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$77f9f80a0cede680$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$77f9f80a0cede680$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $77f9f80a0cede680$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $77f9f80a0cede680$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $77f9f80a0cede680$var$parse_snappy_chunk(t, buf[$77f9f80a0cede680$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $77f9f80a0cede680$var$u8concat(out);
}
function $77f9f80a0cede680$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $77f9f80a0cede680$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$77f9f80a0cede680$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $77f9f80a0cede680$var$u8concat(out);
}
var $77f9f80a0cede680$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $77f9f80a0cede680$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $77f9f80a0cede680$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $77f9f80a0cede680$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $77f9f80a0cede680$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $77f9f80a0cede680$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $77f9f80a0cede680$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $77f9f80a0cede680$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $77f9f80a0cede680$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $77f9f80a0cede680$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $77f9f80a0cede680$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$77f9f80a0cede680$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$77f9f80a0cede680$var$subarray](0, 4)));
    }
    if (zidx > -1) $77f9f80a0cede680$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $77f9f80a0cede680$var$parse_new_storage(buf, lut, opts) {
    var dv = $77f9f80a0cede680$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $77f9f80a0cede680$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $77f9f80a0cede680$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $77f9f80a0cede680$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $77f9f80a0cede680$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$77f9f80a0cede680$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$77f9f80a0cede680$var$subarray](0, 4)));
    }
    doff += $77f9f80a0cede680$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $77f9f80a0cede680$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $77f9f80a0cede680$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $77f9f80a0cede680$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $77f9f80a0cede680$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $77f9f80a0cede680$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($77f9f80a0cede680$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $77f9f80a0cede680$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($77f9f80a0cede680$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$77f9f80a0cede680$var$subarray](0, l);
}
function $77f9f80a0cede680$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $77f9f80a0cede680$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$77f9f80a0cede680$var$subarray](0, l);
}
function $77f9f80a0cede680$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $77f9f80a0cede680$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $77f9f80a0cede680$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $77f9f80a0cede680$var$parse_TSP_Reference(buf) {
    var pb = $77f9f80a0cede680$var$parse_shallow(buf);
    return $77f9f80a0cede680$var$varint_to_i32(pb[1][0].data);
}
function $77f9f80a0cede680$var$write_TSP_Reference(idx) {
    return $77f9f80a0cede680$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(idx)
            }
        ]
    ]);
}
function $77f9f80a0cede680$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $77f9f80a0cede680$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $77f9f80a0cede680$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $77f9f80a0cede680$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $77f9f80a0cede680$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $77f9f80a0cede680$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $77f9f80a0cede680$var$parse_TST_TableDataList(M, root) {
    var pb = $77f9f80a0cede680$var$parse_shallow(root.data);
    var type = $77f9f80a0cede680$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $77f9f80a0cede680$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $77f9f80a0cede680$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $77f9f80a0cede680$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$77f9f80a0cede680$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $77f9f80a0cede680$var$parse_shallow(rt.data);
                var rtpref = M[$77f9f80a0cede680$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $77f9f80a0cede680$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $77f9f80a0cede680$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $77f9f80a0cede680$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $77f9f80a0cede680$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $77f9f80a0cede680$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$77f9f80a0cede680$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $77f9f80a0cede680$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $77f9f80a0cede680$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $77f9f80a0cede680$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $77f9f80a0cede680$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $77f9f80a0cede680$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$77f9f80a0cede680$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $77f9f80a0cede680$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $77f9f80a0cede680$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $77f9f80a0cede680$var$parse_shallow(u8);
    var R = $77f9f80a0cede680$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $77f9f80a0cede680$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $77f9f80a0cede680$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $77f9f80a0cede680$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$77f9f80a0cede680$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$77f9f80a0cede680$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $77f9f80a0cede680$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $77f9f80a0cede680$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($77f9f80a0cede680$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $77f9f80a0cede680$var$mappa(pb[5], function(u8) {
        return $77f9f80a0cede680$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $77f9f80a0cede680$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $77f9f80a0cede680$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $77f9f80a0cede680$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $77f9f80a0cede680$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$77f9f80a0cede680$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $77f9f80a0cede680$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $77f9f80a0cede680$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$77f9f80a0cede680$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($77f9f80a0cede680$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $77f9f80a0cede680$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $77f9f80a0cede680$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $77f9f80a0cede680$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $77f9f80a0cede680$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($77f9f80a0cede680$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($77f9f80a0cede680$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $77f9f80a0cede680$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $77f9f80a0cede680$var$parse_shallow(pb[4][0].data);
    var lut = $77f9f80a0cede680$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $77f9f80a0cede680$var$parse_TST_TableDataList(M, M[$77f9f80a0cede680$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $77f9f80a0cede680$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $77f9f80a0cede680$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $77f9f80a0cede680$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $77f9f80a0cede680$var$varint_to_i32(kv[1][0].data);
        var tidx = $77f9f80a0cede680$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $77f9f80a0cede680$var$parse_shallow(t.data);
        var ref2 = M[$77f9f80a0cede680$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $77f9f80a0cede680$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $77f9f80a0cede680$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $77f9f80a0cede680$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$77f9f80a0cede680$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $77f9f80a0cede680$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $77f9f80a0cede680$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $77f9f80a0cede680$var$parse_shallow(pi.data);
            var origin = $77f9f80a0cede680$var$u8_to_dataview($77f9f80a0cede680$var$parse_shallow(merge[1][0].data)[1][0].data), size = $77f9f80a0cede680$var$u8_to_dataview($77f9f80a0cede680$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
    if (!((_k = ws["!merges"]) == null ? void 0 : _k.length) && ((_l = pb[47]) == null ? void 0 : _l[0])) {
        var merge_owner = $77f9f80a0cede680$var$parse_shallow(pb[47][0].data);
        if ((_m = merge_owner[2]) == null ? void 0 : _m[0]) {
            var formula_store = $77f9f80a0cede680$var$parse_shallow(merge_owner[2][0].data);
            if ((_n = formula_store[3]) == null ? void 0 : _n[0]) ws["!merges"] = $77f9f80a0cede680$var$mappa(formula_store[3], function(u) {
                var _a2, _b2, _c2, _d2, _e2;
                var formula_pair = $77f9f80a0cede680$var$parse_shallow(u);
                var formula = $77f9f80a0cede680$var$parse_shallow(formula_pair[2][0].data);
                var AST_node_array = $77f9f80a0cede680$var$parse_shallow(formula[1][0].data);
                if (!((_a2 = AST_node_array[1]) == null ? void 0 : _a2[0])) return;
                var AST_node0 = $77f9f80a0cede680$var$parse_shallow(AST_node_array[1][0].data);
                var AST_node_type = $77f9f80a0cede680$var$varint_to_i32(AST_node0[1][0].data);
                if (AST_node_type != 67) return;
                var AST_colon_tract = $77f9f80a0cede680$var$parse_shallow(AST_node0[40][0].data);
                if (!((_b2 = AST_colon_tract[3]) == null ? void 0 : _b2[0]) || !((_c2 = AST_colon_tract[4]) == null ? void 0 : _c2[0])) return;
                var colrange = $77f9f80a0cede680$var$parse_shallow(AST_colon_tract[3][0].data);
                var rowrange = $77f9f80a0cede680$var$parse_shallow(AST_colon_tract[4][0].data);
                var c = $77f9f80a0cede680$var$varint_to_i32(colrange[1][0].data);
                var C = ((_d2 = colrange[2]) == null ? void 0 : _d2[0]) ? $77f9f80a0cede680$var$varint_to_i32(colrange[2][0].data) : c;
                var r = $77f9f80a0cede680$var$varint_to_i32(rowrange[1][0].data);
                var R = ((_e2 = rowrange[2]) == null ? void 0 : _e2[0]) ? $77f9f80a0cede680$var$varint_to_i32(rowrange[2][0].data) : r;
                return {
                    s: {
                        r: r,
                        c: c
                    },
                    e: {
                        r: R,
                        c: C
                    }
                };
            }).filter(function(x) {
                return x != null;
            });
        }
    }
}
function $77f9f80a0cede680$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $77f9f80a0cede680$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$77f9f80a0cede680$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $77f9f80a0cede680$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $77f9f80a0cede680$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $77f9f80a0cede680$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $77f9f80a0cede680$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $77f9f80a0cede680$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $77f9f80a0cede680$var$mappa(pb[2], $77f9f80a0cede680$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $77f9f80a0cede680$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($77f9f80a0cede680$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $77f9f80a0cede680$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $77f9f80a0cede680$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $77f9f80a0cede680$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $77f9f80a0cede680$var$mappa(pb[1], $77f9f80a0cede680$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $77f9f80a0cede680$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $77f9f80a0cede680$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $77f9f80a0cede680$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $77f9f80a0cede680$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $77f9f80a0cede680$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $77f9f80a0cede680$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $77f9f80a0cede680$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $77f9f80a0cede680$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $77f9f80a0cede680$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $77f9f80a0cede680$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $77f9f80a0cede680$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $77f9f80a0cede680$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $77f9f80a0cede680$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $77f9f80a0cede680$var$write_new_storage(data[C], lut);
                    _celload = $77f9f80a0cede680$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $77f9f80a0cede680$var$write_new_storage(data[C], lut);
                _celload = $77f9f80a0cede680$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $77f9f80a0cede680$var$write_new_storage(data[C], lut);
                _celload = $77f9f80a0cede680$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $77f9f80a0cede680$var$write_varint49(cnt);
    tri[5][0].data = $77f9f80a0cede680$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $77f9f80a0cede680$var$u8concat(cell_storage);
    tri[3][0].data = $77f9f80a0cede680$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $77f9f80a0cede680$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $77f9f80a0cede680$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $77f9f80a0cede680$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $77f9f80a0cede680$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $77f9f80a0cede680$var$parse_iwa_file($77f9f80a0cede680$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $77f9f80a0cede680$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $77f9f80a0cede680$var$parse_iwa_file($77f9f80a0cede680$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($77f9f80a0cede680$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $77f9f80a0cede680$var$write_TSP_Color_RGB(r, g, b) {
    return $77f9f80a0cede680$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $77f9f80a0cede680$var$write_varint49(1)
            }
        ]
    ]);
}
function $77f9f80a0cede680$var$get_author_color(n) {
    switch(n){
        case 0:
            return $77f9f80a0cede680$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $77f9f80a0cede680$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $77f9f80a0cede680$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $77f9f80a0cede680$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $77f9f80a0cede680$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $77f9f80a0cede680$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $77f9f80a0cede680$var$build_numbers_deps(cfb);
    var docroot = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $77f9f80a0cede680$var$mappa($77f9f80a0cede680$var$parse_shallow(docroot.messages[0].data)[1], $77f9f80a0cede680$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $77f9f80a0cede680$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $77f9f80a0cede680$var$mappa($77f9f80a0cede680$var$parse_shallow(docroot.messages[0].data)[1], $77f9f80a0cede680$var$parse_TSP_Reference);
        }
        $77f9f80a0cede680$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $77f9f80a0cede680$var$parse_iwa_file($77f9f80a0cede680$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $77f9f80a0cede680$var$compress_iwa_file($77f9f80a0cede680$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $77f9f80a0cede680$var$parse_iwa_file($77f9f80a0cede680$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $77f9f80a0cede680$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $77f9f80a0cede680$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $77f9f80a0cede680$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $77f9f80a0cede680$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $77f9f80a0cede680$var$write_varint49(Math.max(newid + 1, $77f9f80a0cede680$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $77f9f80a0cede680$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $77f9f80a0cede680$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $77f9f80a0cede680$var$compress_iwa_file($77f9f80a0cede680$var$write_iwa_file([
        {
            id: id,
            messages: [
                $77f9f80a0cede680$var$write_iwam(type, $77f9f80a0cede680$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
        $77f9f80a0cede680$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
    });
    return id;
}
function $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $77f9f80a0cede680$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $77f9f80a0cede680$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $77f9f80a0cede680$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $77f9f80a0cede680$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $77f9f80a0cede680$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $77f9f80a0cede680$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $77f9f80a0cede680$var$write_shallow(parent);
}
function $77f9f80a0cede680$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $77f9f80a0cede680$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $77f9f80a0cede680$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $77f9f80a0cede680$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $77f9f80a0cede680$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $77f9f80a0cede680$var$varint_to_i32($77f9f80a0cede680$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $77f9f80a0cede680$var$write_shallow(parent);
}
function $77f9f80a0cede680$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $77f9f80a0cede680$var$parse_shallow(docroot.messages[0].data);
        sheetref = $77f9f80a0cede680$var$parse_TSP_Reference($77f9f80a0cede680$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $77f9f80a0cede680$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $77f9f80a0cede680$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $77f9f80a0cede680$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(doc);
    });
    var tiaref = -1;
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $77f9f80a0cede680$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $77f9f80a0cede680$var$mappa(sa[2], $77f9f80a0cede680$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $77f9f80a0cede680$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $77f9f80a0cede680$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $77f9f80a0cede680$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $77f9f80a0cede680$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
            });
            $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(sa);
    });
    var tmaref = -1;
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $77f9f80a0cede680$var$parse_shallow(tiaroot.messages[0].data);
        var da = $77f9f80a0cede680$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $77f9f80a0cede680$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $77f9f80a0cede680$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $77f9f80a0cede680$var$write_shallow(da);
        var oldtmaref = $77f9f80a0cede680$var$parse_TSP_Reference(tia[2][0].data);
        $77f9f80a0cede680$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $77f9f80a0cede680$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $77f9f80a0cede680$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $77f9f80a0cede680$var$write_TSP_Reference(tmaref);
        var tma = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(tia);
    });
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $77f9f80a0cede680$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $77f9f80a0cede680$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $77f9f80a0cede680$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $77f9f80a0cede680$var$parse_shallow(tma[45][0].data);
            var ref = $77f9f80a0cede680$var$parse_TSP_Reference(srrta[1][0].data);
            $77f9f80a0cede680$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $77f9f80a0cede680$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $77f9f80a0cede680$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $77f9f80a0cede680$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $77f9f80a0cede680$var$parse_TSP_Reference(hsea[8][0].data);
                    $77f9f80a0cede680$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $77f9f80a0cede680$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $77f9f80a0cede680$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $77f9f80a0cede680$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $77f9f80a0cede680$var$parse_TSP_Reference(store[n][0].data);
            var newref = $77f9f80a0cede680$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $77f9f80a0cede680$var$numbers_del_oref(tmaroot, oldref);
            $77f9f80a0cede680$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $77f9f80a0cede680$var$compress_iwa_file($77f9f80a0cede680$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                    $77f9f80a0cede680$var$numbers_add_meta(mlist, newref, newloc);
                    $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $77f9f80a0cede680$var$write_TSP_Reference(newref);
        });
        var row_headers = $77f9f80a0cede680$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $77f9f80a0cede680$var$parse_TSP_Reference(tspref.data);
            var newref = $77f9f80a0cede680$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $77f9f80a0cede680$var$numbers_del_oref(tmaroot, oldref);
            $77f9f80a0cede680$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $77f9f80a0cede680$var$compress_iwa_file($77f9f80a0cede680$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                    $77f9f80a0cede680$var$numbers_add_meta(mlist, newref, newloc);
                    $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
                });
            }
            tspref.data = $77f9f80a0cede680$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $77f9f80a0cede680$var$write_shallow(row_headers);
        var tiles = $77f9f80a0cede680$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $77f9f80a0cede680$var$parse_shallow(t.data);
            var oldtileref = $77f9f80a0cede680$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $77f9f80a0cede680$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $77f9f80a0cede680$var$numbers_del_oref(tmaroot, oldtileref);
                $77f9f80a0cede680$var$numbers_add_oref(tmaroot, newtileref);
                $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $77f9f80a0cede680$var$compress_iwa_file($77f9f80a0cede680$var$write_iwa_file([
                    oldtile
                ])));
                $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $77f9f80a0cede680$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $77f9f80a0cede680$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $77f9f80a0cede680$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $77f9f80a0cede680$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $77f9f80a0cede680$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $77f9f80a0cede680$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(Math.max(newtileref + 1, $77f9f80a0cede680$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $77f9f80a0cede680$var$write_TSP_Reference(newtileref);
            t.data = $77f9f80a0cede680$var$write_shallow(tst);
        });
        store[3][0].data = $77f9f80a0cede680$var$write_shallow(tiles);
        tma[4][0].data = $77f9f80a0cede680$var$write_shallow(store);
        tmaroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(tma);
    });
}
function $77f9f80a0cede680$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $77f9f80a0cede680$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $77f9f80a0cede680$var$stru8(wsname)
            }
        ];
        drawables = $77f9f80a0cede680$var$mappa(sheetref[2], $77f9f80a0cede680$var$parse_TSP_Reference);
        docroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(sheetref);
    });
    var tia = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $77f9f80a0cede680$var$parse_TSP_Reference($77f9f80a0cede680$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $77f9f80a0cede680$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $77f9f80a0cede680$var$USE_WIDE_ROWS = true;
function $77f9f80a0cede680$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($77f9f80a0cede680$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $77f9f80a0cede680$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $77f9f80a0cede680$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $77f9f80a0cede680$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $77f9f80a0cede680$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $77f9f80a0cede680$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $77f9f80a0cede680$var$parse_TSP_Reference($77f9f80a0cede680$var$parse_shallow(store[1][0].data)[2][0].data);
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $77f9f80a0cede680$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $77f9f80a0cede680$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $77f9f80a0cede680$var$write_varint49(R2);
            _bucket[4][0].data = $77f9f80a0cede680$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $77f9f80a0cede680$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $77f9f80a0cede680$var$write_shallow(base_bucket);
    });
    var col_header_ref = $77f9f80a0cede680$var$parse_TSP_Reference(store[2][0].data);
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $77f9f80a0cede680$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $77f9f80a0cede680$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $77f9f80a0cede680$var$write_varint49(C);
            _bucket[4][0].data = $77f9f80a0cede680$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $77f9f80a0cede680$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $77f9f80a0cede680$var$write_shallow(base_bucket);
    });
    var rbtree = $77f9f80a0cede680$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $77f9f80a0cede680$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $77f9f80a0cede680$var$write_varint49(tstride)
        }
    ];
    var tileref = $77f9f80a0cede680$var$parse_TSP_Reference($77f9f80a0cede680$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $77f9f80a0cede680$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $77f9f80a0cede680$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $77f9f80a0cede680$var$varint_to_i32($77f9f80a0cede680$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $77f9f80a0cede680$var$varint_to_i32($77f9f80a0cede680$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $77f9f80a0cede680$var$varint_to_i32($77f9f80a0cede680$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $77f9f80a0cede680$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
    });
    $77f9f80a0cede680$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $77f9f80a0cede680$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49($77f9f80a0cede680$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $77f9f80a0cede680$var$write_TST_TileRowInfo(data[R], LUT, $77f9f80a0cede680$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $77f9f80a0cede680$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $77f9f80a0cede680$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $77f9f80a0cede680$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $77f9f80a0cede680$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $77f9f80a0cede680$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $77f9f80a0cede680$var$write_iwam(6002, $77f9f80a0cede680$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $77f9f80a0cede680$var$compress_iwa_file($77f9f80a0cede680$var$write_iwa_file([
            newtile
        ]));
        $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $77f9f80a0cede680$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $77f9f80a0cede680$var$write_varint49(Math.max(newtileid + 1, $77f9f80a0cede680$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
        });
        $77f9f80a0cede680$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $77f9f80a0cede680$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $77f9f80a0cede680$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $77f9f80a0cede680$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $77f9f80a0cede680$var$write_shallow(tilestore);
    store[9][0].data = $77f9f80a0cede680$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $77f9f80a0cede680$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $77f9f80a0cede680$var$write_iwam(6144, $77f9f80a0cede680$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $77f9f80a0cede680$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $77f9f80a0cede680$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $77f9f80a0cede680$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $77f9f80a0cede680$var$write_TSP_Reference(mergeid)
            }
        ];
        $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
            $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
        });
        $77f9f80a0cede680$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $77f9f80a0cede680$var$parse_TSP_Reference(store[4][0].data);
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $77f9f80a0cede680$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $77f9f80a0cede680$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(sstdata);
    });
    var rsstref = $77f9f80a0cede680$var$parse_TSP_Reference(store[17][0].data);
    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $77f9f80a0cede680$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $77f9f80a0cede680$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $77f9f80a0cede680$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $77f9f80a0cede680$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $77f9f80a0cede680$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $77f9f80a0cede680$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $77f9f80a0cede680$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $77f9f80a0cede680$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $77f9f80a0cede680$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $77f9f80a0cede680$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $77f9f80a0cede680$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $77f9f80a0cede680$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $77f9f80a0cede680$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $77f9f80a0cede680$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $77f9f80a0cede680$var$numbers_add_oref(rsstroot, rtpaid);
            $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $77f9f80a0cede680$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $77f9f80a0cede680$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $77f9f80a0cede680$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $77f9f80a0cede680$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $77f9f80a0cede680$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $77f9f80a0cede680$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                        $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $77f9f80a0cede680$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $77f9f80a0cede680$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $77f9f80a0cede680$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $77f9f80a0cede680$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $77f9f80a0cede680$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $77f9f80a0cede680$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $77f9f80a0cede680$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $77f9f80a0cede680$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $77f9f80a0cede680$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $77f9f80a0cede680$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $77f9f80a0cede680$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $77f9f80a0cede680$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $77f9f80a0cede680$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $77f9f80a0cede680$var$numbers_add_oref(cmntroot, csaid);
                $77f9f80a0cede680$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $77f9f80a0cede680$var$parse_shallow(ai.messages[0].data);
                    $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $77f9f80a0cede680$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $77f9f80a0cede680$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $77f9f80a0cede680$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $77f9f80a0cede680$var$write_shallow(store);
    tmaroot.messages[0].data = $77f9f80a0cede680$var$write_shallow(pb);
}
function $77f9f80a0cede680$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $77f9f80a0cede680$var$fix_read_opts(opts) {
    $77f9f80a0cede680$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $77f9f80a0cede680$var$fix_write_opts(opts) {
    $77f9f80a0cede680$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $77f9f80a0cede680$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($77f9f80a0cede680$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($77f9f80a0cede680$var$RELS.CS && n == $77f9f80a0cede680$var$RELS.CS) return "chart";
    if ($77f9f80a0cede680$var$RELS.DS && n == $77f9f80a0cede680$var$RELS.DS) return "dialog";
    if ($77f9f80a0cede680$var$RELS.MS && n == $77f9f80a0cede680$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $77f9f80a0cede680$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $77f9f80a0cede680$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $77f9f80a0cede680$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $77f9f80a0cede680$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $77f9f80a0cede680$var$getzipstr(zip, dfile, true);
    if (draw) $77f9f80a0cede680$var$parse_vml($77f9f80a0cede680$var$utf8read(draw), sheet, comments || []);
}
function $77f9f80a0cede680$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $77f9f80a0cede680$var$parse_rels($77f9f80a0cede680$var$getzipstr(zip, relsPath, true), path);
        var data = $77f9f80a0cede680$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $77f9f80a0cede680$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $77f9f80a0cede680$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $77f9f80a0cede680$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $77f9f80a0cede680$var$get_rels_path(dfile);
                var draw = $77f9f80a0cede680$var$parse_drawing($77f9f80a0cede680$var$getzipstr(zip, dfile, true), $77f9f80a0cede680$var$parse_rels($77f9f80a0cede680$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $77f9f80a0cede680$var$resolve_path(draw, dfile);
                var crelsp = $77f9f80a0cede680$var$get_rels_path(chartp);
                _ws = $77f9f80a0cede680$var$parse_chart($77f9f80a0cede680$var$getzipstr(zip, chartp, true), chartp, opts, $77f9f80a0cede680$var$parse_rels($77f9f80a0cede680$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $77f9f80a0cede680$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $77f9f80a0cede680$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $77f9f80a0cede680$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $77f9f80a0cede680$var$RELS.CMNT) {
                dfile = $77f9f80a0cede680$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $77f9f80a0cede680$var$parse_cmnt($77f9f80a0cede680$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $77f9f80a0cede680$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $77f9f80a0cede680$var$RELS.TCMNT) {
                dfile = $77f9f80a0cede680$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($77f9f80a0cede680$var$parse_tcmnt_xml($77f9f80a0cede680$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $77f9f80a0cede680$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $77f9f80a0cede680$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $77f9f80a0cede680$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $77f9f80a0cede680$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $77f9f80a0cede680$var$make_ssf();
    opts = opts || {};
    $77f9f80a0cede680$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($77f9f80a0cede680$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $77f9f80a0cede680$var$parse_ods(zip, opts);
    /* UOC */ if ($77f9f80a0cede680$var$safegetzipfile(zip, 'objectdata.xml')) return $77f9f80a0cede680$var$parse_ods(zip, opts);
    /* Numbers */ if ($77f9f80a0cede680$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $77f9f80a0cede680$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $77f9f80a0cede680$var$parse_numbers_iwa(zip, opts);
            var _zip = $77f9f80a0cede680$export$9f0e51cd97c572a.utils.cfb_new();
            $77f9f80a0cede680$var$zipentries(zip).forEach(function(e) {
                $77f9f80a0cede680$var$zip_add_file(_zip, e, $77f9f80a0cede680$var$getzipbin(zip, e));
            });
            return $77f9f80a0cede680$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$77f9f80a0cede680$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($77f9f80a0cede680$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($77f9f80a0cede680$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $77f9f80a0cede680$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $77f9f80a0cede680$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $77f9f80a0cede680$require$Buffer.isBuffer(index_zip.content)) return $77f9f80a0cede680$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $77f9f80a0cede680$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $77f9f80a0cede680$var$zipentries(zip);
    var dir = $77f9f80a0cede680$var$parse_ct($77f9f80a0cede680$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($77f9f80a0cede680$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$77f9f80a0cede680$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $77f9f80a0cede680$var$strs = [];
        if (dir.sst) try {
            $77f9f80a0cede680$var$strs = $77f9f80a0cede680$var$parse_sst($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $77f9f80a0cede680$var$parse_theme_xml($77f9f80a0cede680$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $77f9f80a0cede680$var$parse_sty($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $77f9f80a0cede680$var$parse_rels($77f9f80a0cede680$var$getzipstr(zip, $77f9f80a0cede680$var$get_rels_path($77f9f80a0cede680$var$strip_front_slash(link))), link);
            return $77f9f80a0cede680$var$parse_xlink($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $77f9f80a0cede680$var$parse_wb($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $77f9f80a0cede680$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $77f9f80a0cede680$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $77f9f80a0cede680$var$getzipstr(zip, $77f9f80a0cede680$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $77f9f80a0cede680$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $77f9f80a0cede680$var$parse_cc($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$77f9f80a0cede680$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $77f9f80a0cede680$var$parse_rels($77f9f80a0cede680$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $77f9f80a0cede680$var$parse_xlmeta($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $77f9f80a0cede680$var$parse_people_xml($77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $77f9f80a0cede680$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $77f9f80a0cede680$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$77f9f80a0cede680$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$77f9f80a0cede680$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $77f9f80a0cede680$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $77f9f80a0cede680$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $77f9f80a0cede680$var$getzipdata(zip, $77f9f80a0cede680$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $77f9f80a0cede680$var$CT_VBA) out.vbaraw = $77f9f80a0cede680$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $77f9f80a0cede680$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $77f9f80a0cede680$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $77f9f80a0cede680$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $77f9f80a0cede680$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $77f9f80a0cede680$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $77f9f80a0cede680$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $77f9f80a0cede680$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    if (wb && wb.SSF) {
        $77f9f80a0cede680$var$make_ssf();
        $77f9f80a0cede680$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $77f9f80a0cede680$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($77f9f80a0cede680$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $77f9f80a0cede680$var$new_ct();
    $77f9f80a0cede680$var$fix_write_opts(opts = opts || {});
    var zip = $77f9f80a0cede680$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $77f9f80a0cede680$var$add_rels(opts.rels, 2, f, $77f9f80a0cede680$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $77f9f80a0cede680$var$add_rels(opts.rels, 3, f, $77f9f80a0cede680$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $77f9f80a0cede680$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $77f9f80a0cede680$var$add_rels(opts.rels, 4, f, $77f9f80a0cede680$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $77f9f80a0cede680$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $77f9f80a0cede680$var$zip_add_file(zip, cf, $77f9f80a0cede680$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $77f9f80a0cede680$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $77f9f80a0cede680$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $77f9f80a0cede680$var$zip_add_file(zip, cf, $77f9f80a0cede680$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $77f9f80a0cede680$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $77f9f80a0cede680$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $77f9f80a0cede680$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $77f9f80a0cede680$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $77f9f80a0cede680$var$zip_add_file(zip, $77f9f80a0cede680$var$get_rels_path(f), $77f9f80a0cede680$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $77f9f80a0cede680$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $77f9f80a0cede680$var$add_rels(opts.rels, 1, f, $77f9f80a0cede680$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $77f9f80a0cede680$var$write_theme(wb.Themes, opts);
    $77f9f80a0cede680$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $77f9f80a0cede680$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "styles." + wbext, $77f9f80a0cede680$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $77f9f80a0cede680$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $77f9f80a0cede680$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $77f9f80a0cede680$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_people_xml(people, opts));
        ct.people.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "persons/person.xml", $77f9f80a0cede680$var$RELS.PEOPLE);
    }
    $77f9f80a0cede680$var$zip_add_file(zip, "[Content_Types].xml", $77f9f80a0cede680$var$write_ct(ct, opts));
    $77f9f80a0cede680$var$zip_add_file(zip, '_rels/.rels', $77f9f80a0cede680$var$write_rels(opts.rels));
    $77f9f80a0cede680$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $77f9f80a0cede680$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $77f9f80a0cede680$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    if (wb && wb.SSF) {
        $77f9f80a0cede680$var$make_ssf();
        $77f9f80a0cede680$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $77f9f80a0cede680$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($77f9f80a0cede680$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $77f9f80a0cede680$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $77f9f80a0cede680$var$new_ct();
    $77f9f80a0cede680$var$fix_write_opts(opts = opts || {});
    var zip = $77f9f80a0cede680$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $77f9f80a0cede680$var$add_rels(opts.rels, 2, f, $77f9f80a0cede680$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $77f9f80a0cede680$var$add_rels(opts.rels, 3, f, $77f9f80a0cede680$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $77f9f80a0cede680$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $77f9f80a0cede680$var$add_rels(opts.rels, 4, f, $77f9f80a0cede680$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $77f9f80a0cede680$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $77f9f80a0cede680$var$zip_add_file(zip, cf, $77f9f80a0cede680$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $77f9f80a0cede680$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $77f9f80a0cede680$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $77f9f80a0cede680$var$zip_add_file(zip, cf, $77f9f80a0cede680$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $77f9f80a0cede680$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $77f9f80a0cede680$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $77f9f80a0cede680$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $77f9f80a0cede680$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $77f9f80a0cede680$var$zip_add_file(zip, $77f9f80a0cede680$var$get_rels_path(f), $77f9f80a0cede680$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $77f9f80a0cede680$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $77f9f80a0cede680$var$add_rels(opts.rels, 1, f, $77f9f80a0cede680$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $77f9f80a0cede680$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "styles." + wbext, $77f9f80a0cede680$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $77f9f80a0cede680$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $77f9f80a0cede680$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $77f9f80a0cede680$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $77f9f80a0cede680$var$zip_add_file(zip, f, $77f9f80a0cede680$var$write_people_xml(people, opts));
        ct.people.push(f);
        $77f9f80a0cede680$var$add_rels(opts.wbrels, -1, "persons/person.xml", $77f9f80a0cede680$var$RELS.PEOPLE);
    }
    $77f9f80a0cede680$var$zip_add_file(zip, "[Content_Types].xml", $77f9f80a0cede680$var$write_ct(ct, opts));
    $77f9f80a0cede680$var$zip_add_file(zip, '_rels/.rels', $77f9f80a0cede680$var$write_rels(opts.rels));
    $77f9f80a0cede680$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $77f9f80a0cede680$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $77f9f80a0cede680$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $77f9f80a0cede680$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $77f9f80a0cede680$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($77f9f80a0cede680$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $77f9f80a0cede680$var$parse_xlsxcfb(cfb, opts);
    return $77f9f80a0cede680$export$b41972a043aba84c(cfb, opts);
}
function $77f9f80a0cede680$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $77f9f80a0cede680$var$zip_read(d, o);
    return $77f9f80a0cede680$export$b165387946f79a1(zip, o);
}
function $77f9f80a0cede680$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $77f9f80a0cede680$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $77f9f80a0cede680$var$PRN.to_workbook(data, o);
}
function $77f9f80a0cede680$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $77f9f80a0cede680$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $77f9f80a0cede680$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $77f9f80a0cede680$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $77f9f80a0cede680$var$utf8read(str);
    o.type = "binary";
    return $77f9f80a0cede680$var$read_plaintext(str, o);
}
function $77f9f80a0cede680$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $77f9f80a0cede680$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $77f9f80a0cede680$var$$cptable !== "undefined" ? $77f9f80a0cede680$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $77f9f80a0cede680$var$utf16lereadu(d.slice(2)) : $77f9f80a0cede680$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $77f9f80a0cede680$var$read_plaintext(d, o);
}
function $77f9f80a0cede680$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $77f9f80a0cede680$var$utf8write(data);
}
function $77f9f80a0cede680$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $77f9f80a0cede680$var$PRN.to_workbook(data, o);
    }
    return $77f9f80a0cede680$var$PRN.to_workbook(d, o);
}
function $77f9f80a0cede680$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $77f9f80a0cede680$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $77f9f80a0cede680$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $77f9f80a0cede680$export$aafa59e2e03f2942(new Uint8Array(data), (o = $77f9f80a0cede680$var$dup(o), o.type = "array", o));
    /* Javet projects `byte[]` to `Int8Array` */ if (typeof Int8Array !== 'undefined' && data instanceof Int8Array) return $77f9f80a0cede680$export$aafa59e2e03f2942(new Uint8Array(data.buffer, data.byteOffset, data.length), o);
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $77f9f80a0cede680$var$_ssfopts = {};
    if (o.dateNF) $77f9f80a0cede680$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $77f9f80a0cede680$var$has_buf && $77f9f80a0cede680$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $77f9f80a0cede680$var$has_buf ? "buffer" : "binary";
        d = $77f9f80a0cede680$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$77f9f80a0cede680$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $77f9f80a0cede680$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $77f9f80a0cede680$var$dup(o);
            o.type = 'array';
            return $77f9f80a0cede680$export$aafa59e2e03f2942($77f9f80a0cede680$var$ab2a(d), o);
        }
    }
    switch((n = $77f9f80a0cede680$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $77f9f80a0cede680$var$read_cfb($77f9f80a0cede680$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $77f9f80a0cede680$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $77f9f80a0cede680$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $77f9f80a0cede680$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $77f9f80a0cede680$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $77f9f80a0cede680$var$read_zip(d, o) : $77f9f80a0cede680$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $77f9f80a0cede680$var$parse_xlml(d, o) : $77f9f80a0cede680$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $77f9f80a0cede680$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $77f9f80a0cede680$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $77f9f80a0cede680$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $77f9f80a0cede680$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $77f9f80a0cede680$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $77f9f80a0cede680$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $77f9f80a0cede680$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($77f9f80a0cede680$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $77f9f80a0cede680$var$DBF.to_workbook(d, o);
    return $77f9f80a0cede680$var$read_prn(data, d, o, str);
}
function $77f9f80a0cede680$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $77f9f80a0cede680$export$aafa59e2e03f2942(filename, o);
}
function $77f9f80a0cede680$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $77f9f80a0cede680$var$write_dl(o.file, $77f9f80a0cede680$export$9f0e51cd97c572a.write(cfb, {
                type: $77f9f80a0cede680$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $77f9f80a0cede680$export$9f0e51cd97c572a.write(cfb, o);
}
function $77f9f80a0cede680$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $77f9f80a0cede680$var$write_ods(wb, opts);
        case "numbers":
            return $77f9f80a0cede680$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $77f9f80a0cede680$var$write_zip_xlsb(wb, opts);
        default:
            return $77f9f80a0cede680$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $77f9f80a0cede680$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $77f9f80a0cede680$var$dup(opts || {});
    var z = $77f9f80a0cede680$var$write_zip(wb, o);
    return $77f9f80a0cede680$var$write_zip_denouement(z, o);
}
function $77f9f80a0cede680$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $77f9f80a0cede680$var$dup(opts || {});
    var z = $77f9f80a0cede680$var$write_zip_xlsx(wb, o);
    return $77f9f80a0cede680$var$write_zip_denouement(z, o);
}
function $77f9f80a0cede680$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $77f9f80a0cede680$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $77f9f80a0cede680$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($77f9f80a0cede680$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $77f9f80a0cede680$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $77f9f80a0cede680$var$write_dl(o.file, out);
    return o.type == "string" ? $77f9f80a0cede680$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $77f9f80a0cede680$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $77f9f80a0cede680$var$write_xlscfb(wb, o);
    return $77f9f80a0cede680$var$write_cfb_ctr(cfb, o);
}
function $77f9f80a0cede680$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $77f9f80a0cede680$var$Base64_encode($77f9f80a0cede680$var$utf8write(o));
        case "binary":
            return $77f9f80a0cede680$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $77f9f80a0cede680$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $77f9f80a0cede680$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $77f9f80a0cede680$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $77f9f80a0cede680$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $77f9f80a0cede680$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($77f9f80a0cede680$var$has_buf) return $77f9f80a0cede680$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $77f9f80a0cede680$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $77f9f80a0cede680$var$Base64_encode(bstr) : opts.type == 'string' ? $77f9f80a0cede680$var$utf8read(bstr) : bstr;
        case "file":
            return $77f9f80a0cede680$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $77f9f80a0cede680$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $77f9f80a0cede680$var$reset_cp();
    $77f9f80a0cede680$var$check_wb(wb);
    var o = $77f9f80a0cede680$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $77f9f80a0cede680$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $77f9f80a0cede680$var$s2ab(out);
    }
    return $77f9f80a0cede680$var$write_zip_typeXLSX(wb, o);
}
function $77f9f80a0cede680$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $77f9f80a0cede680$var$reset_cp();
    $77f9f80a0cede680$var$check_wb(wb);
    var o = $77f9f80a0cede680$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $77f9f80a0cede680$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $77f9f80a0cede680$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $77f9f80a0cede680$var$write_stxt_type($77f9f80a0cede680$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $77f9f80a0cede680$var$write_binary_type($77f9f80a0cede680$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $77f9f80a0cede680$var$write_string_type($77f9f80a0cede680$var$write_ods(wb, o), o);
        case 'wk1':
            return $77f9f80a0cede680$var$write_binary_type($77f9f80a0cede680$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $77f9f80a0cede680$var$write_binary_type($77f9f80a0cede680$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $77f9f80a0cede680$var$write_binary_type($77f9f80a0cede680$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $77f9f80a0cede680$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $77f9f80a0cede680$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $77f9f80a0cede680$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $77f9f80a0cede680$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $77f9f80a0cede680$var$resolve_book_type(o);
    return $77f9f80a0cede680$export$68d8715fc104d294(wb, o);
}
function $77f9f80a0cede680$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $77f9f80a0cede680$var$resolve_book_type(o);
    return $77f9f80a0cede680$export$f6ca43591cb061b1(wb, o);
}
function $77f9f80a0cede680$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $77f9f80a0cede680$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $77f9f80a0cede680$var$_fs.writeFile(filename, $77f9f80a0cede680$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $77f9f80a0cede680$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $77f9f80a0cede680$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val1 = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val1 == null || val1.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val1.v;
        switch(val1.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val1.z || !$77f9f80a0cede680$var$fmt_is_date(val1.z)) break;
                v = $77f9f80a0cede680$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $77f9f80a0cede680$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val1.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val1.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val1.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $77f9f80a0cede680$var$format_cell(val1, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $77f9f80a0cede680$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $77f9f80a0cede680$var$safe_decode_range(range);
            break;
        case 'number':
            r = $77f9f80a0cede680$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $77f9f80a0cede680$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $77f9f80a0cede680$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $77f9f80a0cede680$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $77f9f80a0cede680$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $77f9f80a0cede680$var$qreg = /"/g;
function $77f9f80a0cede680$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , w /*:number*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $77f9f80a0cede680$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val1 = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val1 == null) txt = "";
        else if (val1.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val1.t == "n" ? val1.v : $77f9f80a0cede680$var$format_cell(val1, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($77f9f80a0cede680$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID" && w == 0 && row.length == 0) txt = '"ID"';
        } else if (val1.f != null && !val1.F) {
            isempty = false;
            txt = '=' + val1.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($77f9f80a0cede680$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $77f9f80a0cede680$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $77f9f80a0cede680$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $77f9f80a0cede680$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $77f9f80a0cede680$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, w, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $77f9f80a0cede680$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $77f9f80a0cede680$var$sheet_to_csv(sheet, opts);
    if (typeof $77f9f80a0cede680$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $77f9f80a0cede680$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $77f9f80a0cede680$var$sheet_to_formulae(sheet /*:Worksheet*/ , opts /*:?Sheet2FormulaOpts*/ ) /*:Array<string>*/ {
    var y = "", x, val1 = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $77f9f80a0cede680$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $77f9f80a0cede680$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $77f9f80a0cede680$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val1 = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val1 = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val1 = x.f;
            else if (opts && opts.values === false) continue;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val1 = "" + x.v;
            else if (x.t == 'b') val1 = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val1 = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val1 = "'" + x.v;
            else val1 = "" + x.v;
            cmds[cmds.length] = y + "=" + val1;
        }
    }
    return cmds;
}
function $77f9f80a0cede680$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($77f9f80a0cede680$var$DENSE != null && dense == null) dense = $77f9f80a0cede680$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $77f9f80a0cede680$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $77f9f80a0cede680$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $77f9f80a0cede680$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $77f9f80a0cede680$var$encode_col(_C + C) + $77f9f80a0cede680$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $77f9f80a0cede680$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $77f9f80a0cede680$var$datenum(v);
                    }
                    z = cell != null && cell.z && $77f9f80a0cede680$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $77f9f80a0cede680$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $77f9f80a0cede680$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$77f9f80a0cede680$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $77f9f80a0cede680$var$encode_range(range);
    return ws;
}
function $77f9f80a0cede680$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $77f9f80a0cede680$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $77f9f80a0cede680$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $77f9f80a0cede680$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $77f9f80a0cede680$var$ws_get_cell_stub(ws, $77f9f80a0cede680$var$encode_cell(R));
    /* R and C are 0-based indices */ return $77f9f80a0cede680$var$ws_get_cell_stub(ws, $77f9f80a0cede680$var$encode_col(C || 0) + $77f9f80a0cede680$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $77f9f80a0cede680$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $77f9f80a0cede680$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $77f9f80a0cede680$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $77f9f80a0cede680$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $77f9f80a0cede680$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $77f9f80a0cede680$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $77f9f80a0cede680$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $77f9f80a0cede680$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $77f9f80a0cede680$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $77f9f80a0cede680$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $77f9f80a0cede680$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $77f9f80a0cede680$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $77f9f80a0cede680$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $77f9f80a0cede680$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $77f9f80a0cede680$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $77f9f80a0cede680$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $77f9f80a0cede680$var$encode_range(wsr);
    return ws;
}
var $77f9f80a0cede680$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $77f9f80a0cede680$var$encode_col,
    encode_row: $77f9f80a0cede680$var$encode_row,
    encode_cell: $77f9f80a0cede680$var$encode_cell,
    encode_range: $77f9f80a0cede680$var$encode_range,
    decode_col: $77f9f80a0cede680$var$decode_col,
    decode_row: $77f9f80a0cede680$var$decode_row,
    split_cell: $77f9f80a0cede680$var$split_cell,
    decode_cell: $77f9f80a0cede680$var$decode_cell,
    decode_range: $77f9f80a0cede680$var$decode_range,
    format_cell: $77f9f80a0cede680$var$format_cell,
    sheet_new: $77f9f80a0cede680$var$sheet_new,
    sheet_add_aoa: $77f9f80a0cede680$var$sheet_add_aoa,
    sheet_add_json: $77f9f80a0cede680$var$sheet_add_json,
    sheet_add_dom: $77f9f80a0cede680$var$sheet_add_dom,
    aoa_to_sheet: $77f9f80a0cede680$var$aoa_to_sheet,
    json_to_sheet: $77f9f80a0cede680$var$json_to_sheet,
    table_to_sheet: $77f9f80a0cede680$var$parse_dom_table,
    table_to_book: $77f9f80a0cede680$var$table_to_book,
    sheet_to_csv: $77f9f80a0cede680$var$sheet_to_csv,
    sheet_to_txt: $77f9f80a0cede680$var$sheet_to_txt,
    sheet_to_json: $77f9f80a0cede680$var$sheet_to_json,
    sheet_to_html: $77f9f80a0cede680$var$sheet_to_html,
    sheet_to_formulae: $77f9f80a0cede680$var$sheet_to_formulae,
    sheet_to_row_object_array: $77f9f80a0cede680$var$sheet_to_json,
    sheet_get_cell: $77f9f80a0cede680$var$ws_get_cell_stub,
    book_new: $77f9f80a0cede680$var$book_new,
    book_append_sheet: $77f9f80a0cede680$var$book_append_sheet,
    book_set_sheet_visibility: $77f9f80a0cede680$var$book_set_sheet_visibility,
    cell_set_number_format: $77f9f80a0cede680$var$cell_set_number_format,
    cell_set_hyperlink: $77f9f80a0cede680$var$cell_set_hyperlink,
    cell_set_internal_link: $77f9f80a0cede680$var$cell_set_internal_link,
    cell_add_comment: $77f9f80a0cede680$var$cell_add_comment,
    sheet_set_array_formula: $77f9f80a0cede680$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $77f9f80a0cede680$var$_Readable;
function $77f9f80a0cede680$var$set_readable(R) {
    $77f9f80a0cede680$var$_Readable = R;
}
function $77f9f80a0cede680$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $77f9f80a0cede680$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $77f9f80a0cede680$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $77f9f80a0cede680$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $77f9f80a0cede680$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, w, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $77f9f80a0cede680$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $77f9f80a0cede680$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $77f9f80a0cede680$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $77f9f80a0cede680$var$HTML_END;
    stream.push(header);
    var r = $77f9f80a0cede680$var$decode_range(ws['!ref']);
    stream.push($77f9f80a0cede680$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($77f9f80a0cede680$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $77f9f80a0cede680$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $77f9f80a0cede680$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $77f9f80a0cede680$var$safe_decode_range(range);
            break;
        case 'number':
            r = $77f9f80a0cede680$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $77f9f80a0cede680$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $77f9f80a0cede680$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $77f9f80a0cede680$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $77f9f80a0cede680$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $77f9f80a0cede680$var$write_xlml_stream(wb /*:Workbook*/ , o /*:?Sheet2XLMLOpts*/ ) {
    var stream = $77f9f80a0cede680$var$_Readable();
    var opts = o == null ? {} : o;
    var stride = +opts.stride || 10;
    if (!wb.SSF) wb.SSF = $77f9f80a0cede680$var$dup($77f9f80a0cede680$var$table_fmt);
    if (wb.SSF) {
        $77f9f80a0cede680$var$make_ssf();
        $77f9f80a0cede680$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $77f9f80a0cede680$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    /* do one pass to determine styles since they must be added before tables */ wb.SheetNames.forEach(function(n) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!ref"]) return;
        var range = $77f9f80a0cede680$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var ddata = dense ? ws["!data"] : [];
        var addr = {
            r: 0,
            c: 0
        };
        for(var R = range.s.r; R <= range.e.r; ++R){
            addr.r = R;
            if (dense && !ddata[R]) continue;
            for(var C = range.s.c; C <= range.e.c; ++C){
                addr.c = C;
                var cell = dense ? ddata[R][C] : ws[$77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R)];
                if (!cell) continue;
                if (cell.t == "d" && cell.z == null) {
                    cell = $77f9f80a0cede680$var$dup(cell);
                    cell.z = $77f9f80a0cede680$var$table_fmt[14];
                }
                $77f9f80a0cede680$var$get_cell_style(opts.cellXfs, cell, opts);
            }
        }
    });
    var sty = $77f9f80a0cede680$var$write_sty_xlml(wb, opts);
    var stage = 0, wsidx = 0, ws = wb.Sheets[wb.SheetNames[wsidx]], range = $77f9f80a0cede680$var$safe_decode_range(ws), R = -1, T = false;
    var marr = [], mi = 0, dense = false, darr = [], addr = {
        r: 0,
        c: 0
    };
    stream._read = function() {
        switch(stage){
            /* header */ case 0:
                stage = 1;
                stream.push($77f9f80a0cede680$var$XML_HEADER);
                stream.push("<Workbook" + $77f9f80a0cede680$var$wxt_helper({
                    'xmlns': $77f9f80a0cede680$var$XLMLNS.ss,
                    'xmlns:o': $77f9f80a0cede680$var$XLMLNS.o,
                    'xmlns:x': $77f9f80a0cede680$var$XLMLNS.x,
                    'xmlns:ss': $77f9f80a0cede680$var$XLMLNS.ss,
                    'xmlns:dt': $77f9f80a0cede680$var$XLMLNS.dt,
                    'xmlns:html': $77f9f80a0cede680$var$XLMLNS.html
                }) + ">");
                break;
            /* preamble */ case 1:
                stage = 2;
                stream.push($77f9f80a0cede680$var$write_props_xlml(wb, opts));
                stream.push($77f9f80a0cede680$var$write_wb_xlml(wb, opts));
                break;
            /* style and name tables */ case 2:
                stage = 3;
                stream.push(sty);
                stream.push($77f9f80a0cede680$var$write_names_xlml(wb, opts));
                break;
            /* worksheet preamble */ case 3:
                T = false;
                if (wsidx >= wb.SheetNames.length) {
                    stage = -1;
                    stream.push("");
                    break;
                }
                stream.push("<Worksheet" + $77f9f80a0cede680$var$wxt_helper({
                    "ss:Name": $77f9f80a0cede680$var$escapexml(wb.SheetNames[wsidx])
                }) + ">");
                ws = wb.Sheets[wb.SheetNames[wsidx]];
                if (!ws) {
                    stream.push("</Worksheet>");
                    return void ++wsidx;
                }
                var names = $77f9f80a0cede680$var$write_ws_xlml_names(ws, opts, wsidx, wb);
                if (names.length) stream.push("<Names>" + names + "</Names>");
                if (!ws["!ref"]) return stage = 5;
                range = $77f9f80a0cede680$var$safe_decode_range(ws["!ref"]);
                R = range.s.r;
                stage = 4;
                break;
            /* worksheet intramble */ case 4:
                if (R < 0 || R > range.e.r) {
                    if (T) stream.push("</Table>");
                    return void (stage = 5);
                }
                if (R <= range.s.r) {
                    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
                        $77f9f80a0cede680$var$process_col(n);
                        var w = !!n.width;
                        var p = $77f9f80a0cede680$var$col_obj_w(i, n);
                        var k /*:any*/  = {
                            "ss:Index": i + 1
                        };
                        if (w) k['ss:Width'] = $77f9f80a0cede680$var$width2px(p.width);
                        if (n.hidden) k['ss:Hidden'] = "1";
                        if (!T) {
                            T = true;
                            stream.push("<Table>");
                        }
                        stream.push($77f9f80a0cede680$var$writextag("Column", null, k));
                    });
                    dense = ws["!data"] != null;
                    if (dense) darr = ws["!data"];
                    addr.r = addr.c = 0;
                }
                /* process `stride` rows per invocation */ for(var cnt = 0; R <= range.e.r && cnt < stride; ++R, ++cnt){
                    var row = [
                        $77f9f80a0cede680$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
                    ];
                    addr.r = R;
                    if (!(dense && !darr[R])) for(var C = range.s.c; C <= range.e.c; ++C){
                        addr.c = C;
                        var skip = false;
                        for(mi = 0; mi != marr.length; ++mi){
                            if (marr[mi].s.c > C) continue;
                            if (marr[mi].s.r > R) continue;
                            if (marr[mi].e.c < C) continue;
                            if (marr[mi].e.r < R) continue;
                            if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                            break;
                        }
                        if (skip) continue;
                        var ref = $77f9f80a0cede680$var$encode_col(C) + $77f9f80a0cede680$var$encode_row(R), cell = dense ? darr[R][C] : ws[ref];
                        row.push($77f9f80a0cede680$var$write_ws_xlml_cell(cell, ref, ws, opts, wsidx, wb, addr));
                    }
                    row.push("</Row>");
                    if (!T) {
                        T = true;
                        stream.push("<Table>");
                    }
                    stream.push(row.join(""));
                }
                break;
            /* worksheet postamble */ case 5:
                stream.push($77f9f80a0cede680$var$write_ws_xlml_wsopts(ws, opts, wsidx, wb));
                if (ws && ws["!autofilter"]) stream.push('<AutoFilter x:Range="' + $77f9f80a0cede680$var$a1_to_rc($77f9f80a0cede680$var$fix_range(ws["!autofilter"].ref), {
                    r: 0,
                    c: 0
                }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
                stream.push("</Worksheet>");
                wsidx++;
                R = -1;
                return void (stage = 3);
            /* footer */ case -1:
                stage = -2;
                stream.push("</Workbook>");
                break;
            /* exeunt */ case -2:
                stream.push(null);
                break;
        }
    };
    return stream;
}
var $77f9f80a0cede680$export$4938110305e6185f = {
    to_json: $77f9f80a0cede680$var$write_json_stream,
    to_html: $77f9f80a0cede680$var$write_html_stream,
    to_csv: $77f9f80a0cede680$var$write_csv_stream,
    to_xlml: $77f9f80a0cede680$var$write_xlml_stream,
    set_readable: $77f9f80a0cede680$var$set_readable
};
const $77f9f80a0cede680$export$83d89fbfd8236492 = $77f9f80a0cede680$var$XLSX.version;
var $77f9f80a0cede680$export$2e2bcd8739ae039 = {
    parse_xlscfb: $77f9f80a0cede680$export$b41972a043aba84c,
    parse_zip: $77f9f80a0cede680$export$b165387946f79a1,
    read: $77f9f80a0cede680$export$aafa59e2e03f2942,
    readFile: $77f9f80a0cede680$export$72c04af63de9061a,
    readFileSync: $77f9f80a0cede680$export$72c04af63de9061a,
    write: $77f9f80a0cede680$export$68d8715fc104d294,
    writeFile: $77f9f80a0cede680$export$552bfb764b5cd2b4,
    writeFileSync: $77f9f80a0cede680$export$552bfb764b5cd2b4,
    writeFileAsync: $77f9f80a0cede680$export$25469296c4b8ebda,
    writeXLSX: $77f9f80a0cede680$export$f6ca43591cb061b1,
    writeFileXLSX: $77f9f80a0cede680$export$40a06aea54ee074e,
    utils: $77f9f80a0cede680$export$eab97d15b1788b8d,
    set_fs: $77f9f80a0cede680$export$a48eb669e1768bcf,
    set_cptable: $77f9f80a0cede680$export$58f247d16f363b86,
    stream: $77f9f80a0cede680$export$4938110305e6185f,
    SSF: $77f9f80a0cede680$export$40d8edd678456c2b,
    CFB: $77f9f80a0cede680$export$9f0e51cd97c572a
};


Object.defineProperty($bd9b13a4b7314f5d$exports, "utils", {
    enumerable: true,
    get: function() {
        return $77f9f80a0cede680$export$eab97d15b1788b8d;
    }
});
var $c896cea3fd00e6ea$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $b4fa0ac54ada5015$export$a143d493d941bafc;
var $b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a;
var $b4fa0ac54ada5015$export$f99ded8fe4b79145;
var $b4fa0ac54ada5015$export$599f31c3813fae4d;
'use strict';
var $bfa49c0062a5803d$export$a48f0734ac7c2329;
var $bfa49c0062a5803d$export$d622b2ad8d90c771;
var $bfa49c0062a5803d$export$6100ba28696e12de;
'use strict';
$bfa49c0062a5803d$export$a48f0734ac7c2329 = $bfa49c0062a5803d$var$byteLength;
$bfa49c0062a5803d$export$d622b2ad8d90c771 = $bfa49c0062a5803d$var$toByteArray;
$bfa49c0062a5803d$export$6100ba28696e12de = $bfa49c0062a5803d$var$fromByteArray;
var $bfa49c0062a5803d$var$lookup = [];
var $bfa49c0062a5803d$var$revLookup = [];
var $bfa49c0062a5803d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $bfa49c0062a5803d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $bfa49c0062a5803d$var$i = 0, $bfa49c0062a5803d$var$len = $bfa49c0062a5803d$var$code.length; $bfa49c0062a5803d$var$i < $bfa49c0062a5803d$var$len; ++$bfa49c0062a5803d$var$i){
    $bfa49c0062a5803d$var$lookup[$bfa49c0062a5803d$var$i] = $bfa49c0062a5803d$var$code[$bfa49c0062a5803d$var$i];
    $bfa49c0062a5803d$var$revLookup[$bfa49c0062a5803d$var$code.charCodeAt($bfa49c0062a5803d$var$i)] = $bfa49c0062a5803d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$bfa49c0062a5803d$var$revLookup['-'.charCodeAt(0)] = 62;
$bfa49c0062a5803d$var$revLookup['_'.charCodeAt(0)] = 63;
function $bfa49c0062a5803d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $bfa49c0062a5803d$var$byteLength(b64) {
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $bfa49c0062a5803d$var$toByteArray(b64) {
    var tmp;
    var lens = $bfa49c0062a5803d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $bfa49c0062a5803d$var$Arr($bfa49c0062a5803d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 18 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 2 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i)] << 10 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $bfa49c0062a5803d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $bfa49c0062a5803d$var$tripletToBase64(num) {
    return $bfa49c0062a5803d$var$lookup[num >> 18 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 12 & 0x3F] + $bfa49c0062a5803d$var$lookup[num >> 6 & 0x3F] + $bfa49c0062a5803d$var$lookup[num & 0x3F];
}
function $bfa49c0062a5803d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($bfa49c0062a5803d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $bfa49c0062a5803d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($bfa49c0062a5803d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 2] + $bfa49c0062a5803d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($bfa49c0062a5803d$var$lookup[tmp >> 10] + $bfa49c0062a5803d$var$lookup[tmp >> 4 & 0x3F] + $bfa49c0062a5803d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $23e3cc2fb993da68$export$aafa59e2e03f2942;
var $23e3cc2fb993da68$export$68d8715fc104d294;
$23e3cc2fb993da68$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$23e3cc2fb993da68$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $b4fa0ac54ada5015$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$b4fa0ac54ada5015$export$a143d493d941bafc = $b4fa0ac54ada5015$var$Buffer;
$b4fa0ac54ada5015$export$e4cf37d7f6fb9e0a = $b4fa0ac54ada5015$var$SlowBuffer;
$b4fa0ac54ada5015$export$f99ded8fe4b79145 = 50;
const $b4fa0ac54ada5015$var$K_MAX_LENGTH = 0x7fffffff;
$b4fa0ac54ada5015$export$599f31c3813fae4d = $b4fa0ac54ada5015$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT = $b4fa0ac54ada5015$var$typedArraySupport();
if (!$b4fa0ac54ada5015$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $b4fa0ac54ada5015$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($b4fa0ac54ada5015$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $b4fa0ac54ada5015$var$createBuffer(length) {
    if (length > $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $b4fa0ac54ada5015$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $b4fa0ac54ada5015$var$allocUnsafe(arg);
    }
    return $b4fa0ac54ada5015$var$from(arg, encodingOrOffset, length);
}
$b4fa0ac54ada5015$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $b4fa0ac54ada5015$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $b4fa0ac54ada5015$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($b4fa0ac54ada5015$var$isInstance(value, ArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, ArrayBuffer)) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($b4fa0ac54ada5015$var$isInstance(value, SharedArrayBuffer) || value && $b4fa0ac54ada5015$var$isInstance(value.buffer, SharedArrayBuffer))) return $b4fa0ac54ada5015$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $b4fa0ac54ada5015$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $b4fa0ac54ada5015$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $b4fa0ac54ada5015$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $b4fa0ac54ada5015$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $b4fa0ac54ada5015$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($b4fa0ac54ada5015$var$Buffer, Uint8Array);
function $b4fa0ac54ada5015$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $b4fa0ac54ada5015$var$alloc(size, fill, encoding) {
    $b4fa0ac54ada5015$var$assertSize(size);
    if (size <= 0) return $b4fa0ac54ada5015$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $b4fa0ac54ada5015$var$createBuffer(size).fill(fill, encoding) : $b4fa0ac54ada5015$var$createBuffer(size).fill(fill);
    return $b4fa0ac54ada5015$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $b4fa0ac54ada5015$var$Buffer.alloc = function(size, fill, encoding) {
    return $b4fa0ac54ada5015$var$alloc(size, fill, encoding);
};
function $b4fa0ac54ada5015$var$allocUnsafe(size) {
    $b4fa0ac54ada5015$var$assertSize(size);
    return $b4fa0ac54ada5015$var$createBuffer(size < 0 ? 0 : $b4fa0ac54ada5015$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $b4fa0ac54ada5015$var$Buffer.allocUnsafe = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $b4fa0ac54ada5015$var$Buffer.allocUnsafeSlow = function(size) {
    return $b4fa0ac54ada5015$var$allocUnsafe(size);
};
function $b4fa0ac54ada5015$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $b4fa0ac54ada5015$var$byteLength(string, encoding) | 0;
    let buf = $b4fa0ac54ada5015$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $b4fa0ac54ada5015$var$checked(array.length) | 0;
    const buf = $b4fa0ac54ada5015$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $b4fa0ac54ada5015$var$fromArrayView(arrayView) {
    if ($b4fa0ac54ada5015$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $b4fa0ac54ada5015$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $b4fa0ac54ada5015$var$fromArrayLike(arrayView);
}
function $b4fa0ac54ada5015$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return buf;
}
function $b4fa0ac54ada5015$var$fromObject(obj) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(obj)) {
        const len = $b4fa0ac54ada5015$var$checked(obj.length) | 0;
        const buf = $b4fa0ac54ada5015$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $b4fa0ac54ada5015$var$numberIsNaN(obj.length)) return $b4fa0ac54ada5015$var$createBuffer(0);
        return $b4fa0ac54ada5015$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $b4fa0ac54ada5015$var$fromArrayLike(obj.data);
}
function $b4fa0ac54ada5015$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $b4fa0ac54ada5015$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $b4fa0ac54ada5015$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $b4fa0ac54ada5015$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $b4fa0ac54ada5015$var$Buffer.alloc(+length);
}
$b4fa0ac54ada5015$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $b4fa0ac54ada5015$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$b4fa0ac54ada5015$var$Buffer.compare = function compare(a, b) {
    if ($b4fa0ac54ada5015$var$isInstance(a, Uint8Array)) a = $b4fa0ac54ada5015$var$Buffer.from(a, a.offset, a.byteLength);
    if ($b4fa0ac54ada5015$var$isInstance(b, Uint8Array)) b = $b4fa0ac54ada5015$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(a) || !$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$b4fa0ac54ada5015$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$b4fa0ac54ada5015$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $b4fa0ac54ada5015$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $b4fa0ac54ada5015$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($b4fa0ac54ada5015$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) buf = $b4fa0ac54ada5015$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $b4fa0ac54ada5015$var$byteLength(string, encoding) {
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $b4fa0ac54ada5015$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $b4fa0ac54ada5015$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $b4fa0ac54ada5015$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $b4fa0ac54ada5015$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$b4fa0ac54ada5015$var$Buffer.byteLength = $b4fa0ac54ada5015$var$byteLength;
function $b4fa0ac54ada5015$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $b4fa0ac54ada5015$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $b4fa0ac54ada5015$var$utf8Slice(this, start, end);
        case 'ascii':
            return $b4fa0ac54ada5015$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $b4fa0ac54ada5015$var$latin1Slice(this, start, end);
        case 'base64':
            return $b4fa0ac54ada5015$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $b4fa0ac54ada5015$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$b4fa0ac54ada5015$var$Buffer.prototype._isBuffer = true;
function $b4fa0ac54ada5015$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$b4fa0ac54ada5015$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$b4fa0ac54ada5015$var$swap(this, i, i + 1);
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $b4fa0ac54ada5015$var$swap(this, i, i + 3);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $b4fa0ac54ada5015$var$swap(this, i, i + 7);
        $b4fa0ac54ada5015$var$swap(this, i + 1, i + 6);
        $b4fa0ac54ada5015$var$swap(this, i + 2, i + 5);
        $b4fa0ac54ada5015$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$b4fa0ac54ada5015$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $b4fa0ac54ada5015$var$utf8Slice(this, 0, length);
    return $b4fa0ac54ada5015$var$slowToString.apply(this, arguments);
};
$b4fa0ac54ada5015$var$Buffer.prototype.toLocaleString = $b4fa0ac54ada5015$var$Buffer.prototype.toString;
$b4fa0ac54ada5015$var$Buffer.prototype.equals = function equals(b) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $b4fa0ac54ada5015$var$Buffer.compare(this, b) === 0;
};
$b4fa0ac54ada5015$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $b4fa0ac54ada5015$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($b4fa0ac54ada5015$var$customInspectSymbol) $b4fa0ac54ada5015$var$Buffer.prototype[$b4fa0ac54ada5015$var$customInspectSymbol] = $b4fa0ac54ada5015$var$Buffer.prototype.inspect;
$b4fa0ac54ada5015$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($b4fa0ac54ada5015$var$isInstance(target, Uint8Array)) target = $b4fa0ac54ada5015$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $b4fa0ac54ada5015$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($b4fa0ac54ada5015$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($b4fa0ac54ada5015$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $b4fa0ac54ada5015$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $b4fa0ac54ada5015$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$b4fa0ac54ada5015$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$b4fa0ac54ada5015$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $b4fa0ac54ada5015$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $b4fa0ac54ada5015$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($b4fa0ac54ada5015$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $b4fa0ac54ada5015$var$utf8Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $b4fa0ac54ada5015$var$asciiWrite(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$asciiToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$base64Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$base64ToBytes(string), buf, offset, length);
}
function $b4fa0ac54ada5015$var$ucs2Write(buf, string, offset, length) {
    return $b4fa0ac54ada5015$var$blitBuffer($b4fa0ac54ada5015$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$b4fa0ac54ada5015$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $b4fa0ac54ada5015$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $b4fa0ac54ada5015$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $b4fa0ac54ada5015$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $b4fa0ac54ada5015$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $b4fa0ac54ada5015$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$b4fa0ac54ada5015$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $b4fa0ac54ada5015$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bfa49c0062a5803d$export$6100ba28696e12de(buf);
    else return $bfa49c0062a5803d$export$6100ba28696e12de(buf.slice(start, end));
}
function $b4fa0ac54ada5015$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $b4fa0ac54ada5015$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $b4fa0ac54ada5015$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $b4fa0ac54ada5015$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $b4fa0ac54ada5015$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $b4fa0ac54ada5015$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $b4fa0ac54ada5015$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $b4fa0ac54ada5015$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $b4fa0ac54ada5015$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$b4fa0ac54ada5015$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $b4fa0ac54ada5015$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $b4fa0ac54ada5015$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$b4fa0ac54ada5015$var$Buffer.prototype.readUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$b4fa0ac54ada5015$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $b4fa0ac54ada5015$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 4, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$b4fa0ac54ada5015$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkOffset(offset, 8, this.length);
    return $23e3cc2fb993da68$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $b4fa0ac54ada5015$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintLE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUintBE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint8 = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint16BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32LE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeUint32BE = $b4fa0ac54ada5015$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $b4fa0ac54ada5015$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $b4fa0ac54ada5015$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigUInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $b4fa0ac54ada5015$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64LE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$b4fa0ac54ada5015$var$Buffer.prototype.writeBigInt64BE = $b4fa0ac54ada5015$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $b4fa0ac54ada5015$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $b4fa0ac54ada5015$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $23e3cc2fb993da68$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeFloat(this, value, offset, false, noAssert);
};
function $b4fa0ac54ada5015$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $b4fa0ac54ada5015$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $23e3cc2fb993da68$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, true, noAssert);
};
$b4fa0ac54ada5015$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $b4fa0ac54ada5015$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$b4fa0ac54ada5015$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$b4fa0ac54ada5015$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$b4fa0ac54ada5015$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$b4fa0ac54ada5015$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $b4fa0ac54ada5015$var$Buffer.isBuffer(val) ? val : $b4fa0ac54ada5015$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $b4fa0ac54ada5015$var$errors = {};
function $b4fa0ac54ada5015$var$E(sym, getMessage, Base) {
    $b4fa0ac54ada5015$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$b4fa0ac54ada5015$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$b4fa0ac54ada5015$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$b4fa0ac54ada5015$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $b4fa0ac54ada5015$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $b4fa0ac54ada5015$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $b4fa0ac54ada5015$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength) {
    $b4fa0ac54ada5015$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $b4fa0ac54ada5015$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $b4fa0ac54ada5015$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $b4fa0ac54ada5015$var$checkBounds(buf, offset, byteLength);
}
function $b4fa0ac54ada5015$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $b4fa0ac54ada5015$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $b4fa0ac54ada5015$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $b4fa0ac54ada5015$var$validateNumber(value, type);
        throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $b4fa0ac54ada5015$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $b4fa0ac54ada5015$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $b4fa0ac54ada5015$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $b4fa0ac54ada5015$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($b4fa0ac54ada5015$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $b4fa0ac54ada5015$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $b4fa0ac54ada5015$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $b4fa0ac54ada5015$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $b4fa0ac54ada5015$var$base64ToBytes(str) {
    return $bfa49c0062a5803d$export$d622b2ad8d90c771($b4fa0ac54ada5015$var$base64clean(str));
}
function $b4fa0ac54ada5015$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $b4fa0ac54ada5015$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $b4fa0ac54ada5015$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $b4fa0ac54ada5015$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $b4fa0ac54ada5015$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $b4fa0ac54ada5015$var$BufferBigIntNotDefined : fn;
}
function $b4fa0ac54ada5015$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $c896cea3fd00e6ea$require$Buffer = $b4fa0ac54ada5015$export$a143d493d941bafc;
"use strict";
Object.defineProperty($c896cea3fd00e6ea$exports, "__esModule", {
    value: true
});
$c896cea3fd00e6ea$exports.saveXlsxOutput = $c896cea3fd00e6ea$exports.toStyledOutput = $c896cea3fd00e6ea$exports.patchStyledWorkbook = $c896cea3fd00e6ea$exports.isCellStyleObject = $c896cea3fd00e6ea$exports.mergeCellStyles = void 0;
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $02f165b0c7730766$var$ch2 = {};
var $02f165b0c7730766$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($02f165b0c7730766$var$ch2[id] || ($02f165b0c7730766$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $02f165b0c7730766$var$u8 = Uint8Array, $02f165b0c7730766$var$u16 = Uint16Array, $02f165b0c7730766$var$i32 = Int32Array;
// fixed length extra bits
var $02f165b0c7730766$var$fleb = new $02f165b0c7730766$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $02f165b0c7730766$var$fdeb = new $02f165b0c7730766$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $02f165b0c7730766$var$clim = new $02f165b0c7730766$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $02f165b0c7730766$var$freb = function(eb, start) {
    var b = new $02f165b0c7730766$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $02f165b0c7730766$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $02f165b0c7730766$var$_a = $02f165b0c7730766$var$freb($02f165b0c7730766$var$fleb, 2), $02f165b0c7730766$var$fl = $02f165b0c7730766$var$_a.b, $02f165b0c7730766$var$revfl = $02f165b0c7730766$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$02f165b0c7730766$var$fl[28] = 258, $02f165b0c7730766$var$revfl[258] = 28;
var $02f165b0c7730766$var$_b = $02f165b0c7730766$var$freb($02f165b0c7730766$var$fdeb, 0), $02f165b0c7730766$var$fd = $02f165b0c7730766$var$_b.b, $02f165b0c7730766$var$revfd = $02f165b0c7730766$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $02f165b0c7730766$var$rev = new $02f165b0c7730766$var$u16(32768);
for(var $02f165b0c7730766$var$i = 0; $02f165b0c7730766$var$i < 32768; ++$02f165b0c7730766$var$i){
    // reverse table algorithm from SO
    var $02f165b0c7730766$var$x = ($02f165b0c7730766$var$i & 0xAAAA) >> 1 | ($02f165b0c7730766$var$i & 0x5555) << 1;
    $02f165b0c7730766$var$x = ($02f165b0c7730766$var$x & 0xCCCC) >> 2 | ($02f165b0c7730766$var$x & 0x3333) << 2;
    $02f165b0c7730766$var$x = ($02f165b0c7730766$var$x & 0xF0F0) >> 4 | ($02f165b0c7730766$var$x & 0x0F0F) << 4;
    $02f165b0c7730766$var$rev[$02f165b0c7730766$var$i] = (($02f165b0c7730766$var$x & 0xFF00) >> 8 | ($02f165b0c7730766$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $02f165b0c7730766$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $02f165b0c7730766$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $02f165b0c7730766$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $02f165b0c7730766$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$02f165b0c7730766$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $02f165b0c7730766$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $02f165b0c7730766$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $02f165b0c7730766$var$flt = new $02f165b0c7730766$var$u8(288);
for(var $02f165b0c7730766$var$i = 0; $02f165b0c7730766$var$i < 144; ++$02f165b0c7730766$var$i)$02f165b0c7730766$var$flt[$02f165b0c7730766$var$i] = 8;
for(var $02f165b0c7730766$var$i = 144; $02f165b0c7730766$var$i < 256; ++$02f165b0c7730766$var$i)$02f165b0c7730766$var$flt[$02f165b0c7730766$var$i] = 9;
for(var $02f165b0c7730766$var$i = 256; $02f165b0c7730766$var$i < 280; ++$02f165b0c7730766$var$i)$02f165b0c7730766$var$flt[$02f165b0c7730766$var$i] = 7;
for(var $02f165b0c7730766$var$i = 280; $02f165b0c7730766$var$i < 288; ++$02f165b0c7730766$var$i)$02f165b0c7730766$var$flt[$02f165b0c7730766$var$i] = 8;
// fixed distance tree
var $02f165b0c7730766$var$fdt = new $02f165b0c7730766$var$u8(32);
for(var $02f165b0c7730766$var$i = 0; $02f165b0c7730766$var$i < 32; ++$02f165b0c7730766$var$i)$02f165b0c7730766$var$fdt[$02f165b0c7730766$var$i] = 5;
// fixed length map
var $02f165b0c7730766$var$flm = /*#__PURE__*/ $02f165b0c7730766$var$hMap($02f165b0c7730766$var$flt, 9, 0), $02f165b0c7730766$var$flrm = /*#__PURE__*/ $02f165b0c7730766$var$hMap($02f165b0c7730766$var$flt, 9, 1);
// fixed distance map
var $02f165b0c7730766$var$fdm = /*#__PURE__*/ $02f165b0c7730766$var$hMap($02f165b0c7730766$var$fdt, 5, 0), $02f165b0c7730766$var$fdrm = /*#__PURE__*/ $02f165b0c7730766$var$hMap($02f165b0c7730766$var$fdt, 5, 1);
// find max of array
var $02f165b0c7730766$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $02f165b0c7730766$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $02f165b0c7730766$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $02f165b0c7730766$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $02f165b0c7730766$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $02f165b0c7730766$var$u8(v.subarray(s, e));
};
var $02f165b0c7730766$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $02f165b0c7730766$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $02f165b0c7730766$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $02f165b0c7730766$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $02f165b0c7730766$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $02f165b0c7730766$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $02f165b0c7730766$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $02f165b0c7730766$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $02f165b0c7730766$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $02f165b0c7730766$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $02f165b0c7730766$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $02f165b0c7730766$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $02f165b0c7730766$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $02f165b0c7730766$var$flrm, dm = $02f165b0c7730766$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $02f165b0c7730766$var$bits(dat, pos, 31) + 257, hcLen = $02f165b0c7730766$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $02f165b0c7730766$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $02f165b0c7730766$var$u8(tl);
                // code length tree
                var clt = new $02f165b0c7730766$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$02f165b0c7730766$var$clim[i]] = $02f165b0c7730766$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $02f165b0c7730766$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $02f165b0c7730766$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$02f165b0c7730766$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $02f165b0c7730766$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $02f165b0c7730766$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $02f165b0c7730766$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $02f165b0c7730766$var$max(lt);
                // max dist bits
                dbt = $02f165b0c7730766$var$max(dt);
                lm = $02f165b0c7730766$var$hMap(lt, lbt, 1);
                dm = $02f165b0c7730766$var$hMap(dt, dbt, 1);
            } else $02f165b0c7730766$var$err(1);
            if (pos > tbts) {
                if (noSt) $02f165b0c7730766$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$02f165b0c7730766$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $02f165b0c7730766$var$err(0);
                break;
            }
            if (!c) $02f165b0c7730766$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $02f165b0c7730766$var$fleb[i];
                    add = $02f165b0c7730766$var$bits(dat, pos, (1 << b) - 1) + $02f165b0c7730766$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$02f165b0c7730766$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $02f165b0c7730766$var$err(3);
                pos += d & 15;
                var dt = $02f165b0c7730766$var$fd[dsym];
                if (dsym > 3) {
                    var b = $02f165b0c7730766$var$fdeb[dsym];
                    dt += $02f165b0c7730766$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $02f165b0c7730766$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $02f165b0c7730766$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $02f165b0c7730766$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $02f165b0c7730766$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $02f165b0c7730766$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $02f165b0c7730766$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $02f165b0c7730766$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $02f165b0c7730766$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $02f165b0c7730766$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $02f165b0c7730766$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $02f165b0c7730766$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $02f165b0c7730766$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($02f165b0c7730766$var$ln(n.l, l, d + 1), $02f165b0c7730766$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $02f165b0c7730766$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $02f165b0c7730766$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $02f165b0c7730766$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $02f165b0c7730766$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $02f165b0c7730766$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $02f165b0c7730766$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $02f165b0c7730766$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $02f165b0c7730766$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $02f165b0c7730766$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $02f165b0c7730766$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $02f165b0c7730766$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $02f165b0c7730766$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $02f165b0c7730766$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$02f165b0c7730766$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $02f165b0c7730766$var$clen(lf, $02f165b0c7730766$var$flt) + $02f165b0c7730766$var$clen(df, $02f165b0c7730766$var$fdt) + eb;
    var dtlen = $02f165b0c7730766$var$clen(lf, dlt) + $02f165b0c7730766$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $02f165b0c7730766$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $02f165b0c7730766$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $02f165b0c7730766$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $02f165b0c7730766$var$hMap(dlt, mlb, 0), ll = dlt, dm = $02f165b0c7730766$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $02f165b0c7730766$var$hMap(lct, mlcb, 0);
        $02f165b0c7730766$var$wbits(out, p, nlc - 257);
        $02f165b0c7730766$var$wbits(out, p + 5, ndc - 1);
        $02f165b0c7730766$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$02f165b0c7730766$var$wbits(out, p + 3 * i, lct[$02f165b0c7730766$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $02f165b0c7730766$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $02f165b0c7730766$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $02f165b0c7730766$var$flm, ll = $02f165b0c7730766$var$flt, dm = $02f165b0c7730766$var$fdm, dl = $02f165b0c7730766$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $02f165b0c7730766$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $02f165b0c7730766$var$wbits(out, p, sym >> 23 & 31), p += $02f165b0c7730766$var$fleb[len];
            var dst = sym & 31;
            $02f165b0c7730766$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $02f165b0c7730766$var$wbits16(out, p, sym >> 5 & 8191), p += $02f165b0c7730766$var$fdeb[dst];
        } else $02f165b0c7730766$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $02f165b0c7730766$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $02f165b0c7730766$var$deo = /*#__PURE__*/ new $02f165b0c7730766$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $02f165b0c7730766$var$et = /*#__PURE__*/ new $02f165b0c7730766$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $02f165b0c7730766$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $02f165b0c7730766$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $02f165b0c7730766$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $02f165b0c7730766$var$u16(32768), head = st.h || new $02f165b0c7730766$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $02f165b0c7730766$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $02f165b0c7730766$var$u16(288), df = new $02f165b0c7730766$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $02f165b0c7730766$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $02f165b0c7730766$var$revfl[l] << 18 | $02f165b0c7730766$var$revfd[d];
                    var lin = $02f165b0c7730766$var$revfl[l] & 31, din = $02f165b0c7730766$var$revfd[d] & 31;
                    eb += $02f165b0c7730766$var$fleb[lin] + $02f165b0c7730766$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $02f165b0c7730766$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $02f165b0c7730766$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $02f165b0c7730766$var$slc(o, 0, pre + $02f165b0c7730766$var$shft(pos) + post);
};
// CRC32 table
var $02f165b0c7730766$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $02f165b0c7730766$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $02f165b0c7730766$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $02f165b0c7730766$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $02f165b0c7730766$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $02f165b0c7730766$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $02f165b0c7730766$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $02f165b0c7730766$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $02f165b0c7730766$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $02f165b0c7730766$var$ch = [];
// clone bufs
var $02f165b0c7730766$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $02f165b0c7730766$var$wrkr = function(fns, init, id, cb) {
    if (!$02f165b0c7730766$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $02f165b0c7730766$var$wcln(fns[i], fnStr, td_1);
        $02f165b0c7730766$var$ch[id] = {
            c: $02f165b0c7730766$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $02f165b0c7730766$var$mrg({}, $02f165b0c7730766$var$ch[id].e);
    return $02f165b0c7730766$var$wk($02f165b0c7730766$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $02f165b0c7730766$var$cbfs(td), cb);
};
// base async inflate fn
var $02f165b0c7730766$var$bInflt = function() {
    return [
        $02f165b0c7730766$var$u8,
        $02f165b0c7730766$var$u16,
        $02f165b0c7730766$var$i32,
        $02f165b0c7730766$var$fleb,
        $02f165b0c7730766$var$fdeb,
        $02f165b0c7730766$var$clim,
        $02f165b0c7730766$var$fl,
        $02f165b0c7730766$var$fd,
        $02f165b0c7730766$var$flrm,
        $02f165b0c7730766$var$fdrm,
        $02f165b0c7730766$var$rev,
        $02f165b0c7730766$var$ec,
        $02f165b0c7730766$var$hMap,
        $02f165b0c7730766$var$max,
        $02f165b0c7730766$var$bits,
        $02f165b0c7730766$var$bits16,
        $02f165b0c7730766$var$shft,
        $02f165b0c7730766$var$slc,
        $02f165b0c7730766$var$err,
        $02f165b0c7730766$var$inflt,
        $02f165b0c7730766$export$90366d8b308ba94a,
        $02f165b0c7730766$var$pbf,
        $02f165b0c7730766$var$gopt
    ];
};
var $02f165b0c7730766$var$bDflt = function() {
    return [
        $02f165b0c7730766$var$u8,
        $02f165b0c7730766$var$u16,
        $02f165b0c7730766$var$i32,
        $02f165b0c7730766$var$fleb,
        $02f165b0c7730766$var$fdeb,
        $02f165b0c7730766$var$clim,
        $02f165b0c7730766$var$revfl,
        $02f165b0c7730766$var$revfd,
        $02f165b0c7730766$var$flm,
        $02f165b0c7730766$var$flt,
        $02f165b0c7730766$var$fdm,
        $02f165b0c7730766$var$fdt,
        $02f165b0c7730766$var$rev,
        $02f165b0c7730766$var$deo,
        $02f165b0c7730766$var$et,
        $02f165b0c7730766$var$hMap,
        $02f165b0c7730766$var$wbits,
        $02f165b0c7730766$var$wbits16,
        $02f165b0c7730766$var$hTree,
        $02f165b0c7730766$var$ln,
        $02f165b0c7730766$var$lc,
        $02f165b0c7730766$var$clen,
        $02f165b0c7730766$var$wfblk,
        $02f165b0c7730766$var$wblk,
        $02f165b0c7730766$var$shft,
        $02f165b0c7730766$var$slc,
        $02f165b0c7730766$var$dflt,
        $02f165b0c7730766$var$dopt,
        $02f165b0c7730766$export$21533ff51b8a0b4a,
        $02f165b0c7730766$var$pbf
    ];
};
// gzip extra
var $02f165b0c7730766$var$gze = function() {
    return [
        $02f165b0c7730766$var$gzh,
        $02f165b0c7730766$var$gzhl,
        $02f165b0c7730766$var$wbytes,
        $02f165b0c7730766$var$crc,
        $02f165b0c7730766$var$crct
    ];
};
// gunzip extra
var $02f165b0c7730766$var$guze = function() {
    return [
        $02f165b0c7730766$var$gzs,
        $02f165b0c7730766$var$gzl
    ];
};
// zlib extra
var $02f165b0c7730766$var$zle = function() {
    return [
        $02f165b0c7730766$var$zlh,
        $02f165b0c7730766$var$wbytes,
        $02f165b0c7730766$var$adler
    ];
};
// unzlib extra
var $02f165b0c7730766$var$zule = function() {
    return [
        $02f165b0c7730766$var$zls
    ];
};
// post buf
var $02f165b0c7730766$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $02f165b0c7730766$var$gopt = function(o) {
    return o && {
        out: o.size && new $02f165b0c7730766$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $02f165b0c7730766$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $02f165b0c7730766$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $02f165b0c7730766$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $02f165b0c7730766$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $02f165b0c7730766$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $02f165b0c7730766$var$err(5);
        if (t) strm.ondata($02f165b0c7730766$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $02f165b0c7730766$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $02f165b0c7730766$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $02f165b0c7730766$var$b8 = function(d, b) {
    return $02f165b0c7730766$var$b4(d, b) + $02f165b0c7730766$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $02f165b0c7730766$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $02f165b0c7730766$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $02f165b0c7730766$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $02f165b0c7730766$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $02f165b0c7730766$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $02f165b0c7730766$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $02f165b0c7730766$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $02f165b0c7730766$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $02f165b0c7730766$var$adler();
        h.p(o.dictionary);
        $02f165b0c7730766$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $02f165b0c7730766$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $02f165b0c7730766$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $02f165b0c7730766$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $02f165b0c7730766$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $02f165b0c7730766$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $02f165b0c7730766$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($02f165b0c7730766$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        if (this.s.l) $02f165b0c7730766$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $02f165b0c7730766$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $02f165b0c7730766$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        if (this.s.l) $02f165b0c7730766$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $02f165b0c7730766$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $02f165b0c7730766$var$wfblk(c, this.s.r, $02f165b0c7730766$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $02f165b0c7730766$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $02f165b0c7730766$var$astrmify([
            $02f165b0c7730766$var$bDflt,
            function() {
                return [
                    $02f165b0c7730766$var$astrm,
                    $02f165b0c7730766$export$ae157b6234afe138
                ];
            }
        ], this, $02f165b0c7730766$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $02f165b0c7730766$export$ae157b6234afe138(ev.data);
            onmessage = $02f165b0c7730766$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $02f165b0c7730766$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return $02f165b0c7730766$var$cbify(data, opts, [
        $02f165b0c7730766$var$bDflt
    ], function(ev) {
        return $02f165b0c7730766$var$pbf($02f165b0c7730766$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $02f165b0c7730766$export$21533ff51b8a0b4a(data, opts) {
    return $02f165b0c7730766$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $02f165b0c7730766$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $02f165b0c7730766$var$u8(32768);
        this.p = new $02f165b0c7730766$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        if (this.d) $02f165b0c7730766$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $02f165b0c7730766$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $02f165b0c7730766$var$inflt(this.p, this.s, this.o);
        this.ondata($02f165b0c7730766$var$slc(dt, bts, this.s.b), this.d);
        this.o = $02f165b0c7730766$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $02f165b0c7730766$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $02f165b0c7730766$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $02f165b0c7730766$var$astrmify([
            $02f165b0c7730766$var$bInflt,
            function() {
                return [
                    $02f165b0c7730766$var$astrm,
                    $02f165b0c7730766$export$d1de70a877d6e43c
                ];
            }
        ], this, $02f165b0c7730766$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $02f165b0c7730766$export$d1de70a877d6e43c(ev.data);
            onmessage = $02f165b0c7730766$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $02f165b0c7730766$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return $02f165b0c7730766$var$cbify(data, opts, [
        $02f165b0c7730766$var$bInflt
    ], function(ev) {
        return $02f165b0c7730766$var$pbf($02f165b0c7730766$export$90366d8b308ba94a(ev.data[0], $02f165b0c7730766$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $02f165b0c7730766$export$90366d8b308ba94a(data, opts) {
    return $02f165b0c7730766$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $02f165b0c7730766$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $02f165b0c7730766$var$crc();
        this.l = 0;
        this.v = 1;
        $02f165b0c7730766$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $02f165b0c7730766$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $02f165b0c7730766$var$dopt(c, this.o, this.v && $02f165b0c7730766$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $02f165b0c7730766$var$gzh(raw, this.o), this.v = 0;
        if (f) $02f165b0c7730766$var$wbytes(raw, raw.length - 8, this.c.d()), $02f165b0c7730766$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $02f165b0c7730766$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $02f165b0c7730766$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $02f165b0c7730766$var$astrmify([
            $02f165b0c7730766$var$bDflt,
            $02f165b0c7730766$var$gze,
            function() {
                return [
                    $02f165b0c7730766$var$astrm,
                    $02f165b0c7730766$export$ae157b6234afe138,
                    $02f165b0c7730766$export$8e4b66d280bf8342
                ];
            }
        ], this, $02f165b0c7730766$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $02f165b0c7730766$export$8e4b66d280bf8342(ev.data);
            onmessage = $02f165b0c7730766$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $02f165b0c7730766$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return $02f165b0c7730766$var$cbify(data, opts, [
        $02f165b0c7730766$var$bDflt,
        $02f165b0c7730766$var$gze,
        function() {
            return [
                $02f165b0c7730766$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $02f165b0c7730766$var$pbf($02f165b0c7730766$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $02f165b0c7730766$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $02f165b0c7730766$var$crc(), l = data.length;
    c.p(data);
    var d = $02f165b0c7730766$var$dopt(data, opts, $02f165b0c7730766$var$gzhl(opts), 8), s = d.length;
    return $02f165b0c7730766$var$gzh(d, opts), $02f165b0c7730766$var$wbytes(d, s - 8, c.d()), $02f165b0c7730766$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $02f165b0c7730766$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $02f165b0c7730766$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $02f165b0c7730766$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $02f165b0c7730766$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $02f165b0c7730766$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $02f165b0c7730766$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $02f165b0c7730766$var$u8(0);
            this.push(new $02f165b0c7730766$var$u8(0), final);
        } else if (final) $02f165b0c7730766$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $02f165b0c7730766$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $02f165b0c7730766$var$astrmify([
            $02f165b0c7730766$var$bInflt,
            $02f165b0c7730766$var$guze,
            function() {
                return [
                    $02f165b0c7730766$var$astrm,
                    $02f165b0c7730766$export$d1de70a877d6e43c,
                    $02f165b0c7730766$export$4cb607de6db70415
                ];
            }
        ], this, $02f165b0c7730766$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $02f165b0c7730766$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $02f165b0c7730766$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $02f165b0c7730766$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return $02f165b0c7730766$var$cbify(data, opts, [
        $02f165b0c7730766$var$bInflt,
        $02f165b0c7730766$var$guze,
        function() {
            return [
                $02f165b0c7730766$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $02f165b0c7730766$var$pbf($02f165b0c7730766$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $02f165b0c7730766$export$c80456f7aaba691c(data, opts) {
    var st = $02f165b0c7730766$var$gzs(data);
    if (st + 8 > data.length) $02f165b0c7730766$var$err(6, 'invalid gzip data');
    return $02f165b0c7730766$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $02f165b0c7730766$var$u8($02f165b0c7730766$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $02f165b0c7730766$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $02f165b0c7730766$var$adler();
        this.v = 1;
        $02f165b0c7730766$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $02f165b0c7730766$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $02f165b0c7730766$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $02f165b0c7730766$var$zlh(raw, this.o), this.v = 0;
        if (f) $02f165b0c7730766$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $02f165b0c7730766$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $02f165b0c7730766$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $02f165b0c7730766$var$astrmify([
            $02f165b0c7730766$var$bDflt,
            $02f165b0c7730766$var$zle,
            function() {
                return [
                    $02f165b0c7730766$var$astrm,
                    $02f165b0c7730766$export$ae157b6234afe138,
                    $02f165b0c7730766$export$4187ccf2467013b9
                ];
            }
        ], this, $02f165b0c7730766$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $02f165b0c7730766$export$4187ccf2467013b9(ev.data);
            onmessage = $02f165b0c7730766$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $02f165b0c7730766$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return $02f165b0c7730766$var$cbify(data, opts, [
        $02f165b0c7730766$var$bDflt,
        $02f165b0c7730766$var$zle,
        function() {
            return [
                $02f165b0c7730766$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $02f165b0c7730766$var$pbf($02f165b0c7730766$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $02f165b0c7730766$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $02f165b0c7730766$var$adler();
    a.p(data);
    var d = $02f165b0c7730766$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $02f165b0c7730766$var$zlh(d, opts), $02f165b0c7730766$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $02f165b0c7730766$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $02f165b0c7730766$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $02f165b0c7730766$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($02f165b0c7730766$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $02f165b0c7730766$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $02f165b0c7730766$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $02f165b0c7730766$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $02f165b0c7730766$var$astrmify([
            $02f165b0c7730766$var$bInflt,
            $02f165b0c7730766$var$zule,
            function() {
                return [
                    $02f165b0c7730766$var$astrm,
                    $02f165b0c7730766$export$d1de70a877d6e43c,
                    $02f165b0c7730766$export$af2424f875ff1b17
                ];
            }
        ], this, $02f165b0c7730766$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $02f165b0c7730766$export$af2424f875ff1b17(ev.data);
            onmessage = $02f165b0c7730766$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $02f165b0c7730766$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return $02f165b0c7730766$var$cbify(data, opts, [
        $02f165b0c7730766$var$bInflt,
        $02f165b0c7730766$var$zule,
        function() {
            return [
                $02f165b0c7730766$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $02f165b0c7730766$var$pbf($02f165b0c7730766$export$9ec8134f0f1b9fc6(ev.data[0], $02f165b0c7730766$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $02f165b0c7730766$export$9ec8134f0f1b9fc6(data, opts) {
    return $02f165b0c7730766$var$inflt(data.subarray($02f165b0c7730766$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $02f165b0c7730766$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $02f165b0c7730766$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $02f165b0c7730766$export$4cb607de6db70415;
        this.I = $02f165b0c7730766$export$d1de70a877d6e43c;
        this.Z = $02f165b0c7730766$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $02f165b0c7730766$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $02f165b0c7730766$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $02f165b0c7730766$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $02f165b0c7730766$export$d5adcdd968132151;
        this.I = $02f165b0c7730766$export$fff8358d6dbaa9cc;
        this.Z = $02f165b0c7730766$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $02f165b0c7730766$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $02f165b0c7730766$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $02f165b0c7730766$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $02f165b0c7730766$export$cae1ce83fe4a1782(data, opts, cb) : $02f165b0c7730766$export$ca7cbb494e731274(data, opts, cb);
}
function $02f165b0c7730766$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $02f165b0c7730766$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $02f165b0c7730766$export$90366d8b308ba94a(data, opts) : $02f165b0c7730766$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $02f165b0c7730766$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $02f165b0c7730766$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $02f165b0c7730766$var$u8(0),
                op
            ];
            $02f165b0c7730766$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $02f165b0c7730766$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $02f165b0c7730766$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $02f165b0c7730766$var$tds = 0;
try {
    $02f165b0c7730766$var$td.decode($02f165b0c7730766$var$et, {
        stream: true
    });
    $02f165b0c7730766$var$tds = 1;
} catch (e) {}
// decode UTF8
var $02f165b0c7730766$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $02f165b0c7730766$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $02f165b0c7730766$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($02f165b0c7730766$var$tds) this.t = new TextDecoder();
        else this.p = $02f165b0c7730766$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $02f165b0c7730766$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $02f165b0c7730766$var$err(4);
        var dat = new $02f165b0c7730766$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $02f165b0c7730766$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $02f165b0c7730766$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $02f165b0c7730766$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        if (this.d) $02f165b0c7730766$var$err(4);
        this.ondata($02f165b0c7730766$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $02f165b0c7730766$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $02f165b0c7730766$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($02f165b0c7730766$var$te) return $02f165b0c7730766$var$te.encode(str);
    var l = str.length;
    var ar = new $02f165b0c7730766$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $02f165b0c7730766$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $02f165b0c7730766$var$slc(ar, 0, ai);
}
function $02f165b0c7730766$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($02f165b0c7730766$var$td) return $02f165b0c7730766$var$td.decode(dat);
    else {
        var _a = $02f165b0c7730766$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $02f165b0c7730766$var$err(8);
        return s;
    }
}
// deflate bit flag
var $02f165b0c7730766$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $02f165b0c7730766$var$slzh = function(d, b) {
    return b + 30 + $02f165b0c7730766$var$b2(d, b + 26) + $02f165b0c7730766$var$b2(d, b + 28);
};
// read zip header
var $02f165b0c7730766$var$zh = function(d, b, z) {
    var fnl = $02f165b0c7730766$var$b2(d, b + 28), efl = $02f165b0c7730766$var$b2(d, b + 30), fn = $02f165b0c7730766$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($02f165b0c7730766$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $02f165b0c7730766$var$z64hs(d, es, efl, z, $02f165b0c7730766$var$b4(d, b + 20), $02f165b0c7730766$var$b4(d, b + 24), $02f165b0c7730766$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $02f165b0c7730766$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $02f165b0c7730766$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $02f165b0c7730766$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $02f165b0c7730766$var$b2(d, b + 2)){
            if ($02f165b0c7730766$var$b2(d, b) == 1) return [
                nsc ? $02f165b0c7730766$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $02f165b0c7730766$var$b8(d, b + 4) : su,
                noff ? $02f165b0c7730766$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $02f165b0c7730766$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $02f165b0c7730766$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $02f165b0c7730766$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $02f165b0c7730766$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $02f165b0c7730766$var$exfl(ex);
    $02f165b0c7730766$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $02f165b0c7730766$var$err(10);
    $02f165b0c7730766$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $02f165b0c7730766$var$wbytes(d, b, f.crc);
        $02f165b0c7730766$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $02f165b0c7730766$var$wbytes(d, b + 8, f.size);
    }
    $02f165b0c7730766$var$wbytes(d, b + 12, fl);
    $02f165b0c7730766$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $02f165b0c7730766$var$wbytes(d, b, col);
        $02f165b0c7730766$var$wbytes(d, b + 6, f.attrs);
        $02f165b0c7730766$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $02f165b0c7730766$var$wbytes(d, b, +k);
        $02f165b0c7730766$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $02f165b0c7730766$var$wzf = function(o, b, c, d, e) {
    $02f165b0c7730766$var$wbytes(o, b, 0x6054B50); // skip disk
    $02f165b0c7730766$var$wbytes(o, b + 8, c);
    $02f165b0c7730766$var$wbytes(o, b + 10, c);
    $02f165b0c7730766$var$wbytes(o, b + 12, d);
    $02f165b0c7730766$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $02f165b0c7730766$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $02f165b0c7730766$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $02f165b0c7730766$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $02f165b0c7730766$export$2b25194e1767ea06.call(this, filename);
        this.d = new $02f165b0c7730766$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $02f165b0c7730766$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $02f165b0c7730766$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $02f165b0c7730766$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $02f165b0c7730766$export$2b25194e1767ea06.call(this, filename);
        this.d = new $02f165b0c7730766$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $02f165b0c7730766$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $02f165b0c7730766$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $02f165b0c7730766$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $02f165b0c7730766$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($02f165b0c7730766$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $02f165b0c7730766$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $02f165b0c7730766$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $02f165b0c7730766$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($02f165b0c7730766$var$err(11, 0, 1), null, false);
            var header = new $02f165b0c7730766$var$u8(hl_1);
            $02f165b0c7730766$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $02f165b0c7730766$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $02f165b0c7730766$var$u8(16);
                        $02f165b0c7730766$var$wbytes(dd, 0, 0x8074B50);
                        $02f165b0c7730766$var$wbytes(dd, 4, file.crc);
                        $02f165b0c7730766$var$wbytes(dd, 8, cl_1);
                        $02f165b0c7730766$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($02f165b0c7730766$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $02f165b0c7730766$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $02f165b0c7730766$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $02f165b0c7730766$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $02f165b0c7730766$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $02f165b0c7730766$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $02f165b0c7730766$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    var r = {};
    $02f165b0c7730766$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $02f165b0c7730766$var$mt(function() {
            cb(a, b);
        });
    };
    $02f165b0c7730766$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $02f165b0c7730766$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $02f165b0c7730766$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $02f165b0c7730766$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $02f165b0c7730766$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $02f165b0c7730766$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $02f165b0c7730766$var$crc(), size = file.length;
        c.p(file);
        var f = $02f165b0c7730766$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $02f165b0c7730766$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $02f165b0c7730766$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $02f165b0c7730766$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($02f165b0c7730766$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $02f165b0c7730766$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($02f165b0c7730766$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $02f165b0c7730766$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $02f165b0c7730766$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $02f165b0c7730766$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $02f165b0c7730766$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $02f165b0c7730766$var$exfl(p.extra);
        if (s > 65535) $02f165b0c7730766$var$err(11);
        var d = compression ? $02f165b0c7730766$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $02f165b0c7730766$var$crc();
        c.p(file);
        files.push($02f165b0c7730766$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $02f165b0c7730766$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $02f165b0c7730766$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $02f165b0c7730766$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $02f165b0c7730766$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $02f165b0c7730766$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $02f165b0c7730766$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $02f165b0c7730766$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $02f165b0c7730766$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $02f165b0c7730766$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $02f165b0c7730766$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $02f165b0c7730766$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $02f165b0c7730766$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $02f165b0c7730766$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $02f165b0c7730766$export$93f81d5bbbb7c6bf
        };
        this.p = $02f165b0c7730766$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $02f165b0c7730766$var$err(5);
        if (!this.p) $02f165b0c7730766$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $02f165b0c7730766$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $02f165b0c7730766$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $02f165b0c7730766$var$b2(buf, i + 6), cmp_1 = $02f165b0c7730766$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $02f165b0c7730766$var$b2(buf, i + 26), es = $02f165b0c7730766$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $02f165b0c7730766$var$b4(buf, i + 18), lsu = $02f165b0c7730766$var$b4(buf, i + 22);
                        var fn_1 = $02f165b0c7730766$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $02f165b0c7730766$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $02f165b0c7730766$var$err(5);
                                if (!sc_1) file_1.ondata(null, $02f165b0c7730766$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($02f165b0c7730766$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($02f165b0c7730766$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $02f165b0c7730766$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($02f165b0c7730766$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $02f165b0c7730766$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $02f165b0c7730766$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $02f165b0c7730766$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $02f165b0c7730766$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $02f165b0c7730766$var$mt(function() {
            cb(a, b);
        });
    };
    $02f165b0c7730766$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $02f165b0c7730766$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($02f165b0c7730766$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $02f165b0c7730766$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $02f165b0c7730766$var$b4(data, e + 16);
        var z = $02f165b0c7730766$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $02f165b0c7730766$var$b4(data, e - 12);
            z = $02f165b0c7730766$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $02f165b0c7730766$var$b4(data, ze + 32);
                o = $02f165b0c7730766$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $02f165b0c7730766$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $02f165b0c7730766$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $02f165b0c7730766$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $02f165b0c7730766$export$90366d8b308ba94a(infl, {
                            out: new $02f165b0c7730766$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($02f165b0c7730766$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($02f165b0c7730766$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $02f165b0c7730766$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $02f165b0c7730766$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $02f165b0c7730766$var$err(13);
    var c = $02f165b0c7730766$var$b2(data, e + 8);
    if (!c) return {};
    var o = $02f165b0c7730766$var$b4(data, e + 16);
    var z = $02f165b0c7730766$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $02f165b0c7730766$var$b4(data, e - 12);
        z = $02f165b0c7730766$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $02f165b0c7730766$var$b4(data, ze + 32);
            o = $02f165b0c7730766$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $02f165b0c7730766$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $02f165b0c7730766$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $02f165b0c7730766$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $02f165b0c7730766$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $02f165b0c7730766$var$u8(su)
            });
            else $02f165b0c7730766$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


class $c896cea3fd00e6ea$var$XmlNode {
    append(node) {
        this.childNodes.push(node);
        return this;
    }
    attr(attr, value) {
        if (typeof attr === "string") {
            if (value === undefined) delete this.attributes[attr];
            else this.attributes[attr] = value;
            return this;
        }
        Object.keys(attr).forEach((key)=>{
            const attributeValue = attr[key];
            if (attributeValue !== undefined) this.attributes[key] = attributeValue;
        });
        return this;
    }
    prefix(prefix) {
        this.prefixText = prefix;
        return this;
    }
    children() {
        return this.childNodes;
    }
    toXml() {
        const attributes = Object.keys(this.attributes).map((key)=>` ${key}="${$c896cea3fd00e6ea$var$escapeXmlAttribute(String(this.attributes[key]))}"`).join("");
        if (this.childNodes.length === 0) return `${this.prefixText}<${this.tagName}${attributes}/>`;
        return `${this.prefixText}<${this.tagName}${attributes}>${this.childNodes.map((node)=>node.toXml()).join("")}</${this.tagName}>`;
    }
    constructor(tagName, attributes = {}, children = []){
        this.tagName = tagName;
        this.prefixText = "";
        this.attributes = attributes;
        this.childNodes = children;
    }
}
class $c896cea3fd00e6ea$var$StyleBuilder {
    addStyle(style) {
        const hashKey = $c896cea3fd00e6ea$var$stableStringify(style);
        const existingIndex = this.hashIndex.get(hashKey);
        if (existingIndex !== undefined) return existingIndex;
        const index = this.addXf(style);
        this.hashIndex.set(hashKey, index);
        return index;
    }
    toXml() {
        return this.styles.toXml();
    }
    addXf(style) {
        const fontId = this.addFont(style.font);
        const fillId = this.addFill(style.fill);
        const borderId = this.addBorder(style.border);
        const numFmtId = this.addNumFmt(style.numFmt);
        const xf = new $c896cea3fd00e6ea$var$XmlNode("xf").attr("numFmtId", numFmtId).attr("fontId", fontId).attr("fillId", fillId).attr("borderId", borderId).attr("xfId", 0);
        if (fontId > 0) xf.attr("applyFont", 1);
        if (fillId > 0) xf.attr("applyFill", 1);
        if (borderId > 0) xf.attr("applyBorder", 1);
        if (Number(numFmtId) > 0) xf.attr("applyNumberFormat", 1);
        if (style.alignment) {
            const alignment = new $c896cea3fd00e6ea$var$XmlNode("alignment");
            Object.keys(style.alignment).forEach((key)=>{
                var _a;
                const value = (_a = style.alignment) === null || _a === void 0 ? void 0 : _a[key];
                if (value !== undefined) alignment.attr(key, value);
            });
            xf.append(alignment).attr("applyAlignment", 1);
        }
        this.cellXfs.append(xf).attr("count", this.cellXfs.children().length);
        return this.cellXfs.children().length - 1;
    }
    addFont(font) {
        var _a, _b, _c, _d, _e, _f;
        if (!font) return 0;
        const key = $c896cea3fd00e6ea$var$stableStringify(font);
        const cached = this.fontHashIndex.get(key);
        if (cached !== undefined) return cached;
        const fontNode = new $c896cea3fd00e6ea$var$XmlNode("font").append(new $c896cea3fd00e6ea$var$XmlNode("sz").attr("val", (_c = (_a = font.sz) !== null && _a !== void 0 ? _a : (_b = this.defaultStyle.font) === null || _b === void 0 ? void 0 : _b.sz) !== null && _c !== void 0 ? _c : 11)).append(new $c896cea3fd00e6ea$var$XmlNode("name").attr("val", (_f = (_d = font.name) !== null && _d !== void 0 ? _d : (_e = this.defaultStyle.font) === null || _e === void 0 ? void 0 : _e.name) !== null && _f !== void 0 ? _f : "Calibri"));
        if (font.bold) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("b"));
        if (font.underline) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("u"));
        if (font.italic) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("i"));
        if (font.strike) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("strike"));
        if (font.outline) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("outline"));
        if (font.shadow) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("shadow"));
        if (font.vertAlign) fontNode.append(new $c896cea3fd00e6ea$var$XmlNode("vertAlign").attr("val", font.vertAlign));
        if (font.color) fontNode.append($c896cea3fd00e6ea$var$colorNode("color", font.color, false));
        this.fonts.append(fontNode).attr("count", this.fonts.children().length);
        const id = this.fonts.children().length - 1;
        this.fontHashIndex.set(key, id);
        return id;
    }
    addNumFmt(numFmt) {
        if (numFmt === undefined || numFmt === null || numFmt === "") return 0;
        if (typeof numFmt === "number") {
            if (!Number.isInteger(numFmt) || numFmt < 0 || numFmt > $c896cea3fd00e6ea$var$maxBuiltInNumFmtId) throw new Error(`Numeric numFmt values must be built-in IDs between 0 and ${$c896cea3fd00e6ea$var$maxBuiltInNumFmtId}; use a string format code for custom formats.`);
            return numFmt;
        }
        const builtInId = $c896cea3fd00e6ea$var$builtInNumberFormats[numFmt];
        if (builtInId !== undefined) return builtInId;
        if (/^[1-9][0-9]*$/.test(numFmt) && Number(numFmt) <= $c896cea3fd00e6ea$var$maxBuiltInNumFmtId) return Number(numFmt);
        const cached = this.numFmtHashIndex.get(numFmt);
        if (cached !== undefined) return cached;
        const id = ++this.customNumFmtId;
        this.numFmts.append(new $c896cea3fd00e6ea$var$XmlNode("numFmt").attr("numFmtId", id).attr("formatCode", numFmt)).attr("count", this.numFmts.children().length);
        this.numFmtHashIndex.set(numFmt, id);
        return id;
    }
    addFill(fill) {
        var _a;
        if (!fill) return 0;
        const key = $c896cea3fd00e6ea$var$stableStringify(fill);
        const cached = this.fillHashIndex.get(key);
        if (cached !== undefined) return cached;
        const patternFill = new $c896cea3fd00e6ea$var$XmlNode("patternFill").attr("patternType", (_a = fill.patternType) !== null && _a !== void 0 ? _a : "solid");
        if (fill.fgColor && $c896cea3fd00e6ea$var$hasColor(fill.fgColor)) {
            patternFill.append($c896cea3fd00e6ea$var$colorNode("fgColor", fill.fgColor, true));
            if (!fill.bgColor) patternFill.append(new $c896cea3fd00e6ea$var$XmlNode("bgColor").attr("indexed", 64));
        }
        if (fill.bgColor && $c896cea3fd00e6ea$var$hasColor(fill.bgColor)) patternFill.append($c896cea3fd00e6ea$var$colorNode("bgColor", fill.bgColor, false));
        this.fills.append(new $c896cea3fd00e6ea$var$XmlNode("fill").append(patternFill)).attr("count", this.fills.children().length);
        const id = this.fills.children().length - 1;
        this.fillHashIndex.set(key, id);
        return id;
    }
    addBorder(border) {
        if (!border) return 0;
        const key = $c896cea3fd00e6ea$var$stableStringify(border);
        const cached = this.borderHashIndex.get(key);
        if (cached !== undefined) return cached;
        const diagonal = border.diagonal;
        const borderNode = new $c896cea3fd00e6ea$var$XmlNode("border").attr("diagonalUp", diagonal === null || diagonal === void 0 ? void 0 : diagonal.diagonalUp).attr("diagonalDown", diagonal === null || diagonal === void 0 ? void 0 : diagonal.diagonalDown);
        [
            "left",
            "right",
            "top",
            "bottom",
            "diagonal"
        ].forEach((direction)=>{
            borderNode.append($c896cea3fd00e6ea$var$borderPartNode(direction, border[direction]));
        });
        this.borders.append(borderNode).attr("count", this.borders.children().length);
        const id = this.borders.children().length - 1;
        this.borderHashIndex.set(key, id);
        return id;
    }
    constructor(defaultCellStyle = {}){
        this.customNumFmtId = 164;
        this.hashIndex = new Map;
        this.fontHashIndex = new Map;
        this.fillHashIndex = new Map;
        this.borderHashIndex = new Map;
        this.numFmtHashIndex = new Map;
        this.fonts = new $c896cea3fd00e6ea$var$XmlNode("fonts").attr("count", 0).attr("x14ac:knownFonts", "1");
        this.fills = new $c896cea3fd00e6ea$var$XmlNode("fills").attr("count", 0);
        this.borders = new $c896cea3fd00e6ea$var$XmlNode("borders").attr("count", 0);
        this.numFmts = new $c896cea3fd00e6ea$var$XmlNode("numFmts").attr("count", 0);
        this.cellStyleXfs = new $c896cea3fd00e6ea$var$XmlNode("cellStyleXfs").attr("count", 1);
        this.cellXfs = new $c896cea3fd00e6ea$var$XmlNode("cellXfs").attr("count", 0);
        this.cellStyles = new $c896cea3fd00e6ea$var$XmlNode("cellStyles").attr("count", 1).append(new $c896cea3fd00e6ea$var$XmlNode("cellStyle").attr("name", "Normal").attr("xfId", 0).attr("builtinId", 0));
        this.dxfs = new $c896cea3fd00e6ea$var$XmlNode("dxfs").attr("count", 0);
        this.tableStyles = new $c896cea3fd00e6ea$var$XmlNode("tableStyles").attr("count", 0).attr("defaultTableStyle", "TableStyleMedium9").attr("defaultPivotStyle", "PivotStyleMedium4");
        this.styles = new $c896cea3fd00e6ea$var$XmlNode("styleSheet").attr("xmlns:mc", "http://schemas.openxmlformats.org/markup-compatibility/2006").attr("xmlns:x14ac", "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac").attr("xmlns", "http://schemas.openxmlformats.org/spreadsheetml/2006/main").attr("mc:Ignorable", "x14ac").prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>');
        this.defaultStyle = (0, $c896cea3fd00e6ea$exports.mergeCellStyles)({
            border: {},
            fill: {
                patternType: "none"
            },
            font: {
                name: "Calibri",
                sz: 11
            },
            numFmt: 0
        }, defaultCellStyle);
        this.styles.append(this.numFmts).append(this.fonts).append(this.fills).append(this.borders).append(this.cellStyleXfs.append(new $c896cea3fd00e6ea$var$XmlNode("xf").attr("numFmtId", 0).attr("fontId", 0).attr("fillId", 0).attr("borderId", 0))).append(this.cellXfs).append(this.cellStyles).append(this.dxfs).append(this.tableStyles);
        this.addStyle(this.defaultStyle);
        this.addStyle(Object.assign(Object.assign({}, this.defaultStyle), {
            fill: {
                patternType: "gray125"
            }
        }));
    }
}
const $c896cea3fd00e6ea$var$builtInNumberFormats = {
    General: 0,
    0: 1,
    "0.00": 2,
    "#,##0": 3,
    "#,##0.00": 4,
    "0%": 9,
    "0.00%": 10,
    "0.00E+00": 11,
    "# ?/?": 12,
    "# ??/??": 13,
    "m/d/yy": 14,
    "d-mmm-yy": 15,
    "d-mmm": 16,
    "mmm-yy": 17,
    "h:mm AM/PM": 18,
    "h:mm:ss AM/PM": 19,
    "h:mm": 20,
    "h:mm:ss": 21,
    "m/d/yy h:mm": 22,
    "#,##0 ;(#,##0)": 37,
    "#,##0 ;[Red](#,##0)": 38,
    "#,##0.00;(#,##0.00)": 39,
    "#,##0.00;[Red](#,##0.00)": 40,
    "mm:ss": 45,
    "[h]:mm:ss": 46,
    "mmss.0": 47,
    "##0.0E+0": 48,
    "@": 49,
    '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "': 56
};
const $c896cea3fd00e6ea$var$maxBuiltInNumFmtId = 163;
const $c896cea3fd00e6ea$var$mergeCellStyles = (...styles)=>{
    return styles.reduce((mergedStyle, style)=>{
        if (!style) return mergedStyle;
        return $c896cea3fd00e6ea$var$deepMerge(mergedStyle, style);
    }, {});
};
$c896cea3fd00e6ea$exports.mergeCellStyles = $c896cea3fd00e6ea$var$mergeCellStyles;
const $c896cea3fd00e6ea$var$isCellStyleObject = (style)=>{
    return Boolean(style) && typeof style === "object" && !Array.isArray(style) && !(style instanceof Date);
};
$c896cea3fd00e6ea$exports.isCellStyleObject = $c896cea3fd00e6ea$var$isCellStyleObject;
const $c896cea3fd00e6ea$var$hasMeaningfulValue = (value)=>value !== undefined && value !== null && value !== "" && value !== false;
const $c896cea3fd00e6ea$var$hasEffectiveAlignment = (alignment)=>{
    return Boolean(alignment) && Object.values(alignment).some($c896cea3fd00e6ea$var$hasMeaningfulValue);
};
const $c896cea3fd00e6ea$var$hasEffectiveFont = (font)=>{
    return Boolean(font && (font.bold || font.italic || font.outline || font.shadow || font.strike || font.underline || $c896cea3fd00e6ea$var$hasMeaningfulValue(font.name) || $c896cea3fd00e6ea$var$hasMeaningfulValue(font.sz) || $c896cea3fd00e6ea$var$hasMeaningfulValue(font.vertAlign) || font.color && $c896cea3fd00e6ea$var$hasColor(font.color)));
};
const $c896cea3fd00e6ea$var$hasEffectiveFill = (fill)=>{
    return Boolean(fill && (fill.patternType === "solid" || fill.patternType === "gray125" || fill.fgColor && $c896cea3fd00e6ea$var$hasColor(fill.fgColor) || fill.bgColor && $c896cea3fd00e6ea$var$hasColor(fill.bgColor)));
};
const $c896cea3fd00e6ea$var$hasEffectiveBorderSide = (side)=>{
    return Boolean(side && (side.style || side.color && $c896cea3fd00e6ea$var$hasColor(side.color)));
};
const $c896cea3fd00e6ea$var$hasEffectiveBorder = (border)=>{
    var _a, _b;
    return Boolean(border && ($c896cea3fd00e6ea$var$hasEffectiveBorderSide(border.top) || $c896cea3fd00e6ea$var$hasEffectiveBorderSide(border.bottom) || $c896cea3fd00e6ea$var$hasEffectiveBorderSide(border.left) || $c896cea3fd00e6ea$var$hasEffectiveBorderSide(border.right) || $c896cea3fd00e6ea$var$hasEffectiveBorderSide(border.diagonal) || ((_a = border.diagonal) === null || _a === void 0 ? void 0 : _a.diagonalUp) || ((_b = border.diagonal) === null || _b === void 0 ? void 0 : _b.diagonalDown)));
};
const $c896cea3fd00e6ea$var$hasEffectiveNumFmt = (numFmt)=>{
    return numFmt !== undefined && numFmt !== null && numFmt !== "" && numFmt !== 0 && numFmt !== "General";
};
const $c896cea3fd00e6ea$var$hasEffectiveCellStyle = (style)=>{
    if (!(0, $c896cea3fd00e6ea$exports.isCellStyleObject)(style)) return false;
    return $c896cea3fd00e6ea$var$hasEffectiveAlignment(style.alignment) || $c896cea3fd00e6ea$var$hasEffectiveBorder(style.border) || $c896cea3fd00e6ea$var$hasEffectiveFill(style.fill) || $c896cea3fd00e6ea$var$hasEffectiveFont(style.font) || $c896cea3fd00e6ea$var$hasEffectiveNumFmt(style.numFmt);
};
const $c896cea3fd00e6ea$var$patchStyledWorkbook = (workbook, workbookData)=>{
    const styleBuilder = new $c896cea3fd00e6ea$var$StyleBuilder;
    const sheetStyles = workbook.SheetNames.map((sheetName)=>{
        const worksheet = workbook.Sheets[sheetName];
        const stylesByRef = new Map;
        Object.keys(worksheet).forEach((cellRef)=>{
            if (!$c896cea3fd00e6ea$var$isCellRef(cellRef)) return;
            const cell = worksheet[cellRef];
            const style = $c896cea3fd00e6ea$var$getCellStyle(cell);
            if (!style) return;
            stylesByRef.set(cellRef, styleBuilder.addStyle(style));
        });
        return stylesByRef;
    });
    const zip = (0, $02f165b0c7730766$export$c757709326bb5901)($c896cea3fd00e6ea$var$toUint8Array(workbookData));
    zip["xl/styles.xml"] = (0, $02f165b0c7730766$export$366b39a6daa8ed7a)(styleBuilder.toXml());
    sheetStyles.forEach((stylesByRef, index)=>{
        const path = `xl/worksheets/sheet${index + 1}.xml`;
        const worksheetXml = zip[path];
        if (!worksheetXml) return;
        zip[path] = (0, $02f165b0c7730766$export$366b39a6daa8ed7a)($c896cea3fd00e6ea$var$patchWorksheetXml((0, $02f165b0c7730766$export$adb211f8cb999894)(worksheetXml), stylesByRef));
    });
    return (0, $02f165b0c7730766$export$eb1654f146d54eb3)(zip);
};
$c896cea3fd00e6ea$exports.patchStyledWorkbook = $c896cea3fd00e6ea$var$patchStyledWorkbook;
const $c896cea3fd00e6ea$var$toArrayBuffer = (data)=>{
    const output = new ArrayBuffer(data.byteLength);
    new Uint8Array(output).set(data);
    return output;
};
const $c896cea3fd00e6ea$var$toStyledOutput = (data, type)=>{
    switch(type){
        case "array":
            return $c896cea3fd00e6ea$var$toArrayBuffer(data);
        case "string":
        case "binary":
            return $c896cea3fd00e6ea$var$uint8ToBinaryString(data);
        case "base64":
            return $c896cea3fd00e6ea$var$uint8ToBase64(data);
        case "buffer":
        default:
            return typeof $c896cea3fd00e6ea$require$Buffer !== "undefined" ? $c896cea3fd00e6ea$require$Buffer.from(data) : data;
    }
};
$c896cea3fd00e6ea$exports.toStyledOutput = $c896cea3fd00e6ea$var$toStyledOutput;
const $c896cea3fd00e6ea$var$saveXlsxOutput = (data, filename)=>{
    var _a;
    if (typeof document !== "undefined" && typeof Blob !== "undefined" && typeof URL !== "undefined" && URL.createObjectURL) {
        const bytes = $c896cea3fd00e6ea$var$toUint8Array(data);
        const blobData = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
        const blob = new Blob([
            blobData
        ], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        link.rel = "noopener";
        link.style.display = "none";
        ((_a = document.body) !== null && _a !== void 0 ? _a : document.documentElement).appendChild(link);
        link.click();
        setTimeout(()=>{
            var _a;
            (_a = link.parentNode) === null || _a === void 0 || _a.removeChild(link);
            URL.revokeObjectURL(url);
        }, 100);
        return;
    }
    const fs = $c896cea3fd00e6ea$var$loadNodeFs();
    if (!fs) throw new Error("Unable to write workbook file in this environment");
    fs.writeFileSync(filename, $c896cea3fd00e6ea$require$Buffer.from($c896cea3fd00e6ea$var$toUint8Array(data)));
};
$c896cea3fd00e6ea$exports.saveXlsxOutput = $c896cea3fd00e6ea$var$saveXlsxOutput;
const $c896cea3fd00e6ea$var$loadNodeFs = ()=>{
    var _a;
    return undefined;
};
const $c896cea3fd00e6ea$var$getCellStyle = (cell)=>{
    if (!cell) return undefined;
    const styles = [];
    if ($c896cea3fd00e6ea$var$hasEffectiveCellStyle(cell.s)) styles.push(cell.s);
    if (cell.z) styles.push({
        numFmt: cell.z
    });
    if (styles.length === 0) return undefined;
    const style = (0, $c896cea3fd00e6ea$exports.mergeCellStyles)(...styles);
    return $c896cea3fd00e6ea$var$hasEffectiveCellStyle(style) ? style : undefined;
};
const $c896cea3fd00e6ea$var$patchWorksheetXml = (xml, stylesByRef)=>{
    return xml.replace(/<c\b[^>]*>/g, (cellTag)=>{
        const refMatch = cellTag.match(/\br=(["'])(.*?)\1/);
        if (!refMatch) return cellTag;
        const styleIndex = stylesByRef.get(refMatch[2]);
        const withoutStyle = cellTag.replace(/\s+s=(["']).*?\1/, "");
        if (styleIndex === undefined) return withoutStyle;
        const end = withoutStyle.endsWith("/>") ? "/>" : ">";
        return `${withoutStyle.slice(0, -end.length)} s="${styleIndex}"${end}`;
    });
};
const $c896cea3fd00e6ea$var$borderPartNode = (direction, spec)=>{
    const directionNode = new $c896cea3fd00e6ea$var$XmlNode(direction);
    if (!spec) return directionNode;
    const colored = Boolean(spec.color) && $c896cea3fd00e6ea$var$hasColor(spec.color);
    if (spec.style) directionNode.attr("style", spec.style);
    else if (colored) directionNode.attr("style", "thin");
    if (colored) directionNode.append($c896cea3fd00e6ea$var$colorNode("color", spec.color, false));
    return directionNode;
};
const $c896cea3fd00e6ea$var$colorNode = (tagName, color, withAlpha)=>{
    const node = new $c896cea3fd00e6ea$var$XmlNode(tagName);
    if (color.auto !== undefined) node.attr("auto", color.auto ? 1 : 0);
    if (color.indexed !== undefined) node.attr("indexed", color.indexed);
    if (color.theme !== undefined) node.attr("theme", color.theme);
    if (color.tint !== undefined) node.attr("tint", color.tint);
    if (color.rgb) node.attr("rgb", withAlpha && color.rgb.length === 6 ? `FF${color.rgb}` : color.rgb);
    return node;
};
const $c896cea3fd00e6ea$var$hasColor = (color)=>{
    return color.auto !== undefined || color.indexed !== undefined || color.theme !== undefined || color.tint !== undefined || Boolean(color.rgb);
};
const $c896cea3fd00e6ea$var$escapeXmlAttribute = (value)=>{
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;");
};
const $c896cea3fd00e6ea$var$isCellRef = (value)=>/^[A-Z]+[0-9]+$/.test(value);
const $c896cea3fd00e6ea$var$toUint8Array = (data)=>{
    return data instanceof Uint8Array ? data : new Uint8Array(data);
};
const $c896cea3fd00e6ea$var$binaryStringChunkSize = 32768;
const $c896cea3fd00e6ea$var$uint8ToBinaryString = (data)=>{
    if (typeof $c896cea3fd00e6ea$require$Buffer !== "undefined") return $c896cea3fd00e6ea$require$Buffer.from(data).toString("binary");
    const chunks = [];
    for(let index = 0; index < data.length; index += $c896cea3fd00e6ea$var$binaryStringChunkSize)chunks.push(String.fromCharCode(...data.subarray(index, index + $c896cea3fd00e6ea$var$binaryStringChunkSize)));
    return chunks.join("");
};
const $c896cea3fd00e6ea$var$uint8ToBase64 = (data)=>{
    if (typeof $c896cea3fd00e6ea$require$Buffer !== "undefined") return $c896cea3fd00e6ea$require$Buffer.from(data).toString("base64");
    return btoa($c896cea3fd00e6ea$var$uint8ToBinaryString(data));
};
const $c896cea3fd00e6ea$var$stableStringify = (value)=>{
    if (!$c896cea3fd00e6ea$var$isPlainObject(value)) return JSON.stringify(value);
    const entries = Object.keys(value).filter((key)=>value[key] !== undefined).sort().map((key)=>`"${key}":${$c896cea3fd00e6ea$var$stableStringify(value[key])}`);
    return `{${entries.join(",")}}`;
};
const $c896cea3fd00e6ea$var$deepMerge = (base, override)=>{
    if (!$c896cea3fd00e6ea$var$isPlainObject(base) || !$c896cea3fd00e6ea$var$isPlainObject(override)) return $c896cea3fd00e6ea$var$cloneValue(override);
    const result = Object.assign({}, base);
    Object.keys(override).forEach((key)=>{
        const overrideValue = override[key];
        if (overrideValue === undefined) return;
        result[key] = key in result ? $c896cea3fd00e6ea$var$deepMerge(result[key], overrideValue) : $c896cea3fd00e6ea$var$cloneValue(overrideValue);
    });
    return result;
};
const $c896cea3fd00e6ea$var$cloneValue = (value)=>{
    if (Array.isArray(value)) return value.map($c896cea3fd00e6ea$var$cloneValue);
    if ($c896cea3fd00e6ea$var$isPlainObject(value)) {
        const clone = {};
        Object.keys(value).forEach((key)=>{
            clone[key] = $c896cea3fd00e6ea$var$cloneValue(value[key]);
        });
        return clone;
    }
    return value;
};
const $c896cea3fd00e6ea$var$isPlainObject = (value)=>{
    return Boolean(value) && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date);
};


const $bd9b13a4b7314f5d$var$normalizeEmptyCellValue = (value, options = {})=>{
    if (options.writeEmptyValuesAsBlankCells && (value === undefined || value === null || value === "")) return null;
    if (options.writeEmptyValuesAsBlankCells && $bd9b13a4b7314f5d$var$isStyledCell(value)) {
        const styledValue = value.v;
        if (styledValue === undefined || styledValue === null || styledValue === "") return null;
    }
    return value !== null && value !== void 0 ? value : "";
};
function $bd9b13a4b7314f5d$var$getContentProperty(content, property, options = {}) {
    const accessContentProperties = (content, properties)=>{
        const value = content[properties[0]];
        if (properties.length === 1) return $bd9b13a4b7314f5d$var$normalizeEmptyCellValue(value, options);
        if (value === undefined || value === null || typeof value === "string" || typeof value === "boolean" || typeof value === "number" || value instanceof Date) return $bd9b13a4b7314f5d$var$normalizeEmptyCellValue(undefined, options);
        return accessContentProperties(value, properties.slice(1));
    };
    const properties = property.split(".");
    return accessContentProperties(content, properties);
}
const $bd9b13a4b7314f5d$var$getJsonSheetRow = (content, columns, options = {})=>{
    const jsonSheetRow = {};
    columns.forEach((column)=>{
        if (typeof column.value === "function") jsonSheetRow[column.label] = $bd9b13a4b7314f5d$var$normalizeEmptyCellValue(column.value(content), options);
        else jsonSheetRow[column.label] = $bd9b13a4b7314f5d$var$getContentProperty(content, column.value, options);
    });
    return jsonSheetRow;
};
$bd9b13a4b7314f5d$exports.getJsonSheetRow = $bd9b13a4b7314f5d$var$getJsonSheetRow;
const $bd9b13a4b7314f5d$var$applyColumnFormat = (worksheet, table, columnFormats)=>{
    for(let i = 0; i < columnFormats.length; i += 1){
        const columnFormat = columnFormats[i];
        if (!columnFormat) continue;
        const column = table.startCol + i;
        for(let row = table.startRow + 1; row <= table.startRow + table.dataRowCount; ++row){
            const ref = $77f9f80a0cede680$export$eab97d15b1788b8d.encode_cell({
                r: row,
                c: column
            });
            if (worksheet[ref] && !$bd9b13a4b7314f5d$var$isBlankWorksheetCell(worksheet[ref])) switch(columnFormat){
                case "hyperlink":
                    worksheet[ref].l = {
                        Target: worksheet[ref].v
                    };
                    break;
                default:
                    worksheet[ref].z = columnFormat;
            }
        }
    }
};
const $bd9b13a4b7314f5d$var$applyHeaderStyles = (worksheet, table, headerStyles)=>{
    for(let i = 0; i < headerStyles.length; i += 1){
        const headerStyle = headerStyles[i];
        if (!headerStyle) continue;
        const column = table.startCol + i;
        const ref = $77f9f80a0cede680$export$eab97d15b1788b8d.encode_cell({
            r: table.startRow,
            c: column
        });
        if (worksheet[ref]) $bd9b13a4b7314f5d$var$applyCellStyles(worksheet[ref], headerStyle);
    }
};
const $bd9b13a4b7314f5d$var$applyColumnStyles = (worksheet, table, columnStyles)=>{
    for(let i = 0; i < columnStyles.length; i += 1){
        const columnStyle = columnStyles[i];
        if (!columnStyle) continue;
        const column = table.startCol + i;
        for(let row = table.startRow + 1; row <= table.startRow + table.dataRowCount; ++row){
            const ref = $77f9f80a0cede680$export$eab97d15b1788b8d.encode_cell({
                r: row,
                c: column
            });
            if (worksheet[ref] && !$bd9b13a4b7314f5d$var$isBlankWorksheetCell(worksheet[ref])) $bd9b13a4b7314f5d$var$applyCellStyles(worksheet[ref], columnStyle);
        }
    }
};
const $bd9b13a4b7314f5d$var$getWorksheetColumnIds = (worksheet)=>{
    var _a;
    const columnRange = $77f9f80a0cede680$export$eab97d15b1788b8d.decode_range((_a = worksheet["!ref"]) !== null && _a !== void 0 ? _a : "");
    const columnIds = [];
    for(let C = columnRange.s.c; C <= columnRange.e.c; C++){
        const address = $77f9f80a0cede680$export$eab97d15b1788b8d.encode_col(C);
        columnIds.push(address);
    }
    return columnIds;
};
const $bd9b13a4b7314f5d$var$getObjectLength = (object)=>{
    if ($bd9b13a4b7314f5d$var$isStyledCell(object)) return $bd9b13a4b7314f5d$var$getObjectLength(object.v);
    if (typeof object === "string") return Math.max(...object.split("\n").map((string)=>string.length));
    if (typeof object === "number") return object.toString().length;
    if (typeof object === "boolean") return object ? 4 : 5;
    if (object instanceof Date) return object.toString().length;
    return 0;
};
const $bd9b13a4b7314f5d$var$isBlankWorksheetCell = (cell)=>{
    return cell.t === "z" || cell.v === null || cell.v === undefined;
};
const $bd9b13a4b7314f5d$var$getWorksheetColumnWidths = (worksheet, extraLength = 1)=>{
    const columnLetters = $bd9b13a4b7314f5d$var$getWorksheetColumnIds(worksheet);
    return columnLetters.map((column)=>{
        const columnCells = Object.keys(worksheet).filter((cell)=>{
            return cell.replace(/[0-9]/g, "") === column;
        });
        const maxWidthCell = columnCells.reduce((maxWidth, cellId)=>{
            const cell = worksheet[cellId];
            const cellContentLength = $bd9b13a4b7314f5d$var$getObjectLength(cell.v);
            if (!cell.z) return Math.max(maxWidth, cellContentLength);
            const cellFormatLength = cell.z.length;
            const largestWidth = Math.max(cellContentLength, cellFormatLength);
            return Math.max(maxWidth, largestWidth);
        }, 0);
        return {
            width: maxWidthCell + extraLength
        };
    });
};
$bd9b13a4b7314f5d$exports.getWorksheetColumnWidths = $bd9b13a4b7314f5d$var$getWorksheetColumnWidths;
const $bd9b13a4b7314f5d$var$buildJsonSheetRows = (columns, content, settings)=>{
    if (content.length > 0) return content.map((contentItem)=>(0, $bd9b13a4b7314f5d$exports.getJsonSheetRow)(contentItem, columns, settings));
    if (settings.writeEmptyValuesAsBlankCells) return [];
    return columns.map((column)=>({
            [column.label]: ""
        }));
};
const $bd9b13a4b7314f5d$var$getWorksheet = (jsonSheet, settings)=>{
    var _a, _b, _c, _d;
    const tables = jsonSheet.tables && jsonSheet.tables.length > 0 ? jsonSheet.tables : [
        {
            columns: (_a = jsonSheet.columns) !== null && _a !== void 0 ? _a : [],
            content: (_b = jsonSheet.content) !== null && _b !== void 0 ? _b : []
        }
    ];
    const layout = (_c = jsonSheet.tablesLayout) !== null && _c !== void 0 ? _c : "vertical";
    const gap = (_d = jsonSheet.tablesGap) !== null && _d !== void 0 ? _d : 1;
    let worksheet;
    let nextRow = 0;
    let nextCol = 0;
    const placedTables = [];
    tables.forEach((table)=>{
        const jsonSheetRows = $bd9b13a4b7314f5d$var$buildJsonSheetRows(table.columns, table.content, settings);
        const jsonSheetOptions = table.content.length === 0 && settings.writeEmptyValuesAsBlankCells ? {
            header: table.columns.map((column)=>column.label)
        } : {};
        const startRow = nextRow;
        const startCol = nextCol;
        if (!worksheet) worksheet = $77f9f80a0cede680$export$eab97d15b1788b8d.json_to_sheet(jsonSheetRows, jsonSheetOptions);
        else $77f9f80a0cede680$export$eab97d15b1788b8d.sheet_add_json(worksheet, jsonSheetRows, Object.assign(Object.assign({}, jsonSheetOptions), {
            origin: {
                r: startRow,
                c: startCol
            }
        }));
        placedTables.push({
            columns: table.columns,
            startRow: startRow,
            startCol: startCol,
            dataRowCount: jsonSheetRows.length
        });
        if (layout === "horizontal") nextCol = startCol + table.columns.length + gap;
        else nextRow = startRow + 1 + jsonSheetRows.length + gap;
    });
    const builtWorksheet = worksheet;
    placedTables.forEach((placedTable)=>{
        const tableColumnFormats = placedTable.columns.map((tableColumn)=>{
            var _a;
            return (_a = tableColumn.format) !== null && _a !== void 0 ? _a : null;
        });
        $bd9b13a4b7314f5d$var$applyColumnFormat(builtWorksheet, placedTable, tableColumnFormats);
        if (settings.enableStyles) {
            const tableHeaderStyles = placedTable.columns.map((tableColumn)=>{
                var _a;
                return (_a = tableColumn.headerStyle) !== null && _a !== void 0 ? _a : null;
            });
            const tableColumnStyles = placedTable.columns.map((tableColumn)=>{
                var _a;
                return (_a = tableColumn.cellStyle) !== null && _a !== void 0 ? _a : null;
            });
            $bd9b13a4b7314f5d$var$applyHeaderStyles(builtWorksheet, placedTable, tableHeaderStyles);
            $bd9b13a4b7314f5d$var$applyColumnStyles(builtWorksheet, placedTable, tableColumnStyles);
        }
    });
    builtWorksheet["!cols"] = (0, $bd9b13a4b7314f5d$exports.getWorksheetColumnWidths)(builtWorksheet, settings.extraLength);
    return builtWorksheet;
};
const $bd9b13a4b7314f5d$var$applyCellStyles = (cell, ...styles)=>{
    const existingStyle = (0, $c896cea3fd00e6ea$exports.isCellStyleObject)(cell.s) ? cell.s : undefined;
    const mergedStyle = (0, $c896cea3fd00e6ea$exports.mergeCellStyles)(...styles, existingStyle);
    if (Object.keys(mergedStyle).length > 0) cell.s = mergedStyle;
};
const $bd9b13a4b7314f5d$var$validCellTypes = new Set([
    "b",
    "n",
    "e",
    "s",
    "d",
    "z",
    "str"
]);
const $bd9b13a4b7314f5d$var$styleKeys = new Set([
    "alignment",
    "border",
    "fill",
    "font",
    "numFmt"
]);
const $bd9b13a4b7314f5d$var$hasStyleKeys = (style)=>{
    return (0, $c896cea3fd00e6ea$exports.isCellStyleObject)(style) && Object.keys(style).some((key)=>$bd9b13a4b7314f5d$var$styleKeys.has(key));
};
const $bd9b13a4b7314f5d$var$isCellLink = (value)=>{
    return Boolean(value) && typeof value === "object" && !Array.isArray(value) && typeof value.Target === "string";
};
const $bd9b13a4b7314f5d$var$isStyledCell = (value)=>{
    if (!value || typeof value !== "object" || Array.isArray(value)) return false;
    const cell = value;
    return "v" in cell && ($bd9b13a4b7314f5d$var$validCellTypes.has(String(cell.t)) || $bd9b13a4b7314f5d$var$hasStyleKeys(cell.s) || typeof cell.z === "string" || $bd9b13a4b7314f5d$var$isCellLink(cell.l));
};
const $bd9b13a4b7314f5d$var$writeWorkbook = (workbook, settings = {})=>{
    var _a, _b, _c, _d, _e, _f;
    var _g;
    const RTL = Boolean(settings.RTL);
    (_a = workbook.Workbook) !== null && _a !== void 0 ? _a : workbook.Workbook = {};
    (_b = (_g = workbook.Workbook).Views) !== null && _b !== void 0 ? _b : _g.Views = [
        {}
    ];
    workbook.Workbook.Views.forEach((view)=>{
        view.RTL = RTL;
    });
    const filename = `${(_c = settings.fileName) !== null && _c !== void 0 ? _c : "Spreadsheet"}.xlsx`;
    const writeOptions = (_d = settings.writeOptions) !== null && _d !== void 0 ? _d : {};
    const writeType = (_e = writeOptions.type) !== null && _e !== void 0 ? _e : "buffer";
    if (settings.enableStyles) {
        const bookType = (_f = writeOptions.bookType) !== null && _f !== void 0 ? _f : "xlsx";
        if (bookType !== "xlsx") throw new Error("enableStyles only supports the xlsx book type");
        const rawWorkbook = (0, $77f9f80a0cede680$export$68d8715fc104d294)(workbook, Object.assign(Object.assign({}, writeOptions), {
            bookType: bookType,
            type: "array"
        }));
        const styledWorkbook = (0, $c896cea3fd00e6ea$exports.patchStyledWorkbook)(workbook, rawWorkbook);
        if (settings.writeMode === "write") return (0, $c896cea3fd00e6ea$exports.toStyledOutput)(styledWorkbook, writeType);
        else if (settings.writeMode === "writeFile") {
            (0, $c896cea3fd00e6ea$exports.saveXlsxOutput)(styledWorkbook, filename);
            return;
        } else if (writeOptions.type === "buffer") return (0, $c896cea3fd00e6ea$exports.toStyledOutput)(styledWorkbook, writeOptions.type);
        else {
            (0, $c896cea3fd00e6ea$exports.saveXlsxOutput)(styledWorkbook, filename);
            return;
        }
    }
    if (settings.writeMode === "write") return (0, $77f9f80a0cede680$export$68d8715fc104d294)(workbook, Object.assign(Object.assign({}, writeOptions), {
        type: writeType
    }));
    else if (settings.writeMode === "writeFile") {
        (0, $77f9f80a0cede680$export$552bfb764b5cd2b4)(workbook, filename, writeOptions);
        return;
    } else if (writeOptions.type === "buffer") return (0, $77f9f80a0cede680$export$68d8715fc104d294)(workbook, writeOptions);
    else {
        (0, $77f9f80a0cede680$export$552bfb764b5cd2b4)(workbook, filename, writeOptions);
        return;
    }
};
function $bd9b13a4b7314f5d$var$xlsx(jsonSheets, settings = {}, workbookCallback = ()=>{}) {
    if (jsonSheets.length === 0) return;
    const workbook = $77f9f80a0cede680$export$eab97d15b1788b8d.book_new();
    jsonSheets.forEach((actualSheet, actualIndex)=>{
        var _a;
        const worksheet = $bd9b13a4b7314f5d$var$getWorksheet(actualSheet, settings);
        const worksheetName = (_a = actualSheet.sheet) !== null && _a !== void 0 ? _a : `Sheet ${actualIndex + 1}`;
        $77f9f80a0cede680$export$eab97d15b1788b8d.book_append_sheet(workbook, worksheet, worksheetName);
    });
    workbookCallback(workbook);
    return $bd9b13a4b7314f5d$var$writeWorkbook(workbook, settings);
}
$bd9b13a4b7314f5d$exports.default = $bd9b13a4b7314f5d$var$xlsx;
$bd9b13a4b7314f5d$exports.libraryName = "json-as-xlsx";
$bd9b13a4b7314f5d$exports = $bd9b13a4b7314f5d$var$xlsx;
$bd9b13a4b7314f5d$exports.xlsx = $bd9b13a4b7314f5d$var$xlsx;
$bd9b13a4b7314f5d$exports.default = $bd9b13a4b7314f5d$var$xlsx;
$bd9b13a4b7314f5d$exports.libraryName = $bd9b13a4b7314f5d$exports.libraryName;
$bd9b13a4b7314f5d$exports.getContentProperty = $bd9b13a4b7314f5d$var$getContentProperty;
$bd9b13a4b7314f5d$exports.getJsonSheetRow = $bd9b13a4b7314f5d$exports.getJsonSheetRow;
$bd9b13a4b7314f5d$exports.getWorksheetColumnWidths = $bd9b13a4b7314f5d$exports.getWorksheetColumnWidths;
$bd9b13a4b7314f5d$exports.utils = $77f9f80a0cede680$export$eab97d15b1788b8d;


document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.js-certificate-search').forEach((el)=>{
        const app = (0, $cc75f711ea0318a4$exports.createApp)({
            data () {
                return {
                    email: '',
                    certificateType: false,
                    selectedCertificate: false,
                    areasDropdownOpen: false,
                    areasDropdownSearch: '',
                    selectedArea: false,
                    certificatesDropdownOpen: false,
                    certificatesDropdownSearch: '',
                    fieldCertificateName: '',
                    fieldOrgNumber: '',
                    fieldZipCode: '',
                    fieldDistrict: '',
                    formError: false,
                    formLoading: false,
                    result: false,
                    techAreas: [],
                    orgDropdownOpen: false,
                    isSwedishOrgNumber: true,
                    init: false,
                    resultTimestamp: false,
                    counties: [],
                    municipalities: [],
                    countiesDropdownOpen: false,
                    selectedCounties: [],
                    selectedMunicipalities: [],
                    countiesSearch: '',
                    municipalitiesSearch: '',
                    municipalitiesDropdownOpen: false,
                    countiesFocusedIndex: -1,
                    municipalitiesFocusedIndex: -1,
                    isAdmin: liGlobal.isAdmin
                };
            },
            mounted () {
                document.addEventListener('click', this.handleClickOutside);
            },
            beforeUnmount () {
                document.removeEventListener('click', this.handleClickOutside);
                document.removeEventListener('keydown', this.handleCountiesKeydown);
                document.removeEventListener('keydown', this.handleMunicipalitiesKeydown);
            },
            watch: {
                countiesFiltered: {
                    handler () {
                        this.countiesFocusedIndex = -1;
                    }
                },
                municipalitiesFiltered: {
                    handler () {
                        this.municipalitiesFocusedIndex = -1;
                    }
                }
            },
            async created () {
                const restBase = liGlobal.restBase;
                try {
                    const softAdminResponse = await this.$http.get(restBase + '/softadmin-tech-areas', {
                        headers: {
                            'X-WP-Nonce': liGlobal.restNonce
                        }
                    });
                    this.techAreas = Array.isArray(softAdminResponse.data) ? softAdminResponse.data : [];
                } catch (error) {
                    this.techAreas = [];
                    console.error(error);
                }
                try {
                    const countiesAndMunicipalitiesResponse = await this.$http.get(restBase + '/get-counties-and-municipalities');
                    this.counties = countiesAndMunicipalitiesResponse.data.Counties.sort((a, b)=>a.CountyName.localeCompare(b.CountyName, 'sv-SE')).sort((a, b)=>{
                        if (a.CountyId === -1) return -1;
                        if (b.CountyId === -1) return 1;
                        return 0;
                    });
                    this.municipalities = countiesAndMunicipalitiesResponse.data.Municipalities.sort((a, b)=>a.MunicipalityName.localeCompare(b.MunicipalityName, 'sv-SE')).sort((a, b)=>{
                        if (a.MunicipalityId === -1) return -1;
                        if (b.MunicipalityId === -1) return 1;
                        return 0;
                    });
                } catch (error) {
                    this.counties = [];
                    this.municipalities = [];
                    console.error(error);
                }
                this.init = true;
                // Vanilla JS: get all buttons by class
                const buttons = document.querySelectorAll('.certificate-area-button');
                buttons.forEach((button)=>{
                    button.addEventListener('click', (e)=>{
                        if (button.dataset.areaId === undefined) return;
                        const area = this.techAreas.find((area)=>button.dataset.areaId == area.TechAreaId);
                        if (area === undefined) return;
                        if (this.selectedArea !== false && this.selectedArea.areaId === area.TechAreaId) return;
                        // Clear all prior selections
                        this.selectedCertificate = false;
                        this.selectedArea = false;
                        this.certificateType = false;
                        this.formError = false;
                        this.clearForm();
                        this.selectArea({
                            areaId: area.TechAreaId,
                            areaName: area.TechAreaName
                        });
                    });
                });
            },
            computed: {
                resultJsonLabelsPerson: function() {
                    return {
                        area: {
                            title: "Omr\xe5de"
                        },
                        organizationNumber: {
                            title: 'Organisationsnummer'
                        },
                        companyName: {
                            title: "F\xf6retagsnamn"
                        },
                        certificateNames: {
                            title: 'Personcertifikat'
                        },
                        zipCode: {
                            title: 'Postnummer'
                        },
                        district: {
                            title: 'Ort'
                        }
                    };
                },
                resultJsonDataPerson: function() {
                    if (this.certificateType === false || this.certificateType !== 'person') return [];
                    if (this.result === false || this.result.Companies === null) return [];
                    return this.result.Companies.map((item)=>{
                        return {
                            area: this.selectedArea.areaName,
                            organizationNumber: item.OrganizationNumber,
                            companyName: item.CompanyName,
                            certificateNames: item.certificateNames,
                            zipCode: item.ZipCode,
                            district: item.City
                        };
                    });
                },
                searchType: function() {
                    if (this.certificateType === false) return '';
                    return this.certificateType === 'person' ? "F\xf6retag med certifierade personer" : "Certifierade f\xf6retag";
                },
                resultJsonLabelsCompany: function() {
                    return {
                        certificateNumber: {
                            title: 'Certifikatsnummer'
                        },
                        area: {
                            title: "Omr\xe5de"
                        },
                        certificateName: {
                            title: 'Certifikatstyp'
                        },
                        validTo: {
                            title: 'Giltigt t.o.m.'
                        },
                        organizationNumber: {
                            title: 'Organisationsnummer'
                        },
                        companyName: {
                            title: "F\xf6retagsnamn"
                        },
                        address: {
                            title: 'Adress'
                        },
                        zipCode: {
                            title: 'Postnummer'
                        },
                        district: {
                            title: 'Ort'
                        },
                        country: {
                            title: 'Land'
                        }
                    };
                },
                resultJsonDataCompany: function() {
                    if (this.certificateType === false || this.certificateType === 'person') return [];
                    if (this.result === false || this.result.CompanyCertificates === null) return [];
                    return this.result.CompanyCertificates.map((item)=>{
                        return {
                            certificateNumber: item.CertificateNumber,
                            area: this.selectedArea.areaName,
                            certificateName: item.CertificateName,
                            validTo: item.DateValidTo,
                            organizationNumber: item.OrganizationNumber,
                            companyName: item.CompanyName,
                            address: item.Address,
                            zipCode: item.ZipCode,
                            district: item.City,
                            country: item.Country
                        };
                    });
                },
                excelPersonData: function() {
                    return [
                        {
                            sheet: "F\xf6retag m certifierade personer",
                            columns: [
                                {
                                    label: "Omr\xe5de",
                                    value: 'area'
                                },
                                {
                                    label: 'Organisationsnummer',
                                    value: 'organizationNumber'
                                },
                                {
                                    label: "F\xf6retagsnamn",
                                    value: 'companyName'
                                },
                                {
                                    label: 'Personcertifikat',
                                    value: 'certificateNames'
                                },
                                {
                                    label: 'Postnummer',
                                    value: 'zipCode'
                                },
                                {
                                    label: 'Ort',
                                    value: 'district'
                                }
                            ],
                            content: this.resultJsonDataPerson
                        }
                    ];
                },
                excelCompanyData: function() {
                    return [
                        {
                            sheet: "Certifierade f\xf6retag",
                            columns: [
                                {
                                    label: 'Certifikatsnummer',
                                    value: 'certificateNumber'
                                },
                                {
                                    label: "Omr\xe5de",
                                    value: 'area'
                                },
                                {
                                    label: 'Certifikatstyp',
                                    value: 'certificateName'
                                },
                                {
                                    label: 'Giltigt t.o.m.',
                                    value: 'validTo'
                                },
                                {
                                    label: 'Organisationsnummer',
                                    value: 'organizationNumber'
                                },
                                {
                                    label: "F\xf6retagsnamn",
                                    value: 'companyName'
                                },
                                {
                                    label: 'Adress',
                                    value: 'address'
                                },
                                {
                                    label: 'Postnummer',
                                    value: 'zipCode'
                                },
                                {
                                    label: 'Ort',
                                    value: 'district'
                                },
                                {
                                    label: 'Land',
                                    value: 'country'
                                }
                            ],
                            content: this.resultJsonDataCompany
                        }
                    ];
                },
                excelSettings: function() {
                    return {
                        fileName: "Incert S\xf6kresultat - " + this.getDateNow(),
                        extraLength: 3,
                        writeOptions: {}
                    };
                },
                formattedFieldOrgNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');
                        this.fieldOrgNumber = number;
                    },
                    get: function() {
                        const number = this.fieldOrgNumber;
                        if (number.length === 6) return number + '-';
                        if (number.length > 6) return number.substring(0, 6) + '-' + number.substring(6);
                        else return number;
                    }
                },
                formattedZipCode: {
                    set: function(val) {
                        const number = val.replaceAll(' ', '');
                        this.fieldZipCode = number;
                    },
                    get: function() {
                        const number = this.fieldZipCode;
                        if (number.length === 3) return number + ' ';
                        if (number.length > 3) return number.substring(0, 3) + ' ' + number.substring(3);
                        else return number;
                    }
                },
                areas: function() {
                    const returnArr = [];
                    this.techAreas.forEach((area)=>{
                        if (area.CertificateTemplates !== null) returnArr.push({
                            areaId: area.TechAreaId,
                            areaName: area.TechAreaName
                        });
                    });
                    returnArr.sort((a, b)=>{
                        return a.areaName.localeCompare(b.areaName, 'sv');
                    });
                    if (this.areasDropdownSearch.trim() == '') return returnArr;
                    else return returnArr.filter((item)=>{
                        return item.areaName.toLowerCase().includes(this.areasDropdownSearch.toLowerCase());
                    });
                },
                certificates: function() {
                    const returnArr = [];
                    if (this.certificateType === false || this.selectedArea === false) return [];
                    const area = this.techAreas.find((area)=>{
                        return area.TechAreaId === this.selectedArea.areaId;
                    });
                    if (area === undefined || area.CertificateTemplates === null) return [];
                    area.CertificateTemplates.forEach((template)=>{
                        if (template.IsRecertificate === false) {
                            if (this.certificateType === 'company') {
                                if (template.IsCompanyCertificate === true) returnArr.push(template);
                            } else if (this.certificateType === 'person') {
                                if (template.IsCompanyCertificate === false) returnArr.push(template);
                            }
                        }
                    });
                    returnArr.sort((a, b)=>{
                        return a.TemplateName.localeCompare(b.TemplateName, 'sv');
                    });
                    if (this.certificatesDropdownSearch.trim() == '') return returnArr;
                    else return returnArr.filter((item)=>{
                        return item.TemplateName.toLowerCase().includes(this.certificatesDropdownSearch.toLowerCase());
                    });
                },
                countiesFiltered: function() {
                    if (this.countiesSearch.trim() == '') return this.counties;
                    else return this.counties.filter((item)=>{
                        return item.CountyName.toLowerCase().includes(this.countiesSearch.trim().toLowerCase());
                    });
                },
                isCin2Area: function() {
                    if (this.selectedArea === false || !this.selectedArea.areaName) return false;
                    return /cin\s*2/i.test(this.selectedArea.areaName);
                },
                showCountyMunicipality: function() {
                    return this.isAdmin || this.isCin2Area;
                },
                municipalitiesFiltered: function() {
                    const returnArr = [];
                    if (this.selectedCounties.length > 0) {
                        if (this.selectedCounties.length === 1 && this.selectedCounties[0].CountyId === -1) return this.municipalities;
                        this.selectedCounties.forEach((county)=>{
                            const municipalities = this.municipalities.filter((municipality)=>{
                                return municipality.CountyId === county.CountyId;
                            });
                            returnArr.push(...municipalities);
                        });
                    } else returnArr.push(...this.municipalities);
                    if (this.municipalitiesSearch.trim() == '') return returnArr;
                    else return returnArr.filter((item)=>{
                        return item.MunicipalityName.toLowerCase().includes(this.municipalitiesSearch.trim().toLowerCase());
                    });
                }
            },
            methods: {
                removeMunicipality (municipality) {
                    this.selectedMunicipalities = this.selectedMunicipalities.filter((item)=>{
                        return item !== municipality;
                    });
                },
                clearMunicipalities () {
                    this.selectedMunicipalities = [];
                },
                handleMunicipalitiesKeydown: function(event) {
                    if (!this.municipalitiesDropdownOpen || this.municipalitiesFiltered.length === 0) return;
                    switch(event.key){
                        case 'ArrowDown':
                            event.preventDefault();
                            this.municipalitiesFocusedIndex = this.municipalitiesFocusedIndex < this.municipalitiesFiltered.length - 1 ? this.municipalitiesFocusedIndex + 1 : this.municipalitiesFocusedIndex;
                            this.scrollToFocusedMunicipalityOption();
                            break;
                        case 'ArrowUp':
                            event.preventDefault();
                            this.municipalitiesFocusedIndex = this.municipalitiesFocusedIndex > -1 ? this.municipalitiesFocusedIndex - 1 : -1;
                            this.scrollToFocusedMunicipalityOption();
                            break;
                        case 'Enter':
                            event.preventDefault();
                            if (this.municipalitiesFocusedIndex >= 0) this.selectMunicipality(this.municipalitiesFiltered[this.municipalitiesFocusedIndex]);
                            else if (this.municipalitiesFiltered.length === 1) this.selectMunicipality(this.municipalitiesFiltered[0]);
                            break;
                        case 'Escape':
                            this.municipalitiesDropdownOpen = false;
                            this.municipalitiesFocusedIndex = -1;
                            break;
                    }
                },
                scrollToFocusedMunicipalityOption: function() {
                    this.$nextTick(()=>{
                        const focusedElement = el.querySelector('.certificate-search-dropdown.county-municipality .option.keyboard-focus');
                        const resultWrapper = el.querySelector('.certificate-search-dropdown.county-municipality .result-wrapper');
                        if (focusedElement && resultWrapper) {
                            const wrapperRect = resultWrapper.getBoundingClientRect();
                            const elementRect = focusedElement.getBoundingClientRect();
                            const isAbove = elementRect.top < wrapperRect.top;
                            const isBelow = elementRect.bottom > wrapperRect.bottom;
                            if (isAbove) resultWrapper.scrollTop += elementRect.top - wrapperRect.top;
                            else if (isBelow) resultWrapper.scrollTop += elementRect.bottom - wrapperRect.bottom;
                        }
                    });
                },
                toggleMunicipalityDropdown: function() {
                    this.countiesDropdownOpen = false;
                    this.municipalitiesDropdownOpen = !this.municipalitiesDropdownOpen;
                    this.municipalitiesFocusedIndex = -1;
                    if (this.municipalitiesDropdownOpen) {
                        document.addEventListener('keydown', this.handleMunicipalitiesKeydown);
                        this.$nextTick(()=>{
                            this.$refs.municipalitiesSearch.focus();
                        });
                    } else document.removeEventListener('keydown', this.handleMunicipalitiesKeydown);
                },
                handleCountiesKeydown: function(event) {
                    if (!this.countiesDropdownOpen || this.countiesFiltered.length === 0) return;
                    switch(event.key){
                        case 'ArrowDown':
                            event.preventDefault();
                            this.countiesFocusedIndex = this.countiesFocusedIndex < this.countiesFiltered.length - 1 ? this.countiesFocusedIndex + 1 : this.countiesFocusedIndex;
                            this.scrollToFocusedOption();
                            break;
                        case 'ArrowUp':
                            event.preventDefault();
                            this.countiesFocusedIndex = this.countiesFocusedIndex > -1 ? this.countiesFocusedIndex - 1 : -1;
                            this.scrollToFocusedOption();
                            break;
                        case 'Enter':
                            event.preventDefault();
                            if (this.countiesFocusedIndex >= 0) this.selectCounty(this.countiesFiltered[this.countiesFocusedIndex]);
                            else if (this.countiesFiltered.length === 1) this.selectCounty(this.countiesFiltered[0]);
                            break;
                        case 'Escape':
                            this.countiesDropdownOpen = false;
                            this.countiesFocusedIndex = -1;
                            break;
                    }
                },
                scrollToFocusedOption: function() {
                    this.$nextTick(()=>{
                        const focusedElement = el.querySelector('.option.keyboard-focus');
                        const resultWrapper = el.querySelector('.result-wrapper');
                        if (focusedElement && resultWrapper) {
                            const wrapperRect = resultWrapper.getBoundingClientRect();
                            const elementRect = focusedElement.getBoundingClientRect();
                            const isAbove = elementRect.top < wrapperRect.top;
                            const isBelow = elementRect.bottom > wrapperRect.bottom;
                            if (isAbove) resultWrapper.scrollTop += elementRect.top - wrapperRect.top;
                            else if (isBelow) resultWrapper.scrollTop += elementRect.bottom - wrapperRect.bottom;
                        }
                    });
                },
                toggleCountyDropdown: function() {
                    this.municipalitiesDropdownOpen = false;
                    this.countiesDropdownOpen = !this.countiesDropdownOpen;
                    this.countiesFocusedIndex = -1;
                    if (this.countiesDropdownOpen) {
                        document.addEventListener('keydown', this.handleCountiesKeydown);
                        this.$nextTick(()=>{
                            this.$refs.countiesSearch.focus();
                        });
                    } else document.removeEventListener('keydown', this.handleCountiesKeydown);
                },
                handleClickOutside (event) {
                    if (this.$refs.countyDropdown && !this.$refs.countyDropdown.contains(event.target)) {
                        this.countiesDropdownOpen = false;
                        this.countiesFocusedIndex = -1;
                        document.removeEventListener('keydown', this.handleCountiesKeydown);
                    }
                    if (this.$refs.municipalityDropdown && !this.$refs.municipalityDropdown.contains(event.target)) {
                        this.municipalitiesDropdownOpen = false;
                        this.municipalitiesFocusedIndex = -1;
                        document.removeEventListener('keydown', this.handleMunicipalitiesKeydown);
                    }
                },
                removeCounty (county) {
                    this.selectedCounties = this.selectedCounties.filter((item)=>{
                        return item !== county;
                    });
                },
                isCountySelected (option) {
                    return this.selectedCounties.some((county)=>county.CountyId === option.CountyId);
                },
                isMunicipalitySelected (option) {
                    return this.selectedMunicipalities.some((municipality)=>municipality.MunicipalityId === option.MunicipalityId);
                },
                selectCounty: function(county) {
                    this.selectedMunicipalities = [];
                    if (county.CountyId === -1) {
                        if (this.selectedCounties[0] === county) this.selectedCounties = [];
                        else this.selectedCounties = [
                            county
                        ];
                    } else {
                        if (this.selectedCounties.find((county)=>county.CountyId === -1) !== undefined) this.selectedCounties = [];
                        if (this.selectedCounties.includes(county)) this.selectedCounties = this.selectedCounties.filter((item)=>{
                            return item !== county;
                        });
                        else this.selectedCounties.push(county);
                    }
                    this.countiesSearch = '';
                },
                selectMunicipality: function(municipality) {
                    if (municipality.MunicipalityId === -1) {
                        if (this.selectedMunicipalities[0] === municipality) this.selectedMunicipalities = [];
                        else this.selectedMunicipalities = [
                            municipality
                        ];
                    } else {
                        if (this.selectedMunicipalities.find((municipality)=>municipality.MunicipalityId === -1) !== undefined) this.selectedMunicipalities = [];
                        if (this.selectedMunicipalities.includes(municipality)) this.selectedMunicipalities = this.selectedMunicipalities.filter((item)=>{
                            return item !== municipality;
                        });
                        else this.selectedMunicipalities.push(municipality);
                    }
                    this.municipalitiesSearch = '';
                },
                getDateNow: function() {
                    return this.resultTimestamp.replaceAll(':', '.');
                },
                selectOrgType: function(type) {
                    this.fieldOrgNumber = '';
                    this.fieldZipCode = '';
                    this.orgDropdownOpen = false;
                    this.isSwedishOrgNumber = type;
                },
                selectCertificateType: function(type) {
                    if (this.certificateOfTypeExists(type) === false) return;
                    if (type === this.certificateType) return;
                    if (this.selectedCertificate !== false) this.selectedCertificate = false;
                    this.clearForm();
                    this.certificateType = type;
                },
                onlyNumber ($event) {
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                onlyNumberOrg ($event) {
                    if ($event.target.value.length > 10) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                onlyNumberZipCode ($event) {
                    if ($event.target.value.length > 5) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                test: function(date) {
                    const today = new Date();
                    return date > today;
                },
                selectArea: function(selected) {
                    this.selectedCertificate = false;
                    this.selectedArea = selected;
                    this.areasDropdownSearch = '';
                    this.areasDropdownOpen = false;
                    this.certificateType = false;
                    this.selectedCertificate = false;
                    this.clearForm();
                    const area = this.techAreas.find((area)=>{
                        return area.TechAreaId === this.selectedArea.areaId;
                    });
                    if (area === undefined || area.CertificateTemplates === null) return;
                    if (area.CertificateTemplates.length > 0) {
                        const companyCertificates = area.CertificateTemplates.filter((template)=>{
                            return template.IsCompanyCertificate === true;
                        });
                        const personCertificates = area.CertificateTemplates.filter((template)=>{
                            return template.IsCompanyCertificate === false;
                        });
                        if (personCertificates.length === 0) this.certificateType = 'company';
                        else if (companyCertificates.length === 0) this.certificateType = 'person';
                    }
                },
                certificateOfTypeExists: function(type) {
                    if (this.selectedArea === false) return false;
                    const area = this.techAreas.find((area)=>{
                        return area.TechAreaId === this.selectedArea.areaId;
                    });
                    if (area === undefined || area.CertificateTemplates === null) return false;
                    if (type === 'company') return area.CertificateTemplates.some((template)=>{
                        return template.IsCompanyCertificate === true;
                    });
                    else if (type === 'person') return area.CertificateTemplates.some((template)=>{
                        return template.IsCompanyCertificate === false;
                    });
                    return false;
                },
                selectCertificate: function(selected) {
                    this.certificatesDropdownOpen = false;
                    this.selectedCertificate = selected;
                    this.certificatesDropdownSearch = '';
                    this.clearForm();
                },
                clearCounties: function() {
                    this.selectedCounties = [];
                },
                clearForm: function() {
                    this.result = false;
                    this.fieldCertificateName = '';
                    this.fieldOrgNumber = '';
                    this.fieldZipCode = '';
                    this.fieldDistrict = '';
                    this.isSwedishOrgNumber = true;
                    this.resultTimestamp = false;
                    this.selectedCounties = [];
                    this.selectedMunicipalities = [];
                    this.countiesSearch = '';
                    this.municipalitiesSearch = '';
                    this.countiesDropdownOpen = false;
                    this.municipalitiesDropdownOpen = false;
                    document.removeEventListener('keydown', this.handleCountiesKeydown);
                    document.removeEventListener('keydown', this.handleMunicipalitiesKeydown);
                },
                validateForm: function() {
                    if (this.formLoading == true) return;
                    // Honeypot field
                    if (this.email !== '') return;
                    this.result = false;
                    this.formError = false;
                    const name = this.fieldCertificateName.trim();
                    const zipCode = this.fieldZipCode.trim();
                    const district = this.fieldDistrict.trim();
                    const orgNumber = this.fieldOrgNumber.trim();
                    const countiesLength = this.showCountyMunicipality ? this.selectedCounties.length : 0;
                    const municipalitiesLength = this.showCountyMunicipality ? this.selectedMunicipalities.length : 0;
                    if (this.certificateType === 'person') {
                        if (zipCode === '' && district === '' && countiesLength === 0 && municipalitiesLength === 0) {
                            this.formError = {
                                field: '',
                                message: "ange minst ett s\xf6kkriterium"
                            };
                            return;
                        }
                    } else if (this.certificateType === 'company') {
                        if (orgNumber === '' && name === '' && zipCode === '' && district === '' && countiesLength === 0 && municipalitiesLength === 0) {
                            this.formError = {
                                field: '',
                                message: "ange minst ett s\xf6kkriterium"
                            };
                            return;
                        }
                        if (orgNumber !== '' && this.isSwedishOrgNumber === true && orgNumber.length !== 10) {
                            this.formError = {
                                field: 'fieldOrgNumber',
                                message: "ange ett fullst\xe4ndigt organisationsnummer (10 siffror)"
                            };
                            return;
                        }
                    }
                    this.formLoading = true;
                    const restBase = liGlobal.restBase;
                    let query;
                    let counties = '';
                    let municipalities = '';
                    if (this.showCountyMunicipality && this.selectedCounties.length > 0) counties = this.selectedCounties.map((county)=>{
                        return county.CountyId;
                    }).join(',');
                    if (this.showCountyMunicipality && this.selectedMunicipalities.length > 0) municipalities = this.selectedMunicipalities.map((municipality)=>{
                        return municipality.MunicipalityId;
                    }).join(',');
                    if (this.certificateType === 'company') {
                        query = '?CompanyName=' + encodeURIComponent(name) + '&OrganizationNumber=' + encodeURIComponent(orgNumber) + '&IsSwedishOrganizationNumber=' + (this.isSwedishOrgNumber === true ? '1' : '0') + '&ZipCode=' + encodeURIComponent(zipCode) + '&City=' + encodeURIComponent(district) + '&TechAreaId=' + this.selectedArea.areaId + '&TemplateId=' + this.selectedCertificate.TemplateId + '&CountyId=' + counties + '&MunicipalityId=' + municipalities;
                        this.$http.get(restBase + '/softadmin-search-company' + query, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.formLoading = false;
                            this.resultTimestamp = (0, $e457b70bcd427770$exports.DateTime).now().toFormat('yyyy-MM-dd HH:mm');
                            if (response.data.CompanyCertificates !== null && response.data.CompanyCertificates.length > 0) {
                                response.data.CompanyCertificates.forEach((certificate)=>{
                                    certificate.isOpen = false;
                                });
                                response.data.CompanyCertificates.sort((a, b)=>{
                                    return a.CompanyName.localeCompare(b.CompanyName, 'sv');
                                });
                            }
                            this.result = response.data;
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: '',
                                message: "Kunde inte h\xe4mta s\xf6kresultat. F\xf6rs\xf6k igen."
                            };
                            console.log(error);
                        });
                    } else if (this.certificateType === 'person') {
                        query = '?ZipCode=' + encodeURIComponent(zipCode) + '&City=' + encodeURIComponent(district) + '&TechAreaId=' + this.selectedArea.areaId + '&CountyId=' + counties + '&MunicipalityId=' + municipalities;
                        this.$http.get(restBase + '/softadmin-search-person' + query, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.formLoading = false;
                            this.resultTimestamp = (0, $e457b70bcd427770$exports.DateTime).now().toFormat('yyyy-MM-dd HH:mm');
                            if (response.data.Companies !== null && response.data.Companies.length > 0) {
                                response.data.Companies.forEach((company)=>{
                                    let certificateNames = '';
                                    if (company.EmployeeCertificates !== null && company.EmployeeCertificates.length > 0) {
                                        company.EmployeeCertificates.forEach((certificate)=>{
                                            if (certificate.DoExistEmployeeWithActiveCertificate === true) certificateNames += certificate.CertificateName + ', ';
                                        });
                                        certificateNames = certificateNames.substring(0, certificateNames.length - 2);
                                        company.certificateNames = certificateNames;
                                    }
                                    company.isOpen = false;
                                });
                                response.data.Companies.sort((a, b)=>{
                                    return a.CompanyName.localeCompare(b.CompanyName, 'sv');
                                });
                            }
                            this.result = response.data;
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: '',
                                message: "Kunde inte h\xe4mta s\xf6kresultat. F\xf6rs\xf6k igen."
                            };
                            console.log(error);
                        });
                    }
                },
                escapeCsvValue: function(value, separator) {
                    const string = value == null ? '' : String(value);
                    if (string.includes('"') || string.includes('\n') || string.includes('\r') || string.includes(separator)) return '"' + string.replaceAll('"', '""') + '"';
                    return string;
                },
                downloadCsv: function() {
                    const rows = this.certificateType === 'company' ? this.resultJsonDataCompany : this.resultJsonDataPerson;
                    const labels = this.certificateType === 'company' ? this.resultJsonLabelsCompany : this.resultJsonLabelsPerson;
                    const separator = ';';
                    if (!rows.length) return;
                    const keys = Object.keys(labels);
                    const header = keys.map((key)=>this.escapeCsvValue(labels[key].title, separator)).join(separator);
                    const body = rows.map((row)=>{
                        return keys.map((key)=>this.escapeCsvValue(row[key], separator)).join(separator);
                    }).join('\r\n');
                    const blob = new Blob([
                        '\uFEFF' + header + '\r\n' + body
                    ], {
                        type: 'text/csv;charset=utf-8;'
                    });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = "Incert S\xf6kresultat - " + this.getDateNow() + '.csv';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                },
                downloadExcel: function() {
                    if (this.certificateType === 'person') (0, (/*@__PURE__*/$parcel$interopDefault($bd9b13a4b7314f5d$exports)))(this.excelPersonData, this.excelSettings);
                    else if (this.certificateType === 'company') (0, (/*@__PURE__*/$parcel$interopDefault($bd9b13a4b7314f5d$exports)))(this.excelCompanyData, this.excelSettings);
                }
            }
        });
        app.config.globalProperties.$http = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.config.globalProperties.axios = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.mount(el);
    });
});






function $1880755912401988$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $535636d8023070c8$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $1880755912401988$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $99f21587b7d92456$export$dfd9b671c89acc8e = 7;
const $99f21587b7d92456$export$3913210603d8e9ae = 365.2425;
const $99f21587b7d92456$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $99f21587b7d92456$export$4dec998e48f9c246 = -$99f21587b7d92456$export$81caae6e1cc7a622;
const $99f21587b7d92456$export$4fad13613e88edc8 = 604800000;
const $99f21587b7d92456$export$b76b1809a2898f9a = 86400000;
const $99f21587b7d92456$export$91246f0b9bd9beff = 60000;
const $99f21587b7d92456$export$7f72910d6dfd237a = 3600000;
const $99f21587b7d92456$export$397c2d5776aa9055 = 1000;
const $99f21587b7d92456$export$3633035e63cee86a = 525600;
const $99f21587b7d92456$export$ab7da2ccd1075c38 = 43200;
const $99f21587b7d92456$export$2423174df8cd3cd2 = 1440;
const $99f21587b7d92456$export$f2f5ae5a8e2d8f9f = 60;
const $99f21587b7d92456$export$3c58128db900d44e = 3;
const $99f21587b7d92456$export$80d7e435f744f319 = 12;
const $99f21587b7d92456$export$4db7641526e3241f = 4;
const $99f21587b7d92456$export$698aec755e92c695 = 3600;
const $99f21587b7d92456$export$a77c1a7ebebe2a5a = 60;
const $99f21587b7d92456$export$815a9362476d2fe3 = $99f21587b7d92456$export$698aec755e92c695 * 24;
const $99f21587b7d92456$export$34804a017b31e2fe = $99f21587b7d92456$export$815a9362476d2fe3 * 7;
const $99f21587b7d92456$export$7271e9e3478110d1 = $99f21587b7d92456$export$815a9362476d2fe3 * $99f21587b7d92456$export$3913210603d8e9ae;
const $99f21587b7d92456$export$8e6600bbdee7dabb = $99f21587b7d92456$export$7271e9e3478110d1 / 12;
const $99f21587b7d92456$export$be1dccf2de902d31 = $99f21587b7d92456$export$8e6600bbdee7dabb * 3;
const $99f21587b7d92456$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $986d131a6bdc7bf2$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $99f21587b7d92456$export$2a7b97929c48d47d) in date) return date[0, $99f21587b7d92456$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$986d131a6bdc7bf2$export$2e2bcd8739ae039 = $986d131a6bdc7bf2$export$ead8a1812b171991;



function $f620a93511abfab4$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$f620a93511abfab4$export$2e2bcd8739ae039 = $f620a93511abfab4$export$e67a095c620b86fe;


function $9beb75eaafe7f582$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$9beb75eaafe7f582$export$2e2bcd8739ae039 = $9beb75eaafe7f582$export$dd412b56f1e4d8aa;




function $d6cc99e193ff1a7d$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$d6cc99e193ff1a7d$export$2e2bcd8739ae039 = $d6cc99e193ff1a7d$export$17c93e242b2d3a22;




function $cd621c9cd579be00$export$e16d8520af44a096(date, duration, options) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    // Add years and months
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const dateWithMonths = months || years ? (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(_date, months + years * 12) : _date;
    // Add weeks and days
    const dateWithDays = days || weeks ? (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes, and seconds
    const minutesToAdd = minutes + hours * 60;
    const secondsToAdd = seconds + minutesToAdd * 60;
    const msToAdd = secondsToAdd * 1000;
    return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, +dateWithDays + msToAdd);
}
var // Fallback for modularized imports:
$cd621c9cd579be00$export$2e2bcd8739ae039 = $cd621c9cd579be00$export$e16d8520af44a096;



function $8ebe48276a8fdbe4$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, +(0, $f620a93511abfab4$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$8ebe48276a8fdbe4$export$2e2bcd8739ae039 = $8ebe48276a8fdbe4$export$baf757aaf0c95c94;



function $114f3c376da8f612$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $8ebe48276a8fdbe4$export$baf757aaf0c95c94)(date, amount * (0, $99f21587b7d92456$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$114f3c376da8f612$export$2e2bcd8739ae039 = $114f3c376da8f612$export$4a4306ad4fa0e5e6;


function $0592f6ea6313b650$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$0592f6ea6313b650$export$2e2bcd8739ae039 = $0592f6ea6313b650$export$3d83eec43f4ea476;


function $6aca57f4bdeccff7$export$113002b5eff6e430(date) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $67190bcef07f011e$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $986d131a6bdc7bf2$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $bd7c8e28b828f3c8$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$bd7c8e28b828f3c8$export$2e2bcd8739ae039 = $bd7c8e28b828f3c8$export$63fa379ae8a9ba2;


function $df2b8c65fdff64db$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $67190bcef07f011e$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $bd7c8e28b828f3c8$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $bd7c8e28b828f3c8$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $6aca57f4bdeccff7$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $6aca57f4bdeccff7$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $99f21587b7d92456$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$df2b8c65fdff64db$export$2e2bcd8739ae039 = $df2b8c65fdff64db$export$4a02e9c37dab4871;



function $777a3effbfb4f132$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $f620a93511abfab4$export$e67a095c620b86fe)(dateLeft) - +(0, $f620a93511abfab4$export$e67a095c620b86fe)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$777a3effbfb4f132$export$2e2bcd8739ae039 = $777a3effbfb4f132$export$fe114145ae75d197;



function $d1046a736cd7a817$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $67190bcef07f011e$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$d1046a736cd7a817$export$2e2bcd8739ae039 = $d1046a736cd7a817$export$c06dce8b38891685;


function $46dd16ed861022fb$export$ed6bf486f68899ca(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $67190bcef07f011e$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    // -1 if the left date is earlier than the right date
    // 2023-12-31 - 2024-01-01 = -1
    const sign = (0, $777a3effbfb4f132$export$fe114145ae75d197)(laterDate_, earlierDate_);
    // First calculate the difference in calendar years
    // 2024-01-01 - 2023-12-31 = 1 year
    const diff = Math.abs((0, $d1046a736cd7a817$export$c06dce8b38891685)(laterDate_, earlierDate_));
    // Now we need to calculate if the difference is full. To do that we set
    // both dates to the same year and check if the both date's month and day
    // form a full year.
    laterDate_.setFullYear(1584);
    earlierDate_.setFullYear(1584);
    // For it to be true, when the later date is indeed later than the earlier date
    // (2026-02-01 - 2023-12-10 = 3 years), the difference is full if
    // the normalized later date is also later than the normalized earlier date.
    // In our example, 1584-02-01 is earlier than 1584-12-10, so the difference
    // is partial, hence we need to subtract 1 from the difference 3 - 1 = 2.
    const partial = (0, $777a3effbfb4f132$export$fe114145ae75d197)(laterDate_, earlierDate_) === -sign;
    const result = sign * (diff - +partial);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$46dd16ed861022fb$export$2e2bcd8739ae039 = $46dd16ed861022fb$export$ed6bf486f68899ca;


function $f02bc6e0b7368b05$export$17b5b2669f734364(context, interval) {
    const [start, end] = (0, $67190bcef07f011e$export$9f53b88e82f64d8d)(context, interval.start, interval.end);
    return {
        start: start,
        end: end
    };
}



function $c9b711093b477e6c$export$7a337e5923c7ceb5(interval, options) {
    const { start: start, end: end } = (0, $f02bc6e0b7368b05$export$17b5b2669f734364)(options === null || options === void 0 ? void 0 : options.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +start : +end;
    const date = reversed ? end : start;
    date.setHours(0, 0, 0, 0);
    var _options_step;
    let step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, $986d131a6bdc7bf2$export$ead8a1812b171991)(start, date));
        date.setDate(date.getDate() + step);
        date.setHours(0, 0, 0, 0);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$c9b711093b477e6c$export$2e2bcd8739ae039 = $c9b711093b477e6c$export$7a337e5923c7ceb5;



function $562f8cc6ed903f18$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$562f8cc6ed903f18$export$2e2bcd8739ae039 = $562f8cc6ed903f18$export$c252a41d0fbed2ce;




function $29afb4b16bbf6e94$export$69be7267a042ecb3(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$29afb4b16bbf6e94$export$2e2bcd8739ae039 = $29afb4b16bbf6e94$export$69be7267a042ecb3;


function $2aa5febcb7470051$export$96790a0abfab0078(interval, options) {
    const { start: start, end: end } = (0, $f02bc6e0b7368b05$export$17b5b2669f734364)(options === null || options === void 0 ? void 0 : options.in, interval);
    let reversed = +start > +end;
    const endTime = reversed ? +(0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(start) : +(0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(end);
    let date = reversed ? (0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(end) : (0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(start);
    var _options_step;
    let step = (_options_step = options === null || options === void 0 ? void 0 : options.step) !== null && _options_step !== void 0 ? _options_step : 1;
    if (!step) return [];
    if (step < 0) {
        step = -step;
        reversed = !reversed;
    }
    const dates = [];
    while(+date <= endTime){
        dates.push((0, $986d131a6bdc7bf2$export$ead8a1812b171991)(start, date));
        date = (0, $562f8cc6ed903f18$export$c252a41d0fbed2ce)(date, step);
    }
    return reversed ? dates.reverse() : dates;
}
var // Fallback for modularized imports:
$2aa5febcb7470051$export$2e2bcd8739ae039 = $2aa5febcb7470051$export$96790a0abfab0078;


function $d32b5f088e249a0e$export$5f53493861eef879(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d32b5f088e249a0e$export$2e2bcd8739ae039 = $d32b5f088e249a0e$export$5f53493861eef879;

let $12d71c9d27432461$var$defaultOptions = {};
function $12d71c9d27432461$export$430a3269e24b912e() {
    return $12d71c9d27432461$var$defaultOptions;
}
function $12d71c9d27432461$export$95365be1b0704abc(newOptions) {
    $12d71c9d27432461$var$defaultOptions = newOptions;
}



function $8e73e36ac64240db$export$ef8b6d9133084f4e(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $12d71c9d27432461$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$8e73e36ac64240db$export$2e2bcd8739ae039 = $8e73e36ac64240db$export$ef8b6d9133084f4e;


function $bac7abe4a926855b$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$bac7abe4a926855b$export$2e2bcd8739ae039 = $bac7abe4a926855b$export$8b7aa55c66d5569e;

const $46c050f070de7192$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $46c050f070de7192$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $46c050f070de7192$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $468c03a7a9a5de26$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $a4ff35e2116789e5$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $a4ff35e2116789e5$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $a4ff35e2116789e5$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $a4ff35e2116789e5$export$cbf60ecb96cbb82f = {
    date: (0, $468c03a7a9a5de26$export$38e44e97ce4dbb7d)({
        formats: $a4ff35e2116789e5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $468c03a7a9a5de26$export$38e44e97ce4dbb7d)({
        formats: $a4ff35e2116789e5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $468c03a7a9a5de26$export$38e44e97ce4dbb7d)({
        formats: $a4ff35e2116789e5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $c2dfc3feb8c9ca62$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $c2dfc3feb8c9ca62$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$c2dfc3feb8c9ca62$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $4b9aa5654f5d118e$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $933264d81cc45273$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $933264d81cc45273$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $933264d81cc45273$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $933264d81cc45273$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $933264d81cc45273$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $933264d81cc45273$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $933264d81cc45273$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $933264d81cc45273$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $933264d81cc45273$var$ordinalNumber,
    era: (0, $4b9aa5654f5d118e$export$63596d6ee8878b25)({
        values: $933264d81cc45273$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $4b9aa5654f5d118e$export$63596d6ee8878b25)({
        values: $933264d81cc45273$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $4b9aa5654f5d118e$export$63596d6ee8878b25)({
        values: $933264d81cc45273$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $4b9aa5654f5d118e$export$63596d6ee8878b25)({
        values: $933264d81cc45273$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $4b9aa5654f5d118e$export$63596d6ee8878b25)({
        values: $933264d81cc45273$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $933264d81cc45273$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $a4dc794792106092$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $a4dc794792106092$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $a4dc794792106092$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $a4dc794792106092$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $a4dc794792106092$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $91de22f6dcc436de$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $e8f2c276e9bf2234$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $e8f2c276e9bf2234$var$parseOrdinalNumberPattern = /\d+/i;
const $e8f2c276e9bf2234$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $e8f2c276e9bf2234$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $e8f2c276e9bf2234$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $e8f2c276e9bf2234$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $e8f2c276e9bf2234$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $e8f2c276e9bf2234$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $e8f2c276e9bf2234$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $e8f2c276e9bf2234$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $e8f2c276e9bf2234$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $e8f2c276e9bf2234$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $e8f2c276e9bf2234$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $91de22f6dcc436de$export$fdaf2fd6d7edde95)({
        matchPattern: $e8f2c276e9bf2234$var$matchOrdinalNumberPattern,
        parsePattern: $e8f2c276e9bf2234$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $a4dc794792106092$export$1430a0f35710914d)({
        matchPatterns: $e8f2c276e9bf2234$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8f2c276e9bf2234$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $a4dc794792106092$export$1430a0f35710914d)({
        matchPatterns: $e8f2c276e9bf2234$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8f2c276e9bf2234$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $a4dc794792106092$export$1430a0f35710914d)({
        matchPatterns: $e8f2c276e9bf2234$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8f2c276e9bf2234$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $a4dc794792106092$export$1430a0f35710914d)({
        matchPatterns: $e8f2c276e9bf2234$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e8f2c276e9bf2234$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $a4dc794792106092$export$1430a0f35710914d)({
        matchPatterns: $e8f2c276e9bf2234$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e8f2c276e9bf2234$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $f5ccfeeb9f5f9e5b$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $46c050f070de7192$export$2c14ff85d6318973),
    formatLong: (0, $a4ff35e2116789e5$export$cbf60ecb96cbb82f),
    formatRelative: (0, $c2dfc3feb8c9ca62$export$8fbbfd65594f46a0),
    localize: (0, $933264d81cc45273$export$b3bd0bc58e36cd63),
    match: (0, $e8f2c276e9bf2234$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$f5ccfeeb9f5f9e5b$export$2e2bcd8739ae039 = $f5ccfeeb9f5f9e5b$export$137380d9ce54f7f;





function $f267ae5ef0b6b4f4$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$f267ae5ef0b6b4f4$export$2e2bcd8739ae039 = $f267ae5ef0b6b4f4$export$f91e89d3d0406102;



function $342ad09d2ad950ea$export$d3b42cd8452deec(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $df2b8c65fdff64db$export$4a02e9c37dab4871)(_date, (0, $f267ae5ef0b6b4f4$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$342ad09d2ad950ea$export$2e2bcd8739ae039 = $342ad09d2ad950ea$export$d3b42cd8452deec;







function $170fa77f96b2c9a8$export$42c81a444fbfb5d4(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $12d71c9d27432461$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$170fa77f96b2c9a8$export$2e2bcd8739ae039 = $170fa77f96b2c9a8$export$42c81a444fbfb5d4;


function $0fb5b102e13a62aa$export$6173213f95a4431e(date, options) {
    return (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(date, (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$0fb5b102e13a62aa$export$2e2bcd8739ae039 = $0fb5b102e13a62aa$export$6173213f95a4431e;






function $d9156cbbcbf4a68a$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $0fb5b102e13a62aa$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $0fb5b102e13a62aa$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$d9156cbbcbf4a68a$export$2e2bcd8739ae039 = $d9156cbbcbf4a68a$export$3dbc52535f6f8fcc;



function $34c3414c9b053a91$export$236bdfa374eb69a9(date, options) {
    const year = (0, $d9156cbbcbf4a68a$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $0fb5b102e13a62aa$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$34c3414c9b053a91$export$2e2bcd8739ae039 = $34c3414c9b053a91$export$236bdfa374eb69a9;



function $98028344a9fe549c$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $0fb5b102e13a62aa$export$6173213f95a4431e)(_date) - +(0, $34c3414c9b053a91$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $99f21587b7d92456$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$98028344a9fe549c$export$2e2bcd8739ae039 = $98028344a9fe549c$export$7cabdc5698b63e2f;











function $7883ecd847cd3b36$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $12d71c9d27432461$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const firstWeekOfNextYear = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$7883ecd847cd3b36$export$2e2bcd8739ae039 = $7883ecd847cd3b36$export$12d572480ceb6e58;



function $82bb14df71407538$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $12d71c9d27432461$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const year = (0, $7883ecd847cd3b36$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$82bb14df71407538$export$2e2bcd8739ae039 = $82bb14df71407538$export$bb7b45bb8e74da0f;



function $88fcf406e8c91795$export$efe19b760242b2fc(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(_date, options) - +(0, $82bb14df71407538$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $99f21587b7d92456$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$88fcf406e8c91795$export$2e2bcd8739ae039 = $88fcf406e8c91795$export$efe19b760242b2fc;



function $5346b967f45db9d3$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $45de1bb7cc0c5ca2$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $5346b967f45db9d3$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $d690f73779d4aa46$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $d690f73779d4aa46$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $7883ecd847cd3b36$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $d9156cbbcbf4a68a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $88fcf406e8c91795$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $98028344a9fe549c$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $342ad09d2ad950ea$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d690f73779d4aa46$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d690f73779d4aa46$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d690f73779d4aa46$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d690f73779d4aa46$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d690f73779d4aa46$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d690f73779d4aa46$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $45de1bb7cc0c5ca2$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d690f73779d4aa46$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $d690f73779d4aa46$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d690f73779d4aa46$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d690f73779d4aa46$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $d690f73779d4aa46$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d690f73779d4aa46$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d690f73779d4aa46$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d690f73779d4aa46$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d690f73779d4aa46$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d690f73779d4aa46$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $5346b967f45db9d3$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $d690f73779d4aa46$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $5346b967f45db9d3$export$c8306e720e213c0f)(minutes, 2);
}
function $d690f73779d4aa46$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $5346b967f45db9d3$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $d690f73779d4aa46$var$formatTimezone(offset, delimiter);
}
function $d690f73779d4aa46$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $5346b967f45db9d3$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $5346b967f45db9d3$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $2fbbd517a742d8c5$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $2fbbd517a742d8c5$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $2fbbd517a742d8c5$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $2fbbd517a742d8c5$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $2fbbd517a742d8c5$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $2fbbd517a742d8c5$var$timeLongFormatter(timePattern, formatLong));
};
const $2fbbd517a742d8c5$export$70cc8fd02856fd58 = {
    p: $2fbbd517a742d8c5$var$timeLongFormatter,
    P: $2fbbd517a742d8c5$var$dateTimeLongFormatter
};


const $81a49b0aab544281$var$dayOfYearTokenRE = /^D+$/;
const $81a49b0aab544281$var$weekYearTokenRE = /^Y+$/;
const $81a49b0aab544281$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $81a49b0aab544281$export$c6cc36aa33304772(token) {
    return $81a49b0aab544281$var$dayOfYearTokenRE.test(token);
}
function $81a49b0aab544281$export$c6b49d6dceb604a1(token) {
    return $81a49b0aab544281$var$weekYearTokenRE.test(token);
}
function $81a49b0aab544281$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $81a49b0aab544281$var$message(token, format, input);
    console.warn(_message);
    if ($81a49b0aab544281$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $81a49b0aab544281$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $75400cbf6bf2962b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$75400cbf6bf2962b$export$2e2bcd8739ae039 = $75400cbf6bf2962b$export$871608497c498473;



function $ec86a50135f8674b$export$1ea939691cdc45b8(date) {
    return !(!(0, $75400cbf6bf2962b$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $f620a93511abfab4$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$ec86a50135f8674b$export$2e2bcd8739ae039 = $ec86a50135f8674b$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $01941d183f2645a8$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $01941d183f2645a8$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $01941d183f2645a8$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $01941d183f2645a8$var$doubleQuoteRegExp = /''/g;
const $01941d183f2645a8$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $01941d183f2645a8$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const defaultOptions = (0, $12d71c9d27432461$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $f5ccfeeb9f5f9e5b$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    const originalDate = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $ec86a50135f8674b$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($01941d183f2645a8$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $2fbbd517a742d8c5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($01941d183f2645a8$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $01941d183f2645a8$var$cleanEscapedString(substring)
        };
        if ((0, $d690f73779d4aa46$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($01941d183f2645a8$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $81a49b0aab544281$export$c6b49d6dceb604a1)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $81a49b0aab544281$export$c6cc36aa33304772)(token)) (0, $81a49b0aab544281$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $d690f73779d4aa46$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $01941d183f2645a8$var$cleanEscapedString(input) {
    const matched = input.match($01941d183f2645a8$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($01941d183f2645a8$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$01941d183f2645a8$export$2e2bcd8739ae039 = $01941d183f2645a8$export$d9468344d3651243;


function $9c36629740f820b2$export$1b64bc9c5306ed54(date, options) {
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDay();
}
var // Fallback for modularized imports:
$9c36629740f820b2$export$2e2bcd8739ae039 = $9c36629740f820b2$export$1b64bc9c5306ed54;


function $bda6db0cdfc5a459$export$257b40f71c07d58f(date, options) {
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getHours();
}
var // Fallback for modularized imports:
$bda6db0cdfc5a459$export$2e2bcd8739ae039 = $bda6db0cdfc5a459$export$257b40f71c07d58f;


function $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145(date, options) {
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getMinutes();
}
var // Fallback for modularized imports:
$65367f09ef3b0fcd$export$2e2bcd8739ae039 = $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145;


function $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b(date, options) {
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getMonth();
}
var // Fallback for modularized imports:
$12bcf4c82ebf2e01$export$2e2bcd8739ae039 = $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b;


function $dba88d0d1ade6ede$export$de90a4bb31c25221(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
var // Fallback for modularized imports:
$dba88d0d1ade6ede$export$2e2bcd8739ae039 = $dba88d0d1ade6ede$export$de90a4bb31c25221;


function $9b5188e8ef63b656$export$5e9417507ff28427(date) {
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date).getSeconds();
}
var // Fallback for modularized imports:
$9b5188e8ef63b656$export$2e2bcd8739ae039 = $9b5188e8ef63b656$export$5e9417507ff28427;


function $9492c9f664b3a98c$export$5846dc2d57a5c860(date, options) {
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getFullYear();
}
var // Fallback for modularized imports:
$9492c9f664b3a98c$export$2e2bcd8739ae039 = $9492c9f664b3a98c$export$5846dc2d57a5c860;


function $dcd5a7c05c821292$export$e4de839670987035(date, dateToCompare) {
    return +(0, $f620a93511abfab4$export$e67a095c620b86fe)(date) > +(0, $f620a93511abfab4$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$dcd5a7c05c821292$export$2e2bcd8739ae039 = $dcd5a7c05c821292$export$e4de839670987035;


function $47e0b58359a22142$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $f620a93511abfab4$export$e67a095c620b86fe)(date) < +(0, $f620a93511abfab4$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$47e0b58359a22142$export$2e2bcd8739ae039 = $47e0b58359a22142$export$5c007e10c6929c95;


function $79cf663451f45a9b$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $f620a93511abfab4$export$e67a095c620b86fe)(leftDate) === +(0, $f620a93511abfab4$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$79cf663451f45a9b$export$2e2bcd8739ae039 = $79cf663451f45a9b$export$248d38f6296296c5;



function $19210918fbdc0c95$export$5c60e4190867161c(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $67190bcef07f011e$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return +(0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(dateLeft_) === +(0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(dateRight_);
}
var // Fallback for modularized imports:
$19210918fbdc0c95$export$2e2bcd8739ae039 = $19210918fbdc0c95$export$5c60e4190867161c;






function $36ae097b967697b1$export$430a3269e24b912e() {
    return Object.assign({}, (0, $12d71c9d27432461$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$36ae097b967697b1$export$2e2bcd8739ae039 = $36ae097b967697b1$export$430a3269e24b912e;






function $dda4da48022bd597$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $dda4da48022bd597$var$isConstructor(constructor) ? new constructor(0) : (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $dda4da48022bd597$var$isConstructor(constructor) {
    var _constructor_prototype;
    return typeof constructor === "function" && ((_constructor_prototype = constructor.prototype) === null || _constructor_prototype === void 0 ? void 0 : _constructor_prototype.constructor) === constructor;
}
var // Fallback for modularized imports:
$dda4da48022bd597$export$2e2bcd8739ae039 = $dda4da48022bd597$export$9cb09a71b7d66923;


const $5d0de32c60bc4394$var$TIMEZONE_UNIT_PRIORITY = 10;
class $5d0de32c60bc4394$export$81d53e3678089a6 {
    validate(_utcDate, _options) {
        return true;
    }
    constructor(){
        (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "subPriority", 0);
    }
}
class $5d0de32c60bc4394$export$9a09e32dd4990fd5 extends $5d0de32c60bc4394$export$81d53e3678089a6 {
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
}
class $5d0de32c60bc4394$export$8be15fe85ad72f86 extends $5d0de32c60bc4394$export$81d53e3678089a6 {
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(date, (0, $dda4da48022bd597$export$9cb09a71b7d66923)(date, this.context));
    }
    constructor(context, reference){
        super(), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", $5d0de32c60bc4394$var$TIMEZONE_UNIT_PRIORITY), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "subPriority", -1);
        this.context = context || ((date)=>(0, $986d131a6bdc7bf2$export$ead8a1812b171991)(reference, date));
    }
}




class $da634dba8855879a$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $5d0de32c60bc4394$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $0c84633b5eb97602$export$8e5a1d3f85a9688 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 140), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
    }
}





const $cd9ec6402d14cbba$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $cd9ec6402d14cbba$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $54312eeef9655309$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $54312eeef9655309$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $54312eeef9655309$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $99f21587b7d92456$export$7f72910d6dfd237a) + minutes * (0, $99f21587b7d92456$export$91246f0b9bd9beff) + seconds * (0, $99f21587b7d92456$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $54312eeef9655309$export$d931c43c4608a164(dateString) {
    return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $54312eeef9655309$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $54312eeef9655309$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $54312eeef9655309$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $54312eeef9655309$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $54312eeef9655309$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $54312eeef9655309$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $37ac39c5bc5a9990$export$48d352de7cd4a988 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $54312eeef9655309$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 130), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}







class $d7a879d91b443d0c$export$b8ef38dfcf05d5db extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $7883ecd847cd3b36$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $54312eeef9655309$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(date, options);
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 130), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
    }
}







class $3c9d0016b2e0d508$export$951d1df011fde06f extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        if (token === "R") return (0, $54312eeef9655309$export$2c9307b2e29c533c)(4, dateString);
        return (0, $54312eeef9655309$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $0fb5b102e13a62aa$export$6173213f95a4431e)(firstWeekOfYear);
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 130), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $a85700c6b46ae570$export$bad9d2ea38e8f1a extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        if (token === "u") return (0, $54312eeef9655309$export$2c9307b2e29c533c)(4, dateString);
        return (0, $54312eeef9655309$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 130), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $eb943df2a1f1f3c7$export$5cb0f701186dde1d extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 120), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $7fca5a7c8f3e308b$export$300c0c2990e20e6d extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 120), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






class $923bfcc6c28bf51d$export$400dd8b40ef138a3 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 110);
    }
}






class $576956c6faf8f215$export$1d7eaa53eaa5deba extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 110), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





function $7986af05ae4e2e43$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $88fcf406e8c91795$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $f620a93511abfab4$export$e67a095c620b86fe)(date_, options === null || options === void 0 ? void 0 : options.in);
}
var // Fallback for modularized imports:
$7986af05ae4e2e43$export$2e2bcd8739ae039 = $7986af05ae4e2e43$export$4b3066ce4afafd88;






class $0921a6d43d153a64$export$c4005ffc174e07c0 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)((0, $7986af05ae4e2e43$export$4b3066ce4afafd88)(date, value, options), options);
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 100), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
    }
}





function $0bd00bcfd12c9ab6$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $98028344a9fe549c$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$0bd00bcfd12c9ab6$export$2e2bcd8739ae039 = $0bd00bcfd12c9ab6$export$6542bebf6be94082;






class $ca1389d3d838ec54$export$6fc8dbedd560a6af extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $0fb5b102e13a62aa$export$6173213f95a4431e)((0, $0bd00bcfd12c9ab6$export$6542bebf6be94082)(date, value));
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 100), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






const $94b59c5e1c52bf47$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $94b59c5e1c52bf47$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $94b59c5e1c52bf47$export$e8d4b28a20981dd2 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $54312eeef9655309$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $94b59c5e1c52bf47$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $94b59c5e1c52bf47$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 90), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "subPriority", 1), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






class $32d45e6b962ae3d9$export$6cfe0d613455f615 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $54312eeef9655309$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 90), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "subpriority", 1), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






function $cb9e3552df4670b1$export$b04fdcda82decc6c(date, day, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $12d71c9d27432461$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const date_ = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$cb9e3552df4670b1$export$2e2bcd8739ae039 = $cb9e3552df4670b1$export$b04fdcda82decc6c;



class $d5d074da1ddb61f8$export$1b03c8b76262f7bd extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $cb9e3552df4670b1$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 90), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






class $b9c04d0b495fbd7c$export$44d1c127ab42c480 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $cb9e3552df4670b1$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 90), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
    }
}






class $6ae497d002cf2d59$export$e447a647caaaec1d extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $cb9e3552df4670b1$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 90), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
    }
}





function $84ee524944598a2e$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$84ee524944598a2e$export$2e2bcd8739ae039 = $84ee524944598a2e$export$c514f4c1a8ed5e9e;



function $efe2ad65055b00e8$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentDay = (0, $84ee524944598a2e$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$efe2ad65055b00e8$export$2e2bcd8739ae039 = $efe2ad65055b00e8$export$1fd9df65adb0d1aa;




class $f6bd8ba15bc7d9ca$export$693fb1e525095b2a extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $54312eeef9655309$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $efe2ad65055b00e8$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 90), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $47377995af2eba68$export$8d1e08492351df91 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $54312eeef9655309$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 80), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
    }
}





class $19704be7b0e3da7f$export$73ca2bd0a17d273 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $54312eeef9655309$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 80), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
    }
}





class $8c40a402ea48f2e3$export$bb9212adf05373db extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $54312eeef9655309$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 80), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
    }
}






class $53aab4d671f741e1$export$8a04050a727a1756 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 70), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
    }
}






class $0e9df6bf3ae1d01b$export$e56f4dea2c3e56dd extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 70), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
    }
}






class $8694628409766d73$export$cbbe855312f87d77 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 70), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
    }
}






class $8b19d66c9ab84f45$export$6008046d2b34b6a5 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 70), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
    }
}






class $d1510394626c4703$export$2b52670d9e2be53 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 60), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T"
        ]);
    }
}






class $9a9e561a2b221938$export$94d46d540cf1366a extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $54312eeef9655309$export$cc7cc9e2a3ff9388)((0, $cd9ec6402d14cbba$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 50), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T"
        ]);
    }
}





class $3178cd6af1e242a9$export$b8e6f8b2d70893b1 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $54312eeef9655309$export$4f84e3a82c7b538)((0, $54312eeef9655309$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 30), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T"
        ]);
    }
}








class $0960b0bf6c32c055$export$104d901d49fea29b extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(date, date.getTime() - (0, $6aca57f4bdeccff7$export$113002b5eff6e430)(date) - value);
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 10), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
    }
}








class $12b3e37789fe9f6d$export$12910e5204b52b9 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $54312eeef9655309$export$6497f4c0ecdfba8e)((0, $cd9ec6402d14cbba$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(date, date.getTime() - (0, $6aca57f4bdeccff7$export$113002b5eff6e430)(date) - value);
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 10), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
    }
}






class $a1644b39e7438137$export$2cd8bf877a05e96 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString) {
        return (0, $54312eeef9655309$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 40), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", "*");
    }
}






class $099c4cc3ba173e02$export$6d8f69c6906d6368 extends (0, $da634dba8855879a$export$7acfa6ed01010e37) {
    parse(dateString) {
        return (0, $54312eeef9655309$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    constructor(...args){
        super(...args), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "priority", 20), (0, $36e600d4bd8d4d58$export$71511d61b312f219)(this, "incompatibleTokens", "*");
    }
}


const $e1cf23b489c74563$export$19131010e7fd8373 = {
    G: new (0, $0c84633b5eb97602$export$8e5a1d3f85a9688)(),
    y: new (0, $37ac39c5bc5a9990$export$48d352de7cd4a988)(),
    Y: new (0, $d7a879d91b443d0c$export$b8ef38dfcf05d5db)(),
    R: new (0, $3c9d0016b2e0d508$export$951d1df011fde06f)(),
    u: new (0, $a85700c6b46ae570$export$bad9d2ea38e8f1a)(),
    Q: new (0, $eb943df2a1f1f3c7$export$5cb0f701186dde1d)(),
    q: new (0, $7fca5a7c8f3e308b$export$300c0c2990e20e6d)(),
    M: new (0, $923bfcc6c28bf51d$export$400dd8b40ef138a3)(),
    L: new (0, $576956c6faf8f215$export$1d7eaa53eaa5deba)(),
    w: new (0, $0921a6d43d153a64$export$c4005ffc174e07c0)(),
    I: new (0, $ca1389d3d838ec54$export$6fc8dbedd560a6af)(),
    d: new (0, $94b59c5e1c52bf47$export$e8d4b28a20981dd2)(),
    D: new (0, $32d45e6b962ae3d9$export$6cfe0d613455f615)(),
    E: new (0, $d5d074da1ddb61f8$export$1b03c8b76262f7bd)(),
    e: new (0, $b9c04d0b495fbd7c$export$44d1c127ab42c480)(),
    c: new (0, $6ae497d002cf2d59$export$e447a647caaaec1d)(),
    i: new (0, $f6bd8ba15bc7d9ca$export$693fb1e525095b2a)(),
    a: new (0, $47377995af2eba68$export$8d1e08492351df91)(),
    b: new (0, $19704be7b0e3da7f$export$73ca2bd0a17d273)(),
    B: new (0, $8c40a402ea48f2e3$export$bb9212adf05373db)(),
    h: new (0, $53aab4d671f741e1$export$8a04050a727a1756)(),
    H: new (0, $0e9df6bf3ae1d01b$export$e56f4dea2c3e56dd)(),
    K: new (0, $8694628409766d73$export$cbbe855312f87d77)(),
    k: new (0, $8b19d66c9ab84f45$export$6008046d2b34b6a5)(),
    m: new (0, $d1510394626c4703$export$2b52670d9e2be53)(),
    s: new (0, $9a9e561a2b221938$export$94d46d540cf1366a)(),
    S: new (0, $3178cd6af1e242a9$export$b8e6f8b2d70893b1)(),
    X: new (0, $0960b0bf6c32c055$export$104d901d49fea29b)(),
    x: new (0, $12b3e37789fe9f6d$export$12910e5204b52b9)(),
    t: new (0, $a1644b39e7438137$export$2cd8bf877a05e96)(),
    T: new (0, $099c4cc3ba173e02$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $03469413ea88cde3$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $03469413ea88cde3$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $03469413ea88cde3$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $03469413ea88cde3$var$doubleQuoteRegExp = /''/g;
const $03469413ea88cde3$var$notWhitespaceRegExp = /\S/;
const $03469413ea88cde3$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $03469413ea88cde3$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const invalidDate = ()=>(0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || referenceDate, NaN);
    const defaultOptions = (0, $36ae097b967697b1$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $f5ccfeeb9f5f9e5b$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $f620a93511abfab4$export$e67a095c620b86fe)(referenceDate, options === null || options === void 0 ? void 0 : options.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $5d0de32c60bc4394$export$8be15fe85ad72f86)(options === null || options === void 0 ? void 0 : options.in, referenceDate)
    ];
    const tokens = formatStr.match($03469413ea88cde3$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $2fbbd517a742d8c5$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $2fbbd517a742d8c5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($03469413ea88cde3$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $81a49b0aab544281$export$c6b49d6dceb604a1)(token)) (0, $81a49b0aab544281$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $81a49b0aab544281$export$c6cc36aa33304772)(token)) (0, $81a49b0aab544281$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $e1cf23b489c74563$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($03469413ea88cde3$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $03469413ea88cde3$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $03469413ea88cde3$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(referenceDate, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $03469413ea88cde3$var$cleanEscapedString(input) {
    return input.match($03469413ea88cde3$var$escapedStringRegExp)[1].replace($03469413ea88cde3$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$03469413ea88cde3$export$2e2bcd8739ae039 = $03469413ea88cde3$export$98e6a39c04603d36;





function $7794a6ebeb440aea$export$f645ddd439eb259d(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$7794a6ebeb440aea$export$2e2bcd8739ae039 = $7794a6ebeb440aea$export$f645ddd439eb259d;



function $cb69da7c2897a9a2$export$63264690f8e36790(date, month, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $7794a6ebeb440aea$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$cb69da7c2897a9a2$export$2e2bcd8739ae039 = $cb69da7c2897a9a2$export$63264690f8e36790;



function $75b278507b3aec9b$export$adaa4cf7ef1b65be(date, values, options) {
    let _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $cb69da7c2897a9a2$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$75b278507b3aec9b$export$2e2bcd8739ae039 = $75b278507b3aec9b$export$adaa4cf7ef1b65be;


function $efcd4b8754d66c54$export$f86b797a4659b781(date, hours, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$efcd4b8754d66c54$export$2e2bcd8739ae039 = $efcd4b8754d66c54$export$f86b797a4659b781;


function $c04bdab14a36bbee$export$de5664029b35e06d(date, milliseconds, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setMilliseconds(milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$c04bdab14a36bbee$export$2e2bcd8739ae039 = $c04bdab14a36bbee$export$de5664029b35e06d;


function $655f07559cbeee6b$export$ad569bf1c79ea89d(date, minutes, options) {
    const date_ = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setMinutes(minutes);
    return date_;
}
var // Fallback for modularized imports:
$655f07559cbeee6b$export$2e2bcd8739ae039 = $655f07559cbeee6b$export$ad569bf1c79ea89d;


function $9c3b4b128b324703$export$aec44746644cbf43(date, seconds, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$9c3b4b128b324703$export$2e2bcd8739ae039 = $9c3b4b128b324703$export$aec44746644cbf43;



function $1a44633bf27f1eed$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$1a44633bf27f1eed$export$2e2bcd8739ae039 = $1a44633bf27f1eed$export$a8408b6c5639cab7;


function $5e4e79e465beac30$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $f620a93511abfab4$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$5e4e79e465beac30$export$2e2bcd8739ae039 = $5e4e79e465beac30$export$a5a3b454ada2268e;



function $c04cb5849bd465df$export$70823084e2deb1ea(date, amount, options) {
    return (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$c04cb5849bd465df$export$2e2bcd8739ae039 = $c04cb5849bd465df$export$70823084e2deb1ea;



function $68126b797c1a3763$export$73d1c15a21f9fae5(date, amount, options) {
    return (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(date, -amount, options);
}
var // Fallback for modularized imports:
$68126b797c1a3763$export$2e2bcd8739ae039 = $68126b797c1a3763$export$73d1c15a21f9fae5;


function $2caa7e79af8b5dd3$export$f93b5905241a7cca(date, duration, options) {
    const { years: years = 0, months: months = 0, weeks: weeks = 0, days: days = 0, hours: hours = 0, minutes: minutes = 0, seconds: seconds = 0 } = duration;
    const withoutMonths = (0, $68126b797c1a3763$export$73d1c15a21f9fae5)(date, months + years * 12, options);
    const withoutDays = (0, $c04cb5849bd465df$export$70823084e2deb1ea)(withoutMonths, days + weeks * 7, options);
    const minutesToSub = minutes + hours * 60;
    const secondsToSub = seconds + minutesToSub * 60;
    const msToSub = secondsToSub * 1000;
    return (0, $986d131a6bdc7bf2$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, +withoutDays - msToSub);
}
var // Fallback for modularized imports:
$2caa7e79af8b5dd3$export$2e2bcd8739ae039 = $2caa7e79af8b5dd3$export$f93b5905241a7cca;


function $79cf7001ad263c02$export$14867687ff6c92e2(date, amount, options) {
    return (0, $0592f6ea6313b650$export$3d83eec43f4ea476)(date, -amount, options);
}
var // Fallback for modularized imports:
$79cf7001ad263c02$export$2e2bcd8739ae039 = $79cf7001ad263c02$export$14867687ff6c92e2;


function $f93880154c0ab2a4$var$jt() {
    const e = (0, $cc75f711ea0318a4$exports.useAttrs)();
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, e), [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
        }),
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
        }),
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
        }),
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
        })
    ]);
}
$f93880154c0ab2a4$var$jt.compatConfig = {
    MODE: 3
};
function $f93880154c0ab2a4$var$Sn() {
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
        }),
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
        })
    ]);
}
$f93880154c0ab2a4$var$Sn.compatConfig = {
    MODE: 3
};
function $f93880154c0ab2a4$var$Ua() {
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
        })
    ]);
}
$f93880154c0ab2a4$var$Ua.compatConfig = {
    MODE: 3
};
function $f93880154c0ab2a4$var$Va() {
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
        })
    ]);
}
$f93880154c0ab2a4$var$Va.compatConfig = {
    MODE: 3
};
function $f93880154c0ab2a4$var$ja() {
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
        }),
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
        })
    ]);
}
$f93880154c0ab2a4$var$ja.compatConfig = {
    MODE: 3
};
function $f93880154c0ab2a4$var$Ka() {
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
        })
    ]);
}
$f93880154c0ab2a4$var$Ka.compatConfig = {
    MODE: 3
};
function $f93880154c0ab2a4$var$Ga() {
    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "currentColor",
        "aria-hidden": "true",
        class: "dp__icon",
        role: "img"
    }, [
        (0, $cc75f711ea0318a4$exports.createElementVNode)("path", {
            d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
        })
    ]);
}
$f93880154c0ab2a4$var$Ga.compatConfig = {
    MODE: 3
};
const $f93880154c0ab2a4$var$Ze = (e, t)=>t ? new Date(e.toLocaleString("en-US", {
        timeZone: t
    })) : new Date(e), $f93880154c0ab2a4$var$Qa = (e, t, l)=>{
    const n = $f93880154c0ab2a4$var$La(e, t, l);
    return n || $f93880154c0ab2a4$var$H();
}, $f93880154c0ab2a4$var$wl = (e, t, l)=>{
    const n = t.dateInTz ? $f93880154c0ab2a4$var$Ze(new Date(e), t.dateInTz) : $f93880154c0ab2a4$var$H(e);
    return l ? $f93880154c0ab2a4$var$Fe(n, !0) : n;
}, $f93880154c0ab2a4$var$La = (e, t, l)=>{
    if (!e) return null;
    const n = l ? $f93880154c0ab2a4$var$Fe($f93880154c0ab2a4$var$H(e), !0) : $f93880154c0ab2a4$var$H(e);
    return t ? t.exactMatch ? $f93880154c0ab2a4$var$wl(e, t, l) : $f93880154c0ab2a4$var$Ze(n, t.timezone) : n;
}, $f93880154c0ab2a4$var$Dl = (e)=>{
    const l = new Date(e.getFullYear(), 0, 1).getTimezoneOffset();
    return e.getTimezoneOffset() < l;
}, $f93880154c0ab2a4$var$Ml = (e, t)=>{
    if (!e) return 0;
    const l = /* @__PURE__ */ new Date(), n = new Date(l.toLocaleString("en-US", {
        timeZone: "UTC"
    })), a = new Date(l.toLocaleString("en-US", {
        timeZone: e
    })), i = ($f93880154c0ab2a4$var$Dl(t !== null && t !== void 0 ? t : a) ? a : t !== null && t !== void 0 ? t : a).getTimezoneOffset() / 60;
    return (+n - +a) / 3600000 - i;
};
var $f93880154c0ab2a4$var$ot = /* @__PURE__ */ ((e)=>(e.month = "month", e.year = "year", e))($f93880154c0ab2a4$var$ot || {}), $f93880154c0ab2a4$var$st = /* @__PURE__ */ ((e)=>(e.top = "top", e.bottom = "bottom", e))($f93880154c0ab2a4$var$st || {}), $f93880154c0ab2a4$var$Ot = /* @__PURE__ */ ((e)=>(e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))($f93880154c0ab2a4$var$Ot || {}), $f93880154c0ab2a4$var$je = /* @__PURE__ */ ((e)=>(e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))($f93880154c0ab2a4$var$je || {});
const $f93880154c0ab2a4$var$$l = [
    "timestamp",
    "date",
    "iso"
];
var $f93880154c0ab2a4$var$Qe = /* @__PURE__ */ ((e)=>(e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))($f93880154c0ab2a4$var$Qe || {}), $f93880154c0ab2a4$var$Re = /* @__PURE__ */ ((e)=>(e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))($f93880154c0ab2a4$var$Re || {}), $f93880154c0ab2a4$var$Lt = /* @__PURE__ */ ((e)=>(e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))($f93880154c0ab2a4$var$Lt || {});
function $f93880154c0ab2a4$var$un(e) {
    return (t)=>{
        const l = new Intl.DateTimeFormat(e, {
            weekday: "short",
            timeZone: "UTC"
        }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`));
        return e === "ar" ? l.slice(2, 5) : l.slice(0, 2);
    };
}
function $f93880154c0ab2a4$var$Al(e) {
    return (t)=>(0, $01941d183f2645a8$export$d9468344d3651243)($f93880154c0ab2a4$var$Ze(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", {
            locale: e
        });
}
const $f93880154c0ab2a4$var$Tl = (e, t, l)=>{
    const n = [
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ];
    let a;
    if (e !== null) try {
        a = n.map($f93880154c0ab2a4$var$Al(e));
    } catch (e) {
        a = n.map($f93880154c0ab2a4$var$un(t));
    }
    else a = n.map($f93880154c0ab2a4$var$un(t));
    const f = a.slice(0, l), i = a.slice(l + 1, a.length);
    return [
        a[l]
    ].concat(...i).concat(...f);
}, $f93880154c0ab2a4$var$qa = (e, t, l)=>{
    const n = [];
    for(let a = +e[0]; a <= +e[1]; a++)n.push({
        value: +a,
        text: $f93880154c0ab2a4$var$Ja(a, t)
    });
    return l ? n.reverse() : n;
}, $f93880154c0ab2a4$var$Pn = (e, t, l)=>{
    const n = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ].map((f)=>{
        const i = f < 10 ? `0${f}` : f;
        return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
    });
    if (e !== null) try {
        const f = l === "long" ? "LLLL" : "LLL";
        return n.map((i, g)=>{
            const d = (0, $01941d183f2645a8$export$d9468344d3651243)($f93880154c0ab2a4$var$Ze(i, "UTC"), f, {
                locale: e
            });
            return {
                text: d.charAt(0).toUpperCase() + d.substring(1),
                value: g
            };
        });
    } catch (e) {}
    const a = new Intl.DateTimeFormat(t, {
        month: l,
        timeZone: "UTC"
    });
    return n.map((f, i)=>{
        const g = a.format(f);
        return {
            text: g.charAt(0).toUpperCase() + g.substring(1),
            value: i
        };
    });
}, $f93880154c0ab2a4$var$Sl = (e)=>[
        12,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ][e], $f93880154c0ab2a4$var$Le = (e)=>{
    const t = (0, $cc75f711ea0318a4$exports.unref)(e);
    return (t === null || t === void 0 ? void 0 : t.$el) ? t === null || t === void 0 ? void 0 : t.$el : t;
}, $f93880154c0ab2a4$var$Pl = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        type: "dot"
    }, e !== null && e !== void 0 ? e : {}), $f93880154c0ab2a4$var$Rn = (e)=>Array.isArray(e) ? !!e[0] && !!e[1] : !1, $f93880154c0ab2a4$var$Xa = {
    prop: (e)=>`"${e}" prop must be enabled!`,
    dateArr: (e)=>`You need to use array as "model-value" binding in order to support "${e}"`
}, $f93880154c0ab2a4$var$Ne = (e)=>e, $f93880154c0ab2a4$var$dn = (e)=>e === 0 ? e : !e || isNaN(+e) ? null : +e, $f93880154c0ab2a4$var$cn = (e)=>e === null, $f93880154c0ab2a4$var$Cn = (e)=>{
    if (e) return [
        ...e.querySelectorAll("input, button, select, textarea, a[href]")
    ][0];
}, $f93880154c0ab2a4$var$Rl = (e)=>{
    const t = [], l = (n)=>n.filter((a)=>a);
    for(let n = 0; n < e.length; n += 3){
        const a = [
            e[n],
            e[n + 1],
            e[n + 2]
        ];
        t.push(l(a));
    }
    return t;
}, $f93880154c0ab2a4$var$Zt = (e, t, l)=>{
    const n = l != null, a = t != null;
    if (!n && !a) return !1;
    const f = +l, i = +t;
    return n && a ? +e > f || +e < i : n ? +e > f : a ? +e < i : !1;
}, $f93880154c0ab2a4$var$Ht = (e, t)=>$f93880154c0ab2a4$var$Rl(e).map((l)=>l.map((n)=>{
            const { active: a, disabled: f, isBetween: i, highlighted: g } = t(n);
            return (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, n), {
                active: a,
                disabled: f,
                className: {
                    dp__overlay_cell_active: a,
                    dp__overlay_cell: !a,
                    dp__overlay_cell_disabled: f,
                    dp__overlay_cell_pad: !0,
                    dp__overlay_cell_active_disabled: f && a,
                    dp__cell_in_between: i,
                    "dp--highlighted": g
                }
            });
        })), $f93880154c0ab2a4$var$Dt = (e, t, l = !1)=>{
    e && t.allowStopPropagation && (l && e.stopImmediatePropagation(), e.stopPropagation());
}, $f93880154c0ab2a4$var$Cl = ()=>[
        "a[href]",
        "area[href]",
        "input:not([disabled]):not([type='hidden'])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "button:not([disabled])",
        "[tabindex]:not([tabindex='-1'])",
        "[data-datepicker-instance]"
    ].join(", ");
function $f93880154c0ab2a4$var$Ol(e, t) {
    let l = [
        ...document.querySelectorAll($f93880154c0ab2a4$var$Cl())
    ];
    l = l.filter((a)=>!e.contains(a) || a.hasAttribute("data-datepicker-instance"));
    const n = l.indexOf(e);
    if (n >= 0 && (t ? n - 1 >= 0 : n + 1 <= l.length)) return l[n + (t ? -1 : 1)];
}
const $f93880154c0ab2a4$var$Fa = (e, t)=>e === null || e === void 0 ? void 0 : e.querySelector(`[data-dp-element="${t}"]`), $f93880154c0ab2a4$var$Ja = (e, t)=>new Intl.NumberFormat(t, {
        useGrouping: !1,
        style: "decimal"
    }).format(e), $f93880154c0ab2a4$var$Za = (e, t)=>(0, $01941d183f2645a8$export$d9468344d3651243)(e, t !== null && t !== void 0 ? t : $f93880154c0ab2a4$var$Lt.DATE), $f93880154c0ab2a4$var$Ta = (e)=>Array.isArray(e), $f93880154c0ab2a4$var$ca = (e, t, l)=>t.get($f93880154c0ab2a4$var$Za(e, l)), $f93880154c0ab2a4$var$Bl = (e, t)=>e ? t ? t instanceof Map ? !!$f93880154c0ab2a4$var$ca(e, t) : t($f93880154c0ab2a4$var$H(e)) : !1 : !0, $f93880154c0ab2a4$var$qe = (e, t, l = !1, n)=>{
    if (e.key === $f93880154c0ab2a4$var$Re.enter || e.key === $f93880154c0ab2a4$var$Re.space) return l && e.preventDefault(), t();
    if (n) return n(e);
}, $f93880154c0ab2a4$var$_l = ()=>"ontouchstart" in window || navigator.maxTouchPoints > 0, $f93880154c0ab2a4$var$On = (e, t)=>e ? $f93880154c0ab2a4$var$Lt.MONTH_AND_YEAR : t ? $f93880154c0ab2a4$var$Lt.YEAR : $f93880154c0ab2a4$var$Lt.DATE, $f93880154c0ab2a4$var$Bn = (e)=>e < 10 ? `0${e}` : e, $f93880154c0ab2a4$var$fn = (e, t, l, n, a, f)=>{
    const i = (0, $03469413ea88cde3$export$98e6a39c04603d36)(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), {
        locale: f
    });
    return (0, $ec86a50135f8674b$export$1ea939691cdc45b8)(i) && (0, $75400cbf6bf2962b$export$871608497c498473)(i) ? n || a ? i : (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(i, {
        hours: +l.hours,
        minutes: +(l === null || l === void 0 ? void 0 : l.minutes),
        seconds: +(l === null || l === void 0 ? void 0 : l.seconds),
        milliseconds: 0
    }) : null;
}, $f93880154c0ab2a4$var$Yl = (e, t, l, n, a, f)=>{
    const i = Array.isArray(l) ? l[0] : l;
    if (typeof t == "string") return $f93880154c0ab2a4$var$fn(e, t, i, n, a, f);
    if (Array.isArray(t)) {
        let g = null;
        for (const d of t)if (g = $f93880154c0ab2a4$var$fn(e, d, i, n, a, f), g) break;
        return g;
    }
    return typeof t == "function" ? t(e) : null;
}, $f93880154c0ab2a4$var$H = (e)=>e ? new Date(e) : /* @__PURE__ */ new Date(), $f93880154c0ab2a4$var$Il = (e, t, l)=>{
    if (t) {
        const a = (e.getMonth() + 1).toString().padStart(2, "0"), f = e.getDate().toString().padStart(2, "0"), i = e.getHours().toString().padStart(2, "0"), g = e.getMinutes().toString().padStart(2, "0"), d = l ? e.getSeconds().toString().padStart(2, "0") : "00";
        return `${e.getFullYear()}-${a}-${f}T${i}:${g}:${d}.000Z`;
    }
    const n = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds());
    return new Date(n).toISOString();
}, $f93880154c0ab2a4$var$Fe = (e, t)=>{
    const l = $f93880154c0ab2a4$var$H(JSON.parse(JSON.stringify(e))), n = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(l, {
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
    });
    return t ? (0, $5e4e79e465beac30$export$a5a3b454ada2268e)(n) : n;
}, $f93880154c0ab2a4$var$Mt = (e, t, l, n)=>{
    let a = e ? $f93880154c0ab2a4$var$H(e) : $f93880154c0ab2a4$var$H();
    return (t || t === 0) && (a = (0, $efcd4b8754d66c54$export$f86b797a4659b781)(a, +t)), (l || l === 0) && (a = (0, $655f07559cbeee6b$export$ad569bf1c79ea89d)(a, +l)), (n || n === 0) && (a = (0, $9c3b4b128b324703$export$aec44746644cbf43)(a, +n)), (0, $c04bdab14a36bbee$export$de5664029b35e06d)(a, 0);
}, $f93880154c0ab2a4$var$Be = (e, t)=>!e || !t ? !1 : (0, $47e0b58359a22142$export$5c007e10c6929c95)($f93880154c0ab2a4$var$Fe(e), $f93880154c0ab2a4$var$Fe(t)), $f93880154c0ab2a4$var$$e = (e, t)=>!e || !t ? !1 : (0, $79cf663451f45a9b$export$248d38f6296296c5)($f93880154c0ab2a4$var$Fe(e), $f93880154c0ab2a4$var$Fe(t)), $f93880154c0ab2a4$var$Ee = (e, t)=>!e || !t ? !1 : (0, $dcd5a7c05c821292$export$e4de839670987035)($f93880154c0ab2a4$var$Fe(e), $f93880154c0ab2a4$var$Fe(t)), $f93880154c0ab2a4$var$xt = (e, t, l)=>(e === null || e === void 0 ? void 0 : e[0]) && (e === null || e === void 0 ? void 0 : e[1]) ? $f93880154c0ab2a4$var$Ee(l, e[0]) && $f93880154c0ab2a4$var$Be(l, e[1]) : (e === null || e === void 0 ? void 0 : e[0]) && t ? $f93880154c0ab2a4$var$Ee(l, e[0]) && $f93880154c0ab2a4$var$Be(l, t) || $f93880154c0ab2a4$var$Be(l, e[0]) && $f93880154c0ab2a4$var$Ee(l, t) : !1, $f93880154c0ab2a4$var$it = (e)=>{
    const t = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(new Date(e), {
        date: 1
    });
    return $f93880154c0ab2a4$var$Fe(t);
}, $f93880154c0ab2a4$var$Sa = (e, t, l)=>t && (l || l === 0) ? Object.fromEntries([
        "hours",
        "minutes",
        "seconds"
    ].map((n)=>n === t ? [
            n,
            l
        ] : [
            n,
            isNaN(+e[n]) ? void 0 : +e[n]
        ])) : {
        hours: isNaN(+e.hours) ? void 0 : +e.hours,
        minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
        seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
    }, $f93880154c0ab2a4$var$Bt = (e)=>({
        hours: (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)(e),
        minutes: (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145)(e),
        seconds: (0, $9b5188e8ef63b656$export$5e9417507ff28427)(e)
    }), $f93880154c0ab2a4$var$_n = (e, t)=>{
    if (t) {
        const l = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(t));
        if (l > e) return 12;
        if (l === e) return (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)($f93880154c0ab2a4$var$H(t));
    }
}, $f93880154c0ab2a4$var$Yn = (e, t)=>{
    if (t) {
        const l = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(t));
        return l < e ? -1 : l === e ? (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)($f93880154c0ab2a4$var$H(t)) : void 0;
    }
}, $f93880154c0ab2a4$var$Wt = (e)=>{
    if (e) return (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(e));
}, $f93880154c0ab2a4$var$In = (e, t)=>{
    const l = $f93880154c0ab2a4$var$Ee(e, t) ? t : e, n = $f93880154c0ab2a4$var$Ee(t, e) ? t : e;
    return (0, $c9b711093b477e6c$export$7a337e5923c7ceb5)({
        start: l,
        end: n
    });
}, $f93880154c0ab2a4$var$El = (e)=>{
    const t = (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(e, 1);
    return {
        month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(t),
        year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(t)
    };
}, $f93880154c0ab2a4$var$mt = (e, t)=>{
    const l = (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(e, {
        weekStartsOn: +t
    }), n = (0, $8e73e36ac64240db$export$ef8b6d9133084f4e)(e, {
        weekStartsOn: +t
    });
    return [
        l,
        n
    ];
}, $f93880154c0ab2a4$var$En = (e, t)=>{
    const l = {
        hours: (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)($f93880154c0ab2a4$var$H()),
        minutes: (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145)($f93880154c0ab2a4$var$H()),
        seconds: t ? (0, $9b5188e8ef63b656$export$5e9417507ff28427)($f93880154c0ab2a4$var$H()) : 0
    };
    return Object.assign(l, e);
}, $f93880154c0ab2a4$var$wt = (e, t, l)=>[
        (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(e), {
            date: 1
        }),
        (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
            month: t,
            year: l,
            date: 1
        })
    ], $f93880154c0ab2a4$var$pt = (e, t, l)=>{
    let n = e ? $f93880154c0ab2a4$var$H(e) : $f93880154c0ab2a4$var$H();
    return (t || t === 0) && (n = (0, $cb69da7c2897a9a2$export$63264690f8e36790)(n, t)), l && (n = (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)(n, l)), n;
}, $f93880154c0ab2a4$var$Nn = (e, t, l, n, a)=>{
    if (!n || a && !t || !a && !l) return !1;
    const f = a ? (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(e, 1) : (0, $68126b797c1a3763$export$73d1c15a21f9fae5)(e, 1), i = [
        (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(f),
        (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(f)
    ];
    return a ? !$f93880154c0ab2a4$var$Ll(...i, t) : !$f93880154c0ab2a4$var$Nl(...i, l);
}, $f93880154c0ab2a4$var$Nl = (e, t, l)=>$f93880154c0ab2a4$var$Be(...$f93880154c0ab2a4$var$wt(l, e, t)) || $f93880154c0ab2a4$var$$e(...$f93880154c0ab2a4$var$wt(l, e, t)), $f93880154c0ab2a4$var$Ll = (e, t, l)=>$f93880154c0ab2a4$var$Ee(...$f93880154c0ab2a4$var$wt(l, e, t)) || $f93880154c0ab2a4$var$$e(...$f93880154c0ab2a4$var$wt(l, e, t)), $f93880154c0ab2a4$var$Ln = (e, t, l, n, a, f, i)=>{
    if (typeof t == "function" && !i) return t(e);
    const g = l ? {
        locale: l
    } : void 0;
    return Array.isArray(e) ? `${(0, $01941d183f2645a8$export$d9468344d3651243)(e[0], f, g)}${a && !e[1] ? "" : n}${e[1] ? (0, $01941d183f2645a8$export$d9468344d3651243)(e[1], f, g) : ""}` : (0, $01941d183f2645a8$export$d9468344d3651243)(e, f, g);
}, $f93880154c0ab2a4$var$It = (e)=>{
    if (e) return null;
    throw new Error($f93880154c0ab2a4$var$Xa.prop("partial-range"));
}, $f93880154c0ab2a4$var$oa = (e, t)=>{
    if (t) return e();
    throw new Error($f93880154c0ab2a4$var$Xa.prop("range"));
}, $f93880154c0ab2a4$var$za = (e)=>Array.isArray(e) ? (0, $ec86a50135f8674b$export$1ea939691cdc45b8)(e[0]) && (e[1] ? (0, $ec86a50135f8674b$export$1ea939691cdc45b8)(e[1]) : !0) : e ? (0, $ec86a50135f8674b$export$1ea939691cdc45b8)(e) : !1, $f93880154c0ab2a4$var$Fl = (e, t)=>(0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(t !== null && t !== void 0 ? t : $f93880154c0ab2a4$var$H(), {
        hours: +e.hours || 0,
        minutes: +e.minutes || 0,
        seconds: +e.seconds || 0
    }), $f93880154c0ab2a4$var$Pa = (e, t, l, n)=>{
    if (!e) return !0;
    if (n) {
        const a = l === "max" ? (0, $47e0b58359a22142$export$5c007e10c6929c95)(e, t) : (0, $dcd5a7c05c821292$export$e4de839670987035)(e, t), f = {
            seconds: 0,
            milliseconds: 0
        };
        return a || (0, $79cf663451f45a9b$export$248d38f6296296c5)((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(e, f), (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(t, f));
    }
    return l === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, $f93880154c0ab2a4$var$Ra = (e, t, l)=>e ? $f93880154c0ab2a4$var$Fl(e, t) : $f93880154c0ab2a4$var$H(l !== null && l !== void 0 ? l : t), $f93880154c0ab2a4$var$vn = (e, t, l, n, a)=>{
    if (Array.isArray(n)) {
        const i = $f93880154c0ab2a4$var$Ra(e, n[0], t), g = $f93880154c0ab2a4$var$Ra(e, n[1], t);
        return $f93880154c0ab2a4$var$Pa(n[0], i, l, !!t) && $f93880154c0ab2a4$var$Pa(n[1], g, l, !!t) && a;
    }
    const f = $f93880154c0ab2a4$var$Ra(e, n, t);
    return $f93880154c0ab2a4$var$Pa(n, f, l, !!t) && a;
}, $f93880154c0ab2a4$var$Ca = (e)=>(0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), $f93880154c0ab2a4$var$Bt(e)), $f93880154c0ab2a4$var$zl = (e, t, l)=>{
    if (e instanceof Map) {
        const n = `${$f93880154c0ab2a4$var$Bn(l + 1)}-${t}`;
        return e.size ? e.has(n) : !1;
    }
    return typeof e == "function" ? e($f93880154c0ab2a4$var$Fe((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
        month: l,
        year: t
    }), !0)) : !1;
}, $f93880154c0ab2a4$var$Hl = (e, t, l)=>{
    if (e instanceof Map) {
        const n = `${$f93880154c0ab2a4$var$Bn(l + 1)}-${t}`;
        return e.size ? e.has(n) : !0;
    }
    return !0;
}, $f93880154c0ab2a4$var$Fn = (e, t, l)=>typeof e == "function" ? e({
        month: t,
        year: l
    }) : !!e.months.find((n)=>n.month === t && n.year === l), $f93880154c0ab2a4$var$xa = (e, t)=>typeof e == "function" ? e(t) : e.years.includes(t), $f93880154c0ab2a4$var$Ha = (e)=>`dp-${(0, $01941d183f2645a8$export$d9468344d3651243)(e, "yyyy-MM-dd")}`, $f93880154c0ab2a4$var$mn = (e, t)=>{
    const l = (0, $c04cb5849bd465df$export$70823084e2deb1ea)($f93880154c0ab2a4$var$Fe(t), e), n = (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)($f93880154c0ab2a4$var$Fe(t), e);
    return {
        before: l,
        after: n
    };
}, $f93880154c0ab2a4$var$zn = (e, t)=>t < +e[0] || t > +e[1], $f93880154c0ab2a4$var$Kt = (0, $cc75f711ea0318a4$exports.reactive)({
    menuFocused: !1,
    shiftKeyInMenu: !1
}), $f93880154c0ab2a4$var$Hn = ()=>{
    const e = (n)=>{
        $f93880154c0ab2a4$var$Kt.menuFocused = n;
    }, t = (n)=>{
        $f93880154c0ab2a4$var$Kt.shiftKeyInMenu !== n && ($f93880154c0ab2a4$var$Kt.shiftKeyInMenu = n);
    };
    return {
        control: (0, $cc75f711ea0318a4$exports.computed)(()=>({
                shiftKeyInMenu: $f93880154c0ab2a4$var$Kt.shiftKeyInMenu,
                menuFocused: $f93880154c0ab2a4$var$Kt.menuFocused
            })),
        setMenuFocused: e,
        setShiftKey: t
    };
}, $f93880154c0ab2a4$var$Pe = (0, $cc75f711ea0318a4$exports.reactive)({
    monthYear: [],
    calendar: [],
    time: [],
    actionRow: [],
    selectionGrid: [],
    timePicker: {
        0: [],
        1: []
    },
    monthPicker: []
}), $f93880154c0ab2a4$var$Oa = (0, $cc75f711ea0318a4$exports.ref)(null), $f93880154c0ab2a4$var$sa = (0, $cc75f711ea0318a4$exports.ref)(!1), $f93880154c0ab2a4$var$Ba = (0, $cc75f711ea0318a4$exports.ref)(!1), $f93880154c0ab2a4$var$_a = (0, $cc75f711ea0318a4$exports.ref)(!1), $f93880154c0ab2a4$var$Ya = (0, $cc75f711ea0318a4$exports.ref)(!1), $f93880154c0ab2a4$var$Ve = (0, $cc75f711ea0318a4$exports.ref)(0), $f93880154c0ab2a4$var$Ie = (0, $cc75f711ea0318a4$exports.ref)(0), $f93880154c0ab2a4$var$At = ()=>{
    const e = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$sa.value ? [
            ...$f93880154c0ab2a4$var$Pe.selectionGrid,
            $f93880154c0ab2a4$var$Pe.actionRow
        ].filter((M)=>M.length) : $f93880154c0ab2a4$var$Ba.value ? [
            ...$f93880154c0ab2a4$var$Pe.timePicker[0],
            ...$f93880154c0ab2a4$var$Pe.timePicker[1],
            $f93880154c0ab2a4$var$Ya.value ? [] : [
                $f93880154c0ab2a4$var$Oa.value
            ],
            $f93880154c0ab2a4$var$Pe.actionRow
        ].filter((M)=>M.length) : $f93880154c0ab2a4$var$_a.value ? [
            ...$f93880154c0ab2a4$var$Pe.monthPicker,
            $f93880154c0ab2a4$var$Pe.actionRow
        ] : [
            $f93880154c0ab2a4$var$Pe.monthYear,
            ...$f93880154c0ab2a4$var$Pe.calendar,
            $f93880154c0ab2a4$var$Pe.time,
            $f93880154c0ab2a4$var$Pe.actionRow
        ].filter((M)=>M.length)), t = (M)=>{
        $f93880154c0ab2a4$var$Ve.value = M ? $f93880154c0ab2a4$var$Ve.value + 1 : $f93880154c0ab2a4$var$Ve.value - 1;
        let A = null;
        e.value[$f93880154c0ab2a4$var$Ie.value] && (A = e.value[$f93880154c0ab2a4$var$Ie.value][$f93880154c0ab2a4$var$Ve.value]), !A && e.value[$f93880154c0ab2a4$var$Ie.value + (M ? 1 : -1)] ? ($f93880154c0ab2a4$var$Ie.value = $f93880154c0ab2a4$var$Ie.value + (M ? 1 : -1), $f93880154c0ab2a4$var$Ve.value = M ? 0 : e.value[$f93880154c0ab2a4$var$Ie.value].length - 1) : A || ($f93880154c0ab2a4$var$Ve.value = M ? $f93880154c0ab2a4$var$Ve.value - 1 : $f93880154c0ab2a4$var$Ve.value + 1);
    }, l = (M)=>{
        if ($f93880154c0ab2a4$var$Ie.value === 0 && !M || $f93880154c0ab2a4$var$Ie.value === e.value.length && M) return;
        $f93880154c0ab2a4$var$Ie.value = M ? $f93880154c0ab2a4$var$Ie.value + 1 : $f93880154c0ab2a4$var$Ie.value - 1, e.value[$f93880154c0ab2a4$var$Ie.value] ? e.value[$f93880154c0ab2a4$var$Ie.value] && !e.value[$f93880154c0ab2a4$var$Ie.value][$f93880154c0ab2a4$var$Ve.value] && $f93880154c0ab2a4$var$Ve.value !== 0 && ($f93880154c0ab2a4$var$Ve.value = e.value[$f93880154c0ab2a4$var$Ie.value].length - 1) : $f93880154c0ab2a4$var$Ie.value = M ? $f93880154c0ab2a4$var$Ie.value - 1 : $f93880154c0ab2a4$var$Ie.value + 1;
    }, n = (M)=>{
        let A = null;
        e.value[$f93880154c0ab2a4$var$Ie.value] && (A = e.value[$f93880154c0ab2a4$var$Ie.value][$f93880154c0ab2a4$var$Ve.value]), A ? A.focus({
            preventScroll: !$f93880154c0ab2a4$var$sa.value
        }) : $f93880154c0ab2a4$var$Ve.value = M ? $f93880154c0ab2a4$var$Ve.value - 1 : $f93880154c0ab2a4$var$Ve.value + 1;
    }, a = ()=>{
        t(!0), n(!0);
    }, f = ()=>{
        t(!1), n(!1);
    }, i = ()=>{
        l(!1), n(!0);
    }, g = ()=>{
        l(!0), n(!0);
    }, d = (M, A)=>{
        $f93880154c0ab2a4$var$Pe[A] = M;
    }, P = (M, A)=>{
        $f93880154c0ab2a4$var$Pe[A] = M;
    }, v = ()=>{
        $f93880154c0ab2a4$var$Ve.value = 0, $f93880154c0ab2a4$var$Ie.value = 0;
    };
    return {
        buildMatrix: d,
        buildMultiLevelMatrix: P,
        setTimePickerBackRef: (M)=>{
            $f93880154c0ab2a4$var$Oa.value = M;
        },
        setSelectionGrid: (M)=>{
            $f93880154c0ab2a4$var$sa.value = M, v(), M || ($f93880154c0ab2a4$var$Pe.selectionGrid = []);
        },
        setTimePicker: (M, A = !1)=>{
            $f93880154c0ab2a4$var$Ba.value = M, $f93880154c0ab2a4$var$Ya.value = A, v(), M || ($f93880154c0ab2a4$var$Pe.timePicker[0] = [], $f93880154c0ab2a4$var$Pe.timePicker[1] = []);
        },
        setTimePickerElements: (M, A = 0)=>{
            $f93880154c0ab2a4$var$Pe.timePicker[A] = M;
        },
        arrowRight: a,
        arrowLeft: f,
        arrowUp: i,
        arrowDown: g,
        clearArrowNav: ()=>{
            $f93880154c0ab2a4$var$Pe.monthYear = [], $f93880154c0ab2a4$var$Pe.calendar = [], $f93880154c0ab2a4$var$Pe.time = [], $f93880154c0ab2a4$var$Pe.actionRow = [], $f93880154c0ab2a4$var$Pe.selectionGrid = [], $f93880154c0ab2a4$var$Pe.timePicker[0] = [], $f93880154c0ab2a4$var$Pe.timePicker[1] = [], $f93880154c0ab2a4$var$sa.value = !1, $f93880154c0ab2a4$var$Ba.value = !1, $f93880154c0ab2a4$var$Ya.value = !1, $f93880154c0ab2a4$var$_a.value = !1, v(), $f93880154c0ab2a4$var$Oa.value = null;
        },
        setMonthPicker: (M)=>{
            $f93880154c0ab2a4$var$_a.value = M, v();
        },
        refSets: $f93880154c0ab2a4$var$Pe
    };
}, $f93880154c0ab2a4$var$pn = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        menuAppearTop: "dp-menu-appear-top",
        menuAppearBottom: "dp-menu-appear-bottom",
        open: "dp-slide-down",
        close: "dp-slide-up",
        next: "calendar-next",
        previous: "calendar-prev",
        vNext: "dp-slide-up",
        vPrevious: "dp-slide-down"
    }, e !== null && e !== void 0 ? e : {}), $f93880154c0ab2a4$var$Wl = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        toggleOverlay: "Toggle overlay",
        menu: "Datepicker menu",
        input: "Datepicker input",
        openTimePicker: "Open time picker",
        closeTimePicker: "Close time Picker",
        incrementValue: (t)=>`Increment ${t}`,
        decrementValue: (t)=>`Decrement ${t}`,
        openTpOverlay: (t)=>`Open ${t} overlay`,
        amPmButton: "Switch AM/PM mode",
        openYearsOverlay: "Open years overlay",
        openMonthsOverlay: "Open months overlay",
        nextMonth: "Next month",
        prevMonth: "Previous month",
        nextYear: "Next year",
        prevYear: "Previous year",
        day: void 0,
        weekDay: void 0,
        clearInput: "Clear value",
        calendarIcon: "Calendar icon",
        timePicker: "Time picker",
        monthPicker: (t)=>`Month picker${t ? " overlay" : ""}`,
        yearPicker: (t)=>`Year picker${t ? " overlay" : ""}`,
        timeOverlay: (t)=>`${t} overlay`
    }, e !== null && e !== void 0 ? e : {}), $f93880154c0ab2a4$var$gn = (e)=>e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, $f93880154c0ab2a4$var$Ul = (e)=>{
    const t = typeof e == "object" && e, l = {
        static: !0,
        solo: !1
    };
    if (!e) return (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, l), {
        count: $f93880154c0ab2a4$var$gn(!1)
    });
    var _n_count;
    const n = t ? e : {}, a = t ? (_n_count = n.count) !== null && _n_count !== void 0 ? _n_count : !0 : e, f = $f93880154c0ab2a4$var$gn(a);
    return Object.assign(l, n, {
        count: f
    });
}, $f93880154c0ab2a4$var$Vl = (e, t, l)=>e || (typeof l == "string" ? l : t), $f93880154c0ab2a4$var$jl = (e)=>typeof e == "boolean" ? e ? $f93880154c0ab2a4$var$pn({}) : !1 : $f93880154c0ab2a4$var$pn(e), $f93880154c0ab2a4$var$Kl = (e)=>{
    const t = {
        enterSubmit: !0,
        tabSubmit: !0,
        openMenu: "open",
        selectOnFocus: !1,
        rangeSeparator: " - ",
        escClose: !0
    };
    return typeof e == "object" ? (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, t, e !== null && e !== void 0 ? e : {}), {
        enabled: !0
    }) : (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, t), {
        enabled: e
    });
}, $f93880154c0ab2a4$var$Gl = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        months: [],
        years: [],
        times: {
            hours: [],
            minutes: [],
            seconds: []
        }
    }, e !== null && e !== void 0 ? e : {}), $f93880154c0ab2a4$var$Ql = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        showSelect: !0,
        showCancel: !0,
        showNow: !1,
        showPreview: !0
    }, e !== null && e !== void 0 ? e : {}), $f93880154c0ab2a4$var$ql = (e)=>{
    const t = {
        input: !1
    };
    return typeof e == "object" ? (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, t, e !== null && e !== void 0 ? e : {}), {
        enabled: !0
    }) : (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        enabled: e
    }, t);
}, $f93880154c0ab2a4$var$Xl = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        allowStopPropagation: !0,
        closeOnScroll: !1,
        modeHeight: 255,
        allowPreventDefault: !1,
        closeOnClearValue: !0,
        closeOnAutoApply: !0,
        noSwipe: !1,
        keepActionRow: !1,
        onClickOutside: void 0,
        tabOutClosesMenu: !0,
        arrowLeft: void 0,
        keepViewOnOffsetClick: !1,
        timeArrowHoldThreshold: 0,
        shadowDom: !1,
        mobileBreakpoint: 600,
        setDateOnMenuClose: !1
    }, e !== null && e !== void 0 ? e : {}), $f93880154c0ab2a4$var$Jl = (e)=>{
    const t = {
        dates: Array.isArray(e) ? e.map((l)=>$f93880154c0ab2a4$var$H(l)) : [],
        years: [],
        months: [],
        quarters: [],
        weeks: [],
        weekdays: [],
        options: {
            highlightDisabled: !1
        }
    };
    return typeof e == "function" ? e : (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, t, e !== null && e !== void 0 ? e : {});
}, $f93880154c0ab2a4$var$Zl = (e)=>{
    var _e_type, _e_hideOnOffsetDates;
    return typeof e == "object" ? {
        type: (_e_type = e === null || e === void 0 ? void 0 : e.type) !== null && _e_type !== void 0 ? _e_type : "local",
        hideOnOffsetDates: (_e_hideOnOffsetDates = e === null || e === void 0 ? void 0 : e.hideOnOffsetDates) !== null && _e_hideOnOffsetDates !== void 0 ? _e_hideOnOffsetDates : !1
    } : {
        type: e,
        hideOnOffsetDates: !1
    };
}, $f93880154c0ab2a4$var$xl = (e)=>{
    const t = {
        noDisabledRange: !1,
        showLastInRange: !0,
        minMaxRawRange: !1,
        partialRange: !0,
        disableTimeRangeValidation: !1,
        maxRange: void 0,
        minRange: void 0,
        autoRange: void 0,
        fixedStart: !1,
        fixedEnd: !1
    };
    return typeof e == "object" ? (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        enabled: !0
    }, t, e) : (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        enabled: e
    }, t);
}, $f93880154c0ab2a4$var$er = (e)=>{
    var _e_exactMatch, _e_dateInTz, _e_emitTimezone, _e_convertModel;
    return e ? typeof e == "string" ? {
        timezone: e,
        exactMatch: !1,
        dateInTz: void 0,
        emitTimezone: void 0,
        convertModel: !0
    } : {
        timezone: e.timezone,
        exactMatch: (_e_exactMatch = e.exactMatch) !== null && _e_exactMatch !== void 0 ? _e_exactMatch : !1,
        dateInTz: (_e_dateInTz = e.dateInTz) !== null && _e_dateInTz !== void 0 ? _e_dateInTz : void 0,
        emitTimezone: (_e_emitTimezone = e.emitTimezone) !== null && _e_emitTimezone !== void 0 ? _e_emitTimezone : void 0,
        convertModel: (_e_convertModel = e.convertModel) !== null && _e_convertModel !== void 0 ? _e_convertModel : !0
    } : {
        timezone: void 0,
        exactMatch: !1,
        emitTimezone: void 0
    };
}, $f93880154c0ab2a4$var$Ia = (e, t, l, n)=>new Map(e.map((a)=>{
        const f = $f93880154c0ab2a4$var$Qa(a, t, n);
        return [
            $f93880154c0ab2a4$var$Za(f, l),
            f
        ];
    })), $f93880154c0ab2a4$var$tr = (e, t)=>e.length ? new Map(e.map((l)=>{
        const n = $f93880154c0ab2a4$var$Qa(l.date, t);
        return [
            $f93880154c0ab2a4$var$Za(n, $f93880154c0ab2a4$var$Lt.DATE),
            l
        ];
    })) : null, $f93880154c0ab2a4$var$ar = (e)=>{
    var _e_highlight;
    const t = $f93880154c0ab2a4$var$On(e.isMonthPicker, e.isYearPicker);
    return {
        minDate: $f93880154c0ab2a4$var$La(e.minDate, e.timezone, e.isSpecific),
        maxDate: $f93880154c0ab2a4$var$La(e.maxDate, e.timezone, e.isSpecific),
        disabledDates: $f93880154c0ab2a4$var$Ta(e.disabledDates) ? $f93880154c0ab2a4$var$Ia(e.disabledDates, e.timezone, t, e.isSpecific) : e.disabledDates,
        allowedDates: $f93880154c0ab2a4$var$Ta(e.allowedDates) ? $f93880154c0ab2a4$var$Ia(e.allowedDates, e.timezone, t, e.isSpecific) : null,
        highlight: typeof e.highlight == "object" && $f93880154c0ab2a4$var$Ta((_e_highlight = e.highlight) === null || _e_highlight === void 0 ? void 0 : _e_highlight.dates) ? $f93880154c0ab2a4$var$Ia(e.highlight.dates, e.timezone, t) : e.highlight,
        markers: $f93880154c0ab2a4$var$tr(e.markers, e.timezone)
    };
}, $f93880154c0ab2a4$var$nr = (e)=>{
    var _e_dragSelect;
    return typeof e == "boolean" ? {
        enabled: e,
        dragSelect: !0,
        limit: null
    } : {
        enabled: !!e,
        limit: e.limit ? +e.limit : null,
        dragSelect: (_e_dragSelect = e.dragSelect) !== null && _e_dragSelect !== void 0 ? _e_dragSelect : !0
    };
}, $f93880154c0ab2a4$var$lr = (e)=>(0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, Object.fromEntries(Object.keys(e).map((l)=>{
        const n = l, a = e[n], f = typeof e[n] == "string" ? {
            [a]: !0
        } : Object.fromEntries(a.map((i)=>[
                i,
                !0
            ]));
        return [
            l,
            f
        ];
    }))), $f93880154c0ab2a4$var$Oe = (e)=>{
    const t = ()=>{
        const U = e.enableSeconds ? ":ss" : "", $ = e.enableMinutes ? ":mm" : "";
        return e.is24 ? `HH${$}${U}` : `hh${$}${U} aa`;
    }, l = ()=>{
        var _C_value;
        return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${((_C_value = C.value) === null || _C_value === void 0 ? void 0 : _C_value.type) === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy";
    }, n = (U)=>$f93880154c0ab2a4$var$En(U, e.enableSeconds), a = ()=>z.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [
            n(e.startTime[0]),
            n(e.startTime[1])
        ] : null : e.startTime && !Array.isArray(e.startTime) ? n(e.startTime) : null, f = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Ul(e.multiCalendars)), i = (0, $cc75f711ea0318a4$exports.computed)(()=>a()), g = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Wl(e.ariaLabels)), d = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Gl(e.filters)), P = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$jl(e.transitions)), v = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Ql(e.actionRow)), R = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Vl(e.previewFormat, e.format, l())), h = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Kl(e.textInput)), T = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$ql(e.inline)), F = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Xl(e.config)), _ = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Jl(e.highlight)), C = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Zl(e.weekNumbers)), M = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$er(e.timezone)), A = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$nr(e.multiDates)), m = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$ar({
            minDate: e.minDate,
            maxDate: e.maxDate,
            disabledDates: e.disabledDates,
            allowedDates: e.allowedDates,
            highlight: _.value,
            markers: e.markers,
            timezone: M.value,
            isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker,
            isMonthPicker: e.monthPicker,
            isYearPicker: e.yearPicker
        })), z = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$xl(e.range)), L = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$lr(e.ui));
    return {
        defaultedTransitions: P,
        defaultedMultiCalendars: f,
        defaultedStartTime: i,
        defaultedAriaLabels: g,
        defaultedFilters: d,
        defaultedActionRow: v,
        defaultedPreviewFormat: R,
        defaultedTextInput: h,
        defaultedInline: T,
        defaultedConfig: F,
        defaultedHighlight: _,
        defaultedWeekNumbers: C,
        defaultedRange: z,
        propDates: m,
        defaultedTz: M,
        defaultedMultiDates: A,
        defaultedUI: L,
        getDefaultPattern: l,
        getDefaultStartTime: a,
        handleEventPropagation: (U)=>{
            F.value.allowStopPropagation && U.stopPropagation(), F.value.allowPreventDefault && U.preventDefault();
        }
    };
}, $f93880154c0ab2a4$var$rr = (e, t, { isInputFocused: l, isTextInputDate: n })=>{
    const a = (0, $cc75f711ea0318a4$exports.ref)(), { defaultedTextInput: f, defaultedRange: i, defaultedTz: g, defaultedMultiDates: d, getDefaultPattern: P } = $f93880154c0ab2a4$var$Oe(t), v = (0, $cc75f711ea0318a4$exports.ref)(""), R = (0, $cc75f711ea0318a4$exports.toRef)(t, "format"), h = (0, $cc75f711ea0318a4$exports.toRef)(t, "formatLocale");
    (0, $cc75f711ea0318a4$exports.watch)(a, ()=>{
        typeof t.onInternalModelChange == "function" && e("internal-model-change", a.value, x(!0));
    }, {
        deep: !0
    }), (0, $cc75f711ea0318a4$exports.watch)(i, (o, X)=>{
        o.enabled !== X.enabled && (a.value = null);
    }), (0, $cc75f711ea0318a4$exports.watch)(R, ()=>{
        S();
    });
    const T = (o)=>g.value.timezone && g.value.convertModel ? $f93880154c0ab2a4$var$Ze(o, g.value.timezone) : o, F = (o)=>{
        if (g.value.timezone && g.value.convertModel) {
            const X = $f93880154c0ab2a4$var$Ml(g.value.timezone, o);
            return (0, $114f3c376da8f612$export$4a4306ad4fa0e5e6)(o, X);
        }
        return o;
    }, _ = (o, X, B = !1)=>$f93880154c0ab2a4$var$Ln(o, t.format, t.formatLocale, f.value.rangeSeparator, t.modelAuto, X !== null && X !== void 0 ? X : P(), B), C = (o)=>o ? t.modelType ? k(o) : {
            hours: (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)(o),
            minutes: (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145)(o),
            seconds: t.enableSeconds ? (0, $9b5188e8ef63b656$export$5e9417507ff28427)(o) : 0
        } : null, M = (o)=>t.modelType ? k(o) : {
            month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(o),
            year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(o)
        }, A = (o)=>Array.isArray(o) ? d.value.enabled ? o.map((X)=>m(X, (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$H(), X))) : $f93880154c0ab2a4$var$oa(()=>[
                (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$H(), o[0]),
                o[1] ? (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$H(), o[1]) : $f93880154c0ab2a4$var$It(i.value.partialRange)
            ], i.value.enabled) : (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$H(), +o), m = (o, X)=>(typeof o == "string" || typeof o == "number") && t.modelType ? q(o) : X, z = (o)=>Array.isArray(o) ? [
            m(o[0], $f93880154c0ab2a4$var$Mt(null, +o[0].hours, +o[0].minutes, o[0].seconds)),
            m(o[1], $f93880154c0ab2a4$var$Mt(null, +o[1].hours, +o[1].minutes, o[1].seconds))
        ] : m(o, $f93880154c0ab2a4$var$Mt(null, o.hours, o.minutes, o.seconds)), L = (o)=>{
        const X = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
            date: 1
        });
        return Array.isArray(o) ? d.value.enabled ? o.map((B)=>m(B, $f93880154c0ab2a4$var$pt(X, +B.month, +B.year))) : $f93880154c0ab2a4$var$oa(()=>[
                m(o[0], $f93880154c0ab2a4$var$pt(X, +o[0].month, +o[0].year)),
                m(o[1], o[1] ? $f93880154c0ab2a4$var$pt(X, +o[1].month, +o[1].year) : $f93880154c0ab2a4$var$It(i.value.partialRange))
            ], i.value.enabled) : m(o, $f93880154c0ab2a4$var$pt(X, +o.month, +o.year));
    }, le = (o)=>{
        if (Array.isArray(o)) return o.map((X)=>q(X));
        throw new Error($f93880154c0ab2a4$var$Xa.dateArr("multi-dates"));
    }, U = (o)=>{
        if (Array.isArray(o) && i.value.enabled) {
            const X = o[0], B = o[1];
            return [
                $f93880154c0ab2a4$var$H(Array.isArray(X) ? X[0] : null),
                Array.isArray(B) && B.length ? $f93880154c0ab2a4$var$H(B[0]) : null
            ];
        }
        return $f93880154c0ab2a4$var$H(o[0]);
    }, $ = (o)=>t.modelAuto ? Array.isArray(o) ? [
            q(o[0]),
            q(o[1])
        ] : t.autoApply ? [
            q(o)
        ] : [
            q(o),
            null
        ] : Array.isArray(o) ? $f93880154c0ab2a4$var$oa(()=>o[1] ? [
                q(o[0]),
                o[1] ? q(o[1]) : $f93880154c0ab2a4$var$It(i.value.partialRange)
            ] : [
                q(o[0])
            ], i.value.enabled) : q(o), ee = ()=>{
        Array.isArray(a.value) && i.value.enabled && a.value.length === 1 && a.value.push($f93880154c0ab2a4$var$It(i.value.partialRange));
    }, O = ()=>{
        const o = a.value;
        return [
            k(o[0]),
            o[1] ? k(o[1]) : $f93880154c0ab2a4$var$It(i.value.partialRange)
        ];
    }, J = ()=>Array.isArray(a.value) ? a.value[1] ? O() : k($f93880154c0ab2a4$var$Ne(a.value[0])) : [], ce = ()=>(a.value || []).map((o)=>k(o)), pe = (o = !1)=>(o || ee(), t.modelAuto ? J() : d.value.enabled ? ce() : Array.isArray(a.value) ? $f93880154c0ab2a4$var$oa(()=>O(), i.value.enabled) : k($f93880154c0ab2a4$var$Ne(a.value))), p = (o)=>!o || Array.isArray(o) && !o.length ? null : t.timePicker ? z($f93880154c0ab2a4$var$Ne(o)) : t.monthPicker ? L($f93880154c0ab2a4$var$Ne(o)) : t.yearPicker ? A($f93880154c0ab2a4$var$Ne(o)) : d.value.enabled ? le($f93880154c0ab2a4$var$Ne(o)) : t.weekPicker ? U($f93880154c0ab2a4$var$Ne(o)) : $($f93880154c0ab2a4$var$Ne(o)), Y = (o)=>{
        if (n.value) return;
        const X = p(o);
        $f93880154c0ab2a4$var$za($f93880154c0ab2a4$var$Ne(X)) ? (a.value = $f93880154c0ab2a4$var$Ne(X), S()) : (a.value = null, v.value = "");
    }, te = ()=>{
        const o = (X)=>(0, $01941d183f2645a8$export$d9468344d3651243)(X, f.value.format);
        return `${o(a.value[0])} ${f.value.rangeSeparator} ${a.value[1] ? o(a.value[1]) : ""}`;
    }, y = ()=>l.value && a.value ? Array.isArray(a.value) ? te() : (0, $01941d183f2645a8$export$d9468344d3651243)(a.value, f.value.format) : _(a.value), V = ()=>a.value ? d.value.enabled ? a.value.map((o)=>_(o)).join("; ") : f.value.enabled && typeof f.value.format == "string" ? y() : _(a.value) : "", S = ()=>{
        !t.format || typeof t.format == "string" || f.value.enabled && typeof f.value.format == "string" ? v.value = V() : v.value = t.format(a.value);
    }, q = (o)=>{
        if (t.utc) {
            const X = new Date(o);
            return t.utc === "preserve" ? new Date(X.getTime() + X.getTimezoneOffset() * 6e4) : X;
        }
        return t.modelType ? $f93880154c0ab2a4$var$$l.includes(t.modelType) ? T(new Date(o)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? T((0, $03469413ea88cde3$export$98e6a39c04603d36)(o, P(), /* @__PURE__ */ new Date(), {
            locale: h.value
        })) : T((0, $03469413ea88cde3$export$98e6a39c04603d36)(o, t.modelType, /* @__PURE__ */ new Date(), {
            locale: h.value
        })) : T(new Date(o));
    }, k = (o)=>o ? t.utc ? $f93880154c0ab2a4$var$Il(o, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +F(o) : t.modelType === "iso" ? F(o).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? _(F(o)) : _(F(o), t.modelType, !0) : F(o) : "", se = (o, X = !1, B = !1)=>{
        if (B) return o;
        if (e("update:model-value", o), g.value.emitTimezone && X) {
            const be = Array.isArray(o) ? o.map((Ae)=>$f93880154c0ab2a4$var$Ze($f93880154c0ab2a4$var$Ne(Ae), g.value.emitTimezone)) : $f93880154c0ab2a4$var$Ze($f93880154c0ab2a4$var$Ne(o), g.value.emitTimezone);
            e("update:model-timezone-value", be);
        }
    }, u = (o)=>Array.isArray(a.value) ? d.value.enabled ? a.value.map((X)=>o(X)) : [
            o(a.value[0]),
            a.value[1] ? o(a.value[1]) : $f93880154c0ab2a4$var$It(i.value.partialRange)
        ] : o($f93880154c0ab2a4$var$Ne(a.value)), re = ()=>{
        if (Array.isArray(a.value)) {
            const o = $f93880154c0ab2a4$var$mt(a.value[0], t.weekStart), X = a.value[1] ? $f93880154c0ab2a4$var$mt(a.value[1], t.weekStart) : [];
            return [
                o.map((B)=>$f93880154c0ab2a4$var$H(B)),
                X.map((B)=>$f93880154c0ab2a4$var$H(B))
            ];
        }
        return $f93880154c0ab2a4$var$mt(a.value, t.weekStart).map((o)=>$f93880154c0ab2a4$var$H(o));
    }, G = (o, X)=>se($f93880154c0ab2a4$var$Ne(u(o)), !1, X), I = (o)=>{
        const X = re();
        return o ? X : e("update:model-value", re());
    }, x = (o = !1)=>(o || S(), t.monthPicker ? G(M, o) : t.timePicker ? G(C, o) : t.yearPicker ? G((0, $9492c9f664b3a98c$export$5846dc2d57a5c860), o) : t.weekPicker ? I(o) : se(pe(o), !0, o));
    return {
        inputValue: v,
        internalModelValue: a,
        checkBeforeEmit: ()=>a.value ? i.value.enabled ? i.value.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : !1,
        parseExternalModelValue: Y,
        formatInputValue: S,
        emitModelValue: x
    };
}, $f93880154c0ab2a4$var$or = (e, t)=>{
    const { defaultedFilters: l, propDates: n } = $f93880154c0ab2a4$var$Oe(e), { validateMonthYearInRange: a } = $f93880154c0ab2a4$var$Tt(e), f = (v, R)=>{
        let h = v;
        return l.value.months.includes((0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(h)) ? (h = R ? (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(v, 1) : (0, $68126b797c1a3763$export$73d1c15a21f9fae5)(v, 1), f(h, R)) : h;
    }, i = (v, R)=>{
        let h = v;
        return l.value.years.includes((0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(h)) ? (h = R ? (0, $0592f6ea6313b650$export$3d83eec43f4ea476)(v, 1) : (0, $79cf7001ad263c02$export$14867687ff6c92e2)(v, 1), i(h, R)) : h;
    }, g = (v, R = !1)=>{
        const h = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
            month: e.month,
            year: e.year
        });
        let T = v ? (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(h, 1) : (0, $68126b797c1a3763$export$73d1c15a21f9fae5)(h, 1);
        e.disableYearSelect && (T = (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)(T, e.year));
        let F = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(T), _ = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(T);
        l.value.months.includes(F) && (T = f(T, v), F = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(T), _ = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(T)), l.value.years.includes(_) && (T = i(T, v), _ = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(T)), a(F, _, v, e.preventMinMaxNavigation) && d(F, _, R);
    }, d = (v, R, h)=>{
        t("update-month-year", {
            month: v,
            year: R,
            fromNav: h
        });
    }, P = (0, $cc75f711ea0318a4$exports.computed)(()=>(v)=>$f93880154c0ab2a4$var$Nn((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
                month: e.month,
                year: e.year
            }), n.value.maxDate, n.value.minDate, e.preventMinMaxNavigation, v));
    return {
        handleMonthYearChange: g,
        isDisabled: P,
        updateMonthYear: d
    };
}, $f93880154c0ab2a4$var$va = {
    multiCalendars: {
        type: [
            Boolean,
            Number,
            String,
            Object
        ],
        default: void 0
    },
    modelValue: {
        type: [
            String,
            Date,
            Array,
            Object,
            Number
        ],
        default: null
    },
    modelType: {
        type: String,
        default: null
    },
    position: {
        type: String,
        default: "center"
    },
    dark: {
        type: Boolean,
        default: !1
    },
    format: {
        type: [
            String,
            Function
        ],
        default: ()=>null
    },
    autoPosition: {
        type: [
            Boolean,
            String
        ],
        default: !0
    },
    altPosition: {
        type: Function,
        default: null
    },
    transitions: {
        type: [
            Boolean,
            Object
        ],
        default: !0
    },
    formatLocale: {
        type: Object,
        default: null
    },
    utc: {
        type: [
            Boolean,
            String
        ],
        default: !1
    },
    ariaLabels: {
        type: Object,
        default: ()=>({})
    },
    offset: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    hideNavigation: {
        type: Array,
        default: ()=>[]
    },
    timezone: {
        type: [
            String,
            Object
        ],
        default: null
    },
    vertical: {
        type: Boolean,
        default: !1
    },
    disableMonthYearSelect: {
        type: Boolean,
        default: !1
    },
    disableYearSelect: {
        type: Boolean,
        default: !1
    },
    dayClass: {
        type: Function,
        default: null
    },
    yearRange: {
        type: Array,
        default: ()=>[
                1900,
                2100
            ]
    },
    enableTimePicker: {
        type: Boolean,
        default: !0
    },
    autoApply: {
        type: Boolean,
        default: !1
    },
    disabledDates: {
        type: [
            Array,
            Function
        ],
        default: ()=>[]
    },
    monthNameFormat: {
        type: String,
        default: "short"
    },
    startDate: {
        type: [
            Date,
            String
        ],
        default: null
    },
    startTime: {
        type: [
            Object,
            Array
        ],
        default: null
    },
    hideOffsetDates: {
        type: Boolean,
        default: !1
    },
    noToday: {
        type: Boolean,
        default: !1
    },
    disabledWeekDays: {
        type: Array,
        default: ()=>[]
    },
    allowedDates: {
        type: Array,
        default: null
    },
    nowButtonLabel: {
        type: String,
        default: "Now"
    },
    markers: {
        type: Array,
        default: ()=>[]
    },
    escClose: {
        type: Boolean,
        default: !0
    },
    spaceConfirm: {
        type: Boolean,
        default: !0
    },
    monthChangeOnArrows: {
        type: Boolean,
        default: !0
    },
    presetDates: {
        type: Array,
        default: ()=>[]
    },
    flow: {
        type: Array,
        default: ()=>[]
    },
    partialFlow: {
        type: Boolean,
        default: !1
    },
    preventMinMaxNavigation: {
        type: Boolean,
        default: !1
    },
    reverseYears: {
        type: Boolean,
        default: !1
    },
    weekPicker: {
        type: Boolean,
        default: !1
    },
    filters: {
        type: Object,
        default: ()=>({})
    },
    arrowNavigation: {
        type: Boolean,
        default: !1
    },
    highlight: {
        type: [
            Function,
            Object
        ],
        default: null
    },
    teleport: {
        type: [
            Boolean,
            String,
            Object
        ],
        default: null
    },
    teleportCenter: {
        type: Boolean,
        default: !1
    },
    locale: {
        type: String,
        default: "en-Us"
    },
    weekNumName: {
        type: String,
        default: "W"
    },
    weekStart: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    weekNumbers: {
        type: [
            String,
            Function,
            Object
        ],
        default: null
    },
    monthChangeOnScroll: {
        type: [
            Boolean,
            String
        ],
        default: !0
    },
    dayNames: {
        type: [
            Function,
            Array
        ],
        default: null
    },
    monthPicker: {
        type: Boolean,
        default: !1
    },
    customProps: {
        type: Object,
        default: null
    },
    yearPicker: {
        type: Boolean,
        default: !1
    },
    modelAuto: {
        type: Boolean,
        default: !1
    },
    selectText: {
        type: String,
        default: "Select"
    },
    cancelText: {
        type: String,
        default: "Cancel"
    },
    previewFormat: {
        type: [
            String,
            Function
        ],
        default: ()=>""
    },
    multiDates: {
        type: [
            Object,
            Boolean
        ],
        default: !1
    },
    ignoreTimeValidation: {
        type: Boolean,
        default: !1
    },
    minDate: {
        type: [
            Date,
            String
        ],
        default: null
    },
    maxDate: {
        type: [
            Date,
            String
        ],
        default: null
    },
    minTime: {
        type: Object,
        default: null
    },
    maxTime: {
        type: Object,
        default: null
    },
    name: {
        type: String,
        default: null
    },
    placeholder: {
        type: String,
        default: ""
    },
    hideInputIcon: {
        type: Boolean,
        default: !1
    },
    clearable: {
        type: Boolean,
        default: !0
    },
    alwaysClearable: {
        type: Boolean,
        default: !1
    },
    state: {
        type: Boolean,
        default: null
    },
    required: {
        type: Boolean,
        default: !1
    },
    autocomplete: {
        type: String,
        default: "off"
    },
    timePicker: {
        type: Boolean,
        default: !1
    },
    enableSeconds: {
        type: Boolean,
        default: !1
    },
    is24: {
        type: Boolean,
        default: !0
    },
    noHoursOverlay: {
        type: Boolean,
        default: !1
    },
    noMinutesOverlay: {
        type: Boolean,
        default: !1
    },
    noSecondsOverlay: {
        type: Boolean,
        default: !1
    },
    hoursGridIncrement: {
        type: [
            String,
            Number
        ],
        default: 1
    },
    minutesGridIncrement: {
        type: [
            String,
            Number
        ],
        default: 5
    },
    secondsGridIncrement: {
        type: [
            String,
            Number
        ],
        default: 5
    },
    hoursIncrement: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    minutesIncrement: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    secondsIncrement: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    range: {
        type: [
            Boolean,
            Object
        ],
        default: !1
    },
    uid: {
        type: String,
        default: null
    },
    disabled: {
        type: Boolean,
        default: !1
    },
    readonly: {
        type: Boolean,
        default: !1
    },
    inline: {
        type: [
            Boolean,
            Object
        ],
        default: !1
    },
    textInput: {
        type: [
            Boolean,
            Object
        ],
        default: !1
    },
    sixWeeks: {
        type: [
            Boolean,
            String
        ],
        default: !1
    },
    actionRow: {
        type: Object,
        default: ()=>({})
    },
    focusStartDate: {
        type: Boolean,
        default: !1
    },
    disabledTimes: {
        type: [
            Function,
            Array
        ],
        default: void 0
    },
    timePickerInline: {
        type: Boolean,
        default: !1
    },
    calendar: {
        type: Function,
        default: null
    },
    config: {
        type: Object,
        default: void 0
    },
    quarterPicker: {
        type: Boolean,
        default: !1
    },
    yearFirst: {
        type: Boolean,
        default: !1
    },
    loading: {
        type: Boolean,
        default: !1
    },
    onInternalModelChange: {
        type: [
            Function,
            Object
        ],
        default: null
    },
    enableMinutes: {
        type: Boolean,
        default: !0
    },
    ui: {
        type: Object,
        default: ()=>({})
    }
}, $f93880154c0ab2a4$var$dt = (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$va), {
    shadow: {
        type: Boolean,
        default: !1
    },
    flowStep: {
        type: Number,
        default: 0
    },
    internalModelValue: {
        type: [
            Date,
            Array
        ],
        default: null
    },
    noOverlayFocus: {
        type: Boolean,
        default: !1
    },
    collapse: {
        type: Boolean,
        default: !1
    },
    menuWrapRef: {
        type: Object,
        default: null
    },
    getInputRect: {
        type: Function,
        default: ()=>({})
    },
    isTextInputDate: {
        type: Boolean,
        default: !1
    },
    isMobile: {
        type: Boolean,
        default: void 0
    }
}), $f93880154c0ab2a4$var$sr = [
    "title"
], $f93880154c0ab2a4$var$ur = [
    "disabled"
], $f93880154c0ab2a4$var$ir = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "ActionRow",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        menuMount: {
            type: Boolean,
            default: !1
        },
        calendarWidth: {
            type: Number,
            default: 0
        }
    }, $f93880154c0ab2a4$var$dt),
    emits: [
        "close-picker",
        "select-date",
        "select-now",
        "invalid-select"
    ],
    setup (e, { emit: t }) {
        const l = t, n = e, { defaultedActionRow: a, defaultedPreviewFormat: f, defaultedMultiCalendars: i, defaultedTextInput: g, defaultedInline: d, defaultedRange: P, defaultedMultiDates: v } = $f93880154c0ab2a4$var$Oe(n), { isTimeValid: R, isMonthValid: h } = $f93880154c0ab2a4$var$Tt(n), { buildMatrix: T } = $f93880154c0ab2a4$var$At(), F = (0, $cc75f711ea0318a4$exports.ref)(null), _ = (0, $cc75f711ea0318a4$exports.ref)(null), C = (0, $cc75f711ea0318a4$exports.ref)(!1), M = (0, $cc75f711ea0318a4$exports.ref)({}), A = (0, $cc75f711ea0318a4$exports.ref)(null), m = (0, $cc75f711ea0318a4$exports.ref)(null);
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            n.arrowNavigation && T([
                $f93880154c0ab2a4$var$Le(F),
                $f93880154c0ab2a4$var$Le(_)
            ], "actionRow"), z(), window.addEventListener("resize", z);
        }), (0, $cc75f711ea0318a4$exports.onUnmounted)(()=>{
            window.removeEventListener("resize", z);
        });
        const z = ()=>{
            C.value = !1, setTimeout(()=>{
                var _A_value, _m_value;
                const p = (_A_value = A.value) === null || _A_value === void 0 ? void 0 : _A_value.getBoundingClientRect(), Y = (_m_value = m.value) === null || _m_value === void 0 ? void 0 : _m_value.getBoundingClientRect();
                p && Y && (M.value.maxWidth = `${Y.width - p.width - 20}px`), C.value = !0;
            }, 0);
        }, L = (0, $cc75f711ea0318a4$exports.computed)(()=>P.value.enabled && !P.value.partialRange && n.internalModelValue ? n.internalModelValue.length === 2 : !0), le = (0, $cc75f711ea0318a4$exports.computed)(()=>!R.value(n.internalModelValue) || !h.value(n.internalModelValue) || !L.value), U = ()=>{
            const p = f.value;
            return n.timePicker || n.monthPicker, p($f93880154c0ab2a4$var$Ne(n.internalModelValue));
        }, $ = ()=>{
            const p = n.internalModelValue;
            return i.value.count > 0 ? `${ee(p[0])} - ${ee(p[1])}` : [
                ee(p[0]),
                ee(p[1])
            ];
        }, ee = (p)=>$f93880154c0ab2a4$var$Ln(p, f.value, n.formatLocale, g.value.rangeSeparator, n.modelAuto, f.value), O = (0, $cc75f711ea0318a4$exports.computed)(()=>!n.internalModelValue || !n.menuMount ? "" : typeof f.value == "string" ? Array.isArray(n.internalModelValue) ? n.internalModelValue.length === 2 && n.internalModelValue[1] ? $() : v.value.enabled ? n.internalModelValue.map((p)=>`${ee(p)}`) : n.modelAuto ? `${ee(n.internalModelValue[0])}` : `${ee(n.internalModelValue[0])} -` : ee(n.internalModelValue) : U()), J = ()=>v.value.enabled ? "; " : " - ", ce = (0, $cc75f711ea0318a4$exports.computed)(()=>Array.isArray(O.value) ? O.value.join(J()) : O.value), pe = ()=>{
            R.value(n.internalModelValue) && h.value(n.internalModelValue) && L.value ? l("select-date") : l("invalid-select");
        };
        return (p, Y)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                ref_key: "actionRowRef",
                ref: m,
                class: "dp__action_row"
            }, [
                p.$slots["action-row"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(p.$slots, "action-row", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.mergeProps)({
                    key: 0
                }, {
                    internalModelValue: p.internalModelValue,
                    disabled: le.value,
                    selectDate: ()=>p.$emit("select-date"),
                    closePicker: ()=>p.$emit("close-picker")
                }))) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                    key: 1
                }, [
                    (0, $cc75f711ea0318a4$exports.unref)(a).showPreview ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                        key: 0,
                        class: "dp__selection_preview",
                        title: ce.value,
                        style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(M.value)
                    }, [
                        p.$slots["action-preview"] && C.value ? (0, $cc75f711ea0318a4$exports.renderSlot)(p.$slots, "action-preview", {
                            key: 0,
                            value: p.internalModelValue
                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        !p.$slots["action-preview"] && C.value ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                            key: 1
                        }, [
                            (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(ce.value), 1)
                        ], 64)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                    ], 12, $f93880154c0ab2a4$var$sr)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                        ref_key: "actionBtnContainer",
                        ref: A,
                        class: "dp__action_buttons",
                        "data-dp-element": "action-row"
                    }, [
                        p.$slots["action-buttons"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(p.$slots, "action-buttons", {
                            key: 0,
                            value: p.internalModelValue
                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        p.$slots["action-buttons"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                            key: 1
                        }, [
                            !(0, $cc75f711ea0318a4$exports.unref)(d).enabled && (0, $cc75f711ea0318a4$exports.unref)(a).showCancel ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                                key: 0,
                                ref_key: "cancelButtonRef",
                                ref: F,
                                type: "button",
                                class: "dp__action_button dp__action_cancel",
                                onClick: Y[0] || (Y[0] = (te)=>p.$emit("close-picker")),
                                onKeydown: Y[1] || (Y[1] = (te)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(te, ()=>p.$emit("close-picker")))
                            }, (0, $cc75f711ea0318a4$exports.toDisplayString)(p.cancelText), 545)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                            (0, $cc75f711ea0318a4$exports.unref)(a).showNow ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                                key: 1,
                                type: "button",
                                class: "dp__action_button dp__action_cancel",
                                onClick: Y[2] || (Y[2] = (te)=>p.$emit("select-now")),
                                onKeydown: Y[3] || (Y[3] = (te)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(te, ()=>p.$emit("select-now")))
                            }, (0, $cc75f711ea0318a4$exports.toDisplayString)(p.nowButtonLabel), 33)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                            (0, $cc75f711ea0318a4$exports.unref)(a).showSelect ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                                key: 2,
                                ref_key: "selectButtonRef",
                                ref: _,
                                type: "button",
                                class: "dp__action_button dp__action_select",
                                disabled: le.value,
                                "data-test-id": "select-button",
                                onKeydown: Y[4] || (Y[4] = (te)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(te, ()=>pe())),
                                onClick: pe
                            }, (0, $cc75f711ea0318a4$exports.toDisplayString)(p.selectText), 41, $f93880154c0ab2a4$var$ur)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                        ], 64))
                    ], 512)
                ], 64))
            ], 512));
    }
}), $f93880154c0ab2a4$var$dr = [
    "role",
    "aria-label",
    "tabindex"
], $f93880154c0ab2a4$var$cr = {
    class: "dp__selection_grid_header"
}, $f93880154c0ab2a4$var$fr = [
    "aria-selected",
    "aria-disabled",
    "data-test-id",
    "onClick",
    "onKeydown",
    "onMouseover"
], $f93880154c0ab2a4$var$vr = [
    "aria-label"
], $f93880154c0ab2a4$var$ta = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    __name: "SelectionOverlay",
    props: {
        items: {},
        type: {},
        isLast: {
            type: Boolean
        },
        arrowNavigation: {
            type: Boolean
        },
        skipButtonRef: {
            type: Boolean
        },
        headerRefs: {},
        hideNavigation: {},
        escClose: {
            type: Boolean
        },
        useRelative: {
            type: Boolean
        },
        height: {},
        textInput: {
            type: [
                Boolean,
                Object
            ]
        },
        config: {},
        noOverlayFocus: {
            type: Boolean
        },
        focusValue: {},
        menuWrapRef: {},
        ariaLabels: {},
        overlayLabel: {}
    },
    emits: [
        "selected",
        "toggle",
        "reset-flow",
        "hover-value"
    ],
    setup (e, { expose: t, emit: l }) {
        const { setSelectionGrid: n, buildMultiLevelMatrix: a, setMonthPicker: f } = $f93880154c0ab2a4$var$At(), i = l, g = e, { defaultedAriaLabels: d, defaultedTextInput: P, defaultedConfig: v, handleEventPropagation: R } = $f93880154c0ab2a4$var$Oe(g), { hideNavigationButtons: h } = $f93880154c0ab2a4$var$ga(), T = (0, $cc75f711ea0318a4$exports.ref)(!1), F = (0, $cc75f711ea0318a4$exports.ref)(null), _ = (0, $cc75f711ea0318a4$exports.ref)(null), C = (0, $cc75f711ea0318a4$exports.ref)([]), M = (0, $cc75f711ea0318a4$exports.ref)(), A = (0, $cc75f711ea0318a4$exports.ref)(null), m = (0, $cc75f711ea0318a4$exports.ref)(0), z = (0, $cc75f711ea0318a4$exports.ref)(null);
        (0, $cc75f711ea0318a4$exports.onBeforeUpdate)(()=>{
            F.value = null;
        }), (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>ce()), g.noOverlayFocus || le(), L(!0);
        }), (0, $cc75f711ea0318a4$exports.onUnmounted)(()=>L(!1));
        const L = (u)=>{
            var _g_headerRefs;
            g.arrowNavigation && (((_g_headerRefs = g.headerRefs) === null || _g_headerRefs === void 0 ? void 0 : _g_headerRefs.length) ? f(u) : n(u));
        }, le = ()=>{
            var _F_value;
            const u = $f93880154c0ab2a4$var$Le(_);
            u && (P.value.enabled || (F.value ? (_F_value = F.value) === null || _F_value === void 0 ? void 0 : _F_value.focus({
                preventScroll: !0
            }) : u.focus({
                preventScroll: !0
            })), T.value = u.clientHeight < u.scrollHeight);
        }, U = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__overlay: !0,
                "dp--overlay-absolute": !g.useRelative,
                "dp--overlay-relative": g.useRelative
            })), $ = (0, $cc75f711ea0318a4$exports.computed)(()=>g.useRelative ? {
                height: `${g.height}px`,
                width: "var(--dp-menu-min-width)"
            } : void 0), ee = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__overlay_col: !0
            })), O = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__btn: !0,
                dp__button: !0,
                dp__overlay_action: !0,
                dp__over_action_scroll: T.value,
                dp__button_bottom: g.isLast
            })), J = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _g_items, _g_items1;
            return {
                dp__overlay_container: !0,
                dp__container_flex: ((_g_items = g.items) === null || _g_items === void 0 ? void 0 : _g_items.length) <= 6,
                dp__container_block: ((_g_items1 = g.items) === null || _g_items1 === void 0 ? void 0 : _g_items1.length) > 6
            };
        });
        (0, $cc75f711ea0318a4$exports.watch)(()=>g.items, ()=>ce(!1), {
            deep: !0
        });
        const ce = (u = !0)=>{
            (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
                const re = $f93880154c0ab2a4$var$Le(F), G = $f93880154c0ab2a4$var$Le(_), I = $f93880154c0ab2a4$var$Le(A), x = $f93880154c0ab2a4$var$Le(z), c = I ? I.getBoundingClientRect().height : 0;
                G && (G.getBoundingClientRect().height ? m.value = G.getBoundingClientRect().height - c : m.value = v.value.modeHeight - c), re && x && u && (x.scrollTop = re.offsetTop - x.offsetTop - (m.value / 2 - re.getBoundingClientRect().height) - c);
            });
        }, pe = (u)=>{
            u.disabled || i("selected", u.value);
        }, p = ()=>{
            i("toggle"), i("reset-flow");
        }, Y = (u)=>{
            g.escClose && (p(), R(u));
        }, te = (u, re, G, I)=>{
            u && ((re.active || re.value === g.focusValue) && (F.value = u), g.arrowNavigation && (Array.isArray(C.value[G]) ? C.value[G][I] = u : C.value[G] = [
                u
            ], y()));
        }, y = ()=>{
            var _g_headerRefs, _g_headerRefs1;
            const u = ((_g_headerRefs = g.headerRefs) === null || _g_headerRefs === void 0 ? void 0 : _g_headerRefs.length) ? [
                g.headerRefs
            ].concat(C.value) : C.value.concat([
                g.skipButtonRef ? [] : [
                    A.value
                ]
            ]);
            a($f93880154c0ab2a4$var$Ne(u), ((_g_headerRefs1 = g.headerRefs) === null || _g_headerRefs1 === void 0 ? void 0 : _g_headerRefs1.length) ? "monthPicker" : "selectionGrid");
        }, V = (u)=>{
            g.arrowNavigation || $f93880154c0ab2a4$var$Dt(u, v.value, !0);
        }, S = (u)=>{
            M.value = u, i("hover-value", u);
        }, q = ()=>{
            if (p(), !g.isLast) {
                var _Cn;
                var _g_menuWrapRef;
                const u = $f93880154c0ab2a4$var$Fa((_g_menuWrapRef = g.menuWrapRef) !== null && _g_menuWrapRef !== void 0 ? _g_menuWrapRef : null, "action-row");
                u && ((_Cn = $f93880154c0ab2a4$var$Cn(u)) === null || _Cn === void 0 ? void 0 : _Cn.focus());
            }
        }, k = (u)=>{
            switch(u.key){
                case $f93880154c0ab2a4$var$Re.esc:
                    return Y(u);
                case $f93880154c0ab2a4$var$Re.arrowLeft:
                    return V(u);
                case $f93880154c0ab2a4$var$Re.arrowRight:
                    return V(u);
                case $f93880154c0ab2a4$var$Re.arrowUp:
                    return V(u);
                case $f93880154c0ab2a4$var$Re.arrowDown:
                    return V(u);
                default:
                    return;
            }
        }, se = (u)=>{
            if (u.key === $f93880154c0ab2a4$var$Re.enter) return p();
            if (u.key === $f93880154c0ab2a4$var$Re.tab) return q();
        };
        return t({
            focusGrid: le
        }), (u, re)=>{
            var _s;
            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                ref_key: "gridWrapRef",
                ref: _,
                class: (0, $cc75f711ea0318a4$exports.normalizeClass)(U.value),
                style: (0, $cc75f711ea0318a4$exports.normalizeStyle)($.value),
                role: e.useRelative ? void 0 : "dialog",
                "aria-label": e.overlayLabel,
                tabindex: e.useRelative ? void 0 : "0",
                onKeydown: k,
                onClick: re[0] || (re[0] = (0, $cc75f711ea0318a4$exports.withModifiers)(()=>{}, [
                    "prevent"
                ]))
            }, [
                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                    ref_key: "containerRef",
                    ref: z,
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(J.value),
                    style: (0, $cc75f711ea0318a4$exports.normalizeStyle)({
                        "--dp-overlay-height": `${m.value}px`
                    }),
                    role: "grid"
                }, [
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", $f93880154c0ab2a4$var$cr, [
                        (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "header")
                    ]),
                    u.$slots.overlay ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "overlay", {
                        key: 0
                    }) : ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                        key: 1
                    }, (0, $cc75f711ea0318a4$exports.renderList)(e.items, (G, I)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                            key: I,
                            class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                                "dp__overlay_row",
                                {
                                    dp__flex_row: e.items.length >= 3
                                }
                            ]),
                            role: "row"
                        }, [
                            ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(G, (x, c)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                    key: x.value,
                                    ref_for: !0,
                                    ref: (o)=>te(o, x, I, c),
                                    role: "gridcell",
                                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(ee.value),
                                    "aria-selected": x.active || void 0,
                                    "aria-disabled": x.disabled || void 0,
                                    tabindex: "0",
                                    "data-test-id": x.text,
                                    onClick: (0, $cc75f711ea0318a4$exports.withModifiers)((o)=>pe(x), [
                                        "prevent"
                                    ]),
                                    onKeydown: (o)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(o, ()=>pe(x), !0),
                                    onMouseover: (o)=>S(x.value)
                                }, [
                                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)(x.className)
                                    }, [
                                        u.$slots.item ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "item", {
                                            key: 0,
                                            item: x
                                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                        u.$slots.item ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(x.text), 1)
                                        ], 64))
                                    ], 2)
                                ], 42, $f93880154c0ab2a4$var$fr))), 128))
                        ], 2))), 128))
                ], 6),
                u.$slots["button-icon"] ? (0, $cc75f711ea0318a4$exports.withDirectives)(((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                    key: 0,
                    ref_key: "toggleButton",
                    ref: A,
                    type: "button",
                    "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s === void 0 ? void 0 : _s.toggleOverlay,
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(O.value),
                    tabindex: "0",
                    onClick: p,
                    onKeydown: se
                }, [
                    (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "button-icon")
                ], 42, $f93880154c0ab2a4$var$vr)), [
                    [
                        (0, $cc75f711ea0318a4$exports.vShow),
                        !(0, $cc75f711ea0318a4$exports.unref)(h)(e.hideNavigation, e.type)
                    ]
                ]) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
            ], 46, $f93880154c0ab2a4$var$dr);
        };
    }
}), $f93880154c0ab2a4$var$mr = [
    "data-dp-mobile"
], $f93880154c0ab2a4$var$ma = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    __name: "InstanceWrap",
    props: {
        multiCalendars: {},
        stretch: {
            type: Boolean
        },
        collapse: {
            type: Boolean
        },
        isMobile: {
            type: Boolean
        }
    },
    setup (e) {
        const t = e, l = (0, $cc75f711ea0318a4$exports.computed)(()=>t.multiCalendars > 0 ? [
                ...Array(t.multiCalendars).keys()
            ] : [
                0
            ]), n = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__instance_calendar: t.multiCalendars > 0
            }));
        return (a, f)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                    dp__menu_inner: !e.stretch,
                    "dp--menu--inner-stretched": e.stretch,
                    dp__flex_display: e.multiCalendars > 0,
                    "dp--flex-display-collapsed": e.collapse
                }),
                "data-dp-mobile": e.isMobile
            }, [
                ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(l.value, (i, g)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                        key: i,
                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)(n.value)
                    }, [
                        (0, $cc75f711ea0318a4$exports.renderSlot)(a.$slots, "default", {
                            instance: i,
                            index: g
                        })
                    ], 2))), 128))
            ], 10, $f93880154c0ab2a4$var$mr));
    }
}), $f93880154c0ab2a4$var$pr = [
    "data-dp-element",
    "aria-label",
    "aria-disabled"
], $f93880154c0ab2a4$var$Qt = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "ArrowBtn",
    props: {
        ariaLabel: {},
        elName: {},
        disabled: {
            type: Boolean
        }
    },
    emits: [
        "activate",
        "set-ref"
    ],
    setup (e, { emit: t }) {
        const l = t, n = (0, $cc75f711ea0318a4$exports.ref)(null);
        return (0, $cc75f711ea0318a4$exports.onMounted)(()=>l("set-ref", n)), (a, f)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                ref_key: "elRef",
                ref: n,
                type: "button",
                "data-dp-element": e.elName,
                class: "dp__btn dp--arrow-btn-nav",
                tabindex: "0",
                "aria-label": e.ariaLabel,
                "aria-disabled": e.disabled || void 0,
                onClick: f[0] || (f[0] = (i)=>l("activate")),
                onKeydown: f[1] || (f[1] = (i)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(i, ()=>l("activate"), !0))
            }, [
                (0, $cc75f711ea0318a4$exports.createElementVNode)("span", {
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                        "dp__inner_nav",
                        {
                            dp__inner_nav_disabled: e.disabled
                        }
                    ])
                }, [
                    (0, $cc75f711ea0318a4$exports.renderSlot)(a.$slots, "default")
                ], 2)
            ], 40, $f93880154c0ab2a4$var$pr));
    }
}), $f93880154c0ab2a4$var$gr = [
    "aria-label",
    "data-test-id"
], $f93880154c0ab2a4$var$Wn = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    __name: "YearModePicker",
    props: (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$dt), {
        showYearPicker: {
            type: Boolean,
            default: !1
        },
        items: {
            type: Array,
            default: ()=>[]
        },
        instance: {
            type: Number,
            default: 0
        },
        year: {
            type: Number,
            default: 0
        },
        isDisabled: {
            type: Function,
            default: ()=>!1
        }
    }),
    emits: [
        "toggle-year-picker",
        "year-select",
        "handle-year"
    ],
    setup (e, { emit: t }) {
        const l = t, n = e, { showRightIcon: a, showLeftIcon: f } = $f93880154c0ab2a4$var$ga(), { defaultedConfig: i, defaultedMultiCalendars: g, defaultedAriaLabels: d, defaultedTransitions: P, defaultedUI: v } = $f93880154c0ab2a4$var$Oe(n), { showTransition: R, transitionName: h } = $f93880154c0ab2a4$var$aa(P), T = (0, $cc75f711ea0318a4$exports.ref)(!1), F = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Ja(n.year, n.locale)), _ = (A = !1, m)=>{
            T.value = !T.value, l("toggle-year-picker", {
                flow: A,
                show: m
            });
        }, C = (A)=>{
            T.value = !1, l("year-select", A);
        }, M = (A = !1)=>{
            l("handle-year", A);
        };
        return (A, m)=>{
            var _s, _s1, _s2, _s3, _s4;
            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, [
                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                        "dp--year-mode-picker",
                        {
                            "dp--hidden-el": T.value
                        }
                    ])
                }, [
                    (0, $cc75f711ea0318a4$exports.unref)(f)((0, $cc75f711ea0318a4$exports.unref)(g), e.instance) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Qt, {
                        key: 0,
                        ref: "mpPrevIconRef",
                        "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s === void 0 ? void 0 : _s.prevYear,
                        disabled: e.isDisabled(!1),
                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)((_s1 = (0, $cc75f711ea0318a4$exports.unref)(v)) === null || _s1 === void 0 ? void 0 : _s1.navBtnPrev),
                        onActivate: m[0] || (m[0] = (z)=>M(!1))
                    }, {
                        default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                A.$slots["arrow-left"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(A.$slots, "arrow-left", {
                                    key: 0
                                }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                A.$slots["arrow-left"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ua), {
                                    key: 1
                                }))
                            ]),
                        _: 3
                    }, 8, [
                        "aria-label",
                        "disabled",
                        "class"
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("button", {
                        ref: "mpYearButtonRef",
                        class: "dp__btn dp--year-select",
                        type: "button",
                        "aria-label": `${e.year}-${(_s2 = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s2 === void 0 ? void 0 : _s2.openYearsOverlay}`,
                        "data-test-id": `year-mode-btn-${e.instance}`,
                        onClick: m[1] || (m[1] = ()=>_(!1)),
                        onKeydown: m[2] || (m[2] = (0, $cc75f711ea0318a4$exports.withKeys)(()=>_(!1), [
                            "enter"
                        ]))
                    }, [
                        A.$slots.year ? (0, $cc75f711ea0318a4$exports.renderSlot)(A.$slots, "year", {
                            key: 0,
                            year: e.year,
                            text: F.value,
                            value: e.year
                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        A.$slots.year ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                            key: 1
                        }, [
                            (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(F.value), 1)
                        ], 64))
                    ], 40, $f93880154c0ab2a4$var$gr),
                    (0, $cc75f711ea0318a4$exports.unref)(a)((0, $cc75f711ea0318a4$exports.unref)(g), e.instance) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Qt, {
                        key: 1,
                        ref: "mpNextIconRef",
                        "aria-label": (_s3 = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s3 === void 0 ? void 0 : _s3.nextYear,
                        disabled: e.isDisabled(!0),
                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)((_s4 = (0, $cc75f711ea0318a4$exports.unref)(v)) === null || _s4 === void 0 ? void 0 : _s4.navBtnNext),
                        onActivate: m[3] || (m[3] = (z)=>M(!0))
                    }, {
                        default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                A.$slots["arrow-right"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(A.$slots, "arrow-right", {
                                    key: 0
                                }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                A.$slots["arrow-right"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Va), {
                                    key: 1
                                }))
                            ]),
                        _: 3
                    }, 8, [
                        "aria-label",
                        "disabled",
                        "class"
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                ], 2),
                (0, $cc75f711ea0318a4$exports.createVNode)((0, $cc75f711ea0318a4$exports.Transition), {
                    name: (0, $cc75f711ea0318a4$exports.unref)(h)(e.showYearPicker),
                    css: (0, $cc75f711ea0318a4$exports.unref)(R)
                }, {
                    default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>{
                        var _s_yearPicker, _s;
                        return [
                            e.showYearPicker ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ta, {
                                key: 0,
                                items: e.items,
                                "text-input": A.textInput,
                                "esc-close": A.escClose,
                                config: A.config,
                                "is-last": A.autoApply && !(0, $cc75f711ea0318a4$exports.unref)(i).keepActionRow,
                                "hide-navigation": A.hideNavigation,
                                "aria-labels": A.ariaLabels,
                                "overlay-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s === void 0 ? void 0 : (_s_yearPicker = _s.yearPicker) === null || _s_yearPicker === void 0 ? void 0 : _s_yearPicker.call(_s, !0),
                                type: "year",
                                onToggle: _,
                                onSelected: m[4] || (m[4] = (z)=>C(z))
                            }, (0, $cc75f711ea0318a4$exports.createSlots)({
                                "button-icon": (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                        A.$slots["calendar-icon"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(A.$slots, "calendar-icon", {
                                            key: 0
                                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                        A.$slots["calendar-icon"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$jt), {
                                            key: 1
                                        }))
                                    ]),
                                _: 2
                            }, [
                                A.$slots["year-overlay-value"] ? {
                                    name: "item",
                                    fn: (0, $cc75f711ea0318a4$exports.withCtx)(({ item: z })=>[
                                            (0, $cc75f711ea0318a4$exports.renderSlot)(A.$slots, "year-overlay-value", {
                                                text: z.text,
                                                value: z.value
                                            })
                                        ]),
                                    key: "0"
                                } : void 0
                            ]), 1032, [
                                "items",
                                "text-input",
                                "esc-close",
                                "config",
                                "is-last",
                                "hide-navigation",
                                "aria-labels",
                                "overlay-label"
                            ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                        ];
                    }),
                    _: 3
                }, 8, [
                    "name",
                    "css"
                ])
            ], 64);
        };
    }
}), $f93880154c0ab2a4$var$en = (e, t, l)=>{
    if (t.value && Array.isArray(t.value)) {
        if (t.value.some((n)=>$f93880154c0ab2a4$var$$e(e, n))) {
            const n = t.value.filter((a)=>!$f93880154c0ab2a4$var$$e(a, e));
            t.value = n.length ? n : null;
        } else (l && +l > t.value.length || !l) && t.value.push(e);
    } else t.value = [
        e
    ];
}, $f93880154c0ab2a4$var$tn = (e, t, l)=>{
    let n = e.value ? e.value.slice() : [];
    return n.length === 2 && n[1] !== null && (n = []), n.length ? ($f93880154c0ab2a4$var$Be(t, n[0]) ? n.unshift(t) : n[1] = t, l("range-end", t)) : (n = [
        t
    ], l("range-start", t)), n;
}, $f93880154c0ab2a4$var$pa = (e, t, l, n)=>{
    e && (e[0] && e[1] && l && t("auto-apply"), e[0] && !e[1] && n && l && t("auto-apply"));
}, $f93880154c0ab2a4$var$Un = (e)=>{
    Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t)=>$f93880154c0ab2a4$var$Ze($f93880154c0ab2a4$var$H(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = $f93880154c0ab2a4$var$Ze($f93880154c0ab2a4$var$H(e.value), e.timezone));
}, $f93880154c0ab2a4$var$Vn = (e, t, l, n)=>Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && n.value.partialRange) ? n.value.fixedStart && ($f93880154c0ab2a4$var$Ee(e, t.value[0]) || $f93880154c0ab2a4$var$$e(e, t.value[0])) ? [
        t.value[0],
        e
    ] : n.value.fixedEnd && ($f93880154c0ab2a4$var$Be(e, t.value[1]) || $f93880154c0ab2a4$var$$e(e, t.value[1])) ? [
        e,
        t.value[1]
    ] : (l("invalid-fixed-range", e), t.value) : [], $f93880154c0ab2a4$var$jn = ({ multiCalendars: e, range: t, highlight: l, propDates: n, calendars: a, modelValue: f, props: i, filters: g, year: d, month: P, emit: v })=>{
    const R = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$qa(i.yearRange, i.locale, i.reverseYears)), h = (0, $cc75f711ea0318a4$exports.ref)([
        !1
    ]), T = (0, $cc75f711ea0318a4$exports.computed)(()=>(O, J)=>{
            const ce = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$it(/* @__PURE__ */ new Date()), {
                month: P.value(O),
                year: d.value(O)
            }), pe = J ? (0, $bac7abe4a926855b$export$8b7aa55c66d5569e)(ce) : (0, $f267ae5ef0b6b4f4$export$f91e89d3d0406102)(ce);
            return $f93880154c0ab2a4$var$Nn(pe, n.value.maxDate, n.value.minDate, i.preventMinMaxNavigation, J);
        }), F = ()=>Array.isArray(f.value) && e.value.solo && f.value[1], _ = ()=>{
        for(let O = 0; O < e.value.count; O++)if (O === 0) a.value[O] = a.value[0];
        else if (O === e.value.count - 1 && F()) a.value[O] = {
            month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(f.value[1]),
            year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(f.value[1])
        };
        else {
            const J = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), a.value[O - 1]);
            a.value[O] = {
                month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(J),
                year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)((0, $0592f6ea6313b650$export$3d83eec43f4ea476)(J, 1))
            };
        }
    }, C = (O)=>{
        if (!O) return _();
        const J = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), a.value[O]);
        return a.value[0].year = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)((0, $79cf7001ad263c02$export$14867687ff6c92e2)(J, e.value.count - 1)), _();
    }, M = (O, J)=>{
        const ce = (0, $46dd16ed861022fb$export$ed6bf486f68899ca)(J, O);
        return t.value.showLastInRange && ce > 1 ? J : O;
    }, A = (O)=>i.focusStartDate || e.value.solo ? O[0] : O[1] ? M(O[0], O[1]) : O[0], m = ()=>{
        if (f.value) {
            const O = Array.isArray(f.value) ? A(f.value) : f.value;
            a.value[0] = {
                month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(O),
                year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(O)
            };
        }
    }, z = ()=>{
        m(), e.value.count && _();
    };
    (0, $cc75f711ea0318a4$exports.watch)(f, (O, J)=>{
        i.isTextInputDate && JSON.stringify(O !== null && O !== void 0 ? O : {}) !== JSON.stringify(J !== null && J !== void 0 ? J : {}) && z();
    }), (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
        z();
    });
    const L = (O, J)=>{
        a.value[J].year = O, v("update-month-year", {
            instance: J,
            year: O,
            month: a.value[J].month
        }), e.value.count && !e.value.solo && C(J);
    }, le = (0, $cc75f711ea0318a4$exports.computed)(()=>(O)=>$f93880154c0ab2a4$var$Ht(R.value, (J)=>{
                var _g_value_years;
                const ce = d.value(O) === J.value, pe = $f93880154c0ab2a4$var$Zt(J.value, $f93880154c0ab2a4$var$Wt(n.value.minDate), $f93880154c0ab2a4$var$Wt(n.value.maxDate)) || ((_g_value_years = g.value.years) === null || _g_value_years === void 0 ? void 0 : _g_value_years.includes(d.value(O))), p = $f93880154c0ab2a4$var$xa(l.value, J.value);
                return {
                    active: ce,
                    disabled: pe,
                    highlighted: p
                };
            })), U = (O, J)=>{
        L(O, J), ee(J);
    }, $ = (O, J = !1)=>{
        if (!T.value(O, J)) {
            const ce = J ? d.value(O) + 1 : d.value(O) - 1;
            L(ce, O);
        }
    }, ee = (O, J = !1, ce)=>{
        J || v("reset-flow"), ce !== void 0 ? h.value[O] = ce : h.value[O] = !h.value[O], h.value[O] ? v("overlay-toggle", {
            open: !0,
            overlay: $f93880154c0ab2a4$var$je.year
        }) : (v("overlay-closed"), v("overlay-toggle", {
            open: !1,
            overlay: $f93880154c0ab2a4$var$je.year
        }));
    };
    return {
        isDisabled: T,
        groupedYears: le,
        showYearPicker: h,
        selectYear: L,
        toggleYearPicker: ee,
        handleYearSelect: U,
        handleYear: $
    };
}, $f93880154c0ab2a4$var$yr = (e, t)=>{
    const { defaultedMultiCalendars: l, defaultedAriaLabels: n, defaultedTransitions: a, defaultedConfig: f, defaultedRange: i, defaultedHighlight: g, propDates: d, defaultedTz: P, defaultedFilters: v, defaultedMultiDates: R } = $f93880154c0ab2a4$var$Oe(e), h = ()=>{
        e.isTextInputDate && z((0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(e.startDate)), 0);
    }, { modelValue: T, year: F, month: _, calendars: C } = $f93880154c0ab2a4$var$na(e, t, h), M = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Pn(e.formatLocale, e.locale, e.monthNameFormat)), A = (0, $cc75f711ea0318a4$exports.ref)(null), { checkMinMaxRange: m } = $f93880154c0ab2a4$var$Tt(e), { selectYear: z, groupedYears: L, showYearPicker: le, toggleYearPicker: U, handleYearSelect: $, handleYear: ee, isDisabled: O } = $f93880154c0ab2a4$var$jn({
        modelValue: T,
        multiCalendars: l,
        range: i,
        highlight: g,
        calendars: C,
        year: F,
        propDates: d,
        month: _,
        filters: v,
        props: e,
        emit: t
    });
    (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
        e.startDate && (T.value && e.focusStartDate || !T.value) && z((0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(e.startDate)), 0);
    });
    const J = (I)=>I ? {
            month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(I),
            year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(I)
        } : {
            month: null,
            year: null
        }, ce = ()=>T.value ? Array.isArray(T.value) ? T.value.map((I)=>J(I)) : J(T.value) : J(), pe = (I, x)=>{
        const c = C.value[I], o = ce();
        return Array.isArray(o) ? o.some((X)=>X.year === (c === null || c === void 0 ? void 0 : c.year) && X.month === x) : (c === null || c === void 0 ? void 0 : c.year) === o.year && x === o.month;
    }, p = (I, x, c)=>{
        var _o_c, _o_c1;
        const o = ce();
        return Array.isArray(o) ? F.value(x) === ((_o_c = o[c]) === null || _o_c === void 0 ? void 0 : _o_c.year) && I === ((_o_c1 = o[c]) === null || _o_c1 === void 0 ? void 0 : _o_c1.month) : !1;
    }, Y = (I, x)=>{
        if (i.value.enabled) {
            const c = ce();
            if (Array.isArray(T.value) && Array.isArray(c)) {
                const o = p(I, x, 0) || p(I, x, 1), X = $f93880154c0ab2a4$var$pt($f93880154c0ab2a4$var$it($f93880154c0ab2a4$var$H()), I, F.value(x));
                return $f93880154c0ab2a4$var$xt(T.value, A.value, X) && !o;
            }
            return !1;
        }
        return !1;
    }, te = (0, $cc75f711ea0318a4$exports.computed)(()=>(I)=>$f93880154c0ab2a4$var$Ht(M.value, (x)=>{
                var _v_value_months;
                const c = pe(I, x.value), o = $f93880154c0ab2a4$var$Zt(x.value, $f93880154c0ab2a4$var$_n(F.value(I), d.value.minDate), $f93880154c0ab2a4$var$Yn(F.value(I), d.value.maxDate)) || $f93880154c0ab2a4$var$zl(d.value.disabledDates, F.value(I), x.value) || ((_v_value_months = v.value.months) === null || _v_value_months === void 0 ? void 0 : _v_value_months.includes(x.value)) || !$f93880154c0ab2a4$var$Hl(d.value.allowedDates, F.value(I), x.value) || $f93880154c0ab2a4$var$zn(e.yearRange, F.value(I)), X = Y(x.value, I), B = $f93880154c0ab2a4$var$Fn(g.value, x.value, F.value(I));
                return {
                    active: c,
                    disabled: o,
                    isBetween: X,
                    highlighted: B
                };
            })), y = (I, x)=>$f93880154c0ab2a4$var$pt($f93880154c0ab2a4$var$it($f93880154c0ab2a4$var$H()), I, F.value(x)), V = (I, x)=>{
        const c = T.value ? T.value : $f93880154c0ab2a4$var$it(/* @__PURE__ */ new Date());
        T.value = $f93880154c0ab2a4$var$pt(c, I, F.value(x)), t("auto-apply"), t("update-flow-step");
    }, S = (I, x)=>{
        const c = y(I, x);
        i.value.fixedEnd || i.value.fixedStart ? T.value = $f93880154c0ab2a4$var$Vn(c, T, t, i) : T.value ? m(c, T.value) && (T.value = $f93880154c0ab2a4$var$tn(T, y(I, x), t)) : T.value = [
            y(I, x)
        ], (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
            $f93880154c0ab2a4$var$pa(T.value, t, e.autoApply, e.modelAuto);
        });
    }, q = (I, x)=>{
        $f93880154c0ab2a4$var$en(y(I, x), T, R.value.limit), t("auto-apply", !0);
    }, k = (I, x)=>(C.value[x].month = I, u(x, C.value[x].year, I), R.value.enabled ? q(I, x) : i.value.enabled ? S(I, x) : V(I, x)), se = (I, x)=>{
        z(I, x), u(x, I, null);
    }, u = (I, x, c)=>{
        let o = c;
        if (!o && o !== 0) {
            const X = ce();
            o = Array.isArray(X) ? X[I].month : X.month;
        }
        t("update-month-year", {
            instance: I,
            year: x,
            month: o
        });
    };
    return {
        groupedMonths: te,
        groupedYears: L,
        year: F,
        isDisabled: O,
        defaultedMultiCalendars: l,
        defaultedAriaLabels: n,
        defaultedTransitions: a,
        defaultedConfig: f,
        showYearPicker: le,
        modelValue: T,
        presetDate: (I, x)=>{
            $f93880154c0ab2a4$var$Un({
                value: I,
                modelValue: T,
                range: i.value.enabled,
                timezone: x ? void 0 : P.value.timezone
            }), t("auto-apply");
        },
        setHoverDate: (I, x)=>{
            A.value = y(I, x);
        },
        selectMonth: k,
        selectYear: se,
        toggleYearPicker: U,
        handleYearSelect: $,
        handleYear: ee,
        getModelMonthYear: ce
    };
}, $f93880154c0ab2a4$var$hr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "MonthPicker",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$dt),
    emits: [
        "update:internal-model-value",
        "overlay-closed",
        "reset-flow",
        "range-start",
        "range-end",
        "auto-apply",
        "update-month-year",
        "update-flow-step",
        "mount",
        "invalid-fixed-range",
        "overlay-toggle"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = (0, $cc75f711ea0318a4$exports.useSlots)(), f = $f93880154c0ab2a4$var$et(a, "yearMode"), i = e;
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            i.shadow || n("mount", null);
        });
        const { groupedMonths: g, groupedYears: d, year: P, isDisabled: v, defaultedMultiCalendars: R, defaultedConfig: h, showYearPicker: T, modelValue: F, presetDate: _, setHoverDate: C, selectMonth: M, selectYear: A, toggleYearPicker: m, handleYearSelect: z, handleYear: L, getModelMonthYear: le } = $f93880154c0ab2a4$var$yr(i, n);
        return t({
            getSidebarProps: ()=>({
                    modelValue: F,
                    year: P,
                    getModelMonthYear: le,
                    selectMonth: M,
                    selectYear: A,
                    handleYear: L
                }),
            presetDate: _,
            toggleYearPicker: ($)=>m(0, $)
        }), ($, ee)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ma, {
                "multi-calendars": (0, $cc75f711ea0318a4$exports.unref)(R).count,
                collapse: $.collapse,
                stretch: "",
                "is-mobile": $.isMobile
            }, {
                default: (0, $cc75f711ea0318a4$exports.withCtx)(({ instance: O })=>[
                        $.$slots["top-extra"] ? (0, $cc75f711ea0318a4$exports.renderSlot)($.$slots, "top-extra", {
                            key: 0,
                            value: $.internalModelValue
                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        $.$slots["month-year"] ? (0, $cc75f711ea0318a4$exports.renderSlot)($.$slots, "month-year", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.mergeProps)({
                            key: 1
                        }, {
                            year: (0, $cc75f711ea0318a4$exports.unref)(P),
                            months: (0, $cc75f711ea0318a4$exports.unref)(g)(O),
                            years: (0, $cc75f711ea0318a4$exports.unref)(d)(O),
                            selectMonth: (0, $cc75f711ea0318a4$exports.unref)(M),
                            selectYear: (0, $cc75f711ea0318a4$exports.unref)(A),
                            instance: O
                        }))) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ta, {
                            key: 2,
                            items: (0, $cc75f711ea0318a4$exports.unref)(g)(O),
                            "arrow-navigation": $.arrowNavigation,
                            "is-last": $.autoApply && !(0, $cc75f711ea0318a4$exports.unref)(h).keepActionRow,
                            "esc-close": $.escClose,
                            height: (0, $cc75f711ea0318a4$exports.unref)(h).modeHeight,
                            config: $.config,
                            "no-overlay-focus": !!($.noOverlayFocus || $.textInput),
                            "use-relative": "",
                            type: "month",
                            onSelected: (J)=>(0, $cc75f711ea0318a4$exports.unref)(M)(J, O),
                            onHoverValue: (J)=>(0, $cc75f711ea0318a4$exports.unref)(C)(J, O)
                        }, (0, $cc75f711ea0318a4$exports.createSlots)({
                            header: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                    (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$Wn, (0, $cc75f711ea0318a4$exports.mergeProps)($.$props, {
                                        items: (0, $cc75f711ea0318a4$exports.unref)(d)(O),
                                        instance: O,
                                        "show-year-picker": (0, $cc75f711ea0318a4$exports.unref)(T)[O],
                                        year: (0, $cc75f711ea0318a4$exports.unref)(P)(O),
                                        "is-disabled": (J)=>(0, $cc75f711ea0318a4$exports.unref)(v)(O, J),
                                        onHandleYear: (J)=>(0, $cc75f711ea0318a4$exports.unref)(L)(O, J),
                                        onYearSelect: (J)=>(0, $cc75f711ea0318a4$exports.unref)(z)(J, O),
                                        onToggleYearPicker: (J)=>(0, $cc75f711ea0318a4$exports.unref)(m)(O, J === null || J === void 0 ? void 0 : J.flow, J === null || J === void 0 ? void 0 : J.show)
                                    }), (0, $cc75f711ea0318a4$exports.createSlots)({
                                        _: 2
                                    }, [
                                        (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(f), (J, ce)=>({
                                                name: J,
                                                fn: (0, $cc75f711ea0318a4$exports.withCtx)((pe)=>[
                                                        (0, $cc75f711ea0318a4$exports.renderSlot)($.$slots, J, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(pe)))
                                                    ])
                                            }))
                                    ]), 1040, [
                                        "items",
                                        "instance",
                                        "show-year-picker",
                                        "year",
                                        "is-disabled",
                                        "onHandleYear",
                                        "onYearSelect",
                                        "onToggleYearPicker"
                                    ])
                                ]),
                            _: 2
                        }, [
                            $.$slots["month-overlay-value"] ? {
                                name: "item",
                                fn: (0, $cc75f711ea0318a4$exports.withCtx)(({ item: J })=>[
                                        (0, $cc75f711ea0318a4$exports.renderSlot)($.$slots, "month-overlay-value", {
                                            text: J.text,
                                            value: J.value
                                        })
                                    ]),
                                key: "0"
                            } : void 0
                        ]), 1032, [
                            "items",
                            "arrow-navigation",
                            "is-last",
                            "esc-close",
                            "height",
                            "config",
                            "no-overlay-focus",
                            "onSelected",
                            "onHoverValue"
                        ]))
                    ]),
                _: 3
            }, 8, [
                "multi-calendars",
                "collapse",
                "is-mobile"
            ]));
    }
}), $f93880154c0ab2a4$var$br = (e, t)=>{
    const l = ()=>{
        e.isTextInputDate && (v.value = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(e.startDate)));
    }, { modelValue: n } = $f93880154c0ab2a4$var$na(e, t, l), a = (0, $cc75f711ea0318a4$exports.ref)(null), { defaultedHighlight: f, defaultedMultiDates: i, defaultedFilters: g, defaultedRange: d, propDates: P } = $f93880154c0ab2a4$var$Oe(e), v = (0, $cc75f711ea0318a4$exports.ref)();
    (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
        e.startDate && (n.value && e.focusStartDate || !n.value) && (v.value = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(e.startDate)));
    });
    const R = (m)=>Array.isArray(n.value) ? n.value.some((z)=>(0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(z) === m) : n.value ? (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(n.value) === m : !1, h = (m)=>d.value.enabled && Array.isArray(n.value) ? $f93880154c0ab2a4$var$xt(n.value, a.value, C(m)) : !1, T = (m)=>P.value.allowedDates instanceof Map ? P.value.allowedDates.size ? P.value.allowedDates.has(`${m}`) : !1 : !0, F = (m)=>P.value.disabledDates instanceof Map ? P.value.disabledDates.size ? P.value.disabledDates.has(`${m}`) : !1 : typeof P.value.disabledDates == "function" ? P.value.disabledDates((0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$Fe((0, $f267ae5ef0b6b4f4$export$f91e89d3d0406102)($f93880154c0ab2a4$var$H())), m)) : !0, _ = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Ht($f93880154c0ab2a4$var$qa(e.yearRange, e.locale, e.reverseYears), (m)=>{
            const z = R(m.value), L = $f93880154c0ab2a4$var$Zt(m.value, $f93880154c0ab2a4$var$Wt(P.value.minDate), $f93880154c0ab2a4$var$Wt(P.value.maxDate)) || g.value.years.includes(m.value) || !T(m.value) || F(m.value), le = h(m.value) && !z, U = $f93880154c0ab2a4$var$xa(f.value, m.value);
            return {
                active: z,
                disabled: L,
                isBetween: le,
                highlighted: U
            };
        })), C = (m)=>(0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$it((0, $f267ae5ef0b6b4f4$export$f91e89d3d0406102)(/* @__PURE__ */ new Date())), m);
    return {
        groupedYears: _,
        modelValue: n,
        focusYear: v,
        setHoverValue: (m)=>{
            a.value = (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$it(/* @__PURE__ */ new Date()), m);
        },
        selectYear: (m)=>{
            var _n_value;
            if (t("update-month-year", {
                instance: 0,
                year: m
            }), i.value.enabled) return n.value ? Array.isArray(n.value) && (((_n_value = n.value) === null || _n_value === void 0 ? void 0 : _n_value.map((L)=>(0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(L))).includes(m) ? n.value = n.value.filter((L)=>(0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(L) !== m) : n.value.push((0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$Fe($f93880154c0ab2a4$var$H()), m))) : n.value = [
                (0, $1a44633bf27f1eed$export$a8408b6c5639cab7)($f93880154c0ab2a4$var$Fe((0, $f267ae5ef0b6b4f4$export$f91e89d3d0406102)($f93880154c0ab2a4$var$H())), m)
            ], t("auto-apply", !0);
            d.value.enabled ? (n.value = $f93880154c0ab2a4$var$tn(n, C(m), t), (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
                $f93880154c0ab2a4$var$pa(n.value, t, e.autoApply, e.modelAuto);
            })) : (n.value = C(m), t("auto-apply"));
        }
    };
}, $f93880154c0ab2a4$var$kr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "YearPicker",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$dt),
    emits: [
        "update:internal-model-value",
        "reset-flow",
        "range-start",
        "range-end",
        "auto-apply",
        "update-month-year"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { groupedYears: f, modelValue: i, focusYear: g, selectYear: d, setHoverValue: P } = $f93880154c0ab2a4$var$br(a, n), { defaultedConfig: v } = $f93880154c0ab2a4$var$Oe(a);
        return t({
            getSidebarProps: ()=>({
                    modelValue: i,
                    selectYear: d
                })
        }), (h, T)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", null, [
                h.$slots["top-extra"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(h.$slots, "top-extra", {
                    key: 0,
                    value: h.internalModelValue
                }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                h.$slots["month-year"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(h.$slots, "month-year", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.mergeProps)({
                    key: 1
                }, {
                    years: (0, $cc75f711ea0318a4$exports.unref)(f),
                    selectYear: (0, $cc75f711ea0318a4$exports.unref)(d)
                }))) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ta, {
                    key: 2,
                    items: (0, $cc75f711ea0318a4$exports.unref)(f),
                    "is-last": h.autoApply && !(0, $cc75f711ea0318a4$exports.unref)(v).keepActionRow,
                    height: (0, $cc75f711ea0318a4$exports.unref)(v).modeHeight,
                    config: h.config,
                    "no-overlay-focus": !!(h.noOverlayFocus || h.textInput),
                    "focus-value": (0, $cc75f711ea0318a4$exports.unref)(g),
                    type: "year",
                    "use-relative": "",
                    onSelected: (0, $cc75f711ea0318a4$exports.unref)(d),
                    onHoverValue: (0, $cc75f711ea0318a4$exports.unref)(P)
                }, (0, $cc75f711ea0318a4$exports.createSlots)({
                    _: 2
                }, [
                    h.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: (0, $cc75f711ea0318a4$exports.withCtx)(({ item: F })=>[
                                (0, $cc75f711ea0318a4$exports.renderSlot)(h.$slots, "year-overlay-value", {
                                    text: F.text,
                                    value: F.value
                                })
                            ]),
                        key: "0"
                    } : void 0
                ]), 1032, [
                    "items",
                    "is-last",
                    "height",
                    "config",
                    "no-overlay-focus",
                    "focus-value",
                    "onSelected",
                    "onHoverValue"
                ]))
            ]));
    }
}), $f93880154c0ab2a4$var$wr = {
    key: 0,
    class: "dp__time_input"
}, $f93880154c0ab2a4$var$Dr = [
    "data-compact",
    "data-collapsed"
], $f93880154c0ab2a4$var$Mr = [
    "data-test-id",
    "aria-label",
    "onKeydown",
    "onClick",
    "onMousedown"
], $f93880154c0ab2a4$var$$r = [
    "aria-label",
    "disabled",
    "data-test-id",
    "onKeydown",
    "onClick"
], $f93880154c0ab2a4$var$Ar = [
    "data-test-id",
    "aria-label",
    "onKeydown",
    "onClick",
    "onMousedown"
], $f93880154c0ab2a4$var$Tr = {
    key: 0
}, $f93880154c0ab2a4$var$Sr = [
    "aria-label",
    "data-compact"
], $f93880154c0ab2a4$var$Pr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "TimeInput",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        hours: {
            type: Number,
            default: 0
        },
        minutes: {
            type: Number,
            default: 0
        },
        seconds: {
            type: Number,
            default: 0
        },
        closeTimePickerBtn: {
            type: Object,
            default: null
        },
        order: {
            type: Number,
            default: 0
        },
        disabledTimesConfig: {
            type: Function,
            default: null
        },
        validateTime: {
            type: Function,
            default: ()=>!1
        }
    }, $f93880154c0ab2a4$var$dt),
    emits: [
        "set-hours",
        "set-minutes",
        "update:hours",
        "update:minutes",
        "update:seconds",
        "reset-flow",
        "mounted",
        "overlay-closed",
        "overlay-opened",
        "am-pm-change"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { setTimePickerElements: f, setTimePickerBackRef: i } = $f93880154c0ab2a4$var$At(), { defaultedAriaLabels: g, defaultedTransitions: d, defaultedFilters: P, defaultedConfig: v, defaultedRange: R, defaultedMultiCalendars: h } = $f93880154c0ab2a4$var$Oe(a), { transitionName: T, showTransition: F } = $f93880154c0ab2a4$var$aa(d), _ = (0, $cc75f711ea0318a4$exports.reactive)({
            hours: !1,
            minutes: !1,
            seconds: !1
        }), C = (0, $cc75f711ea0318a4$exports.ref)("AM"), M = (0, $cc75f711ea0318a4$exports.ref)(null), A = (0, $cc75f711ea0318a4$exports.ref)([]), m = (0, $cc75f711ea0318a4$exports.ref)(), z = (0, $cc75f711ea0318a4$exports.ref)(!1);
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            n("mounted");
        });
        const L = (r)=>(0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(/* @__PURE__ */ new Date(), {
                hours: r.hours,
                minutes: r.minutes,
                seconds: a.enableSeconds ? r.seconds : 0,
                milliseconds: 0
            }), le = (0, $cc75f711ea0318a4$exports.computed)(()=>(r)=>S(r, a[r]) || $(r, a[r])), U = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                hours: a.hours,
                minutes: a.minutes,
                seconds: a.seconds
            })), $ = (r, E)=>R.value.enabled && !R.value.disableTimeRangeValidation ? !a.validateTime(r, E) : !1, ee = (r, E)=>{
            if (R.value.enabled && !R.value.disableTimeRangeValidation) {
                const K = E ? +a[`${r}Increment`] : -+a[`${r}Increment`], oe = a[r] + K;
                return !a.validateTime(r, oe);
            }
            return !1;
        }, O = (0, $cc75f711ea0318a4$exports.computed)(()=>(r)=>!re(+a[r] + +a[`${r}Increment`], r) || ee(r, !0)), J = (0, $cc75f711ea0318a4$exports.computed)(()=>(r)=>!re(+a[r] - +a[`${r}Increment`], r) || ee(r, !1)), ce = (r, E)=>(0, $cd621c9cd579be00$export$e16d8520af44a096)((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), r), E), pe = (r, E)=>(0, $2caa7e79af8b5dd3$export$f93b5905241a7cca)((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), r), E), p = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__time_col: !0,
                dp__time_col_block: !a.timePickerInline,
                dp__time_col_reg_block: !a.enableSeconds && a.is24 && !a.timePickerInline,
                dp__time_col_reg_inline: !a.enableSeconds && a.is24 && a.timePickerInline,
                dp__time_col_reg_with_button: !a.enableSeconds && !a.is24,
                dp__time_col_sec: a.enableSeconds && a.is24,
                dp__time_col_sec_with_button: a.enableSeconds && !a.is24
            })), Y = (0, $cc75f711ea0318a4$exports.computed)(()=>a.timePickerInline && R.value.enabled && !h.value.count), te = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            const r = [
                {
                    type: "hours"
                }
            ];
            return a.enableMinutes && r.push({
                type: "",
                separator: !0
            }, {
                type: "minutes"
            }), a.enableSeconds && r.push({
                type: "",
                separator: !0
            }, {
                type: "seconds"
            }), r;
        }), y = (0, $cc75f711ea0318a4$exports.computed)(()=>te.value.filter((r)=>!r.separator)), V = (0, $cc75f711ea0318a4$exports.computed)(()=>(r)=>{
                if (r === "hours") {
                    const E = X(+a.hours);
                    return {
                        text: E < 10 ? `0${E}` : `${E}`,
                        value: E
                    };
                }
                return {
                    text: a[r] < 10 ? `0${a[r]}` : `${a[r]}`,
                    value: a[r]
                };
            }), S = (r, E)=>{
            var _K_r;
            if (!a.disabledTimesConfig) return !1;
            const K = a.disabledTimesConfig(a.order, r === "hours" ? E : void 0);
            return K[r] ? !!((_K_r = K[r]) === null || _K_r === void 0 ? void 0 : _K_r.includes(E)) : !0;
        }, q = (r, E)=>E !== "hours" || C.value === "AM" ? r : r + 12, k = (r)=>{
            const E = a.is24 ? 24 : 12, K = r === "hours" ? E : 60, oe = +a[`${r}GridIncrement`], ge = r === "hours" && !a.is24 ? oe : 0, _e = [];
            for(let Ye = ge; Ye < K; Ye += oe)_e.push({
                value: a.is24 ? Ye : q(Ye, r),
                text: Ye < 10 ? `0${Ye}` : `${Ye}`
            });
            return r === "hours" && !a.is24 && _e.unshift({
                value: C.value === "PM" ? 12 : 0,
                text: "12"
            }), $f93880154c0ab2a4$var$Ht(_e, (Ye)=>({
                    active: !1,
                    disabled: P.value.times[r].includes(Ye.value) || !re(Ye.value, r) || S(r, Ye.value) || $(r, Ye.value)
                }));
        }, se = (r)=>r >= 0 ? r : 59, u = (r)=>r >= 0 ? r : 23, re = (r, E)=>{
            const K = a.minTime ? L($f93880154c0ab2a4$var$Sa(a.minTime)) : null, oe = a.maxTime ? L($f93880154c0ab2a4$var$Sa(a.maxTime)) : null, ge = L($f93880154c0ab2a4$var$Sa(U.value, E, E === "minutes" || E === "seconds" ? se(r) : u(r)));
            return K && oe ? ((0, $47e0b58359a22142$export$5c007e10c6929c95)(ge, oe) || (0, $79cf663451f45a9b$export$248d38f6296296c5)(ge, oe)) && ((0, $dcd5a7c05c821292$export$e4de839670987035)(ge, K) || (0, $79cf663451f45a9b$export$248d38f6296296c5)(ge, K)) : K ? (0, $dcd5a7c05c821292$export$e4de839670987035)(ge, K) || (0, $79cf663451f45a9b$export$248d38f6296296c5)(ge, K) : oe ? (0, $47e0b58359a22142$export$5c007e10c6929c95)(ge, oe) || (0, $79cf663451f45a9b$export$248d38f6296296c5)(ge, oe) : !0;
        }, G = (r)=>a[`no${r[0].toUpperCase() + r.slice(1)}Overlay`], I = (r)=>{
            G(r) || (_[r] = !_[r], _[r] ? (z.value = !0, n("overlay-opened", r)) : (z.value = !1, n("overlay-closed", r)));
        }, x = (r)=>r === "hours" ? (0, $bda6db0cdfc5a459$export$257b40f71c07d58f) : r === "minutes" ? (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145) : (0, $9b5188e8ef63b656$export$5e9417507ff28427), c = ()=>{
            m.value && clearTimeout(m.value);
        }, o = (r, E = !0, K)=>{
            const oe = E ? ce : pe, ge = E ? +a[`${r}Increment`] : -+a[`${r}Increment`];
            re(+a[r] + ge, r) && n(`update:${r}`, x(r)(oe({
                [r]: +a[r]
            }, {
                [r]: +a[`${r}Increment`]
            }))), !(K === null || K === void 0 ? void 0 : K.keyboard) && v.value.timeArrowHoldThreshold && (m.value = setTimeout(()=>{
                o(r, E);
            }, v.value.timeArrowHoldThreshold));
        }, X = (r)=>a.is24 ? r : (r >= 12 ? C.value = "PM" : C.value = "AM", $f93880154c0ab2a4$var$Sl(r)), B = ()=>{
            C.value === "PM" ? (C.value = "AM", n("update:hours", a.hours - 12)) : (C.value = "PM", n("update:hours", a.hours + 12)), n("am-pm-change", C.value);
        }, be = (r)=>{
            _[r] = !0;
        }, Ae = (r, E, K)=>{
            if (r && a.arrowNavigation) {
                Array.isArray(A.value[E]) ? A.value[E][K] = r : A.value[E] = [
                    r
                ];
                const oe = A.value.reduce((ge, _e)=>_e.map((Ye, nt)=>[
                            ...ge[nt] || [],
                            _e[nt]
                        ]), []);
                i(a.closeTimePickerBtn), M.value && (oe[1] = oe[1].concat(M.value)), f(oe, a.order);
            }
        }, ne = (r, E)=>(I(r), n(`update:${r}`, E));
        return t({
            openChildCmp: be
        }), (r, E)=>{
            var _s;
            return r.disabled ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$wr, [
                ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(te.value, (K, oe)=>{
                    var _s, _s1, _s2;
                    return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                        key: oe,
                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)(p.value),
                        "data-compact": Y.value && !r.enableSeconds,
                        "data-collapsed": Y.value && r.enableSeconds
                    }, [
                        K.separator ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                            key: 0
                        }, [
                            z.value ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                key: 0
                            }, [
                                (0, $cc75f711ea0318a4$exports.createTextVNode)(":")
                            ], 64))
                        ], 64)) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                            key: 1
                        }, [
                            (0, $cc75f711ea0318a4$exports.createElementVNode)("button", {
                                ref_for: !0,
                                ref: (ge)=>Ae(ge, oe, 0),
                                type: "button",
                                class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                                    dp__btn: !0,
                                    dp__inc_dec_button: !r.timePickerInline,
                                    dp__inc_dec_button_inline: r.timePickerInline,
                                    dp__tp_inline_btn_top: r.timePickerInline,
                                    dp__inc_dec_button_disabled: O.value(K.type),
                                    "dp--hidden-el": z.value
                                }),
                                "data-test-id": `${K.type}-time-inc-btn-${a.order}`,
                                "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(g)) === null || _s === void 0 ? void 0 : _s.incrementValue(K.type),
                                tabindex: "0",
                                onKeydown: (ge)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(ge, ()=>o(K.type, !0, {
                                            keyboard: !0
                                        }), !0),
                                onClick: (ge)=>(0, $cc75f711ea0318a4$exports.unref)(v).timeArrowHoldThreshold ? void 0 : o(K.type, !0),
                                onMousedown: (ge)=>(0, $cc75f711ea0318a4$exports.unref)(v).timeArrowHoldThreshold ? o(K.type, !0) : void 0,
                                onMouseup: c
                            }, [
                                a.timePickerInline ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: 1
                                }, [
                                    r.$slots["tp-inline-arrow-up"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, "tp-inline-arrow-up", {
                                        key: 0
                                    }) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                        key: 1
                                    }, [
                                        E[2] || (E[2] = (0, $cc75f711ea0318a4$exports.createElementVNode)("span", {
                                            class: "dp__tp_inline_btn_bar dp__tp_btn_in_l"
                                        }, null, -1)),
                                        E[3] || (E[3] = (0, $cc75f711ea0318a4$exports.createElementVNode)("span", {
                                            class: "dp__tp_inline_btn_bar dp__tp_btn_in_r"
                                        }, null, -1))
                                    ], 64))
                                ], 64)) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: 0
                                }, [
                                    r.$slots["arrow-up"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, "arrow-up", {
                                        key: 0
                                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                    r.$slots["arrow-up"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ka), {
                                        key: 1
                                    }))
                                ], 64))
                            ], 42, $f93880154c0ab2a4$var$Mr),
                            (0, $cc75f711ea0318a4$exports.createElementVNode)("button", {
                                ref_for: !0,
                                ref: (ge)=>Ae(ge, oe, 1),
                                type: "button",
                                "aria-label": `${V.value(K.type).text}-${(_s1 = (0, $cc75f711ea0318a4$exports.unref)(g)) === null || _s1 === void 0 ? void 0 : _s1.openTpOverlay(K.type)}`,
                                class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                                    dp__time_display: !0,
                                    dp__time_display_block: !r.timePickerInline,
                                    dp__time_display_inline: r.timePickerInline,
                                    "dp--time-invalid": le.value(K.type),
                                    "dp--time-overlay-btn": !le.value(K.type),
                                    "dp--hidden-el": z.value
                                }),
                                disabled: G(K.type),
                                tabindex: "0",
                                "data-test-id": `${K.type}-toggle-overlay-btn-${a.order}`,
                                onKeydown: (ge)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(ge, ()=>I(K.type), !0),
                                onClick: (ge)=>I(K.type)
                            }, [
                                r.$slots[K.type] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, K.type, {
                                    key: 0,
                                    text: V.value(K.type).text,
                                    value: V.value(K.type).value
                                }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                r.$slots[K.type] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: 1
                                }, [
                                    (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(V.value(K.type).text), 1)
                                ], 64))
                            ], 42, $f93880154c0ab2a4$var$$r),
                            (0, $cc75f711ea0318a4$exports.createElementVNode)("button", {
                                ref_for: !0,
                                ref: (ge)=>Ae(ge, oe, 2),
                                type: "button",
                                class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                                    dp__btn: !0,
                                    dp__inc_dec_button: !r.timePickerInline,
                                    dp__inc_dec_button_inline: r.timePickerInline,
                                    dp__tp_inline_btn_bottom: r.timePickerInline,
                                    dp__inc_dec_button_disabled: J.value(K.type),
                                    "dp--hidden-el": z.value
                                }),
                                "data-test-id": `${K.type}-time-dec-btn-${a.order}`,
                                "aria-label": (_s2 = (0, $cc75f711ea0318a4$exports.unref)(g)) === null || _s2 === void 0 ? void 0 : _s2.decrementValue(K.type),
                                tabindex: "0",
                                onKeydown: (ge)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(ge, ()=>o(K.type, !1, {
                                            keyboard: !0
                                        }), !0),
                                onClick: (ge)=>(0, $cc75f711ea0318a4$exports.unref)(v).timeArrowHoldThreshold ? void 0 : o(K.type, !1),
                                onMousedown: (ge)=>(0, $cc75f711ea0318a4$exports.unref)(v).timeArrowHoldThreshold ? o(K.type, !1) : void 0,
                                onMouseup: c
                            }, [
                                a.timePickerInline ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: 1
                                }, [
                                    r.$slots["tp-inline-arrow-down"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, "tp-inline-arrow-down", {
                                        key: 0
                                    }) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                        key: 1
                                    }, [
                                        E[4] || (E[4] = (0, $cc75f711ea0318a4$exports.createElementVNode)("span", {
                                            class: "dp__tp_inline_btn_bar dp__tp_btn_in_l"
                                        }, null, -1)),
                                        E[5] || (E[5] = (0, $cc75f711ea0318a4$exports.createElementVNode)("span", {
                                            class: "dp__tp_inline_btn_bar dp__tp_btn_in_r"
                                        }, null, -1))
                                    ], 64))
                                ], 64)) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: 0
                                }, [
                                    r.$slots["arrow-down"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, "arrow-down", {
                                        key: 0
                                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                    r.$slots["arrow-down"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ga), {
                                        key: 1
                                    }))
                                ], 64))
                            ], 42, $f93880154c0ab2a4$var$Ar)
                        ], 64))
                    ], 10, $f93880154c0ab2a4$var$Dr);
                }), 128)),
                r.is24 ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$Tr, [
                    r.$slots["am-pm-button"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, "am-pm-button", {
                        key: 0,
                        toggle: B,
                        value: C.value
                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    r.$slots["am-pm-button"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                        key: 1,
                        ref_key: "amPmButton",
                        ref: M,
                        type: "button",
                        class: "dp__pm_am_button",
                        role: "button",
                        "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(g)) === null || _s === void 0 ? void 0 : _s.amPmButton,
                        tabindex: "0",
                        "data-compact": Y.value,
                        onClick: B,
                        onKeydown: E[0] || (E[0] = (K)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(K, ()=>B(), !0))
                    }, (0, $cc75f711ea0318a4$exports.toDisplayString)(C.value), 41, $f93880154c0ab2a4$var$Sr))
                ])),
                ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(y.value, (K, oe)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.Transition), {
                        key: oe,
                        name: (0, $cc75f711ea0318a4$exports.unref)(T)(_[K.type]),
                        css: (0, $cc75f711ea0318a4$exports.unref)(F)
                    }, {
                        default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>{
                            var _s_timeOverlay, _s;
                            return [
                                _[K.type] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ta, {
                                    key: 0,
                                    items: k(K.type),
                                    "is-last": r.autoApply && !(0, $cc75f711ea0318a4$exports.unref)(v).keepActionRow,
                                    "esc-close": r.escClose,
                                    type: K.type,
                                    "text-input": r.textInput,
                                    config: r.config,
                                    "arrow-navigation": r.arrowNavigation,
                                    "aria-labels": r.ariaLabels,
                                    "overlay-label": (_s_timeOverlay = (_s = (0, $cc75f711ea0318a4$exports.unref)(g)).timeOverlay) === null || _s_timeOverlay === void 0 ? void 0 : _s_timeOverlay.call(_s, K.type),
                                    onSelected: (ge)=>ne(K.type, ge),
                                    onToggle: (ge)=>I(K.type),
                                    onResetFlow: E[1] || (E[1] = (ge)=>r.$emit("reset-flow"))
                                }, (0, $cc75f711ea0318a4$exports.createSlots)({
                                    "button-icon": (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                            r.$slots["clock-icon"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, "clock-icon", {
                                                key: 0
                                            }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                            r.$slots["clock-icon"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.resolveDynamicComponent)(r.timePickerInline ? (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$jt) : (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$ja)), {
                                                key: 1
                                            }))
                                        ]),
                                    _: 2
                                }, [
                                    r.$slots[`${K.type}-overlay-value`] ? {
                                        name: "item",
                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)(({ item: ge })=>[
                                                (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, `${K.type}-overlay-value`, {
                                                    text: ge.text,
                                                    value: ge.value
                                                })
                                            ]),
                                        key: "0"
                                    } : void 0,
                                    r.$slots[`${K.type}-overlay-header`] ? {
                                        name: "header",
                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                                (0, $cc75f711ea0318a4$exports.renderSlot)(r.$slots, `${K.type}-overlay-header`, {
                                                    toggle: ()=>I(K.type)
                                                })
                                            ]),
                                        key: "1"
                                    } : void 0
                                ]), 1032, [
                                    "items",
                                    "is-last",
                                    "esc-close",
                                    "type",
                                    "text-input",
                                    "config",
                                    "arrow-navigation",
                                    "aria-labels",
                                    "overlay-label",
                                    "onSelected",
                                    "onToggle"
                                ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                            ];
                        }),
                        _: 2
                    }, 1032, [
                        "name",
                        "css"
                    ]))), 128))
            ]));
        };
    }
}), $f93880154c0ab2a4$var$Rr = [
    "data-dp-mobile"
], $f93880154c0ab2a4$var$Cr = [
    "aria-label",
    "tabindex"
], $f93880154c0ab2a4$var$Or = [
    "role",
    "aria-label",
    "tabindex"
], $f93880154c0ab2a4$var$Br = [
    "aria-label"
], $f93880154c0ab2a4$var$Kn = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "TimePicker",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        hours: {
            type: [
                Number,
                Array
            ],
            default: 0
        },
        minutes: {
            type: [
                Number,
                Array
            ],
            default: 0
        },
        seconds: {
            type: [
                Number,
                Array
            ],
            default: 0
        },
        disabledTimesConfig: {
            type: Function,
            default: null
        },
        validateTime: {
            type: Function,
            default: ()=>!1
        }
    }, $f93880154c0ab2a4$var$dt),
    emits: [
        "update:hours",
        "update:minutes",
        "update:seconds",
        "mount",
        "reset-flow",
        "overlay-opened",
        "overlay-closed",
        "am-pm-change"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { buildMatrix: f, setTimePicker: i } = $f93880154c0ab2a4$var$At(), g = (0, $cc75f711ea0318a4$exports.useSlots)(), { defaultedTransitions: d, defaultedAriaLabels: P, defaultedTextInput: v, defaultedConfig: R, defaultedRange: h } = $f93880154c0ab2a4$var$Oe(a), { transitionName: T, showTransition: F } = $f93880154c0ab2a4$var$aa(d), { hideNavigationButtons: _ } = $f93880154c0ab2a4$var$ga(), C = (0, $cc75f711ea0318a4$exports.ref)(null), M = (0, $cc75f711ea0318a4$exports.ref)(null), A = (0, $cc75f711ea0318a4$exports.ref)([]), m = (0, $cc75f711ea0318a4$exports.ref)(null), z = (0, $cc75f711ea0318a4$exports.ref)(!1);
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            n("mount"), !a.timePicker && a.arrowNavigation ? f([
                $f93880154c0ab2a4$var$Le(C.value)
            ], "time") : i(!0, a.timePicker);
        });
        const L = (0, $cc75f711ea0318a4$exports.computed)(()=>h.value.enabled && a.modelAuto ? $f93880154c0ab2a4$var$Rn(a.internalModelValue) : !0), le = (0, $cc75f711ea0318a4$exports.ref)(!1), U = (S)=>({
                hours: Array.isArray(a.hours) ? a.hours[S] : a.hours,
                minutes: Array.isArray(a.minutes) ? a.minutes[S] : a.minutes,
                seconds: Array.isArray(a.seconds) ? a.seconds[S] : a.seconds
            }), $ = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            const S = [];
            if (h.value.enabled) for(let q = 0; q < 2; q++)S.push(U(q));
            else S.push(U(0));
            return S;
        }), ee = (S, q = !1, k = "")=>{
            q || n("reset-flow"), le.value = S, n(S ? "overlay-opened" : "overlay-closed", $f93880154c0ab2a4$var$je.time), a.arrowNavigation && i(S), (0, $cc75f711ea0318a4$exports.nextTick)(()=>{
                k !== "" && A.value[0] && A.value[0].openChildCmp(k);
            });
        }, O = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__btn: !0,
                dp__button: !0,
                dp__button_bottom: a.autoApply && !R.value.keepActionRow
            })), J = $f93880154c0ab2a4$var$et(g, "timePicker"), ce = (S, q, k)=>h.value.enabled ? q === 0 ? [
                S,
                $.value[1][k]
            ] : [
                $.value[0][k],
                S
            ] : S, pe = (S)=>{
            n("update:hours", S);
        }, p = (S)=>{
            n("update:minutes", S);
        }, Y = (S)=>{
            n("update:seconds", S);
        }, te = ()=>{
            if (m.value && !v.value.enabled && !a.noOverlayFocus) {
                const S = $f93880154c0ab2a4$var$Cn(m.value);
                S && S.focus({
                    preventScroll: !0
                });
            }
        }, y = (S)=>{
            z.value = !1, n("overlay-closed", S);
        }, V = (S)=>{
            z.value = !0, n("overlay-opened", S);
        };
        return t({
            toggleTimePicker: ee
        }), (S, q)=>{
            var _s;
            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                class: "dp--tp-wrap",
                "data-dp-mobile": S.isMobile
            }, [
                !S.timePicker && !S.timePickerInline ? (0, $cc75f711ea0318a4$exports.withDirectives)(((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                    key: 0,
                    ref_key: "openTimePickerBtn",
                    ref: C,
                    type: "button",
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)((0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, O.value), {
                        "dp--hidden-el": le.value
                    })),
                    "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(P)) === null || _s === void 0 ? void 0 : _s.openTimePicker,
                    tabindex: S.noOverlayFocus ? void 0 : 0,
                    "data-test-id": "open-time-picker-btn",
                    onKeydown: q[0] || (q[0] = (k)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(k, ()=>ee(!0))),
                    onClick: q[1] || (q[1] = (k)=>ee(!0))
                }, [
                    S.$slots["clock-icon"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(S.$slots, "clock-icon", {
                        key: 0
                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    S.$slots["clock-icon"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$ja), {
                        key: 1
                    }))
                ], 42, $f93880154c0ab2a4$var$Cr)), [
                    [
                        (0, $cc75f711ea0318a4$exports.vShow),
                        !(0, $cc75f711ea0318a4$exports.unref)(_)(S.hideNavigation, "time")
                    ]
                ]) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                (0, $cc75f711ea0318a4$exports.createVNode)((0, $cc75f711ea0318a4$exports.Transition), {
                    name: (0, $cc75f711ea0318a4$exports.unref)(T)(le.value),
                    css: (0, $cc75f711ea0318a4$exports.unref)(F) && !S.timePickerInline
                }, {
                    default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>{
                        var _s, _s1;
                        return [
                            le.value || S.timePicker || S.timePickerInline ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                key: 0,
                                ref_key: "overlayRef",
                                ref: m,
                                role: S.timePickerInline ? void 0 : "dialog",
                                class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                                    dp__overlay: !S.timePickerInline,
                                    "dp--overlay-absolute": !a.timePicker && !S.timePickerInline,
                                    "dp--overlay-relative": a.timePicker
                                }),
                                style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(S.timePicker ? {
                                    height: `${(0, $cc75f711ea0318a4$exports.unref)(R).modeHeight}px`
                                } : void 0),
                                "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(P)) === null || _s === void 0 ? void 0 : _s.timePicker,
                                tabindex: S.timePickerInline ? void 0 : 0
                            }, [
                                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(S.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"),
                                    style: {
                                        display: "flex"
                                    }
                                }, [
                                    S.$slots["time-picker-overlay"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(S.$slots, "time-picker-overlay", {
                                        key: 0,
                                        hours: e.hours,
                                        minutes: e.minutes,
                                        seconds: e.seconds,
                                        setHours: pe,
                                        setMinutes: p,
                                        setSeconds: Y
                                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                    S.$slots["time-picker-overlay"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                        key: 1,
                                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)(S.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                                    }, [
                                        ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)($.value, (k, se)=>(0, $cc75f711ea0318a4$exports.withDirectives)(((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Pr, (0, $cc75f711ea0318a4$exports.mergeProps)({
                                                key: se
                                            }, {
                                                ref_for: !0
                                            }, (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, S.$props), {
                                                order: se,
                                                hours: k.hours,
                                                minutes: k.minutes,
                                                seconds: k.seconds,
                                                closeTimePickerBtn: M.value,
                                                disabledTimesConfig: e.disabledTimesConfig,
                                                disabled: se === 0 ? (0, $cc75f711ea0318a4$exports.unref)(h).fixedStart : (0, $cc75f711ea0318a4$exports.unref)(h).fixedEnd
                                            }), {
                                                ref_for: !0,
                                                ref_key: "timeInputRefs",
                                                ref: A,
                                                "validate-time": (u, re)=>e.validateTime(u, ce(re, se, u)),
                                                "onUpdate:hours": (u)=>pe(ce(u, se, "hours")),
                                                "onUpdate:minutes": (u)=>p(ce(u, se, "minutes")),
                                                "onUpdate:seconds": (u)=>Y(ce(u, se, "seconds")),
                                                onMounted: te,
                                                onOverlayClosed: y,
                                                onOverlayOpened: V,
                                                onAmPmChange: q[2] || (q[2] = (u)=>S.$emit("am-pm-change", u))
                                            }), (0, $cc75f711ea0318a4$exports.createSlots)({
                                                _: 2
                                            }, [
                                                (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(J), (u, re)=>({
                                                        name: u,
                                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)((G)=>[
                                                                (0, $cc75f711ea0318a4$exports.renderSlot)(S.$slots, u, (0, $cc75f711ea0318a4$exports.mergeProps)({
                                                                    ref_for: !0
                                                                }, G))
                                                            ])
                                                    }))
                                            ]), 1040, [
                                                "validate-time",
                                                "onUpdate:hours",
                                                "onUpdate:minutes",
                                                "onUpdate:seconds"
                                            ])), [
                                                [
                                                    (0, $cc75f711ea0318a4$exports.vShow),
                                                    se === 0 ? !0 : L.value
                                                ]
                                            ])), 128))
                                    ], 2)),
                                    !S.timePicker && !S.timePickerInline ? (0, $cc75f711ea0318a4$exports.withDirectives)(((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                                        key: 2,
                                        ref_key: "closeTimePickerBtn",
                                        ref: M,
                                        type: "button",
                                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)((0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, O.value), {
                                            "dp--hidden-el": z.value
                                        })),
                                        "aria-label": (_s1 = (0, $cc75f711ea0318a4$exports.unref)(P)) === null || _s1 === void 0 ? void 0 : _s1.closeTimePicker,
                                        tabindex: "0",
                                        onKeydown: q[3] || (q[3] = (k)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(k, ()=>ee(!1))),
                                        onClick: q[4] || (q[4] = (k)=>ee(!1))
                                    }, [
                                        S.$slots["calendar-icon"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(S.$slots, "calendar-icon", {
                                            key: 0
                                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                        S.$slots["calendar-icon"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$jt), {
                                            key: 1
                                        }))
                                    ], 42, $f93880154c0ab2a4$var$Br)), [
                                        [
                                            (0, $cc75f711ea0318a4$exports.vShow),
                                            !(0, $cc75f711ea0318a4$exports.unref)(_)(S.hideNavigation, "time")
                                        ]
                                    ]) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                                ], 2)
                            ], 14, $f93880154c0ab2a4$var$Or)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                        ];
                    }),
                    _: 3
                }, 8, [
                    "name",
                    "css"
                ])
            ], 8, $f93880154c0ab2a4$var$Rr);
        };
    }
}), $f93880154c0ab2a4$var$Gn = (e, t, l, n)=>{
    const { defaultedRange: a } = $f93880154c0ab2a4$var$Oe(e), f = (m, z)=>Array.isArray(t[m]) ? t[m][z] : t[m], i = (m)=>e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[m] : t.seconds : 0, g = (m, z)=>m ? z !== void 0 ? $f93880154c0ab2a4$var$Mt(m, f("hours", z), f("minutes", z), i(z)) : $f93880154c0ab2a4$var$Mt(m, t.hours, t.minutes, i()) : (0, $9c3b4b128b324703$export$aec44746644cbf43)($f93880154c0ab2a4$var$H(), i(z)), d = (m, z)=>{
        t[m] = z;
    }, P = (0, $cc75f711ea0318a4$exports.computed)(()=>e.modelAuto && a.value.enabled ? Array.isArray(l.value) ? l.value.length > 1 : !1 : a.value.enabled), v = (m, z)=>{
        const L = Object.fromEntries(Object.keys(t).map((le)=>le === m ? [
                le,
                z
            ] : [
                le,
                t[le]
            ].slice()));
        if (P.value && !a.value.disableTimeRangeValidation) {
            const le = ($)=>l.value ? $f93880154c0ab2a4$var$Mt(l.value[$], L.hours[$], L.minutes[$], L.seconds[$]) : null, U = ($)=>(0, $c04bdab14a36bbee$export$de5664029b35e06d)(l.value[$], 0);
            return !($f93880154c0ab2a4$var$$e(le(0), le(1)) && ((0, $dcd5a7c05c821292$export$e4de839670987035)(le(0), U(1)) || (0, $47e0b58359a22142$export$5c007e10c6929c95)(le(1), U(0))));
        }
        return !0;
    }, R = (m, z)=>{
        v(m, z) && (d(m, z), n && n());
    }, h = (m)=>{
        R("hours", m);
    }, T = (m)=>{
        R("minutes", m);
    }, F = (m)=>{
        R("seconds", m);
    }, _ = (m, z, L, le)=>{
        z && h(m), !z && !L && T(m), L && F(m), l.value && le(l.value);
    }, C = (m)=>{
        if (m) {
            const z = Array.isArray(m), L = z ? [
                +m[0].hours,
                +m[1].hours
            ] : +m.hours, le = z ? [
                +m[0].minutes,
                +m[1].minutes
            ] : +m.minutes, U = z ? [
                +m[0].seconds,
                +m[1].seconds
            ] : +m.seconds;
            d("hours", L), d("minutes", le), e.enableSeconds && d("seconds", U);
        }
    }, M = (m, z)=>{
        const L = {
            hours: Array.isArray(t.hours) ? t.hours[m] : t.hours,
            disabledArr: []
        };
        return (z || z === 0) && (L.hours = z), Array.isArray(e.disabledTimes) && (L.disabledArr = a.value.enabled && Array.isArray(e.disabledTimes[m]) ? e.disabledTimes[m] : e.disabledTimes), L;
    }, A = (0, $cc75f711ea0318a4$exports.computed)(()=>(m, z)=>{
            if (Array.isArray(e.disabledTimes)) {
                var _U_;
                const { disabledArr: L, hours: le } = M(m, z), U = L.filter(($)=>+$.hours === le);
                var _U_map, _U_map1;
                return ((_U_ = U[0]) === null || _U_ === void 0 ? void 0 : _U_.minutes) === "*" ? {
                    hours: [
                        le
                    ],
                    minutes: void 0,
                    seconds: void 0
                } : {
                    hours: [],
                    minutes: (_U_map = U === null || U === void 0 ? void 0 : U.map(($)=>+$.minutes)) !== null && _U_map !== void 0 ? _U_map : [],
                    seconds: (_U_map1 = U === null || U === void 0 ? void 0 : U.map(($)=>$.seconds ? +$.seconds : void 0)) !== null && _U_map1 !== void 0 ? _U_map1 : []
                };
            }
            return {
                hours: [],
                minutes: [],
                seconds: []
            };
        });
    return {
        setTime: d,
        updateHours: h,
        updateMinutes: T,
        updateSeconds: F,
        getSetDateTime: g,
        updateTimeValues: _,
        getSecondsValue: i,
        assignStartTime: C,
        validateTime: v,
        disabledTimesConfig: A
    };
}, $f93880154c0ab2a4$var$_r = (e, t)=>{
    const l = ()=>{
        e.isTextInputDate && z();
    }, { modelValue: n, time: a } = $f93880154c0ab2a4$var$na(e, t, l), { defaultedStartTime: f, defaultedRange: i, defaultedTz: g } = $f93880154c0ab2a4$var$Oe(e), { updateTimeValues: d, getSetDateTime: P, setTime: v, assignStartTime: R, disabledTimesConfig: h, validateTime: T } = $f93880154c0ab2a4$var$Gn(e, a, n, F);
    function F() {
        t("update-flow-step");
    }
    const _ = (U)=>{
        const { hours: $, minutes: ee, seconds: O } = U;
        return {
            hours: +$,
            minutes: +ee,
            seconds: O ? +O : 0
        };
    }, C = ()=>{
        if (e.startTime) {
            if (Array.isArray(e.startTime)) {
                const $ = _(e.startTime[0]), ee = _(e.startTime[1]);
                return [
                    (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), $),
                    (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), ee)
                ];
            }
            const U = _(e.startTime);
            return (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), U);
        }
        return i.value.enabled ? [
            null,
            null
        ] : null;
    }, M = ()=>{
        if (i.value.enabled) {
            const [U, $] = C();
            n.value = [
                $f93880154c0ab2a4$var$Ze(P(U, 0), g.value.timezone),
                $f93880154c0ab2a4$var$Ze(P($, 1), g.value.timezone)
            ];
        } else n.value = $f93880154c0ab2a4$var$Ze(P(C()), g.value.timezone);
    }, A = (U)=>Array.isArray(U) ? [
            $f93880154c0ab2a4$var$Bt($f93880154c0ab2a4$var$H(U[0])),
            $f93880154c0ab2a4$var$Bt($f93880154c0ab2a4$var$H(U[1]))
        ] : [
            $f93880154c0ab2a4$var$Bt(U !== null && U !== void 0 ? U : $f93880154c0ab2a4$var$H())
        ], m = (U, $, ee)=>{
        v("hours", U), v("minutes", $), v("seconds", e.enableSeconds ? ee : 0);
    }, z = ()=>{
        const [U, $] = A(n.value);
        return i.value.enabled ? m([
            U.hours,
            $.hours
        ], [
            U.minutes,
            $.minutes
        ], [
            U.seconds,
            $.seconds
        ]) : m(U.hours, U.minutes, U.seconds);
    };
    (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
        if (!e.shadow) return R(f.value), n.value ? z() : M();
    });
    const L = ()=>{
        Array.isArray(n.value) ? n.value = n.value.map((U, $)=>U && P(U, $)) : n.value = P(n.value), t("time-update");
    };
    return {
        modelValue: n,
        time: a,
        disabledTimesConfig: h,
        updateTime: (U, $ = !0, ee = !1)=>{
            d(U, $, ee, L);
        },
        validateTime: T
    };
}, $f93880154c0ab2a4$var$Yr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "TimePickerSolo",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$dt),
    emits: [
        "update:internal-model-value",
        "time-update",
        "am-pm-change",
        "mount",
        "reset-flow",
        "update-flow-step",
        "overlay-toggle"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, f = (0, $cc75f711ea0318a4$exports.useSlots)(), i = $f93880154c0ab2a4$var$et(f, "timePicker"), g = (0, $cc75f711ea0318a4$exports.ref)(null), { time: d, modelValue: P, disabledTimesConfig: v, updateTime: R, validateTime: h } = $f93880154c0ab2a4$var$_r(a, n);
        return (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            a.shadow || n("mount", null);
        }), t({
            getSidebarProps: ()=>({
                    modelValue: P,
                    time: d,
                    updateTime: R
                }),
            toggleTimePicker: (_, C = !1, M = "")=>{
                var _g_value;
                (_g_value = g.value) === null || _g_value === void 0 ? void 0 : _g_value.toggleTimePicker(_, C, M);
            }
        }), (_, C)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ma, {
                "multi-calendars": 0,
                stretch: "",
                "is-mobile": _.isMobile
            }, {
                default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                        (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$Kn, (0, $cc75f711ea0318a4$exports.mergeProps)({
                            ref_key: "tpRef",
                            ref: g
                        }, _.$props, {
                            hours: (0, $cc75f711ea0318a4$exports.unref)(d).hours,
                            minutes: (0, $cc75f711ea0318a4$exports.unref)(d).minutes,
                            seconds: (0, $cc75f711ea0318a4$exports.unref)(d).seconds,
                            "internal-model-value": _.internalModelValue,
                            "disabled-times-config": (0, $cc75f711ea0318a4$exports.unref)(v),
                            "validate-time": (0, $cc75f711ea0318a4$exports.unref)(h),
                            "onUpdate:hours": C[0] || (C[0] = (M)=>(0, $cc75f711ea0318a4$exports.unref)(R)(M)),
                            "onUpdate:minutes": C[1] || (C[1] = (M)=>(0, $cc75f711ea0318a4$exports.unref)(R)(M, !1)),
                            "onUpdate:seconds": C[2] || (C[2] = (M)=>(0, $cc75f711ea0318a4$exports.unref)(R)(M, !1, !0)),
                            onAmPmChange: C[3] || (C[3] = (M)=>_.$emit("am-pm-change", M)),
                            onResetFlow: C[4] || (C[4] = (M)=>_.$emit("reset-flow")),
                            onOverlayClosed: C[5] || (C[5] = (M)=>_.$emit("overlay-toggle", {
                                    open: !1,
                                    overlay: M
                                })),
                            onOverlayOpened: C[6] || (C[6] = (M)=>_.$emit("overlay-toggle", {
                                    open: !0,
                                    overlay: M
                                }))
                        }), (0, $cc75f711ea0318a4$exports.createSlots)({
                            _: 2
                        }, [
                            (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(i), (M, A)=>({
                                    name: M,
                                    fn: (0, $cc75f711ea0318a4$exports.withCtx)((m)=>[
                                            (0, $cc75f711ea0318a4$exports.renderSlot)(_.$slots, M, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(m)))
                                        ])
                                }))
                        ]), 1040, [
                            "hours",
                            "minutes",
                            "seconds",
                            "internal-model-value",
                            "disabled-times-config",
                            "validate-time"
                        ])
                    ]),
                _: 3
            }, 8, [
                "is-mobile"
            ]));
    }
}), $f93880154c0ab2a4$var$Ir = {
    class: "dp--header-wrap"
}, $f93880154c0ab2a4$var$Er = {
    key: 0,
    class: "dp__month_year_wrap"
}, $f93880154c0ab2a4$var$Nr = {
    key: 0
}, $f93880154c0ab2a4$var$Lr = {
    class: "dp__month_year_wrap"
}, $f93880154c0ab2a4$var$Fr = [
    "data-dp-element",
    "aria-label",
    "data-test-id",
    "onClick",
    "onKeydown"
], $f93880154c0ab2a4$var$zr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "DpHeader",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        month: {
            type: Number,
            default: 0
        },
        year: {
            type: Number,
            default: 0
        },
        instance: {
            type: Number,
            default: 0
        },
        years: {
            type: Array,
            default: ()=>[]
        },
        months: {
            type: Array,
            default: ()=>[]
        }
    }, $f93880154c0ab2a4$var$dt),
    emits: [
        "update-month-year",
        "mount",
        "reset-flow",
        "overlay-closed",
        "overlay-opened"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { defaultedTransitions: f, defaultedAriaLabels: i, defaultedMultiCalendars: g, defaultedFilters: d, defaultedConfig: P, defaultedHighlight: v, propDates: R, defaultedUI: h } = $f93880154c0ab2a4$var$Oe(a), { transitionName: T, showTransition: F } = $f93880154c0ab2a4$var$aa(f), { buildMatrix: _ } = $f93880154c0ab2a4$var$At(), { handleMonthYearChange: C, isDisabled: M, updateMonthYear: A } = $f93880154c0ab2a4$var$or(a, n), { showLeftIcon: m, showRightIcon: z } = $f93880154c0ab2a4$var$ga(), L = (0, $cc75f711ea0318a4$exports.ref)(!1), le = (0, $cc75f711ea0318a4$exports.ref)(!1), U = (0, $cc75f711ea0318a4$exports.ref)(!1), $ = (0, $cc75f711ea0318a4$exports.ref)([
            null,
            null,
            null,
            null
        ]);
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            n("mount");
        });
        const ee = (u)=>({
                get: ()=>a[u],
                set: (re)=>{
                    const G = u === $f93880154c0ab2a4$var$ot.month ? $f93880154c0ab2a4$var$ot.year : $f93880154c0ab2a4$var$ot.month;
                    n("update-month-year", {
                        [u]: re,
                        [G]: a[G]
                    }), u === $f93880154c0ab2a4$var$ot.month ? y(!0) : V(!0);
                }
            }), O = (0, $cc75f711ea0318a4$exports.computed)(ee($f93880154c0ab2a4$var$ot.month)), J = (0, $cc75f711ea0318a4$exports.computed)(ee($f93880154c0ab2a4$var$ot.year)), ce = (0, $cc75f711ea0318a4$exports.computed)(()=>(u)=>({
                    month: a.month,
                    year: a.year,
                    items: u === $f93880154c0ab2a4$var$ot.month ? a.months : a.years,
                    instance: a.instance,
                    updateMonthYear: A,
                    toggle: u === $f93880154c0ab2a4$var$ot.month ? y : V
                })), pe = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            const u = a.months.find((re)=>re.value === a.month);
            return u || {
                text: "",
                value: 0
            };
        }), p = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Ht(a.months, (u)=>{
                const re = a.month === u.value, G = $f93880154c0ab2a4$var$Zt(u.value, $f93880154c0ab2a4$var$_n(a.year, R.value.minDate), $f93880154c0ab2a4$var$Yn(a.year, R.value.maxDate)) || d.value.months.includes(u.value), I = $f93880154c0ab2a4$var$Fn(v.value, u.value, a.year);
                return {
                    active: re,
                    disabled: G,
                    highlighted: I
                };
            })), Y = (0, $cc75f711ea0318a4$exports.computed)(()=>$f93880154c0ab2a4$var$Ht(a.years, (u)=>{
                const re = a.year === u.value, G = $f93880154c0ab2a4$var$Zt(u.value, $f93880154c0ab2a4$var$Wt(R.value.minDate), $f93880154c0ab2a4$var$Wt(R.value.maxDate)) || d.value.years.includes(u.value), I = $f93880154c0ab2a4$var$xa(v.value, u.value);
                return {
                    active: re,
                    disabled: G,
                    highlighted: I
                };
            })), te = (u, re, G)=>{
            G !== void 0 ? u.value = G : u.value = !u.value, u.value ? (U.value = !0, n("overlay-opened", re)) : (U.value = !1, n("overlay-closed", re));
        }, y = (u = !1, re)=>{
            S(u), te(L, $f93880154c0ab2a4$var$je.month, re);
        }, V = (u = !1, re)=>{
            S(u), te(le, $f93880154c0ab2a4$var$je.year, re);
        }, S = (u)=>{
            u || n("reset-flow");
        }, q = (u, re)=>{
            a.arrowNavigation && ($.value[re] = $f93880154c0ab2a4$var$Le(u), _($.value, "monthYear"));
        }, k = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _i_value, _i_value_monthPicker, _i_value1, _i_value2, _i_value_yearPicker, _i_value3;
            var _i_value_monthPicker1, _i_value_yearPicker1;
            return [
                {
                    type: $f93880154c0ab2a4$var$ot.month,
                    index: 1,
                    toggle: y,
                    modelValue: O.value,
                    updateModelValue: (u)=>O.value = u,
                    text: pe.value.text,
                    showSelectionGrid: L.value,
                    items: p.value,
                    ariaLabel: (_i_value = i.value) === null || _i_value === void 0 ? void 0 : _i_value.openMonthsOverlay,
                    overlayLabel: (_i_value_monthPicker1 = (_i_value_monthPicker = (_i_value1 = i.value).monthPicker) === null || _i_value_monthPicker === void 0 ? void 0 : _i_value_monthPicker.call(_i_value1, !0)) !== null && _i_value_monthPicker1 !== void 0 ? _i_value_monthPicker1 : void 0
                },
                {
                    type: $f93880154c0ab2a4$var$ot.year,
                    index: 2,
                    toggle: V,
                    modelValue: J.value,
                    updateModelValue: (u)=>J.value = u,
                    text: $f93880154c0ab2a4$var$Ja(a.year, a.locale),
                    showSelectionGrid: le.value,
                    items: Y.value,
                    ariaLabel: (_i_value2 = i.value) === null || _i_value2 === void 0 ? void 0 : _i_value2.openYearsOverlay,
                    overlayLabel: (_i_value_yearPicker1 = (_i_value_yearPicker = (_i_value3 = i.value).yearPicker) === null || _i_value_yearPicker === void 0 ? void 0 : _i_value_yearPicker.call(_i_value3, !0)) !== null && _i_value_yearPicker1 !== void 0 ? _i_value_yearPicker1 : void 0
                }
            ];
        }), se = (0, $cc75f711ea0318a4$exports.computed)(()=>a.disableYearSelect ? [
                k.value[0]
            ] : a.yearFirst ? [
                ...k.value
            ].reverse() : k.value);
        return t({
            toggleMonthPicker: y,
            toggleYearPicker: V,
            handleMonthYearChange: C
        }), (u, re)=>{
            var _s, _s1, _s2, _s3, _s4, _s5;
            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$Ir, [
                u.$slots["month-year"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$Er, [
                    (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "month-year", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)({
                        month: e.month,
                        year: e.year,
                        months: e.months,
                        years: e.years,
                        updateMonthYear: (0, $cc75f711ea0318a4$exports.unref)(A),
                        handleMonthYearChange: (0, $cc75f711ea0318a4$exports.unref)(C),
                        instance: e.instance,
                        isDisabled: (0, $cc75f711ea0318a4$exports.unref)(M)
                    })))
                ])) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                    key: 1
                }, [
                    u.$slots["top-extra"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$Nr, [
                        (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "top-extra", {
                            value: u.internalModelValue
                        })
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", $f93880154c0ab2a4$var$Lr, [
                        (0, $cc75f711ea0318a4$exports.unref)(m)((0, $cc75f711ea0318a4$exports.unref)(g), e.instance) && !u.vertical ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Qt, {
                            key: 0,
                            "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(i)) === null || _s === void 0 ? void 0 : _s.prevMonth,
                            disabled: (0, $cc75f711ea0318a4$exports.unref)(M)(!1),
                            class: (0, $cc75f711ea0318a4$exports.normalizeClass)((_s1 = (0, $cc75f711ea0318a4$exports.unref)(h)) === null || _s1 === void 0 ? void 0 : _s1.navBtnPrev),
                            "el-name": "action-prev",
                            onActivate: re[0] || (re[0] = (G)=>(0, $cc75f711ea0318a4$exports.unref)(C)(!1, !0)),
                            onSetRef: re[1] || (re[1] = (G)=>q(G, 0))
                        }, {
                            default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                    u.$slots["arrow-left"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "arrow-left", {
                                        key: 0
                                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                    u.$slots["arrow-left"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ua), {
                                        key: 1
                                    }))
                                ]),
                            _: 3
                        }, 8, [
                            "aria-label",
                            "disabled",
                            "class"
                        ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                            class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                                "dp__month_year_wrap",
                                {
                                    dp__year_disable_select: u.disableYearSelect
                                }
                            ])
                        }, [
                            ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(se.value, (G, I)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: G.type
                                }, [
                                    (0, $cc75f711ea0318a4$exports.createElementVNode)("button", {
                                        ref_for: !0,
                                        ref: (x)=>q(x, I + 1),
                                        type: "button",
                                        "data-dp-element": `overlay-${G.type}`,
                                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                                            "dp__btn dp__month_year_select",
                                            {
                                                "dp--hidden-el": U.value
                                            }
                                        ]),
                                        "aria-label": `${G.text}-${G.ariaLabel}`,
                                        "data-test-id": `${G.type}-toggle-overlay-${e.instance}`,
                                        onClick: G.toggle,
                                        onKeydown: (x)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(x, ()=>G.toggle(), !0)
                                    }, [
                                        u.$slots[G.type] ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, G.type, {
                                            key: 0,
                                            text: G.text,
                                            value: a[G.type]
                                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                        u.$slots[G.type] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                            key: 1
                                        }, [
                                            (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(G.text), 1)
                                        ], 64))
                                    ], 42, $f93880154c0ab2a4$var$Fr),
                                    (0, $cc75f711ea0318a4$exports.createVNode)((0, $cc75f711ea0318a4$exports.Transition), {
                                        name: (0, $cc75f711ea0318a4$exports.unref)(T)(G.showSelectionGrid),
                                        css: (0, $cc75f711ea0318a4$exports.unref)(F)
                                    }, {
                                        default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                                G.showSelectionGrid ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ta, {
                                                    key: 0,
                                                    items: G.items,
                                                    "arrow-navigation": u.arrowNavigation,
                                                    "hide-navigation": u.hideNavigation,
                                                    "is-last": u.autoApply && !(0, $cc75f711ea0318a4$exports.unref)(P).keepActionRow,
                                                    "skip-button-ref": !1,
                                                    config: u.config,
                                                    type: G.type,
                                                    "header-refs": [],
                                                    "esc-close": u.escClose,
                                                    "menu-wrap-ref": u.menuWrapRef,
                                                    "text-input": u.textInput,
                                                    "aria-labels": u.ariaLabels,
                                                    "overlay-label": G.overlayLabel,
                                                    onSelected: G.updateModelValue,
                                                    onToggle: G.toggle
                                                }, (0, $cc75f711ea0318a4$exports.createSlots)({
                                                    "button-icon": (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                                            u.$slots["calendar-icon"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "calendar-icon", {
                                                                key: 0
                                                            }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                                            u.$slots["calendar-icon"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$jt), {
                                                                key: 1
                                                            }))
                                                        ]),
                                                    _: 2
                                                }, [
                                                    u.$slots[`${G.type}-overlay-value`] ? {
                                                        name: "item",
                                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)(({ item: x })=>[
                                                                (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, `${G.type}-overlay-value`, {
                                                                    text: x.text,
                                                                    value: x.value
                                                                })
                                                            ]),
                                                        key: "0"
                                                    } : void 0,
                                                    u.$slots[`${G.type}-overlay`] ? {
                                                        name: "overlay",
                                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                                                (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, `${G.type}-overlay`, (0, $cc75f711ea0318a4$exports.mergeProps)({
                                                                    ref_for: !0
                                                                }, ce.value(G.type)))
                                                            ]),
                                                        key: "1"
                                                    } : void 0,
                                                    u.$slots[`${G.type}-overlay-header`] ? {
                                                        name: "header",
                                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                                                (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, `${G.type}-overlay-header`, {
                                                                    toggle: G.toggle
                                                                })
                                                            ]),
                                                        key: "2"
                                                    } : void 0
                                                ]), 1032, [
                                                    "items",
                                                    "arrow-navigation",
                                                    "hide-navigation",
                                                    "is-last",
                                                    "config",
                                                    "type",
                                                    "esc-close",
                                                    "menu-wrap-ref",
                                                    "text-input",
                                                    "aria-labels",
                                                    "overlay-label",
                                                    "onSelected",
                                                    "onToggle"
                                                ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "name",
                                        "css"
                                    ])
                                ], 64))), 128))
                        ], 2),
                        (0, $cc75f711ea0318a4$exports.unref)(m)((0, $cc75f711ea0318a4$exports.unref)(g), e.instance) && u.vertical ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Qt, {
                            key: 1,
                            "aria-label": (_s2 = (0, $cc75f711ea0318a4$exports.unref)(i)) === null || _s2 === void 0 ? void 0 : _s2.prevMonth,
                            "el-name": "action-prev",
                            disabled: (0, $cc75f711ea0318a4$exports.unref)(M)(!1),
                            class: (0, $cc75f711ea0318a4$exports.normalizeClass)((_s3 = (0, $cc75f711ea0318a4$exports.unref)(h)) === null || _s3 === void 0 ? void 0 : _s3.navBtnPrev),
                            onActivate: re[2] || (re[2] = (G)=>(0, $cc75f711ea0318a4$exports.unref)(C)(!1, !0))
                        }, {
                            default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                    u.$slots["arrow-up"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, "arrow-up", {
                                        key: 0
                                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                    u.$slots["arrow-up"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ka), {
                                        key: 1
                                    }))
                                ]),
                            _: 3
                        }, 8, [
                            "aria-label",
                            "disabled",
                            "class"
                        ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        (0, $cc75f711ea0318a4$exports.unref)(z)((0, $cc75f711ea0318a4$exports.unref)(g), e.instance) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Qt, {
                            key: 2,
                            ref: "rightIcon",
                            "el-name": "action-next",
                            disabled: (0, $cc75f711ea0318a4$exports.unref)(M)(!0),
                            "aria-label": (_s4 = (0, $cc75f711ea0318a4$exports.unref)(i)) === null || _s4 === void 0 ? void 0 : _s4.nextMonth,
                            class: (0, $cc75f711ea0318a4$exports.normalizeClass)((_s5 = (0, $cc75f711ea0318a4$exports.unref)(h)) === null || _s5 === void 0 ? void 0 : _s5.navBtnNext),
                            onActivate: re[3] || (re[3] = (G)=>(0, $cc75f711ea0318a4$exports.unref)(C)(!0, !0)),
                            onSetRef: re[4] || (re[4] = (G)=>q(G, u.disableYearSelect ? 2 : 3))
                        }, {
                            default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                    u.$slots[u.vertical ? "arrow-down" : "arrow-right"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(u.$slots, u.vertical ? "arrow-down" : "arrow-right", {
                                        key: 0
                                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                    u.$slots[u.vertical ? "arrow-down" : "arrow-right"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.resolveDynamicComponent)(u.vertical ? (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ga) : (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Va)), {
                                        key: 1
                                    }))
                                ]),
                            _: 3
                        }, 8, [
                            "disabled",
                            "aria-label",
                            "class"
                        ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                    ])
                ], 64))
            ]);
        };
    }
}), $f93880154c0ab2a4$var$Hr = {
    class: "dp__calendar_header",
    role: "row"
}, $f93880154c0ab2a4$var$Wr = {
    key: 0,
    class: "dp__calendar_header_item",
    role: "gridcell"
}, $f93880154c0ab2a4$var$Ur = [
    "aria-label"
], $f93880154c0ab2a4$var$Vr = {
    key: 0,
    class: "dp__calendar_item dp__week_num",
    role: "gridcell"
}, $f93880154c0ab2a4$var$jr = {
    class: "dp__cell_inner"
}, $f93880154c0ab2a4$var$Kr = [
    "id",
    "aria-selected",
    "aria-disabled",
    "aria-label",
    "tabindex",
    "data-test-id",
    "onClick",
    "onTouchend",
    "onKeydown",
    "onMouseenter",
    "onMouseleave",
    "onMousedown"
], $f93880154c0ab2a4$var$Gr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "DpCalendar",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        mappedDates: {
            type: Array,
            default: ()=>[]
        },
        instance: {
            type: Number,
            default: 0
        },
        month: {
            type: Number,
            default: 0
        },
        year: {
            type: Number,
            default: 0
        }
    }, $f93880154c0ab2a4$var$dt),
    emits: [
        "select-date",
        "set-hover-date",
        "handle-scroll",
        "mount",
        "handle-swipe",
        "handle-space",
        "tooltip-open",
        "tooltip-close"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { buildMultiLevelMatrix: f } = $f93880154c0ab2a4$var$At(), { defaultedTransitions: i, defaultedConfig: g, defaultedAriaLabels: d, defaultedMultiCalendars: P, defaultedWeekNumbers: v, defaultedMultiDates: R, defaultedUI: h } = $f93880154c0ab2a4$var$Oe(a), T = (0, $cc75f711ea0318a4$exports.ref)(null), F = (0, $cc75f711ea0318a4$exports.ref)({
            bottom: "",
            left: "",
            transform: ""
        }), _ = (0, $cc75f711ea0318a4$exports.ref)([]), C = (0, $cc75f711ea0318a4$exports.ref)(null), M = (0, $cc75f711ea0318a4$exports.ref)(!0), A = (0, $cc75f711ea0318a4$exports.ref)(""), m = (0, $cc75f711ea0318a4$exports.ref)({
            startX: 0,
            endX: 0,
            startY: 0,
            endY: 0
        }), z = (0, $cc75f711ea0318a4$exports.ref)([]), L = (0, $cc75f711ea0318a4$exports.ref)({
            left: "50%"
        }), le = (0, $cc75f711ea0318a4$exports.ref)(!1), U = (0, $cc75f711ea0318a4$exports.computed)(()=>a.calendar ? a.calendar(a.mappedDates) : a.mappedDates), $ = (0, $cc75f711ea0318a4$exports.computed)(()=>a.dayNames ? Array.isArray(a.dayNames) ? a.dayNames : a.dayNames(a.locale, +a.weekStart) : $f93880154c0ab2a4$var$Tl(a.formatLocale, a.locale, +a.weekStart));
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            n("mount", {
                cmp: "calendar",
                refs: _
            }), g.value.noSwipe || C.value && (C.value.addEventListener("touchstart", q, {
                passive: !1
            }), C.value.addEventListener("touchend", k, {
                passive: !1
            }), C.value.addEventListener("touchmove", se, {
                passive: !1
            })), a.monthChangeOnScroll && C.value && C.value.addEventListener("wheel", G, {
                passive: !1
            });
        }), (0, $cc75f711ea0318a4$exports.onUnmounted)(()=>{
            g.value.noSwipe || C.value && (C.value.removeEventListener("touchstart", q), C.value.removeEventListener("touchend", k), C.value.removeEventListener("touchmove", se)), a.monthChangeOnScroll && C.value && C.value.removeEventListener("wheel", G);
        });
        const ee = (B)=>B ? a.vertical ? "vNext" : "next" : a.vertical ? "vPrevious" : "previous", O = (B, be)=>{
            if (a.transitions) {
                const Ae = $f93880154c0ab2a4$var$Fe($f93880154c0ab2a4$var$pt($f93880154c0ab2a4$var$H(), a.month, a.year));
                A.value = $f93880154c0ab2a4$var$Ee($f93880154c0ab2a4$var$Fe($f93880154c0ab2a4$var$pt($f93880154c0ab2a4$var$H(), B, be)), Ae) ? i.value[ee(!0)] : i.value[ee(!1)], M.value = !1, (0, $cc75f711ea0318a4$exports.nextTick)(()=>{
                    M.value = !0;
                });
            }
        }, J = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _h_value_calendar;
            return (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, (_h_value_calendar = h.value.calendar) !== null && _h_value_calendar !== void 0 ? _h_value_calendar : {});
        }), ce = (0, $cc75f711ea0318a4$exports.computed)(()=>(B)=>{
                const be = $f93880154c0ab2a4$var$Pl(B);
                return {
                    dp__marker_dot: be.type === "dot",
                    dp__marker_line: be.type === "line"
                };
            }), pe = (0, $cc75f711ea0318a4$exports.computed)(()=>(B)=>$f93880154c0ab2a4$var$$e(B, T.value)), p = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__calendar: !0,
                dp__calendar_next: P.value.count > 0 && a.instance !== 0
            })), Y = (0, $cc75f711ea0318a4$exports.computed)(()=>(B)=>a.hideOffsetDates ? B.current : !0), te = async (B, be)=>{
            const { width: Ae, height: ne } = B.getBoundingClientRect();
            T.value = be.value;
            let r = {
                left: `${Ae / 2}px`
            }, E = -50;
            if (await (0, $cc75f711ea0318a4$exports.nextTick)(), z.value[0]) {
                const { left: K, width: oe } = z.value[0].getBoundingClientRect();
                K < 0 && (r = {
                    left: "0"
                }, E = 0, L.value.left = `${Ae / 2}px`), window.innerWidth < K + oe && (r = {
                    right: "0"
                }, E = 0, L.value.left = `${oe - Ae / 2}px`);
            }
            F.value = (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({
                bottom: `${ne}px`
            }, r), {
                transform: `translateX(${E}%)`
            });
        }, y = async (B, be, Ae)=>{
            var _B_marker, _B_marker_tooltip, _B_marker1;
            const ne = $f93880154c0ab2a4$var$Le(_.value[be][Ae]);
            ne && (((_B_marker = B.marker) === null || _B_marker === void 0 ? void 0 : _B_marker.customPosition) && ((_B_marker1 = B.marker) === null || _B_marker1 === void 0 ? void 0 : (_B_marker_tooltip = _B_marker1.tooltip) === null || _B_marker_tooltip === void 0 ? void 0 : _B_marker_tooltip.length) ? F.value = B.marker.customPosition(ne) : await te(ne, B), n("tooltip-open", B.marker));
        }, V = async (B, be, Ae)=>{
            var _B_marker_tooltip, _B_marker;
            if (le.value && R.value.enabled && R.value.dragSelect) return n("select-date", B);
            if (n("set-hover-date", B), (_B_marker = B.marker) === null || _B_marker === void 0 ? void 0 : (_B_marker_tooltip = _B_marker.tooltip) === null || _B_marker_tooltip === void 0 ? void 0 : _B_marker_tooltip.length) {
                if (a.hideOffsetDates && !B.current) return;
                await y(B, be, Ae);
            }
        }, S = (B)=>{
            T.value && (T.value = null, F.value = JSON.parse(JSON.stringify({
                bottom: "",
                left: "",
                transform: ""
            })), n("tooltip-close", B.marker));
        }, q = (B)=>{
            m.value.startX = B.changedTouches[0].screenX, m.value.startY = B.changedTouches[0].screenY;
        }, k = (B)=>{
            m.value.endX = B.changedTouches[0].screenX, m.value.endY = B.changedTouches[0].screenY, u();
        }, se = (B)=>{
            a.vertical && !a.inline && B.preventDefault();
        }, u = ()=>{
            const B = a.vertical ? "Y" : "X";
            Math.abs(m.value[`start${B}`] - m.value[`end${B}`]) > 10 && n("handle-swipe", m.value[`start${B}`] > m.value[`end${B}`] ? "right" : "left");
        }, re = (B, be, Ae)=>{
            B && (Array.isArray(_.value[be]) ? _.value[be][Ae] = B : _.value[be] = [
                B
            ]), a.arrowNavigation && f(_.value, "calendar");
        }, G = (B)=>{
            a.monthChangeOnScroll && (B.preventDefault(), n("handle-scroll", B));
        }, I = (B)=>v.value.type === "local" ? (0, $88fcf406e8c91795$export$efe19b760242b2fc)(B.value, {
                weekStartsOn: +a.weekStart
            }) : v.value.type === "iso" ? (0, $98028344a9fe549c$export$7cabdc5698b63e2f)(B.value) : typeof v.value.type == "function" ? v.value.type(B.value) : "", x = (B)=>{
            const be = B[0];
            return v.value.hideOnOffsetDates ? B.some((Ae)=>Ae.current) ? I(be) : "" : I(be);
        }, c = (B, be, Ae = !0)=>{
            !Ae && $f93880154c0ab2a4$var$_l() || (!R.value.enabled || g.value.allowPreventDefault) && ($f93880154c0ab2a4$var$Dt(B, g.value), n("select-date", be));
        }, o = (B)=>{
            $f93880154c0ab2a4$var$Dt(B, g.value);
        }, X = (B)=>{
            R.value.enabled && R.value.dragSelect ? (le.value = !0, n("select-date", B)) : R.value.enabled && n("select-date", B);
        };
        return t({
            triggerTransition: O
        }), (B, be)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                class: (0, $cc75f711ea0318a4$exports.normalizeClass)(p.value)
            }, [
                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                    ref_key: "calendarWrapRef",
                    ref: C,
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(J.value),
                    role: "grid"
                }, [
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", $f93880154c0ab2a4$var$Hr, [
                        B.weekNumbers ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$Wr, (0, $cc75f711ea0318a4$exports.toDisplayString)(B.weekNumName), 1)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)($.value, (Ae, ne)=>{
                            var _s_weekDay, _s;
                            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                key: ne,
                                class: "dp__calendar_header_item",
                                role: "gridcell",
                                "data-test-id": "calendar-header",
                                "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s === void 0 ? void 0 : (_s_weekDay = _s.weekDay) === null || _s_weekDay === void 0 ? void 0 : _s_weekDay.call(_s, ne)
                            }, [
                                B.$slots["calendar-header"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(B.$slots, "calendar-header", {
                                    key: 0,
                                    day: Ae,
                                    index: ne
                                }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                B.$slots["calendar-header"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                    key: 1
                                }, [
                                    (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(Ae), 1)
                                ], 64))
                            ], 8, $f93880154c0ab2a4$var$Ur);
                        }), 128))
                    ]),
                    be[2] || (be[2] = (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                        class: "dp__calendar_header_separator"
                    }, null, -1)),
                    (0, $cc75f711ea0318a4$exports.createVNode)((0, $cc75f711ea0318a4$exports.Transition), {
                        name: A.value,
                        css: !!B.transitions
                    }, {
                        default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                M.value ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                    key: 0,
                                    class: "dp__calendar",
                                    role: "rowgroup",
                                    onMouseleave: be[1] || (be[1] = (Ae)=>le.value = !1)
                                }, [
                                    ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(U.value, (Ae, ne)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                            key: ne,
                                            class: "dp__calendar_row",
                                            role: "row"
                                        }, [
                                            B.weekNumbers ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$Vr, [
                                                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", $f93880154c0ab2a4$var$jr, (0, $cc75f711ea0318a4$exports.toDisplayString)(x(Ae.days)), 1)
                                            ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                            ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(Ae.days, (r, E)=>{
                                                var _s_day, _s, _r_marker;
                                                var _ref;
                                                return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                                    id: (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ha)(r.value),
                                                    ref_for: !0,
                                                    ref: (K)=>re(K, ne, E),
                                                    key: E + ne,
                                                    role: "gridcell",
                                                    class: "dp__calendar_item",
                                                    "aria-selected": (_ref = r.classData.dp__active_date || r.classData.dp__range_start || r.classData.dp__range_end) !== null && _ref !== void 0 ? _ref : void 0,
                                                    "aria-disabled": r.classData.dp__cell_disabled || void 0,
                                                    "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(d)) === null || _s === void 0 ? void 0 : (_s_day = _s.day) === null || _s_day === void 0 ? void 0 : _s_day.call(_s, r),
                                                    tabindex: !r.current && B.hideOffsetDates ? void 0 : 0,
                                                    "data-test-id": (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ha)(r.value),
                                                    onClick: (0, $cc75f711ea0318a4$exports.withModifiers)((K)=>c(K, r), [
                                                        "prevent"
                                                    ]),
                                                    onTouchend: (K)=>c(K, r, !1),
                                                    onKeydown: (K)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(K, ()=>B.$emit("select-date", r)),
                                                    onMouseenter: (K)=>V(r, ne, E),
                                                    onMouseleave: (K)=>S(r),
                                                    onMousedown: (K)=>X(r),
                                                    onMouseup: be[0] || (be[0] = (K)=>le.value = !1)
                                                }, [
                                                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                                                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                                                            "dp__cell_inner",
                                                            r.classData
                                                        ])
                                                    }, [
                                                        B.$slots.day && Y.value(r) ? (0, $cc75f711ea0318a4$exports.renderSlot)(B.$slots, "day", {
                                                            key: 0,
                                                            day: +r.text,
                                                            date: r.value
                                                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                                        B.$slots.day ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                                            key: 1
                                                        }, [
                                                            (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)(r.text), 1)
                                                        ], 64)),
                                                        r.marker && Y.value(r) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                                            key: 2
                                                        }, [
                                                            B.$slots.marker ? (0, $cc75f711ea0318a4$exports.renderSlot)(B.$slots, "marker", {
                                                                key: 0,
                                                                marker: r.marker,
                                                                day: +r.text,
                                                                date: r.value
                                                            }) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                                                key: 1,
                                                                class: (0, $cc75f711ea0318a4$exports.normalizeClass)(ce.value(r.marker)),
                                                                style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(r.marker.color ? {
                                                                    backgroundColor: r.marker.color
                                                                } : {})
                                                            }, null, 6))
                                                        ], 64)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                                        pe.value(r.value) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                                            key: 3,
                                                            ref_for: !0,
                                                            ref_key: "activeTooltip",
                                                            ref: z,
                                                            class: "dp__marker_tooltip",
                                                            style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(F.value)
                                                        }, [
                                                            ((_r_marker = r.marker) === null || _r_marker === void 0 ? void 0 : _r_marker.tooltip) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                                                key: 0,
                                                                class: "dp__tooltip_content",
                                                                onClick: o
                                                            }, [
                                                                ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(r.marker.tooltip, (K, oe)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                                                        key: oe,
                                                                        class: "dp__tooltip_text"
                                                                    }, [
                                                                        B.$slots["marker-tooltip"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(B.$slots, "marker-tooltip", {
                                                                            key: 0,
                                                                            tooltip: K,
                                                                            day: r.value
                                                                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                                                                        B.$slots["marker-tooltip"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                                                            key: 1
                                                                        }, [
                                                                            (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                                                                                class: "dp__tooltip_mark",
                                                                                style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(K.color ? {
                                                                                    backgroundColor: K.color
                                                                                } : {})
                                                                            }, null, 4),
                                                                            (0, $cc75f711ea0318a4$exports.createElementVNode)("div", null, (0, $cc75f711ea0318a4$exports.toDisplayString)(K.text), 1)
                                                                        ], 64))
                                                                    ]))), 128)),
                                                                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                                                                    class: "dp__arrow_bottom_tp",
                                                                    style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(L.value)
                                                                }, null, 4)
                                                            ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                                                        ], 4)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                                                    ], 2)
                                                ], 40, $f93880154c0ab2a4$var$Kr);
                                            }), 128))
                                        ]))), 128))
                                ], 32)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                            ]),
                        _: 3
                    }, 8, [
                        "name",
                        "css"
                    ])
                ], 2)
            ], 2));
    }
}), $f93880154c0ab2a4$var$yn = (e)=>Array.isArray(e), $f93880154c0ab2a4$var$Qr = (e, t, l, n)=>{
    const a = (0, $cc75f711ea0318a4$exports.ref)([]), f = (0, $cc75f711ea0318a4$exports.ref)(/* @__PURE__ */ new Date()), i = (0, $cc75f711ea0318a4$exports.ref)(), g = ()=>k(e.isTextInputDate), { modelValue: d, calendars: P, time: v, today: R } = $f93880154c0ab2a4$var$na(e, t, g), { defaultedMultiCalendars: h, defaultedStartTime: T, defaultedRange: F, defaultedConfig: _, defaultedTz: C, propDates: M, defaultedMultiDates: A } = $f93880154c0ab2a4$var$Oe(e), { validateMonthYearInRange: m, isDisabled: z, isDateRangeAllowed: L, checkMinMaxRange: le } = $f93880154c0ab2a4$var$Tt(e), { updateTimeValues: U, getSetDateTime: $, setTime: ee, assignStartTime: O, validateTime: J, disabledTimesConfig: ce } = $f93880154c0ab2a4$var$Gn(e, v, d, n), pe = (0, $cc75f711ea0318a4$exports.computed)(()=>(b)=>P.value[b] ? P.value[b].month : 0), p = (0, $cc75f711ea0318a4$exports.computed)(()=>(b)=>P.value[b] ? P.value[b].year : 0), Y = (b)=>!_.value.keepViewOnOffsetClick || b ? !0 : !i.value, te = (b, ae, ve, N = !1)=>{
        var _P_value_b, _P_value_b1;
        Y(N) && (P.value[b] || (P.value[b] = {
            month: 0,
            year: 0
        }), P.value[b].month = $f93880154c0ab2a4$var$cn(ae) ? (_P_value_b = P.value[b]) === null || _P_value_b === void 0 ? void 0 : _P_value_b.month : ae, P.value[b].year = $f93880154c0ab2a4$var$cn(ve) ? (_P_value_b1 = P.value[b]) === null || _P_value_b1 === void 0 ? void 0 : _P_value_b1.year : ve);
    }, y = ()=>{
        e.autoApply && t("select-date");
    }, V = ()=>{
        T.value && O(T.value);
    };
    (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
        e.shadow || (d.value || (be(), V()), k(!0), e.focusStartDate && e.startDate && be());
    });
    const S = (0, $cc75f711ea0318a4$exports.computed)(()=>{
        var _e_flow;
        return ((_e_flow = e.flow) === null || _e_flow === void 0 ? void 0 : _e_flow.length) && !e.partialFlow ? e.flowStep === e.flow.length : !0;
    }), q = ()=>{
        e.autoApply && S.value && t("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
    }, k = (b = !1)=>{
        if (d.value) return Array.isArray(d.value) ? (a.value = d.value, c(b)) : re(d.value, b);
        if (h.value.count && b && !e.startDate) return u($f93880154c0ab2a4$var$H(), b);
    }, se = ()=>{
        var _d_value_;
        return Array.isArray(d.value) && F.value.enabled ? (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(d.value[0]) === (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)((_d_value_ = d.value[1]) !== null && _d_value_ !== void 0 ? _d_value_ : d.value[0]) : !1;
    }, u = (b = /* @__PURE__ */ new Date(), ae = !1)=>{
        if ((!h.value.count || !h.value.static || ae) && te(0, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(b), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(b)), h.value.count && (!d.value || se() || !h.value.solo) && (!h.value.solo || ae)) for(let ve = 1; ve < h.value.count; ve++){
            const N = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
                month: pe.value(ve - 1),
                year: p.value(ve - 1)
            }), ue = (0, $cd621c9cd579be00$export$e16d8520af44a096)(N, {
                months: 1
            });
            P.value[ve] = {
                month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(ue),
                year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(ue)
            };
        }
    }, re = (b, ae)=>{
        u(b), ee("hours", (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)(b)), ee("minutes", (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145)(b)), ee("seconds", (0, $9b5188e8ef63b656$export$5e9417507ff28427)(b)), h.value.count && ae && B();
    }, G = (b)=>{
        if (h.value.count) {
            if (h.value.solo) return 0;
            const ae = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(b[0]), ve = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(b[1]);
            return Math.abs(ve - ae) < h.value.count ? 0 : 1;
        }
        return 1;
    }, I = (b, ae)=>{
        b[1] && F.value.showLastInRange ? u(b[G(b)], ae) : u(b[0], ae);
        const ve = (N, ue)=>[
                N(b[0]),
                b[1] ? N(b[1]) : v[ue][1]
            ];
        ee("hours", ve((0, $bda6db0cdfc5a459$export$257b40f71c07d58f), "hours")), ee("minutes", ve((0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145), "minutes")), ee("seconds", ve((0, $9b5188e8ef63b656$export$5e9417507ff28427), "seconds"));
    }, x = (b, ae)=>{
        if ((F.value.enabled || e.weekPicker) && !A.value.enabled) return I(b, ae);
        if (A.value.enabled && ae) {
            const ve = b[b.length - 1];
            return re(ve, ae);
        }
    }, c = (b)=>{
        const ae = d.value;
        x(ae, b), h.value.count && h.value.solo && B();
    }, o = (b, ae)=>{
        const ve = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
            month: pe.value(ae),
            year: p.value(ae)
        }), N = b < 0 ? (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(ve, 1) : (0, $68126b797c1a3763$export$73d1c15a21f9fae5)(ve, 1);
        m((0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(N), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(N), b < 0, e.preventMinMaxNavigation) && (te(ae, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(N), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(N)), t("update-month-year", {
            instance: ae,
            month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(N),
            year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(N)
        }), h.value.count && !h.value.solo && X(ae), l());
    }, X = (b)=>{
        for(let ae = b - 1; ae >= 0; ae--){
            const ve = (0, $68126b797c1a3763$export$73d1c15a21f9fae5)((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
                month: pe.value(ae + 1),
                year: p.value(ae + 1)
            }), 1);
            te(ae, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(ve), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(ve));
        }
        for(let ae = b + 1; ae <= h.value.count - 1; ae++){
            const ve = (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(), {
                month: pe.value(ae - 1),
                year: p.value(ae - 1)
            }), 1);
            te(ae, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(ve), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(ve));
        }
    }, B = ()=>{
        if (Array.isArray(d.value) && d.value.length === 2) {
            const b = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$H(d.value[1] ? d.value[1] : (0, $d6cc99e193ff1a7d$export$17c93e242b2d3a22)(d.value[0], 1))), [ae, ve] = [
                (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(d.value[0]),
                (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(d.value[0])
            ], [N, ue] = [
                (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(d.value[1]),
                (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(d.value[1])
            ];
            (ae !== N || ae === N && ve !== ue) && h.value.solo && te(1, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(b), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(b));
        } else d.value && !Array.isArray(d.value) && (te(0, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(d.value), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(d.value)), u($f93880154c0ab2a4$var$H()));
    }, be = ()=>{
        e.startDate && (te(0, (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)($f93880154c0ab2a4$var$H(e.startDate)), (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(e.startDate))), h.value.count && X(0));
    }, Ae = (b, ae)=>{
        if (e.monthChangeOnScroll) {
            const ve = /* @__PURE__ */ new Date().getTime() - f.value.getTime(), N = Math.abs(b.deltaY);
            let ue = 500;
            N > 1 && (ue = 100), N > 100 && (ue = 0), ve > ue && (f.value = /* @__PURE__ */ new Date(), o(e.monthChangeOnScroll !== "inverse" ? -b.deltaY : b.deltaY, ae));
        }
    }, ne = (b, ae, ve = !1)=>{
        e.monthChangeOnArrows && e.vertical === ve && r(b, ae);
    }, r = (b, ae)=>{
        o(b === "right" ? -1 : 1, ae);
    }, E = (b)=>{
        if (M.value.markers) return $f93880154c0ab2a4$var$ca(b.value, M.value.markers);
    }, K = (b, ae)=>{
        switch(e.sixWeeks === !0 ? "append" : e.sixWeeks){
            case "prepend":
                return [
                    !0,
                    !1
                ];
            case "center":
                return [
                    b == 0,
                    !0
                ];
            case "fair":
                return [
                    b == 0 || ae > b,
                    !0
                ];
            case "append":
                return [
                    !1,
                    !1
                ];
            default:
                return [
                    !1,
                    !1
                ];
        }
    }, oe = (b, ae, ve, N)=>{
        if (e.sixWeeks && b.length < 6) {
            const ue = 6 - b.length, me = (ae.getDay() + 7 - N) % 7, ct = 6 - (ve.getDay() + 7 - N) % 7, [Pt, $a] = K(me, ct);
            for(let Rt = 1; Rt <= ue; Rt++)if ($a ? !!(Rt % 2) == Pt : Pt) {
                const ra = b[0].days[0], Aa = ge((0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(ra.value, -7), (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(ae));
                b.unshift({
                    days: Aa
                });
            } else {
                const ra = b[b.length - 1], Aa = ra.days[ra.days.length - 1], Xn = ge((0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(Aa.value, 1), (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(ae));
                b.push({
                    days: Xn
                });
            }
        }
        return b;
    }, ge = (b, ae)=>{
        const ve = $f93880154c0ab2a4$var$H(b), N = [];
        for(let ue = 0; ue < 7; ue++){
            const me = (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(ve, ue), vt = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(me) !== ae;
            N.push({
                text: e.hideOffsetDates && vt ? "" : me.getDate(),
                value: me,
                current: !vt,
                classData: {}
            });
        }
        return N;
    }, _e = (b, ae)=>{
        const ve = [], N = new Date(ae, b), ue = new Date(ae, b + 1, 0), me = e.weekStart, vt = (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(N, {
            weekStartsOn: me
        }), ct = (Pt)=>{
            const $a = ge(Pt, b);
            if (ve.push({
                days: $a
            }), !ve[ve.length - 1].days.some((Rt)=>$f93880154c0ab2a4$var$$e($f93880154c0ab2a4$var$Fe(Rt.value), $f93880154c0ab2a4$var$Fe(ue)))) {
                const Rt = (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(Pt, 7);
                ct(Rt);
            }
        };
        return ct(vt), oe(ve, N, ue, me);
    }, Ye = (b)=>{
        const ae = $f93880154c0ab2a4$var$Mt($f93880154c0ab2a4$var$H(b.value), v.hours, v.minutes, xe());
        t("date-update", ae), A.value.enabled ? $f93880154c0ab2a4$var$en(ae, d, A.value.limit) : d.value = ae, n(), (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
            q();
        });
    }, nt = (b)=>F.value.noDisabledRange ? $f93880154c0ab2a4$var$In(a.value[0], b).some((ve)=>z(ve)) : !1, St = ()=>{
        a.value = d.value ? d.value.slice() : [], a.value.length === 2 && !(F.value.fixedStart || F.value.fixedEnd) && (a.value = []);
    }, D = (b, ae)=>{
        const ve = [
            $f93880154c0ab2a4$var$H(b.value),
            (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)($f93880154c0ab2a4$var$H(b.value), +F.value.autoRange)
        ];
        L(ve) ? (ae && de(b.value), a.value = ve) : t("invalid-date", b.value);
    }, de = (b)=>{
        const ae = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)($f93880154c0ab2a4$var$H(b)), ve = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)($f93880154c0ab2a4$var$H(b));
        if (te(0, ae, ve), h.value.count > 0) for(let N = 1; N < h.value.count; N++){
            const ue = $f93880154c0ab2a4$var$El((0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)($f93880154c0ab2a4$var$H(b), {
                year: p.value(N - 1),
                month: pe.value(N - 1)
            }));
            te(N, ue.month, ue.year);
        }
    }, fe = (b)=>{
        if (nt(b.value) || !le(b.value, d.value, F.value.fixedStart ? 0 : 1)) return t("invalid-date", b.value);
        a.value = $f93880154c0ab2a4$var$Vn($f93880154c0ab2a4$var$H(b.value), d, t, F);
    }, ht = (b, ae)=>{
        if (St(), F.value.autoRange) return D(b, ae);
        if (F.value.fixedStart || F.value.fixedEnd) return fe(b);
        a.value[0] ? le($f93880154c0ab2a4$var$H(b.value), d.value) && !nt(b.value) ? $f93880154c0ab2a4$var$Be($f93880154c0ab2a4$var$H(b.value), $f93880154c0ab2a4$var$H(a.value[0])) ? (a.value.unshift($f93880154c0ab2a4$var$H(b.value)), t("range-end", a.value[0])) : (a.value[1] = $f93880154c0ab2a4$var$H(b.value), t("range-end", a.value[1])) : (e.autoApply && t("auto-apply-invalid", b.value), t("invalid-date", b.value)) : (a.value[0] = $f93880154c0ab2a4$var$H(b.value), t("range-start", a.value[0]));
    }, xe = (b = !0)=>e.enableSeconds ? Array.isArray(v.seconds) ? b ? v.seconds[0] : v.seconds[1] : v.seconds : 0, Xe = (b)=>{
        a.value[b] = $f93880154c0ab2a4$var$Mt(a.value[b], v.hours[b], v.minutes[b], xe(b !== 1));
    }, ya = ()=>{
        var _a_value, _a_value1;
        a.value[0] && a.value[1] && +((_a_value = a.value) === null || _a_value === void 0 ? void 0 : _a_value[0]) > +((_a_value1 = a.value) === null || _a_value1 === void 0 ? void 0 : _a_value1[1]) && (a.value.reverse(), t("range-start", a.value[0]), t("range-end", a.value[1]));
    }, ha = ()=>{
        a.value.length && (a.value[0] && !a.value[1] ? Xe(0) : (Xe(0), Xe(1), n()), ya(), d.value = a.value.slice(), $f93880154c0ab2a4$var$pa(a.value, t, e.autoApply, e.modelAuto));
    }, la = (b, ae = !1)=>{
        if (z(b.value) || !b.current && e.hideOffsetDates) return t("invalid-date", b.value);
        if (i.value = JSON.parse(JSON.stringify(b)), !F.value.enabled) return Ye(b);
        $f93880154c0ab2a4$var$yn(v.hours) && $f93880154c0ab2a4$var$yn(v.minutes) && !A.value.enabled && (ht(b, ae), ha());
    }, ba = (b, ae)=>{
        var _e_flow;
        te(b, ae.month, ae.year, !0), h.value.count && !h.value.solo && X(b), t("update-month-year", {
            instance: b,
            month: ae.month,
            year: ae.year
        }), l(h.value.solo ? b : void 0);
        const ve = ((_e_flow = e.flow) === null || _e_flow === void 0 ? void 0 : _e_flow.length) ? e.flow[e.flowStep] : void 0;
        !ae.fromNav && (ve === $f93880154c0ab2a4$var$je.month || ve === $f93880154c0ab2a4$var$je.year) && n();
    }, ka = (b, ae)=>{
        $f93880154c0ab2a4$var$Un({
            value: b,
            modelValue: d,
            range: F.value.enabled,
            timezone: ae ? void 0 : C.value.timezone
        }), y(), e.multiCalendars && (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>k(!0));
    }, wa = ()=>{
        const b = $f93880154c0ab2a4$var$Qa($f93880154c0ab2a4$var$H(), C.value);
        !F.value.enabled && !A.value.enabled ? d.value = b : d.value && Array.isArray(d.value) && d.value[0] ? A.value.enabled ? d.value = [
            ...d.value,
            b
        ] : d.value = $f93880154c0ab2a4$var$Be(b, d.value[0]) ? [
            b,
            d.value[0]
        ] : [
            d.value[0],
            b
        ] : d.value = [
            b
        ], y();
    }, Da = ()=>{
        if (Array.isArray(d.value)) {
            if (A.value.enabled) {
                const b = Ma();
                d.value[d.value.length - 1] = $(b);
            } else d.value = d.value.map((b, ae)=>b && $(b, ae));
        } else d.value = $(d.value);
        t("time-update");
    }, Ma = ()=>Array.isArray(d.value) && d.value.length ? d.value[d.value.length - 1] : null;
    return {
        calendars: P,
        modelValue: d,
        month: pe,
        year: p,
        time: v,
        disabledTimesConfig: ce,
        today: R,
        validateTime: J,
        getCalendarDays: _e,
        getMarker: E,
        handleScroll: Ae,
        handleSwipe: r,
        handleArrow: ne,
        selectDate: la,
        updateMonthYear: ba,
        presetDate: ka,
        selectCurrentDate: wa,
        updateTime: (b, ae = !0, ve = !1)=>{
            U(b, ae, ve, Da);
        },
        assignMonthAndYear: u,
        setStartTime: V
    };
}, $f93880154c0ab2a4$var$qr = {
    key: 0
}, $f93880154c0ab2a4$var$Xr = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    __name: "DatePicker",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$dt),
    emits: [
        "tooltip-open",
        "tooltip-close",
        "mount",
        "update:internal-model-value",
        "update-flow-step",
        "reset-flow",
        "auto-apply",
        "focus-menu",
        "select-date",
        "range-start",
        "range-end",
        "invalid-fixed-range",
        "time-update",
        "am-pm-change",
        "time-picker-open",
        "time-picker-close",
        "recalculate-position",
        "update-month-year",
        "auto-apply-invalid",
        "date-update",
        "invalid-date",
        "overlay-toggle"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { calendars: f, month: i, year: g, modelValue: d, time: P, disabledTimesConfig: v, today: R, validateTime: h, getCalendarDays: T, getMarker: F, handleArrow: _, handleScroll: C, handleSwipe: M, selectDate: A, updateMonthYear: m, presetDate: z, selectCurrentDate: L, updateTime: le, assignMonthAndYear: U, setStartTime: $ } = $f93880154c0ab2a4$var$Qr(a, n, se, u), ee = (0, $cc75f711ea0318a4$exports.useSlots)(), { setHoverDate: O, getDayClassData: J, clearHoverDate: ce } = $f93880154c0ab2a4$var$mo(d, a), { defaultedMultiCalendars: pe } = $f93880154c0ab2a4$var$Oe(a), p = (0, $cc75f711ea0318a4$exports.ref)([]), Y = (0, $cc75f711ea0318a4$exports.ref)([]), te = (0, $cc75f711ea0318a4$exports.ref)(null), y = $f93880154c0ab2a4$var$et(ee, "calendar"), V = $f93880154c0ab2a4$var$et(ee, "monthYear"), S = $f93880154c0ab2a4$var$et(ee, "timePicker"), q = (ne)=>{
            a.shadow || n("mount", ne);
        };
        (0, $cc75f711ea0318a4$exports.watch)(f, ()=>{
            a.shadow || setTimeout(()=>{
                n("recalculate-position");
            }, 0);
        }, {
            deep: !0
        }), (0, $cc75f711ea0318a4$exports.watch)(pe, (ne, r)=>{
            ne.count - r.count > 0 && U();
        }, {
            deep: !0
        });
        const k = (0, $cc75f711ea0318a4$exports.computed)(()=>(ne)=>T(i.value(ne), g.value(ne)).map((r)=>(0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, r), {
                        days: r.days.map((E)=>(E.marker = F(E), E.classData = J(E), E))
                    })));
        function se(ne) {
            var _Y_value_ne;
            ne || ne === 0 ? (_Y_value_ne = Y.value[ne]) === null || _Y_value_ne === void 0 ? void 0 : _Y_value_ne.triggerTransition(i.value(ne), g.value(ne)) : Y.value.forEach((r, E)=>r.triggerTransition(i.value(E), g.value(E)));
        }
        function u() {
            n("update-flow-step");
        }
        const re = (ne, r = !1)=>{
            A(ne, r), a.spaceConfirm && n("select-date");
        }, G = (ne, r, E = 0)=>{
            var _p_value_E;
            (_p_value_E = p.value[E]) === null || _p_value_E === void 0 ? void 0 : _p_value_E.toggleMonthPicker(ne, r);
        }, I = (ne, r, E = 0)=>{
            var _p_value_E;
            (_p_value_E = p.value[E]) === null || _p_value_E === void 0 ? void 0 : _p_value_E.toggleYearPicker(ne, r);
        }, x = (ne, r, E)=>{
            var _te_value;
            (_te_value = te.value) === null || _te_value === void 0 ? void 0 : _te_value.toggleTimePicker(ne, r, E);
        }, c = (ne, r)=>{
            if (!a.range) {
                var _document_getElementById;
                const E = d.value ? d.value : R, K = r ? new Date(r) : E, oe = ne ? (0, $170fa77f96b2c9a8$export$42c81a444fbfb5d4)(K, {
                    weekStartsOn: 1
                }) : (0, $8e73e36ac64240db$export$ef8b6d9133084f4e)(K, {
                    weekStartsOn: 1
                });
                A({
                    value: oe,
                    current: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(K) === i.value(0),
                    text: "",
                    classData: {}
                }), (_document_getElementById = document.getElementById($f93880154c0ab2a4$var$Ha(oe))) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.focus();
            }
        }, o = (ne)=>{
            var _p_value_;
            (_p_value_ = p.value[0]) === null || _p_value_ === void 0 ? void 0 : _p_value_.handleMonthYearChange(ne, !0);
        }, X = (ne)=>{
            m(0, {
                month: i.value(0),
                year: g.value(0) + (ne ? 1 : -1),
                fromNav: !0
            });
        }, B = (ne, r)=>{
            ne === $f93880154c0ab2a4$var$je.time && n(`time-picker-${r ? "open" : "close"}`), n("overlay-toggle", {
                open: r,
                overlay: ne
            });
        }, be = (ne)=>{
            n("overlay-toggle", {
                open: !1,
                overlay: ne
            }), n("focus-menu");
        };
        return t({
            clearHoverDate: ce,
            presetDate: z,
            selectCurrentDate: L,
            toggleMonthPicker: G,
            toggleYearPicker: I,
            toggleTimePicker: x,
            handleArrow: _,
            updateMonthYear: m,
            getSidebarProps: ()=>({
                    modelValue: d,
                    month: i,
                    year: g,
                    time: P,
                    updateTime: le,
                    updateMonthYear: m,
                    selectDate: A,
                    presetDate: z
                }),
            changeMonth: o,
            changeYear: X,
            selectWeekDate: c,
            setStartTime: $
        }), (ne, r)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, [
                (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$ma, {
                    "multi-calendars": (0, $cc75f711ea0318a4$exports.unref)(pe).count,
                    collapse: ne.collapse,
                    "is-mobile": ne.isMobile
                }, {
                    default: (0, $cc75f711ea0318a4$exports.withCtx)(({ instance: E, index: K })=>[
                            ne.disableMonthYearSelect ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$zr, (0, $cc75f711ea0318a4$exports.mergeProps)({
                                key: 0,
                                ref: (oe)=>{
                                    oe && (p.value[K] = oe);
                                },
                                months: (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Pn)(ne.formatLocale, ne.locale, ne.monthNameFormat),
                                years: (0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qa)(ne.yearRange, ne.locale, ne.reverseYears),
                                month: (0, $cc75f711ea0318a4$exports.unref)(i)(E),
                                year: (0, $cc75f711ea0318a4$exports.unref)(g)(E),
                                instance: E
                            }, ne.$props, {
                                onMount: r[0] || (r[0] = (oe)=>q((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ot).header)),
                                onResetFlow: r[1] || (r[1] = (oe)=>ne.$emit("reset-flow")),
                                onUpdateMonthYear: (oe)=>(0, $cc75f711ea0318a4$exports.unref)(m)(E, oe),
                                onOverlayClosed: be,
                                onOverlayOpened: r[2] || (r[2] = (oe)=>ne.$emit("overlay-toggle", {
                                        open: !0,
                                        overlay: oe
                                    }))
                            }), (0, $cc75f711ea0318a4$exports.createSlots)({
                                _: 2
                            }, [
                                (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(V), (oe, ge)=>({
                                        name: oe,
                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)((_e)=>[
                                                (0, $cc75f711ea0318a4$exports.renderSlot)(ne.$slots, oe, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(_e)))
                                            ])
                                    }))
                            ]), 1040, [
                                "months",
                                "years",
                                "month",
                                "year",
                                "instance",
                                "onUpdateMonthYear"
                            ])),
                            (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$Gr, (0, $cc75f711ea0318a4$exports.mergeProps)({
                                ref: (oe)=>{
                                    oe && (Y.value[K] = oe);
                                },
                                "mapped-dates": k.value(E),
                                month: (0, $cc75f711ea0318a4$exports.unref)(i)(E),
                                year: (0, $cc75f711ea0318a4$exports.unref)(g)(E),
                                instance: E
                            }, ne.$props, {
                                onSelectDate: (oe)=>(0, $cc75f711ea0318a4$exports.unref)(A)(oe, E !== 1),
                                onHandleSpace: (oe)=>re(oe, E !== 1),
                                onSetHoverDate: r[3] || (r[3] = (oe)=>(0, $cc75f711ea0318a4$exports.unref)(O)(oe)),
                                onHandleScroll: (oe)=>(0, $cc75f711ea0318a4$exports.unref)(C)(oe, E),
                                onHandleSwipe: (oe)=>(0, $cc75f711ea0318a4$exports.unref)(M)(oe, E),
                                onMount: r[4] || (r[4] = (oe)=>q((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ot).calendar)),
                                onResetFlow: r[5] || (r[5] = (oe)=>ne.$emit("reset-flow")),
                                onTooltipOpen: r[6] || (r[6] = (oe)=>ne.$emit("tooltip-open", oe)),
                                onTooltipClose: r[7] || (r[7] = (oe)=>ne.$emit("tooltip-close", oe))
                            }), (0, $cc75f711ea0318a4$exports.createSlots)({
                                _: 2
                            }, [
                                (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(y), (oe, ge)=>({
                                        name: oe,
                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)((_e)=>[
                                                (0, $cc75f711ea0318a4$exports.renderSlot)(ne.$slots, oe, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, _e))))
                                            ])
                                    }))
                            ]), 1040, [
                                "mapped-dates",
                                "month",
                                "year",
                                "instance",
                                "onSelectDate",
                                "onHandleSpace",
                                "onHandleScroll",
                                "onHandleSwipe"
                            ])
                        ]),
                    _: 3
                }, 8, [
                    "multi-calendars",
                    "collapse",
                    "is-mobile"
                ]),
                ne.enableTimePicker ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$qr, [
                    ne.$slots["time-picker"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(ne.$slots, "time-picker", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.mergeProps)({
                        key: 0
                    }, {
                        time: (0, $cc75f711ea0318a4$exports.unref)(P),
                        updateTime: (0, $cc75f711ea0318a4$exports.unref)(le)
                    }))) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$Kn, (0, $cc75f711ea0318a4$exports.mergeProps)({
                        key: 1,
                        ref_key: "timePickerRef",
                        ref: te
                    }, ne.$props, {
                        hours: (0, $cc75f711ea0318a4$exports.unref)(P).hours,
                        minutes: (0, $cc75f711ea0318a4$exports.unref)(P).minutes,
                        seconds: (0, $cc75f711ea0318a4$exports.unref)(P).seconds,
                        "internal-model-value": ne.internalModelValue,
                        "disabled-times-config": (0, $cc75f711ea0318a4$exports.unref)(v),
                        "validate-time": (0, $cc75f711ea0318a4$exports.unref)(h),
                        onMount: r[8] || (r[8] = (E)=>q((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Ot).timePicker)),
                        "onUpdate:hours": r[9] || (r[9] = (E)=>(0, $cc75f711ea0318a4$exports.unref)(le)(E)),
                        "onUpdate:minutes": r[10] || (r[10] = (E)=>(0, $cc75f711ea0318a4$exports.unref)(le)(E, !1)),
                        "onUpdate:seconds": r[11] || (r[11] = (E)=>(0, $cc75f711ea0318a4$exports.unref)(le)(E, !1, !0)),
                        onResetFlow: r[12] || (r[12] = (E)=>ne.$emit("reset-flow")),
                        onOverlayClosed: r[13] || (r[13] = (E)=>B(E, !1)),
                        onOverlayOpened: r[14] || (r[14] = (E)=>B(E, !0)),
                        onAmPmChange: r[15] || (r[15] = (E)=>ne.$emit("am-pm-change", E))
                    }), (0, $cc75f711ea0318a4$exports.createSlots)({
                        _: 2
                    }, [
                        (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(S), (E, K)=>({
                                name: E,
                                fn: (0, $cc75f711ea0318a4$exports.withCtx)((oe)=>[
                                        (0, $cc75f711ea0318a4$exports.renderSlot)(ne.$slots, E, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(oe)))
                                    ])
                            }))
                    ]), 1040, [
                        "hours",
                        "minutes",
                        "seconds",
                        "internal-model-value",
                        "disabled-times-config",
                        "validate-time"
                    ]))
                ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
            ], 64));
    }
}), $f93880154c0ab2a4$var$Jr = (e, t)=>{
    const l = (0, $cc75f711ea0318a4$exports.ref)(), { defaultedMultiCalendars: n, defaultedConfig: a, defaultedHighlight: f, defaultedRange: i, propDates: g, defaultedFilters: d, defaultedMultiDates: P } = $f93880154c0ab2a4$var$Oe(e), { modelValue: v, year: R, month: h, calendars: T } = $f93880154c0ab2a4$var$na(e, t), { isDisabled: F } = $f93880154c0ab2a4$var$Tt(e), { selectYear: _, groupedYears: C, showYearPicker: M, isDisabled: A, toggleYearPicker: m, handleYearSelect: z, handleYear: L } = $f93880154c0ab2a4$var$jn({
        modelValue: v,
        multiCalendars: n,
        range: i,
        highlight: f,
        calendars: T,
        propDates: g,
        month: h,
        year: R,
        filters: d,
        props: e,
        emit: t
    }), le = (y, V)=>[
            y,
            V
        ].map((S)=>(0, $01941d183f2645a8$export$d9468344d3651243)(S, "MMMM", {
                locale: e.formatLocale
            })).join("-"), U = (0, $cc75f711ea0318a4$exports.computed)(()=>(y)=>v.value ? Array.isArray(v.value) ? v.value.some((V)=>(0, $19210918fbdc0c95$export$5c60e4190867161c)(y, V)) : (0, $19210918fbdc0c95$export$5c60e4190867161c)(v.value, y) : !1), $ = (y)=>{
        if (i.value.enabled) {
            if (Array.isArray(v.value)) {
                const V = $f93880154c0ab2a4$var$$e(y, v.value[0]) || $f93880154c0ab2a4$var$$e(y, v.value[1]);
                return $f93880154c0ab2a4$var$xt(v.value, l.value, y) && !V;
            }
            return !1;
        }
        return !1;
    }, ee = (y, V)=>y.quarter === (0, $dba88d0d1ade6ede$export$de90a4bb31c25221)(V) && y.year === (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(V), O = (y)=>typeof f.value == "function" ? f.value({
            quarter: (0, $dba88d0d1ade6ede$export$de90a4bb31c25221)(y),
            year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(y)
        }) : !!f.value.quarters.find((V)=>ee(V, y)), J = (0, $cc75f711ea0318a4$exports.computed)(()=>(y)=>{
            const V = (0, $75b278507b3aec9b$export$adaa4cf7ef1b65be)(/* @__PURE__ */ new Date(), {
                year: R.value(y)
            });
            return (0, $2aa5febcb7470051$export$96790a0abfab0078)({
                start: (0, $f267ae5ef0b6b4f4$export$f91e89d3d0406102)(V),
                end: (0, $bac7abe4a926855b$export$8b7aa55c66d5569e)(V)
            }).map((S)=>{
                const q = (0, $29afb4b16bbf6e94$export$69be7267a042ecb3)(S), k = (0, $d32b5f088e249a0e$export$5f53493861eef879)(S), se = F(S), u = $(q), re = O(q);
                return {
                    text: le(q, k),
                    value: q,
                    active: U.value(q),
                    highlighted: re,
                    disabled: se,
                    isBetween: u
                };
            });
        }), ce = (y)=>{
        $f93880154c0ab2a4$var$en(y, v, P.value.limit), t("auto-apply", !0);
    }, pe = (y)=>{
        v.value = $f93880154c0ab2a4$var$tn(v, y, t), $f93880154c0ab2a4$var$pa(v.value, t, e.autoApply, e.modelAuto);
    }, p = (y)=>{
        v.value = y, t("auto-apply");
    };
    return {
        defaultedConfig: a,
        defaultedMultiCalendars: n,
        groupedYears: C,
        year: R,
        isDisabled: A,
        quarters: J,
        showYearPicker: M,
        modelValue: v,
        setHoverDate: (y)=>{
            l.value = y;
        },
        selectYear: _,
        selectQuarter: (y, V, S)=>{
            if (!S) return T.value[V].month = (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)((0, $d32b5f088e249a0e$export$5f53493861eef879)(y)), P.value.enabled ? ce(y) : i.value.enabled ? pe(y) : p(y);
        },
        toggleYearPicker: m,
        handleYearSelect: z,
        handleYear: L
    };
}, $f93880154c0ab2a4$var$Zr = {
    class: "dp--quarter-items"
}, $f93880154c0ab2a4$var$xr = [
    "data-test-id",
    "disabled",
    "onClick",
    "onMouseover"
], $f93880154c0ab2a4$var$eo = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "QuarterPicker",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$dt),
    emits: [
        "update:internal-model-value",
        "reset-flow",
        "overlay-closed",
        "auto-apply",
        "range-start",
        "range-end",
        "overlay-toggle",
        "update-month-year"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, f = (0, $cc75f711ea0318a4$exports.useSlots)(), i = $f93880154c0ab2a4$var$et(f, "yearMode"), { defaultedMultiCalendars: g, defaultedConfig: d, groupedYears: P, year: v, isDisabled: R, quarters: h, modelValue: T, showYearPicker: F, setHoverDate: _, selectQuarter: C, toggleYearPicker: M, handleYearSelect: A, handleYear: m } = $f93880154c0ab2a4$var$Jr(a, n);
        return t({
            getSidebarProps: ()=>({
                    modelValue: T,
                    year: v,
                    selectQuarter: C,
                    handleYearSelect: A,
                    handleYear: m
                })
        }), (L, le)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ma, {
                "multi-calendars": (0, $cc75f711ea0318a4$exports.unref)(g).count,
                collapse: L.collapse,
                stretch: "",
                "is-mobile": L.isMobile
            }, {
                default: (0, $cc75f711ea0318a4$exports.withCtx)(({ instance: U })=>[
                        (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                            class: "dp-quarter-picker-wrap",
                            style: (0, $cc75f711ea0318a4$exports.normalizeStyle)({
                                minHeight: `${(0, $cc75f711ea0318a4$exports.unref)(d).modeHeight}px`
                            })
                        }, [
                            L.$slots["top-extra"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(L.$slots, "top-extra", {
                                key: 0,
                                value: L.internalModelValue
                            }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                            (0, $cc75f711ea0318a4$exports.createElementVNode)("div", null, [
                                (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$Wn, (0, $cc75f711ea0318a4$exports.mergeProps)(L.$props, {
                                    items: (0, $cc75f711ea0318a4$exports.unref)(P)(U),
                                    instance: U,
                                    "show-year-picker": (0, $cc75f711ea0318a4$exports.unref)(F)[U],
                                    year: (0, $cc75f711ea0318a4$exports.unref)(v)(U),
                                    "is-disabled": ($)=>(0, $cc75f711ea0318a4$exports.unref)(R)(U, $),
                                    onHandleYear: ($)=>(0, $cc75f711ea0318a4$exports.unref)(m)(U, $),
                                    onYearSelect: ($)=>(0, $cc75f711ea0318a4$exports.unref)(A)($, U),
                                    onToggleYearPicker: ($)=>(0, $cc75f711ea0318a4$exports.unref)(M)(U, $ === null || $ === void 0 ? void 0 : $.flow, $ === null || $ === void 0 ? void 0 : $.show)
                                }), (0, $cc75f711ea0318a4$exports.createSlots)({
                                    _: 2
                                }, [
                                    (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(i), ($, ee)=>({
                                            name: $,
                                            fn: (0, $cc75f711ea0318a4$exports.withCtx)((O)=>[
                                                    (0, $cc75f711ea0318a4$exports.renderSlot)(L.$slots, $, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(O)))
                                                ])
                                        }))
                                ]), 1040, [
                                    "items",
                                    "instance",
                                    "show-year-picker",
                                    "year",
                                    "is-disabled",
                                    "onHandleYear",
                                    "onYearSelect",
                                    "onToggleYearPicker"
                                ])
                            ]),
                            (0, $cc75f711ea0318a4$exports.createElementVNode)("div", $f93880154c0ab2a4$var$Zr, [
                                ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(h)(U), ($, ee)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                                        key: ee
                                    }, [
                                        (0, $cc75f711ea0318a4$exports.createElementVNode)("button", {
                                            type: "button",
                                            class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                                                "dp--qr-btn",
                                                {
                                                    "dp--qr-btn-active": $.active,
                                                    "dp--qr-btn-between": $.isBetween,
                                                    "dp--qr-btn-disabled": $.disabled,
                                                    "dp--highlighted": $.highlighted
                                                }
                                            ]),
                                            "data-test-id": $.value,
                                            disabled: $.disabled,
                                            onClick: (O)=>(0, $cc75f711ea0318a4$exports.unref)(C)($.value, U, $.disabled),
                                            onMouseover: (O)=>(0, $cc75f711ea0318a4$exports.unref)(_)($.value)
                                        }, [
                                            L.$slots.quarter ? (0, $cc75f711ea0318a4$exports.renderSlot)(L.$slots, "quarter", {
                                                key: 0,
                                                value: $.value,
                                                text: $.text
                                            }) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                                key: 1
                                            }, [
                                                (0, $cc75f711ea0318a4$exports.createTextVNode)((0, $cc75f711ea0318a4$exports.toDisplayString)($.text), 1)
                                            ], 64))
                                        ], 42, $f93880154c0ab2a4$var$xr)
                                    ]))), 128))
                            ])
                        ], 4)
                    ]),
                _: 3
            }, 8, [
                "multi-calendars",
                "collapse",
                "is-mobile"
            ]));
    }
}), $f93880154c0ab2a4$var$Qn = (e, t)=>{
    const l = (0, $cc75f711ea0318a4$exports.ref)(0);
    (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
        n(), window.addEventListener("resize", n, {
            passive: !0
        });
    }), (0, $cc75f711ea0318a4$exports.onUnmounted)(()=>{
        window.removeEventListener("resize", n);
    });
    const n = ()=>{
        l.value = window.document.documentElement.clientWidth;
    };
    return {
        isMobile: (0, $cc75f711ea0318a4$exports.computed)(()=>l.value <= e.value.mobileBreakpoint && !t ? !0 : void 0)
    };
}, $f93880154c0ab2a4$var$to = [
    "id",
    "tabindex",
    "role",
    "aria-label"
], $f93880154c0ab2a4$var$ao = {
    key: 0,
    class: "dp--menu-load-container"
}, $f93880154c0ab2a4$var$no = {
    key: 1,
    class: "dp--menu-header"
}, $f93880154c0ab2a4$var$lo = [
    "data-dp-mobile"
], $f93880154c0ab2a4$var$ro = {
    key: 0,
    class: "dp__sidebar_left"
}, $f93880154c0ab2a4$var$oo = [
    "data-dp-mobile"
], $f93880154c0ab2a4$var$so = [
    "data-test-id",
    "data-dp-mobile",
    "onClick",
    "onKeydown"
], $f93880154c0ab2a4$var$uo = {
    key: 2,
    class: "dp__sidebar_right"
}, $f93880154c0ab2a4$var$io = {
    key: 3,
    class: "dp__action_extra"
}, $f93880154c0ab2a4$var$hn = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "DatepickerMenu",
    props: (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$va), {
        shadow: {
            type: Boolean,
            default: !1
        },
        openOnTop: {
            type: Boolean,
            default: !1
        },
        internalModelValue: {
            type: [
                Date,
                Array
            ],
            default: null
        },
        noOverlayFocus: {
            type: Boolean,
            default: !1
        },
        collapse: {
            type: Boolean,
            default: !1
        },
        getInputRect: {
            type: Function,
            default: ()=>({})
        },
        isTextInputDate: {
            type: Boolean,
            default: !1
        }
    }),
    emits: [
        "close-picker",
        "select-date",
        "auto-apply",
        "time-update",
        "flow-step",
        "update-month-year",
        "invalid-select",
        "update:internal-model-value",
        "recalculate-position",
        "invalid-fixed-range",
        "tooltip-open",
        "tooltip-close",
        "time-picker-open",
        "time-picker-close",
        "am-pm-change",
        "range-start",
        "range-end",
        "auto-apply-invalid",
        "date-update",
        "invalid-date",
        "overlay-toggle",
        "menu-blur"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, f = (0, $cc75f711ea0318a4$exports.ref)(null), i = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            const { openOnTop: D } = a, de = (0, $535636d8023070c8$export$71511d61b312f219)(a, [
                "openOnTop"
            ]);
            return (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, de), {
                isMobile: C.value,
                flowStep: pe.value,
                menuWrapRef: f.value
            });
        }), { setMenuFocused: g, setShiftKey: d, control: P } = $f93880154c0ab2a4$var$Hn(), v = (0, $cc75f711ea0318a4$exports.useSlots)(), { defaultedTextInput: R, defaultedInline: h, defaultedConfig: T, defaultedUI: F, handleEventPropagation: _ } = $f93880154c0ab2a4$var$Oe(a), { isMobile: C } = $f93880154c0ab2a4$var$Qn(T, a.shadow), M = (0, $cc75f711ea0318a4$exports.ref)(null), A = (0, $cc75f711ea0318a4$exports.ref)(0), m = (0, $cc75f711ea0318a4$exports.ref)(null), z = (0, $cc75f711ea0318a4$exports.ref)(!1), L = (0, $cc75f711ea0318a4$exports.ref)(null), le = (0, $cc75f711ea0318a4$exports.ref)(!1), U = (D)=>{
            le.value = !0, T.value.allowPreventDefault && D.preventDefault(), $f93880154c0ab2a4$var$Dt(D, T.value, !0);
        };
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            if (!a.shadow) {
                z.value = !0, $(), window.addEventListener("resize", $);
                const D = $f93880154c0ab2a4$var$Le(f);
                D && !R.value.enabled && !h.value.enabled && (g(!0), q()), D && (D.addEventListener("pointerdown", U), D.addEventListener("mousedown", U));
            }
            document.addEventListener("mousedown", nt);
        }), (0, $cc75f711ea0318a4$exports.onUnmounted)(()=>{
            window.removeEventListener("resize", $), document.removeEventListener("mousedown", nt);
            const D = $f93880154c0ab2a4$var$Le(f);
            D && (D.removeEventListener("pointerdown", U), D.removeEventListener("mousedown", U));
        });
        const $ = ()=>{
            const D = $f93880154c0ab2a4$var$Le(m);
            D && (A.value = D.getBoundingClientRect().width);
        }, { arrowRight: ee, arrowLeft: O, arrowDown: J, arrowUp: ce } = $f93880154c0ab2a4$var$At(), { flowStep: pe, updateFlowStep: p, childMount: Y, resetFlow: te, handleFlow: y } = $f93880154c0ab2a4$var$po(a, n, L), V = (0, $cc75f711ea0318a4$exports.computed)(()=>a.monthPicker ? $f93880154c0ab2a4$var$hr : a.yearPicker ? $f93880154c0ab2a4$var$kr : a.timePicker ? $f93880154c0ab2a4$var$Yr : a.quarterPicker ? $f93880154c0ab2a4$var$eo : $f93880154c0ab2a4$var$Xr), S = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _f_value;
            if (T.value.arrowLeft) return T.value.arrowLeft;
            const D = (_f_value = f.value) === null || _f_value === void 0 ? void 0 : _f_value.getBoundingClientRect(), de = a.getInputRect();
            var _D_left, _D_right;
            return (de === null || de === void 0 ? void 0 : de.width) < (A === null || A === void 0 ? void 0 : A.value) && (de === null || de === void 0 ? void 0 : de.left) <= ((_D_left = D === null || D === void 0 ? void 0 : D.left) !== null && _D_left !== void 0 ? _D_left : 0) ? `${(de === null || de === void 0 ? void 0 : de.width) / 2}px` : (de === null || de === void 0 ? void 0 : de.right) >= ((_D_right = D === null || D === void 0 ? void 0 : D.right) !== null && _D_right !== void 0 ? _D_right : 0) && (de === null || de === void 0 ? void 0 : de.width) < (A === null || A === void 0 ? void 0 : A.value) ? `${(A === null || A === void 0 ? void 0 : A.value) - (de === null || de === void 0 ? void 0 : de.width) / 2}px` : "50%";
        }), q = ()=>{
            const D = $f93880154c0ab2a4$var$Le(f);
            D && D.focus({
                preventScroll: !0
            });
        }, k = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _L_value;
            return ((_L_value = L.value) === null || _L_value === void 0 ? void 0 : _L_value.getSidebarProps()) || {};
        }), se = ()=>{
            a.openOnTop && n("recalculate-position");
        }, u = $f93880154c0ab2a4$var$et(v, "action"), re = (0, $cc75f711ea0318a4$exports.computed)(()=>a.monthPicker || a.yearPicker ? $f93880154c0ab2a4$var$et(v, "monthYear") : a.timePicker ? $f93880154c0ab2a4$var$et(v, "timePicker") : $f93880154c0ab2a4$var$et(v, "shared")), G = (0, $cc75f711ea0318a4$exports.computed)(()=>a.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), I = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__menu_disabled: a.disabled,
                dp__menu_readonly: a.readonly,
                "dp-menu-loading": a.loading
            })), x = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _F_value_menu;
            return (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
                dp__menu: !0,
                dp__menu_index: !h.value.enabled,
                dp__relative: h.value.enabled
            }, (_F_value_menu = F.value.menu) !== null && _F_value_menu !== void 0 ? _F_value_menu : {});
        }), c = (D)=>{
            $f93880154c0ab2a4$var$Dt(D, T.value, !0);
        }, o = (D)=>{
            a.escClose && (n("close-picker"), _(D));
        }, X = (D)=>{
            if (a.arrowNavigation) {
                if (D === $f93880154c0ab2a4$var$Qe.up) return ce();
                if (D === $f93880154c0ab2a4$var$Qe.down) return J();
                if (D === $f93880154c0ab2a4$var$Qe.left) return O();
                if (D === $f93880154c0ab2a4$var$Qe.right) return ee();
            } else D === $f93880154c0ab2a4$var$Qe.left || D === $f93880154c0ab2a4$var$Qe.up ? r("handleArrow", $f93880154c0ab2a4$var$Qe.left, 0, D === $f93880154c0ab2a4$var$Qe.up) : r("handleArrow", $f93880154c0ab2a4$var$Qe.right, 0, D === $f93880154c0ab2a4$var$Qe.down);
        }, B = (D)=>{
            d(D.shiftKey), !a.disableMonthYearSelect && D.code === $f93880154c0ab2a4$var$Re.tab && D.target.classList.contains("dp__menu") && P.value.shiftKeyInMenu && (D.preventDefault(), $f93880154c0ab2a4$var$Dt(D, T.value, !0), n("close-picker"));
        }, be = ()=>{
            q(), n("time-picker-close");
        }, Ae = (D)=>{
            var _L_value, _L_value1, _L_value2;
            (_L_value = L.value) === null || _L_value === void 0 ? void 0 : _L_value.toggleTimePicker(!1, !1), (_L_value1 = L.value) === null || _L_value1 === void 0 ? void 0 : _L_value1.toggleMonthPicker(!1, !1, D), (_L_value2 = L.value) === null || _L_value2 === void 0 ? void 0 : _L_value2.toggleYearPicker(!1, !1, D);
        }, ne = (D, de = 0)=>{
            var _L_value, _L_value1, _L_value2;
            return D === "month" ? (_L_value = L.value) === null || _L_value === void 0 ? void 0 : _L_value.toggleMonthPicker(!1, !0, de) : D === "year" ? (_L_value1 = L.value) === null || _L_value1 === void 0 ? void 0 : _L_value1.toggleYearPicker(!1, !0, de) : D === "time" ? (_L_value2 = L.value) === null || _L_value2 === void 0 ? void 0 : _L_value2.toggleTimePicker(!0, !1) : Ae(de);
        }, r = (D, ...de)=>{
            var _L_value, _L_value1;
            ((_L_value = L.value) === null || _L_value === void 0 ? void 0 : _L_value[D]) && ((_L_value1 = L.value) === null || _L_value1 === void 0 ? void 0 : _L_value1[D](...de));
        }, E = ()=>{
            r("selectCurrentDate");
        }, K = (D, de)=>{
            r("presetDate", (0, $cc75f711ea0318a4$exports.toValue)(D), de);
        }, oe = ()=>{
            r("clearHoverDate");
        }, ge = (D, de)=>{
            r("updateMonthYear", D, de);
        }, _e = (D, de)=>{
            D.preventDefault(), X(de);
        }, Ye = (D)=>{
            var _Fa, _Fa1, _f_value;
            if (B(D), D.key === $f93880154c0ab2a4$var$Re.home || D.key === $f93880154c0ab2a4$var$Re.end) return r("selectWeekDate", D.key === $f93880154c0ab2a4$var$Re.home, D.target.getAttribute("id"));
            switch((D.key === $f93880154c0ab2a4$var$Re.pageUp || D.key === $f93880154c0ab2a4$var$Re.pageDown) && (D.shiftKey ? (r("changeYear", D.key === $f93880154c0ab2a4$var$Re.pageUp), (_Fa = $f93880154c0ab2a4$var$Fa(f.value, "overlay-year")) === null || _Fa === void 0 ? void 0 : _Fa.focus()) : (r("changeMonth", D.key === $f93880154c0ab2a4$var$Re.pageUp), (_Fa1 = $f93880154c0ab2a4$var$Fa(f.value, D.key === $f93880154c0ab2a4$var$Re.pageUp ? "action-prev" : "action-next")) === null || _Fa1 === void 0 ? void 0 : _Fa1.focus()), D.target.getAttribute("id") && ((_f_value = f.value) === null || _f_value === void 0 ? void 0 : _f_value.focus({
                preventScroll: !0
            }))), D.key){
                case $f93880154c0ab2a4$var$Re.esc:
                    return o(D);
                case $f93880154c0ab2a4$var$Re.arrowLeft:
                    return _e(D, $f93880154c0ab2a4$var$Qe.left);
                case $f93880154c0ab2a4$var$Re.arrowRight:
                    return _e(D, $f93880154c0ab2a4$var$Qe.right);
                case $f93880154c0ab2a4$var$Re.arrowUp:
                    return _e(D, $f93880154c0ab2a4$var$Qe.up);
                case $f93880154c0ab2a4$var$Re.arrowDown:
                    return _e(D, $f93880154c0ab2a4$var$Qe.down);
                default:
                    return;
            }
        }, nt = (D)=>{
            var _f_value;
            h.value.enabled && !h.value.input && !((_f_value = f.value) === null || _f_value === void 0 ? void 0 : _f_value.contains(D.target)) && le.value && (le.value = !1, n("menu-blur"));
        };
        return t({
            updateMonthYear: ge,
            switchView: ne,
            handleFlow: y,
            onValueCleared: ()=>{
                var _L_value_setStartTime, _L_value;
                (_L_value = L.value) === null || _L_value === void 0 ? void 0 : (_L_value_setStartTime = _L_value.setStartTime) === null || _L_value_setStartTime === void 0 ? void 0 : _L_value_setStartTime.call(_L_value);
            }
        }), (D, de)=>{
            var _D_ariaLabels, _D_presetDates, _D_presetDates1;
            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                id: D.uid ? `dp-menu-${D.uid}` : void 0,
                ref_key: "dpMenuRef",
                ref: f,
                tabindex: (0, $cc75f711ea0318a4$exports.unref)(h).enabled ? void 0 : "0",
                role: (0, $cc75f711ea0318a4$exports.unref)(h).enabled ? void 0 : "dialog",
                "aria-label": (_D_ariaLabels = D.ariaLabels) === null || _D_ariaLabels === void 0 ? void 0 : _D_ariaLabels.menu,
                class: (0, $cc75f711ea0318a4$exports.normalizeClass)(x.value),
                style: (0, $cc75f711ea0318a4$exports.normalizeStyle)({
                    "--dp-arrow-left": S.value
                }),
                onMouseleave: oe,
                onClick: c,
                onKeydown: Ye
            }, [
                (D.disabled || D.readonly) && (0, $cc75f711ea0318a4$exports.unref)(h).enabled || D.loading ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                    key: 0,
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(I.value)
                }, [
                    D.loading ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$ao, [
                        ...de[19] || (de[19] = [
                            (0, $cc75f711ea0318a4$exports.createElementVNode)("span", {
                                class: "dp--menu-loader"
                            }, null, -1)
                        ])
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                ], 2)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                D.$slots["menu-header"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$no, [
                    (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, "menu-header")
                ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                !(0, $cc75f711ea0318a4$exports.unref)(h).enabled && !D.teleportCenter ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                    key: 2,
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)(G.value)
                }, null, 2)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                    ref_key: "innerMenuRef",
                    ref: m,
                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                        dp__menu_content_wrapper: ((_D_presetDates = D.presetDates) === null || _D_presetDates === void 0 ? void 0 : _D_presetDates.length) || !!D.$slots["left-sidebar"] || !!D.$slots["right-sidebar"],
                        "dp--menu-content-wrapper-collapsed": e.collapse && (((_D_presetDates1 = D.presetDates) === null || _D_presetDates1 === void 0 ? void 0 : _D_presetDates1.length) || !!D.$slots["left-sidebar"] || !!D.$slots["right-sidebar"])
                    }),
                    "data-dp-mobile": (0, $cc75f711ea0318a4$exports.unref)(C),
                    style: (0, $cc75f711ea0318a4$exports.normalizeStyle)({
                        "--dp-menu-width": `${A.value}px`
                    })
                }, [
                    D.$slots["left-sidebar"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$ro, [
                        (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, "left-sidebar", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(k.value)))
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    D.presetDates.length ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                        key: 1,
                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)({
                            "dp--preset-dates-collapsed": e.collapse,
                            "dp--preset-dates": !0
                        }),
                        "data-dp-mobile": (0, $cc75f711ea0318a4$exports.unref)(C)
                    }, [
                        ((0, $cc75f711ea0318a4$exports.openBlock)(!0), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), null, (0, $cc75f711ea0318a4$exports.renderList)(D.presetDates, (fe, ht)=>{
                            var _fe_testId;
                            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)((0, $cc75f711ea0318a4$exports.Fragment), {
                                key: ht
                            }, [
                                fe.slot ? (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, fe.slot, {
                                    key: 0,
                                    presetDate: K,
                                    label: fe.label,
                                    value: fe.value
                                }) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                                    key: 1,
                                    type: "button",
                                    style: (0, $cc75f711ea0318a4$exports.normalizeStyle)(fe.style || {}),
                                    class: (0, $cc75f711ea0318a4$exports.normalizeClass)([
                                        "dp__btn dp--preset-range",
                                        {
                                            "dp--preset-range-collapsed": e.collapse
                                        }
                                    ]),
                                    "data-test-id": (_fe_testId = fe.testId) !== null && _fe_testId !== void 0 ? _fe_testId : void 0,
                                    "data-dp-mobile": (0, $cc75f711ea0318a4$exports.unref)(C),
                                    onClick: (0, $cc75f711ea0318a4$exports.withModifiers)((xe)=>K(fe.value, fe.noTz), [
                                        "prevent"
                                    ]),
                                    onKeydown: (xe)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(xe, ()=>K(fe.value, fe.noTz), !0)
                                }, (0, $cc75f711ea0318a4$exports.toDisplayString)(fe.label), 47, $f93880154c0ab2a4$var$so))
                            ], 64);
                        }), 128))
                    ], 10, $f93880154c0ab2a4$var$oo)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                        ref_key: "calendarWrapperRef",
                        ref: M,
                        class: "dp__instance_calendar",
                        role: "document"
                    }, [
                        ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.resolveDynamicComponent)(V.value), (0, $cc75f711ea0318a4$exports.mergeProps)({
                            ref_key: "dynCmpRef",
                            ref: L
                        }, i.value, {
                            "flow-step": (0, $cc75f711ea0318a4$exports.unref)(pe),
                            onMount: (0, $cc75f711ea0318a4$exports.unref)(Y),
                            onUpdateFlowStep: (0, $cc75f711ea0318a4$exports.unref)(p),
                            onResetFlow: (0, $cc75f711ea0318a4$exports.unref)(te),
                            onFocusMenu: q,
                            onSelectDate: de[0] || (de[0] = (fe)=>D.$emit("select-date")),
                            onDateUpdate: de[1] || (de[1] = (fe)=>D.$emit("date-update", fe)),
                            onTooltipOpen: de[2] || (de[2] = (fe)=>D.$emit("tooltip-open", fe)),
                            onTooltipClose: de[3] || (de[3] = (fe)=>D.$emit("tooltip-close", fe)),
                            onAutoApply: de[4] || (de[4] = (fe)=>D.$emit("auto-apply", fe)),
                            onRangeStart: de[5] || (de[5] = (fe)=>D.$emit("range-start", fe)),
                            onRangeEnd: de[6] || (de[6] = (fe)=>D.$emit("range-end", fe)),
                            onInvalidFixedRange: de[7] || (de[7] = (fe)=>D.$emit("invalid-fixed-range", fe)),
                            onTimeUpdate: de[8] || (de[8] = (fe)=>D.$emit("time-update")),
                            onAmPmChange: de[9] || (de[9] = (fe)=>D.$emit("am-pm-change", fe)),
                            onTimePickerOpen: de[10] || (de[10] = (fe)=>D.$emit("time-picker-open", fe)),
                            onTimePickerClose: be,
                            onRecalculatePosition: se,
                            onUpdateMonthYear: de[11] || (de[11] = (fe)=>D.$emit("update-month-year", fe)),
                            onAutoApplyInvalid: de[12] || (de[12] = (fe)=>D.$emit("auto-apply-invalid", fe)),
                            onInvalidDate: de[13] || (de[13] = (fe)=>D.$emit("invalid-date", fe)),
                            onOverlayToggle: de[14] || (de[14] = (fe)=>D.$emit("overlay-toggle", fe)),
                            "onUpdate:internalModelValue": de[15] || (de[15] = (fe)=>D.$emit("update:internal-model-value", fe))
                        }), (0, $cc75f711ea0318a4$exports.createSlots)({
                            _: 2
                        }, [
                            (0, $cc75f711ea0318a4$exports.renderList)(re.value, (fe, ht)=>({
                                    name: fe,
                                    fn: (0, $cc75f711ea0318a4$exports.withCtx)((xe)=>[
                                            (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, fe, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, xe))))
                                        ])
                                }))
                        ]), 1040, [
                            "flow-step",
                            "onMount",
                            "onUpdateFlowStep",
                            "onResetFlow"
                        ]))
                    ], 512),
                    D.$slots["right-sidebar"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$uo, [
                        (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, "right-sidebar", (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(k.value)))
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    D.$slots["action-extra"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$io, [
                        D.$slots["action-extra"] ? (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, "action-extra", {
                            key: 0,
                            selectCurrentDate: E
                        }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                ], 14, $f93880154c0ab2a4$var$lo),
                !D.autoApply || (0, $cc75f711ea0318a4$exports.unref)(T).keepActionRow ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)($f93880154c0ab2a4$var$ir, (0, $cc75f711ea0318a4$exports.mergeProps)({
                    key: 3,
                    "menu-mount": z.value
                }, i.value, {
                    "calendar-width": A.value,
                    onClosePicker: de[16] || (de[16] = (fe)=>D.$emit("close-picker")),
                    onSelectDate: de[17] || (de[17] = (fe)=>D.$emit("select-date")),
                    onInvalidSelect: de[18] || (de[18] = (fe)=>D.$emit("invalid-select")),
                    onSelectNow: E
                }), (0, $cc75f711ea0318a4$exports.createSlots)({
                    _: 2
                }, [
                    (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(u), (fe, ht)=>({
                            name: fe,
                            fn: (0, $cc75f711ea0318a4$exports.withCtx)((xe)=>[
                                    (0, $cc75f711ea0318a4$exports.renderSlot)(D.$slots, fe, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, xe))))
                                ])
                        }))
                ]), 1040, [
                    "menu-mount",
                    "calendar-width"
                ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
            ], 46, $f93880154c0ab2a4$var$to);
        };
    }
});
var $f93880154c0ab2a4$var$Et = /* @__PURE__ */ ((e)=>(e.center = "center", e.left = "left", e.right = "right", e))($f93880154c0ab2a4$var$Et || {});
const $f93880154c0ab2a4$var$co = ({ menuRef: e, menuRefInner: t, inputRef: l, pickerWrapperRef: n, inline: a, emit: f, props: i, slots: g })=>{
    const { defaultedConfig: d } = $f93880154c0ab2a4$var$Oe(i), P = (0, $cc75f711ea0318a4$exports.ref)({}), v = (0, $cc75f711ea0318a4$exports.ref)(!1), R = (0, $cc75f711ea0318a4$exports.ref)({
        top: "0",
        left: "0"
    }), h = (0, $cc75f711ea0318a4$exports.ref)(!1), T = (0, $cc75f711ea0318a4$exports.toRef)(i, "teleportCenter");
    (0, $cc75f711ea0318a4$exports.watch)(T, ()=>{
        R.value = JSON.parse(JSON.stringify({})), L();
    });
    const F = (y)=>{
        if (i.teleport) {
            const V = y.getBoundingClientRect();
            return {
                left: V.left + window.scrollX,
                top: V.top + window.scrollY
            };
        }
        return {
            top: 0,
            left: 0
        };
    }, _ = (y, V)=>{
        R.value.left = `${y + V - P.value.width}px`;
    }, C = (y)=>{
        R.value.left = `${y}px`;
    }, M = (y, V)=>{
        i.position === $f93880154c0ab2a4$var$Et.left && C(y), i.position === $f93880154c0ab2a4$var$Et.right && _(y, V), i.position === $f93880154c0ab2a4$var$Et.center && (R.value.left = `${y + V / 2 - P.value.width / 2}px`);
    }, A = (y)=>{
        const { width: V, height: S } = y.getBoundingClientRect(), { top: q, left: k } = F(y);
        return {
            top: +q,
            left: +k,
            width: V,
            height: S
        };
    }, m = ()=>{
        R.value.left = "50%", R.value.top = "50%", R.value.transform = "translate(-50%, -50%)", R.value.position = "fixed", delete R.value.opacity;
    }, z = ()=>{
        const y = $f93880154c0ab2a4$var$Le(l);
        R.value = i.altPosition(y);
    }, L = (y = !0)=>{
        if (!a.value.enabled) {
            if (T.value) return m();
            if (i.altPosition !== null) return z();
            if (y) {
                var _t_value;
                const V = i.teleport ? (_t_value = t.value) === null || _t_value === void 0 ? void 0 : _t_value.$el : e.value;
                V && (P.value = V.getBoundingClientRect()), f("recalculate-position");
            }
            return ce();
        }
    }, le = ({ inputEl: y, left: V, width: S })=>{
        window.screen.width > 768 && !v.value && M(V, S), ee(y);
    }, U = (y)=>{
        const { top: V, left: S, height: q, width: k } = A(y);
        R.value.top = `${q + V + +i.offset}px`, h.value = !1, v.value || (R.value.left = `${S + k / 2 - P.value.width / 2}px`), le({
            inputEl: y,
            left: S,
            width: k
        });
    }, $ = (y)=>{
        const { top: V, left: S, width: q } = A(y);
        R.value.top = `${V - +i.offset - P.value.height}px`, h.value = !0, le({
            inputEl: y,
            left: S,
            width: q
        });
    }, ee = (y)=>{
        if (i.autoPosition) {
            const { left: V, width: S } = A(y), { left: q, right: k } = P.value;
            if (!v.value) {
                if (Math.abs(q) !== Math.abs(k)) {
                    if (q <= 0) return v.value = !0, C(V);
                    if (k >= document.documentElement.clientWidth) return v.value = !0, _(V, S);
                }
                return M(V, S);
            }
        }
    }, O = ()=>{
        const y = $f93880154c0ab2a4$var$Le(l);
        if (y) {
            if (i.autoPosition === $f93880154c0ab2a4$var$st.top) return $f93880154c0ab2a4$var$st.top;
            if (i.autoPosition === $f93880154c0ab2a4$var$st.bottom) return $f93880154c0ab2a4$var$st.bottom;
            const { height: V } = P.value, { top: S, height: q } = y.getBoundingClientRect(), se = window.innerHeight - S - q, u = S;
            return V <= se ? $f93880154c0ab2a4$var$st.bottom : V > se && V <= u ? $f93880154c0ab2a4$var$st.top : se >= u ? $f93880154c0ab2a4$var$st.bottom : $f93880154c0ab2a4$var$st.top;
        }
        return $f93880154c0ab2a4$var$st.bottom;
    }, J = (y)=>O() === $f93880154c0ab2a4$var$st.bottom ? U(y) : $(y), ce = ()=>{
        const y = $f93880154c0ab2a4$var$Le(l);
        if (y) return i.autoPosition ? J(y) : U(y);
    }, pe = function(y) {
        if (y) {
            const V = y.scrollHeight > y.clientHeight, q = window.getComputedStyle(y).overflowY.indexOf("hidden") !== -1;
            return V && !q;
        }
        return !0;
    }, p = function(y) {
        return !y || y === document.body || y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : pe(y) ? y : p(y.assignedSlot && d.value.shadowDom ? y.assignedSlot.parentNode : y.parentNode);
    }, Y = (y)=>{
        if (y) switch(i.position){
            case $f93880154c0ab2a4$var$Et.left:
                return {
                    left: 0,
                    transform: "translateX(0)"
                };
            case $f93880154c0ab2a4$var$Et.right:
                return {
                    left: `${y.width}px`,
                    transform: "translateX(-100%)"
                };
            default:
                return {
                    left: `${y.width / 2}px`,
                    transform: "translateX(-50%)"
                };
        }
        return {};
    };
    return {
        openOnTop: h,
        menuStyle: R,
        xCorrect: v,
        setMenuPosition: L,
        getScrollableParent: p,
        shadowRender: (y, V, S)=>{
            var _Le, _n_value, _G_el;
            const q = document.createElement("div"), k = (_Le = $f93880154c0ab2a4$var$Le(l)) === null || _Le === void 0 ? void 0 : _Le.getBoundingClientRect();
            q.setAttribute("id", "dp--temp-container");
            const se = ((_n_value = n.value) === null || _n_value === void 0 ? void 0 : _n_value.clientWidth) ? n.value : document.body;
            se.append(q);
            const u = Y(k), re = d.value.shadowDom ? Object.keys(g).filter((I)=>[
                    "right-sidebar",
                    "left-sidebar",
                    "top-extra",
                    "action-extra"
                ].includes(I)) : Object.keys(g), G = (0, $cc75f711ea0318a4$exports.h)(V, (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, S), {
                shadow: !0,
                style: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
                    opacity: 0,
                    position: "absolute"
                }, u)
            }), Object.fromEntries(re.map((I)=>[
                    I,
                    g[I]
                ])));
            y != null && (G.appContext = y.appContext), (0, $cc75f711ea0318a4$exports.render)(G, q), P.value = (_G_el = G.el) === null || _G_el === void 0 ? void 0 : _G_el.getBoundingClientRect(), (0, $cc75f711ea0318a4$exports.render)(null, q), se.removeChild(q);
        }
    };
}, $f93880154c0ab2a4$var$bt = [
    {
        name: "clock-icon",
        use: [
            "time",
            "calendar",
            "shared"
        ]
    },
    {
        name: "arrow-left",
        use: [
            "month-year",
            "calendar",
            "shared",
            "year-mode"
        ]
    },
    {
        name: "arrow-right",
        use: [
            "month-year",
            "calendar",
            "shared",
            "year-mode"
        ]
    },
    {
        name: "arrow-up",
        use: [
            "time",
            "calendar",
            "month-year",
            "shared"
        ]
    },
    {
        name: "arrow-down",
        use: [
            "time",
            "calendar",
            "month-year",
            "shared"
        ]
    },
    {
        name: "calendar-icon",
        use: [
            "month-year",
            "time",
            "calendar",
            "shared",
            "year-mode"
        ]
    },
    {
        name: "day",
        use: [
            "calendar",
            "shared"
        ]
    },
    {
        name: "month-overlay-value",
        use: [
            "calendar",
            "month-year",
            "shared"
        ]
    },
    {
        name: "year-overlay-value",
        use: [
            "calendar",
            "month-year",
            "shared",
            "year-mode"
        ]
    },
    {
        name: "year-overlay",
        use: [
            "month-year",
            "shared"
        ]
    },
    {
        name: "month-overlay",
        use: [
            "month-year",
            "shared"
        ]
    },
    {
        name: "month-overlay-header",
        use: [
            "month-year",
            "shared"
        ]
    },
    {
        name: "year-overlay-header",
        use: [
            "month-year",
            "shared"
        ]
    },
    {
        name: "hours-overlay-value",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "hours-overlay-header",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "minutes-overlay-value",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "minutes-overlay-header",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "seconds-overlay-value",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "seconds-overlay-header",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "hours",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "minutes",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "month",
        use: [
            "calendar",
            "month-year",
            "shared"
        ]
    },
    {
        name: "year",
        use: [
            "calendar",
            "month-year",
            "shared",
            "year-mode"
        ]
    },
    {
        name: "action-buttons",
        use: [
            "action"
        ]
    },
    {
        name: "action-preview",
        use: [
            "action"
        ]
    },
    {
        name: "calendar-header",
        use: [
            "calendar",
            "shared"
        ]
    },
    {
        name: "marker-tooltip",
        use: [
            "calendar",
            "shared"
        ]
    },
    {
        name: "action-extra",
        use: [
            "menu"
        ]
    },
    {
        name: "time-picker-overlay",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "am-pm-button",
        use: [
            "calendar",
            "time",
            "shared"
        ]
    },
    {
        name: "left-sidebar",
        use: [
            "menu"
        ]
    },
    {
        name: "right-sidebar",
        use: [
            "menu"
        ]
    },
    {
        name: "month-year",
        use: [
            "month-year",
            "shared"
        ]
    },
    {
        name: "time-picker",
        use: [
            "menu",
            "shared"
        ]
    },
    {
        name: "action-row",
        use: [
            "action"
        ]
    },
    {
        name: "marker",
        use: [
            "calendar",
            "shared"
        ]
    },
    {
        name: "quarter",
        use: [
            "shared"
        ]
    },
    {
        name: "top-extra",
        use: [
            "shared",
            "month-year"
        ]
    },
    {
        name: "tp-inline-arrow-up",
        use: [
            "shared",
            "time"
        ]
    },
    {
        name: "tp-inline-arrow-down",
        use: [
            "shared",
            "time"
        ]
    },
    {
        name: "menu-header",
        use: [
            "menu"
        ]
    }
], $f93880154c0ab2a4$var$fo = [
    {
        name: "trigger"
    },
    {
        name: "input-icon"
    },
    {
        name: "clear-icon"
    },
    {
        name: "dp-input"
    }
], $f93880154c0ab2a4$var$vo = {
    all: ()=>$f93880154c0ab2a4$var$bt,
    monthYear: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("month-year")),
    input: ()=>$f93880154c0ab2a4$var$fo,
    timePicker: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("time")),
    action: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("action")),
    calendar: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("calendar")),
    menu: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("menu")),
    shared: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("shared")),
    yearMode: ()=>$f93880154c0ab2a4$var$bt.filter((e)=>e.use.includes("year-mode"))
}, $f93880154c0ab2a4$var$et = (e, t, l)=>{
    const n = [];
    return $f93880154c0ab2a4$var$vo[t]().forEach((a)=>{
        e[a.name] && n.push(a.name);
    }), (l === null || l === void 0 ? void 0 : l.length) && l.forEach((a)=>{
        a.slot && n.push(a.slot);
    }), n;
}, $f93880154c0ab2a4$var$aa = (e)=>{
    const t = (0, $cc75f711ea0318a4$exports.computed)(()=>(n)=>e.value ? n ? e.value.open : e.value.close : ""), l = (0, $cc75f711ea0318a4$exports.computed)(()=>(n)=>e.value ? n ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
    return {
        transitionName: t,
        showTransition: !!e.value,
        menuTransition: l
    };
}, $f93880154c0ab2a4$var$na = (e, t, l)=>{
    const { defaultedRange: n, defaultedTz: a } = $f93880154c0ab2a4$var$Oe(e), f = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$Ze($f93880154c0ab2a4$var$H(), a.value.timezone)), i = (0, $cc75f711ea0318a4$exports.ref)([
        {
            month: (0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(f),
            year: (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(f)
        }
    ]), g = (h)=>{
        const T = {
            hours: (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)(f),
            minutes: (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145)(f),
            seconds: 0
        };
        return n.value.enabled ? [
            T[h],
            T[h]
        ] : T[h];
    }, d = (0, $cc75f711ea0318a4$exports.reactive)({
        hours: g("hours"),
        minutes: g("minutes"),
        seconds: g("seconds")
    });
    (0, $cc75f711ea0318a4$exports.watch)(n, (h, T)=>{
        h.enabled !== T.enabled && (d.hours = g("hours"), d.minutes = g("minutes"), d.seconds = g("seconds"));
    }, {
        deep: !0
    });
    const P = (0, $cc75f711ea0318a4$exports.computed)({
        get: ()=>e.internalModelValue,
        set: (h)=>{
            !e.readonly && !e.disabled && t("update:internal-model-value", h);
        }
    }), v = (0, $cc75f711ea0318a4$exports.computed)(()=>(h)=>i.value[h] ? i.value[h].month : 0), R = (0, $cc75f711ea0318a4$exports.computed)(()=>(h)=>i.value[h] ? i.value[h].year : 0);
    return (0, $cc75f711ea0318a4$exports.watch)(P, (h, T)=>{
        l && JSON.stringify(h !== null && h !== void 0 ? h : {}) !== JSON.stringify(T !== null && T !== void 0 ? T : {}) && l();
    }, {
        deep: !0
    }), {
        calendars: i,
        time: d,
        modelValue: P,
        month: v,
        year: R,
        today: f
    };
}, $f93880154c0ab2a4$var$mo = (e, t)=>{
    const { defaultedMultiCalendars: l, defaultedMultiDates: n, defaultedUI: a, defaultedHighlight: f, defaultedTz: i, propDates: g, defaultedRange: d } = $f93880154c0ab2a4$var$Oe(t), { isDisabled: P } = $f93880154c0ab2a4$var$Tt(t), v = (0, $cc75f711ea0318a4$exports.ref)(null), R = (0, $cc75f711ea0318a4$exports.ref)($f93880154c0ab2a4$var$Ze(/* @__PURE__ */ new Date(), i.value.timezone)), h = (c)=>{
        !c.current && t.hideOffsetDates || (v.value = c.value);
    }, T = ()=>{
        v.value = null;
    }, F = (c)=>Array.isArray(e.value) && d.value.enabled && e.value[0] && v.value ? c ? $f93880154c0ab2a4$var$Ee(v.value, e.value[0]) : $f93880154c0ab2a4$var$Be(v.value, e.value[0]) : !0, _ = (c, o)=>{
        const X = ()=>e.value ? o ? e.value[0] || null : e.value[1] : null, B = e.value && Array.isArray(e.value) ? X() : null;
        return $f93880154c0ab2a4$var$$e($f93880154c0ab2a4$var$H(c.value), B);
    }, C = (c)=>{
        const o = Array.isArray(e.value) ? e.value[0] : null;
        var _v_value;
        return c ? !$f93880154c0ab2a4$var$Be((_v_value = v.value) !== null && _v_value !== void 0 ? _v_value : null, o) : !0;
    }, M = (c, o = !0)=>(d.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !c.current ? !1 : $f93880154c0ab2a4$var$$e($f93880154c0ab2a4$var$H(c.value), e.value[o ? 0 : 1]) : d.value.enabled ? _(c, o) && C(o) || $f93880154c0ab2a4$var$$e(c.value, Array.isArray(e.value) ? e.value[0] : null) && F(o) : !1, A = (c, o)=>{
        if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
            const X = $f93880154c0ab2a4$var$$e(c.value, v.value);
            return o ? $f93880154c0ab2a4$var$Ee(e.value[0], c.value) && X : $f93880154c0ab2a4$var$Be(e.value[0], c.value) && X;
        }
        return !1;
    }, m = (c)=>!e.value || t.hideOffsetDates && !c.current ? !1 : d.value.enabled ? t.modelAuto && Array.isArray(e.value) ? $f93880154c0ab2a4$var$$e(c.value, e.value[0] ? e.value[0] : R.value) : !1 : n.value.enabled && Array.isArray(e.value) ? e.value.some((o)=>$f93880154c0ab2a4$var$$e(o, c.value)) : $f93880154c0ab2a4$var$$e(c.value, e.value ? e.value : R.value), z = (c)=>{
        if (d.value.autoRange || t.weekPicker) {
            if (v.value) {
                if (t.hideOffsetDates && !c.current) return !1;
                const o = (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(v.value, +d.value.autoRange), X = $f93880154c0ab2a4$var$mt($f93880154c0ab2a4$var$H(v.value), t.weekStart);
                return t.weekPicker ? $f93880154c0ab2a4$var$$e(X[1], $f93880154c0ab2a4$var$H(c.value)) : $f93880154c0ab2a4$var$$e(o, $f93880154c0ab2a4$var$H(c.value));
            }
            return !1;
        }
        return !1;
    }, L = (c)=>{
        if (d.value.autoRange || t.weekPicker) {
            if (v.value) {
                const o = (0, $9beb75eaafe7f582$export$dd412b56f1e4d8aa)(v.value, +d.value.autoRange);
                if (t.hideOffsetDates && !c.current) return !1;
                const X = $f93880154c0ab2a4$var$mt($f93880154c0ab2a4$var$H(v.value), t.weekStart);
                return t.weekPicker ? $f93880154c0ab2a4$var$Ee(c.value, X[0]) && $f93880154c0ab2a4$var$Be(c.value, X[1]) : $f93880154c0ab2a4$var$Ee(c.value, v.value) && $f93880154c0ab2a4$var$Be(c.value, o);
            }
            return !1;
        }
        return !1;
    }, le = (c)=>{
        if (d.value.autoRange || t.weekPicker) {
            if (v.value) {
                if (t.hideOffsetDates && !c.current) return !1;
                const o = $f93880154c0ab2a4$var$mt($f93880154c0ab2a4$var$H(v.value), t.weekStart);
                return t.weekPicker ? $f93880154c0ab2a4$var$$e(o[0], c.value) : $f93880154c0ab2a4$var$$e(v.value, c.value);
            }
            return !1;
        }
        return !1;
    }, U = (c)=>$f93880154c0ab2a4$var$xt(e.value, v.value, c.value), $ = ()=>t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, ee = ()=>t.modelAuto ? $f93880154c0ab2a4$var$Rn(t.internalModelValue) : !0, O = (c)=>{
        if (t.weekPicker) return !1;
        const o = d.value.enabled ? !M(c) && !M(c, !1) : !0;
        return !P(c.value) && !m(c) && !(!c.current && t.hideOffsetDates) && o;
    }, J = (c)=>d.value.enabled ? t.modelAuto ? $() && m(c) : !1 : m(c), ce = (c)=>f.value ? $f93880154c0ab2a4$var$Bl(c.value, g.value.highlight) : !1, pe = (c)=>{
        const o = P(c.value);
        return o && (typeof f.value == "function" ? !f.value(c.value, o) : !f.value.options.highlightDisabled);
    }, p = (c)=>{
        var _f_value_weekdays;
        return typeof f.value == "function" ? f.value(c.value) : (_f_value_weekdays = f.value.weekdays) === null || _f_value_weekdays === void 0 ? void 0 : _f_value_weekdays.includes(c.value.getDay());
    }, Y = (c)=>(d.value.enabled || t.weekPicker) && (!(l.value.count > 0) || c.current) && ee() && !(!c.current && t.hideOffsetDates) && !m(c) ? U(c) : !1, te = (c)=>{
        if (Array.isArray(e.value) && e.value.length === 1) {
            const { before: o, after: X } = $f93880154c0ab2a4$var$mn(+d.value.maxRange, e.value[0]);
            return (0, $47e0b58359a22142$export$5c007e10c6929c95)(c.value, o) || (0, $dcd5a7c05c821292$export$e4de839670987035)(c.value, X);
        }
        return !1;
    }, y = (c)=>{
        if (Array.isArray(e.value) && e.value.length === 1) {
            const { before: o, after: X } = $f93880154c0ab2a4$var$mn(+d.value.minRange, e.value[0]);
            return $f93880154c0ab2a4$var$xt([
                o,
                X
            ], e.value[0], c.value);
        }
        return !1;
    }, V = (c)=>d.value.enabled && (d.value.maxRange || d.value.minRange) ? d.value.maxRange && d.value.minRange ? te(c) || y(c) : d.value.maxRange ? te(c) : y(c) : !1, S = (c)=>{
        const { isRangeStart: o, isRangeEnd: X } = u(c), B = d.value.enabled ? o || X : !1;
        return {
            dp__cell_offset: !c.current,
            dp__pointer: !t.disabled && !(!c.current && t.hideOffsetDates) && !P(c.value) && !V(c),
            dp__cell_disabled: P(c.value) || V(c),
            dp__cell_highlight: !pe(c) && (ce(c) || p(c)) && !J(c) && !B && !le(c) && !(Y(c) && t.weekPicker) && !X,
            dp__cell_highlight_active: !pe(c) && (ce(c) || p(c)) && J(c),
            dp__today: !t.noToday && $f93880154c0ab2a4$var$$e(c.value, R.value) && c.current,
            "dp--past": $f93880154c0ab2a4$var$Be(c.value, R.value),
            "dp--future": $f93880154c0ab2a4$var$Ee(c.value, R.value)
        };
    }, q = (c)=>({
            dp__active_date: J(c),
            dp__date_hover: O(c)
        }), k = (c)=>{
        if (e.value && !Array.isArray(e.value)) {
            const o = $f93880154c0ab2a4$var$mt(e.value, t.weekStart);
            return (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, G(c)), {
                dp__range_start: $f93880154c0ab2a4$var$$e(o[0], c.value),
                dp__range_end: $f93880154c0ab2a4$var$$e(o[1], c.value),
                dp__range_between_week: $f93880154c0ab2a4$var$Ee(c.value, o[0]) && $f93880154c0ab2a4$var$Be(c.value, o[1])
            });
        }
        return (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, G(c));
    }, se = (c)=>{
        if (e.value && Array.isArray(e.value)) {
            const o = $f93880154c0ab2a4$var$mt(e.value[0], t.weekStart), X = e.value[1] ? $f93880154c0ab2a4$var$mt(e.value[1], t.weekStart) : [];
            return (0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, G(c)), {
                dp__range_start: $f93880154c0ab2a4$var$$e(o[0], c.value) || $f93880154c0ab2a4$var$$e(X[0], c.value),
                dp__range_end: $f93880154c0ab2a4$var$$e(o[1], c.value) || $f93880154c0ab2a4$var$$e(X[1], c.value),
                dp__range_between_week: $f93880154c0ab2a4$var$Ee(c.value, o[0]) && $f93880154c0ab2a4$var$Be(c.value, o[1]) || $f93880154c0ab2a4$var$Ee(c.value, X[0]) && $f93880154c0ab2a4$var$Be(c.value, X[1]),
                dp__range_between: $f93880154c0ab2a4$var$Ee(c.value, o[1]) && $f93880154c0ab2a4$var$Be(c.value, X[0])
            });
        }
        return (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, G(c));
    }, u = (c)=>{
        const o = l.value.count > 0 ? c.current && M(c) && ee() : M(c) && ee(), X = l.value.count > 0 ? c.current && M(c, !1) && ee() : M(c, !1) && ee();
        return {
            isRangeStart: o,
            isRangeEnd: X
        };
    }, re = (c)=>{
        const { isRangeStart: o, isRangeEnd: X } = u(c);
        return {
            dp__range_start: o,
            dp__range_end: X,
            dp__range_between: Y(c),
            dp__date_hover: $f93880154c0ab2a4$var$$e(c.value, v.value) && !o && !X && !t.weekPicker,
            dp__date_hover_start: A(c, !0),
            dp__date_hover_end: A(c, !1)
        };
    }, G = (c)=>(0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, re(c)), {
            dp__cell_auto_range: L(c),
            dp__cell_auto_range_start: le(c),
            dp__cell_auto_range_end: z(c)
        }), I = (c)=>d.value.enabled ? d.value.autoRange ? G(c) : t.modelAuto ? (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, q(c), re(c)) : t.weekPicker ? se(c) : re(c) : t.weekPicker ? k(c) : q(c);
    return {
        setHoverDate: h,
        clearHoverDate: T,
        getDayClassData: (c)=>{
            var _a_value_calendarCell;
            return t.hideOffsetDates && !c.current ? {} : (0, $cdba156f56d9c0b3$export$71511d61b312f219)((0, $90a40128ed2aa990$export$71511d61b312f219)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, S(c), I(c)), {
                [t.dayClass ? t.dayClass(c.value, t.internalModelValue) : ""]: !0
            }), (_a_value_calendarCell = a.value.calendarCell) !== null && _a_value_calendarCell !== void 0 ? _a_value_calendarCell : {});
        }
    };
}, $f93880154c0ab2a4$var$Tt = (e)=>{
    const { defaultedFilters: t, defaultedRange: l, propDates: n, defaultedMultiDates: a } = $f93880154c0ab2a4$var$Oe(e), f = (p)=>n.value.disabledDates ? typeof n.value.disabledDates == "function" ? n.value.disabledDates($f93880154c0ab2a4$var$H(p)) : !!$f93880154c0ab2a4$var$ca(p, n.value.disabledDates) : !1, i = (p)=>n.value.maxDate ? e.yearPicker ? (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(p) > (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(n.value.maxDate) : $f93880154c0ab2a4$var$Ee(p, n.value.maxDate) : !1, g = (p)=>n.value.minDate ? e.yearPicker ? (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(p) < (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(n.value.minDate) : $f93880154c0ab2a4$var$Be(p, n.value.minDate) : !1, d = (p)=>{
        const Y = i(p), te = g(p), y = f(p), S = t.value.months.map((re)=>+re).includes((0, $12bcf4c82ebf2e01$export$6ce1b5acc29cb53b)(p)), q = e.disabledWeekDays.length ? e.disabledWeekDays.some((re)=>+re === (0, $9c36629740f820b2$export$1b64bc9c5306ed54)(p)) : !1, k = T(p), se = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(p), u = $f93880154c0ab2a4$var$zn(e.yearRange, se);
        return !(Y || te || y || S || u || q || k);
    }, P = (p, Y)=>$f93880154c0ab2a4$var$Be(...$f93880154c0ab2a4$var$wt(n.value.minDate, p, Y)) || $f93880154c0ab2a4$var$$e(...$f93880154c0ab2a4$var$wt(n.value.minDate, p, Y)), v = (p, Y)=>$f93880154c0ab2a4$var$Ee(...$f93880154c0ab2a4$var$wt(n.value.maxDate, p, Y)) || $f93880154c0ab2a4$var$$e(...$f93880154c0ab2a4$var$wt(n.value.maxDate, p, Y)), R = (p, Y, te)=>{
        let y = !1;
        return n.value.maxDate && te && v(p, Y) && (y = !0), n.value.minDate && !te && P(p, Y) && (y = !0), y;
    }, h = (p, Y, te, y)=>{
        let V = !1;
        return y && (n.value.minDate || n.value.maxDate) ? n.value.minDate && n.value.maxDate ? V = R(p, Y, te) : (n.value.minDate && P(p, Y) || n.value.maxDate && v(p, Y)) && (V = !0) : V = !0, V;
    }, T = (p)=>Array.isArray(n.value.allowedDates) && !n.value.allowedDates.length ? !0 : n.value.allowedDates ? !$f93880154c0ab2a4$var$ca(p, n.value.allowedDates, $f93880154c0ab2a4$var$On(e.monthPicker, e.yearPicker)) : !1, F = (p)=>!d(p), _ = (p)=>l.value.noDisabledRange ? !(0, $c9b711093b477e6c$export$7a337e5923c7ceb5)({
            start: p[0],
            end: p[1]
        }).some((te)=>F(te)) : !0, C = (p)=>{
        if (p) {
            const Y = (0, $9492c9f664b3a98c$export$5846dc2d57a5c860)(p);
            return Y >= +e.yearRange[0] && Y <= e.yearRange[1];
        }
        return !0;
    }, M = (p, Y)=>!!(Array.isArray(p) && p[Y] && (l.value.maxRange || l.value.minRange) && C(p[Y])), A = (p, Y, te = 0)=>{
        if (M(Y, te) && C(p)) {
            const y = (0, $df2b8c65fdff64db$export$4a02e9c37dab4871)(p, Y[te]), V = $f93880154c0ab2a4$var$In(Y[te], p), S = V.length === 1 ? 0 : V.filter((k)=>F(k)).length, q = Math.abs(y) - (l.value.minMaxRawRange ? 0 : S);
            if (l.value.minRange && l.value.maxRange) return q >= +l.value.minRange && q <= +l.value.maxRange;
            if (l.value.minRange) return q >= +l.value.minRange;
            if (l.value.maxRange) return q <= +l.value.maxRange;
        }
        return !0;
    }, m = ()=>!e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, z = (p)=>Array.isArray(p) ? [
            p[0] ? $f93880154c0ab2a4$var$Ca(p[0]) : null,
            p[1] ? $f93880154c0ab2a4$var$Ca(p[1]) : null
        ] : $f93880154c0ab2a4$var$Ca(p), L = (p, Y, te)=>p.find((y)=>+y.hours === (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)(Y) && y.minutes === "*" ? !0 : +y.minutes === (0, $65367f09ef3b0fcd$export$b7f1bc3ea3ac4145)(Y) && +y.hours === (0, $bda6db0cdfc5a459$export$257b40f71c07d58f)(Y)) && te, le = (p, Y, te)=>{
        const [y, V] = p, [S, q] = Y;
        return !L(y, S, te) && !L(V, q, te) && te;
    }, U = (p, Y)=>{
        const te = Array.isArray(Y) ? Y : [
            Y
        ];
        return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? le(e.disabledTimes, te, p) : !te.some((y)=>L(e.disabledTimes, y, p)) : p;
    }, $ = (p, Y)=>{
        const te = Array.isArray(Y) ? [
            $f93880154c0ab2a4$var$Bt(Y[0]),
            Y[1] ? $f93880154c0ab2a4$var$Bt(Y[1]) : void 0
        ] : $f93880154c0ab2a4$var$Bt(Y), y = !e.disabledTimes(te);
        return p && y;
    }, ee = (p, Y)=>e.disabledTimes ? Array.isArray(e.disabledTimes) ? U(Y, p) : $(Y, p) : Y, O = (p)=>{
        let Y = !0;
        if (!p || m()) return !0;
        const te = !n.value.minDate && !n.value.maxDate ? z(p) : p;
        return (e.maxTime || n.value.maxDate) && (Y = $f93880154c0ab2a4$var$vn(e.maxTime, n.value.maxDate, "max", $f93880154c0ab2a4$var$Ne(te), Y)), (e.minTime || n.value.minDate) && (Y = $f93880154c0ab2a4$var$vn(e.minTime, n.value.minDate, "min", $f93880154c0ab2a4$var$Ne(te), Y)), ee(p, Y);
    }, J = (p)=>{
        if (!e.monthPicker) return !0;
        let Y = !0;
        const te = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$it(p));
        if (n.value.minDate && n.value.maxDate) {
            const y = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$it(n.value.minDate)), V = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$it(n.value.maxDate));
            return $f93880154c0ab2a4$var$Ee(te, y) && $f93880154c0ab2a4$var$Be(te, V) || $f93880154c0ab2a4$var$$e(te, y) || $f93880154c0ab2a4$var$$e(te, V);
        }
        if (n.value.minDate) {
            const y = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$it(n.value.minDate));
            Y = $f93880154c0ab2a4$var$Ee(te, y) || $f93880154c0ab2a4$var$$e(te, y);
        }
        if (n.value.maxDate) {
            const y = $f93880154c0ab2a4$var$H($f93880154c0ab2a4$var$it(n.value.maxDate));
            Y = $f93880154c0ab2a4$var$Be(te, y) || $f93880154c0ab2a4$var$$e(te, y);
        }
        return Y;
    }, ce = (0, $cc75f711ea0318a4$exports.computed)(()=>(p)=>!e.enableTimePicker || e.ignoreTimeValidation ? !0 : O(p)), pe = (0, $cc75f711ea0318a4$exports.computed)(()=>(p)=>e.monthPicker ? Array.isArray(p) && (l.value.enabled || a.value.enabled) ? !p.filter((te)=>!J(te)).length : J(p) : !0);
    return {
        isDisabled: F,
        validateDate: d,
        validateMonthYearInRange: h,
        isDateRangeAllowed: _,
        checkMinMaxRange: A,
        isValidTime: O,
        isTimeValid: ce,
        isMonthValid: pe
    };
}, $f93880154c0ab2a4$var$ga = ()=>{
    const e = (0, $cc75f711ea0318a4$exports.computed)(()=>(n, a)=>n === null || n === void 0 ? void 0 : n.includes(a)), t = (0, $cc75f711ea0318a4$exports.computed)(()=>(n, a)=>n.count ? n.solo ? !0 : a === 0 : !0), l = (0, $cc75f711ea0318a4$exports.computed)(()=>(n, a)=>n.count ? n.solo ? !0 : a === n.count - 1 : !0);
    return {
        hideNavigationButtons: e,
        showLeftIcon: t,
        showRightIcon: l
    };
}, $f93880154c0ab2a4$var$po = (e, t, l)=>{
    const n = (0, $cc75f711ea0318a4$exports.ref)(0), a = (0, $cc75f711ea0318a4$exports.reactive)({
        [$f93880154c0ab2a4$var$Ot.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
        [$f93880154c0ab2a4$var$Ot.calendar]: !1,
        [$f93880154c0ab2a4$var$Ot.header]: !1
    }), f = (0, $cc75f711ea0318a4$exports.computed)(()=>e.monthPicker || e.timePicker), i = (R)=>{
        var _e_flow;
        if ((_e_flow = e.flow) === null || _e_flow === void 0 ? void 0 : _e_flow.length) {
            if (!R && f.value) return v();
            a[R] = !0, Object.keys(a).filter((h)=>!a[h]).length || v();
        }
    }, g = ()=>{
        var _e_flow, _e_flow1;
        ((_e_flow = e.flow) === null || _e_flow === void 0 ? void 0 : _e_flow.length) && n.value !== -1 && (n.value += 1, t("flow-step", n.value), v()), ((_e_flow1 = e.flow) === null || _e_flow1 === void 0 ? void 0 : _e_flow1.length) === n.value && (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>d());
    }, d = ()=>{
        n.value = -1;
    }, P = (R, h, ...T)=>{
        var _l_value_h, _l_value;
        e.flow[n.value] === R && l.value && ((_l_value_h = (_l_value = l.value)[h]) === null || _l_value_h === void 0 ? void 0 : _l_value_h.call(_l_value, ...T));
    }, v = (R = 0)=>{
        R && (n.value += R), P($f93880154c0ab2a4$var$je.month, "toggleMonthPicker", !0), P($f93880154c0ab2a4$var$je.year, "toggleYearPicker", !0), P($f93880154c0ab2a4$var$je.calendar, "toggleTimePicker", !1, !0), P($f93880154c0ab2a4$var$je.time, "toggleTimePicker", !0, !0);
        const h = e.flow[n.value];
        (h === $f93880154c0ab2a4$var$je.hours || h === $f93880154c0ab2a4$var$je.minutes || h === $f93880154c0ab2a4$var$je.seconds) && P(h, "toggleTimePicker", !0, !0, h);
    };
    return {
        childMount: i,
        updateFlowStep: g,
        resetFlow: d,
        handleFlow: v,
        flowStep: n
    };
}, $f93880154c0ab2a4$var$go = {
    key: 1,
    class: "dp__input_wrap"
}, $f93880154c0ab2a4$var$yo = [
    "id",
    "name",
    "inputmode",
    "placeholder",
    "disabled",
    "readonly",
    "required",
    "value",
    "autocomplete",
    "aria-label",
    "aria-disabled",
    "aria-invalid"
], $f93880154c0ab2a4$var$ho = {
    key: 2,
    class: "dp--clear-btn"
}, $f93880154c0ab2a4$var$bo = [
    "aria-label"
], $f93880154c0ab2a4$var$ko = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "DatepickerInput",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
        isMenuOpen: {
            type: Boolean,
            default: !1
        },
        inputValue: {
            type: String,
            default: ""
        }
    }, $f93880154c0ab2a4$var$va),
    emits: [
        "clear",
        "open",
        "update:input-value",
        "set-input-date",
        "close",
        "select-date",
        "set-empty-date",
        "toggle",
        "focus-prev",
        "focus",
        "blur",
        "real-blur",
        "text-input"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, { defaultedTextInput: f, defaultedAriaLabels: i, defaultedInline: g, defaultedConfig: d, defaultedRange: P, defaultedMultiDates: v, defaultedUI: R, getDefaultPattern: h, getDefaultStartTime: T } = $f93880154c0ab2a4$var$Oe(a), { checkMinMaxRange: F } = $f93880154c0ab2a4$var$Tt(a), _ = (0, $cc75f711ea0318a4$exports.ref)(), C = (0, $cc75f711ea0318a4$exports.ref)(null), M = (0, $cc75f711ea0318a4$exports.ref)(!1), A = (0, $cc75f711ea0318a4$exports.ref)(!1), m = (0, $cc75f711ea0318a4$exports.computed)(()=>{
            var _R_value_input;
            return (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
                dp__pointer: !a.disabled && !a.readonly && !f.value.enabled,
                dp__disabled: a.disabled,
                dp__input_readonly: !f.value.enabled,
                dp__input: !0,
                dp__input_not_clearable: !a.clearable,
                dp__input_icon_pad: !a.hideInputIcon,
                dp__input_valid: typeof a.state == "boolean" ? a.state : !1,
                dp__input_invalid: typeof a.state == "boolean" ? !a.state : !1,
                dp__input_focus: M.value || a.isMenuOpen,
                dp__input_reg: !f.value.enabled
            }, (_R_value_input = R.value.input) !== null && _R_value_input !== void 0 ? _R_value_input : {});
        }), z = ()=>{
            n("set-input-date", null), a.clearable && a.autoApply && (n("set-empty-date"), _.value = null);
        }, L = (k)=>{
            const se = T();
            var _f_value_format;
            return $f93880154c0ab2a4$var$Yl(k, (_f_value_format = f.value.format) !== null && _f_value_format !== void 0 ? _f_value_format : h(), se !== null && se !== void 0 ? se : $f93880154c0ab2a4$var$En({}, a.enableSeconds), a.inputValue, A.value, a.formatLocale);
        }, le = (k)=>{
            const { rangeSeparator: se } = f.value, [u, re] = k.split(`${se}`);
            if (u) {
                const G = L(u.trim()), I = re ? L(re.trim()) : void 0;
                if ((0, $dcd5a7c05c821292$export$e4de839670987035)(G, I)) return;
                const x = G && I ? [
                    G,
                    I
                ] : [
                    G
                ];
                F(I, x, 0) && (_.value = G ? x : null);
            }
        }, U = ()=>{
            A.value = !0;
        }, $ = (k)=>{
            if (P.value.enabled) le(k);
            else if (v.value.enabled) {
                const se = k.split(";");
                _.value = se.map((u)=>L(u.trim())).filter((u)=>u);
            } else _.value = L(k);
        }, ee = (k)=>{
            var _k_target;
            const se = typeof k == "string" ? k : (_k_target = k.target) === null || _k_target === void 0 ? void 0 : _k_target.value;
            se !== "" ? (f.value.openMenu && !a.isMenuOpen && n("open"), $(se), n("set-input-date", _.value)) : z(), A.value = !1, n("update:input-value", se), n("text-input", k, _.value);
        }, O = (k)=>{
            f.value.enabled ? ($(k.target.value), f.value.enterSubmit && $f93880154c0ab2a4$var$za(_.value) && a.inputValue !== "" ? (n("set-input-date", _.value, !0), _.value = null) : f.value.enterSubmit && a.inputValue === "" && (_.value = null, n("clear"))) : pe(k);
        }, J = (k, se)=>{
            f.value.enabled && f.value.tabSubmit && !se && $(k.target.value), f.value.tabSubmit && $f93880154c0ab2a4$var$za(_.value) && a.inputValue !== "" ? (n("set-input-date", _.value, !0, !0), _.value = null) : f.value.tabSubmit && a.inputValue === "" && (_.value = null, n("clear", !0));
        }, ce = ()=>{
            M.value = !0, n("focus"), (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
                var _C_value;
                f.value.enabled && f.value.selectOnFocus && ((_C_value = C.value) === null || _C_value === void 0 ? void 0 : _C_value.select());
            });
        }, pe = (k)=>{
            if ($f93880154c0ab2a4$var$Dt(k, d.value, !0), f.value.enabled && f.value.openMenu && !g.value.input) {
                if (f.value.openMenu === "open" && !a.isMenuOpen) return n("open");
                if (f.value.openMenu === "toggle") return n("toggle");
            } else f.value.enabled || n("toggle");
        }, p = ()=>{
            n("real-blur"), M.value = !1, (!a.isMenuOpen || g.value.enabled && g.value.input) && n("blur"), a.autoApply && f.value.enabled && _.value && !a.isMenuOpen && (n("set-input-date", _.value), n("select-date"), _.value = null);
        }, Y = (k)=>{
            $f93880154c0ab2a4$var$Dt(k, d.value, !0), n("clear");
        }, te = ()=>{
            n("close");
        }, y = (k)=>{
            if (k.key === "Tab" && J(k), k.key === "Enter" && O(k), k.key === "Escape" && f.value.escClose && te(), !f.value.enabled) {
                if (k.code === "Tab") return;
                k.preventDefault();
            }
        }, V = ()=>{
            var _C_value;
            (_C_value = C.value) === null || _C_value === void 0 ? void 0 : _C_value.focus({
                preventScroll: !0
            });
        }, S = (k)=>{
            _.value = k;
        }, q = (k)=>{
            k.key === $f93880154c0ab2a4$var$Re.tab && J(k, !0);
        };
        return t({
            focusInput: V,
            setParsedDate: S
        }), (k, se)=>{
            var _s, _s1, _s2;
            return (0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                onClick: pe
            }, [
                k.$slots.trigger && !k.$slots["dp-input"] && !(0, $cc75f711ea0318a4$exports.unref)(g).enabled ? (0, $cc75f711ea0318a4$exports.renderSlot)(k.$slots, "trigger", {
                    key: 0
                }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                !k.$slots.trigger && (!(0, $cc75f711ea0318a4$exports.unref)(g).enabled || (0, $cc75f711ea0318a4$exports.unref)(g).input) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", $f93880154c0ab2a4$var$go, [
                    k.$slots["dp-input"] && !k.$slots.trigger && (!(0, $cc75f711ea0318a4$exports.unref)(g).enabled || (0, $cc75f711ea0318a4$exports.unref)(g).enabled && (0, $cc75f711ea0318a4$exports.unref)(g).input) ? (0, $cc75f711ea0318a4$exports.renderSlot)(k.$slots, "dp-input", {
                        key: 0,
                        value: e.inputValue,
                        isMenuOpen: e.isMenuOpen,
                        onInput: ee,
                        onEnter: O,
                        onTab: J,
                        onClear: Y,
                        onBlur: p,
                        onKeypress: y,
                        onPaste: U,
                        onFocus: ce,
                        openMenu: ()=>k.$emit("open"),
                        closeMenu: ()=>k.$emit("close"),
                        toggleMenu: ()=>k.$emit("toggle")
                    }) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    k.$slots["dp-input"] ? (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0) : ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("input", {
                        key: 1,
                        id: k.uid ? `dp-input-${k.uid}` : void 0,
                        ref_key: "inputRef",
                        ref: C,
                        "data-test-id": "dp-input",
                        name: k.name,
                        class: (0, $cc75f711ea0318a4$exports.normalizeClass)(m.value),
                        inputmode: (0, $cc75f711ea0318a4$exports.unref)(f).enabled ? "text" : "none",
                        placeholder: k.placeholder,
                        disabled: k.disabled,
                        readonly: k.readonly,
                        required: k.required,
                        value: e.inputValue,
                        autocomplete: k.autocomplete,
                        "aria-label": (_s = (0, $cc75f711ea0318a4$exports.unref)(i)) === null || _s === void 0 ? void 0 : _s.input,
                        "aria-disabled": k.disabled || void 0,
                        "aria-invalid": k.state === !1 ? !0 : void 0,
                        onInput: ee,
                        onBlur: p,
                        onFocus: ce,
                        onKeypress: y,
                        onKeydown: se[0] || (se[0] = (u)=>y(u)),
                        onPaste: U
                    }, null, 42, $f93880154c0ab2a4$var$yo)),
                    (0, $cc75f711ea0318a4$exports.createElementVNode)("div", {
                        onClick: se[3] || (se[3] = (u)=>n("toggle"))
                    }, [
                        k.$slots["input-icon"] && !k.hideInputIcon ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("span", {
                            key: 0,
                            class: "dp__input_icon",
                            onClick: se[1] || (se[1] = (u)=>n("toggle"))
                        }, [
                            (0, $cc75f711ea0318a4$exports.renderSlot)(k.$slots, "input-icon")
                        ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                        !k.$slots["input-icon"] && !k.hideInputIcon && !k.$slots["dp-input"] ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$jt), {
                            key: 1,
                            "aria-label": (_s1 = (0, $cc75f711ea0318a4$exports.unref)(i)) === null || _s1 === void 0 ? void 0 : _s1.calendarIcon,
                            class: "dp__input_icon dp__input_icons",
                            onClick: se[2] || (se[2] = (u)=>n("toggle"))
                        }, null, 8, [
                            "aria-label"
                        ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                    ]),
                    k.$slots["clear-icon"] && (k.alwaysClearable || e.inputValue && k.clearable && !k.disabled && !k.readonly) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("span", $f93880154c0ab2a4$var$ho, [
                        (0, $cc75f711ea0318a4$exports.renderSlot)(k.$slots, "clear-icon", {
                            clear: Y
                        })
                    ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0),
                    !k.$slots["clear-icon"] && (k.alwaysClearable || k.clearable && e.inputValue && !k.disabled && !k.readonly) ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("button", {
                        key: 3,
                        "aria-label": (_s2 = (0, $cc75f711ea0318a4$exports.unref)(i)) === null || _s2 === void 0 ? void 0 : _s2.clearInput,
                        class: "dp--clear-btn",
                        type: "button",
                        onKeydown: se[4] || (se[4] = (u)=>(0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$qe)(u, ()=>Y(u), !0, q)),
                        onClick: se[5] || (se[5] = (0, $cc75f711ea0318a4$exports.withModifiers)((u)=>Y(u), [
                            "prevent"
                        ]))
                    }, [
                        (0, $cc75f711ea0318a4$exports.createVNode)((0, $cc75f711ea0318a4$exports.unref)($f93880154c0ab2a4$var$Sn), {
                            class: "dp__input_icons",
                            "data-test-id": "clear-icon"
                        })
                    ], 40, $f93880154c0ab2a4$var$bo)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                ])) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
            ]);
        };
    }
}), $f93880154c0ab2a4$var$wo = typeof window < "u" ? window : void 0, $f93880154c0ab2a4$var$Ea = ()=>{}, $f93880154c0ab2a4$var$Do = (e)=>(0, $cc75f711ea0318a4$exports.getCurrentScope)() ? ((0, $cc75f711ea0318a4$exports.onScopeDispose)(e), !0) : !1, $f93880154c0ab2a4$var$Mo = (e, t, l, n)=>{
    if (!e) return $f93880154c0ab2a4$var$Ea;
    let a = $f93880154c0ab2a4$var$Ea;
    const f = (0, $cc75f711ea0318a4$exports.watch)(()=>(0, $cc75f711ea0318a4$exports.unref)(e), (g)=>{
        a(), g && (g.removeEventListener(t, l), g.addEventListener(t, l, n), a = ()=>{
            g.removeEventListener(t, l, n), a = $f93880154c0ab2a4$var$Ea;
        });
    }, {
        immediate: !0,
        flush: "post"
    }), i = ()=>{
        f(), a();
    };
    return $f93880154c0ab2a4$var$Do(i), i;
}, $f93880154c0ab2a4$var$$o = (e, t, l, n = {})=>{
    const { window: a = $f93880154c0ab2a4$var$wo, event: f = "pointerdown" } = n;
    return a ? $f93880154c0ab2a4$var$Mo(a, f, (g)=>{
        const d = $f93880154c0ab2a4$var$Le(e), P = $f93880154c0ab2a4$var$Le(t);
        !d || !P || d === g.target || g.composedPath().includes(d) || g.composedPath().includes(P) || l(g);
    }, {
        passive: !0
    }) : void 0;
}, $f93880154c0ab2a4$var$Ao = [
    "data-dp-mobile"
], $f93880154c0ab2a4$var$To = /* @__PURE__ */ (0, $cc75f711ea0318a4$exports.defineComponent)({
    compatConfig: {
        MODE: 3
    },
    __name: "VueDatePicker",
    props: (0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, $f93880154c0ab2a4$var$va),
    emits: [
        "update:model-value",
        "update:model-timezone-value",
        "text-submit",
        "closed",
        "cleared",
        "open",
        "focus",
        "blur",
        "internal-model-change",
        "recalculate-position",
        "flow-step",
        "update-month-year",
        "invalid-select",
        "invalid-fixed-range",
        "tooltip-open",
        "tooltip-close",
        "time-picker-open",
        "time-picker-close",
        "am-pm-change",
        "range-start",
        "range-end",
        "date-update",
        "invalid-date",
        "overlay-toggle",
        "text-input"
    ],
    setup (e, { expose: t, emit: l }) {
        const n = l, a = e, f = (0, $cc75f711ea0318a4$exports.useSlots)(), i = (0, $cc75f711ea0318a4$exports.ref)(!1), g = (0, $cc75f711ea0318a4$exports.toRef)(a, "modelValue"), d = (0, $cc75f711ea0318a4$exports.toRef)(a, "timezone"), P = (0, $cc75f711ea0318a4$exports.ref)(null), v = (0, $cc75f711ea0318a4$exports.ref)(null), R = (0, $cc75f711ea0318a4$exports.ref)(null), h = (0, $cc75f711ea0318a4$exports.ref)(!1), T = (0, $cc75f711ea0318a4$exports.ref)(null), F = (0, $cc75f711ea0318a4$exports.ref)(!1), _ = (0, $cc75f711ea0318a4$exports.ref)(!1), C = (0, $cc75f711ea0318a4$exports.ref)(!1), M = (0, $cc75f711ea0318a4$exports.ref)(!1), { setMenuFocused: A, setShiftKey: m } = $f93880154c0ab2a4$var$Hn(), { clearArrowNav: z } = $f93880154c0ab2a4$var$At(), { validateDate: L, isValidTime: le } = $f93880154c0ab2a4$var$Tt(a), { defaultedTransitions: U, defaultedTextInput: $, defaultedInline: ee, defaultedConfig: O, defaultedRange: J, defaultedMultiDates: ce } = $f93880154c0ab2a4$var$Oe(a), { menuTransition: pe, showTransition: p } = $f93880154c0ab2a4$var$aa(U), { isMobile: Y } = $f93880154c0ab2a4$var$Qn(O), te = (0, $cc75f711ea0318a4$exports.getCurrentInstance)();
        (0, $cc75f711ea0318a4$exports.onMounted)(()=>{
            var _window, _window1;
            x(a.modelValue), (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
                var _u, _window;
                ee.value.enabled || ((_u = u(T.value)) === null || _u === void 0 ? void 0 : _u.addEventListener("scroll", K), (_window = window) === null || _window === void 0 ? void 0 : _window.addEventListener("resize", oe));
            }), ee.value.enabled && (i.value = !0), (_window = window) === null || _window === void 0 ? void 0 : _window.addEventListener("keyup", ge), (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.addEventListener("keydown", _e);
        }), (0, $cc75f711ea0318a4$exports.onUnmounted)(()=>{
            var _u, _window, _window1, _window2;
            ee.value.enabled || ((_u = u(T.value)) === null || _u === void 0 ? void 0 : _u.removeEventListener("scroll", K), (_window = window) === null || _window === void 0 ? void 0 : _window.removeEventListener("resize", oe)), (_window1 = window) === null || _window1 === void 0 ? void 0 : _window1.removeEventListener("keyup", ge), (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.removeEventListener("keydown", _e);
        });
        const y = $f93880154c0ab2a4$var$et(f, "all", a.presetDates), V = $f93880154c0ab2a4$var$et(f, "input");
        (0, $cc75f711ea0318a4$exports.watch)([
            g,
            d
        ], ()=>{
            x(g.value);
        }, {
            deep: !0
        });
        const { openOnTop: S, menuStyle: q, xCorrect: k, setMenuPosition: se, getScrollableParent: u, shadowRender: re } = $f93880154c0ab2a4$var$co({
            menuRef: P,
            menuRefInner: v,
            inputRef: R,
            pickerWrapperRef: T,
            inline: ee,
            emit: n,
            props: a,
            slots: f
        }), { inputValue: G, internalModelValue: I, parseExternalModelValue: x, emitModelValue: c, formatInputValue: o, checkBeforeEmit: X } = $f93880154c0ab2a4$var$rr(n, a, {
            isInputFocused: h,
            isTextInputDate: M
        }), B = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                dp__main: !0,
                dp__theme_dark: a.dark,
                dp__theme_light: !a.dark,
                dp__flex_display: ee.value.enabled,
                "dp--flex-display-collapsed": C.value,
                dp__flex_display_with_input: ee.value.input
            })), be = (0, $cc75f711ea0318a4$exports.computed)(()=>a.dark ? "dp__theme_dark" : "dp__theme_light"), Ae = (0, $cc75f711ea0318a4$exports.computed)(()=>a.teleport ? {
                to: typeof a.teleport == "boolean" ? "body" : a.teleport,
                disabled: !a.teleport || ee.value.enabled
            } : {}), ne = (0, $cc75f711ea0318a4$exports.computed)(()=>({
                class: "dp__outer_menu_wrap"
            })), r = (0, $cc75f711ea0318a4$exports.computed)(()=>ee.value.enabled && (a.timePicker || a.monthPicker || a.yearPicker || a.quarterPicker)), E = ()=>{
            var _R_value_$el, _R_value;
            var _R_value_$el_getBoundingClientRect;
            return (_R_value_$el_getBoundingClientRect = (_R_value = R.value) === null || _R_value === void 0 ? void 0 : (_R_value_$el = _R_value.$el) === null || _R_value_$el === void 0 ? void 0 : _R_value_$el.getBoundingClientRect()) !== null && _R_value_$el_getBoundingClientRect !== void 0 ? _R_value_$el_getBoundingClientRect : {
                width: 0,
                left: 0,
                right: 0
            };
        }, K = ()=>{
            i.value && (O.value.closeOnScroll ? Xe() : se());
        }, oe = ()=>{
            var _v_value;
            i.value && se();
            var _v_value_$el_getBoundingClientRect_width;
            const N = (_v_value_$el_getBoundingClientRect_width = (_v_value = v.value) === null || _v_value === void 0 ? void 0 : _v_value.$el.getBoundingClientRect().width) !== null && _v_value_$el_getBoundingClientRect_width !== void 0 ? _v_value_$el_getBoundingClientRect_width : 0;
            C.value = document.body.offsetWidth <= N;
        }, ge = (N)=>{
            N.key === "Tab" && !ee.value.enabled && !a.teleport && O.value.tabOutClosesMenu && (T.value.contains(document.activeElement) || Xe()), _.value = N.shiftKey;
        }, _e = (N)=>{
            _.value = N.shiftKey;
        }, Ye = ()=>{
            !a.disabled && !a.readonly && (re(te, $f93880154c0ab2a4$var$hn, a), se(!1), i.value = !0, i.value && n("open"), i.value || xe(), x(a.modelValue));
        }, nt = ()=>{
            var _v_value, _R_value;
            G.value = "", xe(), (_v_value = v.value) === null || _v_value === void 0 ? void 0 : _v_value.onValueCleared(), (_R_value = R.value) === null || _R_value === void 0 ? void 0 : _R_value.setParsedDate(null), n("update:model-value", null), n("update:model-timezone-value", null), n("cleared"), O.value.closeOnClearValue && Xe();
        }, St = ()=>{
            const N = I.value;
            return !N || !Array.isArray(N) && L(N) ? !0 : Array.isArray(N) ? ce.value.enabled || N.length === 2 && L(N[0]) && L(N[1]) ? !0 : J.value.partialRange && !a.timePicker ? L(N[0]) : !1 : !1;
        }, D = ()=>{
            X() && St() ? (c(), Xe()) : n("invalid-select", I.value);
        }, de = (N)=>{
            fe(), c(), O.value.closeOnAutoApply && !N && Xe();
        }, fe = ()=>{
            R.value && $.value.enabled && R.value.setParsedDate(I.value);
        }, ht = (N = !1)=>{
            a.autoApply && le(I.value) && St() && (J.value.enabled && Array.isArray(I.value) ? (J.value.partialRange || I.value.length === 2) && de(N) : de(N));
        }, xe = ()=>{
            $.value.enabled || (I.value = null);
        }, Xe = (N = !1)=>{
            var _v_value_$el, _v_value;
            N && I.value && O.value.setDateOnMenuClose && D(), ee.value.enabled || (i.value && (i.value = !1, k.value = !1, A(!1), m(!1), z(), n("closed"), G.value && x(g.value)), xe(), n("blur"), (_v_value = v.value) === null || _v_value === void 0 ? void 0 : (_v_value_$el = _v_value.$el) === null || _v_value_$el === void 0 ? void 0 : _v_value_$el.remove());
        }, ya = (N, ue, me = !1)=>{
            if (!N) {
                I.value = null;
                return;
            }
            const vt = Array.isArray(N) ? !N.some((Pt)=>!L(Pt)) : L(N), ct = le(N);
            vt && ct ? (M.value = !0, I.value = N, ue ? (F.value = me, D(), n("text-submit")) : a.autoApply && ht(!0), (0, $cc75f711ea0318a4$exports.nextTick)().then(()=>{
                M.value = !1;
            })) : n("invalid-date", N);
        }, ha = ()=>{
            a.autoApply && le(I.value) && c(), fe();
        }, la = ()=>i.value ? Xe() : Ye(), ba = (N)=>{
            I.value = N;
        }, ka = ()=>{
            $.value.enabled && (h.value = !0, o()), n("focus");
        }, wa = ()=>{
            var _Ol;
            $.value.enabled && (h.value = !1, x(a.modelValue), F.value && ((_Ol = $f93880154c0ab2a4$var$Ol(T.value, _.value)) === null || _Ol === void 0 ? void 0 : _Ol.focus())), n("blur");
        }, Da = (N)=>{
            v.value && v.value.updateMonthYear(0, {
                month: $f93880154c0ab2a4$var$dn(N.month),
                year: $f93880154c0ab2a4$var$dn(N.year)
            });
        }, Ma = (N)=>{
            x(N !== null && N !== void 0 ? N : a.modelValue);
        }, an = (N, ue)=>{
            var _v_value;
            (_v_value = v.value) === null || _v_value === void 0 ? void 0 : _v_value.switchView(N, ue);
        }, b = (N, ue)=>O.value.onClickOutside ? O.value.onClickOutside(N, ue) : Xe(!0), ae = (N = 0)=>{
            var _v_value;
            (_v_value = v.value) === null || _v_value === void 0 ? void 0 : _v_value.handleFlow(N);
        }, ve = ()=>P;
        return $f93880154c0ab2a4$var$$o(P, R, (N)=>b(St, N)), t({
            closeMenu: Xe,
            selectDate: D,
            clearValue: nt,
            openMenu: Ye,
            onScroll: K,
            formatInputValue: o,
            // exposed for testing purposes
            updateInternalModelValue: ba,
            // modify internal modelValue
            setMonthYear: Da,
            parseModel: Ma,
            switchView: an,
            toggleMenu: la,
            handleFlow: ae,
            getDpWrapMenuRef: ve
        }), (N, ue)=>((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", {
                ref_key: "pickerWrapperRef",
                ref: T,
                class: (0, $cc75f711ea0318a4$exports.normalizeClass)(B.value),
                "data-datepicker-instance": "",
                "data-dp-mobile": (0, $cc75f711ea0318a4$exports.unref)(Y)
            }, [
                (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$ko, (0, $cc75f711ea0318a4$exports.mergeProps)({
                    ref_key: "inputRef",
                    ref: R,
                    "input-value": (0, $cc75f711ea0318a4$exports.unref)(G),
                    "onUpdate:inputValue": ue[0] || (ue[0] = (me)=>(0, $cc75f711ea0318a4$exports.isRef)(G) ? G.value = me : null),
                    "is-menu-open": i.value
                }, N.$props, {
                    onClear: nt,
                    onOpen: Ye,
                    onSetInputDate: ya,
                    onSetEmptyDate: (0, $cc75f711ea0318a4$exports.unref)(c),
                    onSelectDate: D,
                    onToggle: la,
                    onClose: Xe,
                    onFocus: ka,
                    onBlur: wa,
                    onRealBlur: ue[1] || (ue[1] = (me)=>h.value = !1),
                    onTextInput: ue[2] || (ue[2] = (me)=>N.$emit("text-input", me))
                }), (0, $cc75f711ea0318a4$exports.createSlots)({
                    _: 2
                }, [
                    (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(V), (me, vt)=>({
                            name: me,
                            fn: (0, $cc75f711ea0318a4$exports.withCtx)((ct)=>[
                                    (0, $cc75f711ea0318a4$exports.renderSlot)(N.$slots, me, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(ct)))
                                ])
                        }))
                ]), 1040, [
                    "input-value",
                    "is-menu-open",
                    "onSetEmptyDate"
                ]),
                ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createBlock)((0, $cc75f711ea0318a4$exports.resolveDynamicComponent)(N.teleport ? (0, $cc75f711ea0318a4$exports.Teleport) : "div"), (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)(Ae.value)), {
                    default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                            (0, $cc75f711ea0318a4$exports.createVNode)((0, $cc75f711ea0318a4$exports.Transition), {
                                name: (0, $cc75f711ea0318a4$exports.unref)(pe)((0, $cc75f711ea0318a4$exports.unref)(S)),
                                css: (0, $cc75f711ea0318a4$exports.unref)(p) && !(0, $cc75f711ea0318a4$exports.unref)(ee).enabled
                            }, {
                                default: (0, $cc75f711ea0318a4$exports.withCtx)(()=>[
                                        i.value ? ((0, $cc75f711ea0318a4$exports.openBlock)(), (0, $cc75f711ea0318a4$exports.createElementBlock)("div", (0, $cc75f711ea0318a4$exports.mergeProps)({
                                            key: 0,
                                            ref_key: "dpWrapMenuRef",
                                            ref: P
                                        }, ne.value, {
                                            class: {
                                                "dp--menu-wrapper": !(0, $cc75f711ea0318a4$exports.unref)(ee).enabled
                                            },
                                            style: (0, $cc75f711ea0318a4$exports.unref)(ee).enabled ? void 0 : (0, $cc75f711ea0318a4$exports.unref)(q)
                                        }), [
                                            (0, $cc75f711ea0318a4$exports.createVNode)($f93880154c0ab2a4$var$hn, (0, $cc75f711ea0318a4$exports.mergeProps)({
                                                ref_key: "dpMenuRef",
                                                ref: v
                                            }, N.$props, {
                                                "internal-model-value": (0, $cc75f711ea0318a4$exports.unref)(I),
                                                "onUpdate:internalModelValue": ue[3] || (ue[3] = (me)=>(0, $cc75f711ea0318a4$exports.isRef)(I) ? I.value = me : null),
                                                class: {
                                                    [be.value]: !0,
                                                    "dp--menu-wrapper": N.teleport
                                                },
                                                "open-on-top": (0, $cc75f711ea0318a4$exports.unref)(S),
                                                "no-overlay-focus": r.value,
                                                collapse: C.value,
                                                "get-input-rect": E,
                                                "is-text-input-date": M.value,
                                                onClosePicker: Xe,
                                                onSelectDate: D,
                                                onAutoApply: ht,
                                                onTimeUpdate: ha,
                                                onFlowStep: ue[4] || (ue[4] = (me)=>N.$emit("flow-step", me)),
                                                onUpdateMonthYear: ue[5] || (ue[5] = (me)=>N.$emit("update-month-year", me)),
                                                onInvalidSelect: ue[6] || (ue[6] = (me)=>N.$emit("invalid-select", (0, $cc75f711ea0318a4$exports.unref)(I))),
                                                onAutoApplyInvalid: ue[7] || (ue[7] = (me)=>N.$emit("invalid-select", me)),
                                                onInvalidFixedRange: ue[8] || (ue[8] = (me)=>N.$emit("invalid-fixed-range", me)),
                                                onRecalculatePosition: (0, $cc75f711ea0318a4$exports.unref)(se),
                                                onTooltipOpen: ue[9] || (ue[9] = (me)=>N.$emit("tooltip-open", me)),
                                                onTooltipClose: ue[10] || (ue[10] = (me)=>N.$emit("tooltip-close", me)),
                                                onTimePickerOpen: ue[11] || (ue[11] = (me)=>N.$emit("time-picker-open", me)),
                                                onTimePickerClose: ue[12] || (ue[12] = (me)=>N.$emit("time-picker-close", me)),
                                                onAmPmChange: ue[13] || (ue[13] = (me)=>N.$emit("am-pm-change", me)),
                                                onRangeStart: ue[14] || (ue[14] = (me)=>N.$emit("range-start", me)),
                                                onRangeEnd: ue[15] || (ue[15] = (me)=>N.$emit("range-end", me)),
                                                onDateUpdate: ue[16] || (ue[16] = (me)=>N.$emit("date-update", me)),
                                                onInvalidDate: ue[17] || (ue[17] = (me)=>N.$emit("invalid-date", me)),
                                                onOverlayToggle: ue[18] || (ue[18] = (me)=>N.$emit("overlay-toggle", me)),
                                                onMenuBlur: ue[19] || (ue[19] = (me)=>N.$emit("blur"))
                                            }), (0, $cc75f711ea0318a4$exports.createSlots)({
                                                _: 2
                                            }, [
                                                (0, $cc75f711ea0318a4$exports.renderList)((0, $cc75f711ea0318a4$exports.unref)(y), (me, vt)=>({
                                                        name: me,
                                                        fn: (0, $cc75f711ea0318a4$exports.withCtx)((ct)=>[
                                                                (0, $cc75f711ea0318a4$exports.renderSlot)(N.$slots, me, (0, $cc75f711ea0318a4$exports.normalizeProps)((0, $cc75f711ea0318a4$exports.guardReactiveProps)((0, $cdba156f56d9c0b3$export$71511d61b312f219)({}, ct))))
                                                            ])
                                                    }))
                                            ]), 1040, [
                                                "internal-model-value",
                                                "class",
                                                "open-on-top",
                                                "no-overlay-focus",
                                                "collapse",
                                                "is-text-input-date",
                                                "onRecalculatePosition"
                                            ])
                                        ], 16)) : (0, $cc75f711ea0318a4$exports.createCommentVNode)("", !0)
                                    ]),
                                _: 3
                            }, 8, [
                                "name",
                                "css"
                            ])
                        ]),
                    _: 3
                }, 16))
            ], 10, $f93880154c0ab2a4$var$Ao));
    }
}), $f93880154c0ab2a4$export$2e2bcd8739ae039 = /* @__PURE__ */ (()=>{
    const e = $f93880154c0ab2a4$var$To;
    return e.install = (t)=>{
        t.component("Vue3DatePicker", e);
    }, e;
})(), $f93880154c0ab2a4$var$So = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: $f93880154c0ab2a4$export$2e2bcd8739ae039
}, Symbol.toStringTag, {
    value: "Module"
}));
Object.entries($f93880154c0ab2a4$var$So).forEach(([e, t])=>{
    e !== "default" && ($f93880154c0ab2a4$export$2e2bcd8739ae039[e] = t);
});




document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.js-certificate-control').forEach((el)=>{
        const app = (0, $cc75f711ea0318a4$exports.createApp)({
            data () {
                return {
                    certificateType: false,
                    selectedCertificate: false,
                    areasDropdownOpen: false,
                    areasDropdownSearch: '',
                    selectedArea: false,
                    certificatesDropdownOpen: false,
                    certificatesDropdownSearch: '',
                    fieldCertificateNumber: '',
                    fieldCertificateName: '',
                    fieldOrgNumber: '',
                    certificateDate: null,
                    formError: false,
                    formLoading: false,
                    result: false,
                    techAreas: [],
                    orgDropdownOpen: false,
                    isSwedishOrgNumber: true,
                    init: false,
                    resultTimestamp: false,
                    urlParams: '',
                    resultCertificateNumber: '',
                    resultCertificateName: '',
                    resultOrgNumber: ''
                };
            },
            components: {
                VueDatePicker: $f93880154c0ab2a4$export$2e2bcd8739ae039
            },
            created () {
                const restBase = liGlobal.restBase;
                this.$http.get(restBase + '/softadmin-tech-areas', {
                    headers: {
                        'X-WP-Nonce': liGlobal.restNonce
                    }
                }).then((response)=>{
                    // console.log( response );
                    this.techAreas = Array.isArray(response.data) ? response.data : [];
                    this.init = true;
                    // console.log( this.techAreas );
                    // QR-kod Steg 1. Dubbelkolla att alla parametrar som vi förväntar oss är satta (DETECTA QR KOD).
                    // Expected parameters:
                    // type (company eller person), i vue certificateType
                    // techAreaId , i vue selectedArea
                    // templatedId, i vue selectedCertificate
                    // certificateNumber, i vue fieldCertificateNumber
                    // certificateName, i vue fieldCertificateName (person)
                    // isSwedish, i vue isSwedishOrgNumber (company)
                    // orgNumber, i vue fieldOrgNumber (company)
                    if (window.location.search === '') return;
                    else {
                        this.urlParams = new URLSearchParams(window.location.search);
                        if (this.urlParams.has('type')) {
                            this.certificateType = this.urlParams.get('type');
                            if (this.certificateType === 'company') {
                                if (this.urlParams.has('isSwedish') && this.urlParams.has('orgNumber')) {
                                    this.isSwedishOrgNumber = this.urlParams.get('isSwedish') === '1' ? true : false;
                                    this.fieldOrgNumber = this.urlParams.get('orgNumber');
                                } else return;
                            } else if (this.certificateType === 'person') {
                                if (this.urlParams.has('fullName')) this.fieldCertificateName = decodeURIComponent(this.urlParams.get('fullName'));
                                else return;
                            } else return;
                            if (this.urlParams.has('techAreaId') && this.urlParams.has('templateId') && this.urlParams.has('certificateNumber')) {
                                // QR-kod Steg 2. Sätt all data från parametrarna i vue data.
                                const area = this.techAreas.find((area)=>this.urlParams.get('techAreaId') === area.TechAreaId);
                                if (area === undefined) return;
                                this.selectedArea = {
                                    areaId: area.TechAreaId,
                                    areaName: area.TechAreaName
                                };
                                const certificate = area.CertificateTemplates.find((template)=>this.urlParams.get('templateId') === template.TemplateId);
                                if (certificate === undefined) return;
                                this.selectedCertificate = {
                                    TemplateId: certificate.TemplateId,
                                    TemplateName: certificate.TemplateName
                                };
                                this.fieldCertificateNumber = this.urlParams.get('certificateNumber');
                                this.certificateDate = new Date();
                                // QR-kod Steg 3. Skrolla ner till modulen
                                this.$nextTick(()=>{
                                    const element = el.querySelector('.submit-button');
                                    element.scrollIntoView({
                                        behavior: 'smooth'
                                    });
                                });
                                // QR-kod Steg 4. Kör funktionen validateForm()
                                this.validateForm();
                            } else return;
                        } else return;
                    }
                }).catch((error)=>{
                    this.techAreas = [];
                    this.init = true;
                    console.log(error);
                });
                //IN Vanilla JS get all buttons by class
                const buttons = document.querySelectorAll('.certificate-area-button');
                // console.log( buttons );
                // Add click function to buttons
                buttons.forEach((button)=>{
                    button.addEventListener('click', (e)=>{
                        if (button.dataset.areaId === undefined) {
                            console.log('here');
                            return;
                        }
                        const area = this.techAreas.find((area)=>button.dataset.areaId == area.TechAreaId);
                        if (area === undefined) return;
                        if (this.selectedArea !== false && this.selectedArea.areaId === area.TechAreaId) return;
                        // Clear all prior selections
                        this.selectedCertificate = false;
                        this.selectedArea = false;
                        this.certificateType = false;
                        this.certificateDate = null;
                        this.formError = false;
                        this.clearForm();
                        this.selectArea({
                            areaId: area.TechAreaId,
                            areaName: area.TechAreaName
                        });
                    });
                });
            },
            computed: {
                formattedFieldOrgNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');
                        // if( number.length === 6 ) {
                        //     return number + '-';
                        // }
                        // if( number.length > 6 ) {
                        //     return number.substring(0,6) + '-' + number.substring(6);
                        // } else {
                        //     return number;
                        // }
                        this.fieldOrgNumber = number;
                    },
                    get: function() {
                        const number = this.fieldOrgNumber;
                        if (number.length === 6) return number + '-';
                        if (number.length > 6) return number.substring(0, 6) + '-' + number.substring(6);
                        else return number;
                    }
                },
                areas: function() {
                    const returnArr = [];
                    console.log(this.techAreas);
                    this.techAreas.forEach((area)=>{
                        console.log(area);
                        if (area.CertificateTemplates !== null) returnArr.push({
                            areaId: area.TechAreaId,
                            areaName: area.TechAreaName
                        });
                    });
                    //Sort by TemplateName
                    returnArr.sort((a, b)=>{
                        return a.areaName.localeCompare(b.areaName, 'sv');
                    });
                    if (this.areasDropdownSearch.trim() == '') return returnArr;
                    else return returnArr.filter((item)=>{
                        return item.areaName.toLowerCase().includes(this.areasDropdownSearch.toLowerCase());
                    });
                },
                certificates: function() {
                    const returnArr = [];
                    if (this.certificateType === false || this.selectedArea === false) return [];
                    const area = this.techAreas.find((area)=>{
                        return area.TechAreaId === this.selectedArea.areaId;
                    });
                    if (area === undefined || area.CertificateTemplates === null) return [];
                    if (area.CertificateTemplates !== null) area.CertificateTemplates.forEach((template)=>{
                        if (template.IsRecertificate === false) {
                            if (this.certificateType === 'company') {
                                if (template.IsCompanyCertificate === true) returnArr.push(template);
                            } else if (this.certificateType === 'person') {
                                if (template.IsCompanyCertificate === false) returnArr.push(template);
                            }
                        }
                    });
                    //Sort by TemplateName
                    returnArr.sort((a, b)=>{
                        return a.TemplateName.localeCompare(b.TemplateName, 'sv');
                    });
                    if (this.certificatesDropdownSearch.trim() == '') return returnArr;
                    else return returnArr.filter((item)=>{
                        return item.TemplateName.toLowerCase().includes(this.certificatesDropdownSearch.toLowerCase());
                    });
                }
            },
            methods: {
                selectOrgType: function(type) {
                    this.fieldOrgNumber = '';
                    this.orgDropdownOpen = false;
                    this.isSwedishOrgNumber = type;
                },
                selectCertificateType: function(type) {
                    if (this.certificateOfTypeExists(type) === false) return;
                    if (type === this.certificateType) return;
                    if (this.selectedCertificate !== false) this.selectedCertificate = false;
                    this.clearForm();
                    this.certificateType = type;
                },
                onlyNumber ($event) {
                    //console.log($event.keyCode); //keyCodes value
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                preventDateEnterSubmit ($event) {
                    // Stop Enter in the date text input from submitting the form, without blocking Enter on the calendar's buttons
                    if ($event.target.tagName === 'INPUT') $event.preventDefault();
                },
                onlyNumberOrg ($event) {
                    if ($event.target.value.length > 10) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                test: function(date) {
                    const today = new Date();
                    return date > today;
                },
                selectArea: function(selected) {
                    this.selectedCertificate = false;
                    this.selectedArea = selected;
                    this.areasDropdownSearch = '';
                    this.areasDropdownOpen = false;
                    this.certificateType = false;
                    this.selectedCertificate = false;
                    this.clearForm();
                    // If area only contains one type of certificate, select it
                    const area = this.techAreas.find((area)=>{
                        return area.TechAreaId === this.selectedArea.areaId;
                    });
                    if (area.CertificateTemplates !== null && area.CertificateTemplates.length > 0) {
                        const companyCertificates = area.CertificateTemplates.filter((template)=>{
                            return template.IsCompanyCertificate === true;
                        });
                        const personCertificates = area.CertificateTemplates.filter((template)=>{
                            return template.IsCompanyCertificate === false;
                        });
                        if (personCertificates.length === 0) this.certificateType = 'company';
                        else if (companyCertificates.length === 0) this.certificateType = 'person';
                    }
                },
                certificateOfTypeExists: function(type) {
                    if (this.selectedArea === false) return false;
                    const area = this.techAreas.find((area)=>{
                        return area.TechAreaId === this.selectedArea.areaId;
                    });
                    if (area.CertificateTemplates === null) return false;
                    if (type === 'company') return area.CertificateTemplates.some((template)=>{
                        return template.IsCompanyCertificate === true;
                    });
                    else if (type === 'person') return area.CertificateTemplates.some((template)=>{
                        return template.IsCompanyCertificate === false;
                    });
                    return false;
                },
                selectCertificate: function(selected) {
                    this.certificatesDropdownOpen = false;
                    this.selectedCertificate = selected;
                    this.certificatesDropdownSearch = '';
                    this.clearForm();
                },
                clearForm: function() {
                    this.result = false;
                    this.fieldCertificateNumber = '';
                    this.fieldCertificateName = '';
                    this.fieldOrgNumber = '';
                    this.certificateDate = null;
                    this.isSwedishOrgNumber = true;
                    this.resultTimestamp = false;
                },
                clearResult: function() {
                    this.resultCertificateNumber = '';
                    this.resultCertificateName = '';
                    this.resultOrgNumber = '';
                },
                validateForm: function() {
                    if (this.formLoading == true) return;
                    this.clearResult();
                    this.result = false;
                    this.formError = false;
                    const certificateNumber = this.fieldCertificateNumber.trim();
                    const name = this.fieldCertificateName.trim();
                    let date = this.certificateDate;
                    if (certificateNumber === '') {
                        this.formError = {
                            field: 'fieldCertificateNumber',
                            message: 'ange ett certifikatnummer'
                        };
                        return;
                    }
                    if (this.certificateType === 'person') {
                        if (name === '') {
                            this.formError = {
                                field: 'fieldCertificateName',
                                message: 'ange ett namn'
                            };
                            return;
                        }
                        if (!/\s/.test(name)) {
                            this.formError = {
                                field: 'fieldCertificateName',
                                message: "ange b\xe5de ett f\xf6rnamn och ett efternamn"
                            };
                            return;
                        }
                    } else if (this.certificateType === 'company') {
                        if (this.selectedArea && this.selectedArea.areaId !== '26') {
                            if (this.fieldOrgNumber === '') {
                                this.formError = {
                                    field: 'fieldOrgNumber',
                                    message: 'ange ett organisationsnummer'
                                };
                                return;
                            }
                            if (this.isSwedishOrgNumber && this.fieldOrgNumber.length !== 10) {
                                this.formError = {
                                    field: 'fieldOrgNumber',
                                    message: 'oglitigt organisationsnummer'
                                };
                                return;
                            }
                        }
                    }
                    if (date === null) {
                        this.formError = {
                            field: 'certificateDate',
                            message: "v\xe4lj ett datum"
                        };
                        return;
                    }
                    this.formLoading = true;
                    const orgNumber = this.fieldOrgNumber;
                    this.resultCertificateNumber = certificateNumber;
                    this.resultCertificateName = name;
                    // format date to YYYY-MM-DD
                    const offset = date.getTimezoneOffset();
                    date = new Date(date.getTime() - offset * 60000);
                    const dateStatus = date.toISOString().split('T')[0];
                    const restBase = liGlobal.restBase;
                    let query;
                    if (this.certificateType === 'company') {
                        query = '?DateStatus=' + dateStatus + '&CertificateNumber=' + certificateNumber + '&TemplateId=' + this.selectedCertificate.TemplateId;
                        if (this.selectedArea && this.selectedArea.areaId !== '26') query += '&OrganizationNumber=' + this.fieldOrgNumber + '&IsSwedishOrganizationNumber=' + (this.isSwedishOrgNumber === true ? '1' : '0');
                        this.$http.get(restBase + '/softadmin-control-company' + query, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.resultTimestamp = (0, $e457b70bcd427770$exports.DateTime).now().toFormat('yyyy-MM-dd HH:mm');
                            this.result = response.data;
                            console.log(response); // TODO : Remove
                            if (this.certificateType === 'company' && this.result.OrganizationNumber) this.resultOrgNumber = this.result.OrganizationNumber.substring(0, 6) + '-' + this.result.OrganizationNumber.substring(6);
                            this.formLoading = false;
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: '',
                                message: "Kunde inte h\xe4mta kontrollresultat. F\xf6rs\xf6k igen."
                            };
                            console.log(error);
                        });
                    } else if (this.certificateType === 'person') {
                        query = '?DateStatus=' + dateStatus + '&CertificateNumber=' + certificateNumber + '&FullName=' + encodeURIComponent(name) + '&TemplateId=' + this.selectedCertificate.TemplateId;
                        this.$http.get(restBase + '/softadmin-control-person' + query, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.resultTimestamp = (0, $e457b70bcd427770$exports.DateTime).now().toFormat('yyyy-MM-dd HH:mm');
                            this.result = response.data;
                            console.log(response); // TODO : Remove
                            this.formLoading = false;
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: '',
                                message: "Kunde inte h\xe4mta kontrollresultat. F\xf6rs\xf6k igen."
                            };
                            console.log(error);
                        });
                    }
                }
            }
        });
        app.config.globalProperties.$http = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.config.globalProperties.axios = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.mount(el);
    });
});




// src/errors.ts

var $bb8bd86f05b19f6b$var$PersonnummerError = class extends Error {
    constructor(){
        super("Invalid swedish personal identity number");
    }
};
// src/utils.ts
var $bb8bd86f05b19f6b$var$compareAsc = (dateLeft, dateRight)=>{
    const diff = dateLeft.getTime() - dateRight.getTime();
    return diff < 0 ? -1 : diff > 0 ? 1 : diff;
};
var $bb8bd86f05b19f6b$var$diffInYears = (dateLeft, dateRight)=>{
    const sign = $bb8bd86f05b19f6b$var$compareAsc(dateLeft, dateRight);
    const yearDiff = Math.abs(dateLeft.getFullYear() - dateRight.getFullYear());
    dateLeft.setFullYear(dateLeft.getFullYear() - sign * yearDiff);
    const isLastYearNotFull = $bb8bd86f05b19f6b$var$compareAsc(dateLeft, dateRight) === -sign;
    const result = sign * (yearDiff - +isLastYearNotFull);
    return result === 0 ? 0 : result;
};
var $bb8bd86f05b19f6b$var$luhn = (str)=>{
    let sum = 0;
    str += "";
    for(let i = 0, l = str.length; i < l; i++){
        let v = parseInt(str[i]);
        v *= 2 - i % 2;
        if (v > 9) v -= 9;
        sum += v;
    }
    return Math.ceil(sum / 10) * 10 - sum;
};
var $bb8bd86f05b19f6b$var$testDate = (year, month, day)=>{
    month -= 1;
    const date = new Date(year, month, day);
    return !(date.getFullYear() !== year || date.getMonth() !== month || date.getDate() !== day);
};
// src/index.ts
var $bb8bd86f05b19f6b$var$Personnummer = class {
    /**
   * Get century.
   *
   * @return {string}
   */ get century() {
        return this._century;
    }
    /**
   * Get age.
   *
   * @return {string}
   */ get fullYear() {
        return this._fullYear;
    }
    /**
   * Get age.
   *
   * @return {string}
   */ get year() {
        return this._year;
    }
    /**
   * Get month.
   *
   * @return {string}
   */ get month() {
        return this._month;
    }
    /**
   * Get day.
   *
   * @return {string}
   */ get day() {
        return this._day;
    }
    /**
   * Get sep.
   *
   * @return {string}
   */ get sep() {
        return this._sep;
    }
    /**
   * Get num.
   *
   * @return {string}
   */ get num() {
        return this._num;
    }
    /**
   * Get check.
   *
   * @return {string}
   */ get check() {
        return this._check;
    }
    /**
   * Parse personnummer.
   *
   * @param {string} pin
   * @param {object} options
   *
   * @return {Personnummer}
   */ static parse(pin, options) {
        return new $bb8bd86f05b19f6b$var$Personnummer(pin, options);
    }
    /**
   * Validate a Swedish personal identity number.
   *
   * @param {string} str
   * @param {object} options
   *
   * @return {boolean}
   */ static valid(pin, options) {
        try {
            $bb8bd86f05b19f6b$var$Personnummer.parse(pin, options);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * Parse personnummer and set class properties.
   *
   * @param {string} pin
   * @param {object} options
   */ parse(pin, options) {
        if (pin.length < 10 || pin.length > 13) throw new $bb8bd86f05b19f6b$var$PersonnummerError();
        const reg = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([+-]?)((?!000)\d{3}|[TRSUWXJKLMN]\d{2})(\d)$/;
        const match = reg.exec(pin);
        if (!match) throw new $bb8bd86f05b19f6b$var$PersonnummerError();
        const century = match[1];
        const year = match[2];
        const month = match[3];
        const day = match[4];
        const sep = match[5];
        const num = match[6];
        const check = match[7];
        if (typeof century === "undefined" || !century.length) {
            const d = /* @__PURE__ */ new Date();
            let baseYear = 0;
            if (sep === "+") {
                this._sep = "+";
                baseYear = d.getFullYear() - 100;
            } else {
                this._sep = "-";
                baseYear = d.getFullYear();
            }
            this._century = ("" + (baseYear - (baseYear - parseInt(year)) % 100)).substr(0, 2);
        } else {
            this._century = century;
            if (/* @__PURE__ */ new Date().getFullYear() - parseInt(century + year, 10) < 100) this._sep = "-";
            else this._sep = "+";
        }
        this._year = year;
        this._fullYear = this._century + year;
        this._month = month;
        this._day = day;
        this._num = num;
        this._check = check;
        if (!this.valid()) throw new $bb8bd86f05b19f6b$var$PersonnummerError();
        if (!(options == null ? void 0 : options.allowCoordinationNumber) && this.isCoordinationNumber()) throw new $bb8bd86f05b19f6b$var$PersonnummerError();
        if (!(options == null ? void 0 : options.allowInterimNumber) && this.isInterimNumber()) throw new $bb8bd86f05b19f6b$var$PersonnummerError();
    }
    /**
   * Validate a Swedish personal identity number.
   *
   * @return {boolean}
   */ valid() {
        const valid = $bb8bd86f05b19f6b$var$luhn(this.year + this.month + this.day + this.num.replace(/[TRSUWXJKLMN]/, "1")) === +this.check && !!this.check;
        if (valid && $bb8bd86f05b19f6b$var$testDate(parseInt(this.century + this.year), +this.month, +this.day)) return valid;
        return valid && $bb8bd86f05b19f6b$var$testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
    /**
   * Format a Swedish personal identity number as one of the official formats,
   * A long format or a short format.
   *
   * If the input number could not be parsed a empty string will be returned.
   *
   * @param {boolean} longFormat
   *
   * @return {string}
   */ format(longFormat = false) {
        if (longFormat) return `${this.century}${this.year}${this.month}${this.day}${this.num}${this.check}`;
        return `${this.year}${this.month}${this.day}${this.sep}${this.num}${this.check}`;
    }
    /**
   * Get age from a Swedish personal identity number.
   *
   * @return {number}
   */ getAge() {
        const date = this.getDate();
        return $bb8bd86f05b19f6b$var$diffInYears(new Date(Date.now()), date);
    }
    /**
   * Get date from a Swedish personal identity number.
   *
   * @return {Date}
   */ getDate() {
        let ageDay = +this.day;
        if (this.isCoordinationNumber()) ageDay -= 60;
        const ageDate = this.century + this.year + "-" + this.month + "-" + (ageDay < 10 ? "0" + ageDay : ageDay);
        return new Date(ageDate);
    }
    /**
   * Check if a Swedish personal identity number is a interim number or not.
   *
   * @return {boolean}
   */ isInterimNumber() {
        return /[TRSUWXJKLMN]/.test(this.num[0]);
    }
    /**
   * Check if a Swedish personal identity number is a coordination number or not.
   *
   * @return {boolean}
   */ isCoordinationNumber() {
        return $bb8bd86f05b19f6b$var$testDate(parseInt(this.century + this.year), +this.month, +this.day - 60);
    }
    /**
   * Check if a Swedish personal identity number is for a female.
   *
   * @return {boolean}
   */ isFemale() {
        return !this.isMale();
    }
    /**
   * Check if a Swedish personal identity number is for a male.
   *
   * @return {boolean}
   */ isMale() {
        const sexDigit = parseInt(this.num.substr(-1));
        return sexDigit % 2 === 1;
    }
    /**
   * Personnummer constructor.
   *
   * @param {string} pin
   * @param {object} options
   */ constructor(pin, options){
        /**
     * Personnummer century.
     *
     * @var {string}
     */ this._century = "";
        /**
     * Personnummer full year.
     *
     * @var {string}
     */ this._fullYear = "";
        /**
     * Personnummer year.
     *
     * @var {string}
     */ this._year = "";
        /**
     * Personnummer month.
     *
     * @var {string}
     */ this._month = "";
        /**
     * Personnummer day.
     *
     * @var {string}
     */ this._day = "";
        /**
     * Personnummer seperator.
     *
     * @var {string}
     */ this._sep = "";
        /**
     * Personnumer first three of the last four numbers.
     *
     * @var {string}
     */ this._num = "";
        /**
     * The last number of the personnummer.
     *
     * @var {string}
     */ this._check = "";
        this.parse(pin, (0, $cdba156f56d9c0b3$export$71511d61b312f219)({
            allowCoordinationNumber: true,
            allowInterimNumber: false
        }, options));
    }
};
var $bb8bd86f05b19f6b$export$2e2bcd8739ae039 = $bb8bd86f05b19f6b$var$Personnummer;


document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.js-register-company').forEach((el)=>{
        const app = (0, $cc75f711ea0318a4$exports.createApp)({
            data () {
                return {
                    fieldOrgNumber: '',
                    isSwedishOrgNumber: true,
                    fieldCompanyName: '',
                    fieldBillingAddress1: '',
                    fieldBillingAddress2: '',
                    fieldBillingZipCode: '',
                    fieldBillingCity: '',
                    fieldBillingCountry: '',
                    fieldBillingEmail: '',
                    fieldVisitingAddress1: '',
                    fieldVisitingAddress2: '',
                    fieldVisitingZipCode: '',
                    fieldVisitingCity: '',
                    fieldVisitingCountry: '',
                    fieldEmail: '',
                    fieldFirstName: '',
                    fieldLastName: '',
                    fieldPhone: '',
                    formError: false,
                    formLoading: false,
                    result: false,
                    orgDropdownOpen: false,
                    init: false,
                    checkedCompany: false,
                    companyExists: false,
                    step: 1,
                    hasAccount: null,
                    fieldPersonalNumber: '',
                    bankIdPersonalNumber: '',
                    restBase: liGlobal.restBase,
                    authenticatedUser: false,
                    templateDirectory: liGlobal.templateDirectory,
                    qrCode: null,
                    bankIdInterval: null,
                    fieldReference: '',
                    registeredExisting: null,
                    countries: [],
                    selectedBillingCountry: 1,
                    selectedVisitingCountry: 1,
                    billingCountriesDropdownOpen: false,
                    billingCountriesFocusedIndex: -1,
                    billingCountriesSearch: '',
                    visitingCountriesDropdownOpen: false,
                    visitingCountriesFocusedIndex: -1,
                    visitingCountriesSearch: ''
                };
            },
            components: {},
            async created () {
                const countriesResponse = await this.$http.get(this.restBase + '/get-countries');
                this.countries = countriesResponse.data.Countries.sort((a, b)=>a.CountryName.localeCompare(b.CountryName, 'sv-SE'));
                this.init = true;
            },
            mounted () {
                document.addEventListener('click', this.handleClickOutside);
            },
            beforeUnmount () {
                document.removeEventListener('click', this.handleClickOutside);
                document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
            },
            watch: {
                billingCountriesFiltered: {
                    handler () {
                        this.billingCountriesFocusedIndex = -1;
                    }
                },
                visitingCountriesFiltered: {
                    handler () {
                        this.visitingCountriesFocusedIndex = -1;
                    }
                }
            },
            computed: {
                selectedBillingCountryName: function() {
                    var _this_countries_find;
                    if (this.selectedBillingCountry === null) return "V\xe4lj land";
                    var _this_countries_find_CountryName;
                    return (_this_countries_find_CountryName = (_this_countries_find = this.countries.find((country)=>country.CountryId === this.selectedBillingCountry)) === null || _this_countries_find === void 0 ? void 0 : _this_countries_find.CountryName) !== null && _this_countries_find_CountryName !== void 0 ? _this_countries_find_CountryName : "V\xe4lj land";
                },
                selectedVisitingCountryName: function() {
                    var _this_countries_find;
                    if (this.selectedVisitingCountry === null) return "V\xe4lj land";
                    var _this_countries_find_CountryName;
                    return (_this_countries_find_CountryName = (_this_countries_find = this.countries.find((country)=>country.CountryId === this.selectedVisitingCountry)) === null || _this_countries_find === void 0 ? void 0 : _this_countries_find.CountryName) !== null && _this_countries_find_CountryName !== void 0 ? _this_countries_find_CountryName : "V\xe4lj land";
                },
                billingCountriesFiltered: function() {
                    if (this.billingCountriesSearch.trim() == '') return this.countries;
                    else return this.countries.filter((item)=>{
                        return item.CountryName.toLowerCase().includes(this.billingCountriesSearch.trim().toLowerCase());
                    });
                },
                visitingCountriesFiltered: function() {
                    if (this.visitingCountriesSearch.trim() == '') return this.countries;
                    else return this.countries.filter((item)=>{
                        return item.CountryName.toLowerCase().includes(this.visitingCountriesSearch.trim().toLowerCase());
                    });
                },
                formattedFieldPersonalNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');
                        this.fieldPersonalNumber = number;
                    },
                    get: function() {
                        const number = this.fieldPersonalNumber;
                        if (number.length === 8) return number + '-';
                        if (number.length > 8) return number.substring(0, 8) + '-' + number.substring(8);
                        else return number;
                    }
                },
                formattedIntOrgNumber: {
                    set: function(val) {
                        if (!this.isSwedishOrgNumber && this.checkedCompany === true) {
                            this.checkedCompany = false;
                            this.clearForm();
                        }
                        this.fieldOrgNumber = val;
                    },
                    get: function() {
                        return this.fieldOrgNumber;
                    }
                },
                formattedFieldOrgNumber: {
                    set: function(val) {
                        if (this.isSwedishOrgNumber && this.checkedCompany) {
                            this.checkedCompany = false;
                            this.clearForm();
                        }
                        const number = val.replaceAll('-', '');
                        this.fieldOrgNumber = number;
                    },
                    get: function() {
                        const number = this.fieldOrgNumber;
                        if (number.length === 6) return number + '-';
                        if (number.length > 6) return number.substring(0, 6) + '-' + number.substring(6);
                        else return number;
                    }
                }
            },
            methods: {
                toggleBillingCountryDropdown: function() {
                    this.visitingCountriesDropdownOpen = false;
                    this.billingCountriesDropdownOpen = !this.billingCountriesDropdownOpen;
                    this.billingCountriesFocusedIndex = -1;
                    if (this.billingCountriesDropdownOpen) {
                        // Add global event listener when opening
                        document.addEventListener('keydown', this.handleBillingCountriesKeydown);
                        this.$nextTick(()=>{
                            this.$refs.billingCountriesSearch.focus();
                        });
                    } else // Remove listener when closing
                    document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                },
                toggleVisitingCountryDropdown: function() {
                    this.billingCountriesDropdownOpen = false;
                    this.visitingCountriesDropdownOpen = !this.visitingCountriesDropdownOpen;
                    this.visitingCountriesFocusedIndex = -1;
                    if (this.visitingCountriesDropdownOpen) {
                        // Add global event listener when opening
                        document.addEventListener('keydown', this.handleVisitingCountriesKeydown);
                        this.$nextTick(()=>{
                            this.$refs.visitingCountriesSearch.focus();
                        });
                    } else // Remove listener when closing
                    document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
                },
                handleClickOutside (event) {
                    if (this.$refs.billingCountriesDropdown && !this.$refs.billingCountriesDropdown.contains(event.target)) {
                        this.billingCountriesDropdownOpen = false;
                        this.billingCountriesFocusedIndex = -1;
                        // Remove listener when clicking outside
                        document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                    }
                    if (this.$refs.visitingCountriesDropdown && !this.$refs.visitingCountriesDropdown.contains(event.target)) {
                        this.visitingCountriesDropdownOpen = false;
                        this.visitingCountriesFocusedIndex = -1;
                        // Remove listener when clicking outside
                        document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
                    }
                },
                isBillingCountrySelected (option) {
                    const result = this.selectedBillingCountry === option.CountryId;
                    return result;
                },
                isVisitingCountrySelected (option) {
                    const result = this.selectedVisitingCountry === option.CountryId;
                    return result;
                },
                selectBillingCountry: function(county) {
                    this.selectedBillingCountry = county.CountryId;
                    this.billingCountriesDropdownOpen = false;
                    this.billingCountriesSearch = '';
                },
                selectVisitingCountry: function(county) {
                    this.selectedVisitingCountry = county.CountryId;
                    this.visitingCountriesDropdownOpen = false;
                    this.visitingCountriesSearch = '';
                },
                setHasAccount: function(value) {
                    this.hasAccount = value;
                    if (this.hasAccount === false) {
                        this.fieldFirstName = '';
                        this.fieldLastName = '';
                        this.fieldEmail = '';
                    }
                },
                onlyPersonalNumber ($event) {
                    if ($event.target.value.length > 12) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                copyBillingAddress: function() {
                    this.fieldVisitingAddress1 = this.fieldBillingAddress1;
                    this.fieldVisitingAddress2 = this.fieldBillingAddress2;
                    this.fieldVisitingZipCode = this.fieldBillingZipCode;
                    this.fieldVisitingCity = this.fieldBillingCity;
                    this.selectedVisitingCountry = this.selectedBillingCountry;
                },
                checkStep: function(step) {
                    if (this.step >= step) return true;
                    else return false;
                },
                selectOrgType: function(type) {
                    this.fieldOrgNumber = '';
                    this.orgDropdownOpen = false;
                    this.clearForm();
                    if (type === true) {
                        this.selectedBillingCountry = 1;
                        this.selectedVisitingCountry = 1;
                    }
                    this.checkedCompany = false;
                    this.step = 1;
                    this.isSwedishOrgNumber = type;
                },
                onlyNumberOrg ($event) {
                    if ($event.target.value.length > 10) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                clearForm: function() {
                    this.fieldOrgNumber = '';
                    this.fieldCompanyName = '';
                    this.fieldBillingAddress1 = '';
                    this.fieldBillingAddress2 = '';
                    this.fieldBillingZipCode = '';
                    this.fieldBillingCity = '';
                    this.fieldBillingCountry = '';
                    this.fieldBillingEmail = '';
                    this.fieldVisitingAddress1 = '';
                    this.fieldVisitingAddress2 = '';
                    this.fieldVisitingZipCode = '';
                    this.fieldVisitingCity = '';
                    this.fieldVisitingCountry = '';
                    this.hasAccount = null;
                    this.fieldPersonalNumber = '';
                    this.fieldEmail = '';
                    this.fieldFirstName = '';
                    this.fieldLastName = '';
                    this.step = 1;
                    this.fieldReference = '';
                    this.selectedBillingCountry = null;
                    this.selectedVisitingCountry = null;
                    document.removeEventListener('keydown', this.handleBillingCountriesKeydown);
                    document.removeEventListener('keydown', this.handleVisitingCountriesKeydown);
                },
                checkCompany: function() {
                    if (this.formLoading == true) return;
                    this.result = false;
                    this.registeredExisting = null;
                    this.formError = false;
                    this.companyExists = false;
                    const orgNumber = this.fieldOrgNumber.trim();
                    if (this.isSwedishOrgNumber === true) {
                        if (orgNumber === '') {
                            this.formError = {
                                field: 'fieldOrgNumber',
                                message: 'ange ett org. nummer'
                            };
                            return;
                        }
                        if (orgNumber.length !== 10) {
                            this.formError = {
                                field: 'fieldOrgNumber',
                                message: 'ogiltigt org. nummer'
                            };
                            return;
                        }
                    }
                    this.formLoading = true;
                    let query = '?OrganizationNumber=' + orgNumber;
                    this.$http.get(this.restBase + '/softadmin-check-org-number' + query, {
                        headers: {
                            'X-WP-Nonce': liGlobal.restNonce
                        }
                    }).then((response)=>{
                        this.formLoading = false;
                        if (response.data.Exists === false) {
                            this.checkedCompany = true;
                            this.step = 2;
                        } else this.companyExists = true;
                    }).catch((error)=>{
                        this.formLoading = false;
                        this.formError = {
                            field: '',
                            message: "Kunde inte kontrollera organisationsnummer. F\xf6rs\xf6k igen."
                        };
                        console.log(error);
                    });
                },
                authenticateAndRegisterUser: function(device) {
                    const userAgent = navigator.userAgent;
                    const isMobile = userAgent.includes('Mobi') ? 'true' : 'false';
                    const thisDevice = device === 'thisDevice' ? 'true' : 'false';
                    let qrCodeImg = el.querySelector('#qr-code');
                    this.$http.post(this.restBase + '/bankid-federated-login', {
                        isMobile: isMobile,
                        thisDevice: thisDevice
                    }).then((response)=>{
                        const autoStartToken = response.data.autoStartToken;
                        const sessionId = response.data.sessionId;
                        if (device === 'thisDevice') {
                            if (userAgent.includes('Mobi')) {
                                if (userAgent.includes('Mac OS X') && userAgent.includes('Safari/') && !userAgent.includes('Chrome/') && !userAgent.includes('CriOS/') || userAgent.includes('Android') && userAgent.includes('Chrome') || userAgent.includes('Android') && userAgent.includes('CriOs')) // alert('Is Safari on iPhone or Chrome on Android')
                                document.location.href = 'https://app.bankid.com/?autostarttoken=' + autoStartToken + '&redirect=null';
                                else // Split scheme so Parcel does not treat bankid:// as a URL pipeline.
                                document.location.href = [
                                    'bankid:',
                                    '/',
                                    '/',
                                    '/?autostarttoken=',
                                    autoStartToken,
                                    '&redirect=null'
                                ].join('');
                            } else document.location.href = [
                                'bankid:',
                                '/',
                                '/',
                                '/?autostarttoken=',
                                autoStartToken,
                                '&redirect=null'
                            ].join('');
                        } else // const qrCode = response.data.QRCode;
                        this.qrCode = response.data.QRCode;
                        // Get BankID session
                        // Run a function every second for 165 seconds to check if user is authenticated
                        let i = 0;
                        this.bankIdInterval = setInterval(()=>{
                            if (i > 165) {
                                clearInterval(this.bankIdInterval);
                                this.qrCode = null;
                                this.formLoading = false;
                                this.formError = {
                                    field: 'fieldBankId',
                                    message: "Autentisering med BankID genomf\xf6rdes inte. F\xf6rs\xf6k igen."
                                };
                                return;
                            }
                            this.$http.post(this.restBase + '/get-bankid-session', {
                                sessionId: sessionId
                            }).then((response)=>{
                                if (!this.formLoading) return;
                                if (device === 'otherDevice' && response.data.grandidObject !== undefined && response.data.grandidObject.QRCode) this.qrCode = response.data.grandidObject.QRCode;
                                if ('grandidObject' in response.data && response.data.grandidObject.message.status == 'failed') {
                                    clearInterval(this.bankIdInterval);
                                    this.qrCode = null;
                                    this.formLoading = false;
                                    this.formError = {
                                        field: 'fieldBankId',
                                        message: "Autentisering med BankID genomf\xf6rdes inte. F\xf6rs\xf6k igen."
                                    };
                                } else if ('userAttributes' in response.data) {
                                    clearInterval(this.bankIdInterval);
                                    this.qrCode = null;
                                    if (this.fieldPersonalNumber !== response.data.userAttributes.personalNumber) {
                                        this.formLoading = false;
                                        this.formError = {
                                            field: 'fieldPersonalNumber',
                                            message: "Personnumret st\xe4mmer inte \xf6verens med BankID-autentiseringen."
                                        };
                                        this.qrCode = null;
                                        return;
                                    }
                                    // Register user in Softadmin after successful authentication
                                    let data = {
                                        "AddressRow1": this.fieldBillingAddress1,
                                        "AddressRow2": this.fieldBillingAddress2,
                                        "City": this.fieldBillingCity,
                                        "CountryId": this.selectedBillingCountry,
                                        "CompanyName": this.fieldCompanyName,
                                        "IsSwedishOrganizationNumber": this.isSwedishOrgNumber ? '1' : '0',
                                        "OrganizationNumber": this.fieldOrgNumber,
                                        "Zipcode": this.fieldBillingZipCode,
                                        "UserEmail": this.fieldEmail,
                                        "UsernameFirst": this.fieldFirstName,
                                        "UsernameLast": this.fieldLastName,
                                        "UserPersonalNumber": this.fieldPersonalNumber,
                                        "AddressRow1Visit": this.fieldVisitingAddress1,
                                        "AddressRow2Visit": this.fieldVisitingAddress2,
                                        "CityVisit": this.fieldVisitingCity,
                                        "CountryIdVisit": this.selectedVisitingCountry,
                                        "ZipcodeVisit": this.fieldVisitingZipCode,
                                        "EmailInvoice": this.fieldBillingEmail,
                                        "YourReference": this.fieldReference,
                                        "SessionId": sessionId
                                    };
                                    console.log(data);
                                    this.$http.post(this.restBase + '/softadmin-register-company', data, {
                                        headers: {
                                            'X-WP-Nonce': liGlobal.restNonce
                                        }
                                    }).then((response)=>{
                                        this.result = response.data;
                                        this.registeredExisting = this.hasAccount;
                                        if (this.result.ErrorMessage !== undefined && this.result.ErrorMessage === null) this.clearForm();
                                        this.formLoading = false;
                                    }).catch((error)=>{
                                        this.registerError = true;
                                        this.formError = {
                                            field: '',
                                            message: "Kunde inte registrera f\xf6retaget. F\xf6rs\xf6k igen."
                                        };
                                        this.formLoading = false;
                                        console.log(error);
                                    });
                                } else return;
                            });
                            i++;
                        }, 1000);
                    }).catch((error)=>{
                        this.formLoading = false;
                        console.log(error);
                    });
                },
                validateFormAndRegisterUser: async function(device) {
                    if (this.formLoading == true) return;
                    this.formError = false;
                    const step = this.step;
                    const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    this.fieldOrgNumber = this.fieldOrgNumber.trim();
                    this.fieldCompanyName = this.fieldCompanyName.trim();
                    this.fieldBillingAddress1 = this.fieldBillingAddress1.trim();
                    this.fieldBillingAddress2 = this.fieldBillingAddress2.trim();
                    this.fieldBillingZipCode = this.fieldBillingZipCode.trim();
                    this.fieldBillingCity = this.fieldBillingCity.trim();
                    this.fieldBillingCountry = this.selectedBillingCountry;
                    this.fieldBillingEmail = this.fieldBillingEmail.trim();
                    this.fieldReference = this.fieldReference.trim();
                    this.fieldVisitingAddress1 = this.fieldVisitingAddress1.trim();
                    this.fieldVisitingAddress2 = this.fieldVisitingAddress2.trim();
                    this.fieldVisitingZipCode = this.fieldVisitingZipCode.trim();
                    this.fieldVisitingCity = this.fieldVisitingCity.trim();
                    this.fieldVisitingCountry = this.selectedVisitingCountry;
                    this.fieldPersonalNumber = this.fieldPersonalNumber.trim();
                    this.fieldFirstName = this.fieldFirstName.trim();
                    this.fieldLastName = this.fieldLastName.trim();
                    this.fieldEmail = this.fieldEmail.trim();
                    if (step >= 2) {
                        if (this.fieldCompanyName === '') {
                            this.formError = {
                                field: 'fieldCompanyName',
                                message: "ange f\xf6retagsnamn"
                            };
                            return;
                        }
                        if (this.fieldBillingAddress1 === '') {
                            this.formError = {
                                field: 'fieldBillingAddress1',
                                message: 'ange faktureringsadress'
                            };
                            return;
                        }
                        if (this.fieldBillingZipCode === '') {
                            this.formError = {
                                field: 'fieldBillingZipCode',
                                message: 'ange faktureringspostnummer'
                            };
                            return;
                        }
                        if (this.selectedBillingCountry === 1) {
                            const billingZipCode = this.fieldBillingZipCode.replace(/\D/g, '');
                            if (billingZipCode.length !== 5) {
                                this.formError = {
                                    field: 'fieldBillingZipCode',
                                    message: 'ogiltigt faktureringspostnummer'
                                };
                                return;
                            }
                        }
                        if (this.fieldBillingCity === '') {
                            this.formError = {
                                field: 'fieldBillingCity',
                                message: 'ange faktureringsort'
                            };
                            return;
                        }
                        if (this.selectedBillingCountry === null || this.countries.find((country)=>country.CountryId === this.selectedBillingCountry) === undefined) {
                            this.formError = {
                                field: 'fieldBillingCountry',
                                message: 'ange faktureringsland'
                            };
                            return;
                        }
                        if (this.fieldBillingEmail !== '' && !regexp.test(this.fieldBillingEmail)) {
                            this.formError = {
                                field: 'fieldBillingEmail',
                                message: 'ogiltig faktureringsmail'
                            };
                            return;
                        }
                        if (this.fieldReference === '') {
                            this.formError = {
                                field: 'fieldReference',
                                message: 'ange fakturareferens'
                            };
                            return;
                        }
                        this.step = 3;
                    }
                    if (step >= 3) {
                        if (this.fieldVisitingAddress1 === '') {
                            this.formError = {
                                field: 'fieldVisitingAddress1',
                                message: "ange bes\xf6ksadress"
                            };
                            return;
                        }
                        if (this.fieldVisitingZipCode === '') {
                            this.formError = {
                                field: 'fieldVisitingZipCode',
                                message: "ange bes\xf6kspostnummer"
                            };
                            return;
                        }
                        if (this.selectedVisitingCountry === 1) {
                            const visitingZipCode = this.fieldVisitingZipCode.replace(/\D/g, '');
                            if (visitingZipCode.length !== 5) {
                                this.formError = {
                                    field: 'fieldVisitingZipCode',
                                    message: "ogiltigt bes\xf6kspostnummer"
                                };
                                return;
                            }
                        }
                        if (this.fieldVisitingCity === '') {
                            this.formError = {
                                field: 'fieldVisitingCity',
                                message: "ange bes\xf6kssort"
                            };
                            return;
                        }
                        if (this.selectedVisitingCountry === null || this.countries.find((country)=>country.CountryId === this.selectedVisitingCountry) === undefined) {
                            this.formError = {
                                field: 'fieldVisitingCountry',
                                message: "ange bes\xf6ksland"
                            };
                            return;
                        }
                        this.step = 4;
                    }
                    if (step >= 4) {
                        if (this.hasAccount === null) {
                            this.formError = {
                                field: 'fieldHasAccount',
                                message: "v\xe4lj om du har ett konto"
                            };
                            return;
                        }
                        if (this.hasAccount === true) {
                            if (this.fieldPersonalNumber === '') {
                                this.formError = {
                                    field: 'fieldPersonalNumber',
                                    message: 'ange ett personnummer'
                                };
                                return;
                            }
                            if (this.fieldPersonalNumber.length !== 12) {
                                this.formError = {
                                    field: 'fieldPersonalNumber',
                                    message: "oglitigt personnummer, 12 siffror kr\xe4vs."
                                };
                                return;
                            }
                            if (!(0, $bb8bd86f05b19f6b$export$2e2bcd8739ae039).valid(this.fieldPersonalNumber)) {
                                this.formError = {
                                    field: 'fieldPersonalNumber',
                                    message: 'oglitigt personnummer'
                                };
                                return;
                            }
                        } else if (this.hasAccount === false) {
                            if (this.fieldPersonalNumber === '') {
                                this.formError = {
                                    field: 'fieldPersonalNumber',
                                    message: 'ange ett personnummer'
                                };
                                return;
                            }
                            if (this.fieldFirstName === '') {
                                this.formError = {
                                    field: 'fieldFirstName',
                                    message: "ange f\xf6rnamn f\xf6r administrat\xf6r"
                                };
                                return;
                            }
                            if (this.fieldLastName === '') {
                                this.formError = {
                                    field: 'fieldLastName',
                                    message: "ange efternamn f\xf6r administrat\xf6r"
                                };
                                return;
                            }
                            if (this.fieldEmail === '') {
                                this.formError = {
                                    field: 'fieldEmail',
                                    message: "ange en e-postadress administrat\xf6r"
                                };
                                return;
                            }
                            if (!regexp.test(this.fieldEmail)) {
                                this.formError = {
                                    field: 'fieldEmail',
                                    message: 'ogiltig e-postadress'
                                };
                                return;
                            }
                        }
                        this.result = false;
                        this.formLoading = true;
                        if (this.hasAccount === true) {
                            let query = '?PersonalNumber=' + this.fieldPersonalNumber;
                            let response;
                            try {
                                response = await this.$http.get(this.restBase + '/softadmin-check-personal-number' + query, {
                                    headers: {
                                        'X-WP-Nonce': liGlobal.restNonce
                                    }
                                });
                            } catch (error) {
                                this.formLoading = false;
                                this.formError = {
                                    field: '',
                                    message: "Kunde inte kontrollera personnummer. F\xf6rs\xf6k igen."
                                };
                                console.log(error);
                                return;
                            }
                            if (response.data.Exists === false) {
                                this.formLoading = false;
                                this.formError = {
                                    field: 'fieldPersonalNumber',
                                    message: 'konto finns inte med angivet personnummer'
                                };
                                return;
                            }
                        // let data = {
                        //     "AddressRow1": this.fieldBillingAddress1,
                        //     "AddressRow2": this.fieldBillingAddress2,
                        //     "City": this.fieldBillingCity,
                        //     "Country": this.fieldBillingCountry,
                        //     "CompanyName": this.fieldCompanyName,
                        //     "IsSwedishOrganizationNumber": this.isSwedishOrgNumber ? '1' : '0',
                        //     "OrganizationNumber": this.fieldOrgNumber,
                        //     "Zipcode": this.fieldBillingZipCode,
                        //     "UserEmail": this.fieldEmail,
                        //     "UsernameFirst": this.fieldFirstName,
                        //     "UsernameLast": this.fieldLastName,
                        //     "UserPersonalNumber": this.fieldPersonalNumber,
                        //     "AddressRow1Visit": this.fieldVisitingAddress1,
                        //     "AddressRow2Visit": this.fieldVisitingAddress2,
                        //     "CityVisit": this.fieldVisitingCity,
                        //     "CountryVisit": this.fieldVisitingCountry,
                        //     "ZipcodeVisit": this.fieldVisitingZipCode,
                        //     "EmailInvoice": this.fieldBillingEmail,
                        //     "YourReference": this.fieldReference
                        // }
                        // console.log(data);
                        // // console.log('Här anropas Softadmin');
                        // this.$http.post(this.restBase + '/softadmin-register-company', data).then((response) => {
                        //     console.log( response.data );
                        //     this.result = response.data;
                        //     this.formLoading = false;
                        //     this.registeredExisting = true;
                        //     if( this.result.ErrorMessage !== undefined && this.result.ErrorMessage === null ) {
                        //         this.clearForm();
                        //     }
                        // }).catch((error) => {
                        //     console.log( error );
                        //     this.registerError = true;
                        //     this.formLoading = false;
                        // });
                        }
                        this.authenticateAndRegisterUser(device);
                    }
                },
                cancelBankId: function() {
                    clearInterval(this.bankIdInterval);
                    this.qrCode = null;
                    this.formLoading = false;
                }
            }
        });
        app.config.globalProperties.$http = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.config.globalProperties.axios = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.mount(el);
    });
});





var $fcb1be2c68b57ece$exports = {};
$fcb1be2c68b57ece$exports = JSON.parse('[{"id":20,"alpha2":"ad","alpha3":"and","name":"Andorra"},{"id":784,"alpha2":"ae","alpha3":"are","name":"F\xf6renade Arabemiraten"},{"id":4,"alpha2":"af","alpha3":"afg","name":"Afghanistan"},{"id":28,"alpha2":"ag","alpha3":"atg","name":"Antigua och Barbuda"},{"id":8,"alpha2":"al","alpha3":"alb","name":"Albanien"},{"id":51,"alpha2":"am","alpha3":"arm","name":"Armenien"},{"id":24,"alpha2":"ao","alpha3":"ago","name":"Angola"},{"id":32,"alpha2":"ar","alpha3":"arg","name":"Argentina"},{"id":40,"alpha2":"at","alpha3":"aut","name":"\xd6sterrike"},{"id":36,"alpha2":"au","alpha3":"aus","name":"Australien"},{"id":31,"alpha2":"az","alpha3":"aze","name":"Azerbajdzjan"},{"id":70,"alpha2":"ba","alpha3":"bih","name":"Bosnien och Hercegovina"},{"id":52,"alpha2":"bb","alpha3":"brb","name":"Barbados"},{"id":50,"alpha2":"bd","alpha3":"bgd","name":"Bangladesh"},{"id":56,"alpha2":"be","alpha3":"bel","name":"Belgien"},{"id":854,"alpha2":"bf","alpha3":"bfa","name":"Burkina Faso"},{"id":100,"alpha2":"bg","alpha3":"bgr","name":"Bulgarien"},{"id":48,"alpha2":"bh","alpha3":"bhr","name":"Bahrain"},{"id":108,"alpha2":"bi","alpha3":"bdi","name":"Burundi"},{"id":204,"alpha2":"bj","alpha3":"ben","name":"Benin"},{"id":96,"alpha2":"bn","alpha3":"brn","name":"Brunei"},{"id":68,"alpha2":"bo","alpha3":"bol","name":"Bolivia"},{"id":76,"alpha2":"br","alpha3":"bra","name":"Brasilien"},{"id":44,"alpha2":"bs","alpha3":"bhs","name":"Bahamas"},{"id":64,"alpha2":"bt","alpha3":"btn","name":"Bhutan"},{"id":72,"alpha2":"bw","alpha3":"bwa","name":"Botswana"},{"id":112,"alpha2":"by","alpha3":"blr","name":"Belarus"},{"id":84,"alpha2":"bz","alpha3":"blz","name":"Belize"},{"id":124,"alpha2":"ca","alpha3":"can","name":"Kanada"},{"id":180,"alpha2":"cd","alpha3":"cod","name":"Kongo-Kinshasa"},{"id":140,"alpha2":"cf","alpha3":"caf","name":"Centralafrikanska republiken"},{"id":178,"alpha2":"cg","alpha3":"cog","name":"Kongo-Brazzaville"},{"id":756,"alpha2":"ch","alpha3":"che","name":"Schweiz"},{"id":384,"alpha2":"ci","alpha3":"civ","name":"Elfenbenskusten"},{"id":152,"alpha2":"cl","alpha3":"chl","name":"Chile"},{"id":120,"alpha2":"cm","alpha3":"cmr","name":"Kamerun"},{"id":156,"alpha2":"cn","alpha3":"chn","name":"Kina"},{"id":170,"alpha2":"co","alpha3":"col","name":"Colombia"},{"id":188,"alpha2":"cr","alpha3":"cri","name":"Costa Rica"},{"id":192,"alpha2":"cu","alpha3":"cub","name":"Kuba"},{"id":132,"alpha2":"cv","alpha3":"cpv","name":"Kap Verde"},{"id":196,"alpha2":"cy","alpha3":"cyp","name":"Cypern"},{"id":203,"alpha2":"cz","alpha3":"cze","name":"Tjeckien"},{"id":276,"alpha2":"de","alpha3":"deu","name":"Tyskland"},{"id":262,"alpha2":"dj","alpha3":"dji","name":"Djibouti"},{"id":208,"alpha2":"dk","alpha3":"dnk","name":"Danmark"},{"id":212,"alpha2":"dm","alpha3":"dma","name":"Dominica"},{"id":214,"alpha2":"do","alpha3":"dom","name":"Dominikanska republiken"},{"id":12,"alpha2":"dz","alpha3":"dza","name":"Algeriet"},{"id":218,"alpha2":"ec","alpha3":"ecu","name":"Ecuador"},{"id":233,"alpha2":"ee","alpha3":"est","name":"Estland"},{"id":818,"alpha2":"eg","alpha3":"egy","name":"Egypten"},{"id":232,"alpha2":"er","alpha3":"eri","name":"Eritrea"},{"id":724,"alpha2":"es","alpha3":"esp","name":"Spanien"},{"id":231,"alpha2":"et","alpha3":"eth","name":"Etiopien"},{"id":246,"alpha2":"fi","alpha3":"fin","name":"Finland"},{"id":242,"alpha2":"fj","alpha3":"fji","name":"Fiji"},{"id":583,"alpha2":"fm","alpha3":"fsm","name":"Mikronesiska federationen"},{"id":250,"alpha2":"fr","alpha3":"fra","name":"Frankrike"},{"id":266,"alpha2":"ga","alpha3":"gab","name":"Gabon"},{"id":826,"alpha2":"gb","alpha3":"gbr","name":"Storbritannien"},{"id":308,"alpha2":"gd","alpha3":"grd","name":"Grenada"},{"id":268,"alpha2":"ge","alpha3":"geo","name":"Georgien"},{"id":288,"alpha2":"gh","alpha3":"gha","name":"Ghana"},{"id":270,"alpha2":"gm","alpha3":"gmb","name":"Gambia"},{"id":324,"alpha2":"gn","alpha3":"gin","name":"Guinea"},{"id":226,"alpha2":"gq","alpha3":"gnq","name":"Ekvatorialguinea"},{"id":300,"alpha2":"gr","alpha3":"grc","name":"Grekland"},{"id":320,"alpha2":"gt","alpha3":"gtm","name":"Guatemala"},{"id":624,"alpha2":"gw","alpha3":"gnb","name":"Guinea-Bissau"},{"id":328,"alpha2":"gy","alpha3":"guy","name":"Guyana"},{"id":340,"alpha2":"hn","alpha3":"hnd","name":"Honduras"},{"id":191,"alpha2":"hr","alpha3":"hrv","name":"Kroatien"},{"id":332,"alpha2":"ht","alpha3":"hti","name":"Haiti"},{"id":348,"alpha2":"hu","alpha3":"hun","name":"Ungern"},{"id":360,"alpha2":"id","alpha3":"idn","name":"Indonesien"},{"id":372,"alpha2":"ie","alpha3":"irl","name":"Irland"},{"id":376,"alpha2":"il","alpha3":"isr","name":"Israel"},{"id":356,"alpha2":"in","alpha3":"ind","name":"Indien"},{"id":368,"alpha2":"iq","alpha3":"irq","name":"Irak"},{"id":364,"alpha2":"ir","alpha3":"irn","name":"Iran"},{"id":352,"alpha2":"is","alpha3":"isl","name":"Island"},{"id":380,"alpha2":"it","alpha3":"ita","name":"Italien"},{"id":388,"alpha2":"jm","alpha3":"jam","name":"Jamaica"},{"id":400,"alpha2":"jo","alpha3":"jor","name":"Jordanien"},{"id":392,"alpha2":"jp","alpha3":"jpn","name":"Japan"},{"id":404,"alpha2":"ke","alpha3":"ken","name":"Kenya"},{"id":417,"alpha2":"kg","alpha3":"kgz","name":"Kirgizistan"},{"id":116,"alpha2":"kh","alpha3":"khm","name":"Kambodja"},{"id":296,"alpha2":"ki","alpha3":"kir","name":"Kiribati"},{"id":174,"alpha2":"km","alpha3":"com","name":"Komorerna"},{"id":659,"alpha2":"kn","alpha3":"kna","name":"Saint Kitts och Nevis"},{"id":408,"alpha2":"kp","alpha3":"prk","name":"Nordkorea"},{"id":410,"alpha2":"kr","alpha3":"kor","name":"Sydkorea"},{"id":414,"alpha2":"kw","alpha3":"kwt","name":"Kuwait"},{"id":398,"alpha2":"kz","alpha3":"kaz","name":"Kazakstan"},{"id":418,"alpha2":"la","alpha3":"lao","name":"Laos"},{"id":422,"alpha2":"lb","alpha3":"lbn","name":"Libanon"},{"id":662,"alpha2":"lc","alpha3":"lca","name":"Saint Lucia"},{"id":438,"alpha2":"li","alpha3":"lie","name":"Liechtenstein"},{"id":144,"alpha2":"lk","alpha3":"lka","name":"Sri Lanka"},{"id":430,"alpha2":"lr","alpha3":"lbr","name":"Liberia"},{"id":426,"alpha2":"ls","alpha3":"lso","name":"Lesotho"},{"id":440,"alpha2":"lt","alpha3":"ltu","name":"Litauen"},{"id":442,"alpha2":"lu","alpha3":"lux","name":"Luxemburg"},{"id":428,"alpha2":"lv","alpha3":"lva","name":"Lettland"},{"id":434,"alpha2":"ly","alpha3":"lby","name":"Libyen"},{"id":504,"alpha2":"ma","alpha3":"mar","name":"Marocko"},{"id":492,"alpha2":"mc","alpha3":"mco","name":"Monaco"},{"id":498,"alpha2":"md","alpha3":"mda","name":"Moldavien"},{"id":499,"alpha2":"me","alpha3":"mne","name":"Montenegro"},{"id":450,"alpha2":"mg","alpha3":"mdg","name":"Madagaskar"},{"id":584,"alpha2":"mh","alpha3":"mhl","name":"Marshall\xf6arna"},{"id":807,"alpha2":"mk","alpha3":"mkd","name":"Nordmakedonien"},{"id":466,"alpha2":"ml","alpha3":"mli","name":"Mali"},{"id":104,"alpha2":"mm","alpha3":"mmr","name":"Myanmar"},{"id":496,"alpha2":"mn","alpha3":"mng","name":"Mongoliet"},{"id":478,"alpha2":"mr","alpha3":"mrt","name":"Mauretanien"},{"id":470,"alpha2":"mt","alpha3":"mlt","name":"Malta"},{"id":480,"alpha2":"mu","alpha3":"mus","name":"Mauritius"},{"id":462,"alpha2":"mv","alpha3":"mdv","name":"Maldiverna"},{"id":454,"alpha2":"mw","alpha3":"mwi","name":"Malawi"},{"id":484,"alpha2":"mx","alpha3":"mex","name":"Mexiko"},{"id":458,"alpha2":"my","alpha3":"mys","name":"Malaysia"},{"id":508,"alpha2":"mz","alpha3":"moz","name":"Mo\xe7ambique"},{"id":516,"alpha2":"na","alpha3":"nam","name":"Namibia"},{"id":562,"alpha2":"ne","alpha3":"ner","name":"Niger"},{"id":566,"alpha2":"ng","alpha3":"nga","name":"Nigeria"},{"id":558,"alpha2":"ni","alpha3":"nic","name":"Nicaragua"},{"id":528,"alpha2":"nl","alpha3":"nld","name":"Nederl\xe4nderna"},{"id":578,"alpha2":"no","alpha3":"nor","name":"Norge"},{"id":524,"alpha2":"np","alpha3":"npl","name":"Nepal"},{"id":520,"alpha2":"nr","alpha3":"nru","name":"Nauru"},{"id":554,"alpha2":"nz","alpha3":"nzl","name":"Nya Zeeland"},{"id":512,"alpha2":"om","alpha3":"omn","name":"Oman"},{"id":591,"alpha2":"pa","alpha3":"pan","name":"Panama"},{"id":604,"alpha2":"pe","alpha3":"per","name":"Peru"},{"id":598,"alpha2":"pg","alpha3":"png","name":"Papua Nya Guinea"},{"id":608,"alpha2":"ph","alpha3":"phl","name":"Filippinerna"},{"id":586,"alpha2":"pk","alpha3":"pak","name":"Pakistan"},{"id":616,"alpha2":"pl","alpha3":"pol","name":"Polen"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"},{"id":585,"alpha2":"pw","alpha3":"plw","name":"Palau"},{"id":600,"alpha2":"py","alpha3":"pry","name":"Paraguay"},{"id":634,"alpha2":"qa","alpha3":"qat","name":"Qatar"},{"id":642,"alpha2":"ro","alpha3":"rou","name":"Rum\xe4nien"},{"id":688,"alpha2":"rs","alpha3":"srb","name":"Serbien"},{"id":643,"alpha2":"ru","alpha3":"rus","name":"Ryssland"},{"id":646,"alpha2":"rw","alpha3":"rwa","name":"Rwanda"},{"id":682,"alpha2":"sa","alpha3":"sau","name":"Saudiarabien"},{"id":90,"alpha2":"sb","alpha3":"slb","name":"Salomon\xf6arna"},{"id":690,"alpha2":"sc","alpha3":"syc","name":"Seychellerna"},{"id":729,"alpha2":"sd","alpha3":"sdn","name":"Sudan"},{"id":752,"alpha2":"se","alpha3":"swe","name":"Sverige"},{"id":702,"alpha2":"sg","alpha3":"sgp","name":"Singapore"},{"id":705,"alpha2":"si","alpha3":"svn","name":"Slovenien"},{"id":703,"alpha2":"sk","alpha3":"svk","name":"Slovakien"},{"id":694,"alpha2":"sl","alpha3":"sle","name":"Sierra Leone"},{"id":674,"alpha2":"sm","alpha3":"smr","name":"San Marino"},{"id":686,"alpha2":"sn","alpha3":"sen","name":"Senegal"},{"id":706,"alpha2":"so","alpha3":"som","name":"Somalia"},{"id":740,"alpha2":"sr","alpha3":"sur","name":"Surinam"},{"id":728,"alpha2":"ss","alpha3":"ssd","name":"Sydsudan"},{"id":678,"alpha2":"st","alpha3":"stp","name":"S\xe3o Tom\xe9 och Pr\xedncipe"},{"id":222,"alpha2":"sv","alpha3":"slv","name":"El Salvador"},{"id":760,"alpha2":"sy","alpha3":"syr","name":"Syrien"},{"id":748,"alpha2":"sz","alpha3":"swz","name":"Swaziland"},{"id":148,"alpha2":"td","alpha3":"tcd","name":"Tchad"},{"id":768,"alpha2":"tg","alpha3":"tgo","name":"Togo"},{"id":764,"alpha2":"th","alpha3":"tha","name":"Thailand"},{"id":762,"alpha2":"tj","alpha3":"tjk","name":"Tadzjikistan"},{"id":626,"alpha2":"tl","alpha3":"tls","name":"\xd6sttimor"},{"id":795,"alpha2":"tm","alpha3":"tkm","name":"Turkmenistan"},{"id":788,"alpha2":"tn","alpha3":"tun","name":"Tunisien"},{"id":776,"alpha2":"to","alpha3":"ton","name":"Tonga"},{"id":792,"alpha2":"tr","alpha3":"tur","name":"Turkiet"},{"id":780,"alpha2":"tt","alpha3":"tto","name":"Trinidad och Tobago"},{"id":798,"alpha2":"tv","alpha3":"tuv","name":"Tuvalu"},{"id":834,"alpha2":"tz","alpha3":"tza","name":"Tanzania"},{"id":804,"alpha2":"ua","alpha3":"ukr","name":"Ukraina"},{"id":800,"alpha2":"ug","alpha3":"uga","name":"Uganda"},{"id":840,"alpha2":"us","alpha3":"usa","name":"USA"},{"id":858,"alpha2":"uy","alpha3":"ury","name":"Uruguay"},{"id":860,"alpha2":"uz","alpha3":"uzb","name":"Uzbekistan"},{"id":670,"alpha2":"vc","alpha3":"vct","name":"Saint Vincent och Grenadinerna"},{"id":862,"alpha2":"ve","alpha3":"ven","name":"Venezuela"},{"id":704,"alpha2":"vn","alpha3":"vnm","name":"Vietnam"},{"id":548,"alpha2":"vu","alpha3":"vut","name":"Vanuatu"},{"id":882,"alpha2":"ws","alpha3":"wsm","name":"Samoa"},{"id":887,"alpha2":"ye","alpha3":"yem","name":"Jemen"},{"id":710,"alpha2":"za","alpha3":"zaf","name":"Sydafrika"},{"id":894,"alpha2":"zm","alpha3":"zmb","name":"Zambia"},{"id":716,"alpha2":"zw","alpha3":"zwe","name":"Zimbabwe"}]');


var $fd66b5709809509d$exports = {};
$fd66b5709809509d$exports = JSON.parse("{\"BD\":\"880\",\"BE\":\"32\",\"BF\":\"226\",\"BG\":\"359\",\"BA\":\"387\",\"BB\":\"1-246\",\"WF\":\"681\",\"BL\":\"590\",\"BM\":\"1-441\",\"BN\":\"673\",\"BO\":\"591\",\"BH\":\"973\",\"BI\":\"257\",\"BJ\":\"229\",\"BT\":\"975\",\"JM\":\"1-876\",\"BV\":\"\",\"BW\":\"267\",\"WS\":\"685\",\"BQ\":\"599\",\"BR\":\"55\",\"BS\":\"1-242\",\"JE\":\"44-1534\",\"BY\":\"375\",\"BZ\":\"501\",\"RU\":\"7\",\"RW\":\"250\",\"RS\":\"381\",\"TL\":\"670\",\"RE\":\"262\",\"TM\":\"993\",\"TJ\":\"992\",\"RO\":\"40\",\"TK\":\"690\",\"GW\":\"245\",\"GU\":\"1-671\",\"GT\":\"502\",\"GS\":\"\",\"GR\":\"30\",\"GQ\":\"240\",\"GP\":\"590\",\"JP\":\"81\",\"GY\":\"592\",\"GG\":\"44-1481\",\"GF\":\"594\",\"GE\":\"995\",\"GD\":\"1-473\",\"GB\":\"44\",\"GA\":\"241\",\"SV\":\"503\",\"GN\":\"224\",\"GM\":\"220\",\"GL\":\"299\",\"GI\":\"350\",\"GH\":\"233\",\"OM\":\"968\",\"TN\":\"216\",\"JO\":\"962\",\"HR\":\"385\",\"HT\":\"509\",\"HU\":\"36\",\"HK\":\"852\",\"HN\":\"504\",\"HM\":\" \",\"VE\":\"58\",\"PR\":\"1-787\",\"PS\":\"970\",\"PW\":\"680\",\"PT\":\"351\",\"SJ\":\"47\",\"PY\":\"595\",\"IQ\":\"964\",\"PA\":\"507\",\"PF\":\"689\",\"PG\":\"675\",\"PE\":\"51\",\"PK\":\"92\",\"PH\":\"63\",\"PN\":\"870\",\"PL\":\"48\",\"PM\":\"508\",\"ZM\":\"260\",\"EH\":\"212\",\"EE\":\"372\",\"EG\":\"20\",\"ZA\":\"27\",\"EC\":\"593\",\"IT\":\"39\",\"VN\":\"84\",\"SB\":\"677\",\"ET\":\"251\",\"SO\":\"252\",\"ZW\":\"263\",\"SA\":\"966\",\"ES\":\"34\",\"ER\":\"291\",\"ME\":\"382\",\"MD\":\"373\",\"MG\":\"261\",\"MF\":\"590\",\"MA\":\"212\",\"MC\":\"377\",\"UZ\":\"998\",\"MM\":\"95\",\"ML\":\"223\",\"MO\":\"853\",\"MN\":\"976\",\"MH\":\"692\",\"MK\":\"389\",\"MU\":\"230\",\"MT\":\"356\",\"MW\":\"265\",\"MV\":\"960\",\"MQ\":\"596\",\"MP\":\"1-670\",\"MS\":\"1-664\",\"MR\":\"222\",\"IM\":\"44-1624\",\"UG\":\"256\",\"TZ\":\"255\",\"MY\":\"60\",\"MX\":\"52\",\"IL\":\"972\",\"FR\":\"33\",\"IO\":\"246\",\"SH\":\"290\",\"FI\":\"358\",\"FJ\":\"679\",\"FK\":\"500\",\"FM\":\"691\",\"FO\":\"298\",\"NI\":\"505\",\"NL\":\"31\",\"NO\":\"47\",\"NA\":\"264\",\"VU\":\"678\",\"NC\":\"687\",\"NE\":\"227\",\"NF\":\"672\",\"NG\":\"234\",\"NZ\":\"64\",\"NP\":\"977\",\"NR\":\"674\",\"NU\":\"683\",\"CK\":\"682\",\"XK\":\"\",\"CI\":\"225\",\"CH\":\"41\",\"CO\":\"57\",\"CN\":\"86\",\"CM\":\"237\",\"CL\":\"56\",\"CC\":\"61\",\"CA\":\"1\",\"CG\":\"242\",\"CF\":\"236\",\"CD\":\"243\",\"CZ\":\"420\",\"CY\":\"357\",\"CX\":\"61\",\"CR\":\"506\",\"CW\":\"599\",\"CV\":\"238\",\"CU\":\"53\",\"SZ\":\"268\",\"SY\":\"963\",\"SX\":\"599\",\"KG\":\"996\",\"KE\":\"254\",\"SS\":\"211\",\"SR\":\"597\",\"KI\":\"686\",\"KH\":\"855\",\"KN\":\"1-869\",\"KM\":\"269\",\"ST\":\"239\",\"SK\":\"421\",\"KR\":\"82\",\"SI\":\"386\",\"KP\":\"850\",\"KW\":\"965\",\"SN\":\"221\",\"SM\":\"378\",\"SL\":\"232\",\"SC\":\"248\",\"KZ\":\"7\",\"KY\":\"1-345\",\"SG\":\"65\",\"SE\":\"46\",\"SD\":\"249\",\"DO\":\"1-809\",\"DM\":\"1-767\",\"DJ\":\"253\",\"DK\":\"45\",\"VG\":\"1-284\",\"DE\":\"49\",\"YE\":\"967\",\"DZ\":\"213\",\"US\":\"1\",\"UY\":\"598\",\"YT\":\"262\",\"UM\":\"1\",\"LB\":\"961\",\"LC\":\"1-758\",\"LA\":\"856\",\"TV\":\"688\",\"TW\":\"886\",\"TT\":\"1-868\",\"TR\":\"90\",\"LK\":\"94\",\"LI\":\"423\",\"LV\":\"371\",\"TO\":\"676\",\"LT\":\"370\",\"LU\":\"352\",\"LR\":\"231\",\"LS\":\"266\",\"TH\":\"66\",\"TF\":\"\",\"TG\":\"228\",\"TD\":\"235\",\"TC\":\"1-649\",\"LY\":\"218\",\"VA\":\"379\",\"VC\":\"1-784\",\"AE\":\"971\",\"AD\":\"376\",\"AG\":\"1-268\",\"AF\":\"93\",\"AI\":\"1-264\",\"VI\":\"1-340\",\"IS\":\"354\",\"IR\":\"98\",\"AM\":\"374\",\"AL\":\"355\",\"AO\":\"244\",\"AQ\":\"\",\"AS\":\"1-684\",\"AR\":\"54\",\"AU\":\"61\",\"AT\":\"43\",\"AW\":\"297\",\"IN\":\"91\",\"AX\":\"358-18\",\"AZ\":\"994\",\"IE\":\"353\",\"ID\":\"62\",\"UA\":\"380\",\"QA\":\"974\",\"MZ\":\"258\"}");


document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.js-register-user').forEach((el)=>{
        const app = (0, $cc75f711ea0318a4$exports.createApp)({
            data () {
                return {
                    fieldPersonalNumber: '',
                    fieldEmail: '',
                    fieldEmailConfirm: '',
                    fieldFirstName: '',
                    fieldLastName: '',
                    fieldAddress: '',
                    fieldPhone: '',
                    fieldBirthDate: '',
                    formError: false,
                    formLoading: false,
                    result: false,
                    citizenshipDropdownOpen: false,
                    swedishCitizen: true,
                    init: false,
                    checkedUser: false,
                    userExists: false,
                    countries: (0, (/*@__PURE__*/$parcel$interopDefault($fcb1be2c68b57ece$exports))),
                    phoneCodes: (0, (/*@__PURE__*/$parcel$interopDefault($fd66b5709809509d$exports))),
                    selectedCountry: {
                        "id": 752,
                        "alpha2": "se",
                        "alpha3": "swe",
                        "name": "Sverige"
                    },
                    countriesDropdownOpen: false,
                    countriesDropdownSearch: '',
                    bankIdPersonalNumber: '',
                    restBase: liGlobal.restBase,
                    authenticatedUser: false,
                    templateDirectory: liGlobal.templateDirectory,
                    qrCode: null,
                    bankIdInterval: null,
                    doingRegister: false
                };
            },
            components: {},
            created () {
                this.init = true;
            },
            computed: {
                filteredCountries: function() {
                    if (this.countriesDropdownSearch.length > 0) return this.countries.filter((country)=>country.name.toLowerCase().includes(this.countriesDropdownSearch.toLowerCase()));
                    else return this.countries;
                },
                formattedFieldPersonalNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');
                        if (this.checkedUser === true) {
                            this.checkedUser = false;
                            this.clearForm();
                        }
                        this.fieldPersonalNumber = number;
                    },
                    get: function() {
                        const number = this.fieldPersonalNumber;
                        if (number.length === 8) return number + '-';
                        if (number.length > 8) return number.substring(0, 8) + '-' + number.substring(8);
                        else return number;
                    }
                },
                normalizedPhone: function() {
                    if (this.fieldPhone.trim() === '') return '';
                    const phoneCountryCode = this.phoneCodes[this.selectedCountry.alpha2.toUpperCase()];
                    let phone = this.fieldPhone.trim();
                    if (phoneCountryCode === '46' && phone.charAt(0) === '0') phone = phone.substr(1);
                    return '+' + phoneCountryCode.toString() + phone;
                },
                formattedFieldBirthDate: {
                    set: function(val) {
                        if (val.length > this.fieldBirthDate.length) {
                            if (val.length === 4 || val.length === 7) this.fieldBirthDate = val + '-';
                            else this.fieldBirthDate = val;
                        } else {
                            if (val.length === 7) this.fieldBirthDate = val.substring(0, 6);
                            else if (val.length === 4) this.fieldBirthDate = val.substring(0, 3);
                            else this.fieldBirthDate = val;
                        }
                    },
                    get: function() {
                        const number = this.fieldBirthDate;
                        if (number.length === 4 || number.length === 7) return number + '-';
                        return number;
                    }
                },
                formattedEmail: {
                    set: function(val) {
                        if (!this.swedishCitizen && this.checkedUser === true) {
                            this.checkedUser = false;
                            this.clearForm();
                        }
                        this.fieldEmail = val;
                    },
                    get: function() {
                        return this.fieldEmail;
                    }
                }
            },
            methods: {
                selectCountry: function(value) {
                    this.selectedCountry = value;
                    this.countriesDropdownOpen = false;
                    this.countriesDropdownSearch = '';
                },
                selectCitizenship: function(type) {
                    this.citizenshipDropdownOpen = false;
                    if (this.swedishCitizen === type) return;
                    if (this.checkedUser === true) {
                        this.checkedUser = false;
                        this.clearForm();
                    }
                    this.fieldPersonalNumber = '';
                    this.fieldEmail = '';
                    this.fieldEmailConfirm = '';
                    this.swedishCitizen = type;
                },
                onlyNumber ($event) {
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                onlyPersonalNumber ($event) {
                    if ($event.target.value.length > 12) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                onlyBirthDate ($event) {
                    if ($event.target.value.length > 9) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = $event.keyCode ? $event.keyCode : $event.which;
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) $event.preventDefault();
                },
                emailsMatch: function() {
                    return this.fieldEmail.trim().toLowerCase() === this.fieldEmailConfirm.trim().toLowerCase();
                },
                validateEmailConfirmation: function() {
                    if (this.fieldEmailConfirm.trim() === '') {
                        this.formError = {
                            field: 'fieldEmailConfirm',
                            message: "bekr\xe4fta e-postadressen"
                        };
                        return false;
                    }
                    if (!this.emailsMatch()) {
                        this.formError = {
                            field: 'fieldEmailConfirm',
                            message: 'e-postadresserna matchar inte'
                        };
                        return false;
                    }
                    return true;
                },
                clearForm: function() {
                    this.fieldFirstName = '';
                    this.fieldLastName = '';
                    this.fieldAddress = '';
                    this.fieldPhone = '';
                    this.result = false;
                },
                checkUserExists: function() {
                    if (this.formLoading == true) return;
                    this.formError = false;
                    this.userExists = false;
                    const personalNumber = this.fieldPersonalNumber.trim();
                    const email = this.fieldEmail.trim();
                    const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (this.swedishCitizen === true) {
                        if (personalNumber === '') {
                            this.formError = {
                                field: 'fieldPersonalNumber',
                                message: 'ange ett personnummer'
                            };
                            return;
                        }
                        if (personalNumber.length !== 12) {
                            this.formError = {
                                field: 'fieldPersonalNumber',
                                message: "ogiltigt personnummer, 12 siffror kr\xe4vs."
                            };
                            return;
                        }
                        if (!(0, $bb8bd86f05b19f6b$export$2e2bcd8739ae039).valid(personalNumber)) {
                            this.formError = {
                                field: 'fieldPersonalNumber',
                                message: 'ogiltigt personnummer'
                            };
                            return;
                        }
                    } else {
                        if (email === '') {
                            this.formError = {
                                field: 'fieldEmail',
                                message: 'ange en e-postadress'
                            };
                            return;
                        }
                        if (!regexp.test(email)) {
                            this.formError = {
                                field: 'fieldEmail',
                                message: 'ogiltig e-postadress'
                            };
                            return;
                        }
                        if (!this.validateEmailConfirmation()) return;
                    }
                    this.formLoading = true;
                    let query;
                    if (this.swedishCitizen) {
                        query = '?PersonalNumber=' + encodeURIComponent(personalNumber);
                        this.$http.get(this.restBase + '/softadmin-check-personal-number' + query, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.formLoading = false;
                            if (response.data.Exists === false) this.checkedUser = true;
                            else this.userExists = true;
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: '',
                                message: "Kunde inte kontrollera personnummer. F\xf6rs\xf6k igen."
                            };
                            console.log(error);
                        });
                    } else {
                        query = '?Email=' + encodeURIComponent(email);
                        this.$http.get(this.restBase + '/softadmin-check-email' + query, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.formLoading = false;
                            if (response.data.Exists === false) this.checkedUser = true;
                            else this.userExists = true;
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: '',
                                message: "Kunde inte kontrollera e-post. F\xf6rs\xf6k igen."
                            };
                            console.log(error);
                        });
                    }
                },
                authenticateAndRegisterUser: function(device) {
                    if (this.swedishCitizen === true) {
                        const userAgent = navigator.userAgent;
                        const isMobile = userAgent.includes('Mobi') ? 'true' : 'false';
                        const thisDevice = device === 'thisDevice' ? 'true' : 'false';
                        this.$http.post(this.restBase + '/bankid-federated-login', {
                            isMobile: isMobile,
                            thisDevice: thisDevice
                        }).then((response)=>{
                            const autoStartToken = response.data.autoStartToken;
                            const sessionId = response.data.sessionId;
                            if (!sessionId) {
                                this.formLoading = false;
                                this.formError = {
                                    field: 'fieldBankId',
                                    message: "BankID start misslyckades. F\xf6rs\xf6k igen."
                                };
                                return;
                            }
                            if (device === 'thisDevice') {
                                if (userAgent.includes('Mobi')) {
                                    if (userAgent.includes('Mac OS X') && userAgent.includes('Safari/') && !userAgent.includes('Chrome/') && !userAgent.includes('CriOS/') || userAgent.includes('Android') && userAgent.includes('Chrome') || userAgent.includes('Android') && userAgent.includes('CriOs')) document.location.href = 'https://app.bankid.com/?autostarttoken=' + autoStartToken + '&redirect=null';
                                    else document.location.href = 'bankid:///?autostarttoken=' + autoStartToken + '&redirect=null';
                                } else document.location.href = 'bankid:///?autostarttoken=' + autoStartToken + '&redirect=null';
                            } else this.qrCode = response.data.QRCode;
                            // Get BankID session
                            // Run a function every second for 165 seconds to check if user is authenticated
                            let i = 0;
                            this.bankIdInterval = setInterval(()=>{
                                if (i > 165) {
                                    clearInterval(this.bankIdInterval);
                                    this.qrCode = null;
                                    this.formLoading = false;
                                    this.formError = {
                                        field: 'fieldBankId',
                                        message: "Autentisering med BankID genomf\xf6rdes inte. F\xf6rs\xf6k igen."
                                    };
                                    return;
                                }
                                this.$http.post(this.restBase + '/get-bankid-session', {
                                    sessionId: sessionId
                                }).then((response)=>{
                                    const data = response.data || {};
                                    const grand = data.grandidObject || {};
                                    const status = grand.message && grand.message.status;
                                    if (!this.formLoading) return;
                                    if (device === 'otherDevice' && grand.QRCode) this.qrCode = grand.QRCode;
                                    if (status == 'failed') {
                                        clearInterval(this.bankIdInterval);
                                        this.qrCode = null;
                                        this.formLoading = false;
                                        this.formError = {
                                            field: 'fieldBankId',
                                            message: "Autentisering med BankID genomf\xf6rdes inte. F\xf6rs\xf6k igen."
                                        };
                                    } else if ('userAttributes' in data) {
                                        clearInterval(this.bankIdInterval);
                                        this.qrCode = null;
                                        if (this.fieldPersonalNumber !== data.userAttributes.personalNumber) {
                                            this.formLoading = false;
                                            this.formError = {
                                                field: 'fieldPersonalNumber',
                                                message: "Personnumret st\xe4mmer inte \xf6verens med BankID-autentiseringen."
                                            };
                                            this.qrCode = null;
                                            return;
                                        }
                                        // Register user in Softadmin after successful authentication
                                        let dataPayload = {
                                            'FirstName': this.fieldFirstName,
                                            'LastName': this.fieldLastName,
                                            'Email': this.fieldEmail,
                                            'PersonalNumber': this.fieldPersonalNumber,
                                            'MobileNumber': this.normalizedPhone,
                                            'SessionId': sessionId
                                        };
                                        if (!this.doingRegister) this.$http.post(this.restBase + '/softadmin-register-person', dataPayload, {
                                            headers: {
                                                'X-WP-Nonce': liGlobal.restNonce
                                            }
                                        }).then((response)=>{
                                            this.result = response.data;
                                            this.formLoading = false;
                                            this.doingRegister = false;
                                        }).catch((error)=>{
                                            this.registerError = true;
                                            this.formError = {
                                                field: '',
                                                message: "Kunde inte registrera anv\xe4ndaren. F\xf6rs\xf6k igen."
                                            };
                                            this.formLoading = false;
                                            this.doingRegister = false;
                                        });
                                        this.doingRegister = true;
                                    }
                                }).catch(()=>{});
                                i++;
                            }, 1000);
                        }).catch((error)=>{
                            this.formLoading = false;
                            this.formError = {
                                field: 'fieldBankId',
                                message: "Kunde inte starta BankID. F\xf6rs\xf6k igen."
                            };
                        });
                    }
                },
                validateFormAndRegisterUser: function(device) {
                    if (this.formLoading == true) return;
                    this.result = false;
                    this.formError = false;
                    const regexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    this.fieldPersonalNumber = this.fieldPersonalNumber.trim();
                    this.fieldFirstName = this.fieldFirstName.trim();
                    this.fieldLastName = this.fieldLastName.trim();
                    this.fieldEmail = this.fieldEmail.trim();
                    this.fieldEmailConfirm = this.fieldEmailConfirm.trim();
                    this.fieldPhone = this.fieldPhone.trim();
                    this.fieldBirthDate = this.fieldBirthDate.trim();
                    if (this.swedishCitizen) {
                        if (this.fieldFirstName === '') {
                            this.formError = {
                                field: 'fieldFirstName',
                                message: "ange f\xf6rnamn"
                            };
                            return;
                        }
                        if (this.fieldLastName === '') {
                            this.formError = {
                                field: 'fieldLastName',
                                message: 'ange efternamn'
                            };
                            return;
                        }
                        if (this.fieldEmail === '') {
                            this.formError = {
                                field: 'fieldEmail',
                                message: 'ange en e-postadress'
                            };
                            return;
                        }
                        if (!regexp.test(this.fieldEmail)) {
                            this.formError = {
                                field: 'fieldEmail',
                                message: 'ogiltig e-postadress'
                            };
                            return;
                        }
                        if (!this.validateEmailConfirmation()) return;
                    } else {
                        if (this.fieldBirthDate === '') {
                            this.formError = {
                                field: 'fieldBirthDate',
                                message: "ange f\xf6delsedatum"
                            };
                            return;
                        }
                        if (this.fieldBirthDate.length !== 10) {
                            this.formError = {
                                field: 'fieldBirthDate',
                                message: "ogiltigt f\xf6delsedatum"
                            };
                            return;
                        }
                        if (this.fieldFirstName === '') {
                            this.formError = {
                                field: 'fieldFirstName',
                                message: "ange f\xf6rnamn"
                            };
                            return;
                        }
                        if (this.fieldLastName === '') {
                            this.formError = {
                                field: 'fieldLastName',
                                message: 'ange efternamn'
                            };
                            return;
                        }
                        if (!this.validateEmailConfirmation()) return;
                    }
                    this.formLoading = true;
                    if (this.swedishCitizen) this.authenticateAndRegisterUser(device);
                    else {
                        let data = {
                            'FirstName': this.fieldFirstName,
                            'LastName': this.fieldLastName,
                            'Email': this.fieldEmail,
                            'DateBirth': this.fieldBirthDate,
                            'MobileNumber': this.normalizedPhone
                        };
                        this.$http.post(this.restBase + '/softadmin-register-person', data, {
                            headers: {
                                'X-WP-Nonce': liGlobal.restNonce
                            }
                        }).then((response)=>{
                            this.result = response.data;
                            this.formLoading = false;
                        }).catch((error)=>{
                            console.log(error);
                            this.registerError = true;
                            this.formError = {
                                field: '',
                                message: "Kunde inte registrera anv\xe4ndaren. F\xf6rs\xf6k igen."
                            };
                            this.formLoading = false;
                        });
                    }
                },
                cancelBankId: function() {
                    clearInterval(this.bankIdInterval);
                    this.qrCode = null;
                    this.formLoading = false;
                }
            }
        });
        app.config.globalProperties.$http = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.config.globalProperties.axios = (0, $5774572e96b4aaf1$export$2e2bcd8739ae039);
        app.mount(el);
    });
});


/**
 * Ingen klickhantering här, det är i utils/tabs.js
 */ document.addEventListener('DOMContentLoaded', ()=>{
    document.querySelectorAll('.tab-list').forEach((wrapper, wrapperIndex)=>{
        const tabs = wrapper.querySelector('.tabs');
        const tabContents = wrapper.querySelectorAll('.tab-content');
        let tabIndex = 0;
        tabContents.forEach((tabContent)=>{
            // Gör varje data-tab unik så att kan ha flera tab-listor på samma sida
            const tabId = `tab-wrapper-${wrapperIndex}-tab-${tabIndex}`;
            tabContent.dataset.tab = tabId;
            const tab = /*html*/ `<button 
                type="button"
                class="tab px-4 py-2 text-sm md:text-base lg:px-10 border-l border-secondary-200 first:border-l-0 text-secondary-600 hover:text-dark first:rounded-tl-lg last:rounded-tr-lg hover:bg-white transition-colors duration-200 bg-secondary-100 [&.active]:-mb-px z-1 relative [&.active]:bg-white [&.active]:font-medium [&.active]:text-dark [&.active]:border-b-white ${tabIndex === 0 ? 'active' : ''}"
                data-tab="${tabId}">
                    ${tabContent.querySelector('.tab-title').textContent}
                </button>`;
            if (tabIndex === 0) tabContent.classList.add('active');
            tabs.insertAdjacentHTML('beforeend', tab);
            tabIndex++;
        });
    });
});



if (null) null.accept();

})();
//# sourceMappingURL=app.js.map
